var v2 = Object.defineProperty;
var _u = (e, t, n) => t in e ? v2(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var a = (e, t) => v2(e, "name", { value: t, configurable: !0 });
var pe = (e, t, n) => _u(e, typeof t != "symbol" ? t + "" : t, n);
import * as k from "react";
import xn, { forwardRef as J1, useContext as Ru, isValidElement as Ys, cloneElement as qs, Children as Iu, useState as ln, useEffect as Cn, useRef as Vi, useMemo as Ur } from "react";
import Q, { createGlobalStyle as B6, css as a1, styled as me, useTheme as H6, keyframes as D6 } from "styled-components";
import * as ju from "react-dom";
import ms from "react-dom";
import { Link as N6, NavLink as z6 } from "react-router-dom";
function Lu(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
a(Lu, "getDefaultExportFromCjs");
var bs = { exports: {} }, Gr = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var w2;
function Vu() {
  if (w2) return Gr;
  w2 = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function n(o, r, i) {
    var l = null;
    if (i !== void 0 && (l = "" + i), r.key !== void 0 && (l = "" + r.key), "key" in r) {
      i = {};
      for (var c in r)
        c !== "key" && (i[c] = r[c]);
    } else i = r;
    return r = i.ref, {
      $$typeof: e,
      type: o,
      key: l,
      ref: r !== void 0 ? r : null,
      props: i
    };
  }
  return a(n, "jsxProd"), Gr.Fragment = t, Gr.jsx = n, Gr.jsxs = n, Gr;
}
a(Vu, "requireReactJsxRuntime_production");
var Yr = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var S2;
function Au() {
  return S2 || (S2 = 1, process.env.NODE_ENV !== "production" && function() {
    function e($) {
      if ($ == null) return null;
      if (typeof $ == "function")
        return $.$$typeof === v ? null : $.displayName || $.name || null;
      if (typeof $ == "string") return $;
      switch ($) {
        case g:
          return "Fragment";
        case w:
          return "Profiler";
        case y:
          return "StrictMode";
        case M:
          return "Suspense";
        case O:
          return "SuspenseList";
        case I:
          return "Activity";
      }
      if (typeof $ == "object")
        switch (typeof $.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), $.$$typeof) {
          case C:
            return "Portal";
          case x:
            return ($.displayName || "Context") + ".Provider";
          case T:
            return ($._context.displayName || "Context") + ".Consumer";
          case S:
            var A = $.render;
            return $ = $.displayName, $ || ($ = A.displayName || A.name || "", $ = $ !== "" ? "ForwardRef(" + $ + ")" : "ForwardRef"), $;
          case P:
            return A = $.displayName || null, A !== null ? A : e($.type) || "Memo";
          case E:
            A = $._payload, $ = $._init;
            try {
              return e($(A));
            } catch {
            }
        }
      return null;
    }
    a(e, "getComponentNameFromType");
    function t($) {
      return "" + $;
    }
    a(t, "testStringCoercion");
    function n($) {
      try {
        t($);
        var A = !1;
      } catch {
        A = !0;
      }
      if (A) {
        A = console;
        var U = A.error, K = typeof Symbol == "function" && Symbol.toStringTag && $[Symbol.toStringTag] || $.constructor.name || "Object";
        return U.call(
          A,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          K
        ), t($);
      }
    }
    a(n, "checkKeyStringCoercion");
    function o($) {
      if ($ === g) return "<>";
      if (typeof $ == "object" && $ !== null && $.$$typeof === E)
        return "<...>";
      try {
        var A = e($);
        return A ? "<" + A + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    a(o, "getTaskName");
    function r() {
      var $ = _.A;
      return $ === null ? null : $.getOwner();
    }
    a(r, "getOwner");
    function i() {
      return Error("react-stack-top-frame");
    }
    a(i, "UnknownOwner");
    function l($) {
      if (R.call($, "key")) {
        var A = Object.getOwnPropertyDescriptor($, "key").get;
        if (A && A.isReactWarning) return !1;
      }
      return $.key !== void 0;
    }
    a(l, "hasValidKey");
    function c($, A) {
      function U() {
        V || (V = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          A
        ));
      }
      a(U, "warnAboutAccessingKey"), U.isReactWarning = !0, Object.defineProperty($, "key", {
        get: U,
        configurable: !0
      });
    }
    a(c, "defineKeyPropWarningGetter");
    function d() {
      var $ = e(this.type);
      return L[$] || (L[$] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), $ = this.props.ref, $ !== void 0 ? $ : null;
    }
    a(d, "elementRefGetterWithDeprecationWarning");
    function u($, A, U, K, J, F, N, te) {
      return U = F.ref, $ = {
        $$typeof: b,
        type: $,
        key: A,
        props: F,
        _owner: J
      }, (U !== void 0 ? U : null) !== null ? Object.defineProperty($, "ref", {
        enumerable: !1,
        get: d
      }) : Object.defineProperty($, "ref", { enumerable: !1, value: null }), $._store = {}, Object.defineProperty($._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty($, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty($, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: N
      }), Object.defineProperty($, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: te
      }), Object.freeze && (Object.freeze($.props), Object.freeze($)), $;
    }
    a(u, "ReactElement");
    function p($, A, U, K, J, F, N, te) {
      var oe = A.children;
      if (oe !== void 0)
        if (K)
          if (j(oe)) {
            for (K = 0; K < oe.length; K++)
              f(oe[K]);
            Object.freeze && Object.freeze(oe);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else f(oe);
      if (R.call(A, "key")) {
        oe = e($);
        var ne = Object.keys(A).filter(function(se) {
          return se !== "key";
        });
        K = 0 < ne.length ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}", H[oe + K] || (ne = 0 < ne.length ? "{" + ne.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          K,
          oe,
          ne,
          oe
        ), H[oe + K] = !0);
      }
      if (oe = null, U !== void 0 && (n(U), oe = "" + U), l(A) && (n(A.key), oe = "" + A.key), "key" in A) {
        U = {};
        for (var X in A)
          X !== "key" && (U[X] = A[X]);
      } else U = A;
      return oe && c(
        U,
        typeof $ == "function" ? $.displayName || $.name || "Unknown" : $
      ), u(
        $,
        oe,
        F,
        J,
        r(),
        U,
        N,
        te
      );
    }
    a(p, "jsxDEVImpl");
    function f($) {
      typeof $ == "object" && $ !== null && $.$$typeof === b && $._store && ($._store.validated = 1);
    }
    a(f, "validateChildKeys");
    var m = xn, b = Symbol.for("react.transitional.element"), C = Symbol.for("react.portal"), g = Symbol.for("react.fragment"), y = Symbol.for("react.strict_mode"), w = Symbol.for("react.profiler"), T = Symbol.for("react.consumer"), x = Symbol.for("react.context"), S = Symbol.for("react.forward_ref"), M = Symbol.for("react.suspense"), O = Symbol.for("react.suspense_list"), P = Symbol.for("react.memo"), E = Symbol.for("react.lazy"), I = Symbol.for("react.activity"), v = Symbol.for("react.client.reference"), _ = m.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, R = Object.prototype.hasOwnProperty, j = Array.isArray, B = console.createTask ? console.createTask : function() {
      return null;
    };
    m = {
      "react-stack-bottom-frame": /* @__PURE__ */ a(function($) {
        return $();
      }, "react-stack-bottom-frame")
    };
    var V, L = {}, D = m["react-stack-bottom-frame"].bind(
      m,
      i
    )(), z = B(o(i)), H = {};
    Yr.Fragment = g, Yr.jsx = function($, A, U, K, J) {
      var F = 1e4 > _.recentlyCreatedOwnerStacks++;
      return p(
        $,
        A,
        U,
        !1,
        K,
        J,
        F ? Error("react-stack-top-frame") : D,
        F ? B(o($)) : z
      );
    }, Yr.jsxs = function($, A, U, K, J) {
      var F = 1e4 > _.recentlyCreatedOwnerStacks++;
      return p(
        $,
        A,
        U,
        !0,
        K,
        J,
        F ? Error("react-stack-top-frame") : D,
        F ? B(o($)) : z
      );
    };
  }()), Yr;
}
a(Au, "requireReactJsxRuntime_development");
var M2;
function Bu() {
  return M2 || (M2 = 1, process.env.NODE_ENV === "production" ? bs.exports = Vu() : bs.exports = Au()), bs.exports;
}
a(Bu, "requireJsxRuntime");
var h = Bu();
const Ai = {
  black: "#000",
  white: "#fff"
}, cr = {
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  700: "#d32f2f",
  800: "#c62828"
}, dr = {
  50: "#f3e5f5",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  700: "#7b1fa2"
}, ur = {
  50: "#e3f2fd",
  200: "#90caf9",
  400: "#42a5f5",
  700: "#1976d2",
  800: "#1565c0"
}, pr = {
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  700: "#0288d1",
  900: "#01579b"
}, fr = {
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20"
}, qr = {
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  700: "#f57c00",
  900: "#e65100"
}, Hu = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
};
function qn(e, ...t) {
  const n = new URL(`https://mui.com/production-error/?code=${e}`);
  return t.forEach((o) => n.searchParams.append("args[]", o)), `Minified MUI error #${e}; visit ${n} for the full message.`;
}
a(qn, "formatMuiErrorMessage");
const Fa = "$$material";
function oa() {
  return oa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n) ({}).hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, oa.apply(null, arguments);
}
a(oa, "_extends");
function Du(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
a(Du, "sheetForTag");
function Nu(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
a(Nu, "createStyleElement");
var zu = /* @__PURE__ */ function() {
  function e(n) {
    var o = this;
    this._insertTag = function(r) {
      var i;
      o.tags.length === 0 ? o.insertionPoint ? i = o.insertionPoint.nextSibling : o.prepend ? i = o.container.firstChild : i = o.before : i = o.tags[o.tags.length - 1].nextSibling, o.container.insertBefore(r, i), o.tags.push(r);
    }, this.isSpeedy = n.speedy === void 0 ? !0 : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  a(e, "StyleSheet");
  var t = e.prototype;
  return t.hydrate = /* @__PURE__ */ a(function(o) {
    o.forEach(this._insertTag);
  }, "hydrate"), t.insert = /* @__PURE__ */ a(function(o) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Nu(this));
    var r = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var i = Du(r);
      try {
        i.insertRule(o, i.cssRules.length);
      } catch {
      }
    } else
      r.appendChild(document.createTextNode(o));
    this.ctr++;
  }, "insert"), t.flush = /* @__PURE__ */ a(function() {
    this.tags.forEach(function(o) {
      var r;
      return (r = o.parentNode) == null ? void 0 : r.removeChild(o);
    }), this.tags = [], this.ctr = 0;
  }, "flush"), e;
}(), Bt = "-ms-", ra = "-moz-", Ze = "-webkit-", F6 = "comm", Q1 = "rule", ec = "decl", Fu = "@import", W6 = "@keyframes", Wu = "@layer", Zu = Math.abs, Wa = String.fromCharCode, Uu = Object.assign;
function Gu(e, t) {
  return jt(e, 0) ^ 45 ? (((t << 2 ^ jt(e, 0)) << 2 ^ jt(e, 1)) << 2 ^ jt(e, 2)) << 2 ^ jt(e, 3) : 0;
}
a(Gu, "hash$2");
function Z6(e) {
  return e.trim();
}
a(Z6, "trim");
function Yu(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
a(Yu, "match");
function Ue(e, t, n) {
  return e.replace(t, n);
}
a(Ue, "replace");
function l1(e, t) {
  return e.indexOf(t);
}
a(l1, "indexof");
function jt(e, t) {
  return e.charCodeAt(t) | 0;
}
a(jt, "charat");
function Bi(e, t, n) {
  return e.slice(t, n);
}
a(Bi, "substr");
function Fn(e) {
  return e.length;
}
a(Fn, "strlen");
function tc(e) {
  return e.length;
}
a(tc, "sizeof");
function Cs(e, t) {
  return t.push(e), e;
}
a(Cs, "append");
function qu(e, t) {
  return e.map(t).join("");
}
a(qu, "combine");
var Za = 1, $r = 1, U6 = 0, Jt = 0, Ot = 0, Hr = "";
function Ua(e, t, n, o, r, i, l) {
  return { value: e, root: t, parent: n, type: o, props: r, children: i, line: Za, column: $r, length: l, return: "" };
}
a(Ua, "node");
function Kr(e, t) {
  return Uu(Ua("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
a(Kr, "copy");
function Ku() {
  return Ot;
}
a(Ku, "char");
function Xu() {
  return Ot = Jt > 0 ? jt(Hr, --Jt) : 0, $r--, Ot === 10 && ($r = 1, Za--), Ot;
}
a(Xu, "prev");
function cn() {
  return Ot = Jt < U6 ? jt(Hr, Jt++) : 0, $r++, Ot === 10 && ($r = 1, Za++), Ot;
}
a(cn, "next");
function Un() {
  return jt(Hr, Jt);
}
a(Un, "peek");
function Ks() {
  return Jt;
}
a(Ks, "caret");
function es(e, t) {
  return Bi(Hr, e, t);
}
a(es, "slice");
function Hi(e) {
  switch (e) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
a(Hi, "token");
function G6(e) {
  return Za = $r = 1, U6 = Fn(Hr = e), Jt = 0, [];
}
a(G6, "alloc");
function Y6(e) {
  return Hr = "", e;
}
a(Y6, "dealloc");
function Xs(e) {
  return Z6(es(Jt - 1, c1(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
a(Xs, "delimit");
function Ju(e) {
  for (; (Ot = Un()) && Ot < 33; )
    cn();
  return Hi(e) > 2 || Hi(Ot) > 3 ? "" : " ";
}
a(Ju, "whitespace");
function Qu(e, t) {
  for (; --t && cn() && !(Ot < 48 || Ot > 102 || Ot > 57 && Ot < 65 || Ot > 70 && Ot < 97); )
    ;
  return es(e, Ks() + (t < 6 && Un() == 32 && cn() == 32));
}
a(Qu, "escaping");
function c1(e) {
  for (; cn(); )
    switch (Ot) {
      // ] ) " '
      case e:
        return Jt;
      // " '
      case 34:
      case 39:
        e !== 34 && e !== 39 && c1(Ot);
        break;
      // (
      case 40:
        e === 41 && c1(e);
        break;
      // \
      case 92:
        cn();
        break;
    }
  return Jt;
}
a(c1, "delimiter");
function e0(e, t) {
  for (; cn() && e + Ot !== 57; )
    if (e + Ot === 84 && Un() === 47)
      break;
  return "/*" + es(t, Jt - 1) + "*" + Wa(e === 47 ? e : cn());
}
a(e0, "commenter");
function t0(e) {
  for (; !Hi(Un()); )
    cn();
  return es(e, Jt);
}
a(t0, "identifier");
function n0(e) {
  return Y6(Js("", null, null, null, [""], e = G6(e), 0, [0], e));
}
a(n0, "compile");
function Js(e, t, n, o, r, i, l, c, d) {
  for (var u = 0, p = 0, f = l, m = 0, b = 0, C = 0, g = 1, y = 1, w = 1, T = 0, x = "", S = r, M = i, O = o, P = x; y; )
    switch (C = T, T = cn()) {
      // (
      case 40:
        if (C != 108 && jt(P, f - 1) == 58) {
          l1(P += Ue(Xs(T), "&", "&\f"), "&\f") != -1 && (w = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        P += Xs(T);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        P += Ju(C);
        break;
      // \
      case 92:
        P += Qu(Ks() - 1, 7);
        continue;
      // /
      case 47:
        switch (Un()) {
          case 42:
          case 47:
            Cs(o0(e0(cn(), Ks()), t, n), d);
            break;
          default:
            P += "/";
        }
        break;
      // {
      case 123 * g:
        c[u++] = Fn(P) * w;
      // } ; \0
      case 125 * g:
      case 59:
      case 0:
        switch (T) {
          // \0 }
          case 0:
          case 125:
            y = 0;
          // ;
          case 59 + p:
            w == -1 && (P = Ue(P, /\f/g, "")), b > 0 && Fn(P) - f && Cs(b > 32 ? k2(P + ";", o, n, f - 1) : k2(Ue(P, " ", "") + ";", o, n, f - 2), d);
            break;
          // @ ;
          case 59:
            P += ";";
          // { rule/at-rule
          default:
            if (Cs(O = T2(P, t, n, u, p, r, c, x, S = [], M = [], f), i), T === 123)
              if (p === 0)
                Js(P, t, O, O, S, i, f, c, M);
              else
                switch (m === 99 && jt(P, 3) === 110 ? 100 : m) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Js(e, O, O, o && Cs(T2(e, O, O, 0, 0, r, c, x, r, S = [], f), M), r, M, f, c, o ? S : M);
                    break;
                  default:
                    Js(P, O, O, O, [""], M, 0, c, M);
                }
        }
        u = p = b = 0, g = w = 1, x = P = "", f = l;
        break;
      // :
      case 58:
        f = 1 + Fn(P), b = C;
      default:
        if (g < 1) {
          if (T == 123)
            --g;
          else if (T == 125 && g++ == 0 && Xu() == 125)
            continue;
        }
        switch (P += Wa(T), T * g) {
          // &
          case 38:
            w = p > 0 ? 1 : (P += "\f", -1);
            break;
          // ,
          case 44:
            c[u++] = (Fn(P) - 1) * w, w = 1;
            break;
          // @
          case 64:
            Un() === 45 && (P += Xs(cn())), m = Un(), p = f = Fn(x = P += t0(Ks())), T++;
            break;
          // -
          case 45:
            C === 45 && Fn(P) == 2 && (g = 0);
        }
    }
  return i;
}
a(Js, "parse$1");
function T2(e, t, n, o, r, i, l, c, d, u, p) {
  for (var f = r - 1, m = r === 0 ? i : [""], b = tc(m), C = 0, g = 0, y = 0; C < o; ++C)
    for (var w = 0, T = Bi(e, f + 1, f = Zu(g = l[C])), x = e; w < b; ++w)
      (x = Z6(g > 0 ? m[w] + " " + T : Ue(T, /&\f/g, m[w]))) && (d[y++] = x);
  return Ua(e, t, n, r === 0 ? Q1 : c, d, u, p);
}
a(T2, "ruleset");
function o0(e, t, n) {
  return Ua(e, t, n, F6, Wa(Ku()), Bi(e, 2, -2), 0);
}
a(o0, "comment");
function k2(e, t, n, o) {
  return Ua(e, t, n, ec, Bi(e, 0, o), Bi(e, o + 1, -1), o);
}
a(k2, "declaration");
function Mr(e, t) {
  for (var n = "", o = tc(e), r = 0; r < o; r++)
    n += t(e[r], r, e, t) || "";
  return n;
}
a(Mr, "serialize");
function r0(e, t, n, o) {
  switch (e.type) {
    case Wu:
      if (e.children.length) break;
    case Fu:
    case ec:
      return e.return = e.return || e.value;
    case F6:
      return "";
    case W6:
      return e.return = e.value + "{" + Mr(e.children, o) + "}";
    case Q1:
      e.value = e.props.join(",");
  }
  return Fn(n = Mr(e.children, o)) ? e.return = e.value + "{" + n + "}" : "";
}
a(r0, "stringify");
function i0(e) {
  var t = tc(e);
  return function(n, o, r, i) {
    for (var l = "", c = 0; c < t; c++)
      l += e[c](n, o, r, i) || "";
    return l;
  };
}
a(i0, "middleware");
function s0(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
a(s0, "rulesheet");
function q6(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
a(q6, "memoize$1");
var a0 = /* @__PURE__ */ a(function(t, n, o) {
  for (var r = 0, i = 0; r = i, i = Un(), r === 38 && i === 12 && (n[o] = 1), !Hi(i); )
    cn();
  return es(t, Jt);
}, "identifierWithPointTracking"), l0 = /* @__PURE__ */ a(function(t, n) {
  var o = -1, r = 44;
  do
    switch (Hi(r)) {
      case 0:
        r === 38 && Un() === 12 && (n[o] = 1), t[o] += a0(Jt - 1, n, o);
        break;
      case 2:
        t[o] += Xs(r);
        break;
      case 4:
        if (r === 44) {
          t[++o] = Un() === 58 ? "&\f" : "", n[o] = t[o].length;
          break;
        }
      // fallthrough
      default:
        t[o] += Wa(r);
    }
  while (r = cn());
  return t;
}, "toRules"), c0 = /* @__PURE__ */ a(function(t, n) {
  return Y6(l0(G6(t), n));
}, "getRules"), O2 = /* @__PURE__ */ new WeakMap(), d0 = /* @__PURE__ */ a(function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, o = t.parent, r = t.column === o.column && t.line === o.line; o.type !== "rule"; )
      if (o = o.parent, !o) return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !O2.get(o)) && !r) {
      O2.set(t, !0);
      for (var i = [], l = c0(n, i), c = o.props, d = 0, u = 0; d < l.length; d++)
        for (var p = 0; p < c.length; p++, u++)
          t.props[u] = i[d] ? l[d].replace(/&\f/g, c[p]) : c[p] + " " + l[d];
    }
  }
}, "compat"), u0 = /* @__PURE__ */ a(function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
}, "removeLabel");
function K6(e, t) {
  switch (Gu(e, t)) {
    // color-adjust
    case 5103:
      return Ze + "print-" + e + e;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Ze + e + e;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Ze + e + ra + e + Bt + e + e;
    // flex, flex-direction
    case 6828:
    case 4268:
      return Ze + e + Bt + e + e;
    // order
    case 6165:
      return Ze + e + Bt + "flex-" + e + e;
    // align-items
    case 5187:
      return Ze + e + Ue(e, /(\w+).+(:[^]+)/, Ze + "box-$1$2" + Bt + "flex-$1$2") + e;
    // align-self
    case 5443:
      return Ze + e + Bt + "flex-item-" + Ue(e, /flex-|-self/, "") + e;
    // align-content
    case 4675:
      return Ze + e + Bt + "flex-line-pack" + Ue(e, /align-content|flex-|-self/, "") + e;
    // flex-shrink
    case 5548:
      return Ze + e + Bt + Ue(e, "shrink", "negative") + e;
    // flex-basis
    case 5292:
      return Ze + e + Bt + Ue(e, "basis", "preferred-size") + e;
    // flex-grow
    case 6060:
      return Ze + "box-" + Ue(e, "-grow", "") + Ze + e + Bt + Ue(e, "grow", "positive") + e;
    // transition
    case 4554:
      return Ze + Ue(e, /([^-])(transform)/g, "$1" + Ze + "$2") + e;
    // cursor
    case 6187:
      return Ue(Ue(Ue(e, /(zoom-|grab)/, Ze + "$1"), /(image-set)/, Ze + "$1"), e, "") + e;
    // background, background-image
    case 5495:
    case 3959:
      return Ue(e, /(image-set\([^]*)/, Ze + "$1$`$1");
    // justify-content
    case 4968:
      return Ue(Ue(e, /(.+:)(flex-)?(.*)/, Ze + "box-pack:$3" + Bt + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Ze + e + e;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Ue(e, /(.+)-inline(.+)/, Ze + "$1$2") + e;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Fn(e) - 1 - t > 6) switch (jt(e, t + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (jt(e, t + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return Ue(e, /(.+:)(.+)-([^]+)/, "$1" + Ze + "$2-$3$1" + ra + (jt(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        // (s)tretch
        case 115:
          return ~l1(e, "stretch") ? K6(Ue(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    // position: sticky
    case 4949:
      if (jt(e, t + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (jt(e, Fn(e) - 3 - (~l1(e, "!important") && 10))) {
        // stic(k)y
        case 107:
          return Ue(e, ":", ":" + Ze) + e;
        // (inline-)?fl(e)x
        case 101:
          return Ue(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Ze + (jt(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Ze + "$2$3$1" + Bt + "$2box$3") + e;
      }
      break;
    // writing-mode
    case 5936:
      switch (jt(e, t + 11)) {
        // vertical-l(r)
        case 114:
          return Ze + e + Bt + Ue(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        // vertical-r(l)
        case 108:
          return Ze + e + Bt + Ue(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        // horizontal(-)tb
        case 45:
          return Ze + e + Bt + Ue(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return Ze + e + Bt + e + e;
  }
  return e;
}
a(K6, "prefix");
var p0 = /* @__PURE__ */ a(function(t, n, o, r) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case ec:
      t.return = K6(t.value, t.length);
      break;
    case W6:
      return Mr([Kr(t, {
        value: Ue(t.value, "@", "@" + Ze)
      })], r);
    case Q1:
      if (t.length) return qu(t.props, function(i) {
        switch (Yu(i, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ":read-only":
          case ":read-write":
            return Mr([Kr(t, {
              props: [Ue(i, /:(read-\w+)/, ":" + ra + "$1")]
            })], r);
          // :placeholder
          case "::placeholder":
            return Mr([Kr(t, {
              props: [Ue(i, /:(plac\w+)/, ":" + Ze + "input-$1")]
            }), Kr(t, {
              props: [Ue(i, /:(plac\w+)/, ":" + ra + "$1")]
            }), Kr(t, {
              props: [Ue(i, /:(plac\w+)/, Bt + "input-$1")]
            })], r);
        }
        return "";
      });
  }
}, "prefixer"), f0 = [p0], h0 = /* @__PURE__ */ a(function(t) {
  var n = t.key;
  if (n === "css") {
    var o = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(o, function(g) {
      var y = g.getAttribute("data-emotion");
      y.indexOf(" ") !== -1 && (document.head.appendChild(g), g.setAttribute("data-s", ""));
    });
  }
  var r = t.stylisPlugins || f0, i = {}, l, c = [];
  l = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(g) {
      for (var y = g.getAttribute("data-emotion").split(" "), w = 1; w < y.length; w++)
        i[y[w]] = !0;
      c.push(g);
    }
  );
  var d, u = [d0, u0];
  {
    var p, f = [r0, s0(function(g) {
      p.insert(g);
    })], m = i0(u.concat(r, f)), b = /* @__PURE__ */ a(function(y) {
      return Mr(n0(y), m);
    }, "stylis");
    d = /* @__PURE__ */ a(function(y, w, T, x) {
      p = T, b(y ? y + "{" + w.styles + "}" : w.styles), x && (C.inserted[w.name] = !0);
    }, "insert");
  }
  var C = {
    key: n,
    sheet: new zu({
      key: n,
      container: l,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: i,
    registered: {},
    insert: d
  };
  return C.sheet.hydrate(c), C;
}, "createCache"), ys = { exports: {} }, Ge = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var E2;
function g0() {
  if (E2) return Ge;
  E2 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, r = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, b = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, T = e ? Symbol.for("react.scope") : 60119;
  function x(M) {
    if (typeof M == "object" && M !== null) {
      var O = M.$$typeof;
      switch (O) {
        case t:
          switch (M = M.type, M) {
            case d:
            case u:
            case o:
            case i:
            case r:
            case f:
              return M;
            default:
              switch (M = M && M.$$typeof, M) {
                case c:
                case p:
                case C:
                case b:
                case l:
                  return M;
                default:
                  return O;
              }
          }
        case n:
          return O;
      }
    }
  }
  a(x, "z");
  function S(M) {
    return x(M) === u;
  }
  return a(S, "A"), Ge.AsyncMode = d, Ge.ConcurrentMode = u, Ge.ContextConsumer = c, Ge.ContextProvider = l, Ge.Element = t, Ge.ForwardRef = p, Ge.Fragment = o, Ge.Lazy = C, Ge.Memo = b, Ge.Portal = n, Ge.Profiler = i, Ge.StrictMode = r, Ge.Suspense = f, Ge.isAsyncMode = function(M) {
    return S(M) || x(M) === d;
  }, Ge.isConcurrentMode = S, Ge.isContextConsumer = function(M) {
    return x(M) === c;
  }, Ge.isContextProvider = function(M) {
    return x(M) === l;
  }, Ge.isElement = function(M) {
    return typeof M == "object" && M !== null && M.$$typeof === t;
  }, Ge.isForwardRef = function(M) {
    return x(M) === p;
  }, Ge.isFragment = function(M) {
    return x(M) === o;
  }, Ge.isLazy = function(M) {
    return x(M) === C;
  }, Ge.isMemo = function(M) {
    return x(M) === b;
  }, Ge.isPortal = function(M) {
    return x(M) === n;
  }, Ge.isProfiler = function(M) {
    return x(M) === i;
  }, Ge.isStrictMode = function(M) {
    return x(M) === r;
  }, Ge.isSuspense = function(M) {
    return x(M) === f;
  }, Ge.isValidElementType = function(M) {
    return typeof M == "string" || typeof M == "function" || M === o || M === u || M === i || M === r || M === f || M === m || typeof M == "object" && M !== null && (M.$$typeof === C || M.$$typeof === b || M.$$typeof === l || M.$$typeof === c || M.$$typeof === p || M.$$typeof === y || M.$$typeof === w || M.$$typeof === T || M.$$typeof === g);
  }, Ge.typeOf = x, Ge;
}
a(g0, "requireReactIs_production_min");
var Ye = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $2;
function m0() {
  return $2 || ($2 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, r = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, b = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, T = e ? Symbol.for("react.scope") : 60119;
    function x(Y) {
      return typeof Y == "string" || typeof Y == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Y === o || Y === u || Y === i || Y === r || Y === f || Y === m || typeof Y == "object" && Y !== null && (Y.$$typeof === C || Y.$$typeof === b || Y.$$typeof === l || Y.$$typeof === c || Y.$$typeof === p || Y.$$typeof === y || Y.$$typeof === w || Y.$$typeof === T || Y.$$typeof === g);
    }
    a(x, "isValidElementType");
    function S(Y) {
      if (typeof Y == "object" && Y !== null) {
        var fe = Y.$$typeof;
        switch (fe) {
          case t:
            var be = Y.type;
            switch (be) {
              case d:
              case u:
              case o:
              case i:
              case r:
              case f:
                return be;
              default:
                var Re = be && be.$$typeof;
                switch (Re) {
                  case c:
                  case p:
                  case C:
                  case b:
                  case l:
                    return Re;
                  default:
                    return fe;
                }
            }
          case n:
            return fe;
        }
      }
    }
    a(S, "typeOf");
    var M = d, O = u, P = c, E = l, I = t, v = p, _ = o, R = C, j = b, B = n, V = i, L = r, D = f, z = !1;
    function H(Y) {
      return z || (z = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), $(Y) || S(Y) === d;
    }
    a(H, "isAsyncMode");
    function $(Y) {
      return S(Y) === u;
    }
    a($, "isConcurrentMode");
    function A(Y) {
      return S(Y) === c;
    }
    a(A, "isContextConsumer");
    function U(Y) {
      return S(Y) === l;
    }
    a(U, "isContextProvider");
    function K(Y) {
      return typeof Y == "object" && Y !== null && Y.$$typeof === t;
    }
    a(K, "isElement");
    function J(Y) {
      return S(Y) === p;
    }
    a(J, "isForwardRef");
    function F(Y) {
      return S(Y) === o;
    }
    a(F, "isFragment");
    function N(Y) {
      return S(Y) === C;
    }
    a(N, "isLazy");
    function te(Y) {
      return S(Y) === b;
    }
    a(te, "isMemo");
    function oe(Y) {
      return S(Y) === n;
    }
    a(oe, "isPortal");
    function ne(Y) {
      return S(Y) === i;
    }
    a(ne, "isProfiler");
    function X(Y) {
      return S(Y) === r;
    }
    a(X, "isStrictMode");
    function se(Y) {
      return S(Y) === f;
    }
    a(se, "isSuspense"), Ye.AsyncMode = M, Ye.ConcurrentMode = O, Ye.ContextConsumer = P, Ye.ContextProvider = E, Ye.Element = I, Ye.ForwardRef = v, Ye.Fragment = _, Ye.Lazy = R, Ye.Memo = j, Ye.Portal = B, Ye.Profiler = V, Ye.StrictMode = L, Ye.Suspense = D, Ye.isAsyncMode = H, Ye.isConcurrentMode = $, Ye.isContextConsumer = A, Ye.isContextProvider = U, Ye.isElement = K, Ye.isForwardRef = J, Ye.isFragment = F, Ye.isLazy = N, Ye.isMemo = te, Ye.isPortal = oe, Ye.isProfiler = ne, Ye.isStrictMode = X, Ye.isSuspense = se, Ye.isValidElementType = x, Ye.typeOf = S;
  }()), Ye;
}
a(m0, "requireReactIs_development$1");
var P2;
function nc() {
  return P2 || (P2 = 1, process.env.NODE_ENV === "production" ? ys.exports = g0() : ys.exports = m0()), ys.exports;
}
a(nc, "requireReactIs$1");
var El, _2;
function b0() {
  if (_2) return El;
  _2 = 1;
  var e = nc(), t = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, n = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, o = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, r = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, i = {};
  i[e.ForwardRef] = o, i[e.Memo] = r;
  function l(C) {
    return e.isMemo(C) ? r : i[C.$$typeof] || t;
  }
  a(l, "getStatics");
  var c = Object.defineProperty, d = Object.getOwnPropertyNames, u = Object.getOwnPropertySymbols, p = Object.getOwnPropertyDescriptor, f = Object.getPrototypeOf, m = Object.prototype;
  function b(C, g, y) {
    if (typeof g != "string") {
      if (m) {
        var w = f(g);
        w && w !== m && b(C, w, y);
      }
      var T = d(g);
      u && (T = T.concat(u(g)));
      for (var x = l(C), S = l(g), M = 0; M < T.length; ++M) {
        var O = T[M];
        if (!n[O] && !(y && y[O]) && !(S && S[O]) && !(x && x[O])) {
          var P = p(g, O);
          try {
            c(C, O, P);
          } catch {
          }
        }
      }
    }
    return C;
  }
  return a(b, "hoistNonReactStatics"), El = b, El;
}
a(b0, "requireHoistNonReactStatics_cjs");
b0();
var C0 = !0;
function X6(e, t, n) {
  var o = "";
  return n.split(" ").forEach(function(r) {
    e[r] !== void 0 ? t.push(e[r] + ";") : r && (o += r + " ");
  }), o;
}
a(X6, "getRegisteredStyles");
var oc = /* @__PURE__ */ a(function(t, n, o) {
  var r = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (o === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  C0 === !1) && t.registered[r] === void 0 && (t.registered[r] = n.styles);
}, "registerStyles"), rc = /* @__PURE__ */ a(function(t, n, o) {
  oc(t, n, o);
  var r = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var i = n;
    do
      t.insert(n === i ? "." + r : "", i, t.sheet, !0), i = i.next;
    while (i !== void 0);
  }
}, "insertStyles");
function y0(e) {
  for (var t = 0, n, o = 0, r = e.length; r >= 4; ++o, r -= 4)
    n = e.charCodeAt(o) & 255 | (e.charCodeAt(++o) & 255) << 8 | (e.charCodeAt(++o) & 255) << 16 | (e.charCodeAt(++o) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (r) {
    case 3:
      t ^= (e.charCodeAt(o + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(o + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(o) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
a(y0, "murmur2");
var x0 = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, v0 = /[A-Z]|^ms/g, w0 = /_EMO_([^_]+?)_([^]*?)_EMO_/g, J6 = /* @__PURE__ */ a(function(t) {
  return t.charCodeAt(1) === 45;
}, "isCustomProperty"), R2 = /* @__PURE__ */ a(function(t) {
  return t != null && typeof t != "boolean";
}, "isProcessableValue"), $l = /* @__PURE__ */ q6(function(e) {
  return J6(e) ? e : e.replace(v0, "-$&").toLowerCase();
}), I2 = /* @__PURE__ */ a(function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(w0, function(o, r, i) {
          return Wn = {
            name: r,
            styles: i,
            next: Wn
          }, r;
        });
  }
  return x0[t] !== 1 && !J6(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
}, "processStyleValue");
function Di(e, t, n) {
  if (n == null)
    return "";
  var o = n;
  if (o.__emotion_styles !== void 0)
    return o;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var r = n;
      if (r.anim === 1)
        return Wn = {
          name: r.name,
          styles: r.styles,
          next: Wn
        }, r.name;
      var i = n;
      if (i.styles !== void 0) {
        var l = i.next;
        if (l !== void 0)
          for (; l !== void 0; )
            Wn = {
              name: l.name,
              styles: l.styles,
              next: Wn
            }, l = l.next;
        var c = i.styles + ";";
        return c;
      }
      return S0(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var d = Wn, u = n(e);
        return Wn = d, Di(e, t, u);
      }
      break;
    }
  }
  var p = n;
  if (t == null)
    return p;
  var f = t[p];
  return f !== void 0 ? f : p;
}
a(Di, "handleInterpolation");
function S0(e, t, n) {
  var o = "";
  if (Array.isArray(n))
    for (var r = 0; r < n.length; r++)
      o += Di(e, t, n[r]) + ";";
  else
    for (var i in n) {
      var l = n[i];
      if (typeof l != "object") {
        var c = l;
        t != null && t[c] !== void 0 ? o += i + "{" + t[c] + "}" : R2(c) && (o += $l(i) + ":" + I2(i, c) + ";");
      } else if (Array.isArray(l) && typeof l[0] == "string" && (t == null || t[l[0]] === void 0))
        for (var d = 0; d < l.length; d++)
          R2(l[d]) && (o += $l(i) + ":" + I2(i, l[d]) + ";");
      else {
        var u = Di(e, t, l);
        switch (i) {
          case "animation":
          case "animationName": {
            o += $l(i) + ":" + u + ";";
            break;
          }
          default:
            o += i + "{" + u + "}";
        }
      }
    }
  return o;
}
a(S0, "createStringFromObject");
var j2 = /label:\s*([^\s;{]+)\s*(;|$)/g, Wn;
function ts(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var o = !0, r = "";
  Wn = void 0;
  var i = e[0];
  if (i == null || i.raw === void 0)
    o = !1, r += Di(n, t, i);
  else {
    var l = i;
    r += l[0];
  }
  for (var c = 1; c < e.length; c++)
    if (r += Di(n, t, e[c]), o) {
      var d = i;
      r += d[c];
    }
  j2.lastIndex = 0;
  for (var u = "", p; (p = j2.exec(r)) !== null; )
    u += "-" + p[1];
  var f = y0(r) + u;
  return {
    name: f,
    styles: r,
    next: Wn
  };
}
a(ts, "serializeStyles");
var M0 = /* @__PURE__ */ a(function(t) {
  return t();
}, "syncFallback"), Q6 = k.useInsertionEffect ? k.useInsertionEffect : !1, e5 = Q6 || M0, L2 = Q6 || k.useLayoutEffect, t5 = /* @__PURE__ */ k.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ h0({
    key: "css"
  }) : null
);
t5.Provider;
var ic = /* @__PURE__ */ a(function(t) {
  return /* @__PURE__ */ J1(function(n, o) {
    var r = Ru(t5);
    return t(n, r, o);
  });
}, "withEmotionCache"), Ga = /* @__PURE__ */ k.createContext({}), sc = {}.hasOwnProperty, d1 = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", T0 = /* @__PURE__ */ a(function(t, n) {
  var o = {};
  for (var r in n)
    sc.call(n, r) && (o[r] = n[r]);
  return o[d1] = t, o;
}, "createEmotionProps"), k0 = /* @__PURE__ */ a(function(t) {
  var n = t.cache, o = t.serialized, r = t.isStringTag;
  return oc(n, o, r), e5(function() {
    return rc(n, o, r);
  }), null;
}, "Insertion"), O0 = /* @__PURE__ */ ic(function(e, t, n) {
  var o = e.css;
  typeof o == "string" && t.registered[o] !== void 0 && (o = t.registered[o]);
  var r = e[d1], i = [o], l = "";
  typeof e.className == "string" ? l = X6(t.registered, i, e.className) : e.className != null && (l = e.className + " ");
  var c = ts(i, void 0, k.useContext(Ga));
  l += t.key + "-" + c.name;
  var d = {};
  for (var u in e)
    sc.call(e, u) && u !== "css" && u !== d1 && (d[u] = e[u]);
  return d.className = l, n && (d.ref = n), /* @__PURE__ */ k.createElement(k.Fragment, null, /* @__PURE__ */ k.createElement(k0, {
    cache: t,
    serialized: c,
    isStringTag: typeof r == "string"
  }), /* @__PURE__ */ k.createElement(r, d));
}), E0 = O0, V2 = /* @__PURE__ */ a(function(t, n) {
  var o = arguments;
  if (n == null || !sc.call(n, "css"))
    return k.createElement.apply(void 0, o);
  var r = o.length, i = new Array(r);
  i[0] = E0, i[1] = T0(t, n);
  for (var l = 2; l < r; l++)
    i[l] = o[l];
  return k.createElement.apply(null, i);
}, "jsx");
(function(e) {
  var t;
  t || (t = e.JSX || (e.JSX = {}));
})(V2 || (V2 = {}));
var $0 = /* @__PURE__ */ ic(function(e, t) {
  var n = e.styles, o = ts([n], void 0, k.useContext(Ga)), r = k.useRef();
  return L2(function() {
    var i = t.key + "-global", l = new t.sheet.constructor({
      key: i,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }), c = !1, d = document.querySelector('style[data-emotion="' + i + " " + o.name + '"]');
    return t.sheet.tags.length && (l.before = t.sheet.tags[0]), d !== null && (c = !0, d.setAttribute("data-emotion", i), l.hydrate([d])), r.current = [l, c], function() {
      l.flush();
    };
  }, [t]), L2(function() {
    var i = r.current, l = i[0], c = i[1];
    if (c) {
      i[1] = !1;
      return;
    }
    if (o.next !== void 0 && rc(t, o.next, !0), l.tags.length) {
      var d = l.tags[l.tags.length - 1].nextElementSibling;
      l.before = d, l.flush();
    }
    t.insert("", o, l, !1);
  }, [t, o.name]), null;
});
function ac() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return ts(t);
}
a(ac, "css");
function ns() {
  var e = ac.apply(void 0, arguments), t = "animation-" + e.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + e.styles + "}",
    anim: 1,
    toString: /* @__PURE__ */ a(function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }, "toString")
  };
}
a(ns, "keyframes");
var P0 = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, _0 = /* @__PURE__ */ q6(
  function(e) {
    return P0.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), R0 = _0, I0 = /* @__PURE__ */ a(function(t) {
  return t !== "theme";
}, "testOmitPropsOnComponent"), A2 = /* @__PURE__ */ a(function(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? R0 : I0;
}, "getDefaultShouldForwardProp"), B2 = /* @__PURE__ */ a(function(t, n, o) {
  var r;
  if (n) {
    var i = n.shouldForwardProp;
    r = t.__emotion_forwardProp && i ? function(l) {
      return t.__emotion_forwardProp(l) && i(l);
    } : i;
  }
  return typeof r != "function" && o && (r = t.__emotion_forwardProp), r;
}, "composeShouldForwardProps"), j0 = /* @__PURE__ */ a(function(t) {
  var n = t.cache, o = t.serialized, r = t.isStringTag;
  return oc(n, o, r), e5(function() {
    return rc(n, o, r);
  }), null;
}, "Insertion"), L0 = /* @__PURE__ */ a(function e(t, n) {
  var o = t.__emotion_real === t, r = o && t.__emotion_base || t, i, l;
  n !== void 0 && (i = n.label, l = n.target);
  var c = B2(t, n, o), d = c || A2(r), u = !d("as");
  return function() {
    var p = arguments, f = o && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (i !== void 0 && f.push("label:" + i + ";"), p[0] == null || p[0].raw === void 0)
      f.push.apply(f, p);
    else {
      var m = p[0];
      f.push(m[0]);
      for (var b = p.length, C = 1; C < b; C++)
        f.push(p[C], m[C]);
    }
    var g = ic(function(y, w, T) {
      var x = u && y.as || r, S = "", M = [], O = y;
      if (y.theme == null) {
        O = {};
        for (var P in y)
          O[P] = y[P];
        O.theme = k.useContext(Ga);
      }
      typeof y.className == "string" ? S = X6(w.registered, M, y.className) : y.className != null && (S = y.className + " ");
      var E = ts(f.concat(M), w.registered, O);
      S += w.key + "-" + E.name, l !== void 0 && (S += " " + l);
      var I = u && c === void 0 ? A2(x) : d, v = {};
      for (var _ in y)
        u && _ === "as" || I(_) && (v[_] = y[_]);
      return v.className = S, T && (v.ref = T), /* @__PURE__ */ k.createElement(k.Fragment, null, /* @__PURE__ */ k.createElement(j0, {
        cache: w,
        serialized: E,
        isStringTag: typeof x == "string"
      }), /* @__PURE__ */ k.createElement(x, v));
    });
    return g.displayName = i !== void 0 ? i : "Styled(" + (typeof r == "string" ? r : r.displayName || r.name || "Component") + ")", g.defaultProps = t.defaultProps, g.__emotion_real = g, g.__emotion_base = r, g.__emotion_styles = f, g.__emotion_forwardProp = c, Object.defineProperty(g, "toString", {
      value: /* @__PURE__ */ a(function() {
        return "." + l;
      }, "value")
    }), g.withComponent = function(y, w) {
      var T = e(y, oa({}, n, w, {
        shouldForwardProp: B2(g, w, !0)
      }));
      return T.apply(void 0, f);
    }, g;
  };
}, "createStyled"), V0 = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], u1 = L0.bind(null);
V0.forEach(function(e) {
  u1[e] = u1(e);
});
var xs = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Pl, H2;
function A0() {
  if (H2) return Pl;
  H2 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function o(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  a(o, "toObject");
  function r() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var l = {}, c = 0; c < 10; c++)
        l["_" + String.fromCharCode(c)] = c;
      var d = Object.getOwnPropertyNames(l).map(function(p) {
        return l[p];
      });
      if (d.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(p) {
        u[p] = p;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return a(r, "shouldUseNative"), Pl = r() ? Object.assign : function(i, l) {
    for (var c, d = o(i), u, p = 1; p < arguments.length; p++) {
      c = Object(arguments[p]);
      for (var f in c)
        t.call(c, f) && (d[f] = c[f]);
      if (e) {
        u = e(c);
        for (var m = 0; m < u.length; m++)
          n.call(c, u[m]) && (d[u[m]] = c[u[m]]);
      }
    }
    return d;
  }, Pl;
}
a(A0, "requireObjectAssign");
var _l, D2;
function lc() {
  if (D2) return _l;
  D2 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return _l = e, _l;
}
a(lc, "requireReactPropTypesSecret");
var Rl, N2;
function n5() {
  return N2 || (N2 = 1, Rl = Function.call.bind(Object.prototype.hasOwnProperty)), Rl;
}
a(n5, "requireHas");
var Il, z2;
function B0() {
  if (z2) return Il;
  z2 = 1;
  var e = /* @__PURE__ */ a(function() {
  }, "printWarning");
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ lc(), n = {}, o = /* @__PURE__ */ n5();
    e = /* @__PURE__ */ a(function(i) {
      var l = "Warning: " + i;
      typeof console < "u" && console.error(l);
      try {
        throw new Error(l);
      } catch {
      }
    }, "printWarning");
  }
  function r(i, l, c, d, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var p in i)
        if (o(i, p)) {
          var f;
          try {
            if (typeof i[p] != "function") {
              var m = Error(
                (d || "React class") + ": " + c + " type `" + p + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[p] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw m.name = "Invariant Violation", m;
            }
            f = i[p](l, p, d, c, null, t);
          } catch (C) {
            f = C;
          }
          if (f && !(f instanceof Error) && e(
            (d || "React class") + ": type specification of " + c + " `" + p + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var b = u ? u() : "";
            e(
              "Failed " + c + " type: " + f.message + (b ?? "")
            );
          }
        }
    }
  }
  return a(r, "checkPropTypes"), r.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Il = r, Il;
}
a(B0, "requireCheckPropTypes");
var jl, F2;
function H0() {
  if (F2) return jl;
  F2 = 1;
  var e = nc(), t = A0(), n = /* @__PURE__ */ lc(), o = /* @__PURE__ */ n5(), r = /* @__PURE__ */ B0(), i = /* @__PURE__ */ a(function() {
  }, "printWarning");
  process.env.NODE_ENV !== "production" && (i = /* @__PURE__ */ a(function(c) {
    var d = "Warning: " + c;
    typeof console < "u" && console.error(d);
    try {
      throw new Error(d);
    } catch {
    }
  }, "printWarning"));
  function l() {
    return null;
  }
  return a(l, "emptyFunctionThatReturnsNull"), jl = /* @__PURE__ */ a(function(c, d) {
    var u = typeof Symbol == "function" && Symbol.iterator, p = "@@iterator";
    function f($) {
      var A = $ && (u && $[u] || $[p]);
      if (typeof A == "function")
        return A;
    }
    a(f, "getIteratorFn");
    var m = "<<anonymous>>", b = {
      array: w("array"),
      bigint: w("bigint"),
      bool: w("boolean"),
      func: w("function"),
      number: w("number"),
      object: w("object"),
      string: w("string"),
      symbol: w("symbol"),
      any: T(),
      arrayOf: x,
      element: S(),
      elementType: M(),
      instanceOf: O,
      node: v(),
      objectOf: E,
      oneOf: P,
      oneOfType: I,
      shape: R,
      exact: j
    };
    function C($, A) {
      return $ === A ? $ !== 0 || 1 / $ === 1 / A : $ !== $ && A !== A;
    }
    a(C, "is");
    function g($, A) {
      this.message = $, this.data = A && typeof A == "object" ? A : {}, this.stack = "";
    }
    a(g, "PropTypeError"), g.prototype = Error.prototype;
    function y($) {
      if (process.env.NODE_ENV !== "production")
        var A = {}, U = 0;
      function K(F, N, te, oe, ne, X, se) {
        if (oe = oe || m, X = X || te, se !== n) {
          if (d) {
            var Y = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw Y.name = "Invariant Violation", Y;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var fe = oe + ":" + te;
            !A[fe] && // Avoid spamming the console because they are often not actionable except for lib authors
            U < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + X + "` prop on `" + oe + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), A[fe] = !0, U++);
          }
        }
        return N[te] == null ? F ? N[te] === null ? new g("The " + ne + " `" + X + "` is marked as required " + ("in `" + oe + "`, but its value is `null`.")) : new g("The " + ne + " `" + X + "` is marked as required in " + ("`" + oe + "`, but its value is `undefined`.")) : null : $(N, te, oe, ne, X);
      }
      a(K, "checkType");
      var J = K.bind(null, !1);
      return J.isRequired = K.bind(null, !0), J;
    }
    a(y, "createChainableTypeChecker");
    function w($) {
      function A(U, K, J, F, N, te) {
        var oe = U[K], ne = L(oe);
        if (ne !== $) {
          var X = D(oe);
          return new g(
            "Invalid " + F + " `" + N + "` of type " + ("`" + X + "` supplied to `" + J + "`, expected ") + ("`" + $ + "`."),
            { expectedType: $ }
          );
        }
        return null;
      }
      return a(A, "validate"), y(A);
    }
    a(w, "createPrimitiveTypeChecker");
    function T() {
      return y(l);
    }
    a(T, "createAnyTypeChecker");
    function x($) {
      function A(U, K, J, F, N) {
        if (typeof $ != "function")
          return new g("Property `" + N + "` of component `" + J + "` has invalid PropType notation inside arrayOf.");
        var te = U[K];
        if (!Array.isArray(te)) {
          var oe = L(te);
          return new g("Invalid " + F + " `" + N + "` of type " + ("`" + oe + "` supplied to `" + J + "`, expected an array."));
        }
        for (var ne = 0; ne < te.length; ne++) {
          var X = $(te, ne, J, F, N + "[" + ne + "]", n);
          if (X instanceof Error)
            return X;
        }
        return null;
      }
      return a(A, "validate"), y(A);
    }
    a(x, "createArrayOfTypeChecker");
    function S() {
      function $(A, U, K, J, F) {
        var N = A[U];
        if (!c(N)) {
          var te = L(N);
          return new g("Invalid " + J + " `" + F + "` of type " + ("`" + te + "` supplied to `" + K + "`, expected a single ReactElement."));
        }
        return null;
      }
      return a($, "validate"), y($);
    }
    a(S, "createElementTypeChecker");
    function M() {
      function $(A, U, K, J, F) {
        var N = A[U];
        if (!e.isValidElementType(N)) {
          var te = L(N);
          return new g("Invalid " + J + " `" + F + "` of type " + ("`" + te + "` supplied to `" + K + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return a($, "validate"), y($);
    }
    a(M, "createElementTypeTypeChecker");
    function O($) {
      function A(U, K, J, F, N) {
        if (!(U[K] instanceof $)) {
          var te = $.name || m, oe = H(U[K]);
          return new g("Invalid " + F + " `" + N + "` of type " + ("`" + oe + "` supplied to `" + J + "`, expected ") + ("instance of `" + te + "`."));
        }
        return null;
      }
      return a(A, "validate"), y(A);
    }
    a(O, "createInstanceTypeChecker");
    function P($) {
      if (!Array.isArray($))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), l;
      function A(U, K, J, F, N) {
        for (var te = U[K], oe = 0; oe < $.length; oe++)
          if (C(te, $[oe]))
            return null;
        var ne = JSON.stringify($, /* @__PURE__ */ a(function(se, Y) {
          var fe = D(Y);
          return fe === "symbol" ? String(Y) : Y;
        }, "replacer"));
        return new g("Invalid " + F + " `" + N + "` of value `" + String(te) + "` " + ("supplied to `" + J + "`, expected one of " + ne + "."));
      }
      return a(A, "validate"), y(A);
    }
    a(P, "createEnumTypeChecker");
    function E($) {
      function A(U, K, J, F, N) {
        if (typeof $ != "function")
          return new g("Property `" + N + "` of component `" + J + "` has invalid PropType notation inside objectOf.");
        var te = U[K], oe = L(te);
        if (oe !== "object")
          return new g("Invalid " + F + " `" + N + "` of type " + ("`" + oe + "` supplied to `" + J + "`, expected an object."));
        for (var ne in te)
          if (o(te, ne)) {
            var X = $(te, ne, J, F, N + "." + ne, n);
            if (X instanceof Error)
              return X;
          }
        return null;
      }
      return a(A, "validate"), y(A);
    }
    a(E, "createObjectOfTypeChecker");
    function I($) {
      if (!Array.isArray($))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), l;
      for (var A = 0; A < $.length; A++) {
        var U = $[A];
        if (typeof U != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + z(U) + " at index " + A + "."
          ), l;
      }
      function K(J, F, N, te, oe) {
        for (var ne = [], X = 0; X < $.length; X++) {
          var se = $[X], Y = se(J, F, N, te, oe, n);
          if (Y == null)
            return null;
          Y.data && o(Y.data, "expectedType") && ne.push(Y.data.expectedType);
        }
        var fe = ne.length > 0 ? ", expected one of type [" + ne.join(", ") + "]" : "";
        return new g("Invalid " + te + " `" + oe + "` supplied to " + ("`" + N + "`" + fe + "."));
      }
      return a(K, "validate"), y(K);
    }
    a(I, "createUnionTypeChecker");
    function v() {
      function $(A, U, K, J, F) {
        return B(A[U]) ? null : new g("Invalid " + J + " `" + F + "` supplied to " + ("`" + K + "`, expected a ReactNode."));
      }
      return a($, "validate"), y($);
    }
    a(v, "createNodeChecker");
    function _($, A, U, K, J) {
      return new g(
        ($ || "React class") + ": " + A + " type `" + U + "." + K + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + J + "`."
      );
    }
    a(_, "invalidValidatorError");
    function R($) {
      function A(U, K, J, F, N) {
        var te = U[K], oe = L(te);
        if (oe !== "object")
          return new g("Invalid " + F + " `" + N + "` of type `" + oe + "` " + ("supplied to `" + J + "`, expected `object`."));
        for (var ne in $) {
          var X = $[ne];
          if (typeof X != "function")
            return _(J, F, N, ne, D(X));
          var se = X(te, ne, J, F, N + "." + ne, n);
          if (se)
            return se;
        }
        return null;
      }
      return a(A, "validate"), y(A);
    }
    a(R, "createShapeTypeChecker");
    function j($) {
      function A(U, K, J, F, N) {
        var te = U[K], oe = L(te);
        if (oe !== "object")
          return new g("Invalid " + F + " `" + N + "` of type `" + oe + "` " + ("supplied to `" + J + "`, expected `object`."));
        var ne = t({}, U[K], $);
        for (var X in ne) {
          var se = $[X];
          if (o($, X) && typeof se != "function")
            return _(J, F, N, X, D(se));
          if (!se)
            return new g(
              "Invalid " + F + " `" + N + "` key `" + X + "` supplied to `" + J + "`.\nBad object: " + JSON.stringify(U[K], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys($), null, "  ")
            );
          var Y = se(te, X, J, F, N + "." + X, n);
          if (Y)
            return Y;
        }
        return null;
      }
      return a(A, "validate"), y(A);
    }
    a(j, "createStrictShapeTypeChecker");
    function B($) {
      switch (typeof $) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !$;
        case "object":
          if (Array.isArray($))
            return $.every(B);
          if ($ === null || c($))
            return !0;
          var A = f($);
          if (A) {
            var U = A.call($), K;
            if (A !== $.entries) {
              for (; !(K = U.next()).done; )
                if (!B(K.value))
                  return !1;
            } else
              for (; !(K = U.next()).done; ) {
                var J = K.value;
                if (J && !B(J[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    a(B, "isNode");
    function V($, A) {
      return $ === "symbol" ? !0 : A ? A["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && A instanceof Symbol : !1;
    }
    a(V, "isSymbol");
    function L($) {
      var A = typeof $;
      return Array.isArray($) ? "array" : $ instanceof RegExp ? "object" : V(A, $) ? "symbol" : A;
    }
    a(L, "getPropType");
    function D($) {
      if (typeof $ > "u" || $ === null)
        return "" + $;
      var A = L($);
      if (A === "object") {
        if ($ instanceof Date)
          return "date";
        if ($ instanceof RegExp)
          return "regexp";
      }
      return A;
    }
    a(D, "getPreciseType");
    function z($) {
      var A = D($);
      switch (A) {
        case "array":
        case "object":
          return "an " + A;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + A;
        default:
          return A;
      }
    }
    a(z, "getPostfixForTypeWarning");
    function H($) {
      return !$.constructor || !$.constructor.name ? m : $.constructor.name;
    }
    return a(H, "getClassName"), b.checkPropTypes = r, b.resetWarningCache = r.resetWarningCache, b.PropTypes = b, b;
  }, "factoryWithTypeCheckers"), jl;
}
a(H0, "requireFactoryWithTypeCheckers");
var Ll, W2;
function D0() {
  if (W2) return Ll;
  W2 = 1;
  var e = /* @__PURE__ */ lc();
  function t() {
  }
  a(t, "emptyFunction");
  function n() {
  }
  return a(n, "emptyFunctionWithReset"), n.resetWarningCache = t, Ll = /* @__PURE__ */ a(function() {
    function o(l, c, d, u, p, f) {
      if (f !== e) {
        var m = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw m.name = "Invariant Violation", m;
      }
    }
    a(o, "shim"), o.isRequired = o;
    function r() {
      return o;
    }
    a(r, "getShim");
    var i = {
      array: o,
      bigint: o,
      bool: o,
      func: o,
      number: o,
      object: o,
      string: o,
      symbol: o,
      any: o,
      arrayOf: r,
      element: o,
      elementType: o,
      instanceOf: r,
      node: o,
      objectOf: r,
      oneOf: r,
      oneOfType: r,
      shape: r,
      exact: r,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, "factoryWithThrowingShims"), Ll;
}
a(D0, "requireFactoryWithThrowingShims");
var Z2;
function N0() {
  if (Z2) return xs.exports;
  if (Z2 = 1, process.env.NODE_ENV !== "production") {
    var e = nc(), t = !0;
    xs.exports = /* @__PURE__ */ H0()(e.isElement, t);
  } else
    xs.exports = /* @__PURE__ */ D0()();
  return xs.exports;
}
a(N0, "requirePropTypes");
var z0 = /* @__PURE__ */ N0();
const s = /* @__PURE__ */ Lu(z0);
function F0(e) {
  return e == null || Object.keys(e).length === 0;
}
a(F0, "isEmpty$2");
function o5(e) {
  const {
    styles: t,
    defaultTheme: n = {}
  } = e, o = typeof t == "function" ? (r) => t(F0(r) ? n : r) : t;
  return /* @__PURE__ */ h.jsx($0, {
    styles: o
  });
}
a(o5, "GlobalStyles$2");
process.env.NODE_ENV !== "production" && (o5.propTypes = {
  defaultTheme: s.object,
  styles: s.oneOfType([s.array, s.string, s.object, s.func])
});
/**
 * @mui/styled-engine v7.1.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function r5(e, t) {
  const n = u1(e, t);
  return process.env.NODE_ENV !== "production" ? (...o) => {
    const r = typeof e == "string" ? `"${e}"` : "component";
    return o.length === 0 ? console.error([`MUI: Seems like you called \`styled(${r})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : o.some((i) => i === void 0) && console.error(`MUI: the styled(${r})(...args) API requires all its args to be defined.`), n(...o);
  } : n;
}
a(r5, "styled$1");
function W0(e, t) {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}
a(W0, "internal_mutateStyles");
const U2 = [];
function G2(e) {
  return U2[0] = e, ts(U2);
}
a(G2, "internal_serializeStyles");
var vs = { exports: {} }, et = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Y2;
function Z0() {
  if (Y2) return et;
  Y2 = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), i = Symbol.for("react.consumer"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), m = Symbol.for("react.view_transition"), b = Symbol.for("react.client.reference");
  function C(g) {
    if (typeof g == "object" && g !== null) {
      var y = g.$$typeof;
      switch (y) {
        case e:
          switch (g = g.type, g) {
            case n:
            case r:
            case o:
            case d:
            case u:
            case m:
              return g;
            default:
              switch (g = g && g.$$typeof, g) {
                case l:
                case c:
                case f:
                case p:
                  return g;
                case i:
                  return g;
                default:
                  return y;
              }
          }
        case t:
          return y;
      }
    }
  }
  return a(C, "typeOf"), et.ContextConsumer = i, et.ContextProvider = l, et.Element = e, et.ForwardRef = c, et.Fragment = n, et.Lazy = f, et.Memo = p, et.Portal = t, et.Profiler = r, et.StrictMode = o, et.Suspense = d, et.SuspenseList = u, et.isContextConsumer = function(g) {
    return C(g) === i;
  }, et.isContextProvider = function(g) {
    return C(g) === l;
  }, et.isElement = function(g) {
    return typeof g == "object" && g !== null && g.$$typeof === e;
  }, et.isForwardRef = function(g) {
    return C(g) === c;
  }, et.isFragment = function(g) {
    return C(g) === n;
  }, et.isLazy = function(g) {
    return C(g) === f;
  }, et.isMemo = function(g) {
    return C(g) === p;
  }, et.isPortal = function(g) {
    return C(g) === t;
  }, et.isProfiler = function(g) {
    return C(g) === r;
  }, et.isStrictMode = function(g) {
    return C(g) === o;
  }, et.isSuspense = function(g) {
    return C(g) === d;
  }, et.isSuspenseList = function(g) {
    return C(g) === u;
  }, et.isValidElementType = function(g) {
    return typeof g == "string" || typeof g == "function" || g === n || g === r || g === o || g === d || g === u || typeof g == "object" && g !== null && (g.$$typeof === f || g.$$typeof === p || g.$$typeof === l || g.$$typeof === i || g.$$typeof === c || g.$$typeof === b || g.getModuleId !== void 0);
  }, et.typeOf = C, et;
}
a(Z0, "requireReactIs_production");
var tt = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var q2;
function U0() {
  return q2 || (q2 = 1, process.env.NODE_ENV !== "production" && function() {
    function e(g) {
      if (typeof g == "object" && g !== null) {
        var y = g.$$typeof;
        switch (y) {
          case t:
            switch (g = g.type, g) {
              case o:
              case i:
              case r:
              case u:
              case p:
              case b:
                return g;
              default:
                switch (g = g && g.$$typeof, g) {
                  case c:
                  case d:
                  case m:
                  case f:
                    return g;
                  case l:
                    return g;
                  default:
                    return y;
                }
            }
          case n:
            return y;
        }
      }
    }
    a(e, "typeOf");
    var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), l = Symbol.for("react.consumer"), c = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), b = Symbol.for("react.view_transition"), C = Symbol.for("react.client.reference");
    tt.ContextConsumer = l, tt.ContextProvider = c, tt.Element = t, tt.ForwardRef = d, tt.Fragment = o, tt.Lazy = m, tt.Memo = f, tt.Portal = n, tt.Profiler = i, tt.StrictMode = r, tt.Suspense = u, tt.SuspenseList = p, tt.isContextConsumer = function(g) {
      return e(g) === l;
    }, tt.isContextProvider = function(g) {
      return e(g) === c;
    }, tt.isElement = function(g) {
      return typeof g == "object" && g !== null && g.$$typeof === t;
    }, tt.isForwardRef = function(g) {
      return e(g) === d;
    }, tt.isFragment = function(g) {
      return e(g) === o;
    }, tt.isLazy = function(g) {
      return e(g) === m;
    }, tt.isMemo = function(g) {
      return e(g) === f;
    }, tt.isPortal = function(g) {
      return e(g) === n;
    }, tt.isProfiler = function(g) {
      return e(g) === i;
    }, tt.isStrictMode = function(g) {
      return e(g) === r;
    }, tt.isSuspense = function(g) {
      return e(g) === u;
    }, tt.isSuspenseList = function(g) {
      return e(g) === p;
    }, tt.isValidElementType = function(g) {
      return typeof g == "string" || typeof g == "function" || g === o || g === i || g === r || g === u || g === p || typeof g == "object" && g !== null && (g.$$typeof === m || g.$$typeof === f || g.$$typeof === c || g.$$typeof === l || g.$$typeof === d || g.$$typeof === C || g.getModuleId !== void 0);
    }, tt.typeOf = e;
  }()), tt;
}
a(U0, "requireReactIs_development");
var K2;
function G0() {
  return K2 || (K2 = 1, process.env.NODE_ENV === "production" ? vs.exports = /* @__PURE__ */ Z0() : vs.exports = /* @__PURE__ */ U0()), vs.exports;
}
a(G0, "requireReactIs");
var ko = /* @__PURE__ */ G0();
function Zn(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
a(Zn, "isPlainObject");
function i5(e) {
  if (/* @__PURE__ */ k.isValidElement(e) || ko.isValidElementType(e) || !Zn(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = i5(e[n]);
  }), t;
}
a(i5, "deepClone");
function zt(e, t, n = {
  clone: !0
}) {
  const o = n.clone ? {
    ...e
  } : e;
  return Zn(e) && Zn(t) && Object.keys(t).forEach((r) => {
    /* @__PURE__ */ k.isValidElement(t[r]) || ko.isValidElementType(t[r]) ? o[r] = t[r] : Zn(t[r]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, r) && Zn(e[r]) ? o[r] = zt(e[r], t[r], n) : n.clone ? o[r] = Zn(t[r]) ? i5(t[r]) : t[r] : o[r] = t[r];
  }), o;
}
a(zt, "deepmerge");
const Y0 = /* @__PURE__ */ a((e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, o) => n.val - o.val), t.reduce((n, o) => ({
    ...n,
    [o.key]: o.val
  }), {});
}, "sortBreakpointsValues");
function q0(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: o = 5,
    ...r
  } = e, i = Y0(t), l = Object.keys(i);
  function c(m) {
    return `@media (min-width:${typeof t[m] == "number" ? t[m] : m}${n})`;
  }
  a(c, "up");
  function d(m) {
    return `@media (max-width:${(typeof t[m] == "number" ? t[m] : m) - o / 100}${n})`;
  }
  a(d, "down");
  function u(m, b) {
    const C = l.indexOf(b);
    return `@media (min-width:${typeof t[m] == "number" ? t[m] : m}${n}) and (max-width:${(C !== -1 && typeof t[l[C]] == "number" ? t[l[C]] : b) - o / 100}${n})`;
  }
  a(u, "between");
  function p(m) {
    return l.indexOf(m) + 1 < l.length ? u(m, l[l.indexOf(m) + 1]) : c(m);
  }
  a(p, "only");
  function f(m) {
    const b = l.indexOf(m);
    return b === 0 ? c(l[1]) : b === l.length - 1 ? d(l[b]) : u(m, l[l.indexOf(m) + 1]).replace("@media", "@media not all and");
  }
  return a(f, "not"), {
    keys: l,
    values: i,
    up: c,
    down: d,
    between: u,
    only: p,
    not: f,
    unit: n,
    ...r
  };
}
a(q0, "createBreakpoints");
function K0(e, t) {
  if (!e.containerQueries)
    return t;
  const n = Object.keys(t).filter((o) => o.startsWith("@container")).sort((o, r) => {
    var l, c;
    const i = /min-width:\s*([0-9.]+)/;
    return +(((l = o.match(i)) == null ? void 0 : l[1]) || 0) - +(((c = r.match(i)) == null ? void 0 : c[1]) || 0);
  });
  return n.length ? n.reduce((o, r) => {
    const i = t[r];
    return delete o[r], o[r] = i, o;
  }, {
    ...t
  }) : t;
}
a(K0, "sortContainerQueries");
function X0(e, t) {
  return t === "@" || t.startsWith("@") && (e.some((n) => t.startsWith(`@${n}`)) || !!t.match(/^@\d/));
}
a(X0, "isCqShorthand");
function J0(e, t) {
  const n = t.match(/^@([^/]+)?\/?(.+)?$/);
  if (!n) {
    if (process.env.NODE_ENV !== "production")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The provided shorthand ${`(${t})`} is invalid. The format should be \`@<breakpoint | number>\` or \`@<breakpoint | number>/<container>\`.
For example, \`@sm\` or \`@600\` or \`@40rem/sidebar\`.` : qn(18, `(${t})`));
    return null;
  }
  const [, o, r] = n, i = Number.isNaN(+o) ? o || 0 : +o;
  return e.containerQueries(r).up(i);
}
a(J0, "getContainerQuery");
function Q0(e) {
  const t = /* @__PURE__ */ a((i, l) => i.replace("@media", l ? `@container ${l}` : "@container"), "toContainerQuery");
  function n(i, l) {
    i.up = (...c) => t(e.breakpoints.up(...c), l), i.down = (...c) => t(e.breakpoints.down(...c), l), i.between = (...c) => t(e.breakpoints.between(...c), l), i.only = (...c) => t(e.breakpoints.only(...c), l), i.not = (...c) => {
      const d = t(e.breakpoints.not(...c), l);
      return d.includes("not all and") ? d.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : d;
    };
  }
  a(n, "attachCq");
  const o = {}, r = /* @__PURE__ */ a((i) => (n(o, i), o), "containerQueries");
  return n(r), {
    ...e,
    containerQueries: r
  };
}
a(Q0, "cssContainerQueries");
const e7 = {
  borderRadius: 4
}, Po = process.env.NODE_ENV !== "production" ? s.oneOfType([s.number, s.string, s.object, s.array]) : {};
function Ci(e, t) {
  return t ? zt(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
a(Ci, "merge$1");
const Ya = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, X2 = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: /* @__PURE__ */ a((e) => `@media (min-width:${Ya[e]}px)`, "up")
}, t7 = {
  containerQueries: /* @__PURE__ */ a((e) => ({
    up: /* @__PURE__ */ a((t) => {
      let n = typeof t == "number" ? t : Ya[t] || t;
      return typeof n == "number" && (n = `${n}px`), e ? `@container ${e} (min-width:${n})` : `@container (min-width:${n})`;
    }, "up")
  }), "containerQueries")
};
function ao(e, t, n) {
  const o = e.theme || {};
  if (Array.isArray(t)) {
    const i = o.breakpoints || X2;
    return t.reduce((l, c, d) => (l[i.up(i.keys[d])] = n(t[d]), l), {});
  }
  if (typeof t == "object") {
    const i = o.breakpoints || X2;
    return Object.keys(t).reduce((l, c) => {
      if (X0(i.keys, c)) {
        const d = J0(o.containerQueries ? o : t7, c);
        d && (l[d] = n(t[c], c));
      } else if (Object.keys(i.values || Ya).includes(c)) {
        const d = i.up(c);
        l[d] = n(t[c], c);
      } else {
        const d = c;
        l[d] = t[d];
      }
      return l;
    }, {});
  }
  return n(t);
}
a(ao, "handleBreakpoints");
function n7(e = {}) {
  var n;
  return ((n = e.keys) == null ? void 0 : n.reduce((o, r) => {
    const i = e.up(r);
    return o[i] = {}, o;
  }, {})) || {};
}
a(n7, "createEmptyBreakpointObject");
function o7(e, t) {
  return e.reduce((n, o) => {
    const r = n[o];
    return (!r || Object.keys(r).length === 0) && delete n[o], n;
  }, t);
}
a(o7, "removeUnusedBreakpoints");
function G(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : qn(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
a(G, "capitalize");
function qa(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const o = `vars.${t}`.split(".").reduce((r, i) => r && r[i] ? r[i] : null, e);
    if (o != null)
      return o;
  }
  return t.split(".").reduce((o, r) => o && o[r] != null ? o[r] : null, e);
}
a(qa, "getPath");
function ia(e, t, n, o = n) {
  let r;
  return typeof e == "function" ? r = e(n) : Array.isArray(e) ? r = e[n] || o : r = qa(e, n) || o, t && (r = t(r, o, e)), r;
}
a(ia, "getStyleValue$1");
function St(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: o,
    transform: r
  } = e, i = /* @__PURE__ */ a((l) => {
    if (l[t] == null)
      return null;
    const c = l[t], d = l.theme, u = qa(d, o) || {};
    return ao(l, c, /* @__PURE__ */ a((f) => {
      let m = ia(u, r, f);
      return f === m && typeof f == "string" && (m = ia(u, r, `${t}${f === "default" ? "" : G(f)}`, f)), n === !1 ? m : {
        [n]: m
      };
    }, "styleFromPropValue"));
  }, "fn");
  return i.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: Po
  } : {}, i.filterProps = [t], i;
}
a(St, "style$1");
function r7(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
a(r7, "memoize");
const i7 = {
  m: "margin",
  p: "padding"
}, s7 = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, J2 = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, a7 = r7((e) => {
  if (e.length > 2)
    if (J2[e])
      e = J2[e];
    else
      return [e];
  const [t, n] = e.split(""), o = i7[t], r = s7[n] || "";
  return Array.isArray(r) ? r.map((i) => o + i) : [o + r];
}), Ka = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], Xa = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], l7 = [...Ka, ...Xa];
function os(e, t, n, o) {
  const r = qa(e, t, !0) ?? n;
  return typeof r == "number" || typeof r == "string" ? (i) => typeof i == "string" ? i : (process.env.NODE_ENV !== "production" && typeof i != "number" && console.error(`MUI: Expected ${o} argument to be a number or a string, got ${i}.`), typeof r == "string" ? r.startsWith("var(") && i === 0 ? 0 : r.startsWith("var(") && i === 1 ? r : `calc(${i} * ${r})` : r * i) : Array.isArray(r) ? (i) => {
    if (typeof i == "string")
      return i;
    const l = Math.abs(i);
    process.env.NODE_ENV !== "production" && (Number.isInteger(l) ? l > r.length - 1 && console.error([`MUI: The value provided (${l}) overflows.`, `The supported values are: ${JSON.stringify(r)}.`, `${l} > ${r.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`)));
    const c = r[l];
    return i >= 0 ? c : typeof c == "number" ? -c : typeof c == "string" && c.startsWith("var(") ? `calc(-1 * ${c})` : `-${c}`;
  } : typeof r == "function" ? r : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${r}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
a(os, "createUnaryUnit");
function cc(e) {
  return os(e, "spacing", 8, "spacing");
}
a(cc, "createUnarySpacing");
function rs(e, t) {
  return typeof t == "string" || t == null ? t : e(t);
}
a(rs, "getValue");
function c7(e, t) {
  return (n) => e.reduce((o, r) => (o[r] = rs(t, n), o), {});
}
a(c7, "getStyleFromPropValue");
function d7(e, t, n, o) {
  if (!t.includes(n))
    return null;
  const r = a7(n), i = c7(r, o), l = e[n];
  return ao(e, l, i);
}
a(d7, "resolveCssProperty");
function s5(e, t) {
  const n = cc(e.theme);
  return Object.keys(e).map((o) => d7(e, t, o, n)).reduce(Ci, {});
}
a(s5, "style");
function ht(e) {
  return s5(e, Ka);
}
a(ht, "margin");
ht.propTypes = process.env.NODE_ENV !== "production" ? Ka.reduce((e, t) => (e[t] = Po, e), {}) : {};
ht.filterProps = Ka;
function gt(e) {
  return s5(e, Xa);
}
a(gt, "padding");
gt.propTypes = process.env.NODE_ENV !== "production" ? Xa.reduce((e, t) => (e[t] = Po, e), {}) : {};
gt.filterProps = Xa;
process.env.NODE_ENV !== "production" && l7.reduce((e, t) => (e[t] = Po, e), {});
function a5(e = 8, t = cc({
  spacing: e
})) {
  if (e.mui)
    return e;
  const n = /* @__PURE__ */ a((...o) => (process.env.NODE_ENV !== "production" && (o.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${o.length}`)), (o.length === 0 ? [1] : o).map((i) => {
    const l = t(i);
    return typeof l == "number" ? `${l}px` : l;
  }).join(" ")), "spacing");
  return n.mui = !0, n;
}
a(a5, "createSpacing");
function Ja(...e) {
  const t = e.reduce((o, r) => (r.filterProps.forEach((i) => {
    o[i] = r;
  }), o), {}), n = /* @__PURE__ */ a((o) => Object.keys(o).reduce((r, i) => t[i] ? Ci(r, t[i](o)) : r, {}), "fn");
  return n.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((o, r) => Object.assign(o, r.propTypes), {}) : {}, n.filterProps = e.reduce((o, r) => o.concat(r.filterProps), []), n;
}
a(Ja, "compose");
function yn(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
a(yn, "borderTransform");
function kn(e, t) {
  return St({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
a(kn, "createBorderStyle");
const u7 = kn("border", yn), p7 = kn("borderTop", yn), f7 = kn("borderRight", yn), h7 = kn("borderBottom", yn), g7 = kn("borderLeft", yn), m7 = kn("borderColor"), b7 = kn("borderTopColor"), C7 = kn("borderRightColor"), y7 = kn("borderBottomColor"), x7 = kn("borderLeftColor"), v7 = kn("outline", yn), w7 = kn("outlineColor"), Qa = /* @__PURE__ */ a((e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = os(e.theme, "shape.borderRadius", 4, "borderRadius"), n = /* @__PURE__ */ a((o) => ({
      borderRadius: rs(t, o)
    }), "styleFromPropValue");
    return ao(e, e.borderRadius, n);
  }
  return null;
}, "borderRadius");
Qa.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: Po
} : {};
Qa.filterProps = ["borderRadius"];
Ja(u7, p7, f7, h7, g7, m7, b7, C7, y7, x7, Qa, v7, w7);
const el = /* @__PURE__ */ a((e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = os(e.theme, "spacing", 8, "gap"), n = /* @__PURE__ */ a((o) => ({
      gap: rs(t, o)
    }), "styleFromPropValue");
    return ao(e, e.gap, n);
  }
  return null;
}, "gap");
el.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: Po
} : {};
el.filterProps = ["gap"];
const tl = /* @__PURE__ */ a((e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = os(e.theme, "spacing", 8, "columnGap"), n = /* @__PURE__ */ a((o) => ({
      columnGap: rs(t, o)
    }), "styleFromPropValue");
    return ao(e, e.columnGap, n);
  }
  return null;
}, "columnGap");
tl.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: Po
} : {};
tl.filterProps = ["columnGap"];
const nl = /* @__PURE__ */ a((e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = os(e.theme, "spacing", 8, "rowGap"), n = /* @__PURE__ */ a((o) => ({
      rowGap: rs(t, o)
    }), "styleFromPropValue");
    return ao(e, e.rowGap, n);
  }
  return null;
}, "rowGap");
nl.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: Po
} : {};
nl.filterProps = ["rowGap"];
const S7 = St({
  prop: "gridColumn"
}), M7 = St({
  prop: "gridRow"
}), T7 = St({
  prop: "gridAutoFlow"
}), k7 = St({
  prop: "gridAutoColumns"
}), O7 = St({
  prop: "gridAutoRows"
}), E7 = St({
  prop: "gridTemplateColumns"
}), $7 = St({
  prop: "gridTemplateRows"
}), P7 = St({
  prop: "gridTemplateAreas"
}), _7 = St({
  prop: "gridArea"
});
Ja(el, tl, nl, S7, M7, T7, k7, O7, E7, $7, P7, _7);
function Tr(e, t) {
  return t === "grey" ? t : e;
}
a(Tr, "paletteTransform");
const R7 = St({
  prop: "color",
  themeKey: "palette",
  transform: Tr
}), I7 = St({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: Tr
}), j7 = St({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: Tr
});
Ja(R7, I7, j7);
function an(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
a(an, "sizingTransform");
const L7 = St({
  prop: "width",
  transform: an
}), dc = /* @__PURE__ */ a((e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = /* @__PURE__ */ a((n) => {
      var r, i, l, c, d;
      const o = ((l = (i = (r = e.theme) == null ? void 0 : r.breakpoints) == null ? void 0 : i.values) == null ? void 0 : l[n]) || Ya[n];
      return o ? ((d = (c = e.theme) == null ? void 0 : c.breakpoints) == null ? void 0 : d.unit) !== "px" ? {
        maxWidth: `${o}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: o
      } : {
        maxWidth: an(n)
      };
    }, "styleFromPropValue");
    return ao(e, e.maxWidth, t);
  }
  return null;
}, "maxWidth");
dc.filterProps = ["maxWidth"];
const V7 = St({
  prop: "minWidth",
  transform: an
}), A7 = St({
  prop: "height",
  transform: an
}), B7 = St({
  prop: "maxHeight",
  transform: an
}), H7 = St({
  prop: "minHeight",
  transform: an
});
St({
  prop: "size",
  cssProperty: "width",
  transform: an
});
St({
  prop: "size",
  cssProperty: "height",
  transform: an
});
const D7 = St({
  prop: "boxSizing"
});
Ja(L7, dc, V7, A7, B7, H7, D7);
const is = {
  // borders
  border: {
    themeKey: "borders",
    transform: yn
  },
  borderTop: {
    themeKey: "borders",
    transform: yn
  },
  borderRight: {
    themeKey: "borders",
    transform: yn
  },
  borderBottom: {
    themeKey: "borders",
    transform: yn
  },
  borderLeft: {
    themeKey: "borders",
    transform: yn
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: yn
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: Qa
  },
  // palette
  color: {
    themeKey: "palette",
    transform: Tr
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: Tr
  },
  backgroundColor: {
    themeKey: "palette",
    transform: Tr
  },
  // spacing
  p: {
    style: gt
  },
  pt: {
    style: gt
  },
  pr: {
    style: gt
  },
  pb: {
    style: gt
  },
  pl: {
    style: gt
  },
  px: {
    style: gt
  },
  py: {
    style: gt
  },
  padding: {
    style: gt
  },
  paddingTop: {
    style: gt
  },
  paddingRight: {
    style: gt
  },
  paddingBottom: {
    style: gt
  },
  paddingLeft: {
    style: gt
  },
  paddingX: {
    style: gt
  },
  paddingY: {
    style: gt
  },
  paddingInline: {
    style: gt
  },
  paddingInlineStart: {
    style: gt
  },
  paddingInlineEnd: {
    style: gt
  },
  paddingBlock: {
    style: gt
  },
  paddingBlockStart: {
    style: gt
  },
  paddingBlockEnd: {
    style: gt
  },
  m: {
    style: ht
  },
  mt: {
    style: ht
  },
  mr: {
    style: ht
  },
  mb: {
    style: ht
  },
  ml: {
    style: ht
  },
  mx: {
    style: ht
  },
  my: {
    style: ht
  },
  margin: {
    style: ht
  },
  marginTop: {
    style: ht
  },
  marginRight: {
    style: ht
  },
  marginBottom: {
    style: ht
  },
  marginLeft: {
    style: ht
  },
  marginX: {
    style: ht
  },
  marginY: {
    style: ht
  },
  marginInline: {
    style: ht
  },
  marginInlineStart: {
    style: ht
  },
  marginInlineEnd: {
    style: ht
  },
  marginBlock: {
    style: ht
  },
  marginBlockStart: {
    style: ht
  },
  marginBlockEnd: {
    style: ht
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: /* @__PURE__ */ a((e) => ({
      "@media print": {
        display: e
      }
    }), "transform")
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: el
  },
  rowGap: {
    style: nl
  },
  columnGap: {
    style: tl
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: an
  },
  maxWidth: {
    style: dc
  },
  minWidth: {
    transform: an
  },
  height: {
    transform: an
  },
  maxHeight: {
    transform: an
  },
  minHeight: {
    transform: an
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function N7(...e) {
  const t = e.reduce((o, r) => o.concat(Object.keys(r)), []), n = new Set(t);
  return e.every((o) => n.size === Object.keys(o).length);
}
a(N7, "objectsHaveSameKeys");
function z7(e, t) {
  return typeof e == "function" ? e(t) : e;
}
a(z7, "callIfFn");
function F7() {
  function e(n, o, r, i) {
    const l = {
      [n]: o,
      theme: r
    }, c = i[n];
    if (!c)
      return {
        [n]: o
      };
    const {
      cssProperty: d = n,
      themeKey: u,
      transform: p,
      style: f
    } = c;
    if (o == null)
      return null;
    if (u === "typography" && o === "inherit")
      return {
        [n]: o
      };
    const m = qa(r, u) || {};
    return f ? f(l) : ao(l, o, /* @__PURE__ */ a((C) => {
      let g = ia(m, p, C);
      return C === g && typeof C == "string" && (g = ia(m, p, `${n}${C === "default" ? "" : G(C)}`, C)), d === !1 ? g : {
        [d]: g
      };
    }, "styleFromPropValue"));
  }
  a(e, "getThemeValue");
  function t(n) {
    const {
      sx: o,
      theme: r = {}
    } = n || {};
    if (!o)
      return null;
    const i = r.unstable_sxConfig ?? is;
    function l(c) {
      let d = c;
      if (typeof c == "function")
        d = c(r);
      else if (typeof c != "object")
        return c;
      if (!d)
        return null;
      const u = n7(r.breakpoints), p = Object.keys(u);
      let f = u;
      return Object.keys(d).forEach((m) => {
        const b = z7(d[m], r);
        if (b != null)
          if (typeof b == "object")
            if (i[m])
              f = Ci(f, e(m, b, r, i));
            else {
              const C = ao({
                theme: r
              }, b, (g) => ({
                [m]: g
              }));
              N7(C, b) ? f[m] = t({
                sx: b,
                theme: r
              }) : f = Ci(f, C);
            }
          else
            f = Ci(f, e(m, b, r, i));
      }), K0(r, o7(p, f));
    }
    return a(l, "traverse"), Array.isArray(o) ? o.map(l) : l(o);
  }
  return a(t, "styleFunctionSx"), t;
}
a(F7, "unstable_createStyleFunctionSx");
const tr = F7();
tr.filterProps = ["sx"];
function W7(e, t) {
  var o;
  const n = this;
  if (n.vars) {
    if (!((o = n.colorSchemes) != null && o[e]) || typeof n.getColorSchemeSelector != "function")
      return {};
    let r = n.getColorSchemeSelector(e);
    return r === "&" ? t : ((r.includes("data-") || r.includes(".")) && (r = `*:where(${r.replace(/\s*&$/, "")}) &`), {
      [r]: t
    });
  }
  return n.palette.mode === e ? t : {};
}
a(W7, "applyStyles$2");
function uc(e = {}, ...t) {
  const {
    breakpoints: n = {},
    palette: o = {},
    spacing: r,
    shape: i = {},
    ...l
  } = e, c = q0(n), d = a5(r);
  let u = zt({
    breakpoints: c,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...o
    },
    spacing: d,
    shape: {
      ...e7,
      ...i
    }
  }, l);
  return u = Q0(u), u.applyStyles = W7, u = t.reduce((p, f) => zt(p, f), u), u.unstable_sxConfig = {
    ...is,
    ...l == null ? void 0 : l.unstable_sxConfig
  }, u.unstable_sx = /* @__PURE__ */ a(function(f) {
    return tr({
      sx: f,
      theme: this
    });
  }, "sx"), u;
}
a(uc, "createTheme$1");
function Z7(e) {
  return Object.keys(e).length === 0;
}
a(Z7, "isObjectEmpty$2");
function U7(e = null) {
  const t = k.useContext(Ga);
  return !t || Z7(t) ? e : t;
}
a(U7, "useTheme$2");
const G7 = uc();
function pc(e = G7) {
  return U7(e);
}
a(pc, "useTheme$1");
function l5({
  styles: e,
  themeId: t,
  defaultTheme: n = {}
}) {
  const o = pc(n), r = typeof e == "function" ? e(t && o[t] || o) : e;
  return /* @__PURE__ */ h.jsx(o5, {
    styles: r
  });
}
a(l5, "GlobalStyles$1");
process.env.NODE_ENV !== "production" && (l5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: s.object,
  /**
   * @ignore
   */
  styles: s.oneOfType([s.array, s.func, s.number, s.object, s.string, s.bool]),
  /**
   * @ignore
   */
  themeId: s.string
});
const Y7 = /* @__PURE__ */ a((e) => {
  var o;
  const t = {
    systemProps: {},
    otherProps: {}
  }, n = ((o = e == null ? void 0 : e.theme) == null ? void 0 : o.unstable_sxConfig) ?? is;
  return Object.keys(e).forEach((r) => {
    n[r] ? t.systemProps[r] = e[r] : t.otherProps[r] = e[r];
  }), t;
}, "splitProps");
function c5(e) {
  const {
    sx: t,
    ...n
  } = e, {
    systemProps: o,
    otherProps: r
  } = Y7(n);
  let i;
  return Array.isArray(t) ? i = [o, ...t] : typeof t == "function" ? i = /* @__PURE__ */ a((...l) => {
    const c = t(...l);
    return Zn(c) ? {
      ...o,
      ...c
    } : o;
  }, "finalSx") : i = {
    ...o,
    ...t
  }, {
    ...r,
    sx: i
  };
}
a(c5, "extendSxProp$1");
const Q2 = /* @__PURE__ */ a((e) => e, "defaultGenerator"), q7 = /* @__PURE__ */ a(() => {
  let e = Q2;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = Q2;
    }
  };
}, "createClassNameGenerator"), d5 = q7();
function u5(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var r = e.length;
    for (t = 0; t < r; t++) e[t] && (n = u5(e[t])) && (o && (o += " "), o += n);
  } else for (n in e) e[n] && (o && (o += " "), o += n);
  return o;
}
a(u5, "r");
function le() {
  for (var e, t, n = 0, o = "", r = arguments.length; n < r; n++) (e = arguments[n]) && (t = u5(e)) && (o && (o += " "), o += t);
  return o;
}
a(le, "clsx");
function K7(e = {}) {
  const {
    themeId: t,
    defaultTheme: n,
    defaultClassName: o = "MuiBox-root",
    generateClassName: r
  } = e, i = r5("div", {
    shouldForwardProp: /* @__PURE__ */ a((c) => c !== "theme" && c !== "sx" && c !== "as", "shouldForwardProp")
  })(tr);
  return /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(d, u) {
    const p = pc(n), {
      className: f,
      component: m = "div",
      ...b
    } = c5(d);
    return /* @__PURE__ */ h.jsx(i, {
      as: m,
      ref: u,
      className: le(f, r ? r(o) : o),
      theme: t && p[t] || p,
      ...b
    });
  }, "Box"));
}
a(K7, "createBox");
const X7 = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function Te(e, t, n = "Mui") {
  const o = X7[t];
  return o ? `${n}-${o}` : `${d5.generate(e)}-${t}`;
}
a(Te, "generateUtilityClass");
function Se(e, t, n = "Mui") {
  const o = {};
  return t.forEach((r) => {
    o[r] = Te(e, r, n);
  }), o;
}
a(Se, "generateUtilityClasses");
function p5(e, t = "") {
  return e.displayName || e.name || t;
}
a(p5, "getFunctionComponentName");
function e3(e, t, n) {
  const o = p5(t);
  return e.displayName || (o !== "" ? `${n}(${o})` : n);
}
a(e3, "getWrappedName");
function J7(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return p5(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case ko.ForwardRef:
          return e3(e, e.render, "ForwardRef");
        case ko.Memo:
          return e3(e, e.type, "memo");
        default:
          return;
      }
  }
}
a(J7, "getDisplayName");
function f5(e) {
  const {
    variants: t,
    ...n
  } = e, o = {
    variants: t,
    style: G2(n),
    isProcessed: !0
  };
  return o.style === n || t && t.forEach((r) => {
    typeof r.style != "function" && (r.style = G2(r.style));
  }), o;
}
a(f5, "preprocessStyles");
const Q7 = uc();
function Vl(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
a(Vl, "shouldForwardProp");
function ep(e) {
  return e ? (t, n) => n[e] : null;
}
a(ep, "defaultOverridesResolver");
function tp(e, t, n) {
  e.theme = ip(e.theme) ? n : e.theme[t] || e.theme;
}
a(tp, "attachTheme");
function Qs(e, t) {
  const n = typeof t == "function" ? t(e) : t;
  if (Array.isArray(n))
    return n.flatMap((o) => Qs(e, o));
  if (Array.isArray(n == null ? void 0 : n.variants)) {
    let o;
    if (n.isProcessed)
      o = n.style;
    else {
      const {
        variants: r,
        ...i
      } = n;
      o = i;
    }
    return h5(e, n.variants, [o]);
  }
  return n != null && n.isProcessed ? n.style : n;
}
a(Qs, "processStyle");
function h5(e, t, n = []) {
  var r;
  let o;
  e: for (let i = 0; i < t.length; i += 1) {
    const l = t[i];
    if (typeof l.props == "function") {
      if (o ?? (o = {
        ...e,
        ...e.ownerState,
        ownerState: e.ownerState
      }), !l.props(o))
        continue;
    } else
      for (const c in l.props)
        if (e[c] !== l.props[c] && ((r = e.ownerState) == null ? void 0 : r[c]) !== l.props[c])
          continue e;
    typeof l.style == "function" ? (o ?? (o = {
      ...e,
      ...e.ownerState,
      ownerState: e.ownerState
    }), n.push(l.style(o))) : n.push(l.style);
  }
  return n;
}
a(h5, "processStyleVariants");
function np(e = {}) {
  const {
    themeId: t,
    defaultTheme: n = Q7,
    rootShouldForwardProp: o = Vl,
    slotShouldForwardProp: r = Vl
  } = e;
  function i(c) {
    tp(c, t, n);
  }
  return a(i, "styleAttachTheme"), /* @__PURE__ */ a((c, d = {}) => {
    W0(c, (M) => M.filter((O) => O !== tr));
    const {
      name: u,
      slot: p,
      skipVariantsResolver: f,
      skipSx: m,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: b = ep(g5(p)),
      ...C
    } = d, g = f !== void 0 ? f : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      p && p !== "Root" && p !== "root" || !1
    ), y = m || !1;
    let w = Vl;
    p === "Root" || p === "root" ? w = o : p ? w = r : sp(c) && (w = void 0);
    const T = r5(c, {
      shouldForwardProp: w,
      label: rp(u, p),
      ...C
    }), x = /* @__PURE__ */ a((M) => {
      if (typeof M == "function" && M.__emotion_real !== M)
        return /* @__PURE__ */ a(function(P) {
          return Qs(P, M);
        }, "styleFunctionProcessor");
      if (Zn(M)) {
        const O = f5(M);
        return O.variants ? /* @__PURE__ */ a(function(E) {
          return Qs(E, O);
        }, "styleObjectProcessor") : O.style;
      }
      return M;
    }, "transformStyle"), S = /* @__PURE__ */ a((...M) => {
      const O = [], P = M.map(x), E = [];
      if (O.push(i), u && b && E.push(/* @__PURE__ */ a(function(R) {
        var L, D;
        const B = (D = (L = R.theme.components) == null ? void 0 : L[u]) == null ? void 0 : D.styleOverrides;
        if (!B)
          return null;
        const V = {};
        for (const z in B)
          V[z] = Qs(R, B[z]);
        return b(R, V);
      }, "styleThemeOverrides")), u && !g && E.push(/* @__PURE__ */ a(function(R) {
        var V, L;
        const j = R.theme, B = (L = (V = j == null ? void 0 : j.components) == null ? void 0 : V[u]) == null ? void 0 : L.variants;
        return B ? h5(R, B) : null;
      }, "styleThemeVariants")), y || E.push(tr), Array.isArray(P[0])) {
        const _ = P.shift(), R = new Array(O.length).fill(""), j = new Array(E.length).fill("");
        let B;
        B = [...R, ..._, ...j], B.raw = [...R, ..._.raw, ...j], O.unshift(B);
      }
      const I = [...O, ...P, ...E], v = T(...I);
      return c.muiName && (v.muiName = c.muiName), process.env.NODE_ENV !== "production" && (v.displayName = op(u, p, c)), v;
    }, "muiStyledResolver");
    return T.withConfig && (S.withConfig = T.withConfig), S;
  }, "styled");
}
a(np, "createStyled");
function op(e, t, n) {
  return e ? `${e}${G(t || "")}` : `Styled(${J7(n)})`;
}
a(op, "generateDisplayName");
function rp(e, t) {
  let n;
  return process.env.NODE_ENV !== "production" && e && (n = `${e}-${g5(t || "Root")}`), n;
}
a(rp, "generateStyledLabel");
function ip(e) {
  for (const t in e)
    return !1;
  return !0;
}
a(ip, "isObjectEmpty$1");
function sp(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
a(sp, "isStringTag");
function g5(e) {
  return e && e.charAt(0).toLowerCase() + e.slice(1);
}
a(g5, "lowercaseFirstLetter");
function sa(e, t) {
  const n = {
    ...t
  };
  for (const o in e)
    if (Object.prototype.hasOwnProperty.call(e, o)) {
      const r = o;
      if (r === "components" || r === "slots")
        n[r] = {
          ...e[r],
          ...n[r]
        };
      else if (r === "componentsProps" || r === "slotProps") {
        const i = e[r], l = t[r];
        if (!l)
          n[r] = i || {};
        else if (!i)
          n[r] = l;
        else {
          n[r] = {
            ...l
          };
          for (const c in i)
            if (Object.prototype.hasOwnProperty.call(i, c)) {
              const d = c;
              n[r][d] = sa(i[d], l[d]);
            }
        }
      } else n[r] === void 0 && (n[r] = e[r]);
    }
  return n;
}
a(sa, "resolveProps");
const Rn = typeof window < "u" ? k.useLayoutEffect : k.useEffect;
function ap(e, t = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, n));
}
a(ap, "clamp");
function fc(e, t = 0, n = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > n) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${n}].`), ap(e, t, n);
}
a(fc, "clampWrapper");
function lp(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(t);
  return n && n[0].length === 1 && (n = n.map((o) => o + o)), process.env.NODE_ENV !== "production" && e.length !== e.trim().length && console.error(`MUI: The color: "${e}" is invalid. Make sure the color input doesn't contain leading/trailing space.`), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((o, r) => r < 3 ? parseInt(o, 16) : Math.round(parseInt(o, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
a(lp, "hexToRgb");
function Oo(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Oo(lp(e));
  const t = e.indexOf("("), n = e.substring(0, t);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(n))
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : qn(9, e));
  let o = e.substring(t + 1, e.length - 1), r;
  if (n === "color") {
    if (o = o.split(" "), r = o.shift(), o.length === 4 && o[3].charAt(0) === "/" && (o[3] = o[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(r))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${r}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : qn(10, r));
  } else
    o = o.split(",");
  return o = o.map((i) => parseFloat(i)), {
    type: n,
    values: o,
    colorSpace: r
  };
}
a(Oo, "decomposeColor");
const cp = /* @__PURE__ */ a((e) => {
  const t = Oo(e);
  return t.values.slice(0, 3).map((n, o) => t.type.includes("hsl") && o !== 0 ? `${n}%` : n).join(" ");
}, "colorChannel"), ci = /* @__PURE__ */ a((e, t) => {
  try {
    return cp(e);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
}, "private_safeColorChannel");
function ol(e) {
  const {
    type: t,
    colorSpace: n
  } = e;
  let {
    values: o
  } = e;
  return t.includes("rgb") ? o = o.map((r, i) => i < 3 ? parseInt(r, 10) : r) : t.includes("hsl") && (o[1] = `${o[1]}%`, o[2] = `${o[2]}%`), t.includes("color") ? o = `${n} ${o.join(" ")}` : o = `${o.join(", ")}`, `${t}(${o})`;
}
a(ol, "recomposeColor");
function m5(e) {
  e = Oo(e);
  const {
    values: t
  } = e, n = t[0], o = t[1] / 100, r = t[2] / 100, i = o * Math.min(r, 1 - r), l = /* @__PURE__ */ a((u, p = (u + n / 30) % 12) => r - i * Math.max(Math.min(p - 3, 9 - p, 1), -1), "f");
  let c = "rgb";
  const d = [Math.round(l(0) * 255), Math.round(l(8) * 255), Math.round(l(4) * 255)];
  return e.type === "hsla" && (c += "a", d.push(t[3])), ol({
    type: c,
    values: d
  });
}
a(m5, "hslToRgb");
function p1(e) {
  e = Oo(e);
  let t = e.type === "hsl" || e.type === "hsla" ? Oo(m5(e)).values : e.values;
  return t = t.map((n) => (e.type !== "color" && (n /= 255), n <= 0.03928 ? n / 12.92 : ((n + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
a(p1, "getLuminance");
function t3(e, t) {
  const n = p1(e), o = p1(t);
  return (Math.max(n, o) + 0.05) / (Math.min(n, o) + 0.05);
}
a(t3, "getContrastRatio");
function De(e, t) {
  return e = Oo(e), t = fc(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, ol(e);
}
a(De, "alpha$1");
function ws(e, t, n) {
  try {
    return De(e, t);
  } catch {
    return e;
  }
}
a(ws, "private_safeAlpha");
function Ni(e, t) {
  if (e = Oo(e), t = fc(t), e.type.includes("hsl"))
    e.values[2] *= 1 - t;
  else if (e.type.includes("rgb") || e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] *= 1 - t;
  return ol(e);
}
a(Ni, "darken");
function rt(e, t, n) {
  try {
    return Ni(e, t);
  } catch {
    return e;
  }
}
a(rt, "private_safeDarken");
function zi(e, t) {
  if (e = Oo(e), t = fc(t), e.type.includes("hsl"))
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.includes("rgb"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * t;
  else if (e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (1 - e.values[n]) * t;
  return ol(e);
}
a(zi, "lighten");
function it(e, t, n) {
  try {
    return zi(e, t);
  } catch {
    return e;
  }
}
a(it, "private_safeLighten");
function dp(e, t = 0.15) {
  return p1(e) > 0.5 ? Ni(e, t) : zi(e, t);
}
a(dp, "emphasize");
function Ss(e, t, n) {
  try {
    return dp(e, t);
  } catch {
    return e;
  }
}
a(Ss, "private_safeEmphasize");
const up = "exact-prop: ​";
function b5(e) {
  return process.env.NODE_ENV === "production" ? e : {
    ...e,
    [up]: (t) => {
      const n = Object.keys(t).filter((o) => !e.hasOwnProperty(o));
      return n.length > 0 ? new Error(`The following props are not supported: ${n.map((o) => `\`${o}\``).join(", ")}. Please remove them.`) : null;
    }
  };
}
a(b5, "exactProp");
const pp = /* @__PURE__ */ k.createContext();
process.env.NODE_ENV !== "production" && (s.node, s.bool);
const Dr = /* @__PURE__ */ a(() => k.useContext(pp) ?? !1, "useRtl"), fp = /* @__PURE__ */ k.createContext(void 0);
process.env.NODE_ENV !== "production" && (s.node, s.object);
function hp(e) {
  const {
    theme: t,
    name: n,
    props: o
  } = e;
  if (!t || !t.components || !t.components[n])
    return o;
  const r = t.components[n];
  return r.defaultProps ? sa(r.defaultProps, o) : !r.styleOverrides && !r.variants ? sa(r, o) : o;
}
a(hp, "getThemeProps");
function gp({
  props: e,
  name: t
}) {
  const n = k.useContext(fp);
  return hp({
    props: e,
    name: t,
    theme: {
      components: n
    }
  });
}
a(gp, "useDefaultProps$1");
const n3 = {
  theme: void 0
};
function mp(e) {
  let t, n;
  return /* @__PURE__ */ a(function(r) {
    let i = t;
    return (i === void 0 || r.theme !== n) && (n3.theme = r.theme, i = f5(e(n3)), t = i, n = r.theme), i;
  }, "styleMemoized");
}
a(mp, "unstable_memoTheme");
function bp(e = "") {
  function t(...o) {
    if (!o.length)
      return "";
    const r = o[0];
    return typeof r == "string" && !r.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${e ? `${e}-` : ""}${r}${t(...o.slice(1))})` : `, ${r}`;
  }
  return a(t, "appendVar"), /* @__PURE__ */ a((o, ...r) => `var(--${e ? `${e}-` : ""}${o}${t(...r)})`, "getCssVar");
}
a(bp, "createGetCssVar$1");
const o3 = /* @__PURE__ */ a((e, t, n, o = []) => {
  let r = e;
  t.forEach((i, l) => {
    l === t.length - 1 ? Array.isArray(r) ? r[Number(i)] = n : r && typeof r == "object" && (r[i] = n) : r && typeof r == "object" && (r[i] || (r[i] = o.includes(i) ? [] : {}), r = r[i]);
  });
}, "assignNestedKeys"), Cp = /* @__PURE__ */ a((e, t, n) => {
  function o(r, i = [], l = []) {
    Object.entries(r).forEach(([c, d]) => {
      (!n || n && !n([...i, c])) && d != null && (typeof d == "object" && Object.keys(d).length > 0 ? o(d, [...i, c], Array.isArray(d) ? [...l, c] : l) : t([...i, c], d, l));
    });
  }
  a(o, "recurse"), o(e);
}, "walkObjectDeep"), yp = /* @__PURE__ */ a((e, t) => typeof t == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((o) => e.includes(o)) || e[e.length - 1].toLowerCase().includes("opacity") ? t : `${t}px` : t, "getCssValue");
function Al(e, t) {
  const {
    prefix: n,
    shouldSkipGeneratingVar: o
  } = t || {}, r = {}, i = {}, l = {};
  return Cp(
    e,
    (c, d, u) => {
      if ((typeof d == "string" || typeof d == "number") && (!o || !o(c, d))) {
        const p = `--${n ? `${n}-` : ""}${c.join("-")}`, f = yp(c, d);
        Object.assign(r, {
          [p]: f
        }), o3(i, c, `var(${p})`, u), o3(l, c, `var(${p}, ${f})`, u);
      }
    },
    (c) => c[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: r,
    vars: i,
    varsWithDefaults: l
  };
}
a(Al, "cssVarsParser");
function xp(e, t = {}) {
  const {
    getSelector: n = y,
    disableCssColorScheme: o,
    colorSchemeSelector: r
  } = t, {
    colorSchemes: i = {},
    components: l,
    defaultColorScheme: c = "light",
    ...d
  } = e, {
    vars: u,
    css: p,
    varsWithDefaults: f
  } = Al(d, t);
  let m = f;
  const b = {}, {
    [c]: C,
    ...g
  } = i;
  if (Object.entries(g || {}).forEach(([x, S]) => {
    const {
      vars: M,
      css: O,
      varsWithDefaults: P
    } = Al(S, t);
    m = zt(m, P), b[x] = {
      css: O,
      vars: M
    };
  }), C) {
    const {
      css: x,
      vars: S,
      varsWithDefaults: M
    } = Al(C, t);
    m = zt(m, M), b[c] = {
      css: x,
      vars: S
    };
  }
  function y(x, S) {
    var O, P;
    let M = r;
    if (r === "class" && (M = ".%s"), r === "data" && (M = "[data-%s]"), r != null && r.startsWith("data-") && !r.includes("%s") && (M = `[${r}="%s"]`), x) {
      if (M === "media")
        return e.defaultColorScheme === x ? ":root" : {
          [`@media (prefers-color-scheme: ${((P = (O = i[x]) == null ? void 0 : O.palette) == null ? void 0 : P.mode) || x})`]: {
            ":root": S
          }
        };
      if (M)
        return e.defaultColorScheme === x ? `:root, ${M.replace("%s", String(x))}` : M.replace("%s", String(x));
    }
    return ":root";
  }
  return a(y, "defaultGetSelector"), {
    vars: m,
    generateThemeVars: /* @__PURE__ */ a(() => {
      let x = {
        ...u
      };
      return Object.entries(b).forEach(([, {
        vars: S
      }]) => {
        x = zt(x, S);
      }), x;
    }, "generateThemeVars"),
    generateStyleSheets: /* @__PURE__ */ a(() => {
      var E, I;
      const x = [], S = e.defaultColorScheme || "light";
      function M(v, _) {
        Object.keys(_).length && x.push(typeof v == "string" ? {
          [v]: {
            ..._
          }
        } : v);
      }
      a(M, "insertStyleSheet"), M(n(void 0, {
        ...p
      }), p);
      const {
        [S]: O,
        ...P
      } = b;
      if (O) {
        const {
          css: v
        } = O, _ = (I = (E = i[S]) == null ? void 0 : E.palette) == null ? void 0 : I.mode, R = !o && _ ? {
          colorScheme: _,
          ...v
        } : {
          ...v
        };
        M(n(S, {
          ...R
        }), R);
      }
      return Object.entries(P).forEach(([v, {
        css: _
      }]) => {
        var B, V;
        const R = (V = (B = i[v]) == null ? void 0 : B.palette) == null ? void 0 : V.mode, j = !o && R ? {
          colorScheme: R,
          ..._
        } : {
          ..._
        };
        M(n(v, {
          ...j
        }), j);
      }), x;
    }, "generateStyleSheets")
  };
}
a(xp, "prepareCssVars");
function vp(e) {
  return /* @__PURE__ */ a(function(n) {
    return e === "media" ? (process.env.NODE_ENV !== "production" && n !== "light" && n !== "dark" && console.error(`MUI: @media (prefers-color-scheme) supports only 'light' or 'dark', but receive '${n}'.`), `@media (prefers-color-scheme: ${n})`) : e ? e.startsWith("data-") && !e.includes("%s") ? `[${e}="${n}"] &` : e === "class" ? `.${n} &` : e === "data" ? `[data-${n}] &` : `${e.replace("%s", n)} &` : "&";
  }, "getColorSchemeSelector");
}
a(vp, "createGetColorSchemeSelector");
function ke(e, t, n = void 0) {
  const o = {};
  for (const r in e) {
    const i = e[r];
    let l = "", c = !0;
    for (let d = 0; d < i.length; d += 1) {
      const u = i[d];
      u && (l += (c === !0 ? "" : " ") + t(u), c = !1, n && n[u] && (l += " " + n[u]));
    }
    o[r] = l;
  }
  return o;
}
a(ke, "composeClasses");
function Bl(e, t) {
  var n, o, r;
  return /* @__PURE__ */ k.isValidElement(e) && t.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    e.type.muiName ?? ((r = (o = (n = e.type) == null ? void 0 : n._payload) == null ? void 0 : o.value) == null ? void 0 : r.muiName)
  ) !== -1;
}
a(Bl, "isMuiElement");
function C5() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: Ai.white,
      default: Ai.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
a(C5, "getLight");
const wp = C5();
function y5() {
  return {
    text: {
      primary: Ai.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: Ai.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
a(y5, "getDark");
const r3 = y5();
function i3(e, t, n, o) {
  const r = o.light || o, i = o.dark || o * 1.5;
  e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = zi(e.main, r) : t === "dark" && (e.dark = Ni(e.main, i)));
}
a(i3, "addLightOrDark");
function Sp(e = "light") {
  return e === "dark" ? {
    main: ur[200],
    light: ur[50],
    dark: ur[400]
  } : {
    main: ur[700],
    light: ur[400],
    dark: ur[800]
  };
}
a(Sp, "getDefaultPrimary");
function Mp(e = "light") {
  return e === "dark" ? {
    main: dr[200],
    light: dr[50],
    dark: dr[400]
  } : {
    main: dr[500],
    light: dr[300],
    dark: dr[700]
  };
}
a(Mp, "getDefaultSecondary");
function Tp(e = "light") {
  return e === "dark" ? {
    main: cr[500],
    light: cr[300],
    dark: cr[700]
  } : {
    main: cr[700],
    light: cr[400],
    dark: cr[800]
  };
}
a(Tp, "getDefaultError");
function kp(e = "light") {
  return e === "dark" ? {
    main: pr[400],
    light: pr[300],
    dark: pr[700]
  } : {
    main: pr[700],
    light: pr[500],
    dark: pr[900]
  };
}
a(kp, "getDefaultInfo");
function Op(e = "light") {
  return e === "dark" ? {
    main: fr[400],
    light: fr[300],
    dark: fr[700]
  } : {
    main: fr[800],
    light: fr[500],
    dark: fr[900]
  };
}
a(Op, "getDefaultSuccess");
function Ep(e = "light") {
  return e === "dark" ? {
    main: qr[400],
    light: qr[300],
    dark: qr[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: qr[500],
    dark: qr[900]
  };
}
a(Ep, "getDefaultWarning");
function hc(e) {
  const {
    mode: t = "light",
    contrastThreshold: n = 3,
    tonalOffset: o = 0.2,
    ...r
  } = e, i = e.primary || Sp(t), l = e.secondary || Mp(t), c = e.error || Tp(t), d = e.info || kp(t), u = e.success || Op(t), p = e.warning || Ep(t);
  function f(g) {
    const y = t3(g, r3.text.primary) >= n ? r3.text.primary : wp.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const w = t3(g, y);
      w < 3 && console.error([`MUI: The contrast ratio of ${w}:1 for ${y} on ${g}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return y;
  }
  a(f, "getContrastText");
  const m = /* @__PURE__ */ a(({
    color: g,
    name: y,
    mainShade: w = 500,
    lightShade: T = 300,
    darkShade: x = 700
  }) => {
    if (g = {
      ...g
    }, !g.main && g[w] && (g.main = g[w]), !g.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${y ? ` (${y})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${w}\` property.` : qn(11, y ? ` (${y})` : "", w));
    if (typeof g.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${y ? ` (${y})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(g.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : qn(12, y ? ` (${y})` : "", JSON.stringify(g.main)));
    return i3(g, "light", T, o), i3(g, "dark", x, o), g.contrastText || (g.contrastText = f(g.main)), g;
  }, "augmentColor");
  let b;
  return t === "light" ? b = C5() : t === "dark" && (b = y5()), process.env.NODE_ENV !== "production" && (b || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), zt({
    // A collection of common colors.
    common: {
      ...Ai
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: m({
      color: i,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: m({
      color: l,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: m({
      color: c,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: m({
      color: p,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: m({
      color: d,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: m({
      color: u,
      name: "success"
    }),
    // The grey colors.
    grey: Hu,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: f,
    // Generate a rich color object.
    augmentColor: m,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: o,
    // The light and dark mode object.
    ...b
  }, r);
}
a(hc, "createPalette");
function $p(e) {
  const t = {};
  return Object.entries(e).forEach((o) => {
    const [r, i] = o;
    typeof i == "object" && (t[r] = `${i.fontStyle ? `${i.fontStyle} ` : ""}${i.fontVariant ? `${i.fontVariant} ` : ""}${i.fontWeight ? `${i.fontWeight} ` : ""}${i.fontStretch ? `${i.fontStretch} ` : ""}${i.fontSize || ""}${i.lineHeight ? `/${i.lineHeight} ` : ""}${i.fontFamily || ""}`);
  }), t;
}
a($p, "prepareTypographyVars");
function Pp(e, t) {
  return {
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    },
    ...t
  };
}
a(Pp, "createMixins");
function _p(e) {
  return Math.round(e * 1e5) / 1e5;
}
a(_p, "round$3");
const s3 = {
  textTransform: "uppercase"
}, a3 = '"Roboto", "Helvetica", "Arial", sans-serif';
function Rp(e, t) {
  const {
    fontFamily: n = a3,
    // The default font size of the Material Specification.
    fontSize: o = 14,
    // px
    fontWeightLight: r = 300,
    fontWeightRegular: i = 400,
    fontWeightMedium: l = 500,
    fontWeightBold: c = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: d = 16,
    // Apply the CSS properties to all the variants.
    allVariants: u,
    pxToRem: p,
    ...f
  } = typeof t == "function" ? t(e) : t;
  process.env.NODE_ENV !== "production" && (typeof o != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof d != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const m = o / 14, b = p || ((y) => `${y / d * m}rem`), C = /* @__PURE__ */ a((y, w, T, x, S) => ({
    fontFamily: n,
    fontWeight: y,
    fontSize: b(w),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: T,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...n === a3 ? {
      letterSpacing: `${_p(x / w)}em`
    } : {},
    ...S,
    ...u
  }), "buildVariant"), g = {
    h1: C(r, 96, 1.167, -1.5),
    h2: C(r, 60, 1.2, -0.5),
    h3: C(i, 48, 1.167, 0),
    h4: C(i, 34, 1.235, 0.25),
    h5: C(i, 24, 1.334, 0),
    h6: C(l, 20, 1.6, 0.15),
    subtitle1: C(i, 16, 1.75, 0.15),
    subtitle2: C(l, 14, 1.57, 0.1),
    body1: C(i, 16, 1.5, 0.15),
    body2: C(i, 14, 1.43, 0.15),
    button: C(l, 14, 1.75, 0.4, s3),
    caption: C(i, 12, 1.66, 0.4),
    overline: C(i, 12, 2.66, 1, s3),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return zt({
    htmlFontSize: d,
    pxToRem: b,
    fontFamily: n,
    fontSize: o,
    fontWeightLight: r,
    fontWeightRegular: i,
    fontWeightMedium: l,
    fontWeightBold: c,
    ...g
  }, f, {
    clone: !1
    // No need to clone deep
  });
}
a(Rp, "createTypography");
const Ip = 0.2, jp = 0.14, Lp = 0.12;
function ct(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${Ip})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${jp})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${Lp})`].join(",");
}
a(ct, "createShadow");
const Vp = ["none", ct(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), ct(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), ct(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), ct(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), ct(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), ct(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), ct(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), ct(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), ct(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), ct(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), ct(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), ct(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), ct(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), ct(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), ct(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), ct(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), ct(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), ct(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), ct(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), ct(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), ct(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), ct(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), ct(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), ct(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], Ap = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, x5 = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function l3(e) {
  return `${Math.round(e)}ms`;
}
a(l3, "formatMs");
function Bp(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.min(Math.round((4 + 15 * t ** 0.25 + t / 5) * 10), 3e3);
}
a(Bp, "getAutoHeightDuration");
function Hp(e) {
  const t = {
    ...Ap,
    ...e.easing
  }, n = {
    ...x5,
    ...e.duration
  };
  return {
    getAutoHeightDuration: Bp,
    create: /* @__PURE__ */ a((r = ["all"], i = {}) => {
      const {
        duration: l = n.standard,
        easing: c = t.easeInOut,
        delay: d = 0,
        ...u
      } = i;
      if (process.env.NODE_ENV !== "production") {
        const p = /* @__PURE__ */ a((m) => typeof m == "string", "isString"), f = /* @__PURE__ */ a((m) => !Number.isNaN(parseFloat(m)), "isNumber");
        !p(r) && !Array.isArray(r) && console.error('MUI: Argument "props" must be a string or Array.'), !f(l) && !p(l) && console.error(`MUI: Argument "duration" must be a number or a string but found ${l}.`), p(c) || console.error('MUI: Argument "easing" must be a string.'), !f(d) && !p(d) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof i != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(u).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(u).join(",")}].`);
      }
      return (Array.isArray(r) ? r : [r]).map((p) => `${p} ${typeof l == "string" ? l : l3(l)} ${c} ${typeof d == "string" ? d : l3(d)}`).join(",");
    }, "create"),
    ...e,
    easing: t,
    duration: n
  };
}
a(Hp, "createTransitions");
const Dp = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function Np(e) {
  return Zn(e) || typeof e > "u" || typeof e == "string" || typeof e == "boolean" || typeof e == "number" || Array.isArray(e);
}
a(Np, "isSerializable");
function v5(e = {}) {
  const t = {
    ...e
  };
  function n(o) {
    const r = Object.entries(o);
    for (let i = 0; i < r.length; i++) {
      const [l, c] = r[i];
      !Np(c) || l.startsWith("unstable_") ? delete o[l] : Zn(c) && (o[l] = {
        ...c
      }, n(o[l]));
    }
  }
  return a(n, "serializeTheme"), n(t), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(t, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
a(v5, "stringifyTheme");
function f1(e = {}, ...t) {
  const {
    breakpoints: n,
    mixins: o = {},
    spacing: r,
    palette: i = {},
    transitions: l = {},
    typography: c = {},
    shape: d,
    ...u
  } = e;
  if (e.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
  // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
  e.generateThemeVars === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name or follow the [docs](https://mui.com/material-ui/customization/css-theme-variables/usage/) to enable the feature." : qn(20));
  const p = hc(i), f = uc(e);
  let m = zt(f, {
    mixins: Pp(f.breakpoints, o),
    palette: p,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: Vp.slice(),
    typography: Rp(p, c),
    transitions: Hp(l),
    zIndex: {
      ...Dp
    }
  });
  if (m = zt(m, u), m = t.reduce((b, C) => zt(b, C), m), process.env.NODE_ENV !== "production") {
    const b = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], C = /* @__PURE__ */ a((g, y) => {
      let w;
      for (w in g) {
        const T = g[w];
        if (b.includes(w) && Object.keys(T).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const x = Te("", w);
            console.error([`MUI: The \`${y}\` component increases the CSS specificity of the \`${w}\` internal state.`, "You can not override it like this: ", JSON.stringify(g, null, 2), "", `Instead, you need to use the '&.${x}' syntax:`, JSON.stringify({
              root: {
                [`&.${x}`]: T
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          g[w] = {};
        }
      }
    }, "traverse");
    Object.keys(m.components).forEach((g) => {
      const y = m.components[g].styleOverrides;
      y && g.startsWith("Mui") && C(y, g);
    });
  }
  return m.unstable_sxConfig = {
    ...is,
    ...u == null ? void 0 : u.unstable_sxConfig
  }, m.unstable_sx = /* @__PURE__ */ a(function(C) {
    return tr({
      sx: C,
      theme: this
    });
  }, "sx"), m.toRuntimeSource = v5, m;
}
a(f1, "createThemeNoVars");
function h1(e) {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, Math.round(t * 10) / 1e3;
}
a(h1, "getOverlayAlpha");
const zp = [...Array(25)].map((e, t) => {
  if (t === 0)
    return "none";
  const n = h1(t);
  return `linear-gradient(rgba(255 255 255 / ${n}), rgba(255 255 255 / ${n}))`;
});
function w5(e) {
  return {
    inputPlaceholder: e === "dark" ? 0.5 : 0.42,
    inputUnderline: e === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: e === "dark" ? 0.2 : 0.12,
    switchTrack: e === "dark" ? 0.3 : 0.38
  };
}
a(w5, "getOpacity");
function S5(e) {
  return e === "dark" ? zp : [];
}
a(S5, "getOverlays");
function Fp(e) {
  const {
    palette: t = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: n,
    overlays: o,
    ...r
  } = e, i = hc(t);
  return {
    palette: i,
    opacity: {
      ...w5(i.mode),
      ...n
    },
    overlays: o || S5(i.mode),
    ...r
  };
}
a(Fp, "createColorScheme");
function Wp(e) {
  var t;
  return !!e[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!((t = e[1]) != null && t.match(/(mode|contrastThreshold|tonalOffset)/));
}
a(Wp, "shouldSkipGeneratingVar");
const Zp = /* @__PURE__ */ a((e) => [...[...Array(25)].map((t, n) => `--${e ? `${e}-` : ""}overlays-${n}`), `--${e ? `${e}-` : ""}palette-AppBar-darkBg`, `--${e ? `${e}-` : ""}palette-AppBar-darkColor`], "excludeVariablesFromRoot"), Up = /* @__PURE__ */ a((e) => (t, n) => {
  const o = e.rootSelector || ":root", r = e.colorSchemeSelector;
  let i = r;
  if (r === "class" && (i = ".%s"), r === "data" && (i = "[data-%s]"), r != null && r.startsWith("data-") && !r.includes("%s") && (i = `[${r}="%s"]`), e.defaultColorScheme === t) {
    if (t === "dark") {
      const l = {};
      return Zp(e.cssVarPrefix).forEach((c) => {
        l[c] = n[c], delete n[c];
      }), i === "media" ? {
        [o]: n,
        "@media (prefers-color-scheme: dark)": {
          [o]: l
        }
      } : i ? {
        [i.replace("%s", t)]: l,
        [`${o}, ${i.replace("%s", t)}`]: n
      } : {
        [o]: {
          ...n,
          ...l
        }
      };
    }
    if (i && i !== "media")
      return `${o}, ${i.replace("%s", String(t))}`;
  } else if (t) {
    if (i === "media")
      return {
        [`@media (prefers-color-scheme: ${String(t)})`]: {
          [o]: n
        }
      };
    if (i)
      return i.replace("%s", String(t));
  }
  return o;
}, "defaultGetSelector");
function Gp(e, t) {
  t.forEach((n) => {
    e[n] || (e[n] = {});
  });
}
a(Gp, "assignNode");
function Z(e, t, n) {
  !e[t] && n && (e[t] = n);
}
a(Z, "setColor");
function di(e) {
  return typeof e != "string" || !e.startsWith("hsl") ? e : m5(e);
}
a(di, "toRgb");
function Qn(e, t) {
  `${t}Channel` in e || (e[`${t}Channel`] = ci(di(e[t]), `MUI: Can't create \`palette.${t}Channel\` because \`palette.${t}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${t}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`));
}
a(Qn, "setColorChannel");
function Yp(e) {
  return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
a(Yp, "getSpacingVal");
const Hn = /* @__PURE__ */ a((e) => {
  try {
    return e();
  } catch {
  }
}, "silent"), qp = /* @__PURE__ */ a((e = "mui") => bp(e), "createGetCssVar");
function Hl(e, t, n, o) {
  if (!t)
    return;
  t = t === !0 ? {} : t;
  const r = o === "dark" ? "dark" : "light";
  if (!n) {
    e[o] = Fp({
      ...t,
      palette: {
        mode: r,
        ...t == null ? void 0 : t.palette
      }
    });
    return;
  }
  const {
    palette: i,
    ...l
  } = f1({
    ...n,
    palette: {
      mode: r,
      ...t == null ? void 0 : t.palette
    }
  });
  return e[o] = {
    ...t,
    palette: i,
    opacity: {
      ...w5(r),
      ...t == null ? void 0 : t.opacity
    },
    overlays: (t == null ? void 0 : t.overlays) || S5(r)
  }, l;
}
a(Hl, "attachColorScheme$1");
function Kp(e = {}, ...t) {
  const {
    colorSchemes: n = {
      light: !0
    },
    defaultColorScheme: o,
    disableCssColorScheme: r = !1,
    cssVarPrefix: i = "mui",
    shouldSkipGeneratingVar: l = Wp,
    colorSchemeSelector: c = n.light && n.dark ? "media" : void 0,
    rootSelector: d = ":root",
    ...u
  } = e, p = Object.keys(n)[0], f = o || (n.light && p !== "light" ? "light" : p), m = qp(i), {
    [f]: b,
    light: C,
    dark: g,
    ...y
  } = n, w = {
    ...y
  };
  let T = b;
  if ((f === "dark" && !("dark" in n) || f === "light" && !("light" in n)) && (T = !0), !T)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The \`colorSchemes.${f}\` option is either missing or invalid.` : qn(21, f));
  const x = Hl(w, T, u, f);
  C && !w.light && Hl(w, C, void 0, "light"), g && !w.dark && Hl(w, g, void 0, "dark");
  let S = {
    defaultColorScheme: f,
    ...x,
    cssVarPrefix: i,
    colorSchemeSelector: c,
    rootSelector: d,
    getCssVar: m,
    colorSchemes: w,
    font: {
      ...$p(x.typography),
      ...x.font
    },
    spacing: Yp(u.spacing)
  };
  Object.keys(S.colorSchemes).forEach((I) => {
    const v = S.colorSchemes[I].palette, _ = /* @__PURE__ */ a((R) => {
      const j = R.split("-"), B = j[1], V = j[2];
      return m(R, v[B][V]);
    }, "setCssVarColor");
    if (v.mode === "light" && (Z(v.common, "background", "#fff"), Z(v.common, "onBackground", "#000")), v.mode === "dark" && (Z(v.common, "background", "#000"), Z(v.common, "onBackground", "#fff")), Gp(v, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), v.mode === "light") {
      Z(v.Alert, "errorColor", rt(v.error.light, 0.6)), Z(v.Alert, "infoColor", rt(v.info.light, 0.6)), Z(v.Alert, "successColor", rt(v.success.light, 0.6)), Z(v.Alert, "warningColor", rt(v.warning.light, 0.6)), Z(v.Alert, "errorFilledBg", _("palette-error-main")), Z(v.Alert, "infoFilledBg", _("palette-info-main")), Z(v.Alert, "successFilledBg", _("palette-success-main")), Z(v.Alert, "warningFilledBg", _("palette-warning-main")), Z(v.Alert, "errorFilledColor", Hn(() => v.getContrastText(v.error.main))), Z(v.Alert, "infoFilledColor", Hn(() => v.getContrastText(v.info.main))), Z(v.Alert, "successFilledColor", Hn(() => v.getContrastText(v.success.main))), Z(v.Alert, "warningFilledColor", Hn(() => v.getContrastText(v.warning.main))), Z(v.Alert, "errorStandardBg", it(v.error.light, 0.9)), Z(v.Alert, "infoStandardBg", it(v.info.light, 0.9)), Z(v.Alert, "successStandardBg", it(v.success.light, 0.9)), Z(v.Alert, "warningStandardBg", it(v.warning.light, 0.9)), Z(v.Alert, "errorIconColor", _("palette-error-main")), Z(v.Alert, "infoIconColor", _("palette-info-main")), Z(v.Alert, "successIconColor", _("palette-success-main")), Z(v.Alert, "warningIconColor", _("palette-warning-main")), Z(v.AppBar, "defaultBg", _("palette-grey-100")), Z(v.Avatar, "defaultBg", _("palette-grey-400")), Z(v.Button, "inheritContainedBg", _("palette-grey-300")), Z(v.Button, "inheritContainedHoverBg", _("palette-grey-A100")), Z(v.Chip, "defaultBorder", _("palette-grey-400")), Z(v.Chip, "defaultAvatarColor", _("palette-grey-700")), Z(v.Chip, "defaultIconColor", _("palette-grey-700")), Z(v.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), Z(v.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), Z(v.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), Z(v.LinearProgress, "primaryBg", it(v.primary.main, 0.62)), Z(v.LinearProgress, "secondaryBg", it(v.secondary.main, 0.62)), Z(v.LinearProgress, "errorBg", it(v.error.main, 0.62)), Z(v.LinearProgress, "infoBg", it(v.info.main, 0.62)), Z(v.LinearProgress, "successBg", it(v.success.main, 0.62)), Z(v.LinearProgress, "warningBg", it(v.warning.main, 0.62)), Z(v.Skeleton, "bg", `rgba(${_("palette-text-primaryChannel")} / 0.11)`), Z(v.Slider, "primaryTrack", it(v.primary.main, 0.62)), Z(v.Slider, "secondaryTrack", it(v.secondary.main, 0.62)), Z(v.Slider, "errorTrack", it(v.error.main, 0.62)), Z(v.Slider, "infoTrack", it(v.info.main, 0.62)), Z(v.Slider, "successTrack", it(v.success.main, 0.62)), Z(v.Slider, "warningTrack", it(v.warning.main, 0.62));
      const R = Ss(v.background.default, 0.8);
      Z(v.SnackbarContent, "bg", R), Z(v.SnackbarContent, "color", Hn(() => v.getContrastText(R))), Z(v.SpeedDialAction, "fabHoverBg", Ss(v.background.paper, 0.15)), Z(v.StepConnector, "border", _("palette-grey-400")), Z(v.StepContent, "border", _("palette-grey-400")), Z(v.Switch, "defaultColor", _("palette-common-white")), Z(v.Switch, "defaultDisabledColor", _("palette-grey-100")), Z(v.Switch, "primaryDisabledColor", it(v.primary.main, 0.62)), Z(v.Switch, "secondaryDisabledColor", it(v.secondary.main, 0.62)), Z(v.Switch, "errorDisabledColor", it(v.error.main, 0.62)), Z(v.Switch, "infoDisabledColor", it(v.info.main, 0.62)), Z(v.Switch, "successDisabledColor", it(v.success.main, 0.62)), Z(v.Switch, "warningDisabledColor", it(v.warning.main, 0.62)), Z(v.TableCell, "border", it(ws(v.divider, 1), 0.88)), Z(v.Tooltip, "bg", ws(v.grey[700], 0.92));
    }
    if (v.mode === "dark") {
      Z(v.Alert, "errorColor", it(v.error.light, 0.6)), Z(v.Alert, "infoColor", it(v.info.light, 0.6)), Z(v.Alert, "successColor", it(v.success.light, 0.6)), Z(v.Alert, "warningColor", it(v.warning.light, 0.6)), Z(v.Alert, "errorFilledBg", _("palette-error-dark")), Z(v.Alert, "infoFilledBg", _("palette-info-dark")), Z(v.Alert, "successFilledBg", _("palette-success-dark")), Z(v.Alert, "warningFilledBg", _("palette-warning-dark")), Z(v.Alert, "errorFilledColor", Hn(() => v.getContrastText(v.error.dark))), Z(v.Alert, "infoFilledColor", Hn(() => v.getContrastText(v.info.dark))), Z(v.Alert, "successFilledColor", Hn(() => v.getContrastText(v.success.dark))), Z(v.Alert, "warningFilledColor", Hn(() => v.getContrastText(v.warning.dark))), Z(v.Alert, "errorStandardBg", rt(v.error.light, 0.9)), Z(v.Alert, "infoStandardBg", rt(v.info.light, 0.9)), Z(v.Alert, "successStandardBg", rt(v.success.light, 0.9)), Z(v.Alert, "warningStandardBg", rt(v.warning.light, 0.9)), Z(v.Alert, "errorIconColor", _("palette-error-main")), Z(v.Alert, "infoIconColor", _("palette-info-main")), Z(v.Alert, "successIconColor", _("palette-success-main")), Z(v.Alert, "warningIconColor", _("palette-warning-main")), Z(v.AppBar, "defaultBg", _("palette-grey-900")), Z(v.AppBar, "darkBg", _("palette-background-paper")), Z(v.AppBar, "darkColor", _("palette-text-primary")), Z(v.Avatar, "defaultBg", _("palette-grey-600")), Z(v.Button, "inheritContainedBg", _("palette-grey-800")), Z(v.Button, "inheritContainedHoverBg", _("palette-grey-700")), Z(v.Chip, "defaultBorder", _("palette-grey-700")), Z(v.Chip, "defaultAvatarColor", _("palette-grey-300")), Z(v.Chip, "defaultIconColor", _("palette-grey-300")), Z(v.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), Z(v.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), Z(v.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), Z(v.LinearProgress, "primaryBg", rt(v.primary.main, 0.5)), Z(v.LinearProgress, "secondaryBg", rt(v.secondary.main, 0.5)), Z(v.LinearProgress, "errorBg", rt(v.error.main, 0.5)), Z(v.LinearProgress, "infoBg", rt(v.info.main, 0.5)), Z(v.LinearProgress, "successBg", rt(v.success.main, 0.5)), Z(v.LinearProgress, "warningBg", rt(v.warning.main, 0.5)), Z(v.Skeleton, "bg", `rgba(${_("palette-text-primaryChannel")} / 0.13)`), Z(v.Slider, "primaryTrack", rt(v.primary.main, 0.5)), Z(v.Slider, "secondaryTrack", rt(v.secondary.main, 0.5)), Z(v.Slider, "errorTrack", rt(v.error.main, 0.5)), Z(v.Slider, "infoTrack", rt(v.info.main, 0.5)), Z(v.Slider, "successTrack", rt(v.success.main, 0.5)), Z(v.Slider, "warningTrack", rt(v.warning.main, 0.5));
      const R = Ss(v.background.default, 0.98);
      Z(v.SnackbarContent, "bg", R), Z(v.SnackbarContent, "color", Hn(() => v.getContrastText(R))), Z(v.SpeedDialAction, "fabHoverBg", Ss(v.background.paper, 0.15)), Z(v.StepConnector, "border", _("palette-grey-600")), Z(v.StepContent, "border", _("palette-grey-600")), Z(v.Switch, "defaultColor", _("palette-grey-300")), Z(v.Switch, "defaultDisabledColor", _("palette-grey-600")), Z(v.Switch, "primaryDisabledColor", rt(v.primary.main, 0.55)), Z(v.Switch, "secondaryDisabledColor", rt(v.secondary.main, 0.55)), Z(v.Switch, "errorDisabledColor", rt(v.error.main, 0.55)), Z(v.Switch, "infoDisabledColor", rt(v.info.main, 0.55)), Z(v.Switch, "successDisabledColor", rt(v.success.main, 0.55)), Z(v.Switch, "warningDisabledColor", rt(v.warning.main, 0.55)), Z(v.TableCell, "border", rt(ws(v.divider, 1), 0.68)), Z(v.Tooltip, "bg", ws(v.grey[700], 0.92));
    }
    Qn(v.background, "default"), Qn(v.background, "paper"), Qn(v.common, "background"), Qn(v.common, "onBackground"), Qn(v, "divider"), Object.keys(v).forEach((R) => {
      const j = v[R];
      R !== "tonalOffset" && j && typeof j == "object" && (j.main && Z(v[R], "mainChannel", ci(di(j.main))), j.light && Z(v[R], "lightChannel", ci(di(j.light))), j.dark && Z(v[R], "darkChannel", ci(di(j.dark))), j.contrastText && Z(v[R], "contrastTextChannel", ci(di(j.contrastText))), R === "text" && (Qn(v[R], "primary"), Qn(v[R], "secondary")), R === "action" && (j.active && Qn(v[R], "active"), j.selected && Qn(v[R], "selected")));
    });
  }), S = t.reduce((I, v) => zt(I, v), S);
  const M = {
    prefix: i,
    disableCssColorScheme: r,
    shouldSkipGeneratingVar: l,
    getSelector: Up(S)
  }, {
    vars: O,
    generateThemeVars: P,
    generateStyleSheets: E
  } = xp(S, M);
  return S.vars = O, Object.entries(S.colorSchemes[S.defaultColorScheme]).forEach(([I, v]) => {
    S[I] = v;
  }), S.generateThemeVars = P, S.generateStyleSheets = E, S.generateSpacing = /* @__PURE__ */ a(function() {
    return a5(u.spacing, cc(this));
  }, "generateSpacing"), S.getColorSchemeSelector = vp(c), S.spacing = S.generateSpacing(), S.shouldSkipGeneratingVar = l, S.unstable_sxConfig = {
    ...is,
    ...u == null ? void 0 : u.unstable_sxConfig
  }, S.unstable_sx = /* @__PURE__ */ a(function(v) {
    return tr({
      sx: v,
      theme: this
    });
  }, "sx"), S.toRuntimeSource = v5, S;
}
a(Kp, "createThemeWithVars");
function c3(e, t, n) {
  e.colorSchemes && n && (e.colorSchemes[t] = {
    ...n !== !0 && n,
    palette: hc({
      ...n === !0 ? {} : n.palette,
      mode: t
    })
    // cast type to skip module augmentation test
  });
}
a(c3, "attachColorScheme");
function gc(e = {}, ...t) {
  const {
    palette: n,
    cssVariables: o = !1,
    colorSchemes: r = n ? void 0 : {
      light: !0
    },
    defaultColorScheme: i = n == null ? void 0 : n.mode,
    ...l
  } = e, c = i || "light", d = r == null ? void 0 : r[c], u = {
    ...r,
    ...n ? {
      [c]: {
        ...typeof d != "boolean" && d,
        palette: n
      }
    } : void 0
  };
  if (o === !1) {
    if (!("colorSchemes" in e))
      return f1(e, ...t);
    let p = n;
    "palette" in e || u[c] && (u[c] !== !0 ? p = u[c].palette : c === "dark" && (p = {
      mode: "dark"
    }));
    const f = f1({
      ...e,
      palette: p
    }, ...t);
    return f.defaultColorScheme = c, f.colorSchemes = u, f.palette.mode === "light" && (f.colorSchemes.light = {
      ...u.light !== !0 && u.light,
      palette: f.palette
    }, c3(f, "dark", u.dark)), f.palette.mode === "dark" && (f.colorSchemes.dark = {
      ...u.dark !== !0 && u.dark,
      palette: f.palette
    }, c3(f, "light", u.light)), f;
  }
  return !n && !("light" in u) && c === "light" && (u.light = !0), Kp({
    ...l,
    colorSchemes: u,
    defaultColorScheme: c,
    ...typeof o != "boolean" && o
  }, ...t);
}
a(gc, "createTheme");
const mc = gc();
function uo() {
  const e = pc(mc);
  return process.env.NODE_ENV !== "production" && k.useDebugValue(e), e[Fa] || e;
}
a(uo, "useTheme");
function M5(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
a(M5, "slotShouldForwardProp");
const Vt = /* @__PURE__ */ a((e) => M5(e) && e !== "classes", "rootShouldForwardProp"), ee = np({
  themeId: Fa,
  defaultTheme: mc,
  rootShouldForwardProp: Vt
});
function g1(...e) {
  return e.reduce((t, n) => n == null ? t : /* @__PURE__ */ a(function(...r) {
    t.apply(this, r), n.apply(this, r);
  }, "chainedFunction"), () => {
  });
}
a(g1, "createChainedFunction");
function T5(e) {
  return /* @__PURE__ */ h.jsx(l5, {
    ...e,
    defaultTheme: mc,
    themeId: Fa
  });
}
a(T5, "GlobalStyles");
process.env.NODE_ENV !== "production" && (T5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: s.oneOfType([s.array, s.func, s.number, s.object, s.string, s.bool])
});
function Xp(e) {
  return /* @__PURE__ */ a(function(n) {
    return (
      // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
      /* @__PURE__ */ h.jsx(T5, {
        styles: typeof e == "function" ? (o) => e({
          theme: o,
          ...n
        }) : e
      })
    );
  }, "GlobalStylesWrapper");
}
a(Xp, "globalCss");
function Jp() {
  return c5;
}
a(Jp, "internal_createExtendSxProp");
const we = mp;
process.env.NODE_ENV !== "production" && (s.node, s.object.isRequired);
function $e(e) {
  return gp(e);
}
a($e, "useDefaultProps");
function Qp(e) {
  return Te("MuiSvgIcon", e);
}
a(Qp, "getSvgIconUtilityClass");
Se("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const e8 = /* @__PURE__ */ a((e) => {
  const {
    color: t,
    fontSize: n,
    classes: o
  } = e, r = {
    root: ["root", t !== "inherit" && `color${G(t)}`, `fontSize${G(n)}`]
  };
  return ke(r, Qp, o);
}, "useUtilityClasses$I"), t8 = ee("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${G(n.color)}`], t[`fontSize${G(n.fontSize)}`]];
  }, "overridesResolver")
})(we(({
  theme: e
}) => {
  var t, n, o, r, i, l, c, d, u, p, f, m, b, C;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    flexShrink: 0,
    transition: (r = (t = e.transitions) == null ? void 0 : t.create) == null ? void 0 : r.call(t, "fill", {
      duration: (o = (n = (e.vars ?? e).transitions) == null ? void 0 : n.duration) == null ? void 0 : o.shorter
    }),
    variants: [
      {
        props: /* @__PURE__ */ a((g) => !g.hasSvgAsChild, "props"),
        style: {
          // the <svg> will define the property that has `currentColor`
          // for example heroicons uses fill="none" and stroke="currentColor"
          fill: "currentColor"
        }
      },
      {
        props: {
          fontSize: "inherit"
        },
        style: {
          fontSize: "inherit"
        }
      },
      {
        props: {
          fontSize: "small"
        },
        style: {
          fontSize: ((l = (i = e.typography) == null ? void 0 : i.pxToRem) == null ? void 0 : l.call(i, 20)) || "1.25rem"
        }
      },
      {
        props: {
          fontSize: "medium"
        },
        style: {
          fontSize: ((d = (c = e.typography) == null ? void 0 : c.pxToRem) == null ? void 0 : d.call(c, 24)) || "1.5rem"
        }
      },
      {
        props: {
          fontSize: "large"
        },
        style: {
          fontSize: ((p = (u = e.typography) == null ? void 0 : u.pxToRem) == null ? void 0 : p.call(u, 35)) || "2.1875rem"
        }
      },
      // TODO v5 deprecate color prop, v6 remove for sx
      ...Object.entries((e.vars ?? e).palette).filter(([, g]) => g && g.main).map(([g]) => {
        var y, w;
        return {
          props: {
            color: g
          },
          style: {
            color: (w = (y = (e.vars ?? e).palette) == null ? void 0 : y[g]) == null ? void 0 : w.main
          }
        };
      }),
      {
        props: {
          color: "action"
        },
        style: {
          color: (m = (f = (e.vars ?? e).palette) == null ? void 0 : f.action) == null ? void 0 : m.active
        }
      },
      {
        props: {
          color: "disabled"
        },
        style: {
          color: (C = (b = (e.vars ?? e).palette) == null ? void 0 : b.action) == null ? void 0 : C.disabled
        }
      },
      {
        props: {
          color: "inherit"
        },
        style: {
          color: void 0
        }
      }
    ]
  };
})), aa = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: r,
    className: i,
    color: l = "inherit",
    component: c = "svg",
    fontSize: d = "medium",
    htmlColor: u,
    inheritViewBox: p = !1,
    titleAccess: f,
    viewBox: m = "0 0 24 24",
    ...b
  } = o, C = /* @__PURE__ */ k.isValidElement(r) && r.type === "svg", g = {
    ...o,
    color: l,
    component: c,
    fontSize: d,
    instanceFontSize: t.fontSize,
    inheritViewBox: p,
    viewBox: m,
    hasSvgAsChild: C
  }, y = {};
  p || (y.viewBox = m);
  const w = e8(g);
  return /* @__PURE__ */ h.jsxs(t8, {
    as: c,
    className: le(w.root, i),
    focusable: "false",
    color: u,
    "aria-hidden": f ? void 0 : !0,
    role: f ? "img" : void 0,
    ref: n,
    ...y,
    ...b,
    ...C && r.props,
    ownerState: g,
    children: [C ? r.props.children : r, f ? /* @__PURE__ */ h.jsx("title", {
      children: f
    }) : null]
  });
}, "SvgIcon"));
process.env.NODE_ENV !== "production" && (aa.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: s.oneOfType([s.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: s.oneOfType([s.oneOf(["inherit", "large", "medium", "small"]), s.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: s.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: s.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Reference/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: s.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: s.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: s.string
});
aa.muiName = "SvgIcon";
function en(e, t) {
  function n(o, r) {
    return /* @__PURE__ */ h.jsx(aa, {
      "data-testid": process.env.NODE_ENV !== "production" ? `${t}Icon` : void 0,
      ref: r,
      ...o,
      children: e
    });
  }
  return a(n, "Component"), process.env.NODE_ENV !== "production" && (n.displayName = `${t}Icon`), n.muiName = aa.muiName, /* @__PURE__ */ k.memo(/* @__PURE__ */ k.forwardRef(n));
}
a(en, "createSvgIcon");
function ss(e, t = 166) {
  let n;
  function o(...r) {
    const i = /* @__PURE__ */ a(() => {
      e.apply(this, r);
    }, "later");
    clearTimeout(n), n = setTimeout(i, t);
  }
  return a(o, "debounced"), o.clear = () => {
    clearTimeout(n);
  }, o;
}
a(ss, "debounce$2");
function Qt(e) {
  return e && e.ownerDocument || document;
}
a(Qt, "ownerDocument");
function dn(e) {
  return Qt(e).defaultView || window;
}
a(dn, "ownerWindow");
function m1(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
a(m1, "setRef");
let d3 = 0;
function n8(e) {
  const [t, n] = k.useState(e), o = e || t;
  return k.useEffect(() => {
    t == null && (d3 += 1, n(`mui-${d3}`));
  }, [t]), o;
}
a(n8, "useGlobalId");
const o8 = {
  ...k
}, u3 = o8.useId;
function _o(e) {
  if (u3 !== void 0) {
    const t = u3();
    return e ?? t;
  }
  return n8(e);
}
a(_o, "useId");
function k5(e, t, n, o, r) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = r || t;
  return typeof e[t] < "u" ? new Error(`The prop \`${i}\` is not supported. Please remove it.`) : null;
}
a(k5, "unsupportedProp");
function Mo(e) {
  const {
    controlled: t,
    default: n,
    name: o,
    state: r = "value"
  } = e, {
    current: i
  } = k.useRef(t !== void 0), [l, c] = k.useState(n), d = i ? t : l;
  if (process.env.NODE_ENV !== "production") {
    k.useEffect(() => {
      i !== (t !== void 0) && console.error([`MUI: A component is changing the ${i ? "" : "un"}controlled ${r} state of ${o} to be ${i ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${o} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [r, o, t]);
    const {
      current: p
    } = k.useRef(n);
    k.useEffect(() => {
      !i && !Object.is(p, n) && console.error([`MUI: A component is changing the default ${r} state of an uncontrolled ${o} after being initialized. To suppress this warning opt to use a controlled ${o}.`].join(`
`));
    }, [JSON.stringify(n)]);
  }
  const u = k.useCallback((p) => {
    i || c(p);
  }, []);
  return [d, u];
}
a(Mo, "useControlled");
function Dt(e) {
  const t = k.useRef(e);
  return Rn(() => {
    t.current = e;
  }), k.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
a(Dt, "useEventCallback");
function xt(...e) {
  const t = k.useRef(void 0), n = k.useCallback((o) => {
    const r = e.map((i) => {
      if (i == null)
        return null;
      if (typeof i == "function") {
        const l = i, c = l(o);
        return typeof c == "function" ? c : () => {
          l(null);
        };
      }
      return i.current = o, () => {
        i.current = null;
      };
    });
    return () => {
      r.forEach((i) => i == null ? void 0 : i());
    };
  }, e);
  return k.useMemo(() => e.every((o) => o == null) ? null : (o) => {
    t.current && (t.current(), t.current = void 0), o != null && (t.current = n(o));
  }, e);
}
a(xt, "useForkRef");
function r8(e, t) {
  const n = e.charCodeAt(2);
  return e[0] === "o" && e[1] === "n" && n >= 65 && n <= 90 && typeof t == "function";
}
a(r8, "isEventHandler");
function bc(e, t) {
  if (!e)
    return t;
  function n(l, c) {
    const d = {};
    return Object.keys(c).forEach((u) => {
      r8(u, c[u]) && typeof l[u] == "function" && (d[u] = (...p) => {
        l[u](...p), c[u](...p);
      });
    }), d;
  }
  if (a(n, "extractHandlers"), typeof e == "function" || typeof t == "function")
    return (l) => {
      const c = typeof t == "function" ? t(l) : t, d = typeof e == "function" ? e({
        ...l,
        ...c
      }) : e, u = le(l == null ? void 0 : l.className, c == null ? void 0 : c.className, d == null ? void 0 : d.className), p = n(d, c);
      return {
        ...c,
        ...d,
        ...p,
        ...!!u && {
          className: u
        },
        ...(c == null ? void 0 : c.style) && (d == null ? void 0 : d.style) && {
          style: {
            ...c.style,
            ...d.style
          }
        },
        ...(c == null ? void 0 : c.sx) && (d == null ? void 0 : d.sx) && {
          sx: [...Array.isArray(c.sx) ? c.sx : [c.sx], ...Array.isArray(d.sx) ? d.sx : [d.sx]]
        }
      };
    };
  const o = t, r = n(e, o), i = le(o == null ? void 0 : o.className, e == null ? void 0 : e.className);
  return {
    ...t,
    ...e,
    ...r,
    ...!!i && {
      className: i
    },
    ...(o == null ? void 0 : o.style) && (e == null ? void 0 : e.style) && {
      style: {
        ...o.style,
        ...e.style
      }
    },
    ...(o == null ? void 0 : o.sx) && (e == null ? void 0 : e.sx) && {
      sx: [...Array.isArray(o.sx) ? o.sx : [o.sx], ...Array.isArray(e.sx) ? e.sx : [e.sx]]
    }
  };
}
a(bc, "mergeSlotProps$1");
function In(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : /* @__PURE__ */ a(function(...o) {
    return e(...o) || t(...o);
  }, "validate");
}
a(In, "chainPropTypes");
function O5(e, t) {
  if (e == null) return {};
  var n = {};
  for (var o in e) if ({}.hasOwnProperty.call(e, o)) {
    if (t.indexOf(o) !== -1) continue;
    n[o] = e[o];
  }
  return n;
}
a(O5, "_objectWithoutPropertiesLoose");
function b1(e, t) {
  return b1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, b1(e, t);
}
a(b1, "_setPrototypeOf");
function E5(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, b1(e, t);
}
a(E5, "_inheritsLoose");
const p3 = {
  disabled: !1
};
var i8 = process.env.NODE_ENV !== "production" ? s.oneOfType([s.number, s.shape({
  enter: s.number,
  exit: s.number,
  appear: s.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" && s.oneOfType([s.string, s.shape({
  enter: s.string,
  exit: s.string,
  active: s.string
}), s.shape({
  enter: s.string,
  enterDone: s.string,
  enterActive: s.string,
  exit: s.string,
  exitDone: s.string,
  exitActive: s.string
})]);
const la = xn.createContext(null);
var s8 = /* @__PURE__ */ a(function(t) {
  return t.scrollTop;
}, "forceReflow"), ui = "unmounted", No = "exited", zo = "entering", br = "entered", C1 = "exiting", On = /* @__PURE__ */ function(e) {
  E5(t, e);
  function t(o, r) {
    var i;
    i = e.call(this, o, r) || this;
    var l = r, c = l && !l.isMounting ? o.enter : o.appear, d;
    return i.appearStatus = null, o.in ? c ? (d = No, i.appearStatus = zo) : d = br : o.unmountOnExit || o.mountOnEnter ? d = ui : d = No, i.state = {
      status: d
    }, i.nextCallback = null, i;
  }
  a(t, "Transition"), t.getDerivedStateFromProps = /* @__PURE__ */ a(function(r, i) {
    var l = r.in;
    return l && i.status === ui ? {
      status: No
    } : null;
  }, "getDerivedStateFromProps");
  var n = t.prototype;
  return n.componentDidMount = /* @__PURE__ */ a(function() {
    this.updateStatus(!0, this.appearStatus);
  }, "componentDidMount"), n.componentDidUpdate = /* @__PURE__ */ a(function(r) {
    var i = null;
    if (r !== this.props) {
      var l = this.state.status;
      this.props.in ? l !== zo && l !== br && (i = zo) : (l === zo || l === br) && (i = C1);
    }
    this.updateStatus(!1, i);
  }, "componentDidUpdate"), n.componentWillUnmount = /* @__PURE__ */ a(function() {
    this.cancelNextCallback();
  }, "componentWillUnmount"), n.getTimeouts = /* @__PURE__ */ a(function() {
    var r = this.props.timeout, i, l, c;
    return i = l = c = r, r != null && typeof r != "number" && (i = r.exit, l = r.enter, c = r.appear !== void 0 ? r.appear : l), {
      exit: i,
      enter: l,
      appear: c
    };
  }, "getTimeouts"), n.updateStatus = /* @__PURE__ */ a(function(r, i) {
    if (r === void 0 && (r = !1), i !== null)
      if (this.cancelNextCallback(), i === zo) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var l = this.props.nodeRef ? this.props.nodeRef.current : ms.findDOMNode(this);
          l && s8(l);
        }
        this.performEnter(r);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === No && this.setState({
      status: ui
    });
  }, "updateStatus"), n.performEnter = /* @__PURE__ */ a(function(r) {
    var i = this, l = this.props.enter, c = this.context ? this.context.isMounting : r, d = this.props.nodeRef ? [c] : [ms.findDOMNode(this), c], u = d[0], p = d[1], f = this.getTimeouts(), m = c ? f.appear : f.enter;
    if (!r && !l || p3.disabled) {
      this.safeSetState({
        status: br
      }, function() {
        i.props.onEntered(u);
      });
      return;
    }
    this.props.onEnter(u, p), this.safeSetState({
      status: zo
    }, function() {
      i.props.onEntering(u, p), i.onTransitionEnd(m, function() {
        i.safeSetState({
          status: br
        }, function() {
          i.props.onEntered(u, p);
        });
      });
    });
  }, "performEnter"), n.performExit = /* @__PURE__ */ a(function() {
    var r = this, i = this.props.exit, l = this.getTimeouts(), c = this.props.nodeRef ? void 0 : ms.findDOMNode(this);
    if (!i || p3.disabled) {
      this.safeSetState({
        status: No
      }, function() {
        r.props.onExited(c);
      });
      return;
    }
    this.props.onExit(c), this.safeSetState({
      status: C1
    }, function() {
      r.props.onExiting(c), r.onTransitionEnd(l.exit, function() {
        r.safeSetState({
          status: No
        }, function() {
          r.props.onExited(c);
        });
      });
    });
  }, "performExit"), n.cancelNextCallback = /* @__PURE__ */ a(function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, "cancelNextCallback"), n.safeSetState = /* @__PURE__ */ a(function(r, i) {
    i = this.setNextCallback(i), this.setState(r, i);
  }, "safeSetState"), n.setNextCallback = /* @__PURE__ */ a(function(r) {
    var i = this, l = !0;
    return this.nextCallback = function(c) {
      l && (l = !1, i.nextCallback = null, r(c));
    }, this.nextCallback.cancel = function() {
      l = !1;
    }, this.nextCallback;
  }, "setNextCallback"), n.onTransitionEnd = /* @__PURE__ */ a(function(r, i) {
    this.setNextCallback(i);
    var l = this.props.nodeRef ? this.props.nodeRef.current : ms.findDOMNode(this), c = r == null && !this.props.addEndListener;
    if (!l || c) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var d = this.props.nodeRef ? [this.nextCallback] : [l, this.nextCallback], u = d[0], p = d[1];
      this.props.addEndListener(u, p);
    }
    r != null && setTimeout(this.nextCallback, r);
  }, "onTransitionEnd"), n.render = /* @__PURE__ */ a(function() {
    var r = this.state.status;
    if (r === ui)
      return null;
    var i = this.props, l = i.children;
    i.in, i.mountOnEnter, i.unmountOnExit, i.appear, i.enter, i.exit, i.timeout, i.addEndListener, i.onEnter, i.onEntering, i.onEntered, i.onExit, i.onExiting, i.onExited, i.nodeRef;
    var c = O5(i, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ xn.createElement(la.Provider, {
        value: null
      }, typeof l == "function" ? l(r, c) : xn.cloneElement(xn.Children.only(l), c))
    );
  }, "render"), t;
}(xn.Component);
On.contextType = la;
On.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: s.shape({
    current: typeof Element > "u" ? s.any : function(e, t, n, o, r, i) {
      var l = e[t];
      return s.instanceOf(l && "ownerDocument" in l ? l.ownerDocument.defaultView.Element : Element)(e, t, n, o, r, i);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: s.oneOfType([s.func.isRequired, s.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: s.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: s.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: s.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: s.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: s.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: s.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: /* @__PURE__ */ a(function(t) {
    var n = i8;
    t.addEndListener || (n = n.isRequired);
    for (var o = arguments.length, r = new Array(o > 1 ? o - 1 : 0), i = 1; i < o; i++)
      r[i - 1] = arguments[i];
    return n.apply(void 0, [t].concat(r));
  }, "timeout"),
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: s.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: s.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: s.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: s.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: s.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: s.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: s.func
} : {};
function hr() {
}
a(hr, "noop$2");
On.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: hr,
  onEntering: hr,
  onEntered: hr,
  onExit: hr,
  onExiting: hr,
  onExited: hr
};
On.UNMOUNTED = ui;
On.EXITED = No;
On.ENTERING = zo;
On.ENTERED = br;
On.EXITING = C1;
function a8(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
a(a8, "_assertThisInitialized");
function Cc(e, t) {
  var n = /* @__PURE__ */ a(function(i) {
    return t && Ys(i) ? t(i) : i;
  }, "mapper"), o = /* @__PURE__ */ Object.create(null);
  return e && Iu.map(e, function(r) {
    return r;
  }).forEach(function(r) {
    o[r.key] = n(r);
  }), o;
}
a(Cc, "getChildMapping");
function l8(e, t) {
  e = e || {}, t = t || {};
  function n(p) {
    return p in t ? t[p] : e[p];
  }
  a(n, "getValueForKey");
  var o = /* @__PURE__ */ Object.create(null), r = [];
  for (var i in e)
    i in t ? r.length && (o[i] = r, r = []) : r.push(i);
  var l, c = {};
  for (var d in t) {
    if (o[d])
      for (l = 0; l < o[d].length; l++) {
        var u = o[d][l];
        c[o[d][l]] = n(u);
      }
    c[d] = n(d);
  }
  for (l = 0; l < r.length; l++)
    c[r[l]] = n(r[l]);
  return c;
}
a(l8, "mergeChildMappings");
function Yo(e, t, n) {
  return n[t] != null ? n[t] : e.props[t];
}
a(Yo, "getProp");
function c8(e, t) {
  return Cc(e.children, function(n) {
    return qs(n, {
      onExited: t.bind(null, n),
      in: !0,
      appear: Yo(n, "appear", e),
      enter: Yo(n, "enter", e),
      exit: Yo(n, "exit", e)
    });
  });
}
a(c8, "getInitialChildMapping");
function d8(e, t, n) {
  var o = Cc(e.children), r = l8(t, o);
  return Object.keys(r).forEach(function(i) {
    var l = r[i];
    if (Ys(l)) {
      var c = i in t, d = i in o, u = t[i], p = Ys(u) && !u.props.in;
      d && (!c || p) ? r[i] = qs(l, {
        onExited: n.bind(null, l),
        in: !0,
        exit: Yo(l, "exit", e),
        enter: Yo(l, "enter", e)
      }) : !d && c && !p ? r[i] = qs(l, {
        in: !1
      }) : d && c && Ys(u) && (r[i] = qs(l, {
        onExited: n.bind(null, l),
        in: u.props.in,
        exit: Yo(l, "exit", e),
        enter: Yo(l, "enter", e)
      }));
    }
  }), r;
}
a(d8, "getNextChildMapping");
var u8 = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, p8 = {
  component: "div",
  childFactory: /* @__PURE__ */ a(function(t) {
    return t;
  }, "childFactory")
}, yc = /* @__PURE__ */ function(e) {
  E5(t, e);
  function t(o, r) {
    var i;
    i = e.call(this, o, r) || this;
    var l = i.handleExited.bind(a8(i));
    return i.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: l,
      firstRender: !0
    }, i;
  }
  a(t, "TransitionGroup");
  var n = t.prototype;
  return n.componentDidMount = /* @__PURE__ */ a(function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, "componentDidMount"), n.componentWillUnmount = /* @__PURE__ */ a(function() {
    this.mounted = !1;
  }, "componentWillUnmount"), t.getDerivedStateFromProps = /* @__PURE__ */ a(function(r, i) {
    var l = i.children, c = i.handleExited, d = i.firstRender;
    return {
      children: d ? c8(r, c) : d8(r, l, c),
      firstRender: !1
    };
  }, "getDerivedStateFromProps"), n.handleExited = /* @__PURE__ */ a(function(r, i) {
    var l = Cc(this.props.children);
    r.key in l || (r.props.onExited && r.props.onExited(i), this.mounted && this.setState(function(c) {
      var d = oa({}, c.children);
      return delete d[r.key], {
        children: d
      };
    }));
  }, "handleExited"), n.render = /* @__PURE__ */ a(function() {
    var r = this.props, i = r.component, l = r.childFactory, c = O5(r, ["component", "childFactory"]), d = this.state.contextValue, u = u8(this.state.children).map(l);
    return delete c.appear, delete c.enter, delete c.exit, i === null ? /* @__PURE__ */ xn.createElement(la.Provider, {
      value: d
    }, u) : /* @__PURE__ */ xn.createElement(la.Provider, {
      value: d
    }, /* @__PURE__ */ xn.createElement(i, c, u));
  }, "render"), t;
}(xn.Component);
yc.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: s.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: s.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: s.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: s.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: s.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: s.func
} : {};
yc.defaultProps = p8;
const f3 = {};
function $5(e, t) {
  const n = k.useRef(f3);
  return n.current === f3 && (n.current = e(t)), n;
}
a($5, "useLazyRef");
const f8 = [];
function h8(e) {
  k.useEffect(e, f8);
}
a(h8, "useOnMount");
const Da = class Da {
  constructor() {
    pe(this, "currentId", null);
    pe(this, "clear", /* @__PURE__ */ a(() => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    }, "clear"));
    pe(this, "disposeEffect", /* @__PURE__ */ a(() => this.clear, "disposeEffect"));
  }
  static create() {
    return new Da();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, n();
    }, t);
  }
};
a(Da, "Timeout");
let ca = Da;
function qo() {
  const e = $5(ca.create).current;
  return h8(e.disposeEffect), e;
}
a(qo, "useTimeout");
function g8(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
a(g8, "isClassComponent$1");
function m8(e, t, n, o, r) {
  const i = e[t], l = r || t;
  if (i == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let c;
  return typeof i == "function" && !g8(i) && (c = "Did you accidentally provide a plain function component instead?"), c !== void 0 ? new Error(`Invalid ${o} \`${l}\` supplied to \`${n}\`. Expected an element type that can hold a ref. ${c} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
a(m8, "elementTypeAcceptingRef");
const rl = In(s.elementType, m8), xc = /* @__PURE__ */ a((e) => e.scrollTop, "reflow");
function Eo(e, t) {
  const {
    timeout: n,
    easing: o,
    style: r = {}
  } = e;
  return {
    duration: r.transitionDuration ?? (typeof n == "number" ? n : n[t.mode] || 0),
    easing: r.transitionTimingFunction ?? (typeof o == "object" ? o[t.mode] : o),
    delay: r.transitionDelay
  };
}
a(Eo, "getTransitionProps");
function b8(e) {
  return Te("MuiCollapse", e);
}
a(b8, "getCollapseUtilityClass");
Se("MuiCollapse", ["root", "horizontal", "vertical", "entered", "hidden", "wrapper", "wrapperInner"]);
const C8 = /* @__PURE__ */ a((e) => {
  const {
    orientation: t,
    classes: n
  } = e, o = {
    root: ["root", `${t}`],
    entered: ["entered"],
    hidden: ["hidden"],
    wrapper: ["wrapper", `${t}`],
    wrapperInner: ["wrapperInner", `${t}`]
  };
  return ke(o, b8, n);
}, "useUtilityClasses$H"), y8 = ee("div", {
  name: "MuiCollapse",
  slot: "Root",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.orientation], n.state === "entered" && t.entered, n.state === "exited" && !n.in && n.collapsedSize === "0px" && t.hidden];
  }, "overridesResolver")
})(we(({
  theme: e
}) => ({
  height: 0,
  overflow: "hidden",
  transition: e.transitions.create("height"),
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      height: "auto",
      width: 0,
      transition: e.transitions.create("width")
    }
  }, {
    props: {
      state: "entered"
    },
    style: {
      height: "auto",
      overflow: "visible"
    }
  }, {
    props: {
      state: "entered",
      orientation: "horizontal"
    },
    style: {
      width: "auto"
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.state === "exited" && !t.in && t.collapsedSize === "0px", "props"),
    style: {
      visibility: "hidden"
    }
  }]
}))), x8 = ee("div", {
  name: "MuiCollapse",
  slot: "Wrapper"
})({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: "flex",
  width: "100%",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "auto",
      height: "100%"
    }
  }]
}), v8 = ee("div", {
  name: "MuiCollapse",
  slot: "WrapperInner"
})({
  width: "100%",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "auto",
      height: "100%"
    }
  }]
}), da = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiCollapse"
  }), {
    addEndListener: r,
    children: i,
    className: l,
    collapsedSize: c = "0px",
    component: d,
    easing: u,
    in: p,
    onEnter: f,
    onEntered: m,
    onEntering: b,
    onExit: C,
    onExited: g,
    onExiting: y,
    orientation: w = "vertical",
    style: T,
    timeout: x = x5.standard,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: S = On,
    ...M
  } = o, O = {
    ...o,
    orientation: w,
    collapsedSize: c
  }, P = C8(O), E = uo(), I = qo(), v = k.useRef(null), _ = k.useRef(), R = typeof c == "number" ? `${c}px` : c, j = w === "horizontal", B = j ? "width" : "height", V = k.useRef(null), L = xt(n, V), D = /* @__PURE__ */ a((N) => (te) => {
    if (N) {
      const oe = V.current;
      te === void 0 ? N(oe) : N(oe, te);
    }
  }, "normalizedTransitionCallback"), z = /* @__PURE__ */ a(() => v.current ? v.current[j ? "clientWidth" : "clientHeight"] : 0, "getWrapperSize"), H = D((N, te) => {
    v.current && j && (v.current.style.position = "absolute"), N.style[B] = R, f && f(N, te);
  }), $ = D((N, te) => {
    const oe = z();
    v.current && j && (v.current.style.position = "");
    const {
      duration: ne,
      easing: X
    } = Eo({
      style: T,
      timeout: x,
      easing: u
    }, {
      mode: "enter"
    });
    if (x === "auto") {
      const se = E.transitions.getAutoHeightDuration(oe);
      N.style.transitionDuration = `${se}ms`, _.current = se;
    } else
      N.style.transitionDuration = typeof ne == "string" ? ne : `${ne}ms`;
    N.style[B] = `${oe}px`, N.style.transitionTimingFunction = X, b && b(N, te);
  }), A = D((N, te) => {
    N.style[B] = "auto", m && m(N, te);
  }), U = D((N) => {
    N.style[B] = `${z()}px`, C && C(N);
  }), K = D(g), J = D((N) => {
    const te = z(), {
      duration: oe,
      easing: ne
    } = Eo({
      style: T,
      timeout: x,
      easing: u
    }, {
      mode: "exit"
    });
    if (x === "auto") {
      const X = E.transitions.getAutoHeightDuration(te);
      N.style.transitionDuration = `${X}ms`, _.current = X;
    } else
      N.style.transitionDuration = typeof oe == "string" ? oe : `${oe}ms`;
    N.style[B] = R, N.style.transitionTimingFunction = ne, y && y(N);
  }), F = /* @__PURE__ */ a((N) => {
    x === "auto" && I.start(_.current || 0, N), r && r(V.current, N);
  }, "handleAddEndListener");
  return /* @__PURE__ */ h.jsx(S, {
    in: p,
    onEnter: H,
    onEntered: A,
    onEntering: $,
    onExit: U,
    onExited: K,
    onExiting: J,
    addEndListener: F,
    nodeRef: V,
    timeout: x === "auto" ? null : x,
    ...M,
    children: /* @__PURE__ */ a((N, {
      ownerState: te,
      ...oe
    }) => /* @__PURE__ */ h.jsx(y8, {
      as: d,
      className: le(P.root, l, {
        entered: P.entered,
        exited: !p && R === "0px" && P.hidden
      }[N]),
      style: {
        [j ? "minWidth" : "minHeight"]: R,
        ...T
      },
      ref: L,
      ownerState: {
        ...O,
        state: N
      },
      ...oe,
      children: /* @__PURE__ */ h.jsx(x8, {
        ownerState: {
          ...O,
          state: N
        },
        className: P.wrapper,
        ref: v,
        children: /* @__PURE__ */ h.jsx(v8, {
          ownerState: {
            ...O,
            state: N
          },
          className: P.wrapperInner,
          children: i
        })
      })
    }), "children")
  });
}, "Collapse"));
process.env.NODE_ENV !== "production" && (da.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: s.func,
  /**
   * The content node to be collapsed.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */
  collapsedSize: s.oneOfType([s.number, s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: rl,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: s.oneOfType([s.shape({
    enter: s.string,
    exit: s.string
  }), s.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: s.bool,
  /**
   * @ignore
   */
  onEnter: s.func,
  /**
   * @ignore
   */
  onEntered: s.func,
  /**
   * @ignore
   */
  onEntering: s.func,
  /**
   * @ignore
   */
  onExit: s.func,
  /**
   * @ignore
   */
  onExited: s.func,
  /**
   * @ignore
   */
  onExiting: s.func,
  /**
   * The transition orientation.
   * @default 'vertical'
   */
  orientation: s.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  style: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */
  timeout: s.oneOfType([s.oneOf(["auto"]), s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })])
});
da && (da.muiSupportAuto = !0);
function w8(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return t;
  }
}
a(w8, "getTypeByValue");
function P5(e, t, n, o) {
  const r = e[t];
  if (r == null || !Number.isInteger(r)) {
    const i = w8(r);
    return new RangeError(`Invalid ${o} \`${t}\` of type \`${i}\` supplied to \`${n}\`, expected \`integer\`.`);
  }
  return null;
}
a(P5, "requiredInteger");
function _5(e, t, n, o) {
  return e[t] === void 0 ? null : P5(e, t, n, o);
}
a(_5, "validator");
function y1() {
  return null;
}
a(y1, "validatorNoop");
_5.isRequired = P5;
y1.isRequired = y1;
const il = process.env.NODE_ENV === "production" ? y1 : _5;
function S8(e) {
  return Te("MuiPaper", e);
}
a(S8, "getPaperUtilityClass");
Se("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const M8 = /* @__PURE__ */ a((e) => {
  const {
    square: t,
    elevation: n,
    variant: o,
    classes: r
  } = e, i = {
    root: ["root", o, !t && "rounded", o === "elevation" && `elevation${n}`]
  };
  return ke(i, S8, r);
}, "useUtilityClasses$G"), T8 = ee("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], !n.square && t.rounded, n.variant === "elevation" && t[`elevation${n.elevation}`]];
  }, "overridesResolver")
})(we(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  color: (e.vars || e).palette.text.primary,
  transition: e.transitions.create("box-shadow"),
  variants: [{
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => !t.square, "props"),
    style: {
      borderRadius: e.shape.borderRadius
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      border: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: {
      variant: "elevation"
    },
    style: {
      boxShadow: "var(--Paper-shadow)",
      backgroundImage: "var(--Paper-overlay)"
    }
  }]
}))), Ro = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  var b;
  const o = $e({
    props: t,
    name: "MuiPaper"
  }), r = uo(), {
    className: i,
    component: l = "div",
    elevation: c = 1,
    square: d = !1,
    variant: u = "elevation",
    ...p
  } = o, f = {
    ...o,
    component: l,
    elevation: c,
    square: d,
    variant: u
  }, m = M8(f);
  return process.env.NODE_ENV !== "production" && r.shadows[c] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${c}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${c}]\` is defined.`].join(`
`)), /* @__PURE__ */ h.jsx(T8, {
    as: l,
    ownerState: f,
    className: le(m.root, i),
    ref: n,
    ...p,
    style: {
      ...u === "elevation" && {
        "--Paper-shadow": (r.vars || r).shadows[c],
        ...r.vars && {
          "--Paper-overlay": (b = r.vars.overlays) == null ? void 0 : b[c]
        },
        ...!r.vars && r.palette.mode === "dark" && {
          "--Paper-overlay": `linear-gradient(${De("#fff", h1(c))}, ${De("#fff", h1(c))})`
        }
      },
      ...p.style
    }
  });
}, "Paper"));
process.env.NODE_ENV !== "production" && (Ro.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: In(il, (e) => {
    const {
      elevation: t,
      variant: n
    } = e;
    return t > 0 && n === "outlined" ? new Error(`MUI: Combining \`elevation={${t}}\` with \`variant="${n}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: s.bool,
  /**
   * @ignore
   */
  style: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: s.oneOfType([s.oneOf(["elevation", "outlined"]), s.string])
});
function k8(e) {
  return typeof e == "string";
}
a(k8, "isHostComponent$1");
function R5(e, t, n) {
  return e === void 0 || k8(e) ? t : {
    ...t,
    ownerState: {
      ...t.ownerState,
      ...n
    }
  };
}
a(R5, "appendOwnerState");
function I5(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
a(I5, "resolveComponentProps");
function j5(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((o) => o.match(/^on[A-Z]/) && typeof e[o] == "function" && !t.includes(o)).forEach((o) => {
    n[o] = e[o];
  }), n;
}
a(j5, "extractEventHandlers");
function h3(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
a(h3, "omitEventHandlers");
function L5(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: o,
    externalForwardedProps: r,
    className: i
  } = e;
  if (!t) {
    const b = le(n == null ? void 0 : n.className, i, r == null ? void 0 : r.className, o == null ? void 0 : o.className), C = {
      ...n == null ? void 0 : n.style,
      ...r == null ? void 0 : r.style,
      ...o == null ? void 0 : o.style
    }, g = {
      ...n,
      ...r,
      ...o
    };
    return b.length > 0 && (g.className = b), Object.keys(C).length > 0 && (g.style = C), {
      props: g,
      internalRef: void 0
    };
  }
  const l = j5({
    ...r,
    ...o
  }), c = h3(o), d = h3(r), u = t(l), p = le(u == null ? void 0 : u.className, n == null ? void 0 : n.className, i, r == null ? void 0 : r.className, o == null ? void 0 : o.className), f = {
    ...u == null ? void 0 : u.style,
    ...n == null ? void 0 : n.style,
    ...r == null ? void 0 : r.style,
    ...o == null ? void 0 : o.style
  }, m = {
    ...u,
    ...n,
    ...d,
    ...c
  };
  return p.length > 0 && (m.className = p), Object.keys(f).length > 0 && (m.style = f), {
    props: m,
    internalRef: u.ref
  };
}
a(L5, "mergeSlotProps");
function ve(e, t) {
  const {
    className: n,
    elementType: o,
    ownerState: r,
    externalForwardedProps: i,
    internalForwardedProps: l,
    shouldForwardComponentProp: c = !1,
    ...d
  } = t, {
    component: u,
    slots: p = {
      [e]: void 0
    },
    slotProps: f = {
      [e]: void 0
    },
    ...m
  } = i, b = p[e] || o, C = I5(f[e], r), {
    props: {
      component: g,
      ...y
    },
    internalRef: w
  } = L5({
    className: n,
    ...d,
    externalForwardedProps: e === "root" ? m : void 0,
    externalSlotProps: C
  }), T = xt(w, C == null ? void 0 : C.ref, t.ref), x = e === "root" ? g || u : g, S = R5(b, {
    ...e === "root" && !u && !p[e] && l,
    ...e !== "root" && !p[e] && l,
    ...y,
    ...x && !c && {
      as: x
    },
    ...x && c && {
      component: x
    },
    ref: T
  }, r);
  return [b, S];
}
a(ve, "useSlot");
const Wt = s.oneOfType([s.func, s.object]);
function ua(e) {
  try {
    return e.matches(":focus-visible");
  } catch {
    process.env.NODE_ENV !== "production" && !/jsdom/.test(window.navigator.userAgent) && console.warn(["MUI: The `:focus-visible` pseudo class is not supported in this browser.", "Some components rely on this feature to work properly."].join(`
`));
  }
  return !1;
}
a(ua, "isFocusVisible");
const $i = class $i {
  constructor() {
    pe(this, "mountEffect", /* @__PURE__ */ a(() => {
      this.shouldMount && !this.didMount && this.ref.current !== null && (this.didMount = !0, this.mounted.resolve());
    }, "mountEffect"));
    this.ref = {
      current: null
    }, this.mounted = null, this.didMount = !1, this.shouldMount = !1, this.setShouldMount = null;
  }
  /** React ref to the ripple instance */
  /** If the ripple component should be mounted */
  /** Promise that resolves when the ripple component is mounted */
  /** If the ripple component has been mounted */
  /** React state hook setter */
  static create() {
    return new $i();
  }
  static use() {
    const t = $5($i.create).current, [n, o] = k.useState(!1);
    return t.shouldMount = n, t.setShouldMount = o, k.useEffect(t.mountEffect, [n]), t;
  }
  mount() {
    return this.mounted || (this.mounted = E8(), this.shouldMount = !0, this.setShouldMount(this.shouldMount)), this.mounted;
  }
  /* Ripple API */
  start(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.start(...t);
    });
  }
  stop(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.stop(...t);
    });
  }
  pulsate(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.pulsate(...t);
    });
  }
};
a($i, "LazyRipple");
let x1 = $i;
function O8() {
  return x1.use();
}
a(O8, "useLazyRipple");
function E8() {
  let e, t;
  const n = new Promise((o, r) => {
    e = o, t = r;
  });
  return n.resolve = e, n.reject = t, n;
}
a(E8, "createControlledPromise");
function V5(e) {
  const {
    className: t,
    classes: n,
    pulsate: o = !1,
    rippleX: r,
    rippleY: i,
    rippleSize: l,
    in: c,
    onExited: d,
    timeout: u
  } = e, [p, f] = k.useState(!1), m = le(t, n.ripple, n.rippleVisible, o && n.ripplePulsate), b = {
    width: l,
    height: l,
    top: -(l / 2) + i,
    left: -(l / 2) + r
  }, C = le(n.child, p && n.childLeaving, o && n.childPulsate);
  return !c && !p && f(!0), k.useEffect(() => {
    if (!c && d != null) {
      const g = setTimeout(d, u);
      return () => {
        clearTimeout(g);
      };
    }
  }, [d, c, u]), /* @__PURE__ */ h.jsx("span", {
    className: m,
    style: b,
    children: /* @__PURE__ */ h.jsx("span", {
      className: C
    })
  });
}
a(V5, "Ripple");
process.env.NODE_ENV !== "production" && (V5.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object.isRequired,
  className: s.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: s.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: s.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: s.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: s.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: s.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: s.number,
  /**
   * exit delay
   */
  timeout: s.number.isRequired
});
const bn = Se("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), v1 = 550, $8 = 80, P8 = ns`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`, _8 = ns`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`, R8 = ns`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`, I8 = ee("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), j8 = ee(V5, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${bn.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${P8};
    animation-duration: ${v1}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  &.${bn.ripplePulsate} {
    animation-duration: ${({
  theme: e
}) => e.transitions.duration.shorter}ms;
  }

  & .${bn.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${bn.childLeaving} {
    opacity: 0;
    animation-name: ${_8};
    animation-duration: ${v1}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  & .${bn.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${R8};
    animation-duration: 2500ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`, A5 = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: r = !1,
    classes: i = {},
    className: l,
    ...c
  } = o, [d, u] = k.useState([]), p = k.useRef(0), f = k.useRef(null);
  k.useEffect(() => {
    f.current && (f.current(), f.current = null);
  }, [d]);
  const m = k.useRef(!1), b = qo(), C = k.useRef(null), g = k.useRef(null), y = k.useCallback((S) => {
    const {
      pulsate: M,
      rippleX: O,
      rippleY: P,
      rippleSize: E,
      cb: I
    } = S;
    u((v) => [...v, /* @__PURE__ */ h.jsx(j8, {
      classes: {
        ripple: le(i.ripple, bn.ripple),
        rippleVisible: le(i.rippleVisible, bn.rippleVisible),
        ripplePulsate: le(i.ripplePulsate, bn.ripplePulsate),
        child: le(i.child, bn.child),
        childLeaving: le(i.childLeaving, bn.childLeaving),
        childPulsate: le(i.childPulsate, bn.childPulsate)
      },
      timeout: v1,
      pulsate: M,
      rippleX: O,
      rippleY: P,
      rippleSize: E
    }, p.current)]), p.current += 1, f.current = I;
  }, [i]), w = k.useCallback((S = {}, M = {}, O = () => {
  }) => {
    const {
      pulsate: P = !1,
      center: E = r || M.pulsate,
      fakeElement: I = !1
      // For test purposes
    } = M;
    if ((S == null ? void 0 : S.type) === "mousedown" && m.current) {
      m.current = !1;
      return;
    }
    (S == null ? void 0 : S.type) === "touchstart" && (m.current = !0);
    const v = I ? null : g.current, _ = v ? v.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let R, j, B;
    if (E || S === void 0 || S.clientX === 0 && S.clientY === 0 || !S.clientX && !S.touches)
      R = Math.round(_.width / 2), j = Math.round(_.height / 2);
    else {
      const {
        clientX: V,
        clientY: L
      } = S.touches && S.touches.length > 0 ? S.touches[0] : S;
      R = Math.round(V - _.left), j = Math.round(L - _.top);
    }
    if (E)
      B = Math.sqrt((2 * _.width ** 2 + _.height ** 2) / 3), B % 2 === 0 && (B += 1);
    else {
      const V = Math.max(Math.abs((v ? v.clientWidth : 0) - R), R) * 2 + 2, L = Math.max(Math.abs((v ? v.clientHeight : 0) - j), j) * 2 + 2;
      B = Math.sqrt(V ** 2 + L ** 2);
    }
    S != null && S.touches ? C.current === null && (C.current = () => {
      y({
        pulsate: P,
        rippleX: R,
        rippleY: j,
        rippleSize: B,
        cb: O
      });
    }, b.start($8, () => {
      C.current && (C.current(), C.current = null);
    })) : y({
      pulsate: P,
      rippleX: R,
      rippleY: j,
      rippleSize: B,
      cb: O
    });
  }, [r, y, b]), T = k.useCallback(() => {
    w({}, {
      pulsate: !0
    });
  }, [w]), x = k.useCallback((S, M) => {
    if (b.clear(), (S == null ? void 0 : S.type) === "touchend" && C.current) {
      C.current(), C.current = null, b.start(0, () => {
        x(S, M);
      });
      return;
    }
    C.current = null, u((O) => O.length > 0 ? O.slice(1) : O), f.current = M;
  }, [b]);
  return k.useImperativeHandle(n, () => ({
    pulsate: T,
    start: w,
    stop: x
  }), [T, w, x]), /* @__PURE__ */ h.jsx(I8, {
    className: le(bn.root, i.root, l),
    ref: g,
    ...c,
    children: /* @__PURE__ */ h.jsx(yc, {
      component: null,
      exit: !0,
      children: d
    })
  });
}, "TouchRipple"));
process.env.NODE_ENV !== "production" && (A5.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string
});
function L8(e) {
  return Te("MuiButtonBase", e);
}
a(L8, "getButtonBaseUtilityClass");
const V8 = Se("MuiButtonBase", ["root", "disabled", "focusVisible"]), A8 = /* @__PURE__ */ a((e) => {
  const {
    disabled: t,
    focusVisible: n,
    focusVisibleClassName: o,
    classes: r
  } = e, l = ke({
    root: ["root", t && "disabled", n && "focusVisible"]
  }, L8, r);
  return n && o && (l.root += ` ${o}`), l;
}, "useUtilityClasses$F"), B8 = ee("button", {
  name: "MuiButtonBase",
  slot: "Root"
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${V8.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), lo = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: r,
    centerRipple: i = !1,
    children: l,
    className: c,
    component: d = "button",
    disabled: u = !1,
    disableRipple: p = !1,
    disableTouchRipple: f = !1,
    focusRipple: m = !1,
    focusVisibleClassName: b,
    LinkComponent: C = "a",
    onBlur: g,
    onClick: y,
    onContextMenu: w,
    onDragLeave: T,
    onFocus: x,
    onFocusVisible: S,
    onKeyDown: M,
    onKeyUp: O,
    onMouseDown: P,
    onMouseLeave: E,
    onMouseUp: I,
    onTouchEnd: v,
    onTouchMove: _,
    onTouchStart: R,
    tabIndex: j = 0,
    TouchRippleProps: B,
    touchRippleRef: V,
    type: L,
    ...D
  } = o, z = k.useRef(null), H = O8(), $ = xt(H.ref, V), [A, U] = k.useState(!1);
  u && A && U(!1), k.useImperativeHandle(r, () => ({
    focusVisible: /* @__PURE__ */ a(() => {
      U(!0), z.current.focus();
    }, "focusVisible")
  }), []);
  const K = H.shouldMount && !p && !u;
  k.useEffect(() => {
    A && m && !p && H.pulsate();
  }, [p, m, A, H]);
  const J = eo(H, "start", P, f), F = eo(H, "stop", w, f), N = eo(H, "stop", T, f), te = eo(H, "stop", I, f), oe = eo(H, "stop", (de) => {
    A && de.preventDefault(), E && E(de);
  }, f), ne = eo(H, "start", R, f), X = eo(H, "stop", v, f), se = eo(H, "stop", _, f), Y = eo(H, "stop", (de) => {
    ua(de.target) || U(!1), g && g(de);
  }, !1), fe = Dt((de) => {
    z.current || (z.current = de.currentTarget), ua(de.target) && (U(!0), S && S(de)), x && x(de);
  }), be = /* @__PURE__ */ a(() => {
    const de = z.current;
    return d && d !== "button" && !(de.tagName === "A" && de.href);
  }, "isNonNativeButton"), Re = Dt((de) => {
    m && !de.repeat && A && de.key === " " && H.stop(de, () => {
      H.start(de);
    }), de.target === de.currentTarget && be() && de.key === " " && de.preventDefault(), M && M(de), de.target === de.currentTarget && be() && de.key === "Enter" && !u && (de.preventDefault(), y && y(de));
  }), Oe = Dt((de) => {
    m && de.key === " " && A && !de.defaultPrevented && H.stop(de, () => {
      H.pulsate(de);
    }), O && O(de), y && de.target === de.currentTarget && be() && de.key === " " && !de.defaultPrevented && y(de);
  });
  let Be = d;
  Be === "button" && (D.href || D.to) && (Be = C);
  const re = {};
  Be === "button" ? (re.type = L === void 0 ? "button" : L, re.disabled = u) : (!D.href && !D.to && (re.role = "button"), u && (re["aria-disabled"] = u));
  const Fe = xt(n, z), Ce = {
    ...o,
    centerRipple: i,
    component: d,
    disabled: u,
    disableRipple: p,
    disableTouchRipple: f,
    focusRipple: m,
    tabIndex: j,
    focusVisible: A
  }, Pe = A8(Ce);
  return /* @__PURE__ */ h.jsxs(B8, {
    as: Be,
    className: le(Pe.root, c),
    ownerState: Ce,
    onBlur: Y,
    onClick: y,
    onContextMenu: F,
    onFocus: fe,
    onKeyDown: Re,
    onKeyUp: Oe,
    onMouseDown: J,
    onMouseLeave: oe,
    onMouseUp: te,
    onDragLeave: N,
    onTouchEnd: X,
    onTouchMove: se,
    onTouchStart: ne,
    ref: Fe,
    tabIndex: u ? -1 : j,
    type: L,
    ...re,
    ...D,
    children: [l, K ? /* @__PURE__ */ h.jsx(A5, {
      ref: $,
      center: i,
      ...B
    }) : null]
  });
}, "ButtonBase"));
function eo(e, t, n, o = !1) {
  return Dt((r) => (n && n(r), o || e[t](r), !0));
}
a(eo, "useRippleHandler");
process.env.NODE_ENV !== "production" && (lo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: Wt,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: s.bool,
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: rl,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: s.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: s.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: s.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: s.string,
  /**
   * @ignore
   */
  href: s.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: s.elementType,
  /**
   * @ignore
   */
  onBlur: s.func,
  /**
   * @ignore
   */
  onClick: s.func,
  /**
   * @ignore
   */
  onContextMenu: s.func,
  /**
   * @ignore
   */
  onDragLeave: s.func,
  /**
   * @ignore
   */
  onFocus: s.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: s.func,
  /**
   * @ignore
   */
  onKeyDown: s.func,
  /**
   * @ignore
   */
  onKeyUp: s.func,
  /**
   * @ignore
   */
  onMouseDown: s.func,
  /**
   * @ignore
   */
  onMouseLeave: s.func,
  /**
   * @ignore
   */
  onMouseUp: s.func,
  /**
   * @ignore
   */
  onTouchEnd: s.func,
  /**
   * @ignore
   */
  onTouchMove: s.func,
  /**
   * @ignore
   */
  onTouchStart: s.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * @default 0
   */
  tabIndex: s.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: s.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: s.oneOfType([s.func, s.shape({
    current: s.shape({
      pulsate: s.func.isRequired,
      start: s.func.isRequired,
      stop: s.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: s.oneOfType([s.oneOf(["button", "reset", "submit"]), s.string])
});
function H8(e) {
  return typeof e.main == "string";
}
a(H8, "hasCorrectMainProperty");
function D8(e, t = []) {
  if (!H8(e))
    return !1;
  for (const n of t)
    if (!e.hasOwnProperty(n) || typeof e[n] != "string")
      return !1;
  return !0;
}
a(D8, "checkSimplePaletteColorValues");
function bt(e = []) {
  return ([, t]) => t && D8(t, e);
}
a(bt, "createSimplePaletteValueFilter");
function N8(e) {
  return Te("MuiAlert", e);
}
a(N8, "getAlertUtilityClass");
const g3 = Se("MuiAlert", ["root", "action", "icon", "message", "filled", "colorSuccess", "colorInfo", "colorWarning", "colorError", "filledSuccess", "filledInfo", "filledWarning", "filledError", "outlined", "outlinedSuccess", "outlinedInfo", "outlinedWarning", "outlinedError", "standard", "standardSuccess", "standardInfo", "standardWarning", "standardError"]);
function z8(e) {
  return Te("MuiCircularProgress", e);
}
a(z8, "getCircularProgressUtilityClass");
Se("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]);
const Co = 44, w1 = ns`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`, S1 = ns`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`, F8 = typeof w1 != "string" ? ac`
        animation: ${w1} 1.4s linear infinite;
      ` : null, W8 = typeof S1 != "string" ? ac`
        animation: ${S1} 1.4s ease-in-out infinite;
      ` : null, Z8 = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    variant: n,
    color: o,
    disableShrink: r
  } = e, i = {
    root: ["root", n, `color${G(o)}`],
    svg: ["svg"],
    circle: ["circle", `circle${G(n)}`, r && "circleDisableShrink"]
  };
  return ke(i, z8, t);
}, "useUtilityClasses$E"), U8 = ee("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`color${G(n.color)}`]];
  }, "overridesResolver")
})(we(({
  theme: e
}) => ({
  display: "inline-block",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("transform")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: F8 || {
      animation: `${w1} 1.4s linear infinite`
    }
  }, ...Object.entries(e.palette).filter(bt()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  }))]
}))), G8 = ee("svg", {
  name: "MuiCircularProgress",
  slot: "Svg"
})({
  display: "block"
  // Keeps the progress centered
}), Y8 = ee("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.circle, t[`circle${G(n.variant)}`], n.disableShrink && t.circleDisableShrink];
  }, "overridesResolver")
})(we(({
  theme: e
}) => ({
  stroke: "currentColor",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("stroke-dashoffset")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: {
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: "80px, 200px",
      strokeDashoffset: 0
      // Add the unit to fix a Edge 16 and below bug.
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.variant === "indeterminate" && !t.disableShrink, "props"),
    style: W8 || {
      // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
      animation: `${S1} 1.4s ease-in-out infinite`
    }
  }]
}))), vc = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiCircularProgress"
  }), {
    className: r,
    color: i = "primary",
    disableShrink: l = !1,
    size: c = 40,
    style: d,
    thickness: u = 3.6,
    value: p = 0,
    variant: f = "indeterminate",
    ...m
  } = o, b = {
    ...o,
    color: i,
    disableShrink: l,
    size: c,
    thickness: u,
    value: p,
    variant: f
  }, C = Z8(b), g = {}, y = {}, w = {};
  if (f === "determinate") {
    const T = 2 * Math.PI * ((Co - u) / 2);
    g.strokeDasharray = T.toFixed(3), w["aria-valuenow"] = Math.round(p), g.strokeDashoffset = `${((100 - p) / 100 * T).toFixed(3)}px`, y.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ h.jsx(U8, {
    className: le(C.root, r),
    style: {
      width: c,
      height: c,
      ...y,
      ...d
    },
    ownerState: b,
    ref: n,
    role: "progressbar",
    ...w,
    ...m,
    children: /* @__PURE__ */ h.jsx(G8, {
      className: C.svg,
      ownerState: b,
      viewBox: `${Co / 2} ${Co / 2} ${Co} ${Co}`,
      children: /* @__PURE__ */ h.jsx(Y8, {
        className: C.circle,
        style: g,
        ownerState: b,
        cx: Co,
        cy: Co,
        r: (Co - u) / 2,
        fill: "none",
        strokeWidth: u
      })
    })
  });
}, "CircularProgress"));
process.env.NODE_ENV !== "production" && (vc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: s.oneOfType([s.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: In(s.bool, (e) => e.disableShrink && e.variant && e.variant !== "indeterminate" ? new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null),
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */
  size: s.oneOfType([s.number, s.string]),
  /**
   * @ignore
   */
  style: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: s.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: s.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: s.oneOf(["determinate", "indeterminate"])
});
function q8(e) {
  return Te("MuiIconButton", e);
}
a(q8, "getIconButtonUtilityClass");
const m3 = Se("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge", "loading", "loadingIndicator", "loadingWrapper"]), K8 = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    disabled: n,
    color: o,
    edge: r,
    size: i,
    loading: l
  } = e, c = {
    root: ["root", l && "loading", n && "disabled", o !== "default" && `color${G(o)}`, r && `edge${G(r)}`, `size${G(i)}`],
    loadingIndicator: ["loadingIndicator"],
    loadingWrapper: ["loadingWrapper"]
  };
  return ke(c, q8, t);
}, "useUtilityClasses$D"), X8 = ee(lo, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.loading && t.loading, n.color !== "default" && t[`color${G(n.color)}`], n.edge && t[`edge${G(n.edge)}`], t[`size${G(n.size)}`]];
  }, "overridesResolver")
})(we(({
  theme: e
}) => ({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: /* @__PURE__ */ a((t) => !t.disableRipple, "props"),
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : De(e.palette.action.active, e.palette.action.hoverOpacity),
      "&:hover": {
        backgroundColor: "var(--IconButton-hoverBg)",
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }]
})), we(({
  theme: e
}) => ({
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, ...Object.entries(e.palette).filter(bt()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  })), ...Object.entries(e.palette).filter(bt()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${(e.vars || e).palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : De((e.vars || e).palette[t].main, e.palette.action.hoverOpacity)
    }
  })), {
    props: {
      size: "small"
    },
    style: {
      padding: 5,
      fontSize: e.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      padding: 12,
      fontSize: e.typography.pxToRem(28)
    }
  }],
  [`&.${m3.disabled}`]: {
    backgroundColor: "transparent",
    color: (e.vars || e).palette.action.disabled
  },
  [`&.${m3.loading}`]: {
    color: "transparent"
  }
}))), J8 = ee("span", {
  name: "MuiIconButton",
  slot: "LoadingIndicator"
})(({
  theme: e
}) => ({
  display: "none",
  position: "absolute",
  visibility: "visible",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  color: (e.vars || e).palette.action.disabled,
  variants: [{
    props: {
      loading: !0
    },
    style: {
      display: "flex"
    }
  }]
})), po = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiIconButton"
  }), {
    edge: r = !1,
    children: i,
    className: l,
    color: c = "default",
    disabled: d = !1,
    disableFocusRipple: u = !1,
    size: p = "medium",
    id: f,
    loading: m = null,
    loadingIndicator: b,
    ...C
  } = o, g = _o(f), y = b ?? /* @__PURE__ */ h.jsx(vc, {
    "aria-labelledby": g,
    color: "inherit",
    size: 16
  }), w = {
    ...o,
    edge: r,
    color: c,
    disabled: d,
    disableFocusRipple: u,
    loading: m,
    loadingIndicator: y,
    size: p
  }, T = K8(w);
  return /* @__PURE__ */ h.jsxs(X8, {
    id: m ? g : f,
    className: le(T.root, l),
    centerRipple: !0,
    focusRipple: !u,
    disabled: d || m,
    ref: n,
    ...C,
    ownerState: w,
    children: [typeof m == "boolean" && // use plain HTML span to minimize the runtime overhead
    /* @__PURE__ */ h.jsx("span", {
      className: T.loadingWrapper,
      style: {
        display: "contents"
      },
      children: /* @__PURE__ */ h.jsx(J8, {
        className: T.loadingIndicator,
        ownerState: w,
        children: m && y
      })
    }), i]
  });
}, "IconButton"));
process.env.NODE_ENV !== "production" && (po.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: In(s.node, (e) => k.Children.toArray(e.children).some((n) => /* @__PURE__ */ k.isValidElement(n) && n.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: s.oneOfType([s.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: s.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: s.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: s.oneOf(["end", "start", !1]),
  /**
   * @ignore
   */
  id: s.string,
  /**
   * If `true`, the loading indicator is visible and the button is disabled.
   * If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
   * @default null
   */
  loading: s.bool,
  /**
   * Element placed before the children if the button is in loading state.
   * The node should contain an element with `role="progressbar"` with an accessible name.
   * By default, it renders a `CircularProgress` that is labeled by the button itself.
   * @default <CircularProgress color="inherit" size={16} />
   */
  loadingIndicator: s.node,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["small", "medium", "large"]), s.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
const Q8 = en(/* @__PURE__ */ h.jsx("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined"), ef = en(/* @__PURE__ */ h.jsx("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined"), tf = en(/* @__PURE__ */ h.jsx("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline"), nf = en(/* @__PURE__ */ h.jsx("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined"), B5 = en(/* @__PURE__ */ h.jsx("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), of = /* @__PURE__ */ a((e) => {
  const {
    variant: t,
    color: n,
    severity: o,
    classes: r
  } = e, i = {
    root: ["root", `color${G(n || o)}`, `${t}${G(n || o)}`, `${t}`],
    icon: ["icon"],
    message: ["message"],
    action: ["action"]
  };
  return ke(i, N8, r);
}, "useUtilityClasses$C"), rf = ee(Ro, {
  name: "MuiAlert",
  slot: "Root",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`${n.variant}${G(n.color || n.severity)}`]];
  }, "overridesResolver")
})(we(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? Ni : zi, n = e.palette.mode === "light" ? zi : Ni;
  return {
    ...e.typography.body2,
    backgroundColor: "transparent",
    display: "flex",
    padding: "6px 16px",
    variants: [...Object.entries(e.palette).filter(bt(["light"])).map(([o]) => ({
      props: {
        colorSeverity: o,
        variant: "standard"
      },
      style: {
        color: e.vars ? e.vars.palette.Alert[`${o}Color`] : t(e.palette[o].light, 0.6),
        backgroundColor: e.vars ? e.vars.palette.Alert[`${o}StandardBg`] : n(e.palette[o].light, 0.9),
        [`& .${g3.icon}`]: e.vars ? {
          color: e.vars.palette.Alert[`${o}IconColor`]
        } : {
          color: e.palette[o].main
        }
      }
    })), ...Object.entries(e.palette).filter(bt(["light"])).map(([o]) => ({
      props: {
        colorSeverity: o,
        variant: "outlined"
      },
      style: {
        color: e.vars ? e.vars.palette.Alert[`${o}Color`] : t(e.palette[o].light, 0.6),
        border: `1px solid ${(e.vars || e).palette[o].light}`,
        [`& .${g3.icon}`]: e.vars ? {
          color: e.vars.palette.Alert[`${o}IconColor`]
        } : {
          color: e.palette[o].main
        }
      }
    })), ...Object.entries(e.palette).filter(bt(["dark"])).map(([o]) => ({
      props: {
        colorSeverity: o,
        variant: "filled"
      },
      style: {
        fontWeight: e.typography.fontWeightMedium,
        ...e.vars ? {
          color: e.vars.palette.Alert[`${o}FilledColor`],
          backgroundColor: e.vars.palette.Alert[`${o}FilledBg`]
        } : {
          backgroundColor: e.palette.mode === "dark" ? e.palette[o].dark : e.palette[o].main,
          color: e.palette.getContrastText(e.palette[o].main)
        }
      }
    }))]
  };
})), sf = ee("div", {
  name: "MuiAlert",
  slot: "Icon"
})({
  marginRight: 12,
  padding: "7px 0",
  display: "flex",
  fontSize: 22,
  opacity: 0.9
}), af = ee("div", {
  name: "MuiAlert",
  slot: "Message"
})({
  padding: "8px 0",
  minWidth: 0,
  overflow: "auto"
}), lf = ee("div", {
  name: "MuiAlert",
  slot: "Action"
})({
  display: "flex",
  alignItems: "flex-start",
  padding: "4px 0 0 16px",
  marginLeft: "auto",
  marginRight: -8
}), b3 = {
  success: /* @__PURE__ */ h.jsx(Q8, {
    fontSize: "inherit"
  }),
  warning: /* @__PURE__ */ h.jsx(ef, {
    fontSize: "inherit"
  }),
  error: /* @__PURE__ */ h.jsx(tf, {
    fontSize: "inherit"
  }),
  info: /* @__PURE__ */ h.jsx(nf, {
    fontSize: "inherit"
  })
}, H5 = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiAlert"
  }), {
    action: r,
    children: i,
    className: l,
    closeText: c = "Close",
    color: d,
    components: u = {},
    componentsProps: p = {},
    icon: f,
    iconMapping: m = b3,
    onClose: b,
    role: C = "alert",
    severity: g = "success",
    slotProps: y = {},
    slots: w = {},
    variant: T = "standard",
    ...x
  } = o, S = {
    ...o,
    color: d,
    severity: g,
    variant: T,
    colorSeverity: d || g
  }, M = of(S), O = {
    slots: {
      closeButton: u.CloseButton,
      closeIcon: u.CloseIcon,
      ...w
    },
    slotProps: {
      ...p,
      ...y
    }
  }, [P, E] = ve("root", {
    ref: n,
    shouldForwardComponentProp: !0,
    className: le(M.root, l),
    elementType: rf,
    externalForwardedProps: {
      ...O,
      ...x
    },
    ownerState: S,
    additionalProps: {
      role: C,
      elevation: 0
    }
  }), [I, v] = ve("icon", {
    className: M.icon,
    elementType: sf,
    externalForwardedProps: O,
    ownerState: S
  }), [_, R] = ve("message", {
    className: M.message,
    elementType: af,
    externalForwardedProps: O,
    ownerState: S
  }), [j, B] = ve("action", {
    className: M.action,
    elementType: lf,
    externalForwardedProps: O,
    ownerState: S
  }), [V, L] = ve("closeButton", {
    elementType: po,
    externalForwardedProps: O,
    ownerState: S
  }), [D, z] = ve("closeIcon", {
    elementType: B5,
    externalForwardedProps: O,
    ownerState: S
  });
  return /* @__PURE__ */ h.jsxs(P, {
    ...E,
    children: [f !== !1 ? /* @__PURE__ */ h.jsx(I, {
      ...v,
      children: f || m[g] || b3[g]
    }) : null, /* @__PURE__ */ h.jsx(_, {
      ...R,
      children: i
    }), r != null ? /* @__PURE__ */ h.jsx(j, {
      ...B,
      children: r
    }) : null, r == null && b ? /* @__PURE__ */ h.jsx(j, {
      ...B,
      children: /* @__PURE__ */ h.jsx(V, {
        size: "small",
        "aria-label": c,
        title: c,
        color: "inherit",
        onClick: b,
        ...L,
        children: /* @__PURE__ */ h.jsx(D, {
          fontSize: "small",
          ...z
        })
      })
    }) : null]
  });
}, "Alert"));
process.env.NODE_ENV !== "production" && (H5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display. It renders after the message, at the end of the alert.
   */
  action: s.node,
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * Override the default label for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: s.string,
  /**
   * The color of the component. Unless provided, the value is taken from the `severity` prop.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: s.oneOfType([s.oneOf(["error", "info", "success", "warning"]), s.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: s.shape({
    CloseButton: s.elementType,
    CloseIcon: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: s.shape({
    closeButton: s.object,
    closeIcon: s.object
  }),
  /**
   * Override the icon displayed before the children.
   * Unless provided, the icon is mapped to the value of the `severity` prop.
   * Set to `false` to remove the `icon`.
   */
  icon: s.node,
  /**
   * The component maps the `severity` prop to a range of different icons,
   * for instance success to `<SuccessOutlined>`.
   * If you wish to change this mapping, you can provide your own.
   * Alternatively, you can use the `icon` prop to override the icon displayed.
   */
  iconMapping: s.shape({
    error: s.node,
    info: s.node,
    success: s.node,
    warning: s.node
  }),
  /**
   * Callback fired when the component requests to be closed.
   * When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: s.func,
  /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */
  role: s.string,
  /**
   * The severity of the alert. This defines the color and icon used.
   * @default 'success'
   */
  severity: s.oneOfType([s.oneOf(["error", "info", "success", "warning"]), s.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    action: s.oneOfType([s.func, s.object]),
    closeButton: s.oneOfType([s.func, s.object]),
    closeIcon: s.oneOfType([s.func, s.object]),
    icon: s.oneOfType([s.func, s.object]),
    message: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    action: s.elementType,
    closeButton: s.elementType,
    closeIcon: s.elementType,
    icon: s.elementType,
    message: s.elementType,
    root: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: s.oneOfType([s.oneOf(["filled", "outlined", "standard"]), s.string])
});
function cf(e) {
  return Te("MuiTypography", e);
}
a(cf, "getTypographyUtilityClass");
Se("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
const df = {
  primary: !0,
  secondary: !0,
  error: !0,
  info: !0,
  success: !0,
  warning: !0,
  textPrimary: !0,
  textSecondary: !0,
  textDisabled: !0
}, uf = Jp(), pf = /* @__PURE__ */ a((e) => {
  const {
    align: t,
    gutterBottom: n,
    noWrap: o,
    paragraph: r,
    variant: i,
    classes: l
  } = e, c = {
    root: ["root", i, e.align !== "inherit" && `align${G(t)}`, n && "gutterBottom", o && "noWrap", r && "paragraph"]
  };
  return ke(c, cf, l);
}, "useUtilityClasses$B"), ff = ee("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.variant && t[n.variant], n.align !== "inherit" && t[`align${G(n.align)}`], n.noWrap && t.noWrap, n.gutterBottom && t.gutterBottom, n.paragraph && t.paragraph];
  }, "overridesResolver")
})(we(({
  theme: e
}) => {
  var t;
  return {
    margin: 0,
    variants: [{
      props: {
        variant: "inherit"
      },
      style: {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit",
        lineHeight: "inherit",
        letterSpacing: "inherit"
      }
    }, ...Object.entries(e.typography).filter(([n, o]) => n !== "inherit" && o && typeof o == "object").map(([n, o]) => ({
      props: {
        variant: n
      },
      style: o
    })), ...Object.entries(e.palette).filter(bt()).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        color: (e.vars || e).palette[n].main
      }
    })), ...Object.entries(((t = e.palette) == null ? void 0 : t.text) || {}).filter(([, n]) => typeof n == "string").map(([n]) => ({
      props: {
        color: `text${G(n)}`
      },
      style: {
        color: (e.vars || e).palette.text[n]
      }
    })), {
      props: /* @__PURE__ */ a(({
        ownerState: n
      }) => n.align !== "inherit", "props"),
      style: {
        textAlign: "var(--Typography-textAlign)"
      }
    }, {
      props: /* @__PURE__ */ a(({
        ownerState: n
      }) => n.noWrap, "props"),
      style: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    }, {
      props: /* @__PURE__ */ a(({
        ownerState: n
      }) => n.gutterBottom, "props"),
      style: {
        marginBottom: "0.35em"
      }
    }, {
      props: /* @__PURE__ */ a(({
        ownerState: n
      }) => n.paragraph, "props"),
      style: {
        marginBottom: 16
      }
    }]
  };
})), C3 = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, pa = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const {
    color: o,
    ...r
  } = $e({
    props: t,
    name: "MuiTypography"
  }), i = !df[o], l = uf({
    ...r,
    ...i && {
      color: o
    }
  }), {
    align: c = "inherit",
    className: d,
    component: u,
    gutterBottom: p = !1,
    noWrap: f = !1,
    paragraph: m = !1,
    variant: b = "body1",
    variantMapping: C = C3,
    ...g
  } = l, y = {
    ...l,
    align: c,
    color: o,
    className: d,
    component: u,
    gutterBottom: p,
    noWrap: f,
    paragraph: m,
    variant: b,
    variantMapping: C
  }, w = u || (m ? "p" : C[b] || C3[b]) || "span", T = pf(y);
  return /* @__PURE__ */ h.jsx(ff, {
    as: w,
    ref: n,
    className: le(T.root, d),
    ...g,
    ownerState: y,
    style: {
      ...c !== "inherit" && {
        "--Typography-textAlign": c
      },
      ...g.style
    }
  });
}, "Typography"));
process.env.NODE_ENV !== "production" && (pa.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: s.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary", "success", "error", "info", "warning", "textPrimary", "textSecondary", "textDisabled"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: s.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: s.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   * @deprecated Use the `component` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  paragraph: s.bool,
  /**
   * @ignore
   */
  style: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: s.oneOfType([s.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), s.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: s.object
});
const hf = /* @__PURE__ */ a((e) => {
  const t = k.useRef({});
  return k.useEffect(() => {
    t.current = e;
  }), t.current;
}, "usePreviousProps");
function y3(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
a(y3, "stripDiacritics");
function gf(e = {}) {
  const {
    ignoreAccents: t = !0,
    ignoreCase: n = !0,
    limit: o,
    matchFrom: r = "any",
    stringify: i,
    trim: l = !1
  } = e;
  return (c, {
    inputValue: d,
    getOptionLabel: u
  }) => {
    let p = l ? d.trim() : d;
    n && (p = p.toLowerCase()), t && (p = y3(p));
    const f = p ? c.filter((m) => {
      let b = (i || u)(m);
      return n && (b = b.toLowerCase()), t && (b = y3(b)), r === "start" ? b.startsWith(p) : b.includes(p);
    }) : c;
    return typeof o == "number" ? f.slice(0, o) : f;
  };
}
a(gf, "createFilterOptions");
const mf = gf(), x3 = 5, bf = /* @__PURE__ */ a((e) => {
  var t;
  return e.current !== null && ((t = e.current.parentElement) == null ? void 0 : t.contains(document.activeElement));
}, "defaultIsActiveElementInListbox"), Cf = [];
function v3(e, t, n, o) {
  if (t || e == null || o)
    return "";
  const r = n(e);
  return typeof r == "string" ? r : "";
}
a(v3, "getInputValue");
function yf(e) {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox: t = bf,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix: n = "Mui",
    autoComplete: o = !1,
    autoHighlight: r = !1,
    autoSelect: i = !1,
    blurOnSelect: l = !1,
    clearOnBlur: c = !e.freeSolo,
    clearOnEscape: d = !1,
    componentName: u = "useAutocomplete",
    defaultValue: p = e.multiple ? Cf : null,
    disableClearable: f = !1,
    disableCloseOnSelect: m = !1,
    disabled: b,
    disabledItemsFocusable: C = !1,
    disableListWrap: g = !1,
    filterOptions: y = mf,
    filterSelectedOptions: w = !1,
    freeSolo: T = !1,
    getOptionDisabled: x,
    getOptionKey: S,
    getOptionLabel: M = /* @__PURE__ */ a((q) => q.label ?? q, "getOptionLabelProp"),
    groupBy: O,
    handleHomeEndKeys: P = !e.freeSolo,
    id: E,
    includeInputInList: I = !1,
    inputValue: v,
    isOptionEqualToValue: _ = /* @__PURE__ */ a((q, W) => q === W, "isOptionEqualToValue"),
    multiple: R = !1,
    onChange: j,
    onClose: B,
    onHighlightChange: V,
    onInputChange: L,
    onOpen: D,
    open: z,
    openOnFocus: H = !1,
    options: $,
    readOnly: A = !1,
    renderValue: U,
    selectOnFocus: K = !e.freeSolo,
    value: J
  } = e, F = _o(E);
  let N = M;
  N = /* @__PURE__ */ a((q) => {
    const W = M(q);
    if (typeof W != "string") {
      if (process.env.NODE_ENV !== "production") {
        const ie = W === void 0 ? "undefined" : `${typeof W} (${W})`;
        console.error(`MUI: The \`getOptionLabel\` method of ${u} returned ${ie} instead of a string for ${JSON.stringify(q)}.`);
      }
      return String(W);
    }
    return W;
  }, "getOptionLabel");
  const te = k.useRef(!1), oe = k.useRef(!0), ne = k.useRef(null), X = k.useRef(null), [se, Y] = k.useState(null), [fe, be] = k.useState(-1), Re = r ? 0 : -1, Oe = k.useRef(Re), Be = k.useRef(v3(p ?? J, R, N)).current, [re, Fe] = Mo({
    controlled: J,
    default: p,
    name: u
  }), [Ce, Pe] = Mo({
    controlled: v,
    default: Be,
    name: u,
    state: "inputValue"
  }), [de, pt] = k.useState(!1), ze = k.useCallback((q, W, ie) => {
    if (!(R ? re.length < W.length : W !== null) && !c)
      return;
    const ye = v3(W, R, N, U);
    Ce !== ye && (Pe(ye), L && L(q, ye, ie));
  }, [N, Ce, R, L, Pe, c, re, U]), [ut, Mt] = Mo({
    controlled: z,
    default: !1,
    name: u,
    state: "open"
  }), [At, ft] = k.useState(!0), Tt = !R && re != null && Ce === N(re), lt = ut && !A, ce = lt ? y(
    $.filter((q) => !(w && (R ? re : [re]).some((W) => W !== null && _(q, W)))),
    // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
      inputValue: Tt && At ? "" : Ce,
      getOptionLabel: N
    }
  ) : [], nt = hf({
    filteredOptions: ce,
    value: re,
    inputValue: Ce
  });
  k.useEffect(() => {
    const q = re !== nt.value;
    de && !q || T && !q || ze(null, re, "reset");
  }, [re, ze, de, nt.value, T]);
  const vt = ut && ce.length > 0 && !A, Ke = Dt((q) => {
    if (q === -1)
      ne.current.focus();
    else {
      const W = U ? "data-item-index" : "data-tag-index";
      se.querySelector(`[${W}="${q}"]`).focus();
    }
  });
  k.useEffect(() => {
    R && fe > re.length - 1 && (be(-1), Ke(-1));
  }, [re, R, fe, Ke]);
  function tn(q, W) {
    if (!X.current || q < 0 || q >= ce.length)
      return -1;
    let ie = q;
    for (; ; ) {
      const Le = X.current.querySelector(`[data-option-index="${ie}"]`), ye = C ? !1 : !Le || Le.disabled || Le.getAttribute("aria-disabled") === "true";
      if (Le && Le.hasAttribute("tabindex") && !ye)
        return ie;
      if (W === "next" ? ie = (ie + 1) % ce.length : ie = (ie - 1 + ce.length) % ce.length, ie === q)
        return -1;
    }
  }
  a(tn, "validOptionIndex");
  const ue = Dt(({
    event: q,
    index: W,
    reason: ie
  }) => {
    if (Oe.current = W, W === -1 ? ne.current.removeAttribute("aria-activedescendant") : ne.current.setAttribute("aria-activedescendant", `${F}-option-${W}`), V && ["mouse", "keyboard", "touch"].includes(ie) && V(q, W === -1 ? null : ce[W], ie), !X.current)
      return;
    const Le = X.current.querySelector(`[role="option"].${n}-focused`);
    Le && (Le.classList.remove(`${n}-focused`), Le.classList.remove(`${n}-focusVisible`));
    let ye = X.current;
    if (X.current.getAttribute("role") !== "listbox" && (ye = X.current.parentElement.querySelector('[role="listbox"]')), !ye)
      return;
    if (W === -1) {
      ye.scrollTop = 0;
      return;
    }
    const ot = X.current.querySelector(`[data-option-index="${W}"]`);
    if (ot && (ot.classList.add(`${n}-focused`), ie === "keyboard" && ot.classList.add(`${n}-focusVisible`), ye.scrollHeight > ye.clientHeight && ie !== "mouse" && ie !== "touch")) {
      const kt = ot, Ft = ye.clientHeight + ye.scrollTop, Wr = kt.offsetTop + kt.offsetHeight;
      Wr > Ft ? ye.scrollTop = Wr - ye.clientHeight : kt.offsetTop - kt.offsetHeight * (O ? 1.3 : 0) < ye.scrollTop && (ye.scrollTop = kt.offsetTop - kt.offsetHeight * (O ? 1.3 : 0));
    }
  }), Me = Dt(({
    event: q,
    diff: W,
    direction: ie = "next",
    reason: Le
  }) => {
    if (!lt)
      return;
    const ot = tn((/* @__PURE__ */ a(() => {
      const kt = ce.length - 1;
      if (W === "reset")
        return Re;
      if (W === "start")
        return 0;
      if (W === "end")
        return kt;
      const Ft = Oe.current + W;
      return Ft < 0 ? Ft === -1 && I ? -1 : g && Oe.current !== -1 || Math.abs(W) > 1 ? 0 : kt : Ft > kt ? Ft === kt + 1 && I ? -1 : g || Math.abs(W) > 1 ? kt : 0 : Ft;
    }, "getNextIndex"))(), ie);
    if (ue({
      index: ot,
      reason: Le,
      event: q
    }), o && W !== "reset")
      if (ot === -1)
        ne.current.value = Ce;
      else {
        const kt = N(ce[ot]);
        ne.current.value = kt, kt.toLowerCase().indexOf(Ce.toLowerCase()) === 0 && Ce.length > 0 && ne.current.setSelectionRange(Ce.length, kt.length);
      }
  }), Xe = /* @__PURE__ */ a(() => {
    const q = /* @__PURE__ */ a((W, ie) => {
      const Le = W ? N(W) : "", ye = ie ? N(ie) : "";
      return Le === ye;
    }, "isSameValue");
    if (Oe.current !== -1 && nt.filteredOptions && nt.filteredOptions.length !== ce.length && nt.inputValue === Ce && (R ? re.length === nt.value.length && nt.value.every((W, ie) => N(re[ie]) === N(W)) : q(nt.value, re))) {
      const W = nt.filteredOptions[Oe.current];
      if (W)
        return ce.findIndex((ie) => N(ie) === N(W));
    }
    return -1;
  }, "getPreviousHighlightedOptionIndex"), $t = k.useCallback(() => {
    if (!lt)
      return;
    const q = Xe();
    if (q !== -1) {
      Oe.current = q;
      return;
    }
    const W = R ? re[0] : re;
    if (ce.length === 0 || W == null) {
      Me({
        diff: "reset"
      });
      return;
    }
    if (X.current) {
      if (W != null) {
        const ie = ce[Oe.current];
        if (R && ie && re.findIndex((ye) => _(ie, ye)) !== -1)
          return;
        const Le = ce.findIndex((ye) => _(ye, W));
        Le === -1 ? Me({
          diff: "reset"
        }) : ue({
          index: Le
        });
        return;
      }
      if (Oe.current >= ce.length - 1) {
        ue({
          index: ce.length - 1
        });
        return;
      }
      ue({
        index: Oe.current
      });
    }
  }, [
    // Only sync the highlighted index when the option switch between empty and not
    ce.length,
    // Don't sync the highlighted index with the value when multiple
    // eslint-disable-next-line react-hooks/exhaustive-deps
    R ? !1 : re,
    w,
    Me,
    ue,
    lt,
    Ce,
    R
  ]), Ln = Dt((q) => {
    m1(X, q), q && $t();
  });
  process.env.NODE_ENV !== "production" && k.useEffect(() => {
    (!ne.current || ne.current.nodeName !== "INPUT") && (ne.current && ne.current.nodeName === "TEXTAREA" ? console.warn([`A textarea element was provided to ${u} where input was expected.`, "This is not a supported scenario but it may work under certain conditions.", "A textarea keyboard navigation may conflict with Autocomplete controls (for example enter and arrow keys).", "Make sure to test keyboard navigation and add custom event handlers if necessary."].join(`
`)) : console.error([`MUI: Unable to find the input element. It was resolved to ${ne.current} while an HTMLInputElement was expected.`, `Instead, ${u} expects an input element.`, "", u === "useAutocomplete" ? "Make sure you have bound getInputProps correctly and that the normal ref/effect resolutions order is guaranteed." : "Make sure you have customized the input component correctly."].join(`
`)));
  }, [u]), k.useEffect(() => {
    $t();
  }, [$t]);
  const _t = /* @__PURE__ */ a((q) => {
    ut || (Mt(!0), ft(!0), D && D(q));
  }, "handleOpen"), nn = /* @__PURE__ */ a((q, W) => {
    ut && (Mt(!1), B && B(q, W));
  }, "handleClose"), on = /* @__PURE__ */ a((q, W, ie, Le) => {
    if (R) {
      if (re.length === W.length && re.every((ye, ot) => ye === W[ot]))
        return;
    } else if (re === W)
      return;
    j && j(q, W, ie, Le), Fe(W);
  }, "handleValue"), Vn = k.useRef(!1), Zt = /* @__PURE__ */ a((q, W, ie = "selectOption", Le = "options") => {
    let ye = ie, ot = W;
    if (R) {
      if (ot = Array.isArray(re) ? re.slice() : [], process.env.NODE_ENV !== "production") {
        const Ft = ot.filter((Wr) => _(W, Wr));
        Ft.length > 1 && console.error([`MUI: The \`isOptionEqualToValue\` method of ${u} does not handle the arguments correctly.`, `The component expects a single value to match a given option but found ${Ft.length} matches.`].join(`
`));
      }
      const kt = ot.findIndex((Ft) => _(W, Ft));
      kt === -1 ? ot.push(W) : Le !== "freeSolo" && (ot.splice(kt, 1), ye = "removeOption");
    }
    ze(q, ot, ye), on(q, ot, ye, {
      option: W
    }), !m && (!q || !q.ctrlKey && !q.metaKey) && nn(q, ye), (l === !0 || l === "touch" && Vn.current || l === "mouse" && !Vn.current) && ne.current.blur();
  }, "selectNewValue");
  function ho(q, W) {
    if (q === -1)
      return -1;
    let ie = q;
    for (; ; ) {
      if (W === "next" && ie === re.length || W === "previous" && ie === -1)
        return -1;
      const Le = U ? "data-item-index" : "data-tag-index", ye = se.querySelector(`[${Le}="${ie}"]`);
      if (!ye || !ye.hasAttribute("tabindex") || ye.disabled || ye.getAttribute("aria-disabled") === "true")
        ie += W === "next" ? 1 : -1;
      else
        return ie;
    }
  }
  a(ho, "validItemIndex");
  const xe = /* @__PURE__ */ a((q, W) => {
    if (!R)
      return;
    Ce === "" && nn(q, "toggleInput");
    let ie = fe;
    fe === -1 ? Ce === "" && W === "previous" && (ie = re.length - 1) : (ie += W === "next" ? 1 : -1, ie < 0 && (ie = 0), ie === re.length && (ie = -1)), ie = ho(ie, W), be(ie), Ke(ie);
  }, "handleFocusItem"), wt = /* @__PURE__ */ a((q) => {
    te.current = !0, Pe(""), L && L(q, "", "clear"), on(q, R ? [] : null, "clear");
  }, "handleClear"), ae = /* @__PURE__ */ a((q) => (W) => {
    if (q.onKeyDown && q.onKeyDown(W), !W.defaultMuiPrevented && (fe !== -1 && !["ArrowLeft", "ArrowRight"].includes(W.key) && (be(-1), Ke(-1)), W.which !== 229))
      switch (W.key) {
        case "Home":
          lt && P && (W.preventDefault(), Me({
            diff: "start",
            direction: "next",
            reason: "keyboard",
            event: W
          }));
          break;
        case "End":
          lt && P && (W.preventDefault(), Me({
            diff: "end",
            direction: "previous",
            reason: "keyboard",
            event: W
          }));
          break;
        case "PageUp":
          W.preventDefault(), Me({
            diff: -x3,
            direction: "previous",
            reason: "keyboard",
            event: W
          }), _t(W);
          break;
        case "PageDown":
          W.preventDefault(), Me({
            diff: x3,
            direction: "next",
            reason: "keyboard",
            event: W
          }), _t(W);
          break;
        case "ArrowDown":
          W.preventDefault(), Me({
            diff: 1,
            direction: "next",
            reason: "keyboard",
            event: W
          }), _t(W);
          break;
        case "ArrowUp":
          W.preventDefault(), Me({
            diff: -1,
            direction: "previous",
            reason: "keyboard",
            event: W
          }), _t(W);
          break;
        case "ArrowLeft":
          !R && U ? Ke(0) : xe(W, "previous");
          break;
        case "ArrowRight":
          !R && U ? Ke(-1) : xe(W, "next");
          break;
        case "Enter":
          if (Oe.current !== -1 && lt) {
            const ie = ce[Oe.current], Le = x ? x(ie) : !1;
            if (W.preventDefault(), Le)
              return;
            Zt(W, ie, "selectOption"), o && ne.current.setSelectionRange(ne.current.value.length, ne.current.value.length);
          } else T && Ce !== "" && Tt === !1 && (R && W.preventDefault(), Zt(W, Ce, "createOption", "freeSolo"));
          break;
        case "Escape":
          lt ? (W.preventDefault(), W.stopPropagation(), nn(W, "escape")) : d && (Ce !== "" || R && re.length > 0 || U) && (W.preventDefault(), W.stopPropagation(), wt(W));
          break;
        case "Backspace":
          if (R && !A && Ce === "" && re.length > 0) {
            const ie = fe === -1 ? re.length - 1 : fe, Le = re.slice();
            Le.splice(ie, 1), on(W, Le, "removeOption", {
              option: re[ie]
            });
          }
          !R && U && !A && (Fe(null), Ke(-1));
          break;
        case "Delete":
          if (R && !A && Ce === "" && re.length > 0 && fe !== -1) {
            const ie = fe, Le = re.slice();
            Le.splice(ie, 1), on(W, Le, "removeOption", {
              option: re[ie]
            });
          }
          !R && U && !A && (Fe(null), Ke(-1));
          break;
      }
  }, "handleKeyDown"), he = /* @__PURE__ */ a((q) => {
    pt(!0), H && !te.current && _t(q);
  }, "handleFocus"), Ee = /* @__PURE__ */ a((q) => {
    if (t(X)) {
      ne.current.focus();
      return;
    }
    pt(!1), oe.current = !0, te.current = !1, i && Oe.current !== -1 && lt ? Zt(q, ce[Oe.current], "blur") : i && T && Ce !== "" ? Zt(q, Ce, "blur", "freeSolo") : c && ze(q, re, "blur"), nn(q, "blur");
  }, "handleBlur"), Ve = /* @__PURE__ */ a((q) => {
    const W = q.target.value;
    Ce !== W && (Pe(W), ft(!1), L && L(q, W, "input")), W === "" ? !f && !R && on(q, null, "clear") : _t(q);
  }, "handleInputChange"), Je = /* @__PURE__ */ a((q) => {
    const W = Number(q.currentTarget.getAttribute("data-option-index"));
    Oe.current !== W && ue({
      event: q,
      index: W,
      reason: "mouse"
    });
  }, "handleOptionMouseMove"), Ut = /* @__PURE__ */ a((q) => {
    ue({
      event: q,
      index: Number(q.currentTarget.getAttribute("data-option-index")),
      reason: "touch"
    }), Vn.current = !0;
  }, "handleOptionTouchStart"), En = /* @__PURE__ */ a((q) => {
    const W = Number(q.currentTarget.getAttribute("data-option-index"));
    Zt(q, ce[W], "selectOption"), Vn.current = !1;
  }, "handleOptionClick"), An = /* @__PURE__ */ a((q) => (W) => {
    const ie = re.slice();
    ie.splice(q, 1), on(W, ie, "removeOption", {
      option: re[q]
    });
  }, "handleItemDelete"), zr = /* @__PURE__ */ a((q) => {
    on(q, null, "removeOption", {
      option: re
    });
  }, "handleSingleItemDelete"), Bn = /* @__PURE__ */ a((q) => {
    ut ? nn(q, "toggleInput") : _t(q);
  }, "handlePopupIndicator"), It = /* @__PURE__ */ a((q) => {
    q.currentTarget.contains(q.target) && q.target.getAttribute("id") !== F && q.preventDefault();
  }, "handleMouseDown"), Rt = /* @__PURE__ */ a((q) => {
    q.currentTarget.contains(q.target) && (ne.current.focus(), K && oe.current && ne.current.selectionEnd - ne.current.selectionStart === 0 && ne.current.select(), oe.current = !1);
  }, "handleClick"), go = /* @__PURE__ */ a((q) => {
    !b && (Ce === "" || !ut) && Bn(q);
  }, "handleInputMouseDown");
  let Fr = T && Ce.length > 0;
  Fr = Fr || (R ? re.length > 0 : re !== null);
  let fs = ce;
  if (O) {
    const q = /* @__PURE__ */ new Map();
    let W = !1;
    fs = ce.reduce((ie, Le, ye) => {
      const ot = O(Le);
      return ie.length > 0 && ie[ie.length - 1].group === ot ? ie[ie.length - 1].options.push(Le) : (process.env.NODE_ENV !== "production" && (q.get(ot) && !W && (console.warn(`MUI: The options provided combined with the \`groupBy\` method of ${u} returns duplicated headers.`, "You can solve the issue by sorting the options with the output of `groupBy`."), W = !0), q.set(ot, !0)), ie.push({
        key: ye,
        index: ye,
        group: ot,
        options: [Le]
      })), ie;
    }, []);
  }
  return b && de && Ee(), {
    getRootProps: /* @__PURE__ */ a((q = {}) => ({
      ...q,
      onKeyDown: ae(q),
      onMouseDown: It,
      onClick: Rt
    }), "getRootProps"),
    getInputLabelProps: /* @__PURE__ */ a(() => ({
      id: `${F}-label`,
      htmlFor: F
    }), "getInputLabelProps"),
    getInputProps: /* @__PURE__ */ a(() => ({
      id: F,
      value: Ce,
      onBlur: Ee,
      onFocus: he,
      onChange: Ve,
      onMouseDown: go,
      // if open then this is handled imperatively so don't let react override
      // only have an opinion about this when closed
      "aria-activedescendant": lt ? "" : null,
      "aria-autocomplete": o ? "both" : "list",
      "aria-controls": vt ? `${F}-listbox` : void 0,
      "aria-expanded": vt,
      // Disable browser's suggestion that might overlap with the popup.
      // Handle autocomplete but not autofill.
      autoComplete: "off",
      ref: ne,
      autoCapitalize: "none",
      spellCheck: "false",
      role: "combobox",
      disabled: b
    }), "getInputProps"),
    getClearProps: /* @__PURE__ */ a(() => ({
      tabIndex: -1,
      type: "button",
      onClick: wt
    }), "getClearProps"),
    getItemProps: /* @__PURE__ */ a(({
      index: q = 0
    } = {}) => ({
      ...R && {
        key: q
      },
      ...U ? {
        "data-item-index": q
      } : {
        "data-tag-index": q
      },
      tabIndex: -1,
      ...!A && {
        onDelete: R ? An(q) : zr
      }
    }), "getItemProps"),
    getPopupIndicatorProps: /* @__PURE__ */ a(() => ({
      tabIndex: -1,
      type: "button",
      onClick: Bn
    }), "getPopupIndicatorProps"),
    // deprecated
    getTagProps: /* @__PURE__ */ a(({
      index: q
    }) => ({
      key: q,
      "data-tag-index": q,
      tabIndex: -1,
      ...!A && {
        onDelete: An(q)
      }
    }), "getTagProps"),
    getListboxProps: /* @__PURE__ */ a(() => ({
      role: "listbox",
      id: `${F}-listbox`,
      "aria-labelledby": `${F}-label`,
      ref: Ln,
      onMouseDown: /* @__PURE__ */ a((q) => {
        q.preventDefault();
      }, "onMouseDown")
    }), "getListboxProps"),
    getOptionProps: /* @__PURE__ */ a(({
      index: q,
      option: W
    }) => {
      const ie = (R ? re : [re]).some((ye) => ye != null && _(W, ye)), Le = x ? x(W) : !1;
      return {
        key: (S == null ? void 0 : S(W)) ?? N(W),
        tabIndex: -1,
        role: "option",
        id: `${F}-option-${q}`,
        onMouseMove: Je,
        onClick: En,
        onTouchStart: Ut,
        "data-option-index": q,
        "aria-disabled": Le,
        "aria-selected": ie
      };
    }, "getOptionProps"),
    id: F,
    inputValue: Ce,
    value: re,
    dirty: Fr,
    expanded: lt && se,
    popupOpen: lt,
    focused: de || fe !== -1,
    anchorEl: se,
    setAnchorEl: Y,
    focusedItem: fe,
    // deprecated
    focusedTag: fe,
    groupedOptions: fs
  };
}
a(yf, "useAutocomplete");
function Kn(e, t, n, o, r) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = e[t], l = r || t;
  return i == null ? null : i && i.nodeType !== 1 ? new Error(`Invalid ${o} \`${l}\` supplied to \`${n}\`. Expected an HTMLElement.`) : null;
}
a(Kn, "HTMLElementType");
var Kt = "top", Sn = "bottom", Mn = "right", Xt = "left", wc = "auto", as = [Kt, Sn, Mn, Xt], Pr = "start", Fi = "end", xf = "clippingParents", D5 = "viewport", Xr = "popper", vf = "reference", w3 = /* @__PURE__ */ as.reduce(function(e, t) {
  return e.concat([t + "-" + Pr, t + "-" + Fi]);
}, []), N5 = /* @__PURE__ */ [].concat(as, [wc]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Pr, t + "-" + Fi]);
}, []), wf = "beforeRead", Sf = "read", Mf = "afterRead", Tf = "beforeMain", kf = "main", Of = "afterMain", Ef = "beforeWrite", $f = "write", Pf = "afterWrite", _f = [wf, Sf, Mf, Tf, kf, Of, Ef, $f, Pf];
function Xn(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
a(Xn, "getNodeName");
function un(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
a(un, "getWindow");
function nr(e) {
  var t = un(e).Element;
  return e instanceof t || e instanceof Element;
}
a(nr, "isElement");
function wn(e) {
  var t = un(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
a(wn, "isHTMLElement$1");
function Sc(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = un(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
a(Sc, "isShadowRoot");
function Rf(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var o = t.styles[n] || {}, r = t.attributes[n] || {}, i = t.elements[n];
    !wn(i) || !Xn(i) || (Object.assign(i.style, o), Object.keys(r).forEach(function(l) {
      var c = r[l];
      c === !1 ? i.removeAttribute(l) : i.setAttribute(l, c === !0 ? "" : c);
    }));
  });
}
a(Rf, "applyStyles");
function If(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(o) {
      var r = t.elements[o], i = t.attributes[o] || {}, l = Object.keys(t.styles.hasOwnProperty(o) ? t.styles[o] : n[o]), c = l.reduce(function(d, u) {
        return d[u] = "", d;
      }, {});
      !wn(r) || !Xn(r) || (Object.assign(r.style, c), Object.keys(i).forEach(function(d) {
        r.removeAttribute(d);
      }));
    });
  };
}
a(If, "effect$2");
const jf = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Rf,
  effect: If,
  requires: ["computeStyles"]
};
function Gn(e) {
  return e.split("-")[0];
}
a(Gn, "getBasePlacement");
var Qo = Math.max, fa = Math.min, _r = Math.round;
function M1() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
a(M1, "getUAString");
function z5() {
  return !/^((?!chrome|android).)*safari/i.test(M1());
}
a(z5, "isLayoutViewport");
function Rr(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var o = e.getBoundingClientRect(), r = 1, i = 1;
  t && wn(e) && (r = e.offsetWidth > 0 && _r(o.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && _r(o.height) / e.offsetHeight || 1);
  var l = nr(e) ? un(e) : window, c = l.visualViewport, d = !z5() && n, u = (o.left + (d && c ? c.offsetLeft : 0)) / r, p = (o.top + (d && c ? c.offsetTop : 0)) / i, f = o.width / r, m = o.height / i;
  return {
    width: f,
    height: m,
    top: p,
    right: u + f,
    bottom: p + m,
    left: u,
    x: u,
    y: p
  };
}
a(Rr, "getBoundingClientRect");
function Mc(e) {
  var t = Rr(e), n = e.offsetWidth, o = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - o) <= 1 && (o = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: o
  };
}
a(Mc, "getLayoutRect");
function F5(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && Sc(n)) {
    var o = t;
    do {
      if (o && e.isSameNode(o))
        return !0;
      o = o.parentNode || o.host;
    } while (o);
  }
  return !1;
}
a(F5, "contains");
function co(e) {
  return un(e).getComputedStyle(e);
}
a(co, "getComputedStyle$1");
function Lf(e) {
  return ["table", "td", "th"].indexOf(Xn(e)) >= 0;
}
a(Lf, "isTableElement");
function Io(e) {
  return ((nr(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
a(Io, "getDocumentElement");
function sl(e) {
  return Xn(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Sc(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Io(e)
  );
}
a(sl, "getParentNode");
function S3(e) {
  return !wn(e) || // https://github.com/popperjs/popper-core/issues/837
  co(e).position === "fixed" ? null : e.offsetParent;
}
a(S3, "getTrueOffsetParent");
function Vf(e) {
  var t = /firefox/i.test(M1()), n = /Trident/i.test(M1());
  if (n && wn(e)) {
    var o = co(e);
    if (o.position === "fixed")
      return null;
  }
  var r = sl(e);
  for (Sc(r) && (r = r.host); wn(r) && ["html", "body"].indexOf(Xn(r)) < 0; ) {
    var i = co(r);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return r;
    r = r.parentNode;
  }
  return null;
}
a(Vf, "getContainingBlock");
function ls(e) {
  for (var t = un(e), n = S3(e); n && Lf(n) && co(n).position === "static"; )
    n = S3(n);
  return n && (Xn(n) === "html" || Xn(n) === "body" && co(n).position === "static") ? t : n || Vf(e) || t;
}
a(ls, "getOffsetParent");
function Tc(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
a(Tc, "getMainAxisFromPlacement");
function yi(e, t, n) {
  return Qo(e, fa(t, n));
}
a(yi, "within");
function Af(e, t, n) {
  var o = yi(e, t, n);
  return o > n ? n : o;
}
a(Af, "withinMaxClamp");
function W5() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
a(W5, "getFreshSideObject");
function Z5(e) {
  return Object.assign({}, W5(), e);
}
a(Z5, "mergePaddingObject");
function U5(e, t) {
  return t.reduce(function(n, o) {
    return n[o] = e, n;
  }, {});
}
a(U5, "expandToHashMap");
var Bf = /* @__PURE__ */ a(function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, Z5(typeof t != "number" ? t : U5(t, as));
}, "toPaddingObject");
function Hf(e) {
  var t, n = e.state, o = e.name, r = e.options, i = n.elements.arrow, l = n.modifiersData.popperOffsets, c = Gn(n.placement), d = Tc(c), u = [Xt, Mn].indexOf(c) >= 0, p = u ? "height" : "width";
  if (!(!i || !l)) {
    var f = Bf(r.padding, n), m = Mc(i), b = d === "y" ? Kt : Xt, C = d === "y" ? Sn : Mn, g = n.rects.reference[p] + n.rects.reference[d] - l[d] - n.rects.popper[p], y = l[d] - n.rects.reference[d], w = ls(i), T = w ? d === "y" ? w.clientHeight || 0 : w.clientWidth || 0 : 0, x = g / 2 - y / 2, S = f[b], M = T - m[p] - f[C], O = T / 2 - m[p] / 2 + x, P = yi(S, O, M), E = d;
    n.modifiersData[o] = (t = {}, t[E] = P, t.centerOffset = P - O, t);
  }
}
a(Hf, "arrow");
function Df(e) {
  var t = e.state, n = e.options, o = n.element, r = o === void 0 ? "[data-popper-arrow]" : o;
  r != null && (typeof r == "string" && (r = t.elements.popper.querySelector(r), !r) || F5(t.elements.popper, r) && (t.elements.arrow = r));
}
a(Df, "effect$1");
const Nf = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Hf,
  effect: Df,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Ir(e) {
  return e.split("-")[1];
}
a(Ir, "getVariation");
var zf = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Ff(e, t) {
  var n = e.x, o = e.y, r = t.devicePixelRatio || 1;
  return {
    x: _r(n * r) / r || 0,
    y: _r(o * r) / r || 0
  };
}
a(Ff, "roundOffsetsByDPR");
function M3(e) {
  var t, n = e.popper, o = e.popperRect, r = e.placement, i = e.variation, l = e.offsets, c = e.position, d = e.gpuAcceleration, u = e.adaptive, p = e.roundOffsets, f = e.isFixed, m = l.x, b = m === void 0 ? 0 : m, C = l.y, g = C === void 0 ? 0 : C, y = typeof p == "function" ? p({
    x: b,
    y: g
  }) : {
    x: b,
    y: g
  };
  b = y.x, g = y.y;
  var w = l.hasOwnProperty("x"), T = l.hasOwnProperty("y"), x = Xt, S = Kt, M = window;
  if (u) {
    var O = ls(n), P = "clientHeight", E = "clientWidth";
    if (O === un(n) && (O = Io(n), co(O).position !== "static" && c === "absolute" && (P = "scrollHeight", E = "scrollWidth")), O = O, r === Kt || (r === Xt || r === Mn) && i === Fi) {
      S = Sn;
      var I = f && O === M && M.visualViewport ? M.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        O[P]
      );
      g -= I - o.height, g *= d ? 1 : -1;
    }
    if (r === Xt || (r === Kt || r === Sn) && i === Fi) {
      x = Mn;
      var v = f && O === M && M.visualViewport ? M.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        O[E]
      );
      b -= v - o.width, b *= d ? 1 : -1;
    }
  }
  var _ = Object.assign({
    position: c
  }, u && zf), R = p === !0 ? Ff({
    x: b,
    y: g
  }, un(n)) : {
    x: b,
    y: g
  };
  if (b = R.x, g = R.y, d) {
    var j;
    return Object.assign({}, _, (j = {}, j[S] = T ? "0" : "", j[x] = w ? "0" : "", j.transform = (M.devicePixelRatio || 1) <= 1 ? "translate(" + b + "px, " + g + "px)" : "translate3d(" + b + "px, " + g + "px, 0)", j));
  }
  return Object.assign({}, _, (t = {}, t[S] = T ? g + "px" : "", t[x] = w ? b + "px" : "", t.transform = "", t));
}
a(M3, "mapToStyles");
function Wf(e) {
  var t = e.state, n = e.options, o = n.gpuAcceleration, r = o === void 0 ? !0 : o, i = n.adaptive, l = i === void 0 ? !0 : i, c = n.roundOffsets, d = c === void 0 ? !0 : c, u = {
    placement: Gn(t.placement),
    variation: Ir(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: r,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, M3(Object.assign({}, u, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: l,
    roundOffsets: d
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, M3(Object.assign({}, u, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: d
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
a(Wf, "computeStyles");
const Zf = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Wf,
  data: {}
};
var Ms = {
  passive: !0
};
function Uf(e) {
  var t = e.state, n = e.instance, o = e.options, r = o.scroll, i = r === void 0 ? !0 : r, l = o.resize, c = l === void 0 ? !0 : l, d = un(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && u.forEach(function(p) {
    p.addEventListener("scroll", n.update, Ms);
  }), c && d.addEventListener("resize", n.update, Ms), function() {
    i && u.forEach(function(p) {
      p.removeEventListener("scroll", n.update, Ms);
    }), c && d.removeEventListener("resize", n.update, Ms);
  };
}
a(Uf, "effect");
const Gf = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: /* @__PURE__ */ a(function() {
  }, "fn"),
  effect: Uf,
  data: {}
};
var Yf = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function ea(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return Yf[t];
  });
}
a(ea, "getOppositePlacement");
var qf = {
  start: "end",
  end: "start"
};
function T3(e) {
  return e.replace(/start|end/g, function(t) {
    return qf[t];
  });
}
a(T3, "getOppositeVariationPlacement");
function kc(e) {
  var t = un(e), n = t.pageXOffset, o = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: o
  };
}
a(kc, "getWindowScroll");
function Oc(e) {
  return Rr(Io(e)).left + kc(e).scrollLeft;
}
a(Oc, "getWindowScrollBarX");
function Kf(e, t) {
  var n = un(e), o = Io(e), r = n.visualViewport, i = o.clientWidth, l = o.clientHeight, c = 0, d = 0;
  if (r) {
    i = r.width, l = r.height;
    var u = z5();
    (u || !u && t === "fixed") && (c = r.offsetLeft, d = r.offsetTop);
  }
  return {
    width: i,
    height: l,
    x: c + Oc(e),
    y: d
  };
}
a(Kf, "getViewportRect");
function Xf(e) {
  var t, n = Io(e), o = kc(e), r = (t = e.ownerDocument) == null ? void 0 : t.body, i = Qo(n.scrollWidth, n.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0), l = Qo(n.scrollHeight, n.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0), c = -o.scrollLeft + Oc(e), d = -o.scrollTop;
  return co(r || n).direction === "rtl" && (c += Qo(n.clientWidth, r ? r.clientWidth : 0) - i), {
    width: i,
    height: l,
    x: c,
    y: d
  };
}
a(Xf, "getDocumentRect");
function Ec(e) {
  var t = co(e), n = t.overflow, o = t.overflowX, r = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + r + o);
}
a(Ec, "isScrollParent");
function G5(e) {
  return ["html", "body", "#document"].indexOf(Xn(e)) >= 0 ? e.ownerDocument.body : wn(e) && Ec(e) ? e : G5(sl(e));
}
a(G5, "getScrollParent");
function xi(e, t) {
  var n;
  t === void 0 && (t = []);
  var o = G5(e), r = o === ((n = e.ownerDocument) == null ? void 0 : n.body), i = un(o), l = r ? [i].concat(i.visualViewport || [], Ec(o) ? o : []) : o, c = t.concat(l);
  return r ? c : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    c.concat(xi(sl(l)))
  );
}
a(xi, "listScrollParents");
function T1(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
a(T1, "rectToClientRect");
function Jf(e, t) {
  var n = Rr(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
a(Jf, "getInnerBoundingClientRect");
function k3(e, t, n) {
  return t === D5 ? T1(Kf(e, n)) : nr(t) ? Jf(t, n) : T1(Xf(Io(e)));
}
a(k3, "getClientRectFromMixedType");
function Qf(e) {
  var t = xi(sl(e)), n = ["absolute", "fixed"].indexOf(co(e).position) >= 0, o = n && wn(e) ? ls(e) : e;
  return nr(o) ? t.filter(function(r) {
    return nr(r) && F5(r, o) && Xn(r) !== "body";
  }) : [];
}
a(Qf, "getClippingParents");
function e9(e, t, n, o) {
  var r = t === "clippingParents" ? Qf(e) : [].concat(t), i = [].concat(r, [n]), l = i[0], c = i.reduce(function(d, u) {
    var p = k3(e, u, o);
    return d.top = Qo(p.top, d.top), d.right = fa(p.right, d.right), d.bottom = fa(p.bottom, d.bottom), d.left = Qo(p.left, d.left), d;
  }, k3(e, l, o));
  return c.width = c.right - c.left, c.height = c.bottom - c.top, c.x = c.left, c.y = c.top, c;
}
a(e9, "getClippingRect");
function Y5(e) {
  var t = e.reference, n = e.element, o = e.placement, r = o ? Gn(o) : null, i = o ? Ir(o) : null, l = t.x + t.width / 2 - n.width / 2, c = t.y + t.height / 2 - n.height / 2, d;
  switch (r) {
    case Kt:
      d = {
        x: l,
        y: t.y - n.height
      };
      break;
    case Sn:
      d = {
        x: l,
        y: t.y + t.height
      };
      break;
    case Mn:
      d = {
        x: t.x + t.width,
        y: c
      };
      break;
    case Xt:
      d = {
        x: t.x - n.width,
        y: c
      };
      break;
    default:
      d = {
        x: t.x,
        y: t.y
      };
  }
  var u = r ? Tc(r) : null;
  if (u != null) {
    var p = u === "y" ? "height" : "width";
    switch (i) {
      case Pr:
        d[u] = d[u] - (t[p] / 2 - n[p] / 2);
        break;
      case Fi:
        d[u] = d[u] + (t[p] / 2 - n[p] / 2);
        break;
    }
  }
  return d;
}
a(Y5, "computeOffsets");
function Wi(e, t) {
  t === void 0 && (t = {});
  var n = t, o = n.placement, r = o === void 0 ? e.placement : o, i = n.strategy, l = i === void 0 ? e.strategy : i, c = n.boundary, d = c === void 0 ? xf : c, u = n.rootBoundary, p = u === void 0 ? D5 : u, f = n.elementContext, m = f === void 0 ? Xr : f, b = n.altBoundary, C = b === void 0 ? !1 : b, g = n.padding, y = g === void 0 ? 0 : g, w = Z5(typeof y != "number" ? y : U5(y, as)), T = m === Xr ? vf : Xr, x = e.rects.popper, S = e.elements[C ? T : m], M = e9(nr(S) ? S : S.contextElement || Io(e.elements.popper), d, p, l), O = Rr(e.elements.reference), P = Y5({
    reference: O,
    element: x,
    placement: r
  }), E = T1(Object.assign({}, x, P)), I = m === Xr ? E : O, v = {
    top: M.top - I.top + w.top,
    bottom: I.bottom - M.bottom + w.bottom,
    left: M.left - I.left + w.left,
    right: I.right - M.right + w.right
  }, _ = e.modifiersData.offset;
  if (m === Xr && _) {
    var R = _[r];
    Object.keys(v).forEach(function(j) {
      var B = [Mn, Sn].indexOf(j) >= 0 ? 1 : -1, V = [Kt, Sn].indexOf(j) >= 0 ? "y" : "x";
      v[j] += R[V] * B;
    });
  }
  return v;
}
a(Wi, "detectOverflow");
function t9(e, t) {
  t === void 0 && (t = {});
  var n = t, o = n.placement, r = n.boundary, i = n.rootBoundary, l = n.padding, c = n.flipVariations, d = n.allowedAutoPlacements, u = d === void 0 ? N5 : d, p = Ir(o), f = p ? c ? w3 : w3.filter(function(C) {
    return Ir(C) === p;
  }) : as, m = f.filter(function(C) {
    return u.indexOf(C) >= 0;
  });
  m.length === 0 && (m = f);
  var b = m.reduce(function(C, g) {
    return C[g] = Wi(e, {
      placement: g,
      boundary: r,
      rootBoundary: i,
      padding: l
    })[Gn(g)], C;
  }, {});
  return Object.keys(b).sort(function(C, g) {
    return b[C] - b[g];
  });
}
a(t9, "computeAutoPlacement");
function n9(e) {
  if (Gn(e) === wc)
    return [];
  var t = ea(e);
  return [T3(e), t, T3(t)];
}
a(n9, "getExpandedFallbackPlacements");
function o9(e) {
  var t = e.state, n = e.options, o = e.name;
  if (!t.modifiersData[o]._skip) {
    for (var r = n.mainAxis, i = r === void 0 ? !0 : r, l = n.altAxis, c = l === void 0 ? !0 : l, d = n.fallbackPlacements, u = n.padding, p = n.boundary, f = n.rootBoundary, m = n.altBoundary, b = n.flipVariations, C = b === void 0 ? !0 : b, g = n.allowedAutoPlacements, y = t.options.placement, w = Gn(y), T = w === y, x = d || (T || !C ? [ea(y)] : n9(y)), S = [y].concat(x).reduce(function(J, F) {
      return J.concat(Gn(F) === wc ? t9(t, {
        placement: F,
        boundary: p,
        rootBoundary: f,
        padding: u,
        flipVariations: C,
        allowedAutoPlacements: g
      }) : F);
    }, []), M = t.rects.reference, O = t.rects.popper, P = /* @__PURE__ */ new Map(), E = !0, I = S[0], v = 0; v < S.length; v++) {
      var _ = S[v], R = Gn(_), j = Ir(_) === Pr, B = [Kt, Sn].indexOf(R) >= 0, V = B ? "width" : "height", L = Wi(t, {
        placement: _,
        boundary: p,
        rootBoundary: f,
        altBoundary: m,
        padding: u
      }), D = B ? j ? Mn : Xt : j ? Sn : Kt;
      M[V] > O[V] && (D = ea(D));
      var z = ea(D), H = [];
      if (i && H.push(L[R] <= 0), c && H.push(L[D] <= 0, L[z] <= 0), H.every(function(J) {
        return J;
      })) {
        I = _, E = !1;
        break;
      }
      P.set(_, H);
    }
    if (E)
      for (var $ = C ? 3 : 1, A = /* @__PURE__ */ a(function(F) {
        var N = S.find(function(te) {
          var oe = P.get(te);
          if (oe)
            return oe.slice(0, F).every(function(ne) {
              return ne;
            });
        });
        if (N)
          return I = N, "break";
      }, "_loop"), U = $; U > 0; U--) {
        var K = A(U);
        if (K === "break") break;
      }
    t.placement !== I && (t.modifiersData[o]._skip = !0, t.placement = I, t.reset = !0);
  }
}
a(o9, "flip");
const r9 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: o9,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function O3(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
a(O3, "getSideOffsets");
function E3(e) {
  return [Kt, Mn, Sn, Xt].some(function(t) {
    return e[t] >= 0;
  });
}
a(E3, "isAnySideFullyClipped");
function i9(e) {
  var t = e.state, n = e.name, o = t.rects.reference, r = t.rects.popper, i = t.modifiersData.preventOverflow, l = Wi(t, {
    elementContext: "reference"
  }), c = Wi(t, {
    altBoundary: !0
  }), d = O3(l, o), u = O3(c, r, i), p = E3(d), f = E3(u);
  t.modifiersData[n] = {
    referenceClippingOffsets: d,
    popperEscapeOffsets: u,
    isReferenceHidden: p,
    hasPopperEscaped: f
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": p,
    "data-popper-escaped": f
  });
}
a(i9, "hide");
const s9 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: i9
};
function a9(e, t, n) {
  var o = Gn(e), r = [Xt, Kt].indexOf(o) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, l = i[0], c = i[1];
  return l = l || 0, c = (c || 0) * r, [Xt, Mn].indexOf(o) >= 0 ? {
    x: c,
    y: l
  } : {
    x: l,
    y: c
  };
}
a(a9, "distanceAndSkiddingToXY");
function l9(e) {
  var t = e.state, n = e.options, o = e.name, r = n.offset, i = r === void 0 ? [0, 0] : r, l = N5.reduce(function(p, f) {
    return p[f] = a9(f, t.rects, i), p;
  }, {}), c = l[t.placement], d = c.x, u = c.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += d, t.modifiersData.popperOffsets.y += u), t.modifiersData[o] = l;
}
a(l9, "offset");
const c9 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: l9
};
function d9(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = Y5({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
a(d9, "popperOffsets");
const u9 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: d9,
  data: {}
};
function p9(e) {
  return e === "x" ? "y" : "x";
}
a(p9, "getAltAxis");
function f9(e) {
  var t = e.state, n = e.options, o = e.name, r = n.mainAxis, i = r === void 0 ? !0 : r, l = n.altAxis, c = l === void 0 ? !1 : l, d = n.boundary, u = n.rootBoundary, p = n.altBoundary, f = n.padding, m = n.tether, b = m === void 0 ? !0 : m, C = n.tetherOffset, g = C === void 0 ? 0 : C, y = Wi(t, {
    boundary: d,
    rootBoundary: u,
    padding: f,
    altBoundary: p
  }), w = Gn(t.placement), T = Ir(t.placement), x = !T, S = Tc(w), M = p9(S), O = t.modifiersData.popperOffsets, P = t.rects.reference, E = t.rects.popper, I = typeof g == "function" ? g(Object.assign({}, t.rects, {
    placement: t.placement
  })) : g, v = typeof I == "number" ? {
    mainAxis: I,
    altAxis: I
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, I), _ = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, R = {
    x: 0,
    y: 0
  };
  if (O) {
    if (i) {
      var j, B = S === "y" ? Kt : Xt, V = S === "y" ? Sn : Mn, L = S === "y" ? "height" : "width", D = O[S], z = D + y[B], H = D - y[V], $ = b ? -E[L] / 2 : 0, A = T === Pr ? P[L] : E[L], U = T === Pr ? -E[L] : -P[L], K = t.elements.arrow, J = b && K ? Mc(K) : {
        width: 0,
        height: 0
      }, F = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : W5(), N = F[B], te = F[V], oe = yi(0, P[L], J[L]), ne = x ? P[L] / 2 - $ - oe - N - v.mainAxis : A - oe - N - v.mainAxis, X = x ? -P[L] / 2 + $ + oe + te + v.mainAxis : U + oe + te + v.mainAxis, se = t.elements.arrow && ls(t.elements.arrow), Y = se ? S === "y" ? se.clientTop || 0 : se.clientLeft || 0 : 0, fe = (j = _ == null ? void 0 : _[S]) != null ? j : 0, be = D + ne - fe - Y, Re = D + X - fe, Oe = yi(b ? fa(z, be) : z, D, b ? Qo(H, Re) : H);
      O[S] = Oe, R[S] = Oe - D;
    }
    if (c) {
      var Be, re = S === "x" ? Kt : Xt, Fe = S === "x" ? Sn : Mn, Ce = O[M], Pe = M === "y" ? "height" : "width", de = Ce + y[re], pt = Ce - y[Fe], ze = [Kt, Xt].indexOf(w) !== -1, ut = (Be = _ == null ? void 0 : _[M]) != null ? Be : 0, Mt = ze ? de : Ce - P[Pe] - E[Pe] - ut + v.altAxis, At = ze ? Ce + P[Pe] + E[Pe] - ut - v.altAxis : pt, ft = b && ze ? Af(Mt, Ce, At) : yi(b ? Mt : de, Ce, b ? At : pt);
      O[M] = ft, R[M] = ft - Ce;
    }
    t.modifiersData[o] = R;
  }
}
a(f9, "preventOverflow");
const h9 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: f9,
  requiresIfExists: ["offset"]
};
function g9(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
a(g9, "getHTMLElementScroll");
function m9(e) {
  return e === un(e) || !wn(e) ? kc(e) : g9(e);
}
a(m9, "getNodeScroll");
function b9(e) {
  var t = e.getBoundingClientRect(), n = _r(t.width) / e.offsetWidth || 1, o = _r(t.height) / e.offsetHeight || 1;
  return n !== 1 || o !== 1;
}
a(b9, "isElementScaled");
function C9(e, t, n) {
  n === void 0 && (n = !1);
  var o = wn(t), r = wn(t) && b9(t), i = Io(t), l = Rr(e, r, n), c = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = {
    x: 0,
    y: 0
  };
  return (o || !o && !n) && ((Xn(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Ec(i)) && (c = m9(t)), wn(t) ? (d = Rr(t, !0), d.x += t.clientLeft, d.y += t.clientTop) : i && (d.x = Oc(i))), {
    x: l.left + c.scrollLeft - d.x,
    y: l.top + c.scrollTop - d.y,
    width: l.width,
    height: l.height
  };
}
a(C9, "getCompositeRect");
function y9(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), o = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function r(i) {
    n.add(i.name);
    var l = [].concat(i.requires || [], i.requiresIfExists || []);
    l.forEach(function(c) {
      if (!n.has(c)) {
        var d = t.get(c);
        d && r(d);
      }
    }), o.push(i);
  }
  return a(r, "sort"), e.forEach(function(i) {
    n.has(i.name) || r(i);
  }), o;
}
a(y9, "order");
function x9(e) {
  var t = y9(e);
  return _f.reduce(function(n, o) {
    return n.concat(t.filter(function(r) {
      return r.phase === o;
    }));
  }, []);
}
a(x9, "orderModifiers");
function v9(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
a(v9, "debounce$1");
function w9(e) {
  var t = e.reduce(function(n, o) {
    var r = n[o.name];
    return n[o.name] = r ? Object.assign({}, r, o, {
      options: Object.assign({}, r.options, o.options),
      data: Object.assign({}, r.data, o.data)
    }) : o, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
a(w9, "mergeByName");
var $3 = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function P3() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(o) {
    return !(o && typeof o.getBoundingClientRect == "function");
  });
}
a(P3, "areValidElements");
function S9(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, o = n === void 0 ? [] : n, r = t.defaultOptions, i = r === void 0 ? $3 : r;
  return /* @__PURE__ */ a(function(c, d, u) {
    u === void 0 && (u = i);
    var p = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, $3, i),
      modifiersData: {},
      elements: {
        reference: c,
        popper: d
      },
      attributes: {},
      styles: {}
    }, f = [], m = !1, b = {
      state: p,
      setOptions: /* @__PURE__ */ a(function(w) {
        var T = typeof w == "function" ? w(p.options) : w;
        g(), p.options = Object.assign({}, i, p.options, T), p.scrollParents = {
          reference: nr(c) ? xi(c) : c.contextElement ? xi(c.contextElement) : [],
          popper: xi(d)
        };
        var x = x9(w9([].concat(o, p.options.modifiers)));
        return p.orderedModifiers = x.filter(function(S) {
          return S.enabled;
        }), C(), b.update();
      }, "setOptions"),
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: /* @__PURE__ */ a(function() {
        if (!m) {
          var w = p.elements, T = w.reference, x = w.popper;
          if (P3(T, x)) {
            p.rects = {
              reference: C9(T, ls(x), p.options.strategy === "fixed"),
              popper: Mc(x)
            }, p.reset = !1, p.placement = p.options.placement, p.orderedModifiers.forEach(function(v) {
              return p.modifiersData[v.name] = Object.assign({}, v.data);
            });
            for (var S = 0; S < p.orderedModifiers.length; S++) {
              if (p.reset === !0) {
                p.reset = !1, S = -1;
                continue;
              }
              var M = p.orderedModifiers[S], O = M.fn, P = M.options, E = P === void 0 ? {} : P, I = M.name;
              typeof O == "function" && (p = O({
                state: p,
                options: E,
                name: I,
                instance: b
              }) || p);
            }
          }
        }
      }, "forceUpdate"),
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: v9(function() {
        return new Promise(function(y) {
          b.forceUpdate(), y(p);
        });
      }),
      destroy: /* @__PURE__ */ a(function() {
        g(), m = !0;
      }, "destroy")
    };
    if (!P3(c, d))
      return b;
    b.setOptions(u).then(function(y) {
      !m && u.onFirstUpdate && u.onFirstUpdate(y);
    });
    function C() {
      p.orderedModifiers.forEach(function(y) {
        var w = y.name, T = y.options, x = T === void 0 ? {} : T, S = y.effect;
        if (typeof S == "function") {
          var M = S({
            state: p,
            name: w,
            instance: b,
            options: x
          }), O = /* @__PURE__ */ a(function() {
          }, "noopFn");
          f.push(M || O);
        }
      });
    }
    a(C, "runModifierEffects");
    function g() {
      f.forEach(function(y) {
        return y();
      }), f = [];
    }
    return a(g, "cleanupModifierEffects"), b;
  }, "createPopper");
}
a(S9, "popperGenerator");
var M9 = [Gf, u9, Zf, jf, c9, r9, h9, Nf, s9], T9 = /* @__PURE__ */ S9({
  defaultModifiers: M9
});
function jr(e) {
  var f;
  const {
    elementType: t,
    externalSlotProps: n,
    ownerState: o,
    skipResolvingSlotProps: r = !1,
    ...i
  } = e, l = r ? {} : I5(n, o), {
    props: c,
    internalRef: d
  } = L5({
    ...i,
    externalSlotProps: l
  }), u = xt(d, l == null ? void 0 : l.ref, (f = e.additionalProps) == null ? void 0 : f.ref);
  return R5(t, {
    ...c,
    ref: u
  }, o);
}
a(jr, "useSlotProps");
function ir(e) {
  var t;
  return parseInt(k.version, 10) >= 19 ? ((t = e == null ? void 0 : e.props) == null ? void 0 : t.ref) || null : (e == null ? void 0 : e.ref) || null;
}
a(ir, "getReactElementRef");
function k9(e) {
  return typeof e == "function" ? e() : e;
}
a(k9, "getContainer$1");
const Zi = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const {
    children: o,
    container: r,
    disablePortal: i = !1
  } = t, [l, c] = k.useState(null), d = xt(/* @__PURE__ */ k.isValidElement(o) ? ir(o) : null, n);
  if (Rn(() => {
    i || c(k9(r) || document.body);
  }, [r, i]), Rn(() => {
    if (l && !i)
      return m1(n, l), () => {
        m1(n, null);
      };
  }, [n, l, i]), i) {
    if (/* @__PURE__ */ k.isValidElement(o)) {
      const u = {
        ref: d
      };
      return /* @__PURE__ */ k.cloneElement(o, u);
    }
    return o;
  }
  return l && /* @__PURE__ */ ju.createPortal(o, l);
}, "Portal"));
process.env.NODE_ENV !== "production" && (Zi.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: s.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: s.oneOfType([Kn, s.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: s.bool
});
process.env.NODE_ENV !== "production" && (Zi.propTypes = b5(Zi.propTypes));
function O9(e) {
  return Te("MuiPopper", e);
}
a(O9, "getPopperUtilityClass");
Se("MuiPopper", ["root"]);
function E9(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
a(E9, "flipPlacement");
function ha(e) {
  return typeof e == "function" ? e() : e;
}
a(ha, "resolveAnchorEl$1");
function al(e) {
  return e.nodeType !== void 0;
}
a(al, "isHTMLElement");
function $9(e) {
  return !al(e);
}
a($9, "isVirtualElement");
const P9 = /* @__PURE__ */ a((e) => {
  const {
    classes: t
  } = e;
  return ke({
    root: ["root"]
  }, O9, t);
}, "useUtilityClasses$A"), _9 = {}, R9 = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const {
    anchorEl: o,
    children: r,
    direction: i,
    disablePortal: l,
    modifiers: c,
    open: d,
    placement: u,
    popperOptions: p,
    popperRef: f,
    slotProps: m = {},
    slots: b = {},
    TransitionProps: C,
    // @ts-ignore internal logic
    ownerState: g,
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...y
  } = t, w = k.useRef(null), T = xt(w, n), x = k.useRef(null), S = xt(x, f), M = k.useRef(S);
  Rn(() => {
    M.current = S;
  }, [S]), k.useImperativeHandle(f, () => x.current, []);
  const O = E9(u, i), [P, E] = k.useState(O), [I, v] = k.useState(ha(o));
  k.useEffect(() => {
    x.current && x.current.forceUpdate();
  }), k.useEffect(() => {
    o && v(ha(o));
  }, [o]), Rn(() => {
    if (!I || !d)
      return;
    const V = /* @__PURE__ */ a((z) => {
      E(z.placement);
    }, "handlePopperUpdate");
    if (process.env.NODE_ENV !== "production" && I && al(I) && I.nodeType === 1) {
      const z = I.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && z.top === 0 && z.left === 0 && z.right === 0 && z.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let L = [{
      name: "preventOverflow",
      options: {
        altBoundary: l
      }
    }, {
      name: "flip",
      options: {
        altBoundary: l
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: /* @__PURE__ */ a(({
        state: z
      }) => {
        V(z);
      }, "fn")
    }];
    c != null && (L = L.concat(c)), p && p.modifiers != null && (L = L.concat(p.modifiers));
    const D = T9(I, w.current, {
      placement: O,
      ...p,
      modifiers: L
    });
    return M.current(D), () => {
      D.destroy(), M.current(null);
    };
  }, [I, l, c, d, p, O]);
  const _ = {
    placement: P
  };
  C !== null && (_.TransitionProps = C);
  const R = P9(t), j = b.root ?? "div", B = jr({
    elementType: j,
    externalSlotProps: m.root,
    externalForwardedProps: y,
    additionalProps: {
      role: "tooltip",
      ref: T
    },
    ownerState: t,
    className: R.root
  });
  return /* @__PURE__ */ h.jsx(j, {
    ...B,
    children: typeof r == "function" ? r(_) : r
  });
}, "PopperTooltip")), q5 = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const {
    anchorEl: o,
    children: r,
    container: i,
    direction: l = "ltr",
    disablePortal: c = !1,
    keepMounted: d = !1,
    modifiers: u,
    open: p,
    placement: f = "bottom",
    popperOptions: m = _9,
    popperRef: b,
    style: C,
    transition: g = !1,
    slotProps: y = {},
    slots: w = {},
    ...T
  } = t, [x, S] = k.useState(!0), M = /* @__PURE__ */ a(() => {
    S(!1);
  }, "handleEnter"), O = /* @__PURE__ */ a(() => {
    S(!0);
  }, "handleExited");
  if (!d && !p && (!g || x))
    return null;
  let P;
  if (i)
    P = i;
  else if (o) {
    const v = ha(o);
    P = v && al(v) ? Qt(v).body : Qt(null).body;
  }
  const E = !p && d && (!g || x) ? "none" : void 0, I = g ? {
    in: p,
    onEnter: M,
    onExited: O
  } : void 0;
  return /* @__PURE__ */ h.jsx(Zi, {
    disablePortal: c,
    container: P,
    children: /* @__PURE__ */ h.jsx(R9, {
      anchorEl: o,
      direction: l,
      disablePortal: c,
      modifiers: u,
      ref: n,
      open: g ? !x : p,
      placement: f,
      popperOptions: m,
      popperRef: b,
      slotProps: y,
      slots: w,
      ...T,
      style: {
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: E,
        ...C
      },
      TransitionProps: I,
      children: r
    })
  });
}, "Popper"));
process.env.NODE_ENV !== "production" && (q5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: In(s.oneOfType([Kn, s.object, s.func]), (e) => {
    if (e.open) {
      const t = ha(e.anchorEl);
      if (t && al(t) && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || $9(t) && t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: s.oneOfType([s.node, s.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: s.oneOfType([Kn, s.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: s.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: s.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: s.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: s.arrayOf(s.shape({
    data: s.object,
    effect: s.func,
    enabled: s.bool,
    fn: s.func,
    name: s.any,
    options: s.object,
    phase: s.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: s.arrayOf(s.string),
    requiresIfExists: s.arrayOf(s.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: s.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: s.shape({
    modifiers: s.array,
    onFirstUpdate: s.func,
    placement: s.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: s.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: Wt,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: s.shape({
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: s.shape({
    root: s.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: s.bool
});
const I9 = ee(q5, {
  name: "MuiPopper",
  slot: "Root"
})({}), cs = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = Dr(), r = $e({
    props: t,
    name: "MuiPopper"
  }), {
    anchorEl: i,
    component: l,
    components: c,
    componentsProps: d,
    container: u,
    disablePortal: p,
    keepMounted: f,
    modifiers: m,
    open: b,
    placement: C,
    popperOptions: g,
    popperRef: y,
    transition: w,
    slots: T,
    slotProps: x,
    ...S
  } = r, M = (T == null ? void 0 : T.root) ?? (c == null ? void 0 : c.Root), O = {
    anchorEl: i,
    container: u,
    disablePortal: p,
    keepMounted: f,
    modifiers: m,
    open: b,
    placement: C,
    popperOptions: g,
    popperRef: y,
    transition: w,
    ...S
  };
  return /* @__PURE__ */ h.jsx(I9, {
    as: l,
    direction: o ? "rtl" : "ltr",
    slots: {
      root: M
    },
    slotProps: x ?? d,
    ...O,
    ref: n
  });
}, "Popper"));
process.env.NODE_ENV !== "production" && (cs.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: s.oneOfType([Kn, s.object, s.func]),
  /**
   * Popper render function or node.
   */
  children: s.oneOfType([s.node, s.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  components: s.shape({
    Root: s.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  componentsProps: s.shape({
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: s.oneOfType([Kn, s.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: s.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: s.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: s.arrayOf(s.shape({
    data: s.object,
    effect: s.func,
    enabled: s.bool,
    fn: s.func,
    name: s.any,
    options: s.object,
    phase: s.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: s.arrayOf(s.string),
    requiresIfExists: s.arrayOf(s.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: s.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: s.shape({
    modifiers: s.array,
    onFirstUpdate: s.func,
    placement: s.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: s.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: Wt,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: s.shape({
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: s.shape({
    root: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: s.bool
});
function j9(e) {
  return Te("MuiListSubheader", e);
}
a(j9, "getListSubheaderUtilityClass");
Se("MuiListSubheader", ["root", "colorPrimary", "colorInherit", "gutters", "inset", "sticky"]);
const L9 = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    color: n,
    disableGutters: o,
    inset: r,
    disableSticky: i
  } = e, l = {
    root: ["root", n !== "default" && `color${G(n)}`, !o && "gutters", r && "inset", !i && "sticky"]
  };
  return ke(l, j9, t);
}, "useUtilityClasses$z"), V9 = ee("li", {
  name: "MuiListSubheader",
  slot: "Root",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "default" && t[`color${G(n.color)}`], !n.disableGutters && t.gutters, n.inset && t.inset, !n.disableSticky && t.sticky];
  }, "overridesResolver")
})(we(({
  theme: e
}) => ({
  boxSizing: "border-box",
  lineHeight: "48px",
  listStyle: "none",
  color: (e.vars || e).palette.text.secondary,
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(14),
  variants: [{
    props: {
      color: "primary"
    },
    style: {
      color: (e.vars || e).palette.primary.main
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => !t.disableGutters, "props"),
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.inset, "props"),
    style: {
      paddingLeft: 72
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => !t.disableSticky, "props"),
    style: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      backgroundColor: (e.vars || e).palette.background.paper
    }
  }]
}))), ga = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiListSubheader"
  }), {
    className: r,
    color: i = "default",
    component: l = "li",
    disableGutters: c = !1,
    disableSticky: d = !1,
    inset: u = !1,
    ...p
  } = o, f = {
    ...o,
    color: i,
    component: l,
    disableGutters: c,
    disableSticky: d,
    inset: u
  }, m = L9(f);
  return /* @__PURE__ */ h.jsx(V9, {
    as: l,
    className: le(m.root, r),
    ref: n,
    ownerState: f,
    ...p
  });
}, "ListSubheader"));
ga && (ga.muiSkipListHighlight = !0);
process.env.NODE_ENV !== "production" && (ga.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'default'
   */
  color: s.oneOf(["default", "inherit", "primary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, the List Subheader will not have gutters.
   * @default false
   */
  disableGutters: s.bool,
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   * @default false
   */
  disableSticky: s.bool,
  /**
   * If `true`, the List Subheader is indented.
   * @default false
   */
  inset: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
const A9 = en(/* @__PURE__ */ h.jsx("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function B9(e) {
  return Te("MuiChip", e);
}
a(B9, "getChipUtilityClass");
const Ae = Se("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorDefault", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]), H9 = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    disabled: n,
    size: o,
    color: r,
    iconColor: i,
    onDelete: l,
    clickable: c,
    variant: d
  } = e, u = {
    root: ["root", d, n && "disabled", `size${G(o)}`, `color${G(r)}`, c && "clickable", c && `clickableColor${G(r)}`, l && "deletable", l && `deletableColor${G(r)}`, `${d}${G(r)}`],
    label: ["label", `label${G(o)}`],
    avatar: ["avatar", `avatar${G(o)}`, `avatarColor${G(r)}`],
    icon: ["icon", `icon${G(o)}`, `iconColor${G(i)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${G(o)}`, `deleteIconColor${G(r)}`, `deleteIcon${G(d)}Color${G(r)}`]
  };
  return ke(u, B9, t);
}, "useUtilityClasses$y"), D9 = ee("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e, {
      color: o,
      iconColor: r,
      clickable: i,
      onDelete: l,
      size: c,
      variant: d
    } = n;
    return [{
      [`& .${Ae.avatar}`]: t.avatar
    }, {
      [`& .${Ae.avatar}`]: t[`avatar${G(c)}`]
    }, {
      [`& .${Ae.avatar}`]: t[`avatarColor${G(o)}`]
    }, {
      [`& .${Ae.icon}`]: t.icon
    }, {
      [`& .${Ae.icon}`]: t[`icon${G(c)}`]
    }, {
      [`& .${Ae.icon}`]: t[`iconColor${G(r)}`]
    }, {
      [`& .${Ae.deleteIcon}`]: t.deleteIcon
    }, {
      [`& .${Ae.deleteIcon}`]: t[`deleteIcon${G(c)}`]
    }, {
      [`& .${Ae.deleteIcon}`]: t[`deleteIconColor${G(o)}`]
    }, {
      [`& .${Ae.deleteIcon}`]: t[`deleteIcon${G(d)}Color${G(o)}`]
    }, t.root, t[`size${G(c)}`], t[`color${G(o)}`], i && t.clickable, i && o !== "default" && t[`clickableColor${G(o)})`], l && t.deletable, l && o !== "default" && t[`deletableColor${G(o)}`], t[d], t[`${d}${G(o)}`]];
  }, "overridesResolver")
})(we(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[700] : e.palette.grey[300];
  return {
    maxWidth: "100%",
    fontFamily: e.typography.fontFamily,
    fontSize: e.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    color: (e.vars || e).palette.text.primary,
    backgroundColor: (e.vars || e).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: e.transitions.create(["background-color", "box-shadow"]),
    // reset cursor explicitly in case ButtonBase is used
    cursor: "unset",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${Ae.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${Ae.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: e.vars ? e.vars.palette.Chip.defaultAvatarColor : t,
      fontSize: e.typography.pxToRem(12)
    },
    [`& .${Ae.avatarColorPrimary}`]: {
      color: (e.vars || e).palette.primary.contrastText,
      backgroundColor: (e.vars || e).palette.primary.dark
    },
    [`& .${Ae.avatarColorSecondary}`]: {
      color: (e.vars || e).palette.secondary.contrastText,
      backgroundColor: (e.vars || e).palette.secondary.dark
    },
    [`& .${Ae.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: e.typography.pxToRem(10)
    },
    [`& .${Ae.icon}`]: {
      marginLeft: 5,
      marginRight: -6
    },
    [`& .${Ae.deleteIcon}`]: {
      WebkitTapHighlightColor: "transparent",
      color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.26)` : De(e.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : De(e.palette.text.primary, 0.4)
      }
    },
    variants: [{
      props: {
        size: "small"
      },
      style: {
        height: 24,
        [`& .${Ae.icon}`]: {
          fontSize: 18,
          marginLeft: 4,
          marginRight: -4
        },
        [`& .${Ae.deleteIcon}`]: {
          fontSize: 16,
          marginRight: 4,
          marginLeft: -4
        }
      }
    }, ...Object.entries(e.palette).filter(bt(["contrastText"])).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        backgroundColor: (e.vars || e).palette[n].main,
        color: (e.vars || e).palette[n].contrastText,
        [`& .${Ae.deleteIcon}`]: {
          color: e.vars ? `rgba(${e.vars.palette[n].contrastTextChannel} / 0.7)` : De(e.palette[n].contrastText, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[n].contrastText
          }
        }
      }
    })), {
      props: /* @__PURE__ */ a((n) => n.iconColor === n.color, "props"),
      style: {
        [`& .${Ae.icon}`]: {
          color: e.vars ? e.vars.palette.Chip.defaultIconColor : t
        }
      }
    }, {
      props: /* @__PURE__ */ a((n) => n.iconColor === n.color && n.color !== "default", "props"),
      style: {
        [`& .${Ae.icon}`]: {
          color: "inherit"
        }
      }
    }, {
      props: {
        onDelete: !0
      },
      style: {
        [`&.${Ae.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : De(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
        }
      }
    }, ...Object.entries(e.palette).filter(bt(["dark"])).map(([n]) => ({
      props: {
        color: n,
        onDelete: !0
      },
      style: {
        [`&.${Ae.focusVisible}`]: {
          background: (e.vars || e).palette[n].dark
        }
      }
    })), {
      props: {
        clickable: !0
      },
      style: {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : De(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
        },
        [`&.${Ae.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : De(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
        },
        "&:active": {
          boxShadow: (e.vars || e).shadows[1]
        }
      }
    }, ...Object.entries(e.palette).filter(bt(["dark"])).map(([n]) => ({
      props: {
        color: n,
        clickable: !0
      },
      style: {
        [`&:hover, &.${Ae.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette[n].dark
        }
      }
    })), {
      props: {
        variant: "outlined"
      },
      style: {
        backgroundColor: "transparent",
        border: e.vars ? `1px solid ${e.vars.palette.Chip.defaultBorder}` : `1px solid ${e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[700]}`,
        [`&.${Ae.clickable}:hover`]: {
          backgroundColor: (e.vars || e).palette.action.hover
        },
        [`&.${Ae.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette.action.focus
        },
        [`& .${Ae.avatar}`]: {
          marginLeft: 4
        },
        [`& .${Ae.avatarSmall}`]: {
          marginLeft: 2
        },
        [`& .${Ae.icon}`]: {
          marginLeft: 4
        },
        [`& .${Ae.iconSmall}`]: {
          marginLeft: 2
        },
        [`& .${Ae.deleteIcon}`]: {
          marginRight: 5
        },
        [`& .${Ae.deleteIconSmall}`]: {
          marginRight: 3
        }
      }
    }, ...Object.entries(e.palette).filter(bt()).map(([n]) => ({
      props: {
        variant: "outlined",
        color: n
      },
      style: {
        color: (e.vars || e).palette[n].main,
        border: `1px solid ${e.vars ? `rgba(${e.vars.palette[n].mainChannel} / 0.7)` : De(e.palette[n].main, 0.7)}`,
        [`&.${Ae.clickable}:hover`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[n].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : De(e.palette[n].main, e.palette.action.hoverOpacity)
        },
        [`&.${Ae.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[n].mainChannel} / ${e.vars.palette.action.focusOpacity})` : De(e.palette[n].main, e.palette.action.focusOpacity)
        },
        [`& .${Ae.deleteIcon}`]: {
          color: e.vars ? `rgba(${e.vars.palette[n].mainChannel} / 0.7)` : De(e.palette[n].main, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[n].main
          }
        }
      }
    }))]
  };
})), N9 = ee("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e, {
      size: o
    } = n;
    return [t.label, t[`label${G(o)}`]];
  }, "overridesResolver")
})({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      variant: "outlined"
    },
    style: {
      paddingLeft: 11,
      paddingRight: 11
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      paddingLeft: 8,
      paddingRight: 8
    }
  }, {
    props: {
      size: "small",
      variant: "outlined"
    },
    style: {
      paddingLeft: 7,
      paddingRight: 7
    }
  }]
});
function _3(e) {
  return e.key === "Backspace" || e.key === "Delete";
}
a(_3, "isDeleteKeyboardEvent");
const jo = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiChip"
  }), {
    avatar: r,
    className: i,
    clickable: l,
    color: c = "default",
    component: d,
    deleteIcon: u,
    disabled: p = !1,
    icon: f,
    label: m,
    onClick: b,
    onDelete: C,
    onKeyDown: g,
    onKeyUp: y,
    size: w = "medium",
    variant: T = "filled",
    tabIndex: x,
    skipFocusWhenDisabled: S = !1,
    // TODO v6: Rename to `focusableWhenDisabled`.
    ...M
  } = o, O = k.useRef(null), P = xt(O, n), E = /* @__PURE__ */ a((H) => {
    H.stopPropagation(), C && C(H);
  }, "handleDeleteIconClick"), I = /* @__PURE__ */ a((H) => {
    H.currentTarget === H.target && _3(H) && H.preventDefault(), g && g(H);
  }, "handleKeyDown"), v = /* @__PURE__ */ a((H) => {
    H.currentTarget === H.target && C && _3(H) && C(H), y && y(H);
  }, "handleKeyUp"), _ = l !== !1 && b ? !0 : l, R = _ || C ? lo : d || "div", j = {
    ...o,
    component: R,
    disabled: p,
    size: w,
    color: c,
    iconColor: /* @__PURE__ */ k.isValidElement(f) && f.props.color || c,
    onDelete: !!C,
    clickable: _,
    variant: T
  }, B = H9(j), V = R === lo ? {
    component: d || "div",
    focusVisibleClassName: B.focusVisible,
    ...C && {
      disableRipple: !0
    }
  } : {};
  let L = null;
  C && (L = u && /* @__PURE__ */ k.isValidElement(u) ? /* @__PURE__ */ k.cloneElement(u, {
    className: le(u.props.className, B.deleteIcon),
    onClick: E
  }) : /* @__PURE__ */ h.jsx(A9, {
    className: B.deleteIcon,
    onClick: E
  }));
  let D = null;
  r && /* @__PURE__ */ k.isValidElement(r) && (D = /* @__PURE__ */ k.cloneElement(r, {
    className: le(B.avatar, r.props.className)
  }));
  let z = null;
  return f && /* @__PURE__ */ k.isValidElement(f) && (z = /* @__PURE__ */ k.cloneElement(f, {
    className: le(B.icon, f.props.className)
  })), process.env.NODE_ENV !== "production" && D && z && console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one."), /* @__PURE__ */ h.jsxs(D9, {
    as: R,
    className: le(B.root, i),
    disabled: _ && p ? !0 : void 0,
    onClick: b,
    onKeyDown: I,
    onKeyUp: v,
    ref: P,
    tabIndex: S && p ? -1 : x,
    ownerState: j,
    ...V,
    ...M,
    children: [D || z, /* @__PURE__ */ h.jsx(N9, {
      className: B.label,
      ownerState: j,
      children: m
    }), L]
  });
}, "Chip"));
process.env.NODE_ENV !== "production" && (jo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Avatar element to display.
   */
  avatar: s.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: k5,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: s.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: s.oneOfType([s.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: s.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * Icon element.
   */
  icon: s.element,
  /**
   * The content of the component.
   */
  label: s.node,
  /**
   * @ignore
   */
  onClick: s.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: s.func,
  /**
   * @ignore
   */
  onKeyDown: s.func,
  /**
   * @ignore
   */
  onKeyUp: s.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["medium", "small"]), s.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * @ignore
   */
  tabIndex: s.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: s.oneOfType([s.oneOf(["filled", "outlined"]), s.string])
});
function Ts(e) {
  return parseInt(e, 10) || 0;
}
a(Ts, "getStyleValue");
const z9 = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function F9(e) {
  for (const t in e)
    return !1;
  return !0;
}
a(F9, "isObjectEmpty");
function R3(e) {
  return F9(e) || e.outerHeightStyle === 0 && !e.overflowing;
}
a(R3, "isEmpty$1");
const K5 = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const {
    onChange: o,
    maxRows: r,
    minRows: i = 1,
    style: l,
    value: c,
    ...d
  } = t, {
    current: u
  } = k.useRef(c != null), p = k.useRef(null), f = xt(n, p), m = k.useRef(null), b = k.useRef(null), C = k.useCallback(() => {
    const x = p.current, S = b.current;
    if (!x || !S)
      return;
    const O = dn(x).getComputedStyle(x);
    if (O.width === "0px")
      return {
        outerHeightStyle: 0,
        overflowing: !1
      };
    S.style.width = O.width, S.value = x.value || t.placeholder || "x", S.value.slice(-1) === `
` && (S.value += " ");
    const P = O.boxSizing, E = Ts(O.paddingBottom) + Ts(O.paddingTop), I = Ts(O.borderBottomWidth) + Ts(O.borderTopWidth), v = S.scrollHeight;
    S.value = "x";
    const _ = S.scrollHeight;
    let R = v;
    i && (R = Math.max(Number(i) * _, R)), r && (R = Math.min(Number(r) * _, R)), R = Math.max(R, _);
    const j = R + (P === "border-box" ? E + I : 0), B = Math.abs(R - v) <= 1;
    return {
      outerHeightStyle: j,
      overflowing: B
    };
  }, [r, i, t.placeholder]), g = Dt(() => {
    const x = p.current, S = C();
    if (!x || !S || R3(S))
      return !1;
    const M = S.outerHeightStyle;
    return m.current != null && m.current !== M;
  }), y = k.useCallback(() => {
    const x = p.current, S = C();
    if (!x || !S || R3(S))
      return;
    const M = S.outerHeightStyle;
    m.current !== M && (m.current = M, x.style.height = `${M}px`), x.style.overflow = S.overflowing ? "hidden" : "";
  }, [C]), w = k.useRef(-1);
  Rn(() => {
    const x = ss(y), S = p == null ? void 0 : p.current;
    if (!S)
      return;
    const M = dn(S);
    M.addEventListener("resize", x);
    let O;
    return typeof ResizeObserver < "u" && (O = new ResizeObserver(() => {
      g() && (O.unobserve(S), cancelAnimationFrame(w.current), y(), w.current = requestAnimationFrame(() => {
        O.observe(S);
      }));
    }), O.observe(S)), () => {
      x.clear(), cancelAnimationFrame(w.current), M.removeEventListener("resize", x), O && O.disconnect();
    };
  }, [C, y, g]), Rn(() => {
    y();
  });
  const T = /* @__PURE__ */ a((x) => {
    u || y();
    const S = x.target, M = S.value.length, O = S.value.endsWith(`
`), P = S.selectionStart === M;
    O && P && S.setSelectionRange(M, M), o && o(x);
  }, "handleChange");
  return /* @__PURE__ */ h.jsxs(k.Fragment, {
    children: [/* @__PURE__ */ h.jsx("textarea", {
      value: c,
      onChange: T,
      ref: f,
      rows: i,
      style: l,
      ...d
    }), /* @__PURE__ */ h.jsx("textarea", {
      "aria-hidden": !0,
      className: t.className,
      readOnly: !0,
      ref: b,
      tabIndex: -1,
      style: {
        ...z9.shadow,
        ...l,
        paddingTop: 0,
        paddingBottom: 0
      }
    })]
  });
}, "TextareaAutosize"));
process.env.NODE_ENV !== "production" && (K5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: s.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: s.oneOfType([s.number, s.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: s.oneOfType([s.number, s.string]),
  /**
   * @ignore
   */
  onChange: s.func,
  /**
   * @ignore
   */
  placeholder: s.string,
  /**
   * @ignore
   */
  style: s.object,
  /**
   * @ignore
   */
  value: s.oneOfType([s.arrayOf(s.string), s.number, s.string])
});
function k1(e) {
  return typeof e == "string";
}
a(k1, "isHostComponent");
function Lo({
  props: e,
  states: t,
  muiFormControl: n
}) {
  return t.reduce((o, r) => (o[r] = e[r], n && typeof e[r] > "u" && (o[r] = n[r]), o), {});
}
a(Lo, "formControlState");
const ds = /* @__PURE__ */ k.createContext(void 0);
process.env.NODE_ENV !== "production" && (ds.displayName = "FormControlContext");
function jn() {
  return k.useContext(ds);
}
a(jn, "useFormControl");
function I3(e) {
  return e != null && !(Array.isArray(e) && e.length === 0);
}
a(I3, "hasValue");
function ma(e, t = !1) {
  return e && (I3(e.value) && e.value !== "" || t && I3(e.defaultValue) && e.defaultValue !== "");
}
a(ma, "isFilled");
function W9(e) {
  return e.startAdornment;
}
a(W9, "isAdornedStart");
function Z9(e) {
  return Te("MuiInputBase", e);
}
a(Z9, "getInputBaseUtilityClass");
const rn = Se("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]);
var j3;
const ll = /* @__PURE__ */ a((e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.formControl && t.formControl, n.startAdornment && t.adornedStart, n.endAdornment && t.adornedEnd, n.error && t.error, n.size === "small" && t.sizeSmall, n.multiline && t.multiline, n.color && t[`color${G(n.color)}`], n.fullWidth && t.fullWidth, n.hiddenLabel && t.hiddenLabel];
}, "rootOverridesResolver"), cl = /* @__PURE__ */ a((e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.input, n.size === "small" && t.inputSizeSmall, n.multiline && t.inputMultiline, n.type === "search" && t.inputTypeSearch, n.startAdornment && t.inputAdornedStart, n.endAdornment && t.inputAdornedEnd, n.hiddenLabel && t.inputHiddenLabel];
}, "inputOverridesResolver"), U9 = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    color: n,
    disabled: o,
    error: r,
    endAdornment: i,
    focused: l,
    formControl: c,
    fullWidth: d,
    hiddenLabel: u,
    multiline: p,
    readOnly: f,
    size: m,
    startAdornment: b,
    type: C
  } = e, g = {
    root: ["root", `color${G(n)}`, o && "disabled", r && "error", d && "fullWidth", l && "focused", c && "formControl", m && m !== "medium" && `size${G(m)}`, p && "multiline", b && "adornedStart", i && "adornedEnd", u && "hiddenLabel", f && "readOnly"],
    input: ["input", o && "disabled", C === "search" && "inputTypeSearch", p && "inputMultiline", m === "small" && "inputSizeSmall", u && "inputHiddenLabel", b && "inputAdornedStart", i && "inputAdornedEnd", f && "readOnly"]
  };
  return ke(g, Z9, t);
}, "useUtilityClasses$x"), dl = ee("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: ll
})(we(({
  theme: e
}) => ({
  ...e.typography.body1,
  color: (e.vars || e).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${rn.disabled}`]: {
    color: (e.vars || e).palette.text.disabled,
    cursor: "default"
  },
  variants: [{
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.multiline, "props"),
    style: {
      padding: "4px 0 5px"
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t,
      size: n
    }) => t.multiline && n === "small", "props"),
    style: {
      paddingTop: 1
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.fullWidth, "props"),
    style: {
      width: "100%"
    }
  }]
}))), ul = ee("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: cl
})(we(({
  theme: e
}) => {
  const t = e.palette.mode === "light", n = {
    color: "currentColor",
    ...e.vars ? {
      opacity: e.vars.opacity.inputPlaceholder
    } : {
      opacity: t ? 0.42 : 0.5
    },
    transition: e.transitions.create("opacity", {
      duration: e.transitions.duration.shorter
    })
  }, o = {
    opacity: "0 !important"
  }, r = e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: t ? 0.42 : 0.5
  };
  return {
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    "&::-webkit-input-placeholder": n,
    "&::-moz-placeholder": n,
    // Firefox 19+
    "&::-ms-input-placeholder": n,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${rn.formControl} &`]: {
      "&::-webkit-input-placeholder": o,
      "&::-moz-placeholder": o,
      // Firefox 19+
      "&::-ms-input-placeholder": o,
      // Edge
      "&:focus::-webkit-input-placeholder": r,
      "&:focus::-moz-placeholder": r,
      // Firefox 19+
      "&:focus::-ms-input-placeholder": r
      // Edge
    },
    [`&.${rn.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (e.vars || e).palette.text.disabled
      // Fix opacity Safari bug
    },
    variants: [{
      props: /* @__PURE__ */ a(({
        ownerState: i
      }) => !i.disableInjectingGlobalStyles, "props"),
      style: {
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&:-webkit-autofill": {
          animationDuration: "5000s",
          animationName: "mui-auto-fill"
        }
      }
    }, {
      props: {
        size: "small"
      },
      style: {
        paddingTop: 1
      }
    }, {
      props: /* @__PURE__ */ a(({
        ownerState: i
      }) => i.multiline, "props"),
      style: {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
      }
    }, {
      props: {
        type: "search"
      },
      style: {
        MozAppearance: "textfield"
        // Improve type search style.
      }
    }]
  };
})), L3 = Xp({
  "@keyframes mui-auto-fill": {
    from: {
      display: "block"
    }
  },
  "@keyframes mui-auto-fill-cancel": {
    from: {
      display: "block"
    }
  }
}), pl = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiInputBase"
  }), {
    "aria-describedby": r,
    autoComplete: i,
    autoFocus: l,
    className: c,
    color: d,
    components: u = {},
    componentsProps: p = {},
    defaultValue: f,
    disabled: m,
    disableInjectingGlobalStyles: b,
    endAdornment: C,
    error: g,
    fullWidth: y = !1,
    id: w,
    inputComponent: T = "input",
    inputProps: x = {},
    inputRef: S,
    margin: M,
    maxRows: O,
    minRows: P,
    multiline: E = !1,
    name: I,
    onBlur: v,
    onChange: _,
    onClick: R,
    onFocus: j,
    onKeyDown: B,
    onKeyUp: V,
    placeholder: L,
    readOnly: D,
    renderSuffix: z,
    rows: H,
    size: $,
    slotProps: A = {},
    slots: U = {},
    startAdornment: K,
    type: J = "text",
    value: F,
    ...N
  } = o, te = x.value != null ? x.value : F, {
    current: oe
  } = k.useRef(te != null), ne = k.useRef(), X = k.useCallback((ce) => {
    process.env.NODE_ENV !== "production" && ce && ce.nodeName !== "INPUT" && !ce.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), se = xt(ne, S, x.ref, X), [Y, fe] = k.useState(!1), be = jn();
  process.env.NODE_ENV !== "production" && k.useEffect(() => {
    if (be)
      return be.registerEffect();
  }, [be]);
  const Re = Lo({
    props: o,
    muiFormControl: be,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  Re.focused = be ? be.focused : Y, k.useEffect(() => {
    !be && m && Y && (fe(!1), v && v());
  }, [be, m, Y, v]);
  const Oe = be && be.onFilled, Be = be && be.onEmpty, re = k.useCallback((ce) => {
    ma(ce) ? Oe && Oe() : Be && Be();
  }, [Oe, Be]);
  Rn(() => {
    oe && re({
      value: te
    });
  }, [te, re, oe]);
  const Fe = /* @__PURE__ */ a((ce) => {
    j && j(ce), x.onFocus && x.onFocus(ce), be && be.onFocus ? be.onFocus(ce) : fe(!0);
  }, "handleFocus"), Ce = /* @__PURE__ */ a((ce) => {
    v && v(ce), x.onBlur && x.onBlur(ce), be && be.onBlur ? be.onBlur(ce) : fe(!1);
  }, "handleBlur"), Pe = /* @__PURE__ */ a((ce, ...nt) => {
    if (!oe) {
      const vt = ce.target || ne.current;
      if (vt == null)
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : qn(1));
      re({
        value: vt.value
      });
    }
    x.onChange && x.onChange(ce, ...nt), _ && _(ce, ...nt);
  }, "handleChange");
  k.useEffect(() => {
    re(ne.current);
  }, []);
  const de = /* @__PURE__ */ a((ce) => {
    ne.current && ce.currentTarget === ce.target && ne.current.focus(), R && R(ce);
  }, "handleClick");
  let pt = T, ze = x;
  E && pt === "input" && (H ? (process.env.NODE_ENV !== "production" && (P || O) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), ze = {
    type: void 0,
    minRows: H,
    maxRows: H,
    ...ze
  }) : ze = {
    type: void 0,
    maxRows: O,
    minRows: P,
    ...ze
  }, pt = K5);
  const ut = /* @__PURE__ */ a((ce) => {
    re(ce.animationName === "mui-auto-fill-cancel" ? ne.current : {
      value: "x"
    });
  }, "handleAutoFill");
  k.useEffect(() => {
    be && be.setAdornedStart(!!K);
  }, [be, K]);
  const Mt = {
    ...o,
    color: Re.color || "primary",
    disabled: Re.disabled,
    endAdornment: C,
    error: Re.error,
    focused: Re.focused,
    formControl: be,
    fullWidth: y,
    hiddenLabel: Re.hiddenLabel,
    multiline: E,
    size: Re.size,
    startAdornment: K,
    type: J
  }, At = U9(Mt), ft = U.root || u.Root || dl, Tt = A.root || p.root || {}, lt = U.input || u.Input || ul;
  return ze = {
    ...ze,
    ...A.input ?? p.input
  }, /* @__PURE__ */ h.jsxs(k.Fragment, {
    children: [!b && typeof L3 == "function" && // For Emotion/Styled-components, InputGlobalStyles will be a function
    // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
    (j3 || (j3 = /* @__PURE__ */ h.jsx(L3, {}))), /* @__PURE__ */ h.jsxs(ft, {
      ...Tt,
      ref: n,
      onClick: de,
      ...N,
      ...!k1(ft) && {
        ownerState: {
          ...Mt,
          ...Tt.ownerState
        }
      },
      className: le(At.root, Tt.className, c, D && "MuiInputBase-readOnly"),
      children: [K, /* @__PURE__ */ h.jsx(ds.Provider, {
        value: null,
        children: /* @__PURE__ */ h.jsx(lt, {
          "aria-invalid": Re.error,
          "aria-describedby": r,
          autoComplete: i,
          autoFocus: l,
          defaultValue: f,
          disabled: Re.disabled,
          id: w,
          onAnimationStart: ut,
          name: I,
          placeholder: L,
          readOnly: D,
          required: Re.required,
          rows: H,
          value: te,
          onKeyDown: B,
          onKeyUp: V,
          type: J,
          ...ze,
          ...!k1(lt) && {
            as: pt,
            ownerState: {
              ...Mt,
              ...ze.ownerState
            }
          },
          ref: se,
          className: le(At.input, ze.className, D && "MuiInputBase-readOnly"),
          onBlur: Ce,
          onChange: Pe,
          onFocus: Fe
        })
      }), C, z ? z({
        ...Re,
        startAdornment: K
      }) : null]
    })]
  });
}, "InputBase"));
process.env.NODE_ENV !== "production" && (pl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": s.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: s.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: s.shape({
    Input: s.elementType,
    Root: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: s.shape({
    input: s.object,
    root: s.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: s.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: s.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: s.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: s.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * The id of the `input` element.
   */
  id: s.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: rl,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Wt,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: s.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: s.oneOfType([s.number, s.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: s.oneOfType([s.number, s.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: s.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: s.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: s.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: s.func,
  /**
   * @ignore
   */
  onClick: s.func,
  /**
   * @ignore
   */
  onFocus: s.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: s.func,
  /**
   * @ignore
   */
  onKeyDown: s.func,
  /**
   * @ignore
   */
  onKeyUp: s.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: s.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: s.bool,
  /**
   * @ignore
   */
  renderSuffix: s.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: s.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: s.oneOfType([s.number, s.string]),
  /**
   * The size of the component.
   */
  size: s.oneOfType([s.oneOf(["medium", "small"]), s.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: s.shape({
    input: s.object,
    root: s.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: s.shape({
    input: s.elementType,
    root: s.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: s.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
   * @default 'text'
   */
  type: s.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: s.any
});
function G9(e) {
  return Te("MuiInput", e);
}
a(G9, "getInputUtilityClass");
const yo = {
  ...rn,
  ...Se("MuiInput", ["root", "underline", "input"])
};
function Y9(e) {
  return Te("MuiOutlinedInput", e);
}
a(Y9, "getOutlinedInputUtilityClass");
const gn = {
  ...rn,
  ...Se("MuiOutlinedInput", ["root", "notchedOutline", "input"])
};
function q9(e) {
  return Te("MuiFilledInput", e);
}
a(q9, "getFilledInputUtilityClass");
const sn = {
  ...rn,
  ...Se("MuiFilledInput", ["root", "underline", "input", "adornedStart", "adornedEnd", "sizeSmall", "multiline", "hiddenLabel"])
}, X5 = en(/* @__PURE__ */ h.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
function K9(e) {
  return Te("MuiAutocomplete", e);
}
a(K9, "getAutocompleteUtilityClass");
const Ie = Se("MuiAutocomplete", ["root", "expanded", "fullWidth", "focused", "focusVisible", "tag", "tagSizeSmall", "tagSizeMedium", "hasPopupIcon", "hasClearIcon", "inputRoot", "input", "inputFocused", "endAdornment", "clearIndicator", "popupIndicator", "popupIndicatorOpen", "popper", "popperDisablePortal", "paper", "listbox", "loading", "noOptions", "option", "groupLabel", "groupUl"]);
var V3, A3;
const X9 = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    disablePortal: n,
    expanded: o,
    focused: r,
    fullWidth: i,
    hasClearIcon: l,
    hasPopupIcon: c,
    inputFocused: d,
    popupOpen: u,
    size: p
  } = e, f = {
    root: ["root", o && "expanded", r && "focused", i && "fullWidth", l && "hasClearIcon", c && "hasPopupIcon"],
    inputRoot: ["inputRoot"],
    input: ["input", d && "inputFocused"],
    tag: ["tag", `tagSize${G(p)}`],
    endAdornment: ["endAdornment"],
    clearIndicator: ["clearIndicator"],
    popupIndicator: ["popupIndicator", u && "popupIndicatorOpen"],
    popper: ["popper", n && "popperDisablePortal"],
    paper: ["paper"],
    listbox: ["listbox"],
    loading: ["loading"],
    noOptions: ["noOptions"],
    option: ["option"],
    groupLabel: ["groupLabel"],
    groupUl: ["groupUl"]
  };
  return ke(f, K9, t);
}, "useUtilityClasses$w"), J9 = ee("div", {
  name: "MuiAutocomplete",
  slot: "Root",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e, {
      fullWidth: o,
      hasClearIcon: r,
      hasPopupIcon: i,
      inputFocused: l,
      size: c
    } = n;
    return [{
      [`& .${Ie.tag}`]: t.tag
    }, {
      [`& .${Ie.tag}`]: t[`tagSize${G(c)}`]
    }, {
      [`& .${Ie.inputRoot}`]: t.inputRoot
    }, {
      [`& .${Ie.input}`]: t.input
    }, {
      [`& .${Ie.input}`]: l && t.inputFocused
    }, t.root, o && t.fullWidth, i && t.hasPopupIcon, r && t.hasClearIcon];
  }, "overridesResolver")
})({
  [`&.${Ie.focused} .${Ie.clearIndicator}`]: {
    visibility: "visible"
  },
  /* Avoid double tap issue on iOS */
  "@media (pointer: fine)": {
    [`&:hover .${Ie.clearIndicator}`]: {
      visibility: "visible"
    }
  },
  [`& .${Ie.tag}`]: {
    margin: 3,
    maxWidth: "calc(100% - 6px)"
  },
  [`& .${Ie.inputRoot}`]: {
    [`.${Ie.hasPopupIcon}&, .${Ie.hasClearIcon}&`]: {
      paddingRight: 30
    },
    [`.${Ie.hasPopupIcon}.${Ie.hasClearIcon}&`]: {
      paddingRight: 56
    },
    [`& .${Ie.input}`]: {
      width: 0,
      minWidth: 30
    }
  },
  [`& .${yo.root}`]: {
    paddingBottom: 1,
    "& .MuiInput-input": {
      padding: "4px 4px 4px 0px"
    }
  },
  [`& .${yo.root}.${rn.sizeSmall}`]: {
    [`& .${yo.input}`]: {
      padding: "2px 4px 3px 0"
    }
  },
  [`& .${gn.root}`]: {
    padding: 9,
    [`.${Ie.hasPopupIcon}&, .${Ie.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${Ie.hasPopupIcon}.${Ie.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${Ie.input}`]: {
      padding: "7.5px 4px 7.5px 5px"
    },
    [`& .${Ie.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${gn.root}.${rn.sizeSmall}`]: {
    // Don't specify paddingRight, as it overrides the default value set when there is only
    // one of the popup or clear icon as the specificity is equal so the latter one wins
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    [`& .${Ie.input}`]: {
      padding: "2.5px 4px 2.5px 8px"
    }
  },
  [`& .${sn.root}`]: {
    paddingTop: 19,
    paddingLeft: 8,
    [`.${Ie.hasPopupIcon}&, .${Ie.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${Ie.hasPopupIcon}.${Ie.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${sn.input}`]: {
      padding: "7px 4px"
    },
    [`& .${Ie.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${sn.root}.${rn.sizeSmall}`]: {
    paddingBottom: 1,
    [`& .${sn.input}`]: {
      padding: "2.5px 4px"
    }
  },
  [`& .${rn.hiddenLabel}`]: {
    paddingTop: 8
  },
  [`& .${sn.root}.${rn.hiddenLabel}`]: {
    paddingTop: 0,
    paddingBottom: 0,
    [`& .${Ie.input}`]: {
      paddingTop: 16,
      paddingBottom: 17
    }
  },
  [`& .${sn.root}.${rn.hiddenLabel}.${rn.sizeSmall}`]: {
    [`& .${Ie.input}`]: {
      paddingTop: 8,
      paddingBottom: 9
    }
  },
  [`& .${Ie.input}`]: {
    flexGrow: 1,
    textOverflow: "ellipsis",
    opacity: 0
  },
  variants: [{
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      [`& .${Ie.tag}`]: {
        margin: 2,
        maxWidth: "calc(100% - 4px)"
      }
    }
  }, {
    props: {
      inputFocused: !0
    },
    style: {
      [`& .${Ie.input}`]: {
        opacity: 1
      }
    }
  }, {
    props: {
      multiple: !0
    },
    style: {
      [`& .${Ie.inputRoot}`]: {
        flexWrap: "wrap"
      }
    }
  }]
}), Q9 = ee("div", {
  name: "MuiAutocomplete",
  slot: "EndAdornment"
})({
  // We use a position absolute to support wrapping tags.
  position: "absolute",
  right: 0,
  top: "50%",
  transform: "translate(0, -50%)"
}), eh = ee(po, {
  name: "MuiAutocomplete",
  slot: "ClearIndicator"
})({
  marginRight: -2,
  padding: 4,
  visibility: "hidden"
}), th = ee(po, {
  name: "MuiAutocomplete",
  slot: "PopupIndicator",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.popupIndicator, n.popupOpen && t.popupIndicatorOpen];
  }, "overridesResolver")
})({
  padding: 2,
  marginRight: -2,
  variants: [{
    props: {
      popupOpen: !0
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
}), nh = ee(cs, {
  name: "MuiAutocomplete",
  slot: "Popper",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${Ie.option}`]: t.option
    }, t.popper, n.disablePortal && t.popperDisablePortal];
  }, "overridesResolver")
})(we(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.modal,
  variants: [{
    props: {
      disablePortal: !0
    },
    style: {
      position: "absolute"
    }
  }]
}))), oh = ee(Ro, {
  name: "MuiAutocomplete",
  slot: "Paper"
})(we(({
  theme: e
}) => ({
  ...e.typography.body1,
  overflow: "auto"
}))), rh = ee("div", {
  name: "MuiAutocomplete",
  slot: "Loading"
})(we(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
}))), ih = ee("div", {
  name: "MuiAutocomplete",
  slot: "NoOptions"
})(we(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
}))), sh = ee("ul", {
  name: "MuiAutocomplete",
  slot: "Listbox"
})(we(({
  theme: e
}) => ({
  listStyle: "none",
  margin: 0,
  padding: "8px 0",
  maxHeight: "40vh",
  overflow: "auto",
  position: "relative",
  [`& .${Ie.option}`]: {
    minHeight: 48,
    display: "flex",
    overflow: "hidden",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
    paddingTop: 6,
    boxSizing: "border-box",
    outline: "0",
    WebkitTapHighlightColor: "transparent",
    paddingBottom: 6,
    paddingLeft: 16,
    paddingRight: 16,
    [e.breakpoints.up("sm")]: {
      minHeight: "auto"
    },
    [`&.${Ie.focused}`]: {
      backgroundColor: (e.vars || e).palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    '&[aria-disabled="true"]': {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`&.${Ie.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    '&[aria-selected="true"]': {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : De(e.palette.primary.main, e.palette.action.selectedOpacity),
      [`&.${Ie.focused}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : De(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: (e.vars || e).palette.action.selected
        }
      },
      [`&.${Ie.focusVisible}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : De(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
      }
    }
  }
}))), ah = ee(ga, {
  name: "MuiAutocomplete",
  slot: "GroupLabel"
})(we(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  top: -8
}))), lh = ee("ul", {
  name: "MuiAutocomplete",
  slot: "GroupUl"
})({
  padding: 0,
  [`& .${Ie.option}`]: {
    paddingLeft: 24
  }
}), fl = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiAutocomplete"
  }), {
    autoComplete: r = !1,
    autoHighlight: i = !1,
    autoSelect: l = !1,
    blurOnSelect: c = !1,
    ChipProps: d,
    className: u,
    clearIcon: p = V3 || (V3 = /* @__PURE__ */ h.jsx(B5, {
      fontSize: "small"
    })),
    clearOnBlur: f = !o.freeSolo,
    clearOnEscape: m = !1,
    clearText: b = "Clear",
    closeText: C = "Close",
    componentsProps: g,
    defaultValue: y = o.multiple ? [] : null,
    disableClearable: w = !1,
    disableCloseOnSelect: T = !1,
    disabled: x = !1,
    disabledItemsFocusable: S = !1,
    disableListWrap: M = !1,
    disablePortal: O = !1,
    filterOptions: P,
    filterSelectedOptions: E = !1,
    forcePopupIcon: I = "auto",
    freeSolo: v = !1,
    fullWidth: _ = !1,
    getLimitTagsText: R = /* @__PURE__ */ a((We) => `+${We}`, "getLimitTagsText"),
    getOptionDisabled: j,
    getOptionKey: B,
    getOptionLabel: V,
    isOptionEqualToValue: L,
    groupBy: D,
    handleHomeEndKeys: z = !o.freeSolo,
    id: H,
    includeInputInList: $ = !1,
    inputValue: A,
    limitTags: U = -1,
    ListboxComponent: K,
    ListboxProps: J,
    loading: F = !1,
    loadingText: N = "Loading…",
    multiple: te = !1,
    noOptionsText: oe = "No options",
    onChange: ne,
    onClose: X,
    onHighlightChange: se,
    onInputChange: Y,
    onOpen: fe,
    open: be,
    openOnFocus: Re = !1,
    openText: Oe = "Open",
    options: Be,
    PaperComponent: re,
    PopperComponent: Fe,
    popupIcon: Ce = A3 || (A3 = /* @__PURE__ */ h.jsx(X5, {})),
    readOnly: Pe = !1,
    renderGroup: de,
    renderInput: pt,
    renderOption: ze,
    renderTags: ut,
    renderValue: Mt,
    selectOnFocus: At = !o.freeSolo,
    size: ft = "medium",
    slots: Tt = {},
    slotProps: lt = {},
    value: ce,
    ...nt
  } = o, {
    getRootProps: vt,
    getInputProps: Ke,
    getInputLabelProps: tn,
    getPopupIndicatorProps: ue,
    getClearProps: Me,
    getItemProps: Xe,
    getListboxProps: $t,
    getOptionProps: Ln,
    value: _t,
    dirty: nn,
    expanded: on,
    id: Vn,
    popupOpen: Zt,
    focused: ho,
    focusedItem: xe,
    anchorEl: wt,
    setAnchorEl: ae,
    inputValue: he,
    groupedOptions: Ee
  } = yf({
    ...o,
    componentName: "Autocomplete"
  }), Ve = !w && !x && nn && !Pe, Je = (!v || I === !0) && I !== !1, {
    onMouseDown: Ut
  } = Ke(), {
    ref: En,
    ...An
  } = $t(), Bn = V || /* @__PURE__ */ a((We) => We.label ?? We, "defaultGetOptionLabel"), It = {
    ...o,
    disablePortal: O,
    expanded: on,
    focused: ho,
    fullWidth: _,
    getOptionLabel: Bn,
    hasClearIcon: Ve,
    hasPopupIcon: Je,
    inputFocused: xe === -1,
    popupOpen: Zt,
    size: ft
  }, Rt = X9(It), go = {
    slots: {
      paper: re,
      popper: Fe,
      ...Tt
    },
    slotProps: {
      chip: d,
      listbox: J,
      ...g,
      ...lt
    }
  }, [Fr, fs] = ve("listbox", {
    elementType: sh,
    externalForwardedProps: go,
    ownerState: It,
    className: Rt.listbox,
    additionalProps: An,
    ref: En
  }), [q, W] = ve("paper", {
    elementType: Ro,
    externalForwardedProps: go,
    ownerState: It,
    className: Rt.paper
  }), [ie, Le] = ve("popper", {
    elementType: cs,
    externalForwardedProps: go,
    ownerState: It,
    className: Rt.popper,
    additionalProps: {
      disablePortal: O,
      style: {
        width: wt ? wt.clientWidth : null
      },
      role: "presentation",
      anchorEl: wt,
      open: Zt
    }
  });
  let ye;
  const ot = /* @__PURE__ */ a((We) => ({
    className: Rt.tag,
    disabled: x,
    ...Xe(We)
  }), "getCustomizedItemProps");
  if (ut && te && _t.length > 0 ? ye = ut(_t, ot, It) : Mt && _t ? ye = Mt(_t, ot, It) : te && _t.length > 0 && (ye = _t.map((We, mo) => {
    const {
      key: bo,
      ...Zr
    } = ot({
      index: mo
    });
    return /* @__PURE__ */ h.jsx(jo, {
      label: Bn(We),
      size: ft,
      ...Zr,
      ...go.slotProps.chip
    }, bo);
  })), U > -1 && Array.isArray(ye)) {
    const We = ye.length - U;
    !ho && We > 0 && (ye = ye.splice(0, U), ye.push(/* @__PURE__ */ h.jsx("span", {
      className: Rt.tag,
      children: R(We)
    }, ye.length)));
  }
  const Ft = de || /* @__PURE__ */ a((We) => /* @__PURE__ */ h.jsxs("li", {
    children: [/* @__PURE__ */ h.jsx(ah, {
      className: Rt.groupLabel,
      ownerState: It,
      component: "div",
      children: We.group
    }), /* @__PURE__ */ h.jsx(lh, {
      className: Rt.groupUl,
      ownerState: It,
      children: We.children
    })]
  }, We.key), "defaultRenderGroup"), Pu = ze || /* @__PURE__ */ a((We, mo) => {
    const {
      key: bo,
      ...Zr
    } = We;
    return /* @__PURE__ */ h.jsx("li", {
      ...Zr,
      children: Bn(mo)
    }, bo);
  }, "defaultRenderOption"), x2 = /* @__PURE__ */ a((We, mo) => {
    const bo = Ln({
      option: We,
      index: mo
    });
    return Pu({
      ...bo,
      className: Rt.option
    }, We, {
      selected: bo["aria-selected"],
      index: mo,
      inputValue: he
    }, It);
  }, "renderListOption"), hs = go.slotProps.clearIndicator, gs = go.slotProps.popupIndicator;
  return /* @__PURE__ */ h.jsxs(k.Fragment, {
    children: [/* @__PURE__ */ h.jsx(J9, {
      ref: n,
      className: le(Rt.root, u),
      ownerState: It,
      ...vt(nt),
      children: pt({
        id: Vn,
        disabled: x,
        fullWidth: !0,
        size: ft === "small" ? "small" : void 0,
        InputLabelProps: tn(),
        InputProps: {
          ref: ae,
          className: Rt.inputRoot,
          startAdornment: ye,
          onMouseDown: /* @__PURE__ */ a((We) => {
            We.target === We.currentTarget && Ut(We);
          }, "onMouseDown"),
          ...(Ve || Je) && {
            endAdornment: /* @__PURE__ */ h.jsxs(Q9, {
              className: Rt.endAdornment,
              ownerState: It,
              children: [Ve ? /* @__PURE__ */ h.jsx(eh, {
                ...Me(),
                "aria-label": b,
                title: b,
                ownerState: It,
                ...hs,
                className: le(Rt.clearIndicator, hs == null ? void 0 : hs.className),
                children: p
              }) : null, Je ? /* @__PURE__ */ h.jsx(th, {
                ...ue(),
                disabled: x,
                "aria-label": Zt ? C : Oe,
                title: Zt ? C : Oe,
                ownerState: It,
                ...gs,
                className: le(Rt.popupIndicator, gs == null ? void 0 : gs.className),
                children: Ce
              }) : null]
            })
          }
        },
        inputProps: {
          className: Rt.input,
          disabled: x,
          readOnly: Pe,
          ...Ke()
        }
      })
    }), wt ? /* @__PURE__ */ h.jsx(nh, {
      as: ie,
      ...Le,
      children: /* @__PURE__ */ h.jsxs(oh, {
        as: q,
        ...W,
        children: [F && Ee.length === 0 ? /* @__PURE__ */ h.jsx(rh, {
          className: Rt.loading,
          ownerState: It,
          children: N
        }) : null, Ee.length === 0 && !v && !F ? /* @__PURE__ */ h.jsx(ih, {
          className: Rt.noOptions,
          ownerState: It,
          role: "presentation",
          onMouseDown: /* @__PURE__ */ a((We) => {
            We.preventDefault();
          }, "onMouseDown"),
          children: oe
        }) : null, Ee.length > 0 ? /* @__PURE__ */ h.jsx(Fr, {
          as: K,
          ...fs,
          children: Ee.map((We, mo) => D ? Ft({
            key: We.key,
            group: We.group,
            children: We.options.map((bo, Zr) => x2(bo, We.index + Zr))
          }) : x2(We, mo))
        }) : null]
      })
    }) : null]
  });
}, "Autocomplete"));
process.env.NODE_ENV !== "production" && (fl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the portion of the selected suggestion that the user hasn't typed,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   * @default false
   */
  autoComplete: s.bool,
  /**
   * If `true`, the first option is automatically highlighted.
   * @default false
   */
  autoHighlight: s.bool,
  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   *
   * When using the `freeSolo` mode, the typed value will be the input value
   * if the Autocomplete loses focus without highlighting an option.
   * @default false
   */
  autoSelect: s.bool,
  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   * @default false
   */
  blurOnSelect: s.oneOfType([s.oneOf(["mouse", "touch"]), s.bool]),
  /**
   * Props applied to the [`Chip`](https://mui.com/material-ui/api/chip/) element.
   * @deprecated Use `slotProps.chip` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ChipProps: s.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The icon to display in place of the default clear icon.
   * @default <ClearIcon fontSize="small" />
   */
  clearIcon: s.node,
  /**
   * If `true`, the input's text is cleared on blur if no value is selected.
   *
   * Set it to `true` if you want to help the user enter a new value.
   * Set it to `false` if you want to help the user resume their search.
   * @default !props.freeSolo
   */
  clearOnBlur: s.bool,
  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   * @default false
   */
  clearOnEscape: s.bool,
  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Clear'
   */
  clearText: s.string,
  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: s.string,
  /**
   * The props used for each slot inside.
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: s.shape({
    clearIndicator: s.object,
    paper: s.object,
    popper: s.object,
    popupIndicator: s.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   * @default props.multiple ? [] : null
   */
  defaultValue: In(s.any, (e) => e.multiple && e.defaultValue !== void 0 && !Array.isArray(e.defaultValue) ? new Error(["MUI: The Autocomplete expects the `defaultValue` prop to be an array when `multiple={true}` or undefined.", `However, ${e.defaultValue} was provided.`].join(`
`)) : null),
  /**
   * If `true`, the input can't be cleared.
   * @default false
   */
  disableClearable: s.bool,
  /**
   * If `true`, the popup won't close when a value is selected.
   * @default false
   */
  disableCloseOnSelect: s.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: s.bool,
  /**
   * If `true`, the list box in the popup will not wrap focus.
   * @default false
   */
  disableListWrap: s.bool,
  /**
   * If `true`, the `Popper` content will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: s.bool,
  /**
   * A function that determines the filtered options to be rendered on search.
   *
   * @default createFilterOptions()
   * @param {Value[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {Value[]}
   */
  filterOptions: s.func,
  /**
   * If `true`, hide the selected options from the list box.
   * @default false
   */
  filterSelectedOptions: s.bool,
  /**
   * Force the visibility display of the popup icon.
   * @default 'auto'
   */
  forcePopupIcon: s.oneOfType([s.oneOf(["auto"]), s.bool]),
  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   * @default false
   */
  freeSolo: s.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   * @default (more) => `+${more}`
   */
  getLimitTagsText: s.func,
  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {Value} option The option to test.
   * @returns {boolean}
   */
  getOptionDisabled: s.func,
  /**
   * Used to determine the key for a given option.
   * This can be useful when the labels of options are not unique (since labels are used as keys by default).
   *
   * @param {Value} option The option to get the key for.
   * @returns {string | number}
   */
  getOptionKey: s.func,
  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * If used in free solo mode, it must accept both the type of the options and a string.
   *
   * @param {Value} option
   * @returns {string}
   * @default (option) => option.label ?? option
   */
  getOptionLabel: s.func,
  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {Value} option The Autocomplete option.
   * @returns {string}
   */
  groupBy: s.func,
  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   * @default !props.freeSolo
   */
  handleHomeEndKeys: s.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide an id it will fall back to a randomly generated one.
   */
  id: s.string,
  /**
   * If `true`, the highlight can move to the input.
   * @default false
   */
  includeInputInList: s.bool,
  /**
   * The input value.
   */
  inputValue: s.string,
  /**
   * Used to determine if the option represents the given value.
   * Uses strict equality by default.
   * ⚠️ Both arguments need to be handled, an option can only match with one value.
   *
   * @param {Value} option The option to test.
   * @param {Value} value The value to test against.
   * @returns {boolean}
   */
  isOptionEqualToValue: s.func,
  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   * @default -1
   */
  limitTags: il,
  /**
   * The component used to render the listbox.
   * @default 'ul'
   * @deprecated Use `slotProps.listbox.component` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ListboxComponent: s.elementType,
  /**
   * Props applied to the Listbox element.
   * @deprecated Use `slotProps.listbox` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ListboxProps: s.object,
  /**
   * If `true`, the component is in a loading state.
   * This shows the `loadingText` in place of suggestions (only if there are no suggestions to show, for example `options` are empty).
   * @default false
   */
  loading: s.bool,
  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Loading…'
   */
  loadingText: s.node,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: s.bool,
  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'No options'
   */
  noOptionsText: s.node,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value|Value[]} value The new value of the component.
   * @param {string} reason One of "createOption", "selectOption", "removeOption", "blur" or "clear".
   * @param {string} [details]
   */
  onChange: s.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"selectOption"`, `"removeOption"`, `"blur"`.
   */
  onClose: s.func,
  /**
   * Callback fired when the highlight option changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"mouse"`, `"touch"`.
   */
  onHighlightChange: s.func,
  /**
   * Callback fired when the input value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`, `"blur"`, `"selectOption"`, `"removeOption"`
   */
  onInputChange: s.func,
  /**
   * @ignore
   */
  onKeyDown: s.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: s.func,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool,
  /**
   * If `true`, the popup will open on input focus.
   * @default false
   */
  openOnFocus: s.bool,
  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Open'
   */
  openText: s.string,
  /**
   * A list of options that will be shown in the Autocomplete.
   */
  options: s.array.isRequired,
  /**
   * The component used to render the body of the popup.
   * @default Paper
   * @deprecated Use `slots.paper` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PaperComponent: s.elementType,
  /**
   * The component used to position the popup.
   * @default Popper
   * @deprecated Use `slots.popper` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PopperComponent: s.elementType,
  /**
   * The icon to display in place of the default popup icon.
   * @default <ArrowDropDownIcon />
   */
  popupIcon: s.node,
  /**
   * If `true`, the component becomes readonly. It is also supported for multiple tags where the tag cannot be deleted.
   * @default false
   */
  readOnly: s.bool,
  /**
   * Render the group.
   *
   * @param {AutocompleteRenderGroupParams} params The group to render.
   * @returns {ReactNode}
   */
  renderGroup: s.func,
  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: s.func.isRequired,
  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {object} props The props to apply on the li element.
   * @param {Value} option The option to render.
   * @param {object} state The state of each option.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderOption: s.func,
  /**
   * Render the selected value when doing multiple selections.
   *
   * @deprecated Use `renderValue` prop instead
   *
   * @param {Value[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderTags: s.func,
  /**
   * Renders the selected value(s) as rich content in the input for both single and multiple selections.
   *
   * @param {AutocompleteRenderValue<Value, Multiple, FreeSolo>} value The `value` provided to the component.
   * @param {function} getItemProps The value item props.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderValue: s.func,
  /**
   * If `true`, the input's text is selected on focus.
   * It helps the user clear the selected value.
   * @default !props.freeSolo
   */
  selectOnFocus: s.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["small", "medium"]), s.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    chip: s.oneOfType([s.func, s.object]),
    clearIndicator: s.oneOfType([s.func, s.object]),
    listbox: s.oneOfType([s.func, s.object]),
    paper: s.oneOfType([s.func, s.object]),
    popper: s.oneOfType([s.func, s.object]),
    popupIndicator: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    listbox: s.elementType,
    paper: s.elementType,
    popper: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `isOptionEqualToValue` prop.
   */
  value: In(s.any, (e) => e.multiple && e.value !== void 0 && !Array.isArray(e.value) ? new Error(["MUI: The Autocomplete expects the `value` prop to be an array when `multiple={true}` or undefined.", `However, ${e.value} was provided.`].join(`
`)) : null)
});
function ch(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
a(ch, "isClassComponent");
function J5(e, t, n, o, r) {
  const i = e[t], l = r || t;
  if (i == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let c;
  const d = i.type;
  return typeof d == "function" && !ch(d) && (c = "Did you accidentally use a plain function component for an element instead?"), c !== void 0 ? new Error(`Invalid ${o} \`${l}\` supplied to \`${n}\`. Expected an element that can hold a ref. ${c} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
a(J5, "acceptingRef");
const sr = In(s.element, J5);
sr.isRequired = In(s.element.isRequired, J5);
const dh = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, ba = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = uo(), r = {
    enter: o.transitions.duration.enteringScreen,
    exit: o.transitions.duration.leavingScreen
  }, {
    addEndListener: i,
    appear: l = !0,
    children: c,
    easing: d,
    in: u,
    onEnter: p,
    onEntered: f,
    onEntering: m,
    onExit: b,
    onExited: C,
    onExiting: g,
    style: y,
    timeout: w = r,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: T = On,
    ...x
  } = t, S = k.useRef(null), M = xt(S, ir(c), n), O = /* @__PURE__ */ a((B) => (V) => {
    if (B) {
      const L = S.current;
      V === void 0 ? B(L) : B(L, V);
    }
  }, "normalizedTransitionCallback"), P = O(m), E = O((B, V) => {
    xc(B);
    const L = Eo({
      style: y,
      timeout: w,
      easing: d
    }, {
      mode: "enter"
    });
    B.style.webkitTransition = o.transitions.create("opacity", L), B.style.transition = o.transitions.create("opacity", L), p && p(B, V);
  }), I = O(f), v = O(g), _ = O((B) => {
    const V = Eo({
      style: y,
      timeout: w,
      easing: d
    }, {
      mode: "exit"
    });
    B.style.webkitTransition = o.transitions.create("opacity", V), B.style.transition = o.transitions.create("opacity", V), b && b(B);
  }), R = O(C), j = /* @__PURE__ */ a((B) => {
    i && i(S.current, B);
  }, "handleAddEndListener");
  return /* @__PURE__ */ h.jsx(T, {
    appear: l,
    in: u,
    nodeRef: S,
    onEnter: E,
    onEntered: I,
    onEntering: P,
    onExit: _,
    onExited: R,
    onExiting: v,
    addEndListener: j,
    timeout: w,
    ...x,
    children: /* @__PURE__ */ a((B, {
      ownerState: V,
      ...L
    }) => /* @__PURE__ */ k.cloneElement(c, {
      style: {
        opacity: 0,
        visibility: B === "exited" && !u ? "hidden" : void 0,
        ...dh[B],
        ...y,
        ...c.props.style
      },
      ref: M,
      ...L
    }), "children")
  });
}, "Fade"));
process.env.NODE_ENV !== "production" && (ba.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: s.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: s.bool,
  /**
   * A single child content element.
   */
  children: sr.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: s.oneOfType([s.shape({
    enter: s.string,
    exit: s.string
  }), s.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: s.bool,
  /**
   * @ignore
   */
  onEnter: s.func,
  /**
   * @ignore
   */
  onEntered: s.func,
  /**
   * @ignore
   */
  onEntering: s.func,
  /**
   * @ignore
   */
  onExit: s.func,
  /**
   * @ignore
   */
  onExited: s.func,
  /**
   * @ignore
   */
  onExiting: s.func,
  /**
   * @ignore
   */
  style: s.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: s.oneOfType([s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })])
});
function uh(e) {
  return Te("MuiBackdrop", e);
}
a(uh, "getBackdropUtilityClass");
Se("MuiBackdrop", ["root", "invisible"]);
const ph = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    invisible: n
  } = e;
  return ke({
    root: ["root", n && "invisible"]
  }, uh, t);
}, "useUtilityClasses$v"), fh = ee("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.invisible && t.invisible];
  }, "overridesResolver")
})({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent",
  variants: [{
    props: {
      invisible: !0
    },
    style: {
      backgroundColor: "transparent"
    }
  }]
}), hl = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiBackdrop"
  }), {
    children: r,
    className: i,
    component: l = "div",
    invisible: c = !1,
    open: d,
    components: u = {},
    componentsProps: p = {},
    slotProps: f = {},
    slots: m = {},
    TransitionComponent: b,
    transitionDuration: C,
    ...g
  } = o, y = {
    ...o,
    component: l,
    invisible: c
  }, w = ph(y), T = {
    transition: b,
    root: u.Root,
    ...m
  }, x = {
    ...p,
    ...f
  }, S = {
    slots: T,
    slotProps: x
  }, [M, O] = ve("root", {
    elementType: fh,
    externalForwardedProps: S,
    className: le(w.root, i),
    ownerState: y
  }), [P, E] = ve("transition", {
    elementType: ba,
    externalForwardedProps: S,
    ownerState: y
  });
  return /* @__PURE__ */ h.jsx(P, {
    in: d,
    timeout: C,
    ...g,
    ...E,
    children: /* @__PURE__ */ h.jsx(M, {
      "aria-hidden": !0,
      ...O,
      classes: w,
      ref: n,
      children: r
    })
  });
}, "Backdrop"));
process.env.NODE_ENV !== "production" && (hl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: s.shape({
    Root: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: s.shape({
    root: s.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: s.bool,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    root: s.oneOfType([s.func, s.object]),
    transition: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    root: s.elementType,
    transition: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   * @deprecated Use `slots.transition` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: s.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: s.oneOfType([s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })])
});
const hh = Se("MuiBox", ["root"]), gh = gc(), ge = K7({
  themeId: Fa,
  defaultTheme: gh,
  defaultClassName: hh.root,
  generateClassName: d5.generate
});
process.env.NODE_ENV !== "production" && (ge.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: s.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function mh(e) {
  return Te("MuiButton", e);
}
a(mh, "getButtonUtilityClass");
const Ao = Se("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorSuccess", "colorError", "colorInfo", "colorWarning", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "icon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge", "loading", "loadingWrapper", "loadingIconPlaceholder", "loadingIndicator", "loadingPositionCenter", "loadingPositionStart", "loadingPositionEnd"]), $c = /* @__PURE__ */ k.createContext({});
process.env.NODE_ENV !== "production" && ($c.displayName = "ButtonGroupContext");
const Pc = /* @__PURE__ */ k.createContext(void 0);
process.env.NODE_ENV !== "production" && (Pc.displayName = "ButtonGroupButtonContext");
const bh = /* @__PURE__ */ a((e) => {
  const {
    color: t,
    disableElevation: n,
    fullWidth: o,
    size: r,
    variant: i,
    loading: l,
    loadingPosition: c,
    classes: d
  } = e, u = {
    root: ["root", l && "loading", i, `${i}${G(t)}`, `size${G(r)}`, `${i}Size${G(r)}`, `color${G(t)}`, n && "disableElevation", o && "fullWidth", l && `loadingPosition${G(c)}`],
    startIcon: ["icon", "startIcon", `iconSize${G(r)}`],
    endIcon: ["icon", "endIcon", `iconSize${G(r)}`],
    loadingIndicator: ["loadingIndicator"],
    loadingWrapper: ["loadingWrapper"]
  }, p = ke(u, mh, d);
  return {
    ...d,
    // forward the focused, disabled, etc. classes to the ButtonBase
    ...p
  };
}, "useUtilityClasses$u"), Q5 = [{
  props: {
    size: "small"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 18
    }
  }
}, {
  props: {
    size: "medium"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 20
    }
  }
}, {
  props: {
    size: "large"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 22
    }
  }
}], Ch = ee(lo, {
  shouldForwardProp: /* @__PURE__ */ a((e) => Vt(e) || e === "classes", "shouldForwardProp"),
  name: "MuiButton",
  slot: "Root",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`${n.variant}${G(n.color)}`], t[`size${G(n.size)}`], t[`${n.variant}Size${G(n.size)}`], n.color === "inherit" && t.colorInherit, n.disableElevation && t.disableElevation, n.fullWidth && t.fullWidth, n.loading && t.loading];
  }, "overridesResolver")
})(we(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[300] : e.palette.grey[800], n = e.palette.mode === "light" ? e.palette.grey.A100 : e.palette.grey[700];
  return {
    ...e.typography.button,
    minWidth: 64,
    padding: "6px 16px",
    border: 0,
    borderRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: e.transitions.duration.short
    }),
    "&:hover": {
      textDecoration: "none"
    },
    [`&.${Ao.disabled}`]: {
      color: (e.vars || e).palette.action.disabled
    },
    variants: [{
      props: {
        variant: "contained"
      },
      style: {
        color: "var(--variant-containedColor)",
        backgroundColor: "var(--variant-containedBg)",
        boxShadow: (e.vars || e).shadows[2],
        "&:hover": {
          boxShadow: (e.vars || e).shadows[4],
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            boxShadow: (e.vars || e).shadows[2]
          }
        },
        "&:active": {
          boxShadow: (e.vars || e).shadows[8]
        },
        [`&.${Ao.focusVisible}`]: {
          boxShadow: (e.vars || e).shadows[6]
        },
        [`&.${Ao.disabled}`]: {
          color: (e.vars || e).palette.action.disabled,
          boxShadow: (e.vars || e).shadows[0],
          backgroundColor: (e.vars || e).palette.action.disabledBackground
        }
      }
    }, {
      props: {
        variant: "outlined"
      },
      style: {
        padding: "5px 15px",
        border: "1px solid currentColor",
        borderColor: "var(--variant-outlinedBorder, currentColor)",
        backgroundColor: "var(--variant-outlinedBg)",
        color: "var(--variant-outlinedColor)",
        [`&.${Ao.disabled}`]: {
          border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
        }
      }
    }, {
      props: {
        variant: "text"
      },
      style: {
        padding: "6px 8px",
        color: "var(--variant-textColor)",
        backgroundColor: "var(--variant-textBg)"
      }
    }, ...Object.entries(e.palette).filter(bt()).map(([o]) => ({
      props: {
        color: o
      },
      style: {
        "--variant-textColor": (e.vars || e).palette[o].main,
        "--variant-outlinedColor": (e.vars || e).palette[o].main,
        "--variant-outlinedBorder": e.vars ? `rgba(${e.vars.palette[o].mainChannel} / 0.5)` : De(e.palette[o].main, 0.5),
        "--variant-containedColor": (e.vars || e).palette[o].contrastText,
        "--variant-containedBg": (e.vars || e).palette[o].main,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": (e.vars || e).palette[o].dark,
            "--variant-textBg": e.vars ? `rgba(${e.vars.palette[o].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : De(e.palette[o].main, e.palette.action.hoverOpacity),
            "--variant-outlinedBorder": (e.vars || e).palette[o].main,
            "--variant-outlinedBg": e.vars ? `rgba(${e.vars.palette[o].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : De(e.palette[o].main, e.palette.action.hoverOpacity)
          }
        }
      }
    })), {
      props: {
        color: "inherit"
      },
      style: {
        color: "inherit",
        borderColor: "currentColor",
        "--variant-containedBg": e.vars ? e.vars.palette.Button.inheritContainedBg : t,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": e.vars ? e.vars.palette.Button.inheritContainedHoverBg : n,
            "--variant-textBg": e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : De(e.palette.text.primary, e.palette.action.hoverOpacity),
            "--variant-outlinedBg": e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : De(e.palette.text.primary, e.palette.action.hoverOpacity)
          }
        }
      }
    }, {
      props: {
        size: "small",
        variant: "text"
      },
      style: {
        padding: "4px 5px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "text"
      },
      style: {
        padding: "8px 11px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "outlined"
      },
      style: {
        padding: "3px 9px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "outlined"
      },
      style: {
        padding: "7px 21px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "contained"
      },
      style: {
        padding: "4px 10px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "contained"
      },
      style: {
        padding: "8px 22px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        disableElevation: !0
      },
      style: {
        boxShadow: "none",
        "&:hover": {
          boxShadow: "none"
        },
        [`&.${Ao.focusVisible}`]: {
          boxShadow: "none"
        },
        "&:active": {
          boxShadow: "none"
        },
        [`&.${Ao.disabled}`]: {
          boxShadow: "none"
        }
      }
    }, {
      props: {
        fullWidth: !0
      },
      style: {
        width: "100%"
      }
    }, {
      props: {
        loadingPosition: "center"
      },
      style: {
        transition: e.transitions.create(["background-color", "box-shadow", "border-color"], {
          duration: e.transitions.duration.short
        }),
        [`&.${Ao.loading}`]: {
          color: "transparent"
        }
      }
    }]
  };
})), yh = ee("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.startIcon, n.loading && t.startIconLoadingStart, t[`iconSize${G(n.size)}`]];
  }, "overridesResolver")
})(({
  theme: e
}) => ({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginLeft: -2
    }
  }, {
    props: {
      loadingPosition: "start",
      loading: !0
    },
    style: {
      transition: e.transitions.create(["opacity"], {
        duration: e.transitions.duration.short
      }),
      opacity: 0
    }
  }, {
    props: {
      loadingPosition: "start",
      loading: !0,
      fullWidth: !0
    },
    style: {
      marginRight: -8
    }
  }, ...Q5]
})), xh = ee("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.endIcon, n.loading && t.endIconLoadingEnd, t[`iconSize${G(n.size)}`]];
  }, "overridesResolver")
})(({
  theme: e
}) => ({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginRight: -2
    }
  }, {
    props: {
      loadingPosition: "end",
      loading: !0
    },
    style: {
      transition: e.transitions.create(["opacity"], {
        duration: e.transitions.duration.short
      }),
      opacity: 0
    }
  }, {
    props: {
      loadingPosition: "end",
      loading: !0,
      fullWidth: !0
    },
    style: {
      marginLeft: -8
    }
  }, ...Q5]
})), vh = ee("span", {
  name: "MuiButton",
  slot: "LoadingIndicator"
})(({
  theme: e
}) => ({
  display: "none",
  position: "absolute",
  visibility: "visible",
  variants: [{
    props: {
      loading: !0
    },
    style: {
      display: "flex"
    }
  }, {
    props: {
      loadingPosition: "start"
    },
    style: {
      left: 14
    }
  }, {
    props: {
      loadingPosition: "start",
      size: "small"
    },
    style: {
      left: 10
    }
  }, {
    props: {
      variant: "text",
      loadingPosition: "start"
    },
    style: {
      left: 6
    }
  }, {
    props: {
      loadingPosition: "center"
    },
    style: {
      left: "50%",
      transform: "translate(-50%)",
      color: (e.vars || e).palette.action.disabled
    }
  }, {
    props: {
      loadingPosition: "end"
    },
    style: {
      right: 14
    }
  }, {
    props: {
      loadingPosition: "end",
      size: "small"
    },
    style: {
      right: 10
    }
  }, {
    props: {
      variant: "text",
      loadingPosition: "end"
    },
    style: {
      right: 6
    }
  }, {
    props: {
      loadingPosition: "start",
      fullWidth: !0
    },
    style: {
      position: "relative",
      left: -10
    }
  }, {
    props: {
      loadingPosition: "end",
      fullWidth: !0
    },
    style: {
      position: "relative",
      right: -10
    }
  }]
})), B3 = ee("span", {
  name: "MuiButton",
  slot: "LoadingIconPlaceholder"
})({
  display: "inline-block",
  width: "1em",
  height: "1em"
}), gl = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = k.useContext($c), r = k.useContext(Pc), i = sa(o, t), l = $e({
    props: i,
    name: "MuiButton"
  }), {
    children: c,
    color: d = "primary",
    component: u = "button",
    className: p,
    disabled: f = !1,
    disableElevation: m = !1,
    disableFocusRipple: b = !1,
    endIcon: C,
    focusVisibleClassName: g,
    fullWidth: y = !1,
    id: w,
    loading: T = null,
    loadingIndicator: x,
    loadingPosition: S = "center",
    size: M = "medium",
    startIcon: O,
    type: P,
    variant: E = "text",
    ...I
  } = l, v = _o(w), _ = x ?? /* @__PURE__ */ h.jsx(vc, {
    "aria-labelledby": v,
    color: "inherit",
    size: 16
  }), R = {
    ...l,
    color: d,
    component: u,
    disabled: f,
    disableElevation: m,
    disableFocusRipple: b,
    fullWidth: y,
    loading: T,
    loadingIndicator: _,
    loadingPosition: S,
    size: M,
    type: P,
    variant: E
  }, j = bh(R), B = (O || T && S === "start") && /* @__PURE__ */ h.jsx(yh, {
    className: j.startIcon,
    ownerState: R,
    children: O || /* @__PURE__ */ h.jsx(B3, {
      className: j.loadingIconPlaceholder,
      ownerState: R
    })
  }), V = (C || T && S === "end") && /* @__PURE__ */ h.jsx(xh, {
    className: j.endIcon,
    ownerState: R,
    children: C || /* @__PURE__ */ h.jsx(B3, {
      className: j.loadingIconPlaceholder,
      ownerState: R
    })
  }), L = r || "", D = typeof T == "boolean" ? (
    // use plain HTML span to minimize the runtime overhead
    /* @__PURE__ */ h.jsx("span", {
      className: j.loadingWrapper,
      style: {
        display: "contents"
      },
      children: T && /* @__PURE__ */ h.jsx(vh, {
        className: j.loadingIndicator,
        ownerState: R,
        children: _
      })
    })
  ) : null;
  return /* @__PURE__ */ h.jsxs(Ch, {
    ownerState: R,
    className: le(o.className, j.root, p, L),
    component: u,
    disabled: f || T,
    focusRipple: !b,
    focusVisibleClassName: le(j.focusVisible, g),
    ref: n,
    type: P,
    id: T ? v : w,
    ...I,
    classes: j,
    children: [B, S !== "end" && D, c, S === "end" && D, V]
  });
}, "Button"));
process.env.NODE_ENV !== "production" && (gl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: s.oneOfType([s.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: s.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: s.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: s.bool,
  /**
   * Element placed after the children.
   */
  endIcon: s.node,
  /**
   * @ignore
   */
  focusVisibleClassName: s.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: s.string,
  /**
   * @ignore
   */
  id: s.string,
  /**
   * If `true`, the loading indicator is visible and the button is disabled.
   * If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
   * @default null
   */
  loading: s.bool,
  /**
   * Element placed before the children if the button is in loading state.
   * The node should contain an element with `role="progressbar"` with an accessible name.
   * By default, it renders a `CircularProgress` that is labeled by the button itself.
   * @default <CircularProgress color="inherit" size={16} />
   */
  loadingIndicator: s.node,
  /**
   * The loading indicator can be positioned on the start, end, or the center of the button.
   * @default 'center'
   */
  loadingPosition: s.oneOf(["center", "end", "start"]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["small", "medium", "large"]), s.string]),
  /**
   * Element placed before the children.
   */
  startIcon: s.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * @ignore
   */
  type: s.oneOfType([s.oneOf(["button", "reset", "submit"]), s.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: s.oneOfType([s.oneOf(["contained", "outlined", "text"]), s.string])
});
function wh(e) {
  return k.Children.toArray(e).filter((t) => /* @__PURE__ */ k.isValidElement(t));
}
a(wh, "getValidReactChildren");
function Sh(e) {
  return Te("MuiButtonGroup", e);
}
a(Sh, "getButtonGroupUtilityClass");
const _e = Se("MuiButtonGroup", ["root", "contained", "outlined", "text", "disableElevation", "disabled", "firstButton", "fullWidth", "horizontal", "vertical", "colorPrimary", "colorSecondary", "grouped", "groupedHorizontal", "groupedVertical", "groupedText", "groupedTextHorizontal", "groupedTextVertical", "groupedTextPrimary", "groupedTextSecondary", "groupedOutlined", "groupedOutlinedHorizontal", "groupedOutlinedVertical", "groupedOutlinedPrimary", "groupedOutlinedSecondary", "groupedContained", "groupedContainedHorizontal", "groupedContainedVertical", "groupedContainedPrimary", "groupedContainedSecondary", "lastButton", "middleButton"]), Mh = /* @__PURE__ */ a((e, t) => {
  const {
    ownerState: n
  } = e;
  return [{
    [`& .${_e.grouped}`]: t.grouped
  }, {
    [`& .${_e.grouped}`]: t[`grouped${G(n.orientation)}`]
  }, {
    [`& .${_e.grouped}`]: t[`grouped${G(n.variant)}`]
  }, {
    [`& .${_e.grouped}`]: t[`grouped${G(n.variant)}${G(n.orientation)}`]
  }, {
    [`& .${_e.grouped}`]: t[`grouped${G(n.variant)}${G(n.color)}`]
  }, {
    [`& .${_e.firstButton}`]: t.firstButton
  }, {
    [`& .${_e.lastButton}`]: t.lastButton
  }, {
    [`& .${_e.middleButton}`]: t.middleButton
  }, t.root, t[n.variant], n.disableElevation === !0 && t.disableElevation, n.fullWidth && t.fullWidth, n.orientation === "vertical" && t.vertical];
}, "overridesResolver$3"), Th = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    color: n,
    disabled: o,
    disableElevation: r,
    fullWidth: i,
    orientation: l,
    variant: c
  } = e, d = {
    root: ["root", c, l, i && "fullWidth", r && "disableElevation", `color${G(n)}`],
    grouped: ["grouped", `grouped${G(l)}`, `grouped${G(c)}`, `grouped${G(c)}${G(l)}`, `grouped${G(c)}${G(n)}`, o && "disabled"],
    firstButton: ["firstButton"],
    lastButton: ["lastButton"],
    middleButton: ["middleButton"]
  };
  return ke(d, Sh, t);
}, "useUtilityClasses$t"), kh = ee("div", {
  name: "MuiButtonGroup",
  slot: "Root",
  overridesResolver: Mh
})(we(({
  theme: e
}) => ({
  display: "inline-flex",
  borderRadius: (e.vars || e).shape.borderRadius,
  variants: [{
    props: {
      variant: "contained"
    },
    style: {
      boxShadow: (e.vars || e).shadows[2]
    }
  }, {
    props: {
      disableElevation: !0
    },
    style: {
      boxShadow: "none"
    }
  }, {
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      flexDirection: "column",
      [`& .${_e.lastButton},& .${_e.middleButton}`]: {
        borderTopRightRadius: 0,
        borderTopLeftRadius: 0
      },
      [`& .${_e.firstButton},& .${_e.middleButton}`]: {
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0
      }
    }
  }, {
    props: {
      orientation: "horizontal"
    },
    style: {
      [`& .${_e.firstButton},& .${_e.middleButton}`]: {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      },
      [`& .${_e.lastButton},& .${_e.middleButton}`]: {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      }
    }
  }, {
    props: {
      variant: "text",
      orientation: "horizontal"
    },
    style: {
      [`& .${_e.firstButton},& .${_e.middleButton}`]: {
        borderRight: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
        [`&.${_e.disabled}`]: {
          borderRight: `1px solid ${(e.vars || e).palette.action.disabled}`
        }
      }
    }
  }, {
    props: {
      variant: "text",
      orientation: "vertical"
    },
    style: {
      [`& .${_e.firstButton},& .${_e.middleButton}`]: {
        borderBottom: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
        [`&.${_e.disabled}`]: {
          borderBottom: `1px solid ${(e.vars || e).palette.action.disabled}`
        }
      }
    }
  }, ...Object.entries(e.palette).filter(bt()).flatMap(([t]) => [{
    props: {
      variant: "text",
      color: t
    },
    style: {
      [`& .${_e.firstButton},& .${_e.middleButton}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / 0.5)` : De(e.palette[t].main, 0.5)
      }
    }
  }]), {
    props: {
      variant: "outlined",
      orientation: "horizontal"
    },
    style: {
      [`& .${_e.firstButton},& .${_e.middleButton}`]: {
        borderRightColor: "transparent",
        "&:hover": {
          borderRightColor: "currentColor"
        }
      },
      [`& .${_e.lastButton},& .${_e.middleButton}`]: {
        marginLeft: -1
      }
    }
  }, {
    props: {
      variant: "outlined",
      orientation: "vertical"
    },
    style: {
      [`& .${_e.firstButton},& .${_e.middleButton}`]: {
        borderBottomColor: "transparent",
        "&:hover": {
          borderBottomColor: "currentColor"
        }
      },
      [`& .${_e.lastButton},& .${_e.middleButton}`]: {
        marginTop: -1
      }
    }
  }, {
    props: {
      variant: "contained",
      orientation: "horizontal"
    },
    style: {
      [`& .${_e.firstButton},& .${_e.middleButton}`]: {
        borderRight: `1px solid ${(e.vars || e).palette.grey[400]}`,
        [`&.${_e.disabled}`]: {
          borderRight: `1px solid ${(e.vars || e).palette.action.disabled}`
        }
      }
    }
  }, {
    props: {
      variant: "contained",
      orientation: "vertical"
    },
    style: {
      [`& .${_e.firstButton},& .${_e.middleButton}`]: {
        borderBottom: `1px solid ${(e.vars || e).palette.grey[400]}`,
        [`&.${_e.disabled}`]: {
          borderBottom: `1px solid ${(e.vars || e).palette.action.disabled}`
        }
      }
    }
  }, ...Object.entries(e.palette).filter(bt(["dark"])).map(([t]) => ({
    props: {
      variant: "contained",
      color: t
    },
    style: {
      [`& .${_e.firstButton},& .${_e.middleButton}`]: {
        borderColor: (e.vars || e).palette[t].dark
      }
    }
  }))],
  [`& .${_e.grouped}`]: {
    minWidth: 40,
    boxShadow: "none",
    props: {
      variant: "contained"
    },
    style: {
      "&:hover": {
        boxShadow: "none"
      }
    }
  }
}))), ed = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiButtonGroup"
  }), {
    children: r,
    className: i,
    color: l = "primary",
    component: c = "div",
    disabled: d = !1,
    disableElevation: u = !1,
    disableFocusRipple: p = !1,
    disableRipple: f = !1,
    fullWidth: m = !1,
    orientation: b = "horizontal",
    size: C = "medium",
    variant: g = "outlined",
    ...y
  } = o, w = {
    ...o,
    color: l,
    component: c,
    disabled: d,
    disableElevation: u,
    disableFocusRipple: p,
    disableRipple: f,
    fullWidth: m,
    orientation: b,
    size: C,
    variant: g
  }, T = Th(w), x = k.useMemo(() => ({
    className: T.grouped,
    color: l,
    disabled: d,
    disableElevation: u,
    disableFocusRipple: p,
    disableRipple: f,
    fullWidth: m,
    size: C,
    variant: g
  }), [l, d, u, p, f, m, C, g, T.grouped]), S = wh(r), M = S.length, O = /* @__PURE__ */ a((P) => {
    const E = P === 0, I = P === M - 1;
    return E && I ? "" : E ? T.firstButton : I ? T.lastButton : T.middleButton;
  }, "getButtonPositionClassName");
  return /* @__PURE__ */ h.jsx(kh, {
    as: c,
    role: "group",
    className: le(T.root, i),
    ref: n,
    ownerState: w,
    ...y,
    children: /* @__PURE__ */ h.jsx($c.Provider, {
      value: x,
      children: S.map((P, E) => /* @__PURE__ */ h.jsx(Pc.Provider, {
        value: O(E),
        children: P
      }, E))
    })
  });
}, "ButtonGroup"));
process.env.NODE_ENV !== "production" && (ed.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: s.oneOfType([s.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: s.bool,
  /**
   * If `true`, the button keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: s.bool,
  /**
   * If `true`, the button ripple effect is disabled.
   * @default false
   */
  disableRipple: s.bool,
  /**
   * If `true`, the buttons will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: s.oneOf(["horizontal", "vertical"]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["small", "medium", "large"]), s.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: s.oneOfType([s.oneOf(["contained", "outlined", "text"]), s.string])
});
function Oh(e) {
  return Te("PrivateSwitchBase", e);
}
a(Oh, "getSwitchBaseUtilityClass");
Se("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
const Eh = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    checked: n,
    disabled: o,
    edge: r
  } = e, i = {
    root: ["root", n && "checked", o && "disabled", r && `edge${G(r)}`],
    input: ["input"]
  };
  return ke(i, Oh, t);
}, "useUtilityClasses$s"), $h = ee(lo)({
  padding: 9,
  borderRadius: "50%",
  variants: [{
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: /* @__PURE__ */ a(({
      edge: e,
      ownerState: t
    }) => e === "start" && t.size !== "small", "props"),
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }, {
    props: /* @__PURE__ */ a(({
      edge: e,
      ownerState: t
    }) => e === "end" && t.size !== "small", "props"),
    style: {
      marginRight: -12
    }
  }]
}), Ph = ee("input", {
  shouldForwardProp: Vt
})({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), _c = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const {
    autoFocus: o,
    checked: r,
    checkedIcon: i,
    defaultChecked: l,
    disabled: c,
    disableFocusRipple: d = !1,
    edge: u = !1,
    icon: p,
    id: f,
    inputProps: m,
    inputRef: b,
    name: C,
    onBlur: g,
    onChange: y,
    onFocus: w,
    readOnly: T,
    required: x = !1,
    tabIndex: S,
    type: M,
    value: O,
    slots: P = {},
    slotProps: E = {},
    ...I
  } = t, [v, _] = Mo({
    controlled: r,
    default: !!l,
    name: "SwitchBase",
    state: "checked"
  }), R = jn(), j = /* @__PURE__ */ a((F) => {
    w && w(F), R && R.onFocus && R.onFocus(F);
  }, "handleFocus"), B = /* @__PURE__ */ a((F) => {
    g && g(F), R && R.onBlur && R.onBlur(F);
  }, "handleBlur"), V = /* @__PURE__ */ a((F) => {
    if (F.nativeEvent.defaultPrevented)
      return;
    const N = F.target.checked;
    _(N), y && y(F, N);
  }, "handleInputChange");
  let L = c;
  R && typeof L > "u" && (L = R.disabled);
  const D = M === "checkbox" || M === "radio", z = {
    ...t,
    checked: v,
    disabled: L,
    disableFocusRipple: d,
    edge: u
  }, H = Eh(z), $ = {
    slots: P,
    slotProps: {
      input: m,
      ...E
    }
  }, [A, U] = ve("root", {
    ref: n,
    elementType: $h,
    className: H.root,
    shouldForwardComponentProp: !0,
    externalForwardedProps: {
      ...$,
      component: "span",
      ...I
    },
    getSlotProps: /* @__PURE__ */ a((F) => ({
      ...F,
      onFocus: /* @__PURE__ */ a((N) => {
        var te;
        (te = F.onFocus) == null || te.call(F, N), j(N);
      }, "onFocus"),
      onBlur: /* @__PURE__ */ a((N) => {
        var te;
        (te = F.onBlur) == null || te.call(F, N), B(N);
      }, "onBlur")
    }), "getSlotProps"),
    ownerState: z,
    additionalProps: {
      centerRipple: !0,
      focusRipple: !d,
      disabled: L,
      role: void 0,
      tabIndex: null
    }
  }), [K, J] = ve("input", {
    ref: b,
    elementType: Ph,
    className: H.input,
    externalForwardedProps: $,
    getSlotProps: /* @__PURE__ */ a((F) => ({
      ...F,
      onChange: /* @__PURE__ */ a((N) => {
        var te;
        (te = F.onChange) == null || te.call(F, N), V(N);
      }, "onChange")
    }), "getSlotProps"),
    ownerState: z,
    additionalProps: {
      autoFocus: o,
      checked: r,
      defaultChecked: l,
      disabled: L,
      id: D ? f : void 0,
      name: C,
      readOnly: T,
      required: x,
      tabIndex: S,
      type: M,
      ...M === "checkbox" && O === void 0 ? {} : {
        value: O
      }
    }
  });
  return /* @__PURE__ */ h.jsxs(A, {
    ...U,
    children: [/* @__PURE__ */ h.jsx(K, {
      ...J
    }), v ? i : p]
  });
}, "SwitchBase"));
process.env.NODE_ENV !== "production" && (_c.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: s.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: s.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: s.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * @ignore
   */
  defaultChecked: s.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: s.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: s.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: s.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: s.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: s.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   */
  inputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Wt,
  /*
   * @ignore
   */
  name: s.string,
  /**
   * @ignore
   */
  onBlur: s.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: s.func,
  /**
   * @ignore
   */
  onFocus: s.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: s.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: s.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    input: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    input: s.elementType,
    root: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.object,
  /**
   * @ignore
   */
  tabIndex: s.oneOfType([s.number, s.string]),
  /**
   * The input component prop `type`.
   */
  type: s.string.isRequired,
  /**
   * The value of the component.
   */
  value: s.any
});
const _h = en(/* @__PURE__ */ h.jsx("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank"), Rh = en(/* @__PURE__ */ h.jsx("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox"), Ih = en(/* @__PURE__ */ h.jsx("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");
function jh(e) {
  return Te("MuiCheckbox", e);
}
a(jh, "getCheckboxUtilityClass");
const Dl = Se("MuiCheckbox", ["root", "checked", "disabled", "indeterminate", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium"]), Lh = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    indeterminate: n,
    color: o,
    size: r
  } = e, i = {
    root: ["root", n && "indeterminate", `color${G(o)}`, `size${G(r)}`]
  }, l = ke(i, jh, t);
  return {
    ...t,
    // forward the disabled and checked classes to the SwitchBase
    ...l
  };
}, "useUtilityClasses$r"), Vh = ee(_c, {
  shouldForwardProp: /* @__PURE__ */ a((e) => Vt(e) || e === "classes", "shouldForwardProp"),
  name: "MuiCheckbox",
  slot: "Root",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.indeterminate && t.indeterminate, t[`size${G(n.size)}`], n.color !== "default" && t[`color${G(n.color)}`]];
  }, "overridesResolver")
})(we(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  variants: [{
    props: {
      color: "default",
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : De(e.palette.action.active, e.palette.action.hoverOpacity)
      }
    }
  }, ...Object.entries(e.palette).filter(bt()).map(([t]) => ({
    props: {
      color: t,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : De(e.palette[t].main, e.palette.action.hoverOpacity)
      }
    }
  })), ...Object.entries(e.palette).filter(bt()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${Dl.checked}, &.${Dl.indeterminate}`]: {
        color: (e.vars || e).palette[t].main
      },
      [`&.${Dl.disabled}`]: {
        color: (e.vars || e).palette.action.disabled
      }
    }
  })), {
    // Should be last to override other colors
    props: {
      disableRipple: !1
    },
    style: {
      // Reset on touch devices, it doesn't add specificity
      "&:hover": {
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }]
}))), Ah = /* @__PURE__ */ h.jsx(Rh, {}), Bh = /* @__PURE__ */ h.jsx(_h, {}), Hh = /* @__PURE__ */ h.jsx(Ih, {}), Ca = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiCheckbox"
  }), {
    checkedIcon: r = Ah,
    color: i = "primary",
    icon: l = Bh,
    indeterminate: c = !1,
    indeterminateIcon: d = Hh,
    inputProps: u,
    size: p = "medium",
    disableRipple: f = !1,
    className: m,
    slots: b = {},
    slotProps: C = {},
    ...g
  } = o, y = c ? d : l, w = c ? d : r, T = {
    ...o,
    disableRipple: f,
    color: i,
    indeterminate: c,
    size: p
  }, x = Lh(T), S = C.input ?? u, [M, O] = ve("root", {
    ref: n,
    elementType: Vh,
    className: le(x.root, m),
    shouldForwardComponentProp: !0,
    externalForwardedProps: {
      slots: b,
      slotProps: C,
      ...g
    },
    ownerState: T,
    additionalProps: {
      type: "checkbox",
      icon: /* @__PURE__ */ k.cloneElement(y, {
        fontSize: y.props.fontSize ?? p
      }),
      checkedIcon: /* @__PURE__ */ k.cloneElement(w, {
        fontSize: w.props.fontSize ?? p
      }),
      disableRipple: f,
      slots: b,
      slotProps: {
        input: bc(typeof S == "function" ? S(T) : S, {
          "data-indeterminate": c
        })
      }
    }
  });
  return /* @__PURE__ */ h.jsx(M, {
    ...O,
    classes: x
  });
}, "Checkbox"));
process.env.NODE_ENV !== "production" && (Ca.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: s.bool,
  /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */
  checkedIcon: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: s.oneOfType([s.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: s.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: s.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */
  icon: s.node,
  /**
   * The id of the `input` element.
   */
  id: s.string,
  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */
  indeterminate: s.bool,
  /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */
  indeterminateIcon: s.node,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: s.object,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: s.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: s.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["medium", "small"]), s.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    input: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    input: s.elementType,
    root: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: s.any
});
function td(e = window) {
  const t = e.document.documentElement.clientWidth;
  return e.innerWidth - t;
}
a(td, "getScrollbarSize");
function Dh(e) {
  const t = Qt(e);
  return t.body === e ? dn(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
a(Dh, "isOverflowing");
function vi(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
a(vi, "ariaHidden");
function H3(e) {
  return parseInt(dn(e).getComputedStyle(e).paddingRight, 10) || 0;
}
a(H3, "getPaddingRight");
function Nh(e) {
  const n = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].includes(e.tagName), o = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return n || o;
}
a(Nh, "isAriaHiddenForbiddenOnElement");
function D3(e, t, n, o, r) {
  const i = [t, n, ...o];
  [].forEach.call(e.children, (l) => {
    const c = !i.includes(l), d = !Nh(l);
    c && d && vi(l, r);
  });
}
a(D3, "ariaHiddenSiblings");
function Nl(e, t) {
  let n = -1;
  return e.some((o, r) => t(o) ? (n = r, !0) : !1), n;
}
a(Nl, "findIndexOf");
function zh(e, t) {
  const n = [], o = e.container;
  if (!t.disableScrollLock) {
    if (Dh(o)) {
      const l = td(dn(o));
      n.push({
        value: o.style.paddingRight,
        property: "padding-right",
        el: o
      }), o.style.paddingRight = `${H3(o) + l}px`;
      const c = Qt(o).querySelectorAll(".mui-fixed");
      [].forEach.call(c, (d) => {
        n.push({
          value: d.style.paddingRight,
          property: "padding-right",
          el: d
        }), d.style.paddingRight = `${H3(d) + l}px`;
      });
    }
    let i;
    if (o.parentNode instanceof DocumentFragment)
      i = Qt(o).body;
    else {
      const l = o.parentElement, c = dn(o);
      i = (l == null ? void 0 : l.nodeName) === "HTML" && c.getComputedStyle(l).overflowY === "scroll" ? l : o;
    }
    n.push({
      value: i.style.overflow,
      property: "overflow",
      el: i
    }, {
      value: i.style.overflowX,
      property: "overflow-x",
      el: i
    }, {
      value: i.style.overflowY,
      property: "overflow-y",
      el: i
    }), i.style.overflow = "hidden";
  }
  return /* @__PURE__ */ a(() => {
    n.forEach(({
      value: i,
      el: l,
      property: c
    }) => {
      i ? l.style.setProperty(c, i) : l.style.removeProperty(c);
    });
  }, "restore");
}
a(zh, "handleContainer");
function Fh(e) {
  const t = [];
  return [].forEach.call(e.children, (n) => {
    n.getAttribute("aria-hidden") === "true" && t.push(n);
  }), t;
}
a(Fh, "getHiddenSiblings");
const s2 = class s2 {
  constructor() {
    this.modals = [], this.containers = [];
  }
  add(t, n) {
    let o = this.modals.indexOf(t);
    if (o !== -1)
      return o;
    o = this.modals.length, this.modals.push(t), t.modalRef && vi(t.modalRef, !1);
    const r = Fh(n);
    D3(n, t.mount, t.modalRef, r, !0);
    const i = Nl(this.containers, (l) => l.container === n);
    return i !== -1 ? (this.containers[i].modals.push(t), o) : (this.containers.push({
      modals: [t],
      container: n,
      restore: null,
      hiddenSiblings: r
    }), o);
  }
  mount(t, n) {
    const o = Nl(this.containers, (i) => i.modals.includes(t)), r = this.containers[o];
    r.restore || (r.restore = zh(r, n));
  }
  remove(t, n = !0) {
    const o = this.modals.indexOf(t);
    if (o === -1)
      return o;
    const r = Nl(this.containers, (l) => l.modals.includes(t)), i = this.containers[r];
    if (i.modals.splice(i.modals.indexOf(t), 1), this.modals.splice(o, 1), i.modals.length === 0)
      i.restore && i.restore(), t.modalRef && vi(t.modalRef, n), D3(i.container, t.mount, t.modalRef, i.hiddenSiblings, !1), this.containers.splice(r, 1);
    else {
      const l = i.modals[i.modals.length - 1];
      l.modalRef && vi(l.modalRef, !1);
    }
    return o;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
};
a(s2, "ModalManager");
let O1 = s2;
const Wh = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function Zh(e) {
  const t = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(t) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : t;
}
a(Zh, "getTabIndex");
function Uh(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const t = /* @__PURE__ */ a((o) => e.ownerDocument.querySelector(`input[type="radio"]${o}`), "getRadio");
  let n = t(`[name="${e.name}"]:checked`);
  return n || (n = t(`[name="${e.name}"]`)), n !== e;
}
a(Uh, "isNonTabbableRadio");
function Gh(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || Uh(e));
}
a(Gh, "isNodeMatchingSelectorFocusable");
function Yh(e) {
  const t = [], n = [];
  return Array.from(e.querySelectorAll(Wh)).forEach((o, r) => {
    const i = Zh(o);
    i === -1 || !Gh(o) || (i === 0 ? t.push(o) : n.push({
      documentOrder: r,
      tabIndex: i,
      node: o
    }));
  }), n.sort((o, r) => o.tabIndex === r.tabIndex ? o.documentOrder - r.documentOrder : o.tabIndex - r.tabIndex).map((o) => o.node).concat(t);
}
a(Yh, "defaultGetTabbable");
function qh() {
  return !0;
}
a(qh, "defaultIsEnabled");
function ya(e) {
  const {
    children: t,
    disableAutoFocus: n = !1,
    disableEnforceFocus: o = !1,
    disableRestoreFocus: r = !1,
    getTabbable: i = Yh,
    isEnabled: l = qh,
    open: c
  } = e, d = k.useRef(!1), u = k.useRef(null), p = k.useRef(null), f = k.useRef(null), m = k.useRef(null), b = k.useRef(!1), C = k.useRef(null), g = xt(ir(t), C), y = k.useRef(null);
  k.useEffect(() => {
    !c || !C.current || (b.current = !n);
  }, [n, c]), k.useEffect(() => {
    if (!c || !C.current)
      return;
    const x = Qt(C.current);
    return C.current.contains(x.activeElement) || (C.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), C.current.setAttribute("tabIndex", "-1")), b.current && C.current.focus()), () => {
      r || (f.current && f.current.focus && (d.current = !0, f.current.focus()), f.current = null);
    };
  }, [c]), k.useEffect(() => {
    if (!c || !C.current)
      return;
    const x = Qt(C.current), S = /* @__PURE__ */ a((P) => {
      y.current = P, !(o || !l() || P.key !== "Tab") && x.activeElement === C.current && P.shiftKey && (d.current = !0, p.current && p.current.focus());
    }, "loopFocus"), M = /* @__PURE__ */ a(() => {
      var I, v;
      const P = C.current;
      if (P === null)
        return;
      if (!x.hasFocus() || !l() || d.current) {
        d.current = !1;
        return;
      }
      if (P.contains(x.activeElement) || o && x.activeElement !== u.current && x.activeElement !== p.current)
        return;
      if (x.activeElement !== m.current)
        m.current = null;
      else if (m.current !== null)
        return;
      if (!b.current)
        return;
      let E = [];
      if ((x.activeElement === u.current || x.activeElement === p.current) && (E = i(C.current)), E.length > 0) {
        const _ = !!((I = y.current) != null && I.shiftKey && ((v = y.current) == null ? void 0 : v.key) === "Tab"), R = E[0], j = E[E.length - 1];
        typeof R != "string" && typeof j != "string" && (_ ? j.focus() : R.focus());
      } else
        P.focus();
    }, "contain");
    x.addEventListener("focusin", M), x.addEventListener("keydown", S, !0);
    const O = setInterval(() => {
      x.activeElement && x.activeElement.tagName === "BODY" && M();
    }, 50);
    return () => {
      clearInterval(O), x.removeEventListener("focusin", M), x.removeEventListener("keydown", S, !0);
    };
  }, [n, o, r, l, c, i]);
  const w = /* @__PURE__ */ a((x) => {
    f.current === null && (f.current = x.relatedTarget), b.current = !0, m.current = x.target;
    const S = t.props.onFocus;
    S && S(x);
  }, "onFocus"), T = /* @__PURE__ */ a((x) => {
    f.current === null && (f.current = x.relatedTarget), b.current = !0;
  }, "handleFocusSentinel");
  return /* @__PURE__ */ h.jsxs(k.Fragment, {
    children: [/* @__PURE__ */ h.jsx("div", {
      tabIndex: c ? 0 : -1,
      onFocus: T,
      ref: u,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ k.cloneElement(t, {
      ref: g,
      onFocus: w
    }), /* @__PURE__ */ h.jsx("div", {
      tabIndex: c ? 0 : -1,
      onFocus: T,
      ref: p,
      "data-testid": "sentinelEnd"
    })]
  });
}
a(ya, "FocusTrap");
process.env.NODE_ENV !== "production" && (ya.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: sr,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: s.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: s.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: s.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: s.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: s.func,
  /**
   * If `true`, focus is locked.
   */
  open: s.bool.isRequired
});
process.env.NODE_ENV !== "production" && (ya.propTypes = b5(ya.propTypes));
function Kh(e) {
  return typeof e == "function" ? e() : e;
}
a(Kh, "getContainer");
function Xh(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
a(Xh, "getHasTransition");
const N3 = /* @__PURE__ */ a(() => {
}, "noop$1"), ks = new O1();
function Jh(e) {
  const {
    container: t,
    disableEscapeKeyDown: n = !1,
    disableScrollLock: o = !1,
    closeAfterTransition: r = !1,
    onTransitionEnter: i,
    onTransitionExited: l,
    children: c,
    onClose: d,
    open: u,
    rootRef: p
  } = e, f = k.useRef({}), m = k.useRef(null), b = k.useRef(null), C = xt(b, p), [g, y] = k.useState(!u), w = Xh(c);
  let T = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (T = !1);
  const x = /* @__PURE__ */ a(() => Qt(m.current), "getDoc"), S = /* @__PURE__ */ a(() => (f.current.modalRef = b.current, f.current.mount = m.current, f.current), "getModal"), M = /* @__PURE__ */ a(() => {
    ks.mount(S(), {
      disableScrollLock: o
    }), b.current && (b.current.scrollTop = 0);
  }, "handleMounted"), O = Dt(() => {
    const V = Kh(t) || x().body;
    ks.add(S(), V), b.current && M();
  }), P = /* @__PURE__ */ a(() => ks.isTopModal(S()), "isTopModal"), E = Dt((V) => {
    m.current = V, V && (u && P() ? M() : b.current && vi(b.current, T));
  }), I = k.useCallback(() => {
    ks.remove(S(), T);
  }, [T]);
  k.useEffect(() => () => {
    I();
  }, [I]), k.useEffect(() => {
    u ? O() : (!w || !r) && I();
  }, [u, I, w, r, O]);
  const v = /* @__PURE__ */ a((V) => (L) => {
    var D;
    (D = V.onKeyDown) == null || D.call(V, L), !(L.key !== "Escape" || L.which === 229 || // Wait until IME is settled.
    !P()) && (n || (L.stopPropagation(), d && d(L, "escapeKeyDown")));
  }, "createHandleKeyDown"), _ = /* @__PURE__ */ a((V) => (L) => {
    var D;
    (D = V.onClick) == null || D.call(V, L), L.target === L.currentTarget && d && d(L, "backdropClick");
  }, "createHandleBackdropClick");
  return {
    getRootProps: /* @__PURE__ */ a((V = {}) => {
      const L = j5(e);
      delete L.onTransitionEnter, delete L.onTransitionExited;
      const D = {
        ...L,
        ...V
      };
      return {
        /*
         * Marking an element with the role presentation indicates to assistive technology
         * that this element should be ignored; it exists to support the web application and
         * is not meant for humans to interact with directly.
         * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
         */
        role: "presentation",
        ...D,
        onKeyDown: v(D),
        ref: C
      };
    }, "getRootProps"),
    getBackdropProps: /* @__PURE__ */ a((V = {}) => {
      const L = V;
      return {
        "aria-hidden": !0,
        ...L,
        onClick: _(L),
        open: u
      };
    }, "getBackdropProps"),
    getTransitionProps: /* @__PURE__ */ a(() => {
      const V = /* @__PURE__ */ a(() => {
        y(!1), i && i();
      }, "handleEnter"), L = /* @__PURE__ */ a(() => {
        y(!0), l && l(), r && I();
      }, "handleExited");
      return {
        onEnter: g1(V, (c == null ? void 0 : c.props.onEnter) ?? N3),
        onExited: g1(L, (c == null ? void 0 : c.props.onExited) ?? N3)
      };
    }, "getTransitionProps"),
    rootRef: C,
    portalRef: E,
    isTopModal: P,
    exited: g,
    hasTransition: w
  };
}
a(Jh, "useModal");
function Qh(e) {
  return Te("MuiModal", e);
}
a(Qh, "getModalUtilityClass");
Se("MuiModal", ["root", "hidden", "backdrop"]);
const eg = /* @__PURE__ */ a((e) => {
  const {
    open: t,
    exited: n,
    classes: o
  } = e;
  return ke({
    root: ["root", !t && n && "hidden"],
    backdrop: ["backdrop"]
  }, Qh, o);
}, "useUtilityClasses$q"), tg = ee("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.open && n.exited && t.hidden];
  }, "overridesResolver")
})(we(({
  theme: e
}) => ({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  variants: [{
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => !t.open && t.exited, "props"),
    style: {
      visibility: "hidden"
    }
  }]
}))), ng = ee(hl, {
  name: "MuiModal",
  slot: "Backdrop"
})({
  zIndex: -1
}), ml = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    name: "MuiModal",
    props: t
  }), {
    BackdropComponent: r = ng,
    BackdropProps: i,
    classes: l,
    className: c,
    closeAfterTransition: d = !1,
    children: u,
    container: p,
    component: f,
    components: m = {},
    componentsProps: b = {},
    disableAutoFocus: C = !1,
    disableEnforceFocus: g = !1,
    disableEscapeKeyDown: y = !1,
    disablePortal: w = !1,
    disableRestoreFocus: T = !1,
    disableScrollLock: x = !1,
    hideBackdrop: S = !1,
    keepMounted: M = !1,
    onClose: O,
    onTransitionEnter: P,
    onTransitionExited: E,
    open: I,
    slotProps: v = {},
    slots: _ = {},
    // eslint-disable-next-line react/prop-types
    theme: R,
    ...j
  } = o, B = {
    ...o,
    closeAfterTransition: d,
    disableAutoFocus: C,
    disableEnforceFocus: g,
    disableEscapeKeyDown: y,
    disablePortal: w,
    disableRestoreFocus: T,
    disableScrollLock: x,
    hideBackdrop: S,
    keepMounted: M
  }, {
    getRootProps: V,
    getBackdropProps: L,
    getTransitionProps: D,
    portalRef: z,
    isTopModal: H,
    exited: $,
    hasTransition: A
  } = Jh({
    ...B,
    rootRef: n
  }), U = {
    ...B,
    exited: $
  }, K = eg(U), J = {};
  if (u.props.tabIndex === void 0 && (J.tabIndex = "-1"), A) {
    const {
      onEnter: X,
      onExited: se
    } = D();
    J.onEnter = X, J.onExited = se;
  }
  const F = {
    slots: {
      root: m.Root,
      backdrop: m.Backdrop,
      ..._
    },
    slotProps: {
      ...b,
      ...v
    }
  }, [N, te] = ve("root", {
    ref: n,
    elementType: tg,
    externalForwardedProps: {
      ...F,
      ...j,
      component: f
    },
    getSlotProps: V,
    ownerState: U,
    className: le(c, K == null ? void 0 : K.root, !U.open && U.exited && (K == null ? void 0 : K.hidden))
  }), [oe, ne] = ve("backdrop", {
    ref: i == null ? void 0 : i.ref,
    elementType: r,
    externalForwardedProps: F,
    shouldForwardComponentProp: !0,
    additionalProps: i,
    getSlotProps: /* @__PURE__ */ a((X) => L({
      ...X,
      onClick: /* @__PURE__ */ a((se) => {
        X != null && X.onClick && X.onClick(se);
      }, "onClick")
    }), "getSlotProps"),
    className: le(i == null ? void 0 : i.className, K == null ? void 0 : K.backdrop),
    ownerState: U
  });
  return !M && !I && (!A || $) ? null : /* @__PURE__ */ h.jsx(Zi, {
    ref: z,
    container: p,
    disablePortal: w,
    children: /* @__PURE__ */ h.jsxs(N, {
      ...te,
      children: [!S && r ? /* @__PURE__ */ h.jsx(oe, {
        ...ne
      }) : null, /* @__PURE__ */ h.jsx(ya, {
        disableEnforceFocus: g,
        disableAutoFocus: C,
        disableRestoreFocus: T,
        isEnabled: H,
        open: I,
        children: /* @__PURE__ */ k.cloneElement(u, J)
      })]
    })
  });
}, "Modal"));
process.env.NODE_ENV !== "production" && (ml.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: s.elementType,
  /**
   * Props applied to the [`Backdrop`](https://mui.com/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: s.object,
  /**
   * A single child content element.
   */
  children: sr.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: s.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: s.shape({
    Backdrop: s.elementType,
    Root: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: s.shape({
    backdrop: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: s.oneOfType([Kn, s.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: s.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: s.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: s.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: s.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: s.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: s.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: s.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: s.bool,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: s.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: s.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: s.func,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: s.shape({
    backdrop: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: s.shape({
    backdrop: s.elementType,
    root: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function og(e) {
  return Te("MuiDialog", e);
}
a(og, "getDialogUtilityClass");
const zl = Se("MuiDialog", ["root", "scrollPaper", "scrollBody", "container", "paper", "paperScrollPaper", "paperScrollBody", "paperWidthFalse", "paperWidthXs", "paperWidthSm", "paperWidthMd", "paperWidthLg", "paperWidthXl", "paperFullWidth", "paperFullScreen"]), nd = /* @__PURE__ */ k.createContext({});
process.env.NODE_ENV !== "production" && (nd.displayName = "DialogContext");
const rg = ee(hl, {
  name: "MuiDialog",
  slot: "Backdrop",
  overrides: /* @__PURE__ */ a((e, t) => t.backdrop, "overrides")
})({
  // Improve scrollable dialog support.
  zIndex: -1
}), ig = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    scroll: n,
    maxWidth: o,
    fullWidth: r,
    fullScreen: i
  } = e, l = {
    root: ["root"],
    container: ["container", `scroll${G(n)}`],
    paper: ["paper", `paperScroll${G(n)}`, `paperWidth${G(String(o))}`, r && "paperFullWidth", i && "paperFullScreen"]
  };
  return ke(l, og, t);
}, "useUtilityClasses$p"), sg = ee(ml, {
  name: "MuiDialog",
  slot: "Root"
})({
  "@media print": {
    // Use !important to override the Modal inline-style.
    position: "absolute !important"
  }
}), ag = ee("div", {
  name: "MuiDialog",
  slot: "Container",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.container, t[`scroll${G(n.scroll)}`]];
  }, "overridesResolver")
})({
  height: "100%",
  "@media print": {
    height: "auto"
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  variants: [{
    props: {
      scroll: "paper"
    },
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  }, {
    props: {
      scroll: "body"
    },
    style: {
      overflowY: "auto",
      overflowX: "hidden",
      textAlign: "center",
      "&::after": {
        content: '""',
        display: "inline-block",
        verticalAlign: "middle",
        height: "100%",
        width: "0"
      }
    }
  }]
}), lg = ee(Ro, {
  name: "MuiDialog",
  slot: "Paper",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.paper, t[`scrollPaper${G(n.scroll)}`], t[`paperWidth${G(String(n.maxWidth))}`], n.fullWidth && t.paperFullWidth, n.fullScreen && t.paperFullScreen];
  }, "overridesResolver")
})(we(({
  theme: e
}) => ({
  margin: 32,
  position: "relative",
  overflowY: "auto",
  "@media print": {
    overflowY: "visible",
    boxShadow: "none"
  },
  variants: [{
    props: {
      scroll: "paper"
    },
    style: {
      display: "flex",
      flexDirection: "column",
      maxHeight: "calc(100% - 64px)"
    }
  }, {
    props: {
      scroll: "body"
    },
    style: {
      display: "inline-block",
      verticalAlign: "middle",
      textAlign: "initial"
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => !t.maxWidth, "props"),
    style: {
      maxWidth: "calc(100% - 64px)"
    }
  }, {
    props: {
      maxWidth: "xs"
    },
    style: {
      maxWidth: e.breakpoints.unit === "px" ? Math.max(e.breakpoints.values.xs, 444) : `max(${e.breakpoints.values.xs}${e.breakpoints.unit}, 444px)`,
      [`&.${zl.paperScrollBody}`]: {
        [e.breakpoints.down(Math.max(e.breakpoints.values.xs, 444) + 32 * 2)]: {
          maxWidth: "calc(100% - 64px)"
        }
      }
    }
  }, ...Object.keys(e.breakpoints.values).filter((t) => t !== "xs").map((t) => ({
    props: {
      maxWidth: t
    },
    style: {
      maxWidth: `${e.breakpoints.values[t]}${e.breakpoints.unit}`,
      [`&.${zl.paperScrollBody}`]: {
        [e.breakpoints.down(e.breakpoints.values[t] + 32 * 2)]: {
          maxWidth: "calc(100% - 64px)"
        }
      }
    }
  })), {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.fullWidth, "props"),
    style: {
      width: "calc(100% - 64px)"
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.fullScreen, "props"),
    style: {
      margin: 0,
      width: "100%",
      maxWidth: "100%",
      height: "100%",
      maxHeight: "none",
      borderRadius: 0,
      [`&.${zl.paperScrollBody}`]: {
        margin: 0,
        maxWidth: "100%"
      }
    }
  }]
}))), Rc = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiDialog"
  }), r = uo(), i = {
    enter: r.transitions.duration.enteringScreen,
    exit: r.transitions.duration.leavingScreen
  }, {
    "aria-describedby": l,
    "aria-labelledby": c,
    "aria-modal": d = !0,
    BackdropComponent: u,
    BackdropProps: p,
    children: f,
    className: m,
    disableEscapeKeyDown: b = !1,
    fullScreen: C = !1,
    fullWidth: g = !1,
    maxWidth: y = "sm",
    onClick: w,
    onClose: T,
    open: x,
    PaperComponent: S = Ro,
    PaperProps: M = {},
    scroll: O = "paper",
    slots: P = {},
    slotProps: E = {},
    TransitionComponent: I = ba,
    transitionDuration: v = i,
    TransitionProps: _,
    ...R
  } = o, j = {
    ...o,
    disableEscapeKeyDown: b,
    fullScreen: C,
    fullWidth: g,
    maxWidth: y,
    scroll: O
  }, B = ig(j), V = k.useRef(), L = /* @__PURE__ */ a((fe) => {
    V.current = fe.target === fe.currentTarget;
  }, "handleMouseDown"), D = /* @__PURE__ */ a((fe) => {
    w && w(fe), V.current && (V.current = null, T && T(fe, "backdropClick"));
  }, "handleBackdropClick"), z = _o(c), H = k.useMemo(() => ({
    titleId: z
  }), [z]), $ = {
    transition: I,
    ...P
  }, A = {
    transition: _,
    paper: M,
    backdrop: p,
    ...E
  }, U = {
    slots: $,
    slotProps: A
  }, [K, J] = ve("root", {
    elementType: sg,
    shouldForwardComponentProp: !0,
    externalForwardedProps: U,
    ownerState: j,
    className: le(B.root, m),
    ref: n
  }), [F, N] = ve("backdrop", {
    elementType: rg,
    shouldForwardComponentProp: !0,
    externalForwardedProps: U,
    ownerState: j
  }), [te, oe] = ve("paper", {
    elementType: lg,
    shouldForwardComponentProp: !0,
    externalForwardedProps: U,
    ownerState: j,
    className: le(B.paper, M.className)
  }), [ne, X] = ve("container", {
    elementType: ag,
    externalForwardedProps: U,
    ownerState: j,
    className: B.container
  }), [se, Y] = ve("transition", {
    elementType: ba,
    externalForwardedProps: U,
    ownerState: j,
    additionalProps: {
      appear: !0,
      in: x,
      timeout: v,
      role: "presentation"
    }
  });
  return /* @__PURE__ */ h.jsx(K, {
    closeAfterTransition: !0,
    slots: {
      backdrop: F
    },
    slotProps: {
      backdrop: {
        transitionDuration: v,
        as: u,
        ...N
      }
    },
    disableEscapeKeyDown: b,
    onClose: T,
    open: x,
    onClick: D,
    ...J,
    ...R,
    children: /* @__PURE__ */ h.jsx(se, {
      ...Y,
      children: /* @__PURE__ */ h.jsx(ne, {
        onMouseDown: L,
        ...X,
        children: /* @__PURE__ */ h.jsx(te, {
          as: S,
          elevation: 24,
          role: "dialog",
          "aria-describedby": l,
          "aria-labelledby": z,
          "aria-modal": d,
          ...oe,
          children: /* @__PURE__ */ h.jsx(nd.Provider, {
            value: H,
            children: f
          })
        })
      })
    })
  });
}, "Dialog"));
process.env.NODE_ENV !== "production" && (Rc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  "aria-describedby": s.string,
  /**
   * The id(s) of the element(s) that label the dialog.
   */
  "aria-labelledby": s.string,
  /**
   * Informs assistive technologies that the element is modal.
   * It's added on the element with role="dialog".
   * @default true
   */
  "aria-modal": s.oneOfType([s.oneOf(["false", "true"]), s.bool]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: s.elementType,
  /**
   * @ignore
   */
  BackdropProps: s.object,
  /**
   * Dialog children, usually the included sub-components.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: s.bool,
  /**
   * If `true`, the dialog is full-screen.
   * @default false
   */
  fullScreen: s.bool,
  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'sm'
   */
  maxWidth: s.oneOfType([s.oneOf(["xs", "sm", "md", "lg", "xl", !1]), s.string]),
  /**
   * @ignore
   */
  onClick: s.func,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: s.func,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  /**
   * The component used to render the body of the dialog.
   * @default Paper
   */
  PaperComponent: s.elementType,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   * @default {}
   * @deprecated Use `slotProps.paper` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PaperProps: s.object,
  /**
   * Determine the container for scrolling the dialog.
   * @default 'paper'
   */
  scroll: s.oneOf(["body", "paper"]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    backdrop: s.oneOfType([s.func, s.object]),
    container: s.oneOfType([s.func, s.object]),
    paper: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object]),
    transition: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    backdrop: s.elementType,
    container: s.elementType,
    paper: s.elementType,
    root: s.elementType,
    transition: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   * @deprecated Use `slots.transition` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: s.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: s.oneOfType([s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionProps: s.object
});
const z3 = Se("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]);
function cg(e, t, n) {
  const o = t.getBoundingClientRect(), r = n && n.getBoundingClientRect(), i = dn(t);
  let l;
  if (t.fakeTransform)
    l = t.fakeTransform;
  else {
    const u = i.getComputedStyle(t);
    l = u.getPropertyValue("-webkit-transform") || u.getPropertyValue("transform");
  }
  let c = 0, d = 0;
  if (l && l !== "none" && typeof l == "string") {
    const u = l.split("(")[1].split(")")[0].split(",");
    c = parseInt(u[4], 10), d = parseInt(u[5], 10);
  }
  return e === "left" ? r ? `translateX(${r.right + c - o.left}px)` : `translateX(${i.innerWidth + c - o.left}px)` : e === "right" ? r ? `translateX(-${o.right - r.left - c}px)` : `translateX(-${o.left + o.width - c}px)` : e === "up" ? r ? `translateY(${r.bottom + d - o.top}px)` : `translateY(${i.innerHeight + d - o.top}px)` : r ? `translateY(-${o.top - r.top + o.height - d}px)` : `translateY(-${o.top + o.height - d}px)`;
}
a(cg, "getTranslateValue");
function od(e) {
  return typeof e == "function" ? e() : e;
}
a(od, "resolveContainer");
function Os(e, t, n) {
  const o = od(n), r = cg(e, t, o);
  r && (t.style.webkitTransform = r, t.style.transform = r);
}
a(Os, "setTranslateValue");
const Ic = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = uo(), r = {
    enter: o.transitions.easing.easeOut,
    exit: o.transitions.easing.sharp
  }, i = {
    enter: o.transitions.duration.enteringScreen,
    exit: o.transitions.duration.leavingScreen
  }, {
    addEndListener: l,
    appear: c = !0,
    children: d,
    container: u,
    direction: p = "down",
    easing: f = r,
    in: m,
    onEnter: b,
    onEntered: C,
    onEntering: g,
    onExit: y,
    onExited: w,
    onExiting: T,
    style: x,
    timeout: S = i,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: M = On,
    ...O
  } = t, P = k.useRef(null), E = xt(ir(d), P, n), I = /* @__PURE__ */ a((z) => (H) => {
    z && (H === void 0 ? z(P.current) : z(P.current, H));
  }, "normalizedTransitionCallback"), v = I((z, H) => {
    Os(p, z, u), xc(z), b && b(z, H);
  }), _ = I((z, H) => {
    const $ = Eo({
      timeout: S,
      style: x,
      easing: f
    }, {
      mode: "enter"
    });
    z.style.webkitTransition = o.transitions.create("-webkit-transform", {
      ...$
    }), z.style.transition = o.transitions.create("transform", {
      ...$
    }), z.style.webkitTransform = "none", z.style.transform = "none", g && g(z, H);
  }), R = I(C), j = I(T), B = I((z) => {
    const H = Eo({
      timeout: S,
      style: x,
      easing: f
    }, {
      mode: "exit"
    });
    z.style.webkitTransition = o.transitions.create("-webkit-transform", H), z.style.transition = o.transitions.create("transform", H), Os(p, z, u), y && y(z);
  }), V = I((z) => {
    z.style.webkitTransition = "", z.style.transition = "", w && w(z);
  }), L = /* @__PURE__ */ a((z) => {
    l && l(P.current, z);
  }, "handleAddEndListener"), D = k.useCallback(() => {
    P.current && Os(p, P.current, u);
  }, [p, u]);
  return k.useEffect(() => {
    if (m || p === "down" || p === "right")
      return;
    const z = ss(() => {
      P.current && Os(p, P.current, u);
    }), H = dn(P.current);
    return H.addEventListener("resize", z), () => {
      z.clear(), H.removeEventListener("resize", z);
    };
  }, [p, m, u]), k.useEffect(() => {
    m || D();
  }, [m, D]), /* @__PURE__ */ h.jsx(M, {
    nodeRef: P,
    onEnter: v,
    onEntered: R,
    onEntering: _,
    onExit: B,
    onExited: V,
    onExiting: j,
    addEndListener: L,
    appear: c,
    in: m,
    timeout: S,
    ...O,
    children: /* @__PURE__ */ a((z, {
      ownerState: H,
      ...$
    }) => /* @__PURE__ */ k.cloneElement(d, {
      ref: E,
      style: {
        visibility: z === "exited" && !m ? "hidden" : void 0,
        ...x,
        ...d.props.style
      },
      ...$
    }), "children")
  });
}, "Slide"));
process.env.NODE_ENV !== "production" && (Ic.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: s.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: s.bool,
  /**
   * A single child content element.
   */
  children: sr.isRequired,
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the container the Slide is transitioning from.
   */
  container: In(s.oneOfType([Kn, s.func]), (e) => {
    if (e.open) {
      const t = od(e.container);
      if (t && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `container` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `container` prop provided to the component is invalid.", "It should be an HTML element instance."].join(`
`));
    }
    return null;
  }),
  /**
   * Direction the child node will enter from.
   * @default 'down'
   */
  direction: s.oneOf(["down", "left", "right", "up"]),
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   * @default {
   *   enter: theme.transitions.easing.easeOut,
   *   exit: theme.transitions.easing.sharp,
   * }
   */
  easing: s.oneOfType([s.shape({
    enter: s.string,
    exit: s.string
  }), s.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: s.bool,
  /**
   * @ignore
   */
  onEnter: s.func,
  /**
   * @ignore
   */
  onEntered: s.func,
  /**
   * @ignore
   */
  onEntering: s.func,
  /**
   * @ignore
   */
  onExit: s.func,
  /**
   * @ignore
   */
  onExited: s.func,
  /**
   * @ignore
   */
  onExiting: s.func,
  /**
   * @ignore
   */
  style: s.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: s.oneOfType([s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })])
});
function dg(e) {
  return Te("MuiDrawer", e);
}
a(dg, "getDrawerUtilityClass");
Se("MuiDrawer", ["root", "docked", "paper", "anchorLeft", "anchorRight", "anchorTop", "anchorBottom", "paperAnchorLeft", "paperAnchorRight", "paperAnchorTop", "paperAnchorBottom", "paperAnchorDockedLeft", "paperAnchorDockedRight", "paperAnchorDockedTop", "paperAnchorDockedBottom", "modal"]);
const rd = /* @__PURE__ */ a((e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, (n.variant === "permanent" || n.variant === "persistent") && t.docked, t.modal];
}, "overridesResolver$2"), ug = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    anchor: n,
    variant: o
  } = e, r = {
    root: ["root", `anchor${G(n)}`],
    docked: [(o === "permanent" || o === "persistent") && "docked"],
    modal: ["modal"],
    paper: ["paper", `paperAnchor${G(n)}`, o !== "temporary" && `paperAnchorDocked${G(n)}`]
  };
  return ke(r, dg, t);
}, "useUtilityClasses$o"), pg = ee(ml, {
  name: "MuiDrawer",
  slot: "Root",
  overridesResolver: rd
})(we(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.drawer
}))), fg = ee("div", {
  shouldForwardProp: Vt,
  name: "MuiDrawer",
  slot: "Docked",
  skipVariantsResolver: !1,
  overridesResolver: rd
})({
  flex: "0 0 auto"
}), hg = ee(Ro, {
  name: "MuiDrawer",
  slot: "Paper",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.paper, t[`paperAnchor${G(n.anchor)}`], n.variant !== "temporary" && t[`paperAnchorDocked${G(n.anchor)}`]];
  }, "overridesResolver")
})(we(({
  theme: e
}) => ({
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  flex: "1 0 auto",
  zIndex: (e.vars || e).zIndex.drawer,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  // temporary style
  position: "fixed",
  top: 0,
  // We disable the focus ring for mouse, touch and keyboard users.
  // At some point, it would be better to keep it for keyboard users.
  // :focus-ring CSS pseudo-class will help.
  outline: 0,
  variants: [{
    props: {
      anchor: "left"
    },
    style: {
      left: 0
    }
  }, {
    props: {
      anchor: "top"
    },
    style: {
      top: 0,
      left: 0,
      right: 0,
      height: "auto",
      maxHeight: "100%"
    }
  }, {
    props: {
      anchor: "right"
    },
    style: {
      right: 0
    }
  }, {
    props: {
      anchor: "bottom"
    },
    style: {
      top: "auto",
      left: 0,
      bottom: 0,
      right: 0,
      height: "auto",
      maxHeight: "100%"
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.anchor === "left" && t.variant !== "temporary", "props"),
    style: {
      borderRight: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.anchor === "top" && t.variant !== "temporary", "props"),
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.anchor === "right" && t.variant !== "temporary", "props"),
    style: {
      borderLeft: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.anchor === "bottom" && t.variant !== "temporary", "props"),
    style: {
      borderTop: `1px solid ${(e.vars || e).palette.divider}`
    }
  }]
}))), id = {
  left: "right",
  right: "left",
  top: "down",
  bottom: "up"
};
function gg(e) {
  return ["left", "right"].includes(e);
}
a(gg, "isHorizontal");
function mg({
  direction: e
}, t) {
  return e === "rtl" && gg(t) ? id[t] : t;
}
a(mg, "getAnchor");
const jc = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiDrawer"
  }), r = uo(), i = Dr(), l = {
    enter: r.transitions.duration.enteringScreen,
    exit: r.transitions.duration.leavingScreen
  }, {
    anchor: c = "left",
    BackdropProps: d,
    children: u,
    className: p,
    elevation: f = 16,
    hideBackdrop: m = !1,
    ModalProps: {
      BackdropProps: b,
      ...C
    } = {},
    onClose: g,
    open: y = !1,
    PaperProps: w = {},
    SlideProps: T,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: x,
    transitionDuration: S = l,
    variant: M = "temporary",
    slots: O = {},
    slotProps: P = {},
    ...E
  } = o, I = k.useRef(!1);
  k.useEffect(() => {
    I.current = !0;
  }, []);
  const v = mg({
    direction: i ? "rtl" : "ltr"
  }, c), R = {
    ...o,
    anchor: c,
    elevation: f,
    open: y,
    variant: M,
    ...E
  }, j = ug(R), B = {
    slots: {
      transition: x,
      ...O
    },
    slotProps: {
      paper: w,
      transition: T,
      ...P,
      backdrop: bc(P.backdrop || {
        ...d,
        ...b
      }, {
        transitionDuration: S
      })
    }
  }, [V, L] = ve("root", {
    ref: n,
    elementType: pg,
    className: le(j.root, j.modal, p),
    shouldForwardComponentProp: !0,
    ownerState: R,
    externalForwardedProps: {
      ...B,
      ...E,
      ...C
    },
    additionalProps: {
      open: y,
      onClose: g,
      hideBackdrop: m,
      slots: {
        backdrop: B.slots.backdrop
      },
      slotProps: {
        backdrop: B.slotProps.backdrop
      }
    }
  }), [D, z] = ve("paper", {
    elementType: hg,
    shouldForwardComponentProp: !0,
    className: le(j.paper, w.className),
    ownerState: R,
    externalForwardedProps: B,
    additionalProps: {
      elevation: M === "temporary" ? f : 0,
      square: !0
    }
  }), [H, $] = ve("docked", {
    elementType: fg,
    ref: n,
    className: le(j.root, j.docked, p),
    ownerState: R,
    externalForwardedProps: B,
    additionalProps: E
    // pass `other` here because `DockedSlot` is also a root slot for some variants
  }), [A, U] = ve("transition", {
    elementType: Ic,
    ownerState: R,
    externalForwardedProps: B,
    additionalProps: {
      in: y,
      direction: id[v],
      timeout: S,
      appear: I.current
    }
  }), K = /* @__PURE__ */ h.jsx(D, {
    ...z,
    children: u
  });
  if (M === "permanent")
    return /* @__PURE__ */ h.jsx(H, {
      ...$,
      children: K
    });
  const J = /* @__PURE__ */ h.jsx(A, {
    ...U,
    children: K
  });
  return M === "persistent" ? /* @__PURE__ */ h.jsx(H, {
    ...$,
    children: J
  }) : /* @__PURE__ */ h.jsx(V, {
    ...L,
    children: J
  });
}, "Drawer"));
process.env.NODE_ENV !== "production" && (jc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Side from which the drawer will appear.
   * @default 'left'
   */
  anchor: s.oneOf(["bottom", "left", "right", "top"]),
  /**
   * @ignore
   */
  BackdropProps: s.object,
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The elevation of the drawer.
   * @default 16
   */
  elevation: il,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: s.bool,
  /**
   * Props applied to the [`Modal`](https://mui.com/material-ui/api/modal/) element.
   * @default {}
   */
  ModalProps: s.object,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: s.func,
  /**
   * If `true`, the component is shown.
   * @default false
   */
  open: s.bool,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   * @deprecated use the `slotProps.paper` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  PaperProps: s.object,
  /**
   * Props applied to the [`Slide`](https://mui.com/material-ui/api/slide/) element.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  SlideProps: s.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    backdrop: s.oneOfType([s.func, s.object]),
    docked: s.oneOfType([s.func, s.object]),
    paper: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object]),
    transition: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    backdrop: s.elementType,
    docked: s.elementType,
    paper: s.elementType,
    root: s.elementType,
    transition: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: s.oneOfType([s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })]),
  /**
   * The variant to use.
   * @default 'temporary'
   */
  variant: s.oneOf(["permanent", "persistent", "temporary"])
});
const bg = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    disableUnderline: n,
    startAdornment: o,
    endAdornment: r,
    size: i,
    hiddenLabel: l,
    multiline: c
  } = e, d = {
    root: ["root", !n && "underline", o && "adornedStart", r && "adornedEnd", i === "small" && `size${G(i)}`, l && "hiddenLabel", c && "multiline"],
    input: ["input"]
  }, u = ke(d, q9, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...u
  };
}, "useUtilityClasses$n"), Cg = ee(dl, {
  shouldForwardProp: /* @__PURE__ */ a((e) => Vt(e) || e === "classes", "shouldForwardProp"),
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [...ll(e, t), !n.disableUnderline && t.underline];
  }, "overridesResolver")
})(we(({
  theme: e
}) => {
  const t = e.palette.mode === "light", n = t ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", o = t ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", r = t ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", i = t ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return {
    position: "relative",
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : o,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : r,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : o
      }
    },
    [`&.${sn.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : o
    },
    [`&.${sn.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : i
    },
    variants: [{
      props: /* @__PURE__ */ a(({
        ownerState: l
      }) => !l.disableUnderline, "props"),
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${sn.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${sn.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : n}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${sn.disabled}, .${sn.error}):before`]: {
          borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
        },
        [`&.${sn.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(e.palette).filter(bt()).map(([l]) => {
      var c;
      return {
        props: {
          disableUnderline: !1,
          color: l
        },
        style: {
          "&::after": {
            borderBottom: `2px solid ${(c = (e.vars || e).palette[l]) == null ? void 0 : c.main}`
          }
        }
      };
    }), {
      props: /* @__PURE__ */ a(({
        ownerState: l
      }) => l.startAdornment, "props"),
      style: {
        paddingLeft: 12
      }
    }, {
      props: /* @__PURE__ */ a(({
        ownerState: l
      }) => l.endAdornment, "props"),
      style: {
        paddingRight: 12
      }
    }, {
      props: /* @__PURE__ */ a(({
        ownerState: l
      }) => l.multiline, "props"),
      style: {
        padding: "25px 12px 8px"
      }
    }, {
      props: /* @__PURE__ */ a(({
        ownerState: l,
        size: c
      }) => l.multiline && c === "small", "props"),
      style: {
        paddingTop: 21,
        paddingBottom: 4
      }
    }, {
      props: /* @__PURE__ */ a(({
        ownerState: l
      }) => l.multiline && l.hiddenLabel, "props"),
      style: {
        paddingTop: 16,
        paddingBottom: 17
      }
    }, {
      props: /* @__PURE__ */ a(({
        ownerState: l
      }) => l.multiline && l.hiddenLabel && l.size === "small", "props"),
      style: {
        paddingTop: 8,
        paddingBottom: 9
      }
    }]
  };
})), yg = ee(ul, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: cl
})(we(({
  theme: e
}) => ({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
  ...!e.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
      caretColor: e.palette.mode === "light" ? null : "#fff",
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    }
  },
  ...e.vars && {
    "&:-webkit-autofill": {
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    },
    [e.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      paddingTop: 21,
      paddingBottom: 4
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.hiddenLabel, "props"),
    style: {
      paddingTop: 16,
      paddingBottom: 17
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.startAdornment, "props"),
    style: {
      paddingLeft: 0
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.endAdornment, "props"),
    style: {
      paddingRight: 0
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.hiddenLabel && t.size === "small", "props"),
    style: {
      paddingTop: 8,
      paddingBottom: 9
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.multiline, "props"),
    style: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    }
  }]
}))), bl = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiFilledInput"
  }), {
    disableUnderline: r = !1,
    components: i = {},
    componentsProps: l,
    fullWidth: c = !1,
    hiddenLabel: d,
    // declare here to prevent spreading to DOM
    inputComponent: u = "input",
    multiline: p = !1,
    slotProps: f,
    slots: m = {},
    type: b = "text",
    ...C
  } = o, g = {
    ...o,
    disableUnderline: r,
    fullWidth: c,
    inputComponent: u,
    multiline: p,
    type: b
  }, y = bg(o), w = {
    root: {
      ownerState: g
    },
    input: {
      ownerState: g
    }
  }, T = f ?? l ? zt(w, f ?? l) : w, x = m.root ?? i.Root ?? Cg, S = m.input ?? i.Input ?? yg;
  return /* @__PURE__ */ h.jsx(pl, {
    slots: {
      root: x,
      input: S
    },
    slotProps: T,
    fullWidth: c,
    inputComponent: u,
    multiline: p,
    ref: n,
    type: b,
    ...C,
    classes: y
  });
}, "FilledInput"));
process.env.NODE_ENV !== "production" && (bl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: s.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary"]), s.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: s.shape({
    Input: s.elementType,
    Root: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: s.shape({
    input: s.object,
    root: s.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: s.bool,
  /**
   * If `true`, the input will not have an underline.
   * @default false
   */
  disableUnderline: s.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: s.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: s.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: s.bool,
  /**
   * The id of the `input` element.
   */
  id: s.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: s.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Wt,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: s.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: s.oneOfType([s.number, s.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: s.oneOfType([s.number, s.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: s.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: s.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: s.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: s.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: s.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: s.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: s.oneOfType([s.number, s.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: s.shape({
    input: s.object,
    root: s.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: s.shape({
    input: s.elementType,
    root: s.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: s.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
   * @default 'text'
   */
  type: s.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: s.any
});
bl.muiName = "Input";
function xg(e) {
  return Te("MuiFormControl", e);
}
a(xg, "getFormControlUtilityClasses");
Se("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]);
const vg = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    margin: n,
    fullWidth: o
  } = e, r = {
    root: ["root", n !== "none" && `margin${G(n)}`, o && "fullWidth"]
  };
  return ke(r, xg, t);
}, "useUtilityClasses$m"), wg = ee("div", {
  name: "MuiFormControl",
  slot: "Root",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`margin${G(n.margin)}`], n.fullWidth && t.fullWidth];
  }, "overridesResolver")
})({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top",
  // Fix alignment issue on Safari.
  variants: [{
    props: {
      margin: "normal"
    },
    style: {
      marginTop: 16,
      marginBottom: 8
    }
  }, {
    props: {
      margin: "dense"
    },
    style: {
      marginTop: 8,
      marginBottom: 4
    }
  }, {
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }]
}), ar = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiFormControl"
  }), {
    children: r,
    className: i,
    color: l = "primary",
    component: c = "div",
    disabled: d = !1,
    error: u = !1,
    focused: p,
    fullWidth: f = !1,
    hiddenLabel: m = !1,
    margin: b = "none",
    required: C = !1,
    size: g = "medium",
    variant: y = "outlined",
    ...w
  } = o, T = {
    ...o,
    color: l,
    component: c,
    disabled: d,
    error: u,
    fullWidth: f,
    hiddenLabel: m,
    margin: b,
    required: C,
    size: g,
    variant: y
  }, x = vg(T), [S, M] = k.useState(() => {
    let L = !1;
    return r && k.Children.forEach(r, (D) => {
      if (!Bl(D, ["Input", "Select"]))
        return;
      const z = Bl(D, ["Select"]) ? D.props.input : D;
      z && W9(z.props) && (L = !0);
    }), L;
  }), [O, P] = k.useState(() => {
    let L = !1;
    return r && k.Children.forEach(r, (D) => {
      Bl(D, ["Input", "Select"]) && (ma(D.props, !0) || ma(D.props.inputProps, !0)) && (L = !0);
    }), L;
  }), [E, I] = k.useState(!1);
  d && E && I(!1);
  const v = p !== void 0 && !d ? p : E;
  let _;
  const R = k.useRef(!1);
  process.env.NODE_ENV !== "production" && (_ = /* @__PURE__ */ a(() => (R.current && console.error(["MUI: There are multiple `InputBase` components inside a FormControl.", "This creates visual inconsistencies, only use one `InputBase`."].join(`
`)), R.current = !0, () => {
    R.current = !1;
  }), "registerEffect"));
  const j = k.useCallback(() => {
    P(!0);
  }, []), B = k.useCallback(() => {
    P(!1);
  }, []), V = k.useMemo(() => ({
    adornedStart: S,
    setAdornedStart: M,
    color: l,
    disabled: d,
    error: u,
    filled: O,
    focused: v,
    fullWidth: f,
    hiddenLabel: m,
    size: g,
    onBlur: /* @__PURE__ */ a(() => {
      I(!1);
    }, "onBlur"),
    onFocus: /* @__PURE__ */ a(() => {
      I(!0);
    }, "onFocus"),
    onEmpty: B,
    onFilled: j,
    registerEffect: _,
    required: C,
    variant: y
  }), [S, l, d, u, O, v, f, m, _, B, j, C, g, y]);
  return /* @__PURE__ */ h.jsx(ds.Provider, {
    value: V,
    children: /* @__PURE__ */ h.jsx(wg, {
      as: c,
      ownerState: T,
      className: le(x.root, i),
      ref: n,
      ...w,
      children: r
    })
  });
}, "FormControl"));
process.env.NODE_ENV !== "production" && (ar.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: s.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: s.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: s.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: s.oneOf(["dense", "none", "normal"]),
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: s.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["medium", "small"]), s.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: s.oneOf(["filled", "outlined", "standard"])
});
function Sg(e) {
  return Te("MuiFormControlLabel", e);
}
a(Sg, "getFormControlLabelUtilityClasses");
const pi = Se("MuiFormControlLabel", ["root", "labelPlacementStart", "labelPlacementTop", "labelPlacementBottom", "disabled", "label", "error", "required", "asterisk"]), Mg = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    disabled: n,
    labelPlacement: o,
    error: r,
    required: i
  } = e, l = {
    root: ["root", n && "disabled", `labelPlacement${G(o)}`, r && "error", i && "required"],
    label: ["label", n && "disabled"],
    asterisk: ["asterisk", r && "error"]
  };
  return ke(l, Sg, t);
}, "useUtilityClasses$l"), Tg = ee("label", {
  name: "MuiFormControlLabel",
  slot: "Root",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${pi.label}`]: t.label
    }, t.root, t[`labelPlacement${G(n.labelPlacement)}`]];
  }, "overridesResolver")
})(we(({
  theme: e
}) => ({
  display: "inline-flex",
  alignItems: "center",
  cursor: "pointer",
  // For correct alignment with the text.
  verticalAlign: "middle",
  WebkitTapHighlightColor: "transparent",
  marginLeft: -11,
  marginRight: 16,
  // used for row presentation of radio/checkbox
  [`&.${pi.disabled}`]: {
    cursor: "default"
  },
  [`& .${pi.label}`]: {
    [`&.${pi.disabled}`]: {
      color: (e.vars || e).palette.text.disabled
    }
  },
  variants: [{
    props: {
      labelPlacement: "start"
    },
    style: {
      flexDirection: "row-reverse",
      marginRight: -11
    }
  }, {
    props: {
      labelPlacement: "top"
    },
    style: {
      flexDirection: "column-reverse"
    }
  }, {
    props: {
      labelPlacement: "bottom"
    },
    style: {
      flexDirection: "column"
    }
  }, {
    props: /* @__PURE__ */ a(({
      labelPlacement: t
    }) => t === "start" || t === "top" || t === "bottom", "props"),
    style: {
      marginLeft: 16
      // used for row presentation of radio/checkbox
    }
  }]
}))), kg = ee("span", {
  name: "MuiFormControlLabel",
  slot: "Asterisk"
})(we(({
  theme: e
}) => ({
  [`&.${pi.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}))), Lc = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiFormControlLabel"
  }), {
    checked: r,
    className: i,
    componentsProps: l = {},
    control: c,
    disabled: d,
    disableTypography: u,
    inputRef: p,
    label: f,
    labelPlacement: m = "end",
    name: b,
    onChange: C,
    required: g,
    slots: y = {},
    slotProps: w = {},
    value: T,
    ...x
  } = o, S = jn(), M = d ?? c.props.disabled ?? (S == null ? void 0 : S.disabled), O = g ?? c.props.required, P = {
    disabled: M,
    required: O
  };
  ["checked", "name", "onChange", "value", "inputRef"].forEach((V) => {
    typeof c.props[V] > "u" && typeof o[V] < "u" && (P[V] = o[V]);
  });
  const E = Lo({
    props: o,
    muiFormControl: S,
    states: ["error"]
  }), I = {
    ...o,
    disabled: M,
    labelPlacement: m,
    required: O,
    error: E.error
  }, v = Mg(I), _ = {
    slots: y,
    slotProps: {
      ...l,
      ...w
    }
  }, [R, j] = ve("typography", {
    elementType: pa,
    externalForwardedProps: _,
    ownerState: I
  });
  let B = f;
  return B != null && B.type !== pa && !u && (B = /* @__PURE__ */ h.jsx(R, {
    component: "span",
    ...j,
    className: le(v.label, j == null ? void 0 : j.className),
    children: B
  })), /* @__PURE__ */ h.jsxs(Tg, {
    className: le(v.root, i),
    ownerState: I,
    ref: n,
    ...x,
    children: [/* @__PURE__ */ k.cloneElement(c, P), O ? /* @__PURE__ */ h.jsxs("div", {
      children: [B, /* @__PURE__ */ h.jsxs(kg, {
        ownerState: I,
        "aria-hidden": !0,
        className: v.asterisk,
        children: [" ", "*"]
      })]
    }) : B]
  });
}, "FormControlLabel"));
process.env.NODE_ENV !== "production" && (Lc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component appears selected.
   */
  checked: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The props used for each slot inside.
   * @default {}
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: s.shape({
    typography: s.object
  }),
  /**
   * A control element. For instance, it can be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: s.element.isRequired,
  /**
   * If `true`, the control is disabled.
   */
  disabled: s.bool,
  /**
   * If `true`, the label is rendered as it is passed without an additional typography node.
   */
  disableTypography: s.bool,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Wt,
  /**
   * A text or an element to be used in an enclosing label element.
   */
  label: s.node,
  /**
   * The position of the label.
   * @default 'end'
   */
  labelPlacement: s.oneOf(["bottom", "end", "start", "top"]),
  /**
   * @ignore
   */
  name: s.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: s.func,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: s.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    typography: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    typography: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The value of the component.
   */
  value: s.any
});
function Og(e) {
  return Te("MuiFormGroup", e);
}
a(Og, "getFormGroupUtilityClass");
Se("MuiFormGroup", ["root", "row", "error"]);
const Eg = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    row: n,
    error: o
  } = e;
  return ke({
    root: ["root", n && "row", o && "error"]
  }, Og, t);
}, "useUtilityClasses$k"), $g = ee("div", {
  name: "MuiFormGroup",
  slot: "Root",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.row && t.row];
  }, "overridesResolver")
})({
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap",
  variants: [{
    props: {
      row: !0
    },
    style: {
      flexDirection: "row"
    }
  }]
}), Vc = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiFormGroup"
  }), {
    className: r,
    row: i = !1,
    ...l
  } = o, c = jn(), d = Lo({
    props: o,
    muiFormControl: c,
    states: ["error"]
  }), u = {
    ...o,
    row: i,
    error: d.error
  }, p = Eg(u);
  return /* @__PURE__ */ h.jsx($g, {
    className: le(p.root, r),
    ownerState: u,
    ref: n,
    ...l
  });
}, "FormGroup"));
process.env.NODE_ENV !== "production" && (Vc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * Display group of elements in a compact row.
   * @default false
   */
  row: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function Pg(e) {
  return Te("MuiFormHelperText", e);
}
a(Pg, "getFormHelperTextUtilityClasses");
const F3 = Se("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]);
var W3;
const _g = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    contained: n,
    size: o,
    disabled: r,
    error: i,
    filled: l,
    focused: c,
    required: d
  } = e, u = {
    root: ["root", r && "disabled", i && "error", o && `size${G(o)}`, n && "contained", c && "focused", l && "filled", d && "required"]
  };
  return ke(u, Pg, t);
}, "useUtilityClasses$j"), Rg = ee("p", {
  name: "MuiFormHelperText",
  slot: "Root",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.size && t[`size${G(n.size)}`], n.contained && t.contained, n.filled && t.filled];
  }, "overridesResolver")
})(we(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  ...e.typography.caption,
  textAlign: "left",
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${F3.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${F3.error}`]: {
    color: (e.vars || e).palette.error.main
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginTop: 4
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.contained, "props"),
    style: {
      marginLeft: 14,
      marginRight: 14
    }
  }]
}))), sd = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiFormHelperText"
  }), {
    children: r,
    className: i,
    component: l = "p",
    disabled: c,
    error: d,
    filled: u,
    focused: p,
    margin: f,
    required: m,
    variant: b,
    ...C
  } = o, g = jn(), y = Lo({
    props: o,
    muiFormControl: g,
    states: ["variant", "size", "disabled", "error", "filled", "focused", "required"]
  }), w = {
    ...o,
    component: l,
    contained: y.variant === "filled" || y.variant === "outlined",
    variant: y.variant,
    size: y.size,
    disabled: y.disabled,
    error: y.error,
    filled: y.filled,
    focused: y.focused,
    required: y.required
  };
  delete w.ownerState;
  const T = _g(w);
  return /* @__PURE__ */ h.jsx(Rg, {
    as: l,
    className: le(T.root, i),
    ref: n,
    ...C,
    ownerState: w,
    children: r === " " ? (
      // notranslate needed while Google Translate will not fix zero-width space issue
      W3 || (W3 = /* @__PURE__ */ h.jsx("span", {
        className: "notranslate",
        "aria-hidden": !0,
        children: "​"
      }))
    ) : r
  });
}, "FormHelperText"));
process.env.NODE_ENV !== "production" && (sd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: s.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: s.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: s.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: s.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: s.oneOf(["dense"]),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The variant to use.
   */
  variant: s.oneOfType([s.oneOf(["filled", "outlined", "standard"]), s.string])
});
function Ig(e) {
  return Te("MuiFormLabel", e);
}
a(Ig, "getFormLabelUtilityClasses");
const wi = Se("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]), jg = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    color: n,
    focused: o,
    disabled: r,
    error: i,
    filled: l,
    required: c
  } = e, d = {
    root: ["root", `color${G(n)}`, r && "disabled", i && "error", l && "filled", o && "focused", c && "required"],
    asterisk: ["asterisk", i && "error"]
  };
  return ke(d, Ig, t);
}, "useUtilityClasses$i"), Lg = ee("label", {
  name: "MuiFormLabel",
  slot: "Root",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color === "secondary" && t.colorSecondary, n.filled && t.filled];
  }, "overridesResolver")
})(we(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  ...e.typography.body1,
  lineHeight: "1.4375em",
  padding: 0,
  position: "relative",
  variants: [...Object.entries(e.palette).filter(bt()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${wi.focused}`]: {
        color: (e.vars || e).palette[t].main
      }
    }
  })), {
    props: {},
    style: {
      [`&.${wi.disabled}`]: {
        color: (e.vars || e).palette.text.disabled
      },
      [`&.${wi.error}`]: {
        color: (e.vars || e).palette.error.main
      }
    }
  }]
}))), Vg = ee("span", {
  name: "MuiFormLabel",
  slot: "Asterisk"
})(we(({
  theme: e
}) => ({
  [`&.${wi.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}))), _n = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiFormLabel"
  }), {
    children: r,
    className: i,
    color: l,
    component: c = "label",
    disabled: d,
    error: u,
    filled: p,
    focused: f,
    required: m,
    ...b
  } = o, C = jn(), g = Lo({
    props: o,
    muiFormControl: C,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  }), y = {
    ...o,
    color: g.color || "primary",
    component: c,
    disabled: g.disabled,
    error: g.error,
    filled: g.filled,
    focused: g.focused,
    required: g.required
  }, w = jg(y);
  return /* @__PURE__ */ h.jsxs(Lg, {
    as: c,
    ownerState: y,
    className: le(w.root, i),
    ref: n,
    ...b,
    children: [r, g.required && /* @__PURE__ */ h.jsxs(Vg, {
      ownerState: y,
      "aria-hidden": !0,
      className: w.asterisk,
      children: [" ", "*"]
    })]
  });
}, "FormLabel"));
process.env.NODE_ENV !== "production" && (_n.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: s.oneOfType([s.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: s.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: s.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: s.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: s.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function E1(e) {
  return `scale(${e}, ${e ** 2})`;
}
a(E1, "getScale");
const Ag = {
  entering: {
    opacity: 1,
    transform: E1(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, Fl = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), Ui = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const {
    addEndListener: o,
    appear: r = !0,
    children: i,
    easing: l,
    in: c,
    onEnter: d,
    onEntered: u,
    onEntering: p,
    onExit: f,
    onExited: m,
    onExiting: b,
    style: C,
    timeout: g = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: y = On,
    ...w
  } = t, T = qo(), x = k.useRef(), S = uo(), M = k.useRef(null), O = xt(M, ir(i), n), P = /* @__PURE__ */ a((V) => (L) => {
    if (V) {
      const D = M.current;
      L === void 0 ? V(D) : V(D, L);
    }
  }, "normalizedTransitionCallback"), E = P(p), I = P((V, L) => {
    xc(V);
    const {
      duration: D,
      delay: z,
      easing: H
    } = Eo({
      style: C,
      timeout: g,
      easing: l
    }, {
      mode: "enter"
    });
    let $;
    g === "auto" ? ($ = S.transitions.getAutoHeightDuration(V.clientHeight), x.current = $) : $ = D, V.style.transition = [S.transitions.create("opacity", {
      duration: $,
      delay: z
    }), S.transitions.create("transform", {
      duration: Fl ? $ : $ * 0.666,
      delay: z,
      easing: H
    })].join(","), d && d(V, L);
  }), v = P(u), _ = P(b), R = P((V) => {
    const {
      duration: L,
      delay: D,
      easing: z
    } = Eo({
      style: C,
      timeout: g,
      easing: l
    }, {
      mode: "exit"
    });
    let H;
    g === "auto" ? (H = S.transitions.getAutoHeightDuration(V.clientHeight), x.current = H) : H = L, V.style.transition = [S.transitions.create("opacity", {
      duration: H,
      delay: D
    }), S.transitions.create("transform", {
      duration: Fl ? H : H * 0.666,
      delay: Fl ? D : D || H * 0.333,
      easing: z
    })].join(","), V.style.opacity = 0, V.style.transform = E1(0.75), f && f(V);
  }), j = P(m), B = /* @__PURE__ */ a((V) => {
    g === "auto" && T.start(x.current || 0, V), o && o(M.current, V);
  }, "handleAddEndListener");
  return /* @__PURE__ */ h.jsx(y, {
    appear: r,
    in: c,
    nodeRef: M,
    onEnter: I,
    onEntered: v,
    onEntering: E,
    onExit: R,
    onExited: j,
    onExiting: _,
    addEndListener: B,
    timeout: g === "auto" ? null : g,
    ...w,
    children: /* @__PURE__ */ a((V, {
      ownerState: L,
      ...D
    }) => /* @__PURE__ */ k.cloneElement(i, {
      style: {
        opacity: 0,
        transform: E1(0.75),
        visibility: V === "exited" && !c ? "hidden" : void 0,
        ...Ag[V],
        ...C,
        ...i.props.style
      },
      ref: O,
      ...D
    }), "children")
  });
}, "Grow"));
process.env.NODE_ENV !== "production" && (Ui.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: s.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: s.bool,
  /**
   * A single child content element.
   */
  children: sr.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: s.oneOfType([s.shape({
    enter: s.string,
    exit: s.string
  }), s.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: s.bool,
  /**
   * @ignore
   */
  onEnter: s.func,
  /**
   * @ignore
   */
  onEntered: s.func,
  /**
   * @ignore
   */
  onEntering: s.func,
  /**
   * @ignore
   */
  onExit: s.func,
  /**
   * @ignore
   */
  onExited: s.func,
  /**
   * @ignore
   */
  onExiting: s.func,
  /**
   * @ignore
   */
  style: s.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: s.oneOfType([s.oneOf(["auto"]), s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })])
});
Ui && (Ui.muiSupportAuto = !0);
const Bg = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, r = ke({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, G9, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...r
  };
}, "useUtilityClasses$h"), Hg = ee(dl, {
  shouldForwardProp: /* @__PURE__ */ a((e) => Vt(e) || e === "classes", "shouldForwardProp"),
  name: "MuiInput",
  slot: "Root",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [...ll(e, t), !n.disableUnderline && t.underline];
  }, "overridesResolver")
})(we(({
  theme: e
}) => {
  let n = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (n = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), {
    position: "relative",
    variants: [{
      props: /* @__PURE__ */ a(({
        ownerState: o
      }) => o.formControl, "props"),
      style: {
        "label + &": {
          marginTop: 16
        }
      }
    }, {
      props: /* @__PURE__ */ a(({
        ownerState: o
      }) => !o.disableUnderline, "props"),
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${yo.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${yo.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${n}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${yo.disabled}, .${yo.error}):before`]: {
          borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            borderBottom: `1px solid ${n}`
          }
        },
        [`&.${yo.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(e.palette).filter(bt()).map(([o]) => ({
      props: {
        color: o,
        disableUnderline: !1
      },
      style: {
        "&::after": {
          borderBottom: `2px solid ${(e.vars || e).palette[o].main}`
        }
      }
    }))]
  };
})), Dg = ee(ul, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: cl
})({}), Cl = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiInput"
  }), {
    disableUnderline: r = !1,
    components: i = {},
    componentsProps: l,
    fullWidth: c = !1,
    inputComponent: d = "input",
    multiline: u = !1,
    slotProps: p,
    slots: f = {},
    type: m = "text",
    ...b
  } = o, C = Bg(o), y = {
    root: {
      ownerState: {
        disableUnderline: r
      }
    }
  }, w = p ?? l ? zt(p ?? l, y) : y, T = f.root ?? i.Root ?? Hg, x = f.input ?? i.Input ?? Dg;
  return /* @__PURE__ */ h.jsx(pl, {
    slots: {
      root: T,
      input: x
    },
    slotProps: w,
    fullWidth: c,
    inputComponent: d,
    multiline: u,
    ref: n,
    type: m,
    ...b,
    classes: C
  });
}, "Input"));
process.env.NODE_ENV !== "production" && (Cl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: s.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary"]), s.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: s.shape({
    Input: s.elementType,
    Root: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: s.shape({
    input: s.object,
    root: s.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: s.bool,
  /**
   * If `true`, the `input` will not have an underline.
   * @default false
   */
  disableUnderline: s.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: s.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: s.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * The id of the `input` element.
   */
  id: s.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: s.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Wt,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: s.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: s.oneOfType([s.number, s.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: s.oneOfType([s.number, s.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: s.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: s.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: s.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: s.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: s.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: s.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: s.oneOfType([s.number, s.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: s.shape({
    input: s.object,
    root: s.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: s.shape({
    input: s.elementType,
    root: s.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: s.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
   * @default 'text'
   */
  type: s.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: s.any
});
Cl.muiName = "Input";
function Ng(e) {
  return Te("MuiInputAdornment", e);
}
a(Ng, "getInputAdornmentUtilityClass");
const Z3 = Se("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]);
var U3;
const zg = /* @__PURE__ */ a((e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, t[`position${G(n.position)}`], n.disablePointerEvents === !0 && t.disablePointerEvents, t[n.variant]];
}, "overridesResolver$1"), Fg = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    disablePointerEvents: n,
    hiddenLabel: o,
    position: r,
    size: i,
    variant: l
  } = e, c = {
    root: ["root", n && "disablePointerEvents", r && `position${G(r)}`, l, o && "hiddenLabel", i && `size${G(i)}`]
  };
  return ke(c, Ng, t);
}, "useUtilityClasses$g"), Wg = ee("div", {
  name: "MuiInputAdornment",
  slot: "Root",
  overridesResolver: zg
})(we(({
  theme: e
}) => ({
  display: "flex",
  maxHeight: "2em",
  alignItems: "center",
  whiteSpace: "nowrap",
  color: (e.vars || e).palette.action.active,
  variants: [{
    props: {
      variant: "filled"
    },
    style: {
      [`&.${Z3.positionStart}&:not(.${Z3.hiddenLabel})`]: {
        marginTop: 16
      }
    }
  }, {
    props: {
      position: "start"
    },
    style: {
      marginRight: 8
    }
  }, {
    props: {
      position: "end"
    },
    style: {
      marginLeft: 8
    }
  }, {
    props: {
      disablePointerEvents: !0
    },
    style: {
      pointerEvents: "none"
    }
  }]
}))), $n = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiInputAdornment"
  }), {
    children: r,
    className: i,
    component: l = "div",
    disablePointerEvents: c = !1,
    disableTypography: d = !1,
    position: u,
    variant: p,
    ...f
  } = o, m = jn() || {};
  let b = p;
  p && m.variant && process.env.NODE_ENV !== "production" && p === m.variant && console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one."), m && !b && (b = m.variant);
  const C = {
    ...o,
    hiddenLabel: m.hiddenLabel,
    size: m.size,
    disablePointerEvents: c,
    position: u,
    variant: b
  }, g = Fg(C);
  return /* @__PURE__ */ h.jsx(ds.Provider, {
    value: null,
    children: /* @__PURE__ */ h.jsx(Wg, {
      as: l,
      ownerState: C,
      className: le(g.root, i),
      ref: n,
      ...f,
      children: typeof r == "string" && !d ? /* @__PURE__ */ h.jsx(pa, {
        color: "textSecondary",
        children: r
      }) : /* @__PURE__ */ h.jsxs(k.Fragment, {
        children: [u === "start" ? (
          /* notranslate needed while Google Translate will not fix zero-width space issue */
          U3 || (U3 = /* @__PURE__ */ h.jsx("span", {
            className: "notranslate",
            "aria-hidden": !0,
            children: "​"
          }))
        ) : null, r]
      })
    })
  });
}, "InputAdornment"));
process.env.NODE_ENV !== "production" && ($n.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */
  disablePointerEvents: s.bool,
  /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */
  disableTypography: s.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: s.oneOf(["end", "start"]).isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: s.oneOf(["filled", "outlined", "standard"])
});
function Zg(e) {
  return Te("MuiInputLabel", e);
}
a(Zg, "getInputLabelUtilityClasses");
Se("MuiInputLabel", ["root", "focused", "disabled", "error", "required", "asterisk", "formControl", "sizeSmall", "shrink", "animated", "standard", "filled", "outlined"]);
const Ug = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    formControl: n,
    size: o,
    shrink: r,
    disableAnimation: i,
    variant: l,
    required: c
  } = e, d = {
    root: ["root", n && "formControl", !i && "animated", r && "shrink", o && o !== "medium" && `size${G(o)}`, l],
    asterisk: [c && "asterisk"]
  }, u = ke(d, Zg, t);
  return {
    ...t,
    // forward the focused, disabled, etc. classes to the FormLabel
    ...u
  };
}, "useUtilityClasses$f"), Gg = ee(_n, {
  shouldForwardProp: /* @__PURE__ */ a((e) => Vt(e) || e === "classes", "shouldForwardProp"),
  name: "MuiInputLabel",
  slot: "Root",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${wi.asterisk}`]: t.asterisk
    }, t.root, n.formControl && t.formControl, n.size === "small" && t.sizeSmall, n.shrink && t.shrink, !n.disableAnimation && t.animated, n.focused && t.focused, t[n.variant]];
  }, "overridesResolver")
})(we(({
  theme: e
}) => ({
  display: "block",
  transformOrigin: "top left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%",
  variants: [{
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.formControl, "props"),
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: "translate(0, 20px) scale(1)"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      // Compensation for the `Input.inputSizeSmall` style.
      transform: "translate(0, 17px) scale(1)"
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.shrink, "props"),
    style: {
      transform: "translate(0, -1.5px) scale(0.75)",
      transformOrigin: "top left",
      maxWidth: "133%"
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => !t.disableAnimation, "props"),
    style: {
      transition: e.transitions.create(["color", "transform", "max-width"], {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(12px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "filled",
      size: "small"
    },
    style: {
      transform: "translate(12px, 13px) scale(1)"
    }
  }, {
    props: /* @__PURE__ */ a(({
      variant: t,
      ownerState: n
    }) => t === "filled" && n.shrink, "props"),
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      transform: "translate(12px, 7px) scale(0.75)",
      maxWidth: "calc(133% - 24px)"
    }
  }, {
    props: /* @__PURE__ */ a(({
      variant: t,
      ownerState: n,
      size: o
    }) => t === "filled" && n.shrink && o === "small", "props"),
    style: {
      transform: "translate(12px, 4px) scale(0.75)"
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(14px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "outlined",
      size: "small"
    },
    style: {
      transform: "translate(14px, 9px) scale(1)"
    }
  }, {
    props: /* @__PURE__ */ a(({
      variant: t,
      ownerState: n
    }) => t === "outlined" && n.shrink, "props"),
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      // Theoretically, we should have (8+5)*2/0.75 = 34px
      // but it feels a better when it bleeds a bit on the left, so 32px.
      maxWidth: "calc(133% - 32px)",
      transform: "translate(14px, -9px) scale(0.75)"
    }
  }]
}))), ad = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    name: "MuiInputLabel",
    props: t
  }), {
    disableAnimation: r = !1,
    margin: i,
    shrink: l,
    variant: c,
    className: d,
    ...u
  } = o, p = jn();
  let f = l;
  typeof f > "u" && p && (f = p.filled || p.focused || p.adornedStart);
  const m = Lo({
    props: o,
    muiFormControl: p,
    states: ["size", "variant", "required", "focused"]
  }), b = {
    ...o,
    disableAnimation: r,
    formControl: p,
    shrink: f,
    size: m.size,
    variant: m.variant,
    required: m.required,
    focused: m.focused
  }, C = Ug(b);
  return /* @__PURE__ */ h.jsx(Gg, {
    "data-shrink": f,
    ref: n,
    className: le(C.root, d),
    ...u,
    ownerState: b,
    classes: C
  });
}, "InputLabel"));
process.env.NODE_ENV !== "production" && (ad.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: s.oneOfType([s.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), s.string]),
  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: s.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: s.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: s.bool,
  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: s.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: s.oneOf(["dense"]),
  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: s.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: s.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["medium", "small"]), s.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The variant to use.
   */
  variant: s.oneOf(["filled", "outlined", "standard"])
});
const xa = /* @__PURE__ */ k.createContext({});
process.env.NODE_ENV !== "production" && (xa.displayName = "ListContext");
function Yg(e) {
  return Te("MuiList", e);
}
a(Yg, "getListUtilityClass");
Se("MuiList", ["root", "padding", "dense", "subheader"]);
const qg = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    disablePadding: n,
    dense: o,
    subheader: r
  } = e;
  return ke({
    root: ["root", !n && "padding", o && "dense", r && "subheader"]
  }, Yg, t);
}, "useUtilityClasses$e"), Kg = ee("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disablePadding && t.padding, n.dense && t.dense, n.subheader && t.subheader];
  }, "overridesResolver")
})({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative",
  variants: [{
    props: /* @__PURE__ */ a(({
      ownerState: e
    }) => !e.disablePadding, "props"),
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: e
    }) => e.subheader, "props"),
    style: {
      paddingTop: 0
    }
  }]
}), ld = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiList"
  }), {
    children: r,
    className: i,
    component: l = "ul",
    dense: c = !1,
    disablePadding: d = !1,
    subheader: u,
    ...p
  } = o, f = k.useMemo(() => ({
    dense: c
  }), [c]), m = {
    ...o,
    component: l,
    dense: c,
    disablePadding: d
  }, b = qg(m);
  return /* @__PURE__ */ h.jsx(xa.Provider, {
    value: f,
    children: /* @__PURE__ */ h.jsxs(Kg, {
      as: l,
      className: le(b.root, i),
      ref: n,
      ownerState: m,
      ...p,
      children: [u, r]
    })
  });
}, "List"));
process.env.NODE_ENV !== "production" && (ld.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: s.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: s.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: s.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
const G3 = Se("MuiListItemIcon", ["root", "alignItemsFlexStart"]), Y3 = Se("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]);
function Wl(e, t, n) {
  return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : n ? null : e.firstChild;
}
a(Wl, "nextItem$1");
function q3(e, t, n) {
  return e === t ? n ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : n ? null : e.lastChild;
}
a(q3, "previousItem$1");
function cd(e, t) {
  if (t === void 0)
    return !0;
  let n = e.innerText;
  return n === void 0 && (n = e.textContent), n = n.trim().toLowerCase(), n.length === 0 ? !1 : t.repeating ? n[0] === t.keys[0] : n.startsWith(t.keys.join(""));
}
a(cd, "textCriteriaMatches");
function Jr(e, t, n, o, r, i) {
  let l = !1, c = r(e, t, t ? n : !1);
  for (; c; ) {
    if (c === e.firstChild) {
      if (l)
        return !1;
      l = !0;
    }
    const d = o ? !1 : c.disabled || c.getAttribute("aria-disabled") === "true";
    if (!c.hasAttribute("tabindex") || !cd(c, i) || d)
      c = r(e, c, n);
    else
      return c.focus(), !0;
  }
  return !1;
}
a(Jr, "moveFocus$1");
const dd = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: o,
    autoFocus: r = !1,
    autoFocusItem: i = !1,
    children: l,
    className: c,
    disabledItemsFocusable: d = !1,
    disableListWrap: u = !1,
    onKeyDown: p,
    variant: f = "selectedMenu",
    ...m
  } = t, b = k.useRef(null), C = k.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  Rn(() => {
    r && b.current.focus();
  }, [r]), k.useImperativeHandle(o, () => ({
    adjustStyleForScrollbar: /* @__PURE__ */ a((x, {
      direction: S
    }) => {
      const M = !b.current.style.width;
      if (x.clientHeight < b.current.clientHeight && M) {
        const O = `${td(dn(x))}px`;
        b.current.style[S === "rtl" ? "paddingLeft" : "paddingRight"] = O, b.current.style.width = `calc(100% + ${O})`;
      }
      return b.current;
    }, "adjustStyleForScrollbar")
  }), []);
  const g = /* @__PURE__ */ a((x) => {
    const S = b.current, M = x.key;
    if (x.ctrlKey || x.metaKey || x.altKey) {
      p && p(x);
      return;
    }
    const P = Qt(S).activeElement;
    if (M === "ArrowDown")
      x.preventDefault(), Jr(S, P, u, d, Wl);
    else if (M === "ArrowUp")
      x.preventDefault(), Jr(S, P, u, d, q3);
    else if (M === "Home")
      x.preventDefault(), Jr(S, null, u, d, Wl);
    else if (M === "End")
      x.preventDefault(), Jr(S, null, u, d, q3);
    else if (M.length === 1) {
      const E = C.current, I = M.toLowerCase(), v = performance.now();
      E.keys.length > 0 && (v - E.lastTime > 500 ? (E.keys = [], E.repeating = !0, E.previousKeyMatched = !0) : E.repeating && I !== E.keys[0] && (E.repeating = !1)), E.lastTime = v, E.keys.push(I);
      const _ = P && !E.repeating && cd(P, E);
      E.previousKeyMatched && (_ || Jr(S, P, !1, d, Wl, E)) ? x.preventDefault() : E.previousKeyMatched = !1;
    }
    p && p(x);
  }, "handleKeyDown"), y = xt(b, n);
  let w = -1;
  k.Children.forEach(l, (x, S) => {
    if (!/* @__PURE__ */ k.isValidElement(x)) {
      w === S && (w += 1, w >= l.length && (w = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && ko.isFragment(x) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), x.props.disabled || (f === "selectedMenu" && x.props.selected || w === -1) && (w = S), w === S && (x.props.disabled || x.props.muiSkipListHighlight || x.type.muiSkipListHighlight) && (w += 1, w >= l.length && (w = -1));
  });
  const T = k.Children.map(l, (x, S) => {
    if (S === w) {
      const M = {};
      return i && (M.autoFocus = !0), x.props.tabIndex === void 0 && f === "selectedMenu" && (M.tabIndex = 0), /* @__PURE__ */ k.cloneElement(x, M);
    }
    return x;
  });
  return /* @__PURE__ */ h.jsx(ld, {
    role: "menu",
    ref: y,
    className: c,
    onKeyDown: g,
    tabIndex: r ? 0 : -1,
    ...m,
    children: T
  });
}, "MenuList"));
process.env.NODE_ENV !== "production" && (dd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: s.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: s.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: s.node,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: s.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: s.bool,
  /**
   * @ignore
   */
  onKeyDown: s.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: s.oneOf(["menu", "selectedMenu"])
});
function Xg(e) {
  return Te("MuiPopover", e);
}
a(Xg, "getPopoverUtilityClass");
Se("MuiPopover", ["root", "paper"]);
function K3(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.height / 2 : t === "bottom" && (n = e.height), n;
}
a(K3, "getOffsetTop");
function X3(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.width / 2 : t === "right" && (n = e.width), n;
}
a(X3, "getOffsetLeft");
function J3(e) {
  return [e.horizontal, e.vertical].map((t) => typeof t == "number" ? `${t}px` : t).join(" ");
}
a(J3, "getTransformOriginValue");
function fi(e) {
  return typeof e == "function" ? e() : e;
}
a(fi, "resolveAnchorEl");
const Jg = /* @__PURE__ */ a((e) => {
  const {
    classes: t
  } = e;
  return ke({
    root: ["root"],
    paper: ["paper"]
  }, Xg, t);
}, "useUtilityClasses$d"), Qg = ee(ml, {
  name: "MuiPopover",
  slot: "Root"
})({}), ud = ee(Ro, {
  name: "MuiPopover",
  slot: "Paper"
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), pd = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiPopover"
  }), {
    action: r,
    anchorEl: i,
    anchorOrigin: l = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: c,
    anchorReference: d = "anchorEl",
    children: u,
    className: p,
    container: f,
    elevation: m = 8,
    marginThreshold: b = 16,
    open: C,
    PaperProps: g = {},
    // TODO: remove in v7
    slots: y = {},
    slotProps: w = {},
    transformOrigin: T = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: x,
    // TODO: remove in v7
    transitionDuration: S = "auto",
    TransitionProps: M = {},
    // TODO: remove in v7
    disableScrollLock: O = !1,
    ...P
  } = o, E = k.useRef(), I = {
    ...o,
    anchorOrigin: l,
    anchorReference: d,
    elevation: m,
    marginThreshold: b,
    transformOrigin: T,
    TransitionComponent: x,
    transitionDuration: S,
    TransitionProps: M
  }, v = Jg(I), _ = k.useCallback(() => {
    if (d === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (c || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), c;
    const X = fi(i), se = X && X.nodeType === 1 ? X : Qt(E.current).body, Y = se.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const fe = se.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && fe.top === 0 && fe.left === 0 && fe.right === 0 && fe.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: Y.top + K3(Y, l.vertical),
      left: Y.left + X3(Y, l.horizontal)
    };
  }, [i, l.horizontal, l.vertical, c, d]), R = k.useCallback((X) => ({
    vertical: K3(X, T.vertical),
    horizontal: X3(X, T.horizontal)
  }), [T.horizontal, T.vertical]), j = k.useCallback((X) => {
    const se = {
      width: X.offsetWidth,
      height: X.offsetHeight
    }, Y = R(se);
    if (d === "none")
      return {
        top: null,
        left: null,
        transformOrigin: J3(Y)
      };
    const fe = _();
    let be = fe.top - Y.vertical, Re = fe.left - Y.horizontal;
    const Oe = be + se.height, Be = Re + se.width, re = dn(fi(i)), Fe = re.innerHeight - b, Ce = re.innerWidth - b;
    if (b !== null && be < b) {
      const Pe = be - b;
      be -= Pe, Y.vertical += Pe;
    } else if (b !== null && Oe > Fe) {
      const Pe = Oe - Fe;
      be -= Pe, Y.vertical += Pe;
    }
    if (process.env.NODE_ENV !== "production" && se.height > Fe && se.height && Fe && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${se.height - Fe}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), b !== null && Re < b) {
      const Pe = Re - b;
      Re -= Pe, Y.horizontal += Pe;
    } else if (Be > Ce) {
      const Pe = Be - Ce;
      Re -= Pe, Y.horizontal += Pe;
    }
    return {
      top: `${Math.round(be)}px`,
      left: `${Math.round(Re)}px`,
      transformOrigin: J3(Y)
    };
  }, [i, d, _, R, b]), [B, V] = k.useState(C), L = k.useCallback(() => {
    const X = E.current;
    if (!X)
      return;
    const se = j(X);
    se.top !== null && X.style.setProperty("top", se.top), se.left !== null && (X.style.left = se.left), X.style.transformOrigin = se.transformOrigin, V(!0);
  }, [j]);
  k.useEffect(() => (O && window.addEventListener("scroll", L), () => window.removeEventListener("scroll", L)), [i, O, L]);
  const D = /* @__PURE__ */ a(() => {
    L();
  }, "handleEntering"), z = /* @__PURE__ */ a(() => {
    V(!1);
  }, "handleExited");
  k.useEffect(() => {
    C && L();
  }), k.useImperativeHandle(r, () => C ? {
    updatePosition: /* @__PURE__ */ a(() => {
      L();
    }, "updatePosition")
  } : null, [C, L]), k.useEffect(() => {
    if (!C)
      return;
    const X = ss(() => {
      L();
    }), se = dn(fi(i));
    return se.addEventListener("resize", X), () => {
      X.clear(), se.removeEventListener("resize", X);
    };
  }, [i, C, L]);
  let H = S;
  const $ = {
    slots: {
      transition: x,
      ...y
    },
    slotProps: {
      transition: M,
      paper: g,
      ...w
    }
  }, [A, U] = ve("transition", {
    elementType: Ui,
    externalForwardedProps: $,
    ownerState: I,
    getSlotProps: /* @__PURE__ */ a((X) => ({
      ...X,
      onEntering: /* @__PURE__ */ a((se, Y) => {
        var fe;
        (fe = X.onEntering) == null || fe.call(X, se, Y), D();
      }, "onEntering"),
      onExited: /* @__PURE__ */ a((se) => {
        var Y;
        (Y = X.onExited) == null || Y.call(X, se), z();
      }, "onExited")
    }), "getSlotProps"),
    additionalProps: {
      appear: !0,
      in: C
    }
  });
  S === "auto" && !A.muiSupportAuto && (H = void 0);
  const K = f || (i ? Qt(fi(i)).body : void 0), [J, {
    slots: F,
    slotProps: N,
    ...te
  }] = ve("root", {
    ref: n,
    elementType: Qg,
    externalForwardedProps: {
      ...$,
      ...P
    },
    shouldForwardComponentProp: !0,
    additionalProps: {
      slots: {
        backdrop: y.backdrop
      },
      slotProps: {
        backdrop: bc(typeof w.backdrop == "function" ? w.backdrop(I) : w.backdrop, {
          invisible: !0
        })
      },
      container: K,
      open: C
    },
    ownerState: I,
    className: le(v.root, p)
  }), [oe, ne] = ve("paper", {
    ref: E,
    className: v.paper,
    elementType: ud,
    externalForwardedProps: $,
    shouldForwardComponentProp: !0,
    additionalProps: {
      elevation: m,
      style: B ? void 0 : {
        opacity: 0
      }
    },
    ownerState: I
  });
  return /* @__PURE__ */ h.jsx(J, {
    ...te,
    ...!k1(J) && {
      slots: F,
      slotProps: N,
      disableScrollLock: O
    },
    children: /* @__PURE__ */ h.jsx(A, {
      ...U,
      timeout: H,
      children: /* @__PURE__ */ h.jsx(oe, {
        ...ne,
        children: u
      })
    })
  });
}, "Popover"));
process.env.NODE_ENV !== "production" && (pd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: Wt,
  /**
   * An HTML element, [PopoverVirtualElement](https://mui.com/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: In(s.oneOfType([Kn, s.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const t = fi(e.anchorEl);
      if (t && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${t}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: s.shape({
    horizontal: s.oneOfType([s.oneOf(["center", "left", "right"]), s.number]).isRequired,
    vertical: s.oneOfType([s.oneOf(["bottom", "center", "top"]), s.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: s.shape({
    left: s.number.isRequired,
    top: s.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: s.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: s.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  BackdropProps: s.object,
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: s.oneOfType([Kn, s.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: s.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: il,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: s.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: s.func,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: s.shape({
    component: rl
  }),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    backdrop: s.oneOfType([s.func, s.object]),
    paper: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object]),
    transition: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    backdrop: s.elementType,
    paper: s.elementType,
    root: s.elementType,
    transition: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: s.shape({
    horizontal: s.oneOfType([s.oneOf(["center", "left", "right"]), s.number]).isRequired,
    vertical: s.oneOfType([s.oneOf(["bottom", "center", "top"]), s.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated use the `slots.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default Grow
   */
  TransitionComponent: s.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: s.oneOfType([s.oneOf(["auto"]), s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: s.object
});
function em(e) {
  return Te("MuiMenu", e);
}
a(em, "getMenuUtilityClass");
Se("MuiMenu", ["root", "paper", "list"]);
const tm = {
  vertical: "top",
  horizontal: "right"
}, nm = {
  vertical: "top",
  horizontal: "left"
}, om = /* @__PURE__ */ a((e) => {
  const {
    classes: t
  } = e;
  return ke({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, em, t);
}, "useUtilityClasses$c"), rm = ee(pd, {
  shouldForwardProp: /* @__PURE__ */ a((e) => Vt(e) || e === "classes", "shouldForwardProp"),
  name: "MuiMenu",
  slot: "Root"
})({}), im = ee(ud, {
  name: "MuiMenu",
  slot: "Paper"
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), sm = ee(dd, {
  name: "MuiMenu",
  slot: "List"
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), fd = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiMenu"
  }), {
    autoFocus: r = !0,
    children: i,
    className: l,
    disableAutoFocusItem: c = !1,
    MenuListProps: d = {},
    onClose: u,
    open: p,
    PaperProps: f = {},
    PopoverClasses: m,
    transitionDuration: b = "auto",
    TransitionProps: {
      onEntering: C,
      ...g
    } = {},
    variant: y = "selectedMenu",
    slots: w = {},
    slotProps: T = {},
    ...x
  } = o, S = Dr(), M = {
    ...o,
    autoFocus: r,
    disableAutoFocusItem: c,
    MenuListProps: d,
    onEntering: C,
    PaperProps: f,
    transitionDuration: b,
    TransitionProps: g,
    variant: y
  }, O = om(M), P = r && !c && p, E = k.useRef(null), I = /* @__PURE__ */ a((H, $) => {
    E.current && E.current.adjustStyleForScrollbar(H, {
      direction: S ? "rtl" : "ltr"
    }), C && C(H, $);
  }, "handleEntering"), v = /* @__PURE__ */ a((H) => {
    H.key === "Tab" && (H.preventDefault(), u && u(H, "tabKeyDown"));
  }, "handleListKeyDown");
  let _ = -1;
  k.Children.map(i, (H, $) => {
    /* @__PURE__ */ k.isValidElement(H) && (process.env.NODE_ENV !== "production" && ko.isFragment(H) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), H.props.disabled || (y === "selectedMenu" && H.props.selected || _ === -1) && (_ = $));
  });
  const R = {
    slots: w,
    slotProps: {
      list: d,
      transition: g,
      paper: f,
      ...T
    }
  }, j = jr({
    elementType: w.root,
    externalSlotProps: T.root,
    ownerState: M,
    className: [O.root, l]
  }), [B, V] = ve("paper", {
    className: O.paper,
    elementType: im,
    externalForwardedProps: R,
    shouldForwardComponentProp: !0,
    ownerState: M
  }), [L, D] = ve("list", {
    className: le(O.list, d.className),
    elementType: sm,
    shouldForwardComponentProp: !0,
    externalForwardedProps: R,
    getSlotProps: /* @__PURE__ */ a((H) => ({
      ...H,
      onKeyDown: /* @__PURE__ */ a(($) => {
        var A;
        v($), (A = H.onKeyDown) == null || A.call(H, $);
      }, "onKeyDown")
    }), "getSlotProps"),
    ownerState: M
  }), z = typeof R.slotProps.transition == "function" ? R.slotProps.transition(M) : R.slotProps.transition;
  return /* @__PURE__ */ h.jsx(rm, {
    onClose: u,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: S ? "right" : "left"
    },
    transformOrigin: S ? tm : nm,
    slots: {
      root: w.root,
      paper: B,
      backdrop: w.backdrop,
      ...w.transition && {
        // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
        transition: w.transition
      }
    },
    slotProps: {
      root: j,
      paper: V,
      backdrop: typeof T.backdrop == "function" ? T.backdrop(M) : T.backdrop,
      transition: {
        ...z,
        onEntering: /* @__PURE__ */ a((...H) => {
          var $;
          I(...H), ($ = z == null ? void 0 : z.onEntering) == null || $.call(z, ...H);
        }, "onEntering")
      }
    },
    open: p,
    ref: n,
    transitionDuration: b,
    ownerState: M,
    ...x,
    classes: m,
    children: /* @__PURE__ */ h.jsx(L, {
      actions: E,
      autoFocus: r && (_ === -1 || c),
      autoFocusItem: P,
      variant: y,
      ...D,
      children: i
    })
  });
}, "Menu"));
process.env.NODE_ENV !== "production" && (fd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: s.oneOfType([Kn, s.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: s.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: s.bool,
  /**
   * Props applied to the [`MenuList`](https://mui.com/material-ui/api/menu-list/) element.
   * @deprecated use the `slotProps.list` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  MenuListProps: s.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: s.func,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: s.object,
  /**
   * `classes` prop applied to the [`Popover`](https://mui.com/material-ui/api/popover/) element.
   */
  PopoverClasses: s.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    backdrop: s.oneOfType([s.func, s.object]),
    list: s.oneOfType([s.func, s.object]),
    paper: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object]),
    transition: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    backdrop: s.elementType,
    list: s.elementType,
    paper: s.elementType,
    root: s.elementType,
    transition: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: s.oneOfType([s.oneOf(["auto"]), s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: s.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: s.oneOf(["menu", "selectedMenu"])
});
function am(e) {
  return Te("MuiMenuItem", e);
}
a(am, "getMenuItemUtilityClass");
const Qr = Se("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), lm = /* @__PURE__ */ a((e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.divider && t.divider, !n.disableGutters && t.gutters];
}, "overridesResolver"), cm = /* @__PURE__ */ a((e) => {
  const {
    disabled: t,
    dense: n,
    divider: o,
    disableGutters: r,
    selected: i,
    classes: l
  } = e, d = ke({
    root: ["root", n && "dense", t && "disabled", !r && "gutters", o && "divider", i && "selected"]
  }, am, l);
  return {
    ...l,
    ...d
  };
}, "useUtilityClasses$b"), dm = ee(lo, {
  shouldForwardProp: /* @__PURE__ */ a((e) => Vt(e) || e === "classes", "shouldForwardProp"),
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: lm
})(we(({
  theme: e
}) => ({
  ...e.typography.body1,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap",
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${Qr.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : De(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${Qr.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : De(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${Qr.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : De(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : De(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${Qr.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${Qr.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  [`& + .${z3.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${z3.inset}`]: {
    marginLeft: 52
  },
  [`& .${Y3.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${Y3.inset}`]: {
    paddingLeft: 36
  },
  [`& .${G3.root}`]: {
    minWidth: 36
  },
  variants: [{
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => !t.disableGutters, "props"),
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.divider, "props"),
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => !t.dense, "props"),
    style: {
      [e.breakpoints.up("sm")]: {
        minHeight: "auto"
      }
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.dense, "props"),
    style: {
      minHeight: 32,
      // https://m2.material.io/components/menus#specs > Dense
      paddingTop: 4,
      paddingBottom: 4,
      ...e.typography.body2,
      [`& .${G3.root} svg`]: {
        fontSize: "1.25rem"
      }
    }
  }]
}))), Ac = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiMenuItem"
  }), {
    autoFocus: r = !1,
    component: i = "li",
    dense: l = !1,
    divider: c = !1,
    disableGutters: d = !1,
    focusVisibleClassName: u,
    role: p = "menuitem",
    tabIndex: f,
    className: m,
    ...b
  } = o, C = k.useContext(xa), g = k.useMemo(() => ({
    dense: l || C.dense || !1,
    disableGutters: d
  }), [C.dense, l, d]), y = k.useRef(null);
  Rn(() => {
    r && (y.current ? y.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [r]);
  const w = {
    ...o,
    dense: g.dense,
    divider: c,
    disableGutters: d
  }, T = cm(o), x = xt(y, n);
  let S;
  return o.disabled || (S = f !== void 0 ? f : -1), /* @__PURE__ */ h.jsx(xa.Provider, {
    value: g,
    children: /* @__PURE__ */ h.jsx(dm, {
      ref: x,
      role: p,
      tabIndex: S,
      component: i,
      focusVisibleClassName: le(T.focusVisible, u),
      className: le(T.root, m),
      ...b,
      ownerState: w,
      classes: T
    })
  });
}, "MenuItem"));
process.env.NODE_ENV !== "production" && (Ac.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: s.bool,
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: s.bool,
  /**
   * @ignore
   */
  disabled: s.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: s.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: s.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: s.string,
  /**
   * @ignore
   */
  role: s.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * @default 0
   */
  tabIndex: s.number
});
function um(e) {
  return Te("MuiNativeSelect", e);
}
a(um, "getNativeSelectUtilityClasses");
const Bc = Se("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), pm = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    variant: n,
    disabled: o,
    multiple: r,
    open: i,
    error: l
  } = e, c = {
    select: ["select", n, o && "disabled", r && "multiple", l && "error"],
    icon: ["icon", `icon${G(n)}`, i && "iconOpen", o && "disabled"]
  };
  return ke(c, um, t);
}, "useUtilityClasses$a"), hd = ee("select")(({
  theme: e
}) => ({
  // Reset
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  // Reset
  borderRadius: 0,
  cursor: "pointer",
  "&:focus": {
    // Reset Chrome style
    borderRadius: 0
  },
  [`&.${Bc.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (e.vars || e).palette.background.paper
  },
  variants: [{
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.variant !== "filled" && t.variant !== "outlined", "props"),
    style: {
      // Bump specificity to allow extending custom inputs
      "&&&": {
        paddingRight: 24,
        minWidth: 16
        // So it doesn't collapse.
      }
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      "&&&": {
        paddingRight: 32
      }
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      borderRadius: (e.vars || e).shape.borderRadius,
      "&:focus": {
        borderRadius: (e.vars || e).shape.borderRadius
        // Reset the reset for Chrome style
      },
      "&&&": {
        paddingRight: 32
      }
    }
  }]
})), fm = ee(hd, {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: Vt,
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.select, t[n.variant], n.error && t.error, {
      [`&.${Bc.multiple}`]: t.multiple
    }];
  }, "overridesResolver")
})({}), gd = ee("svg")(({
  theme: e
}) => ({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  // Center vertically, height is 1em
  top: "calc(50% - .5em)",
  // Don't block pointer events on the select under the icon.
  pointerEvents: "none",
  color: (e.vars || e).palette.action.active,
  [`&.${Bc.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  },
  variants: [{
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.open, "props"),
    style: {
      transform: "rotate(180deg)"
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      right: 7
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      right: 7
    }
  }]
})), hm = ee(gd, {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${G(n.variant)}`], n.open && t.iconOpen];
  }, "overridesResolver")
})({}), md = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const {
    className: o,
    disabled: r,
    error: i,
    IconComponent: l,
    inputRef: c,
    variant: d = "standard",
    ...u
  } = t, p = {
    ...t,
    disabled: r,
    variant: d,
    error: i
  }, f = pm(p);
  return /* @__PURE__ */ h.jsxs(k.Fragment, {
    children: [/* @__PURE__ */ h.jsx(fm, {
      ownerState: p,
      className: le(f.select, o),
      disabled: r,
      ref: c || n,
      ...u
    }), t.multiple ? null : /* @__PURE__ */ h.jsx(hm, {
      as: l,
      ownerState: p,
      className: f.icon
    })]
  });
}, "NativeSelectInput"));
process.env.NODE_ENV !== "production" && (md.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * The CSS class name of the select element.
   */
  className: s.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: s.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: s.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: s.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: Wt,
  /**
   * @ignore
   */
  multiple: s.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: s.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: s.func,
  /**
   * The input value.
   */
  value: s.any,
  /**
   * The variant to use.
   */
  variant: s.oneOf(["standard", "outlined", "filled"])
});
var Q3;
const gm = ee("fieldset", {
  shouldForwardProp: Vt
})({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), mm = ee("legend", {
  shouldForwardProp: Vt
})(we(({
  theme: e
}) => ({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden",
  // Fix Horizontal scroll when label too long
  variants: [{
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => !t.withLabel, "props"),
    style: {
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: e.transitions.create("width", {
        duration: 150,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.withLabel, "props"),
    style: {
      display: "block",
      // Fix conflict with normalize.css and sanitize.css
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: e.transitions.create("max-width", {
        duration: 50,
        easing: e.transitions.easing.easeOut
      }),
      whiteSpace: "nowrap",
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block",
        opacity: 0,
        visibility: "visible"
      }
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.withLabel && t.notched, "props"),
    style: {
      maxWidth: "100%",
      transition: e.transitions.create("max-width", {
        duration: 100,
        easing: e.transitions.easing.easeOut,
        delay: 50
      })
    }
  }]
})));
function bd(e) {
  const {
    children: t,
    classes: n,
    className: o,
    label: r,
    notched: i,
    ...l
  } = e, c = r != null && r !== "", d = {
    ...e,
    notched: i,
    withLabel: c
  };
  return /* @__PURE__ */ h.jsx(gm, {
    "aria-hidden": !0,
    className: o,
    ownerState: d,
    ...l,
    children: /* @__PURE__ */ h.jsx(mm, {
      ownerState: d,
      children: c ? /* @__PURE__ */ h.jsx("span", {
        children: r
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        Q3 || (Q3 = /* @__PURE__ */ h.jsx("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      )
    })
  });
}
a(bd, "NotchedOutline");
process.env.NODE_ENV !== "production" && (bd.propTypes = {
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The label.
   */
  label: s.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: s.bool.isRequired,
  /**
   * @ignore
   */
  style: s.object
});
const bm = /* @__PURE__ */ a((e) => {
  const {
    classes: t
  } = e, o = ke({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, Y9, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...o
  };
}, "useUtilityClasses$9"), Cm = ee(dl, {
  shouldForwardProp: /* @__PURE__ */ a((e) => Vt(e) || e === "classes", "shouldForwardProp"),
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: ll
})(we(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    position: "relative",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${gn.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${gn.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
      }
    },
    [`&.${gn.focused} .${gn.notchedOutline}`]: {
      borderWidth: 2
    },
    variants: [...Object.entries(e.palette).filter(bt()).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        [`&.${gn.focused} .${gn.notchedOutline}`]: {
          borderColor: (e.vars || e).palette[n].main
        }
      }
    })), {
      props: {},
      // to overide the above style
      style: {
        [`&.${gn.error} .${gn.notchedOutline}`]: {
          borderColor: (e.vars || e).palette.error.main
        },
        [`&.${gn.disabled} .${gn.notchedOutline}`]: {
          borderColor: (e.vars || e).palette.action.disabled
        }
      }
    }, {
      props: /* @__PURE__ */ a(({
        ownerState: n
      }) => n.startAdornment, "props"),
      style: {
        paddingLeft: 14
      }
    }, {
      props: /* @__PURE__ */ a(({
        ownerState: n
      }) => n.endAdornment, "props"),
      style: {
        paddingRight: 14
      }
    }, {
      props: /* @__PURE__ */ a(({
        ownerState: n
      }) => n.multiline, "props"),
      style: {
        padding: "16.5px 14px"
      }
    }, {
      props: /* @__PURE__ */ a(({
        ownerState: n,
        size: o
      }) => n.multiline && o === "small", "props"),
      style: {
        padding: "8.5px 14px"
      }
    }]
  };
})), ym = ee(bd, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline"
})(we(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
  };
})), xm = ee(ul, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: cl
})(we(({
  theme: e
}) => ({
  padding: "16.5px 14px",
  ...!e.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
      caretColor: e.palette.mode === "light" ? null : "#fff",
      borderRadius: "inherit"
    }
  },
  ...e.vars && {
    "&:-webkit-autofill": {
      borderRadius: "inherit"
    },
    [e.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      padding: "8.5px 14px"
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.multiline, "props"),
    style: {
      padding: 0
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.startAdornment, "props"),
    style: {
      paddingLeft: 0
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.endAdornment, "props"),
    style: {
      paddingRight: 0
    }
  }]
}))), yl = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiOutlinedInput"
  }), {
    components: r = {},
    fullWidth: i = !1,
    inputComponent: l = "input",
    label: c,
    multiline: d = !1,
    notched: u,
    slots: p = {},
    slotProps: f = {},
    type: m = "text",
    ...b
  } = o, C = bm(o), g = jn(), y = Lo({
    props: o,
    muiFormControl: g,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), w = {
    ...o,
    color: y.color || "primary",
    disabled: y.disabled,
    error: y.error,
    focused: y.focused,
    formControl: g,
    fullWidth: i,
    hiddenLabel: y.hiddenLabel,
    multiline: d,
    size: y.size,
    type: m
  }, T = p.root ?? r.Root ?? Cm, x = p.input ?? r.Input ?? xm, [S, M] = ve("notchedOutline", {
    elementType: ym,
    className: C.notchedOutline,
    shouldForwardComponentProp: !0,
    ownerState: w,
    externalForwardedProps: {
      slots: p,
      slotProps: f
    },
    additionalProps: {
      label: c != null && c !== "" && y.required ? /* @__PURE__ */ h.jsxs(k.Fragment, {
        children: [c, " ", "*"]
      }) : c
    }
  });
  return /* @__PURE__ */ h.jsx(pl, {
    slots: {
      root: T,
      input: x
    },
    slotProps: f,
    renderSuffix: /* @__PURE__ */ a((O) => /* @__PURE__ */ h.jsx(S, {
      ...M,
      notched: typeof u < "u" ? u : !!(O.startAdornment || O.filled || O.focused)
    }), "renderSuffix"),
    fullWidth: i,
    inputComponent: l,
    multiline: d,
    ref: n,
    type: m,
    ...b,
    classes: {
      ...C,
      notchedOutline: null
    }
  });
}, "OutlinedInput"));
process.env.NODE_ENV !== "production" && (yl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: s.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary"]), s.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: s.shape({
    Input: s.elementType,
    Root: s.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: s.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: s.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: s.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * The id of the `input` element.
   */
  id: s.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: s.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Wt,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: s.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: s.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: s.oneOfType([s.number, s.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: s.oneOfType([s.number, s.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: s.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: s.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: s.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: s.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: s.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: s.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: s.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: s.oneOfType([s.number, s.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    input: s.object,
    notchedOutline: s.oneOfType([s.func, s.object]),
    root: s.object
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    input: s.elementType,
    notchedOutline: s.elementType,
    root: s.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: s.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
   * @default 'text'
   */
  type: s.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: s.any
});
yl.muiName = "Input";
const vm = en(/* @__PURE__ */ h.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked"), wm = en(/* @__PURE__ */ h.jsx("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked"), Sm = ee("span", {
  shouldForwardProp: Vt
})({
  position: "relative",
  display: "flex"
}), Mm = ee(vm)({
  // Scale applied to prevent dot misalignment in Safari
  transform: "scale(1)"
}), Tm = ee(wm)(we(({
  theme: e
}) => ({
  left: 0,
  position: "absolute",
  transform: "scale(0)",
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeIn,
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: {
      checked: !0
    },
    style: {
      transform: "scale(1)",
      transition: e.transitions.create("transform", {
        easing: e.transitions.easing.easeOut,
        duration: e.transitions.duration.shortest
      })
    }
  }]
})));
function Hc(e) {
  const {
    checked: t = !1,
    classes: n = {},
    fontSize: o
  } = e, r = {
    ...e,
    checked: t
  };
  return /* @__PURE__ */ h.jsxs(Sm, {
    className: n.root,
    ownerState: r,
    children: [/* @__PURE__ */ h.jsx(Mm, {
      fontSize: o,
      className: n.background,
      ownerState: r
    }), /* @__PURE__ */ h.jsx(Tm, {
      fontSize: o,
      className: n.dot,
      ownerState: r
    })]
  });
}
a(Hc, "RadioButtonIcon");
process.env.NODE_ENV !== "production" && (Hc.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   */
  fontSize: s.oneOf(["small", "medium"])
});
const Dc = /* @__PURE__ */ k.createContext(void 0);
process.env.NODE_ENV !== "production" && (Dc.displayName = "RadioGroupContext");
function km() {
  return k.useContext(Dc);
}
a(km, "useRadioGroup");
function Om(e) {
  return Te("MuiRadio", e);
}
a(Om, "getRadioUtilityClass");
const e4 = Se("MuiRadio", ["root", "checked", "disabled", "colorPrimary", "colorSecondary", "sizeSmall"]), Em = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    color: n,
    size: o
  } = e, r = {
    root: ["root", `color${G(n)}`, o !== "medium" && `size${G(o)}`]
  };
  return {
    ...t,
    ...ke(r, Om, t)
  };
}, "useUtilityClasses$8"), $m = ee(_c, {
  shouldForwardProp: /* @__PURE__ */ a((e) => Vt(e) || e === "classes", "shouldForwardProp"),
  name: "MuiRadio",
  slot: "Root",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.size !== "medium" && t[`size${G(n.size)}`], t[`color${G(n.color)}`]];
  }, "overridesResolver")
})(we(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  [`&.${e4.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  },
  variants: [{
    props: {
      color: "default",
      disabled: !1,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : De(e.palette.action.active, e.palette.action.hoverOpacity)
      }
    }
  }, ...Object.entries(e.palette).filter(bt()).map(([t]) => ({
    props: {
      color: t,
      disabled: !1,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : De(e.palette[t].main, e.palette.action.hoverOpacity)
      }
    }
  })), ...Object.entries(e.palette).filter(bt()).map(([t]) => ({
    props: {
      color: t,
      disabled: !1
    },
    style: {
      [`&.${e4.checked}`]: {
        color: (e.vars || e).palette[t].main
      }
    }
  })), {
    // Should be last to override other colors
    props: {
      disableRipple: !1
    },
    style: {
      // Reset on touch devices, it doesn't add specificity
      "&:hover": {
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }]
})));
function Pm(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
a(Pm, "areEqualValues$1");
const _m = /* @__PURE__ */ h.jsx(Hc, {
  checked: !0
}), Rm = /* @__PURE__ */ h.jsx(Hc, {}), Cd = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiRadio"
  }), {
    checked: r,
    checkedIcon: i = _m,
    color: l = "primary",
    icon: c = Rm,
    name: d,
    onChange: u,
    size: p = "medium",
    className: f,
    disabled: m,
    disableRipple: b = !1,
    slots: C = {},
    slotProps: g = {},
    inputProps: y,
    ...w
  } = o, T = jn();
  let x = m;
  T && typeof x > "u" && (x = T.disabled), x ?? (x = !1);
  const S = {
    ...o,
    disabled: x,
    disableRipple: b,
    color: l,
    size: p
  }, M = Em(S), O = km();
  let P = r;
  const E = g1(u, O && O.onChange);
  let I = d;
  O && (typeof P > "u" && (P = Pm(O.value, o.value)), typeof I > "u" && (I = O.name));
  const v = g.input ?? y, [_, R] = ve("root", {
    ref: n,
    elementType: $m,
    className: le(M.root, f),
    shouldForwardComponentProp: !0,
    externalForwardedProps: {
      slots: C,
      slotProps: g,
      ...w
    },
    getSlotProps: /* @__PURE__ */ a((j) => ({
      ...j,
      onChange: /* @__PURE__ */ a((B, ...V) => {
        var L;
        (L = j.onChange) == null || L.call(j, B, ...V), E(B, ...V);
      }, "onChange")
    }), "getSlotProps"),
    ownerState: S,
    additionalProps: {
      type: "radio",
      icon: /* @__PURE__ */ k.cloneElement(c, {
        fontSize: c.props.fontSize ?? p
      }),
      checkedIcon: /* @__PURE__ */ k.cloneElement(i, {
        fontSize: i.props.fontSize ?? p
      }),
      disabled: x,
      name: I,
      checked: P,
      slots: C,
      slotProps: {
        // Do not forward `slotProps.root` again because it's already handled by the `RootSlot` in this file.
        input: typeof v == "function" ? v(S) : v
      }
    }
  });
  return /* @__PURE__ */ h.jsx(_, {
    ...R,
    classes: M
  });
}, "Radio"));
process.env.NODE_ENV !== "production" && (Cd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: s.bool,
  /**
   * The icon to display when the component is checked.
   * @default <RadioButtonIcon checked />
   */
  checkedIcon: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: s.oneOfType([s.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * If `true`, the component is disabled.
   */
  disabled: s.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: s.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <RadioButtonIcon />
   */
  icon: s.node,
  /**
   * The id of the `input` element.
   */
  id: s.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   * @deprecated Use `slotProps.input.ref` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputRef: Wt,
  /**
   * Name attribute of the `input` element.
   */
  name: s.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: s.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: s.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["medium", "small"]), s.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    input: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    input: s.elementType,
    root: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   */
  value: s.any
});
function Im(e) {
  return Te("MuiRadioGroup", e);
}
a(Im, "getRadioGroupUtilityClass");
Se("MuiRadioGroup", ["root", "row", "error"]);
const jm = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    row: n,
    error: o
  } = e;
  return ke({
    root: ["root", n && "row", o && "error"]
  }, Im, t);
}, "useUtilityClasses$7"), yd = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: o,
    children: r,
    className: i,
    defaultValue: l,
    name: c,
    onChange: d,
    value: u,
    ...p
  } = t, f = k.useRef(null), m = jm(t), [b, C] = Mo({
    controlled: u,
    default: l,
    name: "RadioGroup"
  });
  k.useImperativeHandle(o, () => ({
    focus: /* @__PURE__ */ a(() => {
      let T = f.current.querySelector("input:not(:disabled):checked");
      T || (T = f.current.querySelector("input:not(:disabled)")), T && T.focus();
    }, "focus")
  }), []);
  const g = xt(n, f), y = _o(c), w = k.useMemo(() => ({
    name: y,
    onChange(T) {
      C(T.target.value), d && d(T, T.target.value);
    },
    value: b
  }), [y, d, C, b]);
  return /* @__PURE__ */ h.jsx(Dc.Provider, {
    value: w,
    children: /* @__PURE__ */ h.jsx(Vc, {
      role: "radiogroup",
      ref: g,
      className: le(m.root, i),
      ...p,
      children: r
    })
  });
}, "RadioGroup"));
process.env.NODE_ENV !== "production" && (yd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * The name used to reference the value of the control.
   * If you don't provide this prop, it falls back to a randomly generated name.
   */
  name: s.string,
  /**
   * Callback fired when a radio button is selected.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {string} value The value of the selected radio button.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: s.func,
  /**
   * Value of the selected radio button. The DOM API casts this to a string.
   */
  value: s.any
});
function xd(e) {
  return Te("MuiSelect", e);
}
a(xd, "getSelectUtilityClasses");
const ei = Se("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
var t4;
const Lm = ee(hd, {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [
      // Win specificity over the input base
      {
        [`&.${ei.select}`]: t.select
      },
      {
        [`&.${ei.select}`]: t[n.variant]
      },
      {
        [`&.${ei.error}`]: t.error
      },
      {
        [`&.${ei.multiple}`]: t.multiple
      }
    ];
  }, "overridesResolver")
})({
  // Win specificity over the input base
  [`&.${ei.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), Vm = ee(gd, {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${G(n.variant)}`], n.open && t.iconOpen];
  }, "overridesResolver")
})({}), Am = ee("input", {
  shouldForwardProp: /* @__PURE__ */ a((e) => M5(e) && e !== "classes", "shouldForwardProp"),
  name: "MuiSelect",
  slot: "NativeInput"
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function n4(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
a(n4, "areEqualValues");
function Bm(e) {
  return e == null || typeof e == "string" && !e.trim();
}
a(Bm, "isEmpty");
const Hm = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    variant: n,
    disabled: o,
    multiple: r,
    open: i,
    error: l
  } = e, c = {
    select: ["select", n, o && "disabled", r && "multiple", l && "error"],
    icon: ["icon", `icon${G(n)}`, i && "iconOpen", o && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return ke(c, xd, t);
}, "useUtilityClasses$6"), vd = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  var tn;
  const {
    "aria-describedby": o,
    "aria-label": r,
    autoFocus: i,
    autoWidth: l,
    children: c,
    className: d,
    defaultOpen: u,
    defaultValue: p,
    disabled: f,
    displayEmpty: m,
    error: b = !1,
    IconComponent: C,
    inputRef: g,
    labelId: y,
    MenuProps: w = {},
    multiple: T,
    name: x,
    onBlur: S,
    onChange: M,
    onClose: O,
    onFocus: P,
    onOpen: E,
    open: I,
    readOnly: v,
    renderValue: _,
    required: R,
    SelectDisplayProps: j = {},
    tabIndex: B,
    // catching `type` from Input which makes no sense for SelectInput
    type: V,
    value: L,
    variant: D = "standard",
    ...z
  } = t, [H, $] = Mo({
    controlled: L,
    default: p,
    name: "Select"
  }), [A, U] = Mo({
    controlled: I,
    default: u,
    name: "Select"
  }), K = k.useRef(null), J = k.useRef(null), [F, N] = k.useState(null), {
    current: te
  } = k.useRef(I != null), [oe, ne] = k.useState(), X = xt(n, g), se = k.useCallback((ue) => {
    J.current = ue, ue && N(ue);
  }, []), Y = F == null ? void 0 : F.parentNode;
  k.useImperativeHandle(X, () => ({
    focus: /* @__PURE__ */ a(() => {
      J.current.focus();
    }, "focus"),
    node: K.current,
    value: H
  }), [H]), k.useEffect(() => {
    u && A && F && !te && (ne(l ? null : Y.clientWidth), J.current.focus());
  }, [F, l]), k.useEffect(() => {
    i && J.current.focus();
  }, [i]), k.useEffect(() => {
    if (!y)
      return;
    const ue = Qt(J.current).getElementById(y);
    if (ue) {
      const Me = /* @__PURE__ */ a(() => {
        getSelection().isCollapsed && J.current.focus();
      }, "handler");
      return ue.addEventListener("click", Me), () => {
        ue.removeEventListener("click", Me);
      };
    }
  }, [y]);
  const fe = /* @__PURE__ */ a((ue, Me) => {
    ue ? E && E(Me) : O && O(Me), te || (ne(l ? null : Y.clientWidth), U(ue));
  }, "update"), be = /* @__PURE__ */ a((ue) => {
    ue.button === 0 && (ue.preventDefault(), J.current.focus(), fe(!0, ue));
  }, "handleMouseDown"), Re = /* @__PURE__ */ a((ue) => {
    fe(!1, ue);
  }, "handleClose"), Oe = k.Children.toArray(c), Be = /* @__PURE__ */ a((ue) => {
    const Me = Oe.find((Xe) => Xe.props.value === ue.target.value);
    Me !== void 0 && ($(Me.props.value), M && M(ue, Me));
  }, "handleChange"), re = /* @__PURE__ */ a((ue) => (Me) => {
    let Xe;
    if (Me.currentTarget.hasAttribute("tabindex")) {
      if (T) {
        Xe = Array.isArray(H) ? H.slice() : [];
        const $t = H.indexOf(ue.props.value);
        $t === -1 ? Xe.push(ue.props.value) : Xe.splice($t, 1);
      } else
        Xe = ue.props.value;
      if (ue.props.onClick && ue.props.onClick(Me), H !== Xe && ($(Xe), M)) {
        const $t = Me.nativeEvent || Me, Ln = new $t.constructor($t.type, $t);
        Object.defineProperty(Ln, "target", {
          writable: !0,
          value: {
            value: Xe,
            name: x
          }
        }), M(Ln, ue);
      }
      T || fe(!1, Me);
    }
  }, "handleItemClick"), Fe = /* @__PURE__ */ a((ue) => {
    v || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].includes(ue.key) && (ue.preventDefault(), fe(!0, ue));
  }, "handleKeyDown"), Ce = F !== null && A, Pe = /* @__PURE__ */ a((ue) => {
    !Ce && S && (Object.defineProperty(ue, "target", {
      writable: !0,
      value: {
        value: H,
        name: x
      }
    }), S(ue));
  }, "handleBlur");
  delete z["aria-invalid"];
  let de, pt;
  const ze = [];
  let ut = !1, Mt = !1;
  (ma({
    value: H
  }) || m) && (_ ? de = _(H) : ut = !0);
  const At = Oe.map((ue) => {
    if (!/* @__PURE__ */ k.isValidElement(ue))
      return null;
    process.env.NODE_ENV !== "production" && ko.isFragment(ue) && console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    let Me;
    if (T) {
      if (!Array.isArray(H))
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : qn(2));
      Me = H.some((Xe) => n4(Xe, ue.props.value)), Me && ut && ze.push(ue.props.children);
    } else
      Me = n4(H, ue.props.value), Me && ut && (pt = ue.props.children);
    return Me && (Mt = !0), /* @__PURE__ */ k.cloneElement(ue, {
      "aria-selected": Me ? "true" : "false",
      onClick: re(ue),
      onKeyUp: /* @__PURE__ */ a((Xe) => {
        Xe.key === " " && Xe.preventDefault(), ue.props.onKeyUp && ue.props.onKeyUp(Xe);
      }, "onKeyUp"),
      role: "option",
      selected: Me,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": ue.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  process.env.NODE_ENV !== "production" && k.useEffect(() => {
    if (!Mt && !T && H !== "") {
      const ue = Oe.map((Me) => Me.props.value);
      console.warn([`MUI: You have provided an out-of-range value \`${H}\` for the select ${x ? `(name="${x}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${ue.filter((Me) => Me != null).map((Me) => `\`${Me}\``).join(", ") || '""'}.`].join(`
`));
    }
  }, [Mt, Oe, T, x, H]), ut && (T ? ze.length === 0 ? de = null : de = ze.reduce((ue, Me, Xe) => (ue.push(Me), Xe < ze.length - 1 && ue.push(", "), ue), []) : de = pt);
  let ft = oe;
  !l && te && F && (ft = Y.clientWidth);
  let Tt;
  typeof B < "u" ? Tt = B : Tt = f ? null : 0;
  const lt = j.id || (x ? `mui-component-select-${x}` : void 0), ce = {
    ...t,
    variant: D,
    value: H,
    open: Ce,
    error: b
  }, nt = Hm(ce), vt = {
    ...w.PaperProps,
    ...(tn = w.slotProps) == null ? void 0 : tn.paper
  }, Ke = _o();
  return /* @__PURE__ */ h.jsxs(k.Fragment, {
    children: [/* @__PURE__ */ h.jsx(Lm, {
      as: "div",
      ref: se,
      tabIndex: Tt,
      role: "combobox",
      "aria-controls": Ce ? Ke : void 0,
      "aria-disabled": f ? "true" : void 0,
      "aria-expanded": Ce ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": r,
      "aria-labelledby": [y, lt].filter(Boolean).join(" ") || void 0,
      "aria-describedby": o,
      "aria-required": R ? "true" : void 0,
      "aria-invalid": b ? "true" : void 0,
      onKeyDown: Fe,
      onMouseDown: f || v ? null : be,
      onBlur: Pe,
      onFocus: P,
      ...j,
      ownerState: ce,
      className: le(j.className, nt.select, d),
      id: lt,
      children: Bm(de) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        t4 || (t4 = /* @__PURE__ */ h.jsx("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      ) : de
    }), /* @__PURE__ */ h.jsx(Am, {
      "aria-invalid": b,
      value: Array.isArray(H) ? H.join(",") : H,
      name: x,
      ref: K,
      "aria-hidden": !0,
      onChange: Be,
      tabIndex: -1,
      disabled: f,
      className: nt.nativeInput,
      autoFocus: i,
      required: R,
      ...z,
      ownerState: ce
    }), /* @__PURE__ */ h.jsx(Vm, {
      as: C,
      className: nt.icon,
      ownerState: ce
    }), /* @__PURE__ */ h.jsx(fd, {
      id: `menu-${x || ""}`,
      anchorEl: Y,
      open: Ce,
      onClose: Re,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      },
      ...w,
      slotProps: {
        ...w.slotProps,
        list: {
          "aria-labelledby": y,
          role: "listbox",
          "aria-multiselectable": T ? "true" : void 0,
          disableListWrap: !0,
          id: Ke,
          ...w.MenuListProps
        },
        paper: {
          ...vt,
          style: {
            minWidth: ft,
            ...vt != null ? vt.style : null
          }
        }
      },
      children: At
    })]
  });
}, "SelectInput"));
process.env.NODE_ENV !== "production" && (vd.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": s.string,
  /**
   * @ignore
   */
  "aria-label": s.string,
  /**
   * @ignore
   */
  autoFocus: s.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: s.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * The CSS class name of the select element.
   */
  className: s.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: s.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: s.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: s.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: s.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: s.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: Wt,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: s.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: s.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: s.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: s.string,
  /**
   * @ignore
   */
  onBlur: s.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: s.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: s.func,
  /**
   * @ignore
   */
  onFocus: s.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: s.func,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool,
  /**
   * @ignore
   */
  readOnly: s.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: s.func,
  /**
   * If `true`, the component is required.
   */
  required: s.bool,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: s.object,
  /**
   * @ignore
   */
  tabIndex: s.oneOfType([s.number, s.string]),
  /**
   * @ignore
   */
  type: s.any,
  /**
   * The input value.
   */
  value: s.any,
  /**
   * The variant to use.
   */
  variant: s.oneOf(["standard", "outlined", "filled"])
});
const Dm = /* @__PURE__ */ a((e) => {
  const {
    classes: t
  } = e, o = ke({
    root: ["root"]
  }, xd, t);
  return {
    ...t,
    ...o
  };
}, "useUtilityClasses$5"), Nc = {
  name: "MuiSelect",
  slot: "Root",
  shouldForwardProp: /* @__PURE__ */ a((e) => Vt(e) && e !== "variant", "shouldForwardProp")
}, Nm = ee(Cl, Nc)(""), zm = ee(yl, Nc)(""), Fm = ee(bl, Nc)(""), xl = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    name: "MuiSelect",
    props: t
  }), {
    autoWidth: r = !1,
    children: i,
    classes: l = {},
    className: c,
    defaultOpen: d = !1,
    displayEmpty: u = !1,
    IconComponent: p = X5,
    id: f,
    input: m,
    inputProps: b,
    label: C,
    labelId: g,
    MenuProps: y,
    multiple: w = !1,
    native: T = !1,
    onClose: x,
    onOpen: S,
    open: M,
    renderValue: O,
    SelectDisplayProps: P,
    variant: E = "outlined",
    ...I
  } = o, v = T ? md : vd, _ = jn(), R = Lo({
    props: o,
    muiFormControl: _,
    states: ["variant", "error"]
  }), j = R.variant || E, B = {
    ...o,
    variant: j,
    classes: l
  }, V = Dm(B), {
    root: L,
    ...D
  } = V, z = m || {
    standard: /* @__PURE__ */ h.jsx(Nm, {
      ownerState: B
    }),
    outlined: /* @__PURE__ */ h.jsx(zm, {
      label: C,
      ownerState: B
    }),
    filled: /* @__PURE__ */ h.jsx(Fm, {
      ownerState: B
    })
  }[j], H = xt(n, ir(z));
  return /* @__PURE__ */ h.jsx(k.Fragment, {
    children: /* @__PURE__ */ k.cloneElement(z, {
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: v,
      inputProps: {
        children: i,
        error: R.error,
        IconComponent: p,
        variant: j,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: w,
        ...T ? {
          id: f
        } : {
          autoWidth: r,
          defaultOpen: d,
          displayEmpty: u,
          labelId: g,
          MenuProps: y,
          onClose: x,
          onOpen: S,
          open: M,
          renderValue: O,
          SelectDisplayProps: {
            id: f,
            ...P
          }
        },
        ...b,
        classes: b ? zt(D, b.classes) : D,
        ...m ? m.props.inputProps : {}
      },
      ...(w && T || u) && j === "outlined" ? {
        notched: !0
      } : {},
      ref: H,
      className: le(z.props.className, c, V.root),
      // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
      ...!m && {
        variant: j
      },
      ...I
    })
  });
}, "Select"));
process.env.NODE_ENV !== "production" && (xl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: s.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: s.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: s.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: s.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: s.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: s.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: s.object,
  /**
   * See [OutlinedInput#label](https://mui.com/material-ui/api/outlined-input/#props)
   */
  label: s.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: s.string,
  /**
   * Props applied to the [`Menu`](https://mui.com/material-ui/api/menu/) element.
   */
  MenuProps: s.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: s.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: s.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: s.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: s.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: s.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: s.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: s.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: s.oneOfType([s.oneOf([""]), s.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: s.oneOf(["filled", "outlined", "standard"])
});
xl.muiName = "Select";
function Wm(e) {
  return Te("MuiTooltip", e);
}
a(Wm, "getTooltipUtilityClass");
const mt = Se("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]);
function Zm(e) {
  return Math.round(e * 1e5) / 1e5;
}
a(Zm, "round$1");
const Um = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    disableInteractive: n,
    arrow: o,
    touch: r,
    placement: i
  } = e, l = {
    popper: ["popper", !n && "popperInteractive", o && "popperArrow"],
    tooltip: ["tooltip", o && "tooltipArrow", r && "touch", `tooltipPlacement${G(i.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return ke(l, Wm, t);
}, "useUtilityClasses$4"), Gm = ee(cs, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.popper, !n.disableInteractive && t.popperInteractive, n.arrow && t.popperArrow, !n.open && t.popperClose];
  }, "overridesResolver")
})(we(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.tooltip,
  pointerEvents: "none",
  variants: [{
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => !t.disableInteractive, "props"),
    style: {
      pointerEvents: "auto"
    }
  }, {
    props: /* @__PURE__ */ a(({
      open: t
    }) => !t, "props"),
    style: {
      pointerEvents: "none"
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.arrow, "props"),
    style: {
      [`&[data-popper-placement*="bottom"] .${mt.arrow}`]: {
        top: 0,
        marginTop: "-0.71em",
        "&::before": {
          transformOrigin: "0 100%"
        }
      },
      [`&[data-popper-placement*="top"] .${mt.arrow}`]: {
        bottom: 0,
        marginBottom: "-0.71em",
        "&::before": {
          transformOrigin: "100% 0"
        }
      },
      [`&[data-popper-placement*="right"] .${mt.arrow}`]: {
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "100% 100%"
        }
      },
      [`&[data-popper-placement*="left"] .${mt.arrow}`]: {
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "0 0"
        }
      }
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.arrow && !t.isRtl, "props"),
    style: {
      [`&[data-popper-placement*="right"] .${mt.arrow}`]: {
        left: 0,
        marginLeft: "-0.71em"
      }
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.arrow && !!t.isRtl, "props"),
    style: {
      [`&[data-popper-placement*="right"] .${mt.arrow}`]: {
        right: 0,
        marginRight: "-0.71em"
      }
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.arrow && !t.isRtl, "props"),
    style: {
      [`&[data-popper-placement*="left"] .${mt.arrow}`]: {
        right: 0,
        marginRight: "-0.71em"
      }
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.arrow && !!t.isRtl, "props"),
    style: {
      [`&[data-popper-placement*="left"] .${mt.arrow}`]: {
        left: 0,
        marginLeft: "-0.71em"
      }
    }
  }]
}))), Ym = ee("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.tooltip, n.touch && t.touch, n.arrow && t.tooltipArrow, t[`tooltipPlacement${G(n.placement.split("-")[0])}`]];
  }, "overridesResolver")
})(we(({
  theme: e
}) => ({
  backgroundColor: e.vars ? e.vars.palette.Tooltip.bg : De(e.palette.grey[700], 0.92),
  borderRadius: (e.vars || e).shape.borderRadius,
  color: (e.vars || e).palette.common.white,
  fontFamily: e.typography.fontFamily,
  padding: "4px 8px",
  fontSize: e.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: e.typography.fontWeightMedium,
  [`.${mt.popper}[data-popper-placement*="left"] &`]: {
    transformOrigin: "right center"
  },
  [`.${mt.popper}[data-popper-placement*="right"] &`]: {
    transformOrigin: "left center"
  },
  [`.${mt.popper}[data-popper-placement*="top"] &`]: {
    transformOrigin: "center bottom",
    marginBottom: "14px"
  },
  [`.${mt.popper}[data-popper-placement*="bottom"] &`]: {
    transformOrigin: "center top",
    marginTop: "14px"
  },
  variants: [{
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.arrow, "props"),
    style: {
      position: "relative",
      margin: 0
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.touch, "props"),
    style: {
      padding: "8px 16px",
      fontSize: e.typography.pxToRem(14),
      lineHeight: `${Zm(16 / 14)}em`,
      fontWeight: e.typography.fontWeightRegular
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => !t.isRtl, "props"),
    style: {
      [`.${mt.popper}[data-popper-placement*="left"] &`]: {
        marginRight: "14px"
      },
      [`.${mt.popper}[data-popper-placement*="right"] &`]: {
        marginLeft: "14px"
      }
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => !t.isRtl && t.touch, "props"),
    style: {
      [`.${mt.popper}[data-popper-placement*="left"] &`]: {
        marginRight: "24px"
      },
      [`.${mt.popper}[data-popper-placement*="right"] &`]: {
        marginLeft: "24px"
      }
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => !!t.isRtl, "props"),
    style: {
      [`.${mt.popper}[data-popper-placement*="left"] &`]: {
        marginLeft: "14px"
      },
      [`.${mt.popper}[data-popper-placement*="right"] &`]: {
        marginRight: "14px"
      }
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => !!t.isRtl && t.touch, "props"),
    style: {
      [`.${mt.popper}[data-popper-placement*="left"] &`]: {
        marginLeft: "24px"
      },
      [`.${mt.popper}[data-popper-placement*="right"] &`]: {
        marginRight: "24px"
      }
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.touch, "props"),
    style: {
      [`.${mt.popper}[data-popper-placement*="top"] &`]: {
        marginBottom: "24px"
      }
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.touch, "props"),
    style: {
      [`.${mt.popper}[data-popper-placement*="bottom"] &`]: {
        marginTop: "24px"
      }
    }
  }]
}))), qm = ee("span", {
  name: "MuiTooltip",
  slot: "Arrow"
})(we(({
  theme: e
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: e.vars ? e.vars.palette.Tooltip.bg : De(e.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
})));
let Es = !1;
const o4 = new ca();
let ti = {
  x: 0,
  y: 0
};
function $s(e, t) {
  return (n, ...o) => {
    t && t(n, ...o), e(n, ...o);
  };
}
a($s, "composeEventHandler");
const wd = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiTooltip"
  }), {
    arrow: r = !1,
    children: i,
    classes: l,
    components: c = {},
    componentsProps: d = {},
    describeChild: u = !1,
    disableFocusListener: p = !1,
    disableHoverListener: f = !1,
    disableInteractive: m = !1,
    disableTouchListener: b = !1,
    enterDelay: C = 100,
    enterNextDelay: g = 0,
    enterTouchDelay: y = 700,
    followCursor: w = !1,
    id: T,
    leaveDelay: x = 0,
    leaveTouchDelay: S = 1500,
    onClose: M,
    onOpen: O,
    open: P,
    placement: E = "bottom",
    PopperComponent: I,
    PopperProps: v = {},
    slotProps: _ = {},
    slots: R = {},
    title: j,
    TransitionComponent: B,
    TransitionProps: V,
    ...L
  } = o, D = /* @__PURE__ */ k.isValidElement(i) ? i : /* @__PURE__ */ h.jsx("span", {
    children: i
  }), z = uo(), H = Dr(), [$, A] = k.useState(), [U, K] = k.useState(null), J = k.useRef(!1), F = m || w, N = qo(), te = qo(), oe = qo(), ne = qo(), [X, se] = Mo({
    controlled: P,
    default: !1,
    name: "Tooltip",
    state: "open"
  });
  let Y = X;
  if (process.env.NODE_ENV !== "production") {
    const {
      current: xe
    } = k.useRef(P !== void 0);
    k.useEffect(() => {
      $ && $.disabled && !xe && j !== "" && $.tagName.toLowerCase() === "button" && console.warn(["MUI: You are providing a disabled `button` child to the Tooltip component.", "A disabled element does not fire events.", "Tooltip needs to listen to the child element's events to display the title.", "", "Add a simple wrapper element, such as a `span`."].join(`
`));
    }, [j, $, xe]);
  }
  const fe = _o(T), be = k.useRef(), Re = Dt(() => {
    be.current !== void 0 && (document.body.style.WebkitUserSelect = be.current, be.current = void 0), ne.clear();
  });
  k.useEffect(() => Re, [Re]);
  const Oe = /* @__PURE__ */ a((xe) => {
    o4.clear(), Es = !0, se(!0), O && !Y && O(xe);
  }, "handleOpen"), Be = Dt(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (xe) => {
      o4.start(800 + x, () => {
        Es = !1;
      }), se(!1), M && Y && M(xe), N.start(z.transitions.duration.shortest, () => {
        J.current = !1;
      });
    }
  ), re = /* @__PURE__ */ a((xe) => {
    J.current && xe.type !== "touchstart" || ($ && $.removeAttribute("title"), te.clear(), oe.clear(), C || Es && g ? te.start(Es ? g : C, () => {
      Oe(xe);
    }) : Oe(xe));
  }, "handleMouseOver"), Fe = /* @__PURE__ */ a((xe) => {
    te.clear(), oe.start(x, () => {
      Be(xe);
    });
  }, "handleMouseLeave"), [, Ce] = k.useState(!1), Pe = /* @__PURE__ */ a((xe) => {
    ua(xe.target) || (Ce(!1), Fe(xe));
  }, "handleBlur"), de = /* @__PURE__ */ a((xe) => {
    $ || A(xe.currentTarget), ua(xe.target) && (Ce(!0), re(xe));
  }, "handleFocus"), pt = /* @__PURE__ */ a((xe) => {
    J.current = !0;
    const wt = D.props;
    wt.onTouchStart && wt.onTouchStart(xe);
  }, "detectTouchStart"), ze = /* @__PURE__ */ a((xe) => {
    pt(xe), oe.clear(), N.clear(), Re(), be.current = document.body.style.WebkitUserSelect, document.body.style.WebkitUserSelect = "none", ne.start(y, () => {
      document.body.style.WebkitUserSelect = be.current, re(xe);
    });
  }, "handleTouchStart"), ut = /* @__PURE__ */ a((xe) => {
    D.props.onTouchEnd && D.props.onTouchEnd(xe), Re(), oe.start(S, () => {
      Be(xe);
    });
  }, "handleTouchEnd");
  k.useEffect(() => {
    if (!Y)
      return;
    function xe(wt) {
      wt.key === "Escape" && Be(wt);
    }
    return a(xe, "handleKeyDown"), document.addEventListener("keydown", xe), () => {
      document.removeEventListener("keydown", xe);
    };
  }, [Be, Y]);
  const Mt = xt(ir(D), A, n);
  !j && j !== 0 && (Y = !1);
  const At = k.useRef(), ft = /* @__PURE__ */ a((xe) => {
    const wt = D.props;
    wt.onMouseMove && wt.onMouseMove(xe), ti = {
      x: xe.clientX,
      y: xe.clientY
    }, At.current && At.current.update();
  }, "handleMouseMove"), Tt = {}, lt = typeof j == "string";
  u ? (Tt.title = !Y && lt && !f ? j : null, Tt["aria-describedby"] = Y ? fe : null) : (Tt["aria-label"] = lt ? j : null, Tt["aria-labelledby"] = Y && !lt ? fe : null);
  const ce = {
    ...Tt,
    ...L,
    ...D.props,
    className: le(L.className, D.props.className),
    onTouchStart: pt,
    ref: Mt,
    ...w ? {
      onMouseMove: ft
    } : {}
  };
  process.env.NODE_ENV !== "production" && (ce["data-mui-internal-clone-element"] = !0, k.useEffect(() => {
    $ && !$.getAttribute("data-mui-internal-clone-element") && console.error(["MUI: The `children` component of the Tooltip is not forwarding its props correctly.", "Please make sure that props are spread on the same element that the ref is applied to."].join(`
`));
  }, [$]));
  const nt = {};
  b || (ce.onTouchStart = ze, ce.onTouchEnd = ut), f || (ce.onMouseOver = $s(re, ce.onMouseOver), ce.onMouseLeave = $s(Fe, ce.onMouseLeave), F || (nt.onMouseOver = re, nt.onMouseLeave = Fe)), p || (ce.onFocus = $s(de, ce.onFocus), ce.onBlur = $s(Pe, ce.onBlur), F || (nt.onFocus = de, nt.onBlur = Pe)), process.env.NODE_ENV !== "production" && D.props.title && console.error(["MUI: You have provided a `title` prop to the child of <Tooltip />.", `Remove this title prop \`${D.props.title}\` or the Tooltip component.`].join(`
`));
  const vt = {
    ...o,
    isRtl: H,
    arrow: r,
    disableInteractive: F,
    placement: E,
    PopperComponentProp: I,
    touch: J.current
  }, Ke = typeof _.popper == "function" ? _.popper(vt) : _.popper, tn = k.useMemo(() => {
    var wt, ae;
    let xe = [{
      name: "arrow",
      enabled: !!U,
      options: {
        element: U,
        padding: 4
      }
    }];
    return (wt = v.popperOptions) != null && wt.modifiers && (xe = xe.concat(v.popperOptions.modifiers)), (ae = Ke == null ? void 0 : Ke.popperOptions) != null && ae.modifiers && (xe = xe.concat(Ke.popperOptions.modifiers)), {
      ...v.popperOptions,
      ...Ke == null ? void 0 : Ke.popperOptions,
      modifiers: xe
    };
  }, [U, v.popperOptions, Ke == null ? void 0 : Ke.popperOptions]), ue = Um(vt), Me = typeof _.transition == "function" ? _.transition(vt) : _.transition, Xe = {
    slots: {
      popper: c.Popper,
      transition: c.Transition ?? B,
      tooltip: c.Tooltip,
      arrow: c.Arrow,
      ...R
    },
    slotProps: {
      arrow: _.arrow ?? d.arrow,
      popper: {
        ...v,
        ...Ke ?? d.popper
      },
      // resolvedPopperProps can be spread because it's already an object
      tooltip: _.tooltip ?? d.tooltip,
      transition: {
        ...V,
        ...Me ?? d.transition
      }
    }
  }, [$t, Ln] = ve("popper", {
    elementType: Gm,
    externalForwardedProps: Xe,
    ownerState: vt,
    className: le(ue.popper, v == null ? void 0 : v.className)
  }), [_t, nn] = ve("transition", {
    elementType: Ui,
    externalForwardedProps: Xe,
    ownerState: vt
  }), [on, Vn] = ve("tooltip", {
    elementType: Ym,
    className: ue.tooltip,
    externalForwardedProps: Xe,
    ownerState: vt
  }), [Zt, ho] = ve("arrow", {
    elementType: qm,
    className: ue.arrow,
    externalForwardedProps: Xe,
    ownerState: vt,
    ref: K
  });
  return /* @__PURE__ */ h.jsxs(k.Fragment, {
    children: [/* @__PURE__ */ k.cloneElement(D, ce), /* @__PURE__ */ h.jsx($t, {
      as: I ?? cs,
      placement: E,
      anchorEl: w ? {
        getBoundingClientRect: /* @__PURE__ */ a(() => ({
          top: ti.y,
          left: ti.x,
          right: ti.x,
          bottom: ti.y,
          width: 0,
          height: 0
        }), "getBoundingClientRect")
      } : $,
      popperRef: At,
      open: $ ? Y : !1,
      id: fe,
      transition: !0,
      ...nt,
      ...Ln,
      popperOptions: tn,
      children: /* @__PURE__ */ a(({
        TransitionProps: xe
      }) => /* @__PURE__ */ h.jsx(_t, {
        timeout: z.transitions.duration.shorter,
        ...xe,
        ...nn,
        children: /* @__PURE__ */ h.jsxs(on, {
          ...Vn,
          children: [j, r ? /* @__PURE__ */ h.jsx(Zt, {
            ...ho
          }) : null]
        })
      }), "children")
    })]
  });
}, "Tooltip"));
process.env.NODE_ENV !== "production" && (wd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: s.bool,
  /**
   * Tooltip reference element.
   */
  children: sr.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: s.shape({
    Arrow: s.elementType,
    Popper: s.elementType,
    Tooltip: s.elementType,
    Transition: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: s.shape({
    arrow: s.object,
    popper: s.object,
    tooltip: s.object,
    transition: s.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: s.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: s.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: s.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: s.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: s.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: s.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: s.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: s.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: s.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: s.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: s.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: s.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: s.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: s.func,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: s.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The component used for the popper.
   * @deprecated use the `slots.popper` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PopperComponent: s.elementType,
  /**
   * Props applied to the [`Popper`](https://mui.com/material-ui/api/popper/) element.
   * @deprecated use the `slotProps.popper` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  PopperProps: s.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    arrow: s.oneOfType([s.func, s.object]),
    popper: s.oneOfType([s.func, s.object]),
    tooltip: s.oneOfType([s.func, s.object]),
    transition: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    arrow: s.elementType,
    popper: s.elementType,
    tooltip: s.elementType,
    transition: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: s.node,
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated use the `slots.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: s.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: s.object
});
function Km(e) {
  return Te("MuiTab", e);
}
a(Km, "getTabUtilityClass");
const fn = Se("MuiTab", ["root", "labelIcon", "textColorInherit", "textColorPrimary", "textColorSecondary", "selected", "disabled", "fullWidth", "wrapped", "iconWrapper", "icon"]), Xm = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    textColor: n,
    fullWidth: o,
    wrapped: r,
    icon: i,
    label: l,
    selected: c,
    disabled: d
  } = e, u = {
    root: ["root", i && l && "labelIcon", `textColor${G(n)}`, o && "fullWidth", r && "wrapped", c && "selected", d && "disabled"],
    icon: ["iconWrapper", "icon"]
  };
  return ke(u, Km, t);
}, "useUtilityClasses$3"), Jm = ee(lo, {
  name: "MuiTab",
  slot: "Root",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.label && n.icon && t.labelIcon, t[`textColor${G(n.textColor)}`], n.fullWidth && t.fullWidth, n.wrapped && t.wrapped, {
      [`& .${fn.iconWrapper}`]: t.iconWrapper
    }, {
      [`& .${fn.icon}`]: t.icon
    }];
  }, "overridesResolver")
})(we(({
  theme: e
}) => ({
  ...e.typography.button,
  maxWidth: 360,
  minWidth: 90,
  position: "relative",
  minHeight: 48,
  flexShrink: 0,
  padding: "12px 16px",
  overflow: "hidden",
  whiteSpace: "normal",
  textAlign: "center",
  lineHeight: 1.25,
  variants: [{
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.label && (t.iconPosition === "top" || t.iconPosition === "bottom"), "props"),
    style: {
      flexDirection: "column"
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.label && t.iconPosition !== "top" && t.iconPosition !== "bottom", "props"),
    style: {
      flexDirection: "row"
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.icon && t.label, "props"),
    style: {
      minHeight: 72,
      paddingTop: 9,
      paddingBottom: 9
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t,
      iconPosition: n
    }) => t.icon && t.label && n === "top", "props"),
    style: {
      [`& > .${fn.icon}`]: {
        marginBottom: 6
      }
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t,
      iconPosition: n
    }) => t.icon && t.label && n === "bottom", "props"),
    style: {
      [`& > .${fn.icon}`]: {
        marginTop: 6
      }
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t,
      iconPosition: n
    }) => t.icon && t.label && n === "start", "props"),
    style: {
      [`& > .${fn.icon}`]: {
        marginRight: e.spacing(1)
      }
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t,
      iconPosition: n
    }) => t.icon && t.label && n === "end", "props"),
    style: {
      [`& > .${fn.icon}`]: {
        marginLeft: e.spacing(1)
      }
    }
  }, {
    props: {
      textColor: "inherit"
    },
    style: {
      color: "inherit",
      opacity: 0.6,
      // same opacity as theme.palette.text.secondary
      [`&.${fn.selected}`]: {
        opacity: 1
      },
      [`&.${fn.disabled}`]: {
        opacity: (e.vars || e).palette.action.disabledOpacity
      }
    }
  }, {
    props: {
      textColor: "primary"
    },
    style: {
      color: (e.vars || e).palette.text.secondary,
      [`&.${fn.selected}`]: {
        color: (e.vars || e).palette.primary.main
      },
      [`&.${fn.disabled}`]: {
        color: (e.vars || e).palette.text.disabled
      }
    }
  }, {
    props: {
      textColor: "secondary"
    },
    style: {
      color: (e.vars || e).palette.text.secondary,
      [`&.${fn.selected}`]: {
        color: (e.vars || e).palette.secondary.main
      },
      [`&.${fn.disabled}`]: {
        color: (e.vars || e).palette.text.disabled
      }
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.fullWidth, "props"),
    style: {
      flexShrink: 1,
      flexGrow: 1,
      flexBasis: 0,
      maxWidth: "none"
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.wrapped, "props"),
    style: {
      fontSize: e.typography.pxToRem(12)
    }
  }]
}))), Sd = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiTab"
  }), {
    className: r,
    disabled: i = !1,
    disableFocusRipple: l = !1,
    // eslint-disable-next-line react/prop-types
    fullWidth: c,
    icon: d,
    iconPosition: u = "top",
    // eslint-disable-next-line react/prop-types
    indicator: p,
    label: f,
    onChange: m,
    onClick: b,
    onFocus: C,
    // eslint-disable-next-line react/prop-types
    selected: g,
    // eslint-disable-next-line react/prop-types
    selectionFollowsFocus: y,
    // eslint-disable-next-line react/prop-types
    textColor: w = "inherit",
    value: T,
    wrapped: x = !1,
    ...S
  } = o, M = {
    ...o,
    disabled: i,
    disableFocusRipple: l,
    selected: g,
    icon: !!d,
    iconPosition: u,
    label: !!f,
    fullWidth: c,
    textColor: w,
    wrapped: x
  }, O = Xm(M), P = d && f && /* @__PURE__ */ k.isValidElement(d) ? /* @__PURE__ */ k.cloneElement(d, {
    className: le(O.icon, d.props.className)
  }) : d, E = /* @__PURE__ */ a((v) => {
    !g && m && m(v, T), b && b(v);
  }, "handleClick"), I = /* @__PURE__ */ a((v) => {
    y && !g && m && m(v, T), C && C(v);
  }, "handleFocus");
  return /* @__PURE__ */ h.jsxs(Jm, {
    focusRipple: !l,
    className: le(O.root, r),
    ref: n,
    role: "tab",
    "aria-selected": g,
    disabled: i,
    onClick: E,
    onFocus: I,
    ownerState: M,
    tabIndex: g ? 0 : -1,
    ...S,
    children: [u === "top" || u === "start" ? /* @__PURE__ */ h.jsxs(k.Fragment, {
      children: [P, f]
    }) : /* @__PURE__ */ h.jsxs(k.Fragment, {
      children: [f, P]
    }), p]
  });
}, "Tab"));
process.env.NODE_ENV !== "production" && (Sd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: k5,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: s.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: s.bool,
  /**
   * The icon to display.
   */
  icon: s.oneOfType([s.element, s.string]),
  /**
   * The position of the icon relative to the label.
   * @default 'top'
   */
  iconPosition: s.oneOf(["bottom", "end", "start", "top"]),
  /**
   * The label element.
   */
  label: s.node,
  /**
   * @ignore
   */
  onChange: s.func,
  /**
   * @ignore
   */
  onClick: s.func,
  /**
   * @ignore
   */
  onFocus: s.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: s.any,
  /**
   * Tab labels appear in a single row.
   * They can use a second line if needed.
   * @default false
   */
  wrapped: s.bool
});
const Qm = en(/* @__PURE__ */ h.jsx("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft"), eb = en(/* @__PURE__ */ h.jsx("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");
function tb(e) {
  return (1 + Math.sin(Math.PI * e - Math.PI / 2)) / 2;
}
a(tb, "easeInOutSin");
function nb(e, t, n, o = {}, r = () => {
}) {
  const {
    ease: i = tb,
    duration: l = 300
    // standard
  } = o;
  let c = null;
  const d = t[e];
  let u = !1;
  const p = /* @__PURE__ */ a(() => {
    u = !0;
  }, "cancel"), f = /* @__PURE__ */ a((m) => {
    if (u) {
      r(new Error("Animation cancelled"));
      return;
    }
    c === null && (c = m);
    const b = Math.min(1, (m - c) / l);
    if (t[e] = i(b) * (n - d) + d, b >= 1) {
      requestAnimationFrame(() => {
        r(null);
      });
      return;
    }
    requestAnimationFrame(f);
  }, "step");
  return d === n ? (r(new Error("Element already at target position")), p) : (requestAnimationFrame(f), p);
}
a(nb, "animate");
const ob = {
  width: 99,
  height: 99,
  position: "absolute",
  top: -9999,
  overflow: "scroll"
};
function Md(e) {
  const {
    onChange: t,
    ...n
  } = e, o = k.useRef(), r = k.useRef(null), i = /* @__PURE__ */ a(() => {
    o.current = r.current.offsetHeight - r.current.clientHeight;
  }, "setMeasurements");
  return Rn(() => {
    const l = ss(() => {
      const d = o.current;
      i(), d !== o.current && t(o.current);
    }), c = dn(r.current);
    return c.addEventListener("resize", l), () => {
      l.clear(), c.removeEventListener("resize", l);
    };
  }, [t]), k.useEffect(() => {
    i(), t(o.current);
  }, [t]), /* @__PURE__ */ h.jsx("div", {
    style: ob,
    ...n,
    ref: r
  });
}
a(Md, "ScrollbarSize");
process.env.NODE_ENV !== "production" && (Md.propTypes = {
  onChange: s.func.isRequired
});
function rb(e) {
  return Te("MuiTabScrollButton", e);
}
a(rb, "getTabScrollButtonUtilityClass");
const ib = Se("MuiTabScrollButton", ["root", "vertical", "horizontal", "disabled"]), sb = /* @__PURE__ */ a((e) => {
  const {
    classes: t,
    orientation: n,
    disabled: o
  } = e;
  return ke({
    root: ["root", n, o && "disabled"]
  }, rb, t);
}, "useUtilityClasses$2"), ab = ee(lo, {
  name: "MuiTabScrollButton",
  slot: "Root",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.orientation && t[n.orientation]];
  }, "overridesResolver")
})({
  width: 40,
  flexShrink: 0,
  opacity: 0.8,
  [`&.${ib.disabled}`]: {
    opacity: 0
  },
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      width: "100%",
      height: 40,
      "& svg": {
        transform: "var(--TabScrollButton-svgRotate)"
      }
    }
  }]
}), Td = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiTabScrollButton"
  }), {
    className: r,
    slots: i = {},
    slotProps: l = {},
    direction: c,
    orientation: d,
    disabled: u,
    ...p
  } = o, f = Dr(), m = {
    isRtl: f,
    ...o
  }, b = sb(m), C = i.StartScrollButtonIcon ?? Qm, g = i.EndScrollButtonIcon ?? eb, y = jr({
    elementType: C,
    externalSlotProps: l.startScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: m
  }), w = jr({
    elementType: g,
    externalSlotProps: l.endScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: m
  });
  return /* @__PURE__ */ h.jsx(ab, {
    component: "div",
    className: le(b.root, r),
    ref: n,
    role: null,
    ownerState: m,
    tabIndex: null,
    ...p,
    style: {
      ...p.style,
      ...d === "vertical" && {
        "--TabScrollButton-svgRotate": `rotate(${f ? -90 : 90}deg)`
      }
    },
    children: c === "left" ? /* @__PURE__ */ h.jsx(C, {
      ...y
    }) : /* @__PURE__ */ h.jsx(g, {
      ...w
    })
  });
}, "TabScrollButton"));
process.env.NODE_ENV !== "production" && (Td.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The direction the button should indicate.
   */
  direction: s.oneOf(["left", "right"]).isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * The component orientation (layout flow direction).
   */
  orientation: s.oneOf(["horizontal", "vertical"]).isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */
  slotProps: s.shape({
    endScrollButtonIcon: s.oneOfType([s.func, s.object]),
    startScrollButtonIcon: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    EndScrollButtonIcon: s.elementType,
    StartScrollButtonIcon: s.elementType
  }),
  /**
   * @ignore
   */
  style: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function lb(e) {
  return Te("MuiTabs", e);
}
a(lb, "getTabsUtilityClass");
const Zl = Se("MuiTabs", ["root", "vertical", "list", "flexContainer", "flexContainerVertical", "centered", "scroller", "fixed", "scrollableX", "scrollableY", "hideScrollbar", "scrollButtons", "scrollButtonsHideMobile", "indicator"]), r4 = /* @__PURE__ */ a((e, t) => e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : e.firstChild, "nextItem"), i4 = /* @__PURE__ */ a((e, t) => e === t ? e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : e.lastChild, "previousItem"), Ps = /* @__PURE__ */ a((e, t, n) => {
  let o = !1, r = n(e, t);
  for (; r; ) {
    if (r === e.firstChild) {
      if (o)
        return;
      o = !0;
    }
    const i = r.disabled || r.getAttribute("aria-disabled") === "true";
    if (!r.hasAttribute("tabindex") || i)
      r = n(e, r);
    else {
      r.focus();
      return;
    }
  }
}, "moveFocus"), cb = /* @__PURE__ */ a((e) => {
  const {
    vertical: t,
    fixed: n,
    hideScrollbar: o,
    scrollableX: r,
    scrollableY: i,
    centered: l,
    scrollButtonsHideMobile: c,
    classes: d
  } = e;
  return ke({
    root: ["root", t && "vertical"],
    scroller: ["scroller", n && "fixed", o && "hideScrollbar", r && "scrollableX", i && "scrollableY"],
    list: ["list", "flexContainer", t && "flexContainerVertical", t && "vertical", l && "centered"],
    indicator: ["indicator"],
    scrollButtons: ["scrollButtons", c && "scrollButtonsHideMobile"],
    scrollableX: [r && "scrollableX"],
    hideScrollbar: [o && "hideScrollbar"]
  }, lb, d);
}, "useUtilityClasses$1"), db = ee("div", {
  name: "MuiTabs",
  slot: "Root",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${Zl.scrollButtons}`]: t.scrollButtons
    }, {
      [`& .${Zl.scrollButtons}`]: n.scrollButtonsHideMobile && t.scrollButtonsHideMobile
    }, t.root, n.vertical && t.vertical];
  }, "overridesResolver")
})(we(({
  theme: e
}) => ({
  overflow: "hidden",
  minHeight: 48,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  display: "flex",
  variants: [{
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.vertical, "props"),
    style: {
      flexDirection: "column"
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.scrollButtonsHideMobile, "props"),
    style: {
      [`& .${Zl.scrollButtons}`]: {
        [e.breakpoints.down("sm")]: {
          display: "none"
        }
      }
    }
  }]
}))), ub = ee("div", {
  name: "MuiTabs",
  slot: "Scroller",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.scroller, n.fixed && t.fixed, n.hideScrollbar && t.hideScrollbar, n.scrollableX && t.scrollableX, n.scrollableY && t.scrollableY];
  }, "overridesResolver")
})({
  position: "relative",
  display: "inline-block",
  flex: "1 1 auto",
  whiteSpace: "nowrap",
  variants: [{
    props: /* @__PURE__ */ a(({
      ownerState: e
    }) => e.fixed, "props"),
    style: {
      overflowX: "hidden",
      width: "100%"
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: e
    }) => e.hideScrollbar, "props"),
    style: {
      // Hide dimensionless scrollbar on macOS
      scrollbarWidth: "none",
      // Firefox
      "&::-webkit-scrollbar": {
        display: "none"
        // Safari + Chrome
      }
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: e
    }) => e.scrollableX, "props"),
    style: {
      overflowX: "auto",
      overflowY: "hidden"
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: e
    }) => e.scrollableY, "props"),
    style: {
      overflowY: "auto",
      overflowX: "hidden"
    }
  }]
}), pb = ee("div", {
  name: "MuiTabs",
  slot: "List",
  overridesResolver: /* @__PURE__ */ a((e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.list, t.flexContainer, n.vertical && t.flexContainerVertical, n.centered && t.centered];
  }, "overridesResolver")
})({
  display: "flex",
  variants: [{
    props: /* @__PURE__ */ a(({
      ownerState: e
    }) => e.vertical, "props"),
    style: {
      flexDirection: "column"
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: e
    }) => e.centered, "props"),
    style: {
      justifyContent: "center"
    }
  }]
}), fb = ee("span", {
  name: "MuiTabs",
  slot: "Indicator"
})(we(({
  theme: e
}) => ({
  position: "absolute",
  height: 2,
  bottom: 0,
  width: "100%",
  transition: e.transitions.create(),
  variants: [{
    props: {
      indicatorColor: "primary"
    },
    style: {
      backgroundColor: (e.vars || e).palette.primary.main
    }
  }, {
    props: {
      indicatorColor: "secondary"
    },
    style: {
      backgroundColor: (e.vars || e).palette.secondary.main
    }
  }, {
    props: /* @__PURE__ */ a(({
      ownerState: t
    }) => t.vertical, "props"),
    style: {
      height: "100%",
      width: 2,
      right: 0
    }
  }]
}))), hb = ee(Md)({
  overflowX: "auto",
  overflowY: "hidden",
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: "none",
  // Firefox
  "&::-webkit-scrollbar": {
    display: "none"
    // Safari + Chrome
  }
}), s4 = {};
let a4 = !1;
const kd = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiTabs"
  }), r = uo(), i = Dr(), {
    "aria-label": l,
    "aria-labelledby": c,
    action: d,
    centered: u = !1,
    children: p,
    className: f,
    component: m = "div",
    allowScrollButtonsMobile: b = !1,
    indicatorColor: C = "primary",
    onChange: g,
    orientation: y = "horizontal",
    ScrollButtonComponent: w,
    // TODO: remove in v7 (deprecated in v6)
    scrollButtons: T = "auto",
    selectionFollowsFocus: x,
    slots: S = {},
    slotProps: M = {},
    TabIndicatorProps: O = {},
    // TODO: remove in v7 (deprecated in v6)
    TabScrollButtonProps: P = {},
    // TODO: remove in v7 (deprecated in v6)
    textColor: E = "primary",
    value: I,
    variant: v = "standard",
    visibleScrollbar: _ = !1,
    ...R
  } = o, j = v === "scrollable", B = y === "vertical", V = B ? "scrollTop" : "scrollLeft", L = B ? "top" : "left", D = B ? "bottom" : "right", z = B ? "clientHeight" : "clientWidth", H = B ? "height" : "width", $ = {
    ...o,
    component: m,
    allowScrollButtonsMobile: b,
    indicatorColor: C,
    orientation: y,
    vertical: B,
    scrollButtons: T,
    textColor: E,
    variant: v,
    visibleScrollbar: _,
    fixed: !j,
    hideScrollbar: j && !_,
    scrollableX: j && !B,
    scrollableY: j && B,
    centered: u && !j,
    scrollButtonsHideMobile: !b
  }, A = cb($), U = jr({
    elementType: S.StartScrollButtonIcon,
    externalSlotProps: M.startScrollButtonIcon,
    ownerState: $
  }), K = jr({
    elementType: S.EndScrollButtonIcon,
    externalSlotProps: M.endScrollButtonIcon,
    ownerState: $
  });
  process.env.NODE_ENV !== "production" && u && j && console.error('MUI: You can not use the `centered={true}` and `variant="scrollable"` properties at the same time on a `Tabs` component.');
  const [J, F] = k.useState(!1), [N, te] = k.useState(s4), [oe, ne] = k.useState(!1), [X, se] = k.useState(!1), [Y, fe] = k.useState(!1), [be, Re] = k.useState({
    overflow: "hidden",
    scrollbarWidth: 0
  }), Oe = /* @__PURE__ */ new Map(), Be = k.useRef(null), re = k.useRef(null), Fe = {
    slots: S,
    slotProps: {
      indicator: O,
      scrollButton: P,
      ...M
    }
  }, Ce = /* @__PURE__ */ a(() => {
    const ae = Be.current;
    let he;
    if (ae) {
      const Ve = ae.getBoundingClientRect();
      he = {
        clientWidth: ae.clientWidth,
        scrollLeft: ae.scrollLeft,
        scrollTop: ae.scrollTop,
        scrollWidth: ae.scrollWidth,
        top: Ve.top,
        bottom: Ve.bottom,
        left: Ve.left,
        right: Ve.right
      };
    }
    let Ee;
    if (ae && I !== !1) {
      const Ve = re.current.children;
      if (Ve.length > 0) {
        const Je = Ve[Oe.get(I)];
        process.env.NODE_ENV !== "production" && (Je || console.error(["MUI: The `value` provided to the Tabs component is invalid.", `None of the Tabs' children match with "${I}".`, Oe.keys ? `You can provide one of the following values: ${Array.from(Oe.keys()).join(", ")}.` : null].join(`
`))), Ee = Je ? Je.getBoundingClientRect() : null, process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && !a4 && Ee && Ee.width === 0 && Ee.height === 0 && // if the whole Tabs component is hidden, don't warn
        he.clientWidth !== 0 && (he = null, console.error(["MUI: The `value` provided to the Tabs component is invalid.", `The Tab with this \`value\` ("${I}") is not part of the document layout.`, "Make sure the tab item is present in the document or that it's not `display: none`."].join(`
`)), a4 = !0);
      }
    }
    return {
      tabsMeta: he,
      tabMeta: Ee
    };
  }, "getTabsMeta"), Pe = Dt(() => {
    const {
      tabsMeta: ae,
      tabMeta: he
    } = Ce();
    let Ee = 0, Ve;
    B ? (Ve = "top", he && ae && (Ee = he.top - ae.top + ae.scrollTop)) : (Ve = i ? "right" : "left", he && ae && (Ee = (i ? -1 : 1) * (he[Ve] - ae[Ve] + ae.scrollLeft)));
    const Je = {
      [Ve]: Ee,
      // May be wrong until the font is loaded.
      [H]: he ? he[H] : 0
    };
    if (typeof N[Ve] != "number" || typeof N[H] != "number")
      te(Je);
    else {
      const Ut = Math.abs(N[Ve] - Je[Ve]), En = Math.abs(N[H] - Je[H]);
      (Ut >= 1 || En >= 1) && te(Je);
    }
  }), de = /* @__PURE__ */ a((ae, {
    animation: he = !0
  } = {}) => {
    he ? nb(V, Be.current, ae, {
      duration: r.transitions.duration.standard
    }) : Be.current[V] = ae;
  }, "scroll"), pt = /* @__PURE__ */ a((ae) => {
    let he = Be.current[V];
    B ? he += ae : he += ae * (i ? -1 : 1), de(he);
  }, "moveTabsScroll"), ze = /* @__PURE__ */ a(() => {
    const ae = Be.current[z];
    let he = 0;
    const Ee = Array.from(re.current.children);
    for (let Ve = 0; Ve < Ee.length; Ve += 1) {
      const Je = Ee[Ve];
      if (he + Je[z] > ae) {
        Ve === 0 && (he = ae);
        break;
      }
      he += Je[z];
    }
    return he;
  }, "getScrollSize"), ut = /* @__PURE__ */ a(() => {
    pt(-1 * ze());
  }, "handleStartScrollClick"), Mt = /* @__PURE__ */ a(() => {
    pt(ze());
  }, "handleEndScrollClick"), [At, {
    onChange: ft,
    ...Tt
  }] = ve("scrollbar", {
    className: le(A.scrollableX, A.hideScrollbar),
    elementType: hb,
    shouldForwardComponentProp: !0,
    externalForwardedProps: Fe,
    ownerState: $
  }), lt = k.useCallback((ae) => {
    ft == null || ft(ae), Re({
      overflow: null,
      scrollbarWidth: ae
    });
  }, [ft]), [ce, nt] = ve("scrollButtons", {
    className: le(A.scrollButtons, P.className),
    elementType: Td,
    externalForwardedProps: Fe,
    ownerState: $,
    additionalProps: {
      orientation: y,
      slots: {
        StartScrollButtonIcon: S.startScrollButtonIcon || S.StartScrollButtonIcon,
        EndScrollButtonIcon: S.endScrollButtonIcon || S.EndScrollButtonIcon
      },
      slotProps: {
        startScrollButtonIcon: U,
        endScrollButtonIcon: K
      }
    }
  }), vt = /* @__PURE__ */ a(() => {
    const ae = {};
    ae.scrollbarSizeListener = j ? /* @__PURE__ */ h.jsx(At, {
      ...Tt,
      onChange: lt
    }) : null;
    const Ee = j && (T === "auto" && (oe || X) || T === !0);
    return ae.scrollButtonStart = Ee ? /* @__PURE__ */ h.jsx(ce, {
      direction: i ? "right" : "left",
      onClick: ut,
      disabled: !oe,
      ...nt
    }) : null, ae.scrollButtonEnd = Ee ? /* @__PURE__ */ h.jsx(ce, {
      direction: i ? "left" : "right",
      onClick: Mt,
      disabled: !X,
      ...nt
    }) : null, ae;
  }, "getConditionalElements"), Ke = Dt((ae) => {
    const {
      tabsMeta: he,
      tabMeta: Ee
    } = Ce();
    if (!(!Ee || !he)) {
      if (Ee[L] < he[L]) {
        const Ve = he[V] + (Ee[L] - he[L]);
        de(Ve, {
          animation: ae
        });
      } else if (Ee[D] > he[D]) {
        const Ve = he[V] + (Ee[D] - he[D]);
        de(Ve, {
          animation: ae
        });
      }
    }
  }), tn = Dt(() => {
    j && T !== !1 && fe(!Y);
  });
  k.useEffect(() => {
    const ae = ss(() => {
      Be.current && Pe();
    });
    let he;
    const Ee = /* @__PURE__ */ a((Ut) => {
      Ut.forEach((En) => {
        En.removedNodes.forEach((An) => {
          he == null || he.unobserve(An);
        }), En.addedNodes.forEach((An) => {
          he == null || he.observe(An);
        });
      }), ae(), tn();
    }, "handleMutation"), Ve = dn(Be.current);
    Ve.addEventListener("resize", ae);
    let Je;
    return typeof ResizeObserver < "u" && (he = new ResizeObserver(ae), Array.from(re.current.children).forEach((Ut) => {
      he.observe(Ut);
    })), typeof MutationObserver < "u" && (Je = new MutationObserver(Ee), Je.observe(re.current, {
      childList: !0
    })), () => {
      ae.clear(), Ve.removeEventListener("resize", ae), Je == null || Je.disconnect(), he == null || he.disconnect();
    };
  }, [Pe, tn]), k.useEffect(() => {
    const ae = Array.from(re.current.children), he = ae.length;
    if (typeof IntersectionObserver < "u" && he > 0 && j && T !== !1) {
      const Ee = ae[0], Ve = ae[he - 1], Je = {
        root: Be.current,
        threshold: 0.99
      }, Ut = /* @__PURE__ */ a((Bn) => {
        ne(!Bn[0].isIntersecting);
      }, "handleScrollButtonStart"), En = new IntersectionObserver(Ut, Je);
      En.observe(Ee);
      const An = /* @__PURE__ */ a((Bn) => {
        se(!Bn[0].isIntersecting);
      }, "handleScrollButtonEnd"), zr = new IntersectionObserver(An, Je);
      return zr.observe(Ve), () => {
        En.disconnect(), zr.disconnect();
      };
    }
  }, [j, T, Y, p == null ? void 0 : p.length]), k.useEffect(() => {
    F(!0);
  }, []), k.useEffect(() => {
    Pe();
  }), k.useEffect(() => {
    Ke(s4 !== N);
  }, [Ke, N]), k.useImperativeHandle(d, () => ({
    updateIndicator: Pe,
    updateScrollButtons: tn
  }), [Pe, tn]);
  const [ue, Me] = ve("indicator", {
    className: le(A.indicator, O.className),
    elementType: fb,
    externalForwardedProps: Fe,
    ownerState: $,
    additionalProps: {
      style: N
    }
  }), Xe = /* @__PURE__ */ h.jsx(ue, {
    ...Me
  });
  let $t = 0;
  const Ln = k.Children.map(p, (ae) => {
    if (!/* @__PURE__ */ k.isValidElement(ae))
      return null;
    process.env.NODE_ENV !== "production" && ko.isFragment(ae) && console.error(["MUI: The Tabs component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    const he = ae.props.value === void 0 ? $t : ae.props.value;
    Oe.set(he, $t);
    const Ee = he === I;
    return $t += 1, /* @__PURE__ */ k.cloneElement(ae, {
      fullWidth: v === "fullWidth",
      indicator: Ee && !J && Xe,
      selected: Ee,
      selectionFollowsFocus: x,
      onChange: g,
      textColor: E,
      value: he,
      ...$t === 1 && I === !1 && !ae.props.tabIndex ? {
        tabIndex: 0
      } : {}
    });
  }), _t = /* @__PURE__ */ a((ae) => {
    if (ae.altKey || ae.shiftKey || ae.ctrlKey || ae.metaKey)
      return;
    const he = re.current, Ee = Qt(he).activeElement;
    if (Ee.getAttribute("role") !== "tab")
      return;
    let Je = y === "horizontal" ? "ArrowLeft" : "ArrowUp", Ut = y === "horizontal" ? "ArrowRight" : "ArrowDown";
    switch (y === "horizontal" && i && (Je = "ArrowRight", Ut = "ArrowLeft"), ae.key) {
      case Je:
        ae.preventDefault(), Ps(he, Ee, i4);
        break;
      case Ut:
        ae.preventDefault(), Ps(he, Ee, r4);
        break;
      case "Home":
        ae.preventDefault(), Ps(he, null, r4);
        break;
      case "End":
        ae.preventDefault(), Ps(he, null, i4);
        break;
    }
  }, "handleKeyDown"), nn = vt(), [on, Vn] = ve("root", {
    ref: n,
    className: le(A.root, f),
    elementType: db,
    externalForwardedProps: {
      ...Fe,
      ...R,
      component: m
    },
    ownerState: $
  }), [Zt, ho] = ve("scroller", {
    ref: Be,
    className: A.scroller,
    elementType: ub,
    externalForwardedProps: Fe,
    ownerState: $,
    additionalProps: {
      style: {
        overflow: be.overflow,
        [B ? `margin${i ? "Left" : "Right"}` : "marginBottom"]: _ ? void 0 : -be.scrollbarWidth
      }
    }
  }), [xe, wt] = ve("list", {
    ref: re,
    className: le(A.list, A.flexContainer),
    elementType: pb,
    externalForwardedProps: Fe,
    ownerState: $,
    getSlotProps: /* @__PURE__ */ a((ae) => ({
      ...ae,
      onKeyDown: /* @__PURE__ */ a((he) => {
        var Ee;
        _t(he), (Ee = ae.onKeyDown) == null || Ee.call(ae, he);
      }, "onKeyDown")
    }), "getSlotProps")
  });
  return /* @__PURE__ */ h.jsxs(on, {
    ...Vn,
    children: [nn.scrollButtonStart, nn.scrollbarSizeListener, /* @__PURE__ */ h.jsxs(Zt, {
      ...ho,
      children: [/* @__PURE__ */ h.jsx(xe, {
        "aria-label": l,
        "aria-labelledby": c,
        "aria-orientation": y === "vertical" ? "vertical" : null,
        role: "tablist",
        ...wt,
        children: Ln
      }), J && Xe]
    }), nn.scrollButtonEnd]
  });
}, "Tabs"));
process.env.NODE_ENV !== "production" && (kd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: Wt,
  /**
   * If `true`, the scroll buttons aren't forced hidden on mobile.
   * By default the scroll buttons are hidden on mobile and takes precedence over `scrollButtons`.
   * @default false
   */
  allowScrollButtonsMobile: s.bool,
  /**
   * The label for the Tabs as a string.
   */
  "aria-label": s.string,
  /**
   * An id or list of ids separated by a space that label the Tabs.
   */
  "aria-labelledby": s.string,
  /**
   * If `true`, the tabs are centered.
   * This prop is intended for large views.
   * @default false
   */
  centered: s.bool,
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * Determines the color of the indicator.
   * @default 'primary'
   */
  indicatorColor: s.oneOfType([s.oneOf(["primary", "secondary"]), s.string]),
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {any} value We default to the index of the child (number)
   */
  onChange: s.func,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: s.oneOf(["horizontal", "vertical"]),
  /**
   * The component used to render the scroll buttons.
   * @deprecated use the `slots.scrollButtons` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default TabScrollButton
   */
  ScrollButtonComponent: s.elementType,
  /**
   * Determine behavior of scroll buttons when tabs are set to scroll:
   *
   * - `auto` will only present them when not all the items are visible.
   * - `true` will always present them.
   * - `false` will never present them.
   *
   * By default the scroll buttons are hidden on mobile.
   * This behavior can be disabled with `allowScrollButtonsMobile`.
   * @default 'auto'
   */
  scrollButtons: s.oneOf(["auto", !1, !0]),
  /**
   * If `true` the selected tab changes on focus. Otherwise it only
   * changes on activation.
   */
  selectionFollowsFocus: s.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    endScrollButtonIcon: s.oneOfType([s.func, s.object]),
    indicator: s.oneOfType([s.func, s.object]),
    list: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object]),
    scrollbar: s.oneOfType([s.func, s.object]),
    scrollButtons: s.oneOfType([s.func, s.object]),
    scroller: s.oneOfType([s.func, s.object]),
    startScrollButtonIcon: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    endScrollButtonIcon: s.elementType,
    EndScrollButtonIcon: s.elementType,
    indicator: s.elementType,
    list: s.elementType,
    root: s.elementType,
    scrollbar: s.elementType,
    scrollButtons: s.elementType,
    scroller: s.elementType,
    startScrollButtonIcon: s.elementType,
    StartScrollButtonIcon: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Props applied to the tab indicator element.
   * @deprecated use the `slotProps.indicator` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default  {}
   */
  TabIndicatorProps: s.object,
  /**
   * Props applied to the [`TabScrollButton`](https://mui.com/material-ui/api/tab-scroll-button/) element.
   * @deprecated use the `slotProps.scrollButtons` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TabScrollButtonProps: s.object,
  /**
   * Determines the color of the `Tab`.
   * @default 'primary'
   */
  textColor: s.oneOf(["inherit", "primary", "secondary"]),
  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this prop to `false`.
   */
  value: s.any,
  /**
   * Determines additional display behavior of the tabs:
   *
   *  - `scrollable` will invoke scrolling properties and allow for horizontally
   *  scrolling (or swiping) of the tab bar.
   *  - `fullWidth` will make the tabs grow to use all the available space,
   *  which should be used for small views, like on mobile.
   *  - `standard` will render the default state.
   * @default 'standard'
   */
  variant: s.oneOf(["fullWidth", "scrollable", "standard"]),
  /**
   * If `true`, the scrollbar is visible. It can be useful when displaying
   * a long vertical list of tabs.
   * @default false
   */
  visibleScrollbar: s.bool
});
function gb(e) {
  return Te("MuiTextField", e);
}
a(gb, "getTextFieldUtilityClass");
Se("MuiTextField", ["root"]);
const mb = {
  standard: Cl,
  filled: bl,
  outlined: yl
}, bb = /* @__PURE__ */ a((e) => {
  const {
    classes: t
  } = e;
  return ke({
    root: ["root"]
  }, gb, t);
}, "useUtilityClasses"), Cb = ee(ar, {
  name: "MuiTextField",
  slot: "Root"
})({}), Ko = /* @__PURE__ */ k.forwardRef(/* @__PURE__ */ a(function(t, n) {
  const o = $e({
    props: t,
    name: "MuiTextField"
  }), {
    autoComplete: r,
    autoFocus: i = !1,
    children: l,
    className: c,
    color: d = "primary",
    defaultValue: u,
    disabled: p = !1,
    error: f = !1,
    FormHelperTextProps: m,
    fullWidth: b = !1,
    helperText: C,
    id: g,
    InputLabelProps: y,
    inputProps: w,
    InputProps: T,
    inputRef: x,
    label: S,
    maxRows: M,
    minRows: O,
    multiline: P = !1,
    name: E,
    onBlur: I,
    onChange: v,
    onFocus: _,
    placeholder: R,
    required: j = !1,
    rows: B,
    select: V = !1,
    SelectProps: L,
    slots: D = {},
    slotProps: z = {},
    type: H,
    value: $,
    variant: A = "outlined",
    ...U
  } = o, K = {
    ...o,
    autoFocus: i,
    color: d,
    disabled: p,
    error: f,
    fullWidth: b,
    multiline: P,
    required: j,
    select: V,
    variant: A
  }, J = bb(K);
  process.env.NODE_ENV !== "production" && V && !l && console.error("MUI: `children` must be passed when using the `TextField` component with `select`.");
  const F = _o(g), N = C && F ? `${F}-helper-text` : void 0, te = S && F ? `${F}-label` : void 0, oe = mb[A], ne = {
    slots: D,
    slotProps: {
      input: T,
      inputLabel: y,
      htmlInput: w,
      formHelperText: m,
      select: L,
      ...z
    }
  }, X = {}, se = ne.slotProps.inputLabel;
  A === "outlined" && (se && typeof se.shrink < "u" && (X.notched = se.shrink), X.label = S), V && ((!L || !L.native) && (X.id = void 0), X["aria-describedby"] = void 0);
  const [Y, fe] = ve("root", {
    elementType: Cb,
    shouldForwardComponentProp: !0,
    externalForwardedProps: {
      ...ne,
      ...U
    },
    ownerState: K,
    className: le(J.root, c),
    ref: n,
    additionalProps: {
      disabled: p,
      error: f,
      fullWidth: b,
      required: j,
      color: d,
      variant: A
    }
  }), [be, Re] = ve("input", {
    elementType: oe,
    externalForwardedProps: ne,
    additionalProps: X,
    ownerState: K
  }), [Oe, Be] = ve("inputLabel", {
    elementType: ad,
    externalForwardedProps: ne,
    ownerState: K
  }), [re, Fe] = ve("htmlInput", {
    elementType: "input",
    externalForwardedProps: ne,
    ownerState: K
  }), [Ce, Pe] = ve("formHelperText", {
    elementType: sd,
    externalForwardedProps: ne,
    ownerState: K
  }), [de, pt] = ve("select", {
    elementType: xl,
    externalForwardedProps: ne,
    ownerState: K
  }), ze = /* @__PURE__ */ h.jsx(be, {
    "aria-describedby": N,
    autoComplete: r,
    autoFocus: i,
    defaultValue: u,
    fullWidth: b,
    multiline: P,
    name: E,
    rows: B,
    maxRows: M,
    minRows: O,
    type: H,
    value: $,
    id: F,
    inputRef: x,
    onBlur: I,
    onChange: v,
    onFocus: _,
    placeholder: R,
    inputProps: Fe,
    slots: {
      input: D.htmlInput ? re : void 0
    },
    ...Re
  });
  return /* @__PURE__ */ h.jsxs(Y, {
    ...fe,
    children: [S != null && S !== "" && /* @__PURE__ */ h.jsx(Oe, {
      htmlFor: F,
      id: te,
      ...Be,
      children: S
    }), V ? /* @__PURE__ */ h.jsx(de, {
      "aria-describedby": N,
      id: F,
      labelId: te,
      value: $,
      input: ze,
      ...pt,
      children: l
    }) : ze, C && /* @__PURE__ */ h.jsx(Ce, {
      id: N,
      ...Pe,
      children: C
    })]
  });
}, "TextField"));
process.env.NODE_ENV !== "production" && (Ko.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: s.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: s.bool,
  /**
   * @ignore
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: s.bool,
  /**
   * Props applied to the [`FormHelperText`](https://mui.com/material-ui/api/form-helper-text/) element.
   * @deprecated Use `slotProps.formHelperText` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  FormHelperTextProps: s.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * The helper text content.
   */
  helperText: s.node,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: s.string,
  /**
   * Props applied to the [`InputLabel`](https://mui.com/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   * @deprecated Use `slotProps.inputLabel` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputLabelProps: s.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @deprecated Use `slotProps.htmlInput` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: s.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](https://mui.com/material-ui/api/filled-input/),
   * [`OutlinedInput`](https://mui.com/material-ui/api/outlined-input/) or [`Input`](https://mui.com/material-ui/api/input/)
   * component depending on the `variant` prop value.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Wt,
  /**
   * The label content.
   */
  label: s.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: s.oneOf(["dense", "none", "normal"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: s.oneOfType([s.number, s.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: s.oneOfType([s.number, s.string]),
  /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */
  multiline: s.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: s.string,
  /**
   * @ignore
   */
  onBlur: s.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: s.func,
  /**
   * @ignore
   */
  onFocus: s.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: s.string,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: s.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: s.oneOfType([s.number, s.string]),
  /**
   * Render a [`Select`](https://mui.com/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */
  select: s.bool,
  /**
   * Props applied to the [`Select`](https://mui.com/material-ui/api/select/) element.
   * @deprecated Use `slotProps.select` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  SelectProps: s.object,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["medium", "small"]), s.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    formHelperText: s.oneOfType([s.func, s.object]),
    htmlInput: s.oneOfType([s.func, s.object]),
    input: s.oneOfType([s.func, s.object]),
    inputLabel: s.oneOfType([s.func, s.object]),
    select: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    formHelperText: s.elementType,
    htmlInput: s.elementType,
    input: s.elementType,
    inputLabel: s.elementType,
    root: s.elementType,
    select: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
   */
  type: s.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: s.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: s.oneOf(["filled", "outlined", "standard"])
});
const at = {
  palette: {
    primary: {
      primaryBlue: "#00ABF1",
      lightBlue: "#C1EAFF",
      lightBlue2: "#E8F7FF",
      lightBlue3: "#CCE3FA",
      mediumBlue: "#75AAFF",
      mediumBlue2: "#8AB4F7",
      secondaryBlue: "#0073E6",
      interactiveBlue: "#0047CC",
      blueBackground: "#5A7588",
      darkBlue: "#00172E",
      mainBlue: "#1F262E",
      marginBlue: "#002E5C",
      accentGreen: "#156534",
      white: "#FFFFFF",
      lightGrey: "#F4F4F4",
      lightGrey2: "#FAFAFA",
      lightGrey3: "#E0EEFC",
      lightGrey4: "#FAF9F8",
      lightGrey5: "#8593A5",
      mediumGrey: "#0c0c0eff",
      mediumGrey2: "#CDDBE2",
      mediumGrey3: "#86939C",
      mediumGrey4: "#CCD1DC",
      neutralGrey1: "#BBBBBC",
      neutralGrey2: "#E1DFDD",
      neutralGrey3: "#F3F2F1",
      neutralGreyDark: "#646464",
      darkGrey: "#213543",
      darkGrey2: "#3F515D",
      darkGrey3: "#162631",
      darkGrey4: "#595959",
      darkGrey5: "#394A55",
      neutralBlack: "#121212"
    },
    error: {
      errorPink: "#93005F"
    },
    opacity: {
      10: "1A",
      // 10% opacity
      20: "33",
      // 20% opacity
      30: "4D",
      // 30% opacity
      40: "66",
      // 40% opacity
      50: "80",
      // 50% opacity
      60: "99",
      // 60% opacity
      70: "B3",
      // 70% opacity
      80: "CC",
      // 80% opacity
      90: "E6",
      // 90% opacity
      95: "F2"
      // 95% opacity
    }
  },
  fontSizes: {
    headings: {
      h1: "40px",
      h2: "32px",
      h3: "24px",
      h4: "22px",
      h5: "18px",
      h6: "16px"
    },
    body: {
      xxl: "20px",
      xl: "18px",
      l: "16px",
      m: "14px",
      s: "13px",
      xs: "11.67px"
    }
  },
  fontFamilies: {
    Roboto: "'Roboto', sans-serif",
    BigShouldersDisplay: "'Big Shoulders Display', sans-serif"
  },
  breakpoints: {
    xxs: 0,
    xs: 568,
    sm: 768,
    md: 1024,
    lg: 1200,
    xl: 1440,
    xxl: 1920
  },
  appNav: {
    height: "36px"
  },
  headerNav: {
    height: "82px"
  },
  footerNav: {
    height: "36px"
  },
  fontWeights: {
    thin: 100,
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
  },
  elevations: {
    small: "0px 1px 8px rgba(25, 25, 112, 0.12)",
    medium: "0px 4px 12px 4px rgba(25, 25, 112, 0.08)",
    big: "0px 4px 16px 8px rgba(25, 25, 112, 0.12)",
    tooltip: "-2px -2px 8px rgba(255, 255, 255, 0.32), 0px 4px 8px rgba(66, 66, 69, 0.12)"
  }
}, aT = gc({
  palette: {
    primary: {
      main: at.palette.primary.primaryBlue
    },
    secondary: {
      main: at.palette.primary.secondaryBlue
    }
  },
  breakpoints: {
    values: at.breakpoints
  }
}), lT = B6`
   /**
    * FONT IMPORT
    */
    @font-face {
        font-family: "Roboto";
        src: local("RobotoThin"),
        url("${(e) => e.$basePath ?? ""}/fonts/Roboto/Roboto-Thin.woff") format("woff"),
        url("${(e) => e.$basePath ?? ""}/fonts/Roboto/Roboto-Thin.ttf") format("truetype");
        font-weight: 100;
    }
    @font-face {
        font-family: "Roboto";
        src: local("RobotoLight"),
        url("${(e) => e.$basePath ?? ""}/fonts/Roboto/Roboto-Light.woff") format("woff"),
        url("${(e) => e.$basePath ?? ""}/fonts/Roboto/Roboto-Light.ttf") format("truetype");
        font-weight: 300;
    }
    @font-face {
        font-family: "Roboto";
        src: local("RobotoRegular"),
        url("${(e) => e.$basePath ?? ""}/fonts/Roboto/Roboto-Regular.woff") format("woff"),
        url("${(e) => e.$basePath ?? ""}/fonts/Roboto/Roboto-Regular.ttf") format("truetype");
        font-weight: 400;
    }
    @font-face {
        font-family: "Roboto";
        src: local("RobotoMedium"),
        url("${(e) => e.$basePath ?? ""}/fonts/Roboto/Roboto-Medium.woff") format("woff"),
        url("${(e) => e.$basePath ?? ""}/fonts/Roboto/Roboto-Medium.ttf") format("truetype");
        font-weight: 500;
    }
    @font-face {
        font-family: "Roboto";
        src: local("RobotoSemiBold"),
        url("${(e) => e.$basePath ?? ""}/fonts/Roboto/Roboto-SemiBold.ttf") format("truetype");
        font-weight: 600;
    }
    @font-face {
        font-family: "Roboto";
        src: local("RobotoBold"),
        url("${(e) => e.$basePath ?? ""}/fonts/Roboto/Roboto-Bold.woff") format("woff"),
        url("${(e) => e.$basePath ?? ""}/fonts/Roboto/Roboto-Bold.ttf") format("truetype");
        font-weight: 700;
    }
    @font-face {
        font-family: "Roboto";
        src: local("RobotoBlack"),
        url("${(e) => e.$basePath ?? ""}/fonts/Roboto/Roboto-Black.woff") format("woff"),
        url("${(e) => e.$basePath ?? ""}/fonts/Roboto/Roboto-Black.ttf") format("truetype");
        font-weight: 900;
    }
    @font-face {
        font-family: "Big Shoulders Display";
        src: local("BigShouldersDisplayThin"),
        url("${(e) => e.$basePath ?? ""}/fonts/BigShouldersDisplay/BigShouldersDisplay-Thin.ttf") format("truetype");
        font-weight: 100;
    }
    @font-face {
        font-family: "Big Shoulders Display";
        src: local("BigShouldersDisplayLight"),
        url("${(e) => e.$basePath ?? ""}/fonts/BigShouldersDisplay/BigShouldersDisplay-Light.ttf") format("truetype");
        font-weight: 300;
    }
    @font-face {
        font-family: "Big Shoulders Display";
        src: local("BigShouldersDisplayRegular"),
        url("${(e) => e.$basePath ?? ""}/fonts/BigShouldersDisplay/BigShouldersDisplay-Regular.ttf") format("truetype");
        font-weight: 400;
    }
    @font-face {
        font-family: "Big Shoulders Display";
        src: local("BigShouldersDisplayMedium"),
        url("${(e) => e.$basePath ?? ""}/fonts/BigShouldersDisplay/BigShouldersDisplay-Medium.ttf") format("truetype");
        font-weight: 500;
    }
    @font-face {
        font-family: "Big Shoulders Display";
        src: local("BigShouldersDisplaySemiBold"),
        url("${(e) => e.$basePath ?? ""}/fonts/BigShouldersDisplay/BigShouldersDisplay-SemiBold.ttf") format("truetype");
        font-weight: 600;
    }
    @font-face {
        font-family: "Big Shoulders Display";
        src: local("BigShouldersDisplayBold"),
        url("${(e) => e.$basePath ?? ""}/fonts/BigShouldersDisplay/BigShouldersDisplay-Bold.ttf") format("truetype");
        font-weight: 700;
    }
    @font-face {
        font-family: "Big Shoulders Display";
        src: local("BigShouldersDisplayExtraBold"),
        url("${(e) => e.$basePath ?? ""}/fonts/BigShouldersDisplay/BigShouldersDisplay-ExtraBold.ttf") format("truetype");
        font-weight: 800;
    }
    @font-face {
        font-family: "Big Shoulders Display";
        src: local("BigShouldersDisplayBlack"),
        url("${(e) => e.$basePath ?? ""}/fonts/BigShouldersDisplay/BigShouldersDisplay-Black.ttf") format("truetype");
        font-weight: 900;
    }

    /**
    * GLOBAL STYLES
    */
    body {
        font-family: ${(e) => e.theme.fontFamilies.Roboto};
        font-weight: 400;
        margin: 0;
        padding: 0;
        min-width: 100%;
        width: 100%;
    } 

    *,
    :after,
    :before {
        background-repeat: no-repeat;
        box-sizing: border-box;
    }

    *:focus {
        outline: none;
    }

    /**
    *
    * ANIMATIONS
    *
    */
    @keyframes zoominout {
        0% {
        transform: scale(1);
        }
        50% {
        transform: scale(1.1);
        }
        100% {
        transform: scale(1);
        }
    }


    /*
    *
    * INITIAL TYPOGRAPHY
    *
    */

    h1,h2 ,h3 ,h4 ,h5, p{
        font-family: ${(e) => e.theme.fontFamilies.Roboto};
        font-weight: 400;
        margin: 0;
    }

    h1{
        font-size: ${(e) => e.theme.fontSizes.headings.h1};
    }
    h2{
        font-size: ${(e) => e.theme.fontSizes.headings.h2};
    }
    h3{
        font-size: ${(e) => e.theme.fontSizes.headings.h3};
    }
    h4{
        font-size: ${(e) => e.theme.fontSizes.headings.h4};
    }
    h5{
        font-size: ${(e) => e.theme.fontSizes.headings.h5};
    }
    p {
        font-size: ${(e) => e.theme.fontSizes.body.xs}
    }
`, cT = B6`
  html, body {
    overflow: hidden;          
    overscroll-behavior: none; 
  }
`, Vo = Q(ge)`
  flex: 1;
  width: 100%;
  height: 100%;
  max-width: ${({ theme: e }) => e.breakpoints.xxl}px;
  display: flex;
  justify-content: center;
  margin: 0;
  padding: 0 20px;
`, dT = Q(ge)`
  flex: 1;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: ${({ theme: e }) => e.headerNav.height};
  background: linear-gradient(#394a55, 60%, #0c0813);
`, yb = /* @__PURE__ */ a(({ time: e, property: t = "all", type: n = "ease" }) => `
  -webkit-transition: ${t} ${e} ${n};
  -moz-transition: ${t} ${e} ${n};
  -ms-transition: ${t} ${e} ${n};
  -o-transition: ${t} ${e} ${n};
  transition: ${t} ${e} ${n};
`, "animation"), zc = /* @__PURE__ */ a((e = at.palette.primary.neutralGrey2) => a1`
  /* Webkit browsers (Chrome, Safari, Edge) */

  &&::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  &&::-webkit-scrollbar-track {
    background-image: none;
  }

  &&::-webkit-scrollbar-track:vertical {
    background-size: 1px 100%;
  }

  &&::-webkit-scrollbar-track:horizontal {
    background-size: 100% 1px;
  }

  &&::-webkit-scrollbar-thumb {
    background: ${e}B3;
    border-radius: 8px;
  }

  /* Firefox */
  /* scrollbar-width: thin;
  scrollbar-color: ${e} transparent; */
`, "customScrollbarMixin"), xb = Q(ge)`
  display: flex;
  justify-content: center;
  width: 100%;
  flex-grow: 0;
`, vb = Q.footer`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: ${({ theme: e }) => e.palette.primary.marginBlue};
  color: ${({ theme: e }) => e.palette.primary.white};
`, wb = Q(Vo)`
  display: flex;
  overflow-y: hidden;
  justify-content: end;
  align-items: center;
  height: 36px;
  font-size: ${(e) => e.theme.fontSizes.body.m};
  font-weight: ${(e) => e.theme.fontSizes.body.m};
`, Sb = Q(ge)`
  display: flex;
  align-items: center;
  gap: 16px;

  :first-child {
    padding-left: 0;
  }
`, Mb = Q.a`
  padding-left: 16px;
  color: ${(e) => e.theme.palette.primary.white};
  text-decoration: none;

  &:hover {
    cursor: pointer;
    text-decoration: none;
  }
`, uT = /* @__PURE__ */ a(({ appNavItems: e = [] }) => /* @__PURE__ */ h.jsx(xb, { children: /* @__PURE__ */ h.jsx(vb, { children: /* @__PURE__ */ h.jsx(wb, { children: /* @__PURE__ */ h.jsx(Sb, { children: e.map((t, n) => /* @__PURE__ */ h.jsx(Mb, { href: t.url, target: "_blank", children: t.label }, t.label + n)) }) }) }) }), "AppNav"), Od = me(fl)`
  & .MuiOutlinedInput-root {
    background-color: ${({ theme: e }) => e.palette.primary.white};
    border-radius: 4px;
    border: none;
    border-bottom: 1px solid ${({ theme: e }) => e.palette.primary.darkGrey4};
    color: ${({ theme: e }) => e.palette.primary.neutralBlack};
    
    &.Mui-focused {
      border-bottom: 2px solid ${({ theme: e }) => e.palette.primary.secondaryBlue};
    }
    
    /* Remove the default outline */
    & .MuiOutlinedInput-notchedOutline {
      border: none;
    }
    
    &:hover .MuiOutlinedInput-notchedOutline {
      border: none;
    }
    
    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border: none;
    }
  }
  
  & .MuiInputBase-input {
    padding: 8px 12px;
    color: ${({ theme: e }) => e.palette.primary.neutralBlack};
  }

  & .MuiInputBase-input::placeholder {
    color: ${({ theme: e }) => e.palette.primary.neutralBlack};
    opacity: 1;
  }
`, Tb = me(Od)`
  & .MuiOutlinedInput-root {
    height: 70px;
    color: ${({ theme: e }) => e.palette.primary.neutralBlack};
    border-radius: 0px;
  }

  & .MuiInputBase-input {
    padding: 16px 8px;
    color: ${({ theme: e }) => e.palette.primary.neutralBlack};
    font-size: ${({ theme: e }) => e.fontSizes.headings.h2};
    font-weight: ${({ theme: e }) => e.fontWeights.bold};
  }

  & .MuiInputBase-input::placeholder {
    color: ${({ theme: e }) => e.palette.primary.darkGrey4};
    opacity: 1;
    font-size: ${({ theme: e }) => e.fontSizes.headings.h2};
    font-weight: ${({ theme: e }) => e.fontWeights.bold};
  }

  & .MuiInputAdornment-positionEnd {
    svg {
      width: 32px;
      height: 32px;
      color: ${({ theme: e }) => e.palette.primary.neutralBlack};
    }
  }
`, kb = me(fl)`
  & .MuiOutlinedInput-root {
    background-color: ${({ theme: e }) => e.palette.primary.darkGrey};
    border: 1px solid ${({ theme: e }) => e.palette.primary.white};
    border-radius: 4px;
    color: ${({ theme: e }) => e.palette.primary.white};
    height: 40px;

    &.Mui-focused {
      border: 1px solid ${({ theme: e }) => e.palette.primary.lightBlue};
    }

    /* Remove the default outline */
    & .MuiOutlinedInput-notchedOutline {
      border: none;
    }

    &:hover .MuiOutlinedInput-notchedOutline {
      border: none;
    }

    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border: none;
    }
  }

  & .MuiInputBase-input {
    padding: 8px 12px;
    color: ${({ theme: e }) => e.palette.primary.white};
    font-size: ${({ theme: e }) => e.fontSizes.body.m};
  }

  & .MuiInputBase-input::placeholder {
    color: ${({ theme: e }) => e.palette.primary.neutralGrey2};
    opacity: 1;
    font-size: ${({ theme: e }) => e.fontSizes.body.m};
  }

  & .MuiAutocomplete-endAdornment {
    svg {
      color: ${({ theme: e }) => e.palette.primary.white};
    }
  }

  & .MuiAutocomplete-paper {
    background-color: ${({ theme: e }) => e.palette.primary.darkGrey3};
    color: ${({ theme: e }) => e.palette.primary.white};
  }

  & .MuiAutocomplete-option {
    background-color: ${({ theme: e }) => e.palette.primary.darkGrey3};
    color: ${({ theme: e }) => e.palette.primary.white};
    font-size: ${({ theme: e }) => e.fontSizes.body.m};

    &:hover {
      background-color: ${({ theme: e }) => e.palette.primary.darkGrey};
    }

    &.Mui-focused {
      background-color: ${({ theme: e }) => e.palette.primary.darkGrey};
    }

    &[aria-selected="true"] {
      background-color: ${({ theme: e }) => e.palette.primary.darkGrey};
      border: 1px solid ${({ theme: e }) => e.palette.primary.lightBlue};
      border-radius: 4px;
    }
  }

  & .MuiInputAdornment-root {
    svg {
      color: ${({ theme: e }) => e.palette.primary.white};
    }
  }
`, Ob = me(ar)`
  & .MuiFormLabel-root {
    color: ${({ theme: e }) => e.palette.primary.white};
    font-weight: ${({ theme: e }) => e.fontWeights.medium};
    font-size: ${({ theme: e }) => e.fontSizes.body.l};
    margin-bottom: 8px;

    &.Mui-focused {
      color: ${({ theme: e }) => e.palette.primary.white};
    }
  }
`, Eb = me(fl)`
  &&{  
    & .MuiOutlinedInput-root {
      height: 35px;
      background-color: transparent;
      border: 1px solid ${({ theme: e }) => e.palette.primary.neutralGrey2};
      border-radius: 4px;
      color: ${({ theme: e }) => e.palette.primary.neutralGrey2};

      &.Mui-focused {
        background-color: ${({ theme: e }) => e.palette.primary.mainBlue};
        color: ${({ theme: e }) => e.palette.primary.white};
        border: 1px solid ${({ theme: e }) => e.palette.primary.mediumBlue2};
      }

      & .MuiOutlinedInput-notchedOutline {
        border: none;
      }

      &:hover .MuiOutlinedInput-notchedOutline {
        border: none;
      }

      &.Mui-focused .MuiOutlinedInput-notchedOutline {
        border: none;
      }
    }

    & .MuiInputBase-input {
      padding: 8px 12px;
      color: ${({ theme: e }) => e.palette.primary.neutralGrey2};
      font-size: ${({ theme: e }) => e.fontSizes.body.l};

      &.Mui-focused {
        color: ${({ theme: e }) => e.palette.primary.white};
      }
    }

    & .MuiInputBase-input::placeholder {
      color: ${({ theme: e }) => e.palette.primary.neutralGrey2};
      opacity: 1;
      font-size: ${({ theme: e }) => e.fontSizes.body.l};
    }

    & .MuiAutocomplete-endAdornment {
      svg {
        color: ${({ theme: e }) => e.palette.primary.neutralGrey2};
      }
    }

    & .Mui-focused .MuiAutocomplete-endAdornment {
      svg {
        color: ${({ theme: e }) => e.palette.primary.white};
      }
    }

    & .MuiAutocomplete-paper {
      background-color: ${({ theme: e }) => e.palette.primary.mainBlue};
      color: ${({ theme: e }) => e.palette.primary.white};
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      margin-top: 4px;
    }

    & .MuiAutocomplete-listbox {
      max-height: 185px;
      padding: 5px;
    }

    & .MuiAutocomplete-option {
      background-color: ${({ theme: e }) => e.palette.primary.mainBlue};
      color: ${({ theme: e }) => e.palette.primary.white};
      font-size: ${({ theme: e }) => e.fontSizes.body.l};
      border-radius: 4px;
      margin: 0 5px;

      &:hover {
        background-color: ${({ theme: e }) => e.palette.primary.mediumBlue} !important;
      }

      &.Mui-focused,
      &.Mui-focusVisible {
        background-color: ${({ theme: e }) => e.palette.primary.mediumBlue} !important;
      }

      &[aria-selected="true"] {
        background-color: ${({ theme: e }) => e.palette.primary.mainBlue};
        border: 1px solid ${({ theme: e }) => e.palette.primary.mediumBlue2};
      }
    }

    & .MuiInputAdornment-root {
      svg {
        color: ${({ theme: e }) => e.palette.primary.neutralGrey2};
      }
    }

    & .Mui-focused .MuiInputAdornment-root {
      svg {
        color: ${({ theme: e }) => e.palette.primary.white};
      }
    }
  }
`, $b = {
  backgroundColor: "inherit",
  border: "none",
  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  gap: "4px",
  "& .MuiAutocomplete-listbox": {
    "&::-webkit-scrollbar": {
      width: "5px",
      height: "5px"
    },
    "&::-webkit-scrollbar-track": {
      backgroundImage: "none"
    },
    "::-webkit-scrollbar-track:vertical": {
      backgroundSize: "1px 100%"
    },
    "::-webkit-scrollbar-track:horizontal": {
      backgroundSize: "100% 1px"
    },
    "&::-webkit-scrollbar-thumb": {
      background: `${at.palette.primary.mediumGrey3}B3`,
      borderRadius: "8px"
    }
  }
}, pT = /* @__PURE__ */ a(({
  options: e,
  selectedValue: t,
  onSelectedChange: n,
  onSearch: o,
  placeholder: r = "Search...",
  type: i = "primary",
  disabled: l = !1,
  fullWidth: c = !1,
  startIcon: d,
  endIcon: u,
  minCharsForSuggestions: p = 3,
  disableDropdown: f = !1,
  onInputChange: m,
  title: b
}) => {
  const [C, g] = ln(t), [y, w] = ln(!1);
  Cn(() => {
    g(t);
  }, [t]);
  const T = !f && C.length >= p, x = T ? e.filter((E) => E.value.toLowerCase().includes(t.toLowerCase())) : [], S = /* @__PURE__ */ a((E) => {
    g(E), m == null || m(E), E.trim() === "" && (n(""), o == null || o(""));
  }, "handleInputChange"), M = /* @__PURE__ */ a((E, I) => {
    if (typeof I == "string")
      n(I), o == null || o(I), w(!1);
    else {
      const v = I;
      v != null && v.value && (n(v.value), o == null || o(v.value), w(!1));
    }
  }, "handleOptionSelect"), O = /* @__PURE__ */ a((E) => {
    E.key === "Enter" && (E.preventDefault(), n(C), o == null || o(C), w(!1));
  }, "handleKeyDown"), P = /* @__PURE__ */ a((E) => {
    (E.key === "Enter" || E.key === " ") && (E.preventDefault(), E.stopPropagation(), S(""));
  }, "handleClearKeyDown");
  if (i === "primary")
    return /* @__PURE__ */ h.jsx(
      Od,
      {
        slotProps: { clearIndicator: { tabIndex: 0, onKeyDown: P } },
        options: e,
        getOptionLabel: /* @__PURE__ */ a((E) => typeof E == "string" ? E : E.label, "getOptionLabel"),
        value: null,
        inputValue: C,
        open: y && T && x.length > 0,
        onOpen: /* @__PURE__ */ a(() => w(!0), "onOpen"),
        onClose: /* @__PURE__ */ a(() => w(!1), "onClose"),
        onInputChange: /* @__PURE__ */ a((E, I) => S(I || ""), "onInputChange"),
        onChange: M,
        renderInput: /* @__PURE__ */ a((E) => {
          var I, v;
          return /* @__PURE__ */ h.jsx(
            Ko,
            {
              ...E,
              multiline: !1,
              placeholder: r,
              variant: "outlined",
              size: "small",
              fullWidth: !0,
              onKeyDown: O,
              slotProps: {
                input: {
                  ...E.InputProps,
                  startAdornment: d ? /* @__PURE__ */ h.jsx($n, { position: "start", children: d }) : (I = E.InputProps) == null ? void 0 : I.startAdornment,
                  endAdornment: /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
                    d && u && /* @__PURE__ */ h.jsx($n, { position: "end", children: u }),
                    (v = E.InputProps) == null ? void 0 : v.endAdornment
                  ] })
                }
              }
            }
          );
        }, "renderInput"),
        disabled: l,
        fullWidth: c,
        freeSolo: !0
      }
    );
  if (i === "secondary")
    return /* @__PURE__ */ h.jsx(
      Tb,
      {
        options: e,
        getOptionLabel: /* @__PURE__ */ a((E) => typeof E == "string" ? E : E.label, "getOptionLabel"),
        value: null,
        inputValue: C,
        open: y && T && x.length > 0,
        onOpen: /* @__PURE__ */ a(() => w(!0), "onOpen"),
        onClose: /* @__PURE__ */ a(() => w(!1), "onClose"),
        onInputChange: /* @__PURE__ */ a((E, I) => S(I || ""), "onInputChange"),
        onChange: M,
        renderInput: /* @__PURE__ */ a((E) => {
          var I, v;
          return /* @__PURE__ */ h.jsx(
            Ko,
            {
              ...E,
              multiline: !1,
              placeholder: r,
              variant: "outlined",
              size: "small",
              fullWidth: !0,
              onKeyDown: O,
              slotProps: {
                input: {
                  ...E.InputProps,
                  startAdornment: d ? /* @__PURE__ */ h.jsx($n, { position: "start", children: d }) : (I = E.InputProps) == null ? void 0 : I.startAdornment,
                  endAdornment: /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
                    u && /* @__PURE__ */ h.jsx($n, { position: "end", children: u }),
                    (v = E.InputProps) == null ? void 0 : v.endAdornment
                  ] })
                }
              }
            }
          );
        }, "renderInput"),
        disabled: l,
        fullWidth: c,
        freeSolo: !0
      }
    );
  if (i === "ternary")
    return /* @__PURE__ */ h.jsx(
      kb,
      {
        slotProps: { clearIndicator: { tabIndex: 0, onKeyDown: P } },
        options: e,
        getOptionLabel: /* @__PURE__ */ a((E) => typeof E == "string" ? E : E.label, "getOptionLabel"),
        value: null,
        inputValue: C,
        open: y && T && x.length > 0,
        onOpen: /* @__PURE__ */ a(() => w(!0), "onOpen"),
        onClose: /* @__PURE__ */ a(() => w(!1), "onClose"),
        onInputChange: /* @__PURE__ */ a((E, I) => S(I || ""), "onInputChange"),
        onChange: M,
        renderInput: /* @__PURE__ */ a((E) => {
          var I, v;
          return /* @__PURE__ */ h.jsx(
            Ko,
            {
              ...E,
              multiline: !1,
              placeholder: r,
              variant: "outlined",
              size: "small",
              fullWidth: !0,
              onKeyDown: O,
              slotProps: {
                input: {
                  ...E.InputProps,
                  startAdornment: d ? /* @__PURE__ */ h.jsx($n, { position: "start", children: d }) : (I = E.InputProps) == null ? void 0 : I.startAdornment,
                  endAdornment: /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
                    u && /* @__PURE__ */ h.jsx($n, { position: "end", children: u }),
                    (v = E.InputProps) == null ? void 0 : v.endAdornment
                  ] })
                }
              }
            }
          );
        }, "renderInput"),
        disabled: l,
        fullWidth: c,
        freeSolo: !0
      }
    );
  if (i === "quaternary")
    return /* @__PURE__ */ h.jsxs(Ob, { fullWidth: !0, children: [
      b && /* @__PURE__ */ h.jsx(_n, { component: "legend", sx: { flexGrow: 1 }, children: b }),
      /* @__PURE__ */ h.jsx(
        Eb,
        {
          options: e,
          getOptionLabel: /* @__PURE__ */ a((E) => typeof E == "string" ? E : E.label, "getOptionLabel"),
          value: null,
          inputValue: C,
          open: y && T && x.length > 0,
          onOpen: /* @__PURE__ */ a(() => w(!0), "onOpen"),
          onClose: /* @__PURE__ */ a(() => w(!1), "onClose"),
          onInputChange: /* @__PURE__ */ a((E, I) => S(I || ""), "onInputChange"),
          onChange: M,
          slotProps: {
            paper: {
              sx: {
                ...$b,
                backgroundColor: at.palette.primary.mainBlue,
                color: at.palette.primary.white,
                "& .MuiAutocomplete-option": {
                  background: at.palette.primary.mainBlue,
                  "&:hover": {
                    background: "#213543 !important"
                  },
                  "&.Mui-focused": {
                    background: "#213543 !important"
                  },
                  "&.Mui-focusVisible": {
                    background: "#213543 !important"
                  }
                }
              }
            }
          },
          renderInput: /* @__PURE__ */ a((E) => {
            var I, v;
            return /* @__PURE__ */ h.jsx(
              Ko,
              {
                ...E,
                multiline: !1,
                placeholder: r,
                variant: "outlined",
                size: "small",
                fullWidth: !0,
                onKeyDown: O,
                slotProps: {
                  input: {
                    ...E.InputProps,
                    startAdornment: d ? /* @__PURE__ */ h.jsx($n, { position: "start", children: d }) : (I = E.InputProps) == null ? void 0 : I.startAdornment,
                    endAdornment: /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
                      u && /* @__PURE__ */ h.jsx($n, { position: "end", children: u }),
                      (v = E.InputProps) == null ? void 0 : v.endAdornment
                    ] })
                  }
                }
              }
            );
          }, "renderInput"),
          disabled: l,
          fullWidth: c,
          freeSolo: !0
        }
      )
    ] });
}, "Autocomplete");
/*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */
function us(e) {
  return e + 0.5 | 0;
}
a(us, "round");
const vo = /* @__PURE__ */ a((e, t, n) => Math.max(Math.min(e, n), t), "lim");
function hi(e) {
  return vo(us(e * 2.55), 0, 255);
}
a(hi, "p2b");
function To(e) {
  return vo(us(e * 255), 0, 255);
}
a(To, "n2b");
function ro(e) {
  return vo(us(e / 2.55) / 100, 0, 1);
}
a(ro, "b2n");
function l4(e) {
  return vo(us(e * 100), 0, 100);
}
a(l4, "n2p");
const hn = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, $1 = [..."0123456789ABCDEF"], Pb = /* @__PURE__ */ a((e) => $1[e & 15], "h1"), _b = /* @__PURE__ */ a((e) => $1[(e & 240) >> 4] + $1[e & 15], "h2"), _s = /* @__PURE__ */ a((e) => (e & 240) >> 4 === (e & 15), "eq"), Rb = /* @__PURE__ */ a((e) => _s(e.r) && _s(e.g) && _s(e.b) && _s(e.a), "isShort");
function Ib(e) {
  var t = e.length, n;
  return e[0] === "#" && (t === 4 || t === 5 ? n = {
    r: 255 & hn[e[1]] * 17,
    g: 255 & hn[e[2]] * 17,
    b: 255 & hn[e[3]] * 17,
    a: t === 5 ? hn[e[4]] * 17 : 255
  } : (t === 7 || t === 9) && (n = {
    r: hn[e[1]] << 4 | hn[e[2]],
    g: hn[e[3]] << 4 | hn[e[4]],
    b: hn[e[5]] << 4 | hn[e[6]],
    a: t === 9 ? hn[e[7]] << 4 | hn[e[8]] : 255
  })), n;
}
a(Ib, "hexParse");
const jb = /* @__PURE__ */ a((e, t) => e < 255 ? t(e) : "", "alpha");
function Lb(e) {
  var t = Rb(e) ? Pb : _b;
  return e ? "#" + t(e.r) + t(e.g) + t(e.b) + jb(e.a, t) : void 0;
}
a(Lb, "hexString");
const Vb = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function Ed(e, t, n) {
  const o = t * Math.min(n, 1 - n), r = /* @__PURE__ */ a((i, l = (i + e / 30) % 12) => n - o * Math.max(Math.min(l - 3, 9 - l, 1), -1), "f");
  return [r(0), r(8), r(4)];
}
a(Ed, "hsl2rgbn");
function Ab(e, t, n) {
  const o = /* @__PURE__ */ a((r, i = (r + e / 60) % 6) => n - n * t * Math.max(Math.min(i, 4 - i, 1), 0), "f");
  return [o(5), o(3), o(1)];
}
a(Ab, "hsv2rgbn");
function Bb(e, t, n) {
  const o = Ed(e, 1, 0.5);
  let r;
  for (t + n > 1 && (r = 1 / (t + n), t *= r, n *= r), r = 0; r < 3; r++)
    o[r] *= 1 - t - n, o[r] += t;
  return o;
}
a(Bb, "hwb2rgbn");
function Hb(e, t, n, o, r) {
  return e === r ? (t - n) / o + (t < n ? 6 : 0) : t === r ? (n - e) / o + 2 : (e - t) / o + 4;
}
a(Hb, "hueValue");
function Fc(e) {
  const n = e.r / 255, o = e.g / 255, r = e.b / 255, i = Math.max(n, o, r), l = Math.min(n, o, r), c = (i + l) / 2;
  let d, u, p;
  return i !== l && (p = i - l, u = c > 0.5 ? p / (2 - i - l) : p / (i + l), d = Hb(n, o, r, p, i), d = d * 60 + 0.5), [d | 0, u || 0, c];
}
a(Fc, "rgb2hsl");
function Wc(e, t, n, o) {
  return (Array.isArray(t) ? e(t[0], t[1], t[2]) : e(t, n, o)).map(To);
}
a(Wc, "calln");
function Zc(e, t, n) {
  return Wc(Ed, e, t, n);
}
a(Zc, "hsl2rgb");
function Db(e, t, n) {
  return Wc(Bb, e, t, n);
}
a(Db, "hwb2rgb");
function Nb(e, t, n) {
  return Wc(Ab, e, t, n);
}
a(Nb, "hsv2rgb");
function $d(e) {
  return (e % 360 + 360) % 360;
}
a($d, "hue");
function zb(e) {
  const t = Vb.exec(e);
  let n = 255, o;
  if (!t)
    return;
  t[5] !== o && (n = t[6] ? hi(+t[5]) : To(+t[5]));
  const r = $d(+t[2]), i = +t[3] / 100, l = +t[4] / 100;
  return t[1] === "hwb" ? o = Db(r, i, l) : t[1] === "hsv" ? o = Nb(r, i, l) : o = Zc(r, i, l), {
    r: o[0],
    g: o[1],
    b: o[2],
    a: n
  };
}
a(zb, "hueParse");
function Fb(e, t) {
  var n = Fc(e);
  n[0] = $d(n[0] + t), n = Zc(n), e.r = n[0], e.g = n[1], e.b = n[2];
}
a(Fb, "rotate");
function Wb(e) {
  if (!e)
    return;
  const t = Fc(e), n = t[0], o = l4(t[1]), r = l4(t[2]);
  return e.a < 255 ? `hsla(${n}, ${o}%, ${r}%, ${ro(e.a)})` : `hsl(${n}, ${o}%, ${r}%)`;
}
a(Wb, "hslString");
const c4 = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, d4 = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function Zb() {
  const e = {}, t = Object.keys(d4), n = Object.keys(c4);
  let o, r, i, l, c;
  for (o = 0; o < t.length; o++) {
    for (l = c = t[o], r = 0; r < n.length; r++)
      i = n[r], c = c.replace(i, c4[i]);
    i = parseInt(d4[l], 16), e[c] = [i >> 16 & 255, i >> 8 & 255, i & 255];
  }
  return e;
}
a(Zb, "unpack");
let Rs;
function Ub(e) {
  Rs || (Rs = Zb(), Rs.transparent = [0, 0, 0, 0]);
  const t = Rs[e.toLowerCase()];
  return t && {
    r: t[0],
    g: t[1],
    b: t[2],
    a: t.length === 4 ? t[3] : 255
  };
}
a(Ub, "nameParse");
const Gb = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function Yb(e) {
  const t = Gb.exec(e);
  let n = 255, o, r, i;
  if (t) {
    if (t[7] !== o) {
      const l = +t[7];
      n = t[8] ? hi(l) : vo(l * 255, 0, 255);
    }
    return o = +t[1], r = +t[3], i = +t[5], o = 255 & (t[2] ? hi(o) : vo(o, 0, 255)), r = 255 & (t[4] ? hi(r) : vo(r, 0, 255)), i = 255 & (t[6] ? hi(i) : vo(i, 0, 255)), {
      r: o,
      g: r,
      b: i,
      a: n
    };
  }
}
a(Yb, "rgbParse");
function qb(e) {
  return e && (e.a < 255 ? `rgba(${e.r}, ${e.g}, ${e.b}, ${ro(e.a)})` : `rgb(${e.r}, ${e.g}, ${e.b})`);
}
a(qb, "rgbString");
const Ul = /* @__PURE__ */ a((e) => e <= 31308e-7 ? e * 12.92 : Math.pow(e, 1 / 2.4) * 1.055 - 0.055, "to"), gr = /* @__PURE__ */ a((e) => e <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4), "from");
function Kb(e, t, n) {
  const o = gr(ro(e.r)), r = gr(ro(e.g)), i = gr(ro(e.b));
  return {
    r: To(Ul(o + n * (gr(ro(t.r)) - o))),
    g: To(Ul(r + n * (gr(ro(t.g)) - r))),
    b: To(Ul(i + n * (gr(ro(t.b)) - i))),
    a: e.a + n * (t.a - e.a)
  };
}
a(Kb, "interpolate$1");
function Is(e, t, n) {
  if (e) {
    let o = Fc(e);
    o[t] = Math.max(0, Math.min(o[t] + o[t] * n, t === 0 ? 360 : 1)), o = Zc(o), e.r = o[0], e.g = o[1], e.b = o[2];
  }
}
a(Is, "modHSL");
function Pd(e, t) {
  return e && Object.assign(t || {}, e);
}
a(Pd, "clone$1");
function u4(e) {
  var t = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(e) ? e.length >= 3 && (t = { r: e[0], g: e[1], b: e[2], a: 255 }, e.length > 3 && (t.a = To(e[3]))) : (t = Pd(e, { r: 0, g: 0, b: 0, a: 1 }), t.a = To(t.a)), t;
}
a(u4, "fromObject");
function Xb(e) {
  return e.charAt(0) === "r" ? Yb(e) : zb(e);
}
a(Xb, "functionParse");
const Pi = class Pi {
  constructor(t) {
    if (t instanceof Pi)
      return t;
    const n = typeof t;
    let o;
    n === "object" ? o = u4(t) : n === "string" && (o = Ib(t) || Ub(t) || Xb(t)), this._rgb = o, this._valid = !!o;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var t = Pd(this._rgb);
    return t && (t.a = ro(t.a)), t;
  }
  set rgb(t) {
    this._rgb = u4(t);
  }
  rgbString() {
    return this._valid ? qb(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? Lb(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? Wb(this._rgb) : void 0;
  }
  mix(t, n) {
    if (t) {
      const o = this.rgb, r = t.rgb;
      let i;
      const l = n === i ? 0.5 : n, c = 2 * l - 1, d = o.a - r.a, u = ((c * d === -1 ? c : (c + d) / (1 + c * d)) + 1) / 2;
      i = 1 - u, o.r = 255 & u * o.r + i * r.r + 0.5, o.g = 255 & u * o.g + i * r.g + 0.5, o.b = 255 & u * o.b + i * r.b + 0.5, o.a = l * o.a + (1 - l) * r.a, this.rgb = o;
    }
    return this;
  }
  interpolate(t, n) {
    return t && (this._rgb = Kb(this._rgb, t._rgb, n)), this;
  }
  clone() {
    return new Pi(this.rgb);
  }
  alpha(t) {
    return this._rgb.a = To(t), this;
  }
  clearer(t) {
    const n = this._rgb;
    return n.a *= 1 - t, this;
  }
  greyscale() {
    const t = this._rgb, n = us(t.r * 0.3 + t.g * 0.59 + t.b * 0.11);
    return t.r = t.g = t.b = n, this;
  }
  opaquer(t) {
    const n = this._rgb;
    return n.a *= 1 + t, this;
  }
  negate() {
    const t = this._rgb;
    return t.r = 255 - t.r, t.g = 255 - t.g, t.b = 255 - t.b, this;
  }
  lighten(t) {
    return Is(this._rgb, 2, t), this;
  }
  darken(t) {
    return Is(this._rgb, 2, -t), this;
  }
  saturate(t) {
    return Is(this._rgb, 1, t), this;
  }
  desaturate(t) {
    return Is(this._rgb, 1, -t), this;
  }
  rotate(t) {
    return Fb(this._rgb, t), this;
  }
};
a(Pi, "Color");
let va = Pi;
/*!
 * Chart.js v4.5.0
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
function to() {
}
a(to, "noop");
const Jb = /* @__PURE__ */ (() => {
  let e = 0;
  return () => e++;
})();
function He(e) {
  return e == null;
}
a(He, "isNullOrUndef");
function Et(e) {
  if (Array.isArray && Array.isArray(e))
    return !0;
  const t = Object.prototype.toString.call(e);
  return t.slice(0, 7) === "[object" && t.slice(-6) === "Array]";
}
a(Et, "isArray");
function Ne(e) {
  return e !== null && Object.prototype.toString.call(e) === "[object Object]";
}
a(Ne, "isObject");
function Tn(e) {
  return (typeof e == "number" || e instanceof Number) && isFinite(+e);
}
a(Tn, "isNumberFinite");
function Dn(e, t) {
  return Tn(e) ? e : t;
}
a(Dn, "finiteOrDefault");
function je(e, t) {
  return typeof e > "u" ? t : e;
}
a(je, "valueOrDefault");
const Qb = /* @__PURE__ */ a((e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 : +e / t, "toPercentage"), _d = /* @__PURE__ */ a((e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 * t : +e, "toDimension");
function st(e, t, n) {
  if (e && typeof e.call == "function")
    return e.apply(n, t);
}
a(st, "callback");
function qe(e, t, n, o) {
  let r, i, l;
  if (Et(e))
    for (i = e.length, r = 0; r < i; r++)
      t.call(n, e[r], r);
  else if (Ne(e))
    for (l = Object.keys(e), i = l.length, r = 0; r < i; r++)
      t.call(n, e[l[r]], l[r]);
}
a(qe, "each");
function wa(e, t) {
  let n, o, r, i;
  if (!e || !t || e.length !== t.length)
    return !1;
  for (n = 0, o = e.length; n < o; ++n)
    if (r = e[n], i = t[n], r.datasetIndex !== i.datasetIndex || r.index !== i.index)
      return !1;
  return !0;
}
a(wa, "_elementsEqual");
function Sa(e) {
  if (Et(e))
    return e.map(Sa);
  if (Ne(e)) {
    const t = /* @__PURE__ */ Object.create(null), n = Object.keys(e), o = n.length;
    let r = 0;
    for (; r < o; ++r)
      t[n[r]] = Sa(e[n[r]]);
    return t;
  }
  return e;
}
a(Sa, "clone");
function Rd(e) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(e) === -1;
}
a(Rd, "isValidKey");
function eC(e, t, n, o) {
  if (!Rd(e))
    return;
  const r = t[e], i = n[e];
  Ne(r) && Ne(i) ? Jn(r, i, o) : t[e] = Sa(i);
}
a(eC, "_merger");
function Jn(e, t, n) {
  const o = Et(t) ? t : [
    t
  ], r = o.length;
  if (!Ne(e))
    return e;
  n = n || {};
  const i = n.merger || eC;
  let l;
  for (let c = 0; c < r; ++c) {
    if (l = o[c], !Ne(l))
      continue;
    const d = Object.keys(l);
    for (let u = 0, p = d.length; u < p; ++u)
      i(d[u], e, l, n);
  }
  return e;
}
a(Jn, "merge");
function Si(e, t) {
  return Jn(e, t, {
    merger: tC
  });
}
a(Si, "mergeIf");
function tC(e, t, n) {
  if (!Rd(e))
    return;
  const o = t[e], r = n[e];
  Ne(o) && Ne(r) ? Si(o, r) : Object.prototype.hasOwnProperty.call(t, e) || (t[e] = Sa(r));
}
a(tC, "_mergerIf");
const p4 = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (e) => e,
  // default resolvers
  x: /* @__PURE__ */ a((e) => e.x, "x"),
  y: /* @__PURE__ */ a((e) => e.y, "y")
};
function nC(e) {
  const t = e.split("."), n = [];
  let o = "";
  for (const r of t)
    o += r, o.endsWith("\\") ? o = o.slice(0, -1) + "." : (n.push(o), o = "");
  return n;
}
a(nC, "_splitKey");
function oC(e) {
  const t = nC(e);
  return (n) => {
    for (const o of t) {
      if (o === "")
        break;
      n = n && n[o];
    }
    return n;
  };
}
a(oC, "_getKeyResolver");
function or(e, t) {
  return (p4[t] || (p4[t] = oC(t)))(e);
}
a(or, "resolveObjectKey");
function Uc(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
a(Uc, "_capitalize");
const Gi = /* @__PURE__ */ a((e) => typeof e < "u", "defined"), $o = /* @__PURE__ */ a((e) => typeof e == "function", "isFunction"), f4 = /* @__PURE__ */ a((e, t) => {
  if (e.size !== t.size)
    return !1;
  for (const n of e)
    if (!t.has(n))
      return !1;
  return !0;
}, "setsEqual");
function rC(e) {
  return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
a(rC, "_isClickEvent");
const Qe = Math.PI, Ct = 2 * Qe, iC = Ct + Qe, Ma = Number.POSITIVE_INFINITY, sC = Qe / 180, Pt = Qe / 2, Bo = Qe / 4, h4 = Qe * 2 / 3, Id = Math.log10, Yn = Math.sign;
function Mi(e, t, n) {
  return Math.abs(e - t) < n;
}
a(Mi, "almostEquals");
function g4(e) {
  const t = Math.round(e);
  e = Mi(e, t, e / 1e3) ? t : e;
  const n = Math.pow(10, Math.floor(Id(e))), o = e / n;
  return (o <= 1 ? 1 : o <= 2 ? 2 : o <= 5 ? 5 : 10) * n;
}
a(g4, "niceNum");
function aC(e) {
  const t = [], n = Math.sqrt(e);
  let o;
  for (o = 1; o < n; o++)
    e % o === 0 && (t.push(o), t.push(e / o));
  return n === (n | 0) && t.push(n), t.sort((r, i) => r - i).pop(), t;
}
a(aC, "_factorize");
function lC(e) {
  return typeof e == "symbol" || typeof e == "object" && e !== null && !(Symbol.toPrimitive in e || "toString" in e || "valueOf" in e);
}
a(lC, "isNonPrimitive");
function Yi(e) {
  return !lC(e) && !isNaN(parseFloat(e)) && isFinite(e);
}
a(Yi, "isNumber");
function cC(e, t) {
  const n = Math.round(e);
  return n - t <= e && n + t >= e;
}
a(cC, "almostWhole");
function dC(e, t, n) {
  let o, r, i;
  for (o = 0, r = e.length; o < r; o++)
    i = e[o][n], isNaN(i) || (t.min = Math.min(t.min, i), t.max = Math.max(t.max, i));
}
a(dC, "_setMinAndMaxByKey");
function io(e) {
  return e * (Qe / 180);
}
a(io, "toRadians");
function uC(e) {
  return e * (180 / Qe);
}
a(uC, "toDegrees");
function m4(e) {
  if (!Tn(e))
    return;
  let t = 1, n = 0;
  for (; Math.round(e * t) / t !== e; )
    t *= 10, n++;
  return n;
}
a(m4, "_decimalPlaces");
function jd(e, t) {
  const n = t.x - e.x, o = t.y - e.y, r = Math.sqrt(n * n + o * o);
  let i = Math.atan2(o, n);
  return i < -0.5 * Qe && (i += Ct), {
    angle: i,
    distance: r
  };
}
a(jd, "getAngleFromPoint");
function P1(e, t) {
  return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
}
a(P1, "distanceBetweenPoints");
function pC(e, t) {
  return (e - t + iC) % Ct - Qe;
}
a(pC, "_angleDiff");
function Pn(e) {
  return (e % Ct + Ct) % Ct;
}
a(Pn, "_normalizeAngle");
function qi(e, t, n, o) {
  const r = Pn(e), i = Pn(t), l = Pn(n), c = Pn(i - r), d = Pn(l - r), u = Pn(r - i), p = Pn(r - l);
  return r === i || r === l || o && i === l || c > d && u < p;
}
a(qi, "_angleBetween");
function Nt(e, t, n) {
  return Math.max(t, Math.min(n, e));
}
a(Nt, "_limitValue");
function fC(e) {
  return Nt(e, -32768, 32767);
}
a(fC, "_int16Range");
function wo(e, t, n, o = 1e-6) {
  return e >= Math.min(t, n) - o && e <= Math.max(t, n) + o;
}
a(wo, "_isBetween");
function Gc(e, t, n) {
  n = n || ((l) => e[l] < t);
  let o = e.length - 1, r = 0, i;
  for (; o - r > 1; )
    i = r + o >> 1, n(i) ? r = i : o = i;
  return {
    lo: r,
    hi: o
  };
}
a(Gc, "_lookup");
const Xo = /* @__PURE__ */ a((e, t, n, o) => Gc(e, n, o ? (r) => {
  const i = e[r][t];
  return i < n || i === n && e[r + 1][t] === n;
} : (r) => e[r][t] < n), "_lookupByKey"), hC = /* @__PURE__ */ a((e, t, n) => Gc(e, n, (o) => e[o][t] >= n), "_rlookupByKey");
function gC(e, t, n) {
  let o = 0, r = e.length;
  for (; o < r && e[o] < t; )
    o++;
  for (; r > o && e[r - 1] > n; )
    r--;
  return o > 0 || r < e.length ? e.slice(o, r) : e;
}
a(gC, "_filterBetween");
const Ld = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function mC(e, t) {
  if (e._chartjs) {
    e._chartjs.listeners.push(t);
    return;
  }
  Object.defineProperty(e, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        t
      ]
    }
  }), Ld.forEach((n) => {
    const o = "_onData" + Uc(n), r = e[n];
    Object.defineProperty(e, n, {
      configurable: !0,
      enumerable: !1,
      value(...i) {
        const l = r.apply(this, i);
        return e._chartjs.listeners.forEach((c) => {
          typeof c[o] == "function" && c[o](...i);
        }), l;
      }
    });
  });
}
a(mC, "listenArrayEvents");
function b4(e, t) {
  const n = e._chartjs;
  if (!n)
    return;
  const o = n.listeners, r = o.indexOf(t);
  r !== -1 && o.splice(r, 1), !(o.length > 0) && (Ld.forEach((i) => {
    delete e[i];
  }), delete e._chartjs);
}
a(b4, "unlistenArrayEvents");
function Vd(e) {
  const t = new Set(e);
  return t.size === e.length ? e : Array.from(t);
}
a(Vd, "_arrayUnique");
const Ad = function() {
  return typeof window > "u" ? function(e) {
    return e();
  } : window.requestAnimationFrame;
}();
function Bd(e, t) {
  let n = [], o = !1;
  return function(...r) {
    n = r, o || (o = !0, Ad.call(window, () => {
      o = !1, e.apply(t, n);
    }));
  };
}
a(Bd, "throttled");
function bC(e, t) {
  let n;
  return function(...o) {
    return t ? (clearTimeout(n), n = setTimeout(e, t, o)) : e.apply(this, o), t;
  };
}
a(bC, "debounce");
const Yc = /* @__PURE__ */ a((e) => e === "start" ? "left" : e === "end" ? "right" : "center", "_toLeftRightCenter"), Ht = /* @__PURE__ */ a((e, t, n) => e === "start" ? t : e === "end" ? n : (t + n) / 2, "_alignStartEnd"), CC = /* @__PURE__ */ a((e, t, n, o) => e === (o ? "left" : "right") ? n : e === "center" ? (t + n) / 2 : t, "_textX");
function yC(e, t, n) {
  const o = t.length;
  let r = 0, i = o;
  if (e._sorted) {
    const { iScale: l, vScale: c, _parsed: d } = e, u = e.dataset && e.dataset.options ? e.dataset.options.spanGaps : null, p = l.axis, { min: f, max: m, minDefined: b, maxDefined: C } = l.getUserBounds();
    if (b) {
      if (r = Math.min(
        // @ts-expect-error Need to type _parsed
        Xo(d, p, f).lo,
        // @ts-expect-error Need to fix types on _lookupByKey
        n ? o : Xo(t, p, l.getPixelForValue(f)).lo
      ), u) {
        const g = d.slice(0, r + 1).reverse().findIndex((y) => !He(y[c.axis]));
        r -= Math.max(0, g);
      }
      r = Nt(r, 0, o - 1);
    }
    if (C) {
      let g = Math.max(
        // @ts-expect-error Need to type _parsed
        Xo(d, l.axis, m, !0).hi + 1,
        // @ts-expect-error Need to fix types on _lookupByKey
        n ? 0 : Xo(t, p, l.getPixelForValue(m), !0).hi + 1
      );
      if (u) {
        const y = d.slice(g - 1).findIndex((w) => !He(w[c.axis]));
        g += Math.max(0, y);
      }
      i = Nt(g, r, o) - r;
    } else
      i = o - r;
  }
  return {
    start: r,
    count: i
  };
}
a(yC, "_getStartAndCountOfVisiblePoints");
function xC(e) {
  const { xScale: t, yScale: n, _scaleRanges: o } = e, r = {
    xmin: t.min,
    xmax: t.max,
    ymin: n.min,
    ymax: n.max
  };
  if (!o)
    return e._scaleRanges = r, !0;
  const i = o.xmin !== t.min || o.xmax !== t.max || o.ymin !== n.min || o.ymax !== n.max;
  return Object.assign(o, r), i;
}
a(xC, "_scaleRangesChanged");
const js = /* @__PURE__ */ a((e) => e === 0 || e === 1, "atEdge"), C4 = /* @__PURE__ */ a((e, t, n) => -(Math.pow(2, 10 * (e -= 1)) * Math.sin((e - t) * Ct / n)), "elasticIn"), y4 = /* @__PURE__ */ a((e, t, n) => Math.pow(2, -10 * e) * Math.sin((e - t) * Ct / n) + 1, "elasticOut"), Ti = {
  linear: /* @__PURE__ */ a((e) => e, "linear"),
  easeInQuad: /* @__PURE__ */ a((e) => e * e, "easeInQuad"),
  easeOutQuad: /* @__PURE__ */ a((e) => -e * (e - 2), "easeOutQuad"),
  easeInOutQuad: /* @__PURE__ */ a((e) => (e /= 0.5) < 1 ? 0.5 * e * e : -0.5 * (--e * (e - 2) - 1), "easeInOutQuad"),
  easeInCubic: /* @__PURE__ */ a((e) => e * e * e, "easeInCubic"),
  easeOutCubic: /* @__PURE__ */ a((e) => (e -= 1) * e * e + 1, "easeOutCubic"),
  easeInOutCubic: /* @__PURE__ */ a((e) => (e /= 0.5) < 1 ? 0.5 * e * e * e : 0.5 * ((e -= 2) * e * e + 2), "easeInOutCubic"),
  easeInQuart: /* @__PURE__ */ a((e) => e * e * e * e, "easeInQuart"),
  easeOutQuart: /* @__PURE__ */ a((e) => -((e -= 1) * e * e * e - 1), "easeOutQuart"),
  easeInOutQuart: /* @__PURE__ */ a((e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e : -0.5 * ((e -= 2) * e * e * e - 2), "easeInOutQuart"),
  easeInQuint: /* @__PURE__ */ a((e) => e * e * e * e * e, "easeInQuint"),
  easeOutQuint: /* @__PURE__ */ a((e) => (e -= 1) * e * e * e * e + 1, "easeOutQuint"),
  easeInOutQuint: /* @__PURE__ */ a((e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e * e : 0.5 * ((e -= 2) * e * e * e * e + 2), "easeInOutQuint"),
  easeInSine: /* @__PURE__ */ a((e) => -Math.cos(e * Pt) + 1, "easeInSine"),
  easeOutSine: /* @__PURE__ */ a((e) => Math.sin(e * Pt), "easeOutSine"),
  easeInOutSine: /* @__PURE__ */ a((e) => -0.5 * (Math.cos(Qe * e) - 1), "easeInOutSine"),
  easeInExpo: /* @__PURE__ */ a((e) => e === 0 ? 0 : Math.pow(2, 10 * (e - 1)), "easeInExpo"),
  easeOutExpo: /* @__PURE__ */ a((e) => e === 1 ? 1 : -Math.pow(2, -10 * e) + 1, "easeOutExpo"),
  easeInOutExpo: /* @__PURE__ */ a((e) => js(e) ? e : e < 0.5 ? 0.5 * Math.pow(2, 10 * (e * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (e * 2 - 1)) + 2), "easeInOutExpo"),
  easeInCirc: /* @__PURE__ */ a((e) => e >= 1 ? e : -(Math.sqrt(1 - e * e) - 1), "easeInCirc"),
  easeOutCirc: /* @__PURE__ */ a((e) => Math.sqrt(1 - (e -= 1) * e), "easeOutCirc"),
  easeInOutCirc: /* @__PURE__ */ a((e) => (e /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - e * e) - 1) : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1), "easeInOutCirc"),
  easeInElastic: /* @__PURE__ */ a((e) => js(e) ? e : C4(e, 0.075, 0.3), "easeInElastic"),
  easeOutElastic: /* @__PURE__ */ a((e) => js(e) ? e : y4(e, 0.075, 0.3), "easeOutElastic"),
  easeInOutElastic(e) {
    return js(e) ? e : e < 0.5 ? 0.5 * C4(e * 2, 0.1125, 0.45) : 0.5 + 0.5 * y4(e * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(e) {
    return e * e * ((1.70158 + 1) * e - 1.70158);
  },
  easeOutBack(e) {
    return (e -= 1) * e * ((1.70158 + 1) * e + 1.70158) + 1;
  },
  easeInOutBack(e) {
    let t = 1.70158;
    return (e /= 0.5) < 1 ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t)) : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
  },
  easeInBounce: /* @__PURE__ */ a((e) => 1 - Ti.easeOutBounce(1 - e), "easeInBounce"),
  easeOutBounce(e) {
    return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
  },
  easeInOutBounce: /* @__PURE__ */ a((e) => e < 0.5 ? Ti.easeInBounce(e * 2) * 0.5 : Ti.easeOutBounce(e * 2 - 1) * 0.5 + 0.5, "easeInOutBounce")
};
function qc(e) {
  if (e && typeof e == "object") {
    const t = e.toString();
    return t === "[object CanvasPattern]" || t === "[object CanvasGradient]";
  }
  return !1;
}
a(qc, "isPatternOrGradient");
function x4(e) {
  return qc(e) ? e : new va(e);
}
a(x4, "color");
function Gl(e) {
  return qc(e) ? e : new va(e).saturate(0.5).darken(0.1).hexString();
}
a(Gl, "getHoverColor");
const vC = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], wC = [
  "color",
  "borderColor",
  "backgroundColor"
];
function SC(e) {
  e.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), e.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: /* @__PURE__ */ a((t) => t !== "onProgress" && t !== "onComplete" && t !== "fn", "_scriptable")
  }), e.set("animations", {
    colors: {
      type: "color",
      properties: wC
    },
    numbers: {
      type: "number",
      properties: vC
    }
  }), e.describe("animations", {
    _fallback: "animation"
  }), e.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: /* @__PURE__ */ a((t) => t | 0, "fn")
        }
      }
    }
  });
}
a(SC, "applyAnimationsDefaults");
function MC(e) {
  e.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
a(MC, "applyLayoutsDefaults");
const v4 = /* @__PURE__ */ new Map();
function TC(e, t) {
  t = t || {};
  const n = e + JSON.stringify(t);
  let o = v4.get(n);
  return o || (o = new Intl.NumberFormat(e, t), v4.set(n, o)), o;
}
a(TC, "getNumberFormat");
function Kc(e, t, n) {
  return TC(t, n).format(e);
}
a(Kc, "formatNumber");
const kC = {
  values(e) {
    return Et(e) ? e : "" + e;
  },
  numeric(e, t, n) {
    if (e === 0)
      return "0";
    const o = this.chart.options.locale;
    let r, i = e;
    if (n.length > 1) {
      const u = Math.max(Math.abs(n[0].value), Math.abs(n[n.length - 1].value));
      (u < 1e-4 || u > 1e15) && (r = "scientific"), i = OC(e, n);
    }
    const l = Id(Math.abs(i)), c = isNaN(l) ? 1 : Math.max(Math.min(-1 * Math.floor(l), 20), 0), d = {
      notation: r,
      minimumFractionDigits: c,
      maximumFractionDigits: c
    };
    return Object.assign(d, this.options.ticks.format), Kc(e, o, d);
  }
};
function OC(e, t) {
  let n = t.length > 3 ? t[2].value - t[1].value : t[1].value - t[0].value;
  return Math.abs(n) >= 1 && e !== Math.floor(e) && (n = e - Math.floor(e)), n;
}
a(OC, "calculateDelta");
var Hd = {
  formatters: kC
};
function EC(e) {
  e.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    clip: !0,
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: /* @__PURE__ */ a((t, n) => n.lineWidth, "tickWidth"),
      tickColor: /* @__PURE__ */ a((t, n) => n.color, "tickColor"),
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: Hd.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), e.route("scale.ticks", "color", "", "color"), e.route("scale.grid", "color", "", "borderColor"), e.route("scale.border", "color", "", "borderColor"), e.route("scale.title", "color", "", "color"), e.describe("scale", {
    _fallback: !1,
    _scriptable: /* @__PURE__ */ a((t) => !t.startsWith("before") && !t.startsWith("after") && t !== "callback" && t !== "parser", "_scriptable"),
    _indexable: /* @__PURE__ */ a((t) => t !== "borderDash" && t !== "tickBorderDash" && t !== "dash", "_indexable")
  }), e.describe("scales", {
    _fallback: "scale"
  }), e.describe("scale.ticks", {
    _scriptable: /* @__PURE__ */ a((t) => t !== "backdropPadding" && t !== "callback", "_scriptable"),
    _indexable: /* @__PURE__ */ a((t) => t !== "backdropPadding", "_indexable")
  });
}
a(EC, "applyScaleDefaults");
const rr = /* @__PURE__ */ Object.create(null), _1 = /* @__PURE__ */ Object.create(null);
function ki(e, t) {
  if (!t)
    return e;
  const n = t.split(".");
  for (let o = 0, r = n.length; o < r; ++o) {
    const i = n[o];
    e = e[i] || (e[i] = /* @__PURE__ */ Object.create(null));
  }
  return e;
}
a(ki, "getScope$1");
function Yl(e, t, n) {
  return typeof t == "string" ? Jn(ki(e, t), n) : Jn(ki(e, ""), t);
}
a(Yl, "set");
const a2 = class a2 {
  constructor(t, n) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (o) => o.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (o, r) => Gl(r.backgroundColor), this.hoverBorderColor = (o, r) => Gl(r.borderColor), this.hoverColor = (o, r) => Gl(r.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(t), this.apply(n);
  }
  set(t, n) {
    return Yl(this, t, n);
  }
  get(t) {
    return ki(this, t);
  }
  describe(t, n) {
    return Yl(_1, t, n);
  }
  override(t, n) {
    return Yl(rr, t, n);
  }
  route(t, n, o, r) {
    const i = ki(this, t), l = ki(this, o), c = "_" + n;
    Object.defineProperties(i, {
      [c]: {
        value: i[n],
        writable: !0
      },
      [n]: {
        enumerable: !0,
        get() {
          const d = this[c], u = l[r];
          return Ne(d) ? Object.assign({}, u, d) : je(d, u);
        },
        set(d) {
          this[c] = d;
        }
      }
    });
  }
  apply(t) {
    t.forEach((n) => n(this));
  }
};
a(a2, "Defaults");
let R1 = a2;
var yt = /* @__PURE__ */ new R1({
  _scriptable: /* @__PURE__ */ a((e) => !e.startsWith("on"), "_scriptable"),
  _indexable: /* @__PURE__ */ a((e) => e !== "events", "_indexable"),
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  SC,
  MC,
  EC
]);
function $C(e) {
  return !e || He(e.size) || He(e.family) ? null : (e.style ? e.style + " " : "") + (e.weight ? e.weight + " " : "") + e.size + "px " + e.family;
}
a($C, "toFontString");
function w4(e, t, n, o, r) {
  let i = t[r];
  return i || (i = t[r] = e.measureText(r).width, n.push(r)), i > o && (o = i), o;
}
a(w4, "_measureText");
function Ho(e, t, n) {
  const o = e.currentDevicePixelRatio, r = n !== 0 ? Math.max(n / 2, 0.5) : 0;
  return Math.round((t - r) * o) / o + r;
}
a(Ho, "_alignPixel");
function S4(e, t) {
  !t && !e || (t = t || e.getContext("2d"), t.save(), t.resetTransform(), t.clearRect(0, 0, e.width, e.height), t.restore());
}
a(S4, "clearCanvas");
function I1(e, t, n, o) {
  Dd(e, t, n, o, null);
}
a(I1, "drawPoint");
function Dd(e, t, n, o, r) {
  let i, l, c, d, u, p, f, m;
  const b = t.pointStyle, C = t.rotation, g = t.radius;
  let y = (C || 0) * sC;
  if (b && typeof b == "object" && (i = b.toString(), i === "[object HTMLImageElement]" || i === "[object HTMLCanvasElement]")) {
    e.save(), e.translate(n, o), e.rotate(y), e.drawImage(b, -b.width / 2, -b.height / 2, b.width, b.height), e.restore();
    return;
  }
  if (!(isNaN(g) || g <= 0)) {
    switch (e.beginPath(), b) {
      // Default includes circle
      default:
        r ? e.ellipse(n, o, r / 2, g, 0, 0, Ct) : e.arc(n, o, g, 0, Ct), e.closePath();
        break;
      case "triangle":
        p = r ? r / 2 : g, e.moveTo(n + Math.sin(y) * p, o - Math.cos(y) * g), y += h4, e.lineTo(n + Math.sin(y) * p, o - Math.cos(y) * g), y += h4, e.lineTo(n + Math.sin(y) * p, o - Math.cos(y) * g), e.closePath();
        break;
      case "rectRounded":
        u = g * 0.516, d = g - u, l = Math.cos(y + Bo) * d, f = Math.cos(y + Bo) * (r ? r / 2 - u : d), c = Math.sin(y + Bo) * d, m = Math.sin(y + Bo) * (r ? r / 2 - u : d), e.arc(n - f, o - c, u, y - Qe, y - Pt), e.arc(n + m, o - l, u, y - Pt, y), e.arc(n + f, o + c, u, y, y + Pt), e.arc(n - m, o + l, u, y + Pt, y + Qe), e.closePath();
        break;
      case "rect":
        if (!C) {
          d = Math.SQRT1_2 * g, p = r ? r / 2 : d, e.rect(n - p, o - d, 2 * p, 2 * d);
          break;
        }
        y += Bo;
      /* falls through */
      case "rectRot":
        f = Math.cos(y) * (r ? r / 2 : g), l = Math.cos(y) * g, c = Math.sin(y) * g, m = Math.sin(y) * (r ? r / 2 : g), e.moveTo(n - f, o - c), e.lineTo(n + m, o - l), e.lineTo(n + f, o + c), e.lineTo(n - m, o + l), e.closePath();
        break;
      case "crossRot":
        y += Bo;
      /* falls through */
      case "cross":
        f = Math.cos(y) * (r ? r / 2 : g), l = Math.cos(y) * g, c = Math.sin(y) * g, m = Math.sin(y) * (r ? r / 2 : g), e.moveTo(n - f, o - c), e.lineTo(n + f, o + c), e.moveTo(n + m, o - l), e.lineTo(n - m, o + l);
        break;
      case "star":
        f = Math.cos(y) * (r ? r / 2 : g), l = Math.cos(y) * g, c = Math.sin(y) * g, m = Math.sin(y) * (r ? r / 2 : g), e.moveTo(n - f, o - c), e.lineTo(n + f, o + c), e.moveTo(n + m, o - l), e.lineTo(n - m, o + l), y += Bo, f = Math.cos(y) * (r ? r / 2 : g), l = Math.cos(y) * g, c = Math.sin(y) * g, m = Math.sin(y) * (r ? r / 2 : g), e.moveTo(n - f, o - c), e.lineTo(n + f, o + c), e.moveTo(n + m, o - l), e.lineTo(n - m, o + l);
        break;
      case "line":
        l = r ? r / 2 : Math.cos(y) * g, c = Math.sin(y) * g, e.moveTo(n - l, o - c), e.lineTo(n + l, o + c);
        break;
      case "dash":
        e.moveTo(n, o), e.lineTo(n + Math.cos(y) * (r ? r / 2 : g), o + Math.sin(y) * g);
        break;
      case !1:
        e.closePath();
        break;
    }
    e.fill(), t.borderWidth > 0 && e.stroke();
  }
}
a(Dd, "drawPointLegend");
function Ki(e, t, n) {
  return n = n || 0.5, !t || e && e.x > t.left - n && e.x < t.right + n && e.y > t.top - n && e.y < t.bottom + n;
}
a(Ki, "_isPointInArea");
function Xc(e, t) {
  e.save(), e.beginPath(), e.rect(t.left, t.top, t.right - t.left, t.bottom - t.top), e.clip();
}
a(Xc, "clipArea");
function Jc(e) {
  e.restore();
}
a(Jc, "unclipArea");
function PC(e, t, n, o, r) {
  if (!t)
    return e.lineTo(n.x, n.y);
  if (r === "middle") {
    const i = (t.x + n.x) / 2;
    e.lineTo(i, t.y), e.lineTo(i, n.y);
  } else r === "after" != !!o ? e.lineTo(t.x, n.y) : e.lineTo(n.x, t.y);
  e.lineTo(n.x, n.y);
}
a(PC, "_steppedLineTo");
function _C(e, t, n, o) {
  if (!t)
    return e.lineTo(n.x, n.y);
  e.bezierCurveTo(o ? t.cp1x : t.cp2x, o ? t.cp1y : t.cp2y, o ? n.cp2x : n.cp1x, o ? n.cp2y : n.cp1y, n.x, n.y);
}
a(_C, "_bezierCurveTo");
function RC(e, t) {
  t.translation && e.translate(t.translation[0], t.translation[1]), He(t.rotation) || e.rotate(t.rotation), t.color && (e.fillStyle = t.color), t.textAlign && (e.textAlign = t.textAlign), t.textBaseline && (e.textBaseline = t.textBaseline);
}
a(RC, "setRenderOpts");
function IC(e, t, n, o, r) {
  if (r.strikethrough || r.underline) {
    const i = e.measureText(o), l = t - i.actualBoundingBoxLeft, c = t + i.actualBoundingBoxRight, d = n - i.actualBoundingBoxAscent, u = n + i.actualBoundingBoxDescent, p = r.strikethrough ? (d + u) / 2 : u;
    e.strokeStyle = e.fillStyle, e.beginPath(), e.lineWidth = r.decorationWidth || 2, e.moveTo(l, p), e.lineTo(c, p), e.stroke();
  }
}
a(IC, "decorateText");
function jC(e, t) {
  const n = e.fillStyle;
  e.fillStyle = t.color, e.fillRect(t.left, t.top, t.width, t.height), e.fillStyle = n;
}
a(jC, "drawBackdrop");
function Xi(e, t, n, o, r, i = {}) {
  const l = Et(t) ? t : [
    t
  ], c = i.strokeWidth > 0 && i.strokeColor !== "";
  let d, u;
  for (e.save(), e.font = r.string, RC(e, i), d = 0; d < l.length; ++d)
    u = l[d], i.backdrop && jC(e, i.backdrop), c && (i.strokeColor && (e.strokeStyle = i.strokeColor), He(i.strokeWidth) || (e.lineWidth = i.strokeWidth), e.strokeText(u, n, o, i.maxWidth)), e.fillText(u, n, o, i.maxWidth), IC(e, n, o, u, i), o += Number(r.lineHeight);
  e.restore();
}
a(Xi, "renderText");
function Ta(e, t) {
  const { x: n, y: o, w: r, h: i, radius: l } = t;
  e.arc(n + l.topLeft, o + l.topLeft, l.topLeft, 1.5 * Qe, Qe, !0), e.lineTo(n, o + i - l.bottomLeft), e.arc(n + l.bottomLeft, o + i - l.bottomLeft, l.bottomLeft, Qe, Pt, !0), e.lineTo(n + r - l.bottomRight, o + i), e.arc(n + r - l.bottomRight, o + i - l.bottomRight, l.bottomRight, Pt, 0, !0), e.lineTo(n + r, o + l.topRight), e.arc(n + r - l.topRight, o + l.topRight, l.topRight, 0, -Pt, !0), e.lineTo(n + l.topLeft, o);
}
a(Ta, "addRoundedRectPath");
const LC = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, VC = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function AC(e, t) {
  const n = ("" + e).match(LC);
  if (!n || n[1] === "normal")
    return t * 1.2;
  switch (e = +n[2], n[3]) {
    case "px":
      return e;
    case "%":
      e /= 100;
      break;
  }
  return t * e;
}
a(AC, "toLineHeight");
const BC = /* @__PURE__ */ a((e) => +e || 0, "numberOrZero");
function Qc(e, t) {
  const n = {}, o = Ne(t), r = o ? Object.keys(t) : t, i = Ne(e) ? o ? (l) => je(e[l], e[t[l]]) : (l) => e[l] : () => e;
  for (const l of r)
    n[l] = BC(i(l));
  return n;
}
a(Qc, "_readValueToProps");
function Nd(e) {
  return Qc(e, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
a(Nd, "toTRBL");
function kr(e) {
  return Qc(e, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
a(kr, "toTRBLCorners");
function pn(e) {
  const t = Nd(e);
  return t.width = t.left + t.right, t.height = t.top + t.bottom, t;
}
a(pn, "toPadding");
function Lt(e, t) {
  e = e || {}, t = t || yt.font;
  let n = je(e.size, t.size);
  typeof n == "string" && (n = parseInt(n, 10));
  let o = je(e.style, t.style);
  o && !("" + o).match(VC) && (console.warn('Invalid font style specified: "' + o + '"'), o = void 0);
  const r = {
    family: je(e.family, t.family),
    lineHeight: AC(je(e.lineHeight, t.lineHeight), n),
    size: n,
    style: o,
    weight: je(e.weight, t.weight),
    string: ""
  };
  return r.string = $C(r), r;
}
a(Lt, "toFont");
function dt(e, t, n, o) {
  let r, i, l;
  for (r = 0, i = e.length; r < i; ++r)
    if (l = e[r], l !== void 0 && (t !== void 0 && typeof l == "function" && (l = l(t)), n !== void 0 && Et(l) && (l = l[n % l.length]), l !== void 0))
      return l;
}
a(dt, "resolve");
function HC(e, t, n) {
  const { min: o, max: r } = e, i = _d(t, (r - o) / 2), l = /* @__PURE__ */ a((c, d) => n && c === 0 ? 0 : c + d, "keepZero");
  return {
    min: l(o, -Math.abs(i)),
    max: l(r, i)
  };
}
a(HC, "_addGrace");
function lr(e, t) {
  return Object.assign(Object.create(e), t);
}
a(lr, "createContext");
function e2(e, t = [
  ""
], n, o, r = () => e[0]) {
  const i = n || e;
  typeof o > "u" && (o = Zd("_fallback", e));
  const l = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: e,
    _rootScopes: i,
    _fallback: o,
    _getTarget: r,
    override: /* @__PURE__ */ a((c) => e2([
      c,
      ...e
    ], t, i, o), "override")
  };
  return new Proxy(l, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(c, d) {
      return delete c[d], delete c._keys, delete e[0][d], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(c, d) {
      return Fd(c, d, () => GC(d, t, e, c));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(c, d) {
      return Reflect.getOwnPropertyDescriptor(c._scopes[0], d);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(c, d) {
      return T4(c).includes(d);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(c) {
      return T4(c);
    },
    /**
    * A trap for setting property values.
    */
    set(c, d, u) {
      const p = c._storage || (c._storage = r());
      return c[d] = p[d] = u, delete c._keys, !0;
    }
  });
}
a(e2, "_createResolver");
function Lr(e, t, n, o) {
  const r = {
    _cacheable: !1,
    _proxy: e,
    _context: t,
    _subProxy: n,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: zd(e, o),
    setContext: /* @__PURE__ */ a((i) => Lr(e, i, n, o), "setContext"),
    override: /* @__PURE__ */ a((i) => Lr(e.override(i), t, n, o), "override")
  };
  return new Proxy(r, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(i, l) {
      return delete i[l], delete e[l], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(i, l, c) {
      return Fd(i, l, () => NC(i, l, c));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(i, l) {
      return i._descriptors.allKeys ? Reflect.has(e, l) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(e, l);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e);
    },
    /**
    * A trap for the in operator.
    */
    has(i, l) {
      return Reflect.has(e, l);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(e);
    },
    /**
    * A trap for setting property values.
    */
    set(i, l, c) {
      return e[l] = c, delete i[l], !0;
    }
  });
}
a(Lr, "_attachContext");
function zd(e, t = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: n = t.scriptable, _indexable: o = t.indexable, _allKeys: r = t.allKeys } = e;
  return {
    allKeys: r,
    scriptable: n,
    indexable: o,
    isScriptable: $o(n) ? n : () => n,
    isIndexable: $o(o) ? o : () => o
  };
}
a(zd, "_descriptors");
const DC = /* @__PURE__ */ a((e, t) => e ? e + Uc(t) : t, "readKey"), t2 = /* @__PURE__ */ a((e, t) => Ne(t) && e !== "adapters" && (Object.getPrototypeOf(t) === null || t.constructor === Object), "needsSubResolver");
function Fd(e, t, n) {
  if (Object.prototype.hasOwnProperty.call(e, t) || t === "constructor")
    return e[t];
  const o = n();
  return e[t] = o, o;
}
a(Fd, "_cached");
function NC(e, t, n) {
  const { _proxy: o, _context: r, _subProxy: i, _descriptors: l } = e;
  let c = o[t];
  return $o(c) && l.isScriptable(t) && (c = zC(t, c, e, n)), Et(c) && c.length && (c = FC(t, c, e, l.isIndexable)), t2(t, c) && (c = Lr(c, r, i && i[t], l)), c;
}
a(NC, "_resolveWithContext");
function zC(e, t, n, o) {
  const { _proxy: r, _context: i, _subProxy: l, _stack: c } = n;
  if (c.has(e))
    throw new Error("Recursion detected: " + Array.from(c).join("->") + "->" + e);
  c.add(e);
  let d = t(i, l || o);
  return c.delete(e), t2(e, d) && (d = n2(r._scopes, r, e, d)), d;
}
a(zC, "_resolveScriptable");
function FC(e, t, n, o) {
  const { _proxy: r, _context: i, _subProxy: l, _descriptors: c } = n;
  if (typeof i.index < "u" && o(e))
    return t[i.index % t.length];
  if (Ne(t[0])) {
    const d = t, u = r._scopes.filter((p) => p !== d);
    t = [];
    for (const p of d) {
      const f = n2(u, r, e, p);
      t.push(Lr(f, i, l && l[e], c));
    }
  }
  return t;
}
a(FC, "_resolveArray");
function Wd(e, t, n) {
  return $o(e) ? e(t, n) : e;
}
a(Wd, "resolveFallback");
const WC = /* @__PURE__ */ a((e, t) => e === !0 ? t : typeof e == "string" ? or(t, e) : void 0, "getScope");
function ZC(e, t, n, o, r) {
  for (const i of t) {
    const l = WC(n, i);
    if (l) {
      e.add(l);
      const c = Wd(l._fallback, n, r);
      if (typeof c < "u" && c !== n && c !== o)
        return c;
    } else if (l === !1 && typeof o < "u" && n !== o)
      return null;
  }
  return !1;
}
a(ZC, "addScopes");
function n2(e, t, n, o) {
  const r = t._rootScopes, i = Wd(t._fallback, n, o), l = [
    ...e,
    ...r
  ], c = /* @__PURE__ */ new Set();
  c.add(o);
  let d = M4(c, l, n, i || n, o);
  return d === null || typeof i < "u" && i !== n && (d = M4(c, l, i, d, o), d === null) ? !1 : e2(Array.from(c), [
    ""
  ], r, i, () => UC(t, n, o));
}
a(n2, "createSubResolver");
function M4(e, t, n, o, r) {
  for (; n; )
    n = ZC(e, t, n, o, r);
  return n;
}
a(M4, "addScopesFromKey");
function UC(e, t, n) {
  const o = e._getTarget();
  t in o || (o[t] = {});
  const r = o[t];
  return Et(r) && Ne(n) ? n : r || {};
}
a(UC, "subGetTarget");
function GC(e, t, n, o) {
  let r;
  for (const i of t)
    if (r = Zd(DC(i, e), n), typeof r < "u")
      return t2(e, r) ? n2(n, o, e, r) : r;
}
a(GC, "_resolveWithPrefixes");
function Zd(e, t) {
  for (const n of t) {
    if (!n)
      continue;
    const o = n[e];
    if (typeof o < "u")
      return o;
  }
}
a(Zd, "_resolve");
function T4(e) {
  let t = e._keys;
  return t || (t = e._keys = YC(e._scopes)), t;
}
a(T4, "getKeysFromAllScopes");
function YC(e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e)
    for (const o of Object.keys(n).filter((r) => !r.startsWith("_")))
      t.add(o);
  return Array.from(t);
}
a(YC, "resolveKeysFromAllScopes");
const qC = Number.EPSILON || 1e-14, Vr = /* @__PURE__ */ a((e, t) => t < e.length && !e[t].skip && e[t], "getPoint"), Ud = /* @__PURE__ */ a((e) => e === "x" ? "y" : "x", "getValueAxis");
function KC(e, t, n, o) {
  const r = e.skip ? t : e, i = t, l = n.skip ? t : n, c = P1(i, r), d = P1(l, i);
  let u = c / (c + d), p = d / (c + d);
  u = isNaN(u) ? 0 : u, p = isNaN(p) ? 0 : p;
  const f = o * u, m = o * p;
  return {
    previous: {
      x: i.x - f * (l.x - r.x),
      y: i.y - f * (l.y - r.y)
    },
    next: {
      x: i.x + m * (l.x - r.x),
      y: i.y + m * (l.y - r.y)
    }
  };
}
a(KC, "splineCurve");
function XC(e, t, n) {
  const o = e.length;
  let r, i, l, c, d, u = Vr(e, 0);
  for (let p = 0; p < o - 1; ++p)
    if (d = u, u = Vr(e, p + 1), !(!d || !u)) {
      if (Mi(t[p], 0, qC)) {
        n[p] = n[p + 1] = 0;
        continue;
      }
      r = n[p] / t[p], i = n[p + 1] / t[p], c = Math.pow(r, 2) + Math.pow(i, 2), !(c <= 9) && (l = 3 / Math.sqrt(c), n[p] = r * l * t[p], n[p + 1] = i * l * t[p]);
    }
}
a(XC, "monotoneAdjust");
function JC(e, t, n = "x") {
  const o = Ud(n), r = e.length;
  let i, l, c, d = Vr(e, 0);
  for (let u = 0; u < r; ++u) {
    if (l = c, c = d, d = Vr(e, u + 1), !c)
      continue;
    const p = c[n], f = c[o];
    l && (i = (p - l[n]) / 3, c[`cp1${n}`] = p - i, c[`cp1${o}`] = f - i * t[u]), d && (i = (d[n] - p) / 3, c[`cp2${n}`] = p + i, c[`cp2${o}`] = f + i * t[u]);
  }
}
a(JC, "monotoneCompute");
function QC(e, t = "x") {
  const n = Ud(t), o = e.length, r = Array(o).fill(0), i = Array(o);
  let l, c, d, u = Vr(e, 0);
  for (l = 0; l < o; ++l)
    if (c = d, d = u, u = Vr(e, l + 1), !!d) {
      if (u) {
        const p = u[t] - d[t];
        r[l] = p !== 0 ? (u[n] - d[n]) / p : 0;
      }
      i[l] = c ? u ? Yn(r[l - 1]) !== Yn(r[l]) ? 0 : (r[l - 1] + r[l]) / 2 : r[l - 1] : r[l];
    }
  XC(e, r, i), JC(e, i, t);
}
a(QC, "splineCurveMonotone");
function Ls(e, t, n) {
  return Math.max(Math.min(e, n), t);
}
a(Ls, "capControlPoint");
function ey(e, t) {
  let n, o, r, i, l, c = Ki(e[0], t);
  for (n = 0, o = e.length; n < o; ++n)
    l = i, i = c, c = n < o - 1 && Ki(e[n + 1], t), i && (r = e[n], l && (r.cp1x = Ls(r.cp1x, t.left, t.right), r.cp1y = Ls(r.cp1y, t.top, t.bottom)), c && (r.cp2x = Ls(r.cp2x, t.left, t.right), r.cp2y = Ls(r.cp2y, t.top, t.bottom)));
}
a(ey, "capBezierPoints");
function ty(e, t, n, o, r) {
  let i, l, c, d;
  if (t.spanGaps && (e = e.filter((u) => !u.skip)), t.cubicInterpolationMode === "monotone")
    QC(e, r);
  else {
    let u = o ? e[e.length - 1] : e[0];
    for (i = 0, l = e.length; i < l; ++i)
      c = e[i], d = KC(u, c, e[Math.min(i + 1, l - (o ? 0 : 1)) % l], t.tension), c.cp1x = d.previous.x, c.cp1y = d.previous.y, c.cp2x = d.next.x, c.cp2y = d.next.y, u = c;
  }
  t.capBezierPoints && ey(e, n);
}
a(ty, "_updateBezierControlPoints");
function o2() {
  return typeof window < "u" && typeof document < "u";
}
a(o2, "_isDomSupported");
function r2(e) {
  let t = e.parentNode;
  return t && t.toString() === "[object ShadowRoot]" && (t = t.host), t;
}
a(r2, "_getParentNode");
function ka(e, t, n) {
  let o;
  return typeof e == "string" ? (o = parseInt(e, 10), e.indexOf("%") !== -1 && (o = o / 100 * t.parentNode[n])) : o = e, o;
}
a(ka, "parseMaxStyle");
const vl = /* @__PURE__ */ a((e) => e.ownerDocument.defaultView.getComputedStyle(e, null), "getComputedStyle");
function ny(e, t) {
  return vl(e).getPropertyValue(t);
}
a(ny, "getStyle");
const oy = [
  "top",
  "right",
  "bottom",
  "left"
];
function er(e, t, n) {
  const o = {};
  n = n ? "-" + n : "";
  for (let r = 0; r < 4; r++) {
    const i = oy[r];
    o[i] = parseFloat(e[t + "-" + i + n]) || 0;
  }
  return o.width = o.left + o.right, o.height = o.top + o.bottom, o;
}
a(er, "getPositionedStyle");
const ry = /* @__PURE__ */ a((e, t, n) => (e > 0 || t > 0) && (!n || !n.shadowRoot), "useOffsetPos");
function iy(e, t) {
  const n = e.touches, o = n && n.length ? n[0] : e, { offsetX: r, offsetY: i } = o;
  let l = !1, c, d;
  if (ry(r, i, e.target))
    c = r, d = i;
  else {
    const u = t.getBoundingClientRect();
    c = o.clientX - u.left, d = o.clientY - u.top, l = !0;
  }
  return {
    x: c,
    y: d,
    box: l
  };
}
a(iy, "getCanvasPosition");
function Fo(e, t) {
  if ("native" in e)
    return e;
  const { canvas: n, currentDevicePixelRatio: o } = t, r = vl(n), i = r.boxSizing === "border-box", l = er(r, "padding"), c = er(r, "border", "width"), { x: d, y: u, box: p } = iy(e, n), f = l.left + (p && c.left), m = l.top + (p && c.top);
  let { width: b, height: C } = t;
  return i && (b -= l.width + c.width, C -= l.height + c.height), {
    x: Math.round((d - f) / b * n.width / o),
    y: Math.round((u - m) / C * n.height / o)
  };
}
a(Fo, "getRelativePosition");
function sy(e, t, n) {
  let o, r;
  if (t === void 0 || n === void 0) {
    const i = e && r2(e);
    if (!i)
      t = e.clientWidth, n = e.clientHeight;
    else {
      const l = i.getBoundingClientRect(), c = vl(i), d = er(c, "border", "width"), u = er(c, "padding");
      t = l.width - u.width - d.width, n = l.height - u.height - d.height, o = ka(c.maxWidth, i, "clientWidth"), r = ka(c.maxHeight, i, "clientHeight");
    }
  }
  return {
    width: t,
    height: n,
    maxWidth: o || Ma,
    maxHeight: r || Ma
  };
}
a(sy, "getContainerSize");
const Vs = /* @__PURE__ */ a((e) => Math.round(e * 10) / 10, "round1");
function ay(e, t, n, o) {
  const r = vl(e), i = er(r, "margin"), l = ka(r.maxWidth, e, "clientWidth") || Ma, c = ka(r.maxHeight, e, "clientHeight") || Ma, d = sy(e, t, n);
  let { width: u, height: p } = d;
  if (r.boxSizing === "content-box") {
    const m = er(r, "border", "width"), b = er(r, "padding");
    u -= b.width + m.width, p -= b.height + m.height;
  }
  return u = Math.max(0, u - i.width), p = Math.max(0, o ? u / o : p - i.height), u = Vs(Math.min(u, l, d.maxWidth)), p = Vs(Math.min(p, c, d.maxHeight)), u && !p && (p = Vs(u / 2)), (t !== void 0 || n !== void 0) && o && d.height && p > d.height && (p = d.height, u = Vs(Math.floor(p * o))), {
    width: u,
    height: p
  };
}
a(ay, "getMaximumSize");
function k4(e, t, n) {
  const o = t || 1, r = Math.floor(e.height * o), i = Math.floor(e.width * o);
  e.height = Math.floor(e.height), e.width = Math.floor(e.width);
  const l = e.canvas;
  return l.style && (n || !l.style.height && !l.style.width) && (l.style.height = `${e.height}px`, l.style.width = `${e.width}px`), e.currentDevicePixelRatio !== o || l.height !== r || l.width !== i ? (e.currentDevicePixelRatio = o, l.height = r, l.width = i, e.ctx.setTransform(o, 0, 0, o, 0, 0), !0) : !1;
}
a(k4, "retinaScale");
const ly = function() {
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    };
    o2() && (window.addEventListener("test", null, t), window.removeEventListener("test", null, t));
  } catch {
  }
  return e;
}();
function O4(e, t) {
  const n = ny(e, t), o = n && n.match(/^(\d+)(\.\d+)?px$/);
  return o ? +o[1] : void 0;
}
a(O4, "readUsedSize");
function Wo(e, t, n, o) {
  return {
    x: e.x + n * (t.x - e.x),
    y: e.y + n * (t.y - e.y)
  };
}
a(Wo, "_pointInLine");
function cy(e, t, n, o) {
  return {
    x: e.x + n * (t.x - e.x),
    y: o === "middle" ? n < 0.5 ? e.y : t.y : o === "after" ? n < 1 ? e.y : t.y : n > 0 ? t.y : e.y
  };
}
a(cy, "_steppedInterpolation");
function dy(e, t, n, o) {
  const r = {
    x: e.cp2x,
    y: e.cp2y
  }, i = {
    x: t.cp1x,
    y: t.cp1y
  }, l = Wo(e, r, n), c = Wo(r, i, n), d = Wo(i, t, n), u = Wo(l, c, n), p = Wo(c, d, n);
  return Wo(u, p, n);
}
a(dy, "_bezierInterpolation");
const uy = /* @__PURE__ */ a(function(e, t) {
  return {
    x(n) {
      return e + e + t - n;
    },
    setWidth(n) {
      t = n;
    },
    textAlign(n) {
      return n === "center" ? n : n === "right" ? "left" : "right";
    },
    xPlus(n, o) {
      return n - o;
    },
    leftForLtr(n, o) {
      return n - o;
    }
  };
}, "getRightToLeftAdapter"), py = /* @__PURE__ */ a(function() {
  return {
    x(e) {
      return e;
    },
    setWidth(e) {
    },
    textAlign(e) {
      return e;
    },
    xPlus(e, t) {
      return e + t;
    },
    leftForLtr(e, t) {
      return e;
    }
  };
}, "getLeftToRightAdapter");
function Or(e, t, n) {
  return e ? uy(t, n) : py();
}
a(Or, "getRtlAdapter");
function Gd(e, t) {
  let n, o;
  (t === "ltr" || t === "rtl") && (n = e.canvas.style, o = [
    n.getPropertyValue("direction"),
    n.getPropertyPriority("direction")
  ], n.setProperty("direction", t, "important"), e.prevTextDirection = o);
}
a(Gd, "overrideTextDirection");
function Yd(e, t) {
  t !== void 0 && (delete e.prevTextDirection, e.canvas.style.setProperty("direction", t[0], t[1]));
}
a(Yd, "restoreTextDirection");
function qd(e) {
  return e === "angle" ? {
    between: qi,
    compare: pC,
    normalize: Pn
  } : {
    between: wo,
    compare: /* @__PURE__ */ a((t, n) => t - n, "compare"),
    normalize: /* @__PURE__ */ a((t) => t, "normalize")
  };
}
a(qd, "propertyFn");
function E4({ start: e, end: t, count: n, loop: o, style: r }) {
  return {
    start: e % n,
    end: t % n,
    loop: o && (t - e + 1) % n === 0,
    style: r
  };
}
a(E4, "normalizeSegment");
function fy(e, t, n) {
  const { property: o, start: r, end: i } = n, { between: l, normalize: c } = qd(o), d = t.length;
  let { start: u, end: p, loop: f } = e, m, b;
  if (f) {
    for (u += d, p += d, m = 0, b = d; m < b && l(c(t[u % d][o]), r, i); ++m)
      u--, p--;
    u %= d, p %= d;
  }
  return p < u && (p += d), {
    start: u,
    end: p,
    loop: f,
    style: e.style
  };
}
a(fy, "getSegment");
function hy(e, t, n) {
  if (!n)
    return [
      e
    ];
  const { property: o, start: r, end: i } = n, l = t.length, { compare: c, between: d, normalize: u } = qd(o), { start: p, end: f, loop: m, style: b } = fy(e, t, n), C = [];
  let g = !1, y = null, w, T, x;
  const S = /* @__PURE__ */ a(() => d(r, x, w) && c(r, x) !== 0, "startIsBefore"), M = /* @__PURE__ */ a(() => c(i, w) === 0 || d(i, x, w), "endIsBefore"), O = /* @__PURE__ */ a(() => g || S(), "shouldStart"), P = /* @__PURE__ */ a(() => !g || M(), "shouldStop");
  for (let E = p, I = p; E <= f; ++E)
    T = t[E % l], !T.skip && (w = u(T[o]), w !== x && (g = d(w, r, i), y === null && O() && (y = c(w, r) === 0 ? E : I), y !== null && P() && (C.push(E4({
      start: y,
      end: E,
      loop: m,
      count: l,
      style: b
    })), y = null), I = E, x = w));
  return y !== null && C.push(E4({
    start: y,
    end: f,
    loop: m,
    count: l,
    style: b
  })), C;
}
a(hy, "_boundSegment");
function gy(e, t) {
  const n = [], o = e.segments;
  for (let r = 0; r < o.length; r++) {
    const i = hy(o[r], e.points, t);
    i.length && n.push(...i);
  }
  return n;
}
a(gy, "_boundSegments");
function my(e, t, n, o) {
  let r = 0, i = t - 1;
  if (n && !o)
    for (; r < t && !e[r].skip; )
      r++;
  for (; r < t && e[r].skip; )
    r++;
  for (r %= t, n && (i += r); i > r && e[i % t].skip; )
    i--;
  return i %= t, {
    start: r,
    end: i
  };
}
a(my, "findStartAndEnd");
function by(e, t, n, o) {
  const r = e.length, i = [];
  let l = t, c = e[t], d;
  for (d = t + 1; d <= n; ++d) {
    const u = e[d % r];
    u.skip || u.stop ? c.skip || (o = !1, i.push({
      start: t % r,
      end: (d - 1) % r,
      loop: o
    }), t = l = u.stop ? d : null) : (l = d, c.skip && (t = d)), c = u;
  }
  return l !== null && i.push({
    start: t % r,
    end: l % r,
    loop: o
  }), i;
}
a(by, "solidSegments");
function Cy(e, t) {
  const n = e.points, o = e.options.spanGaps, r = n.length;
  if (!r)
    return [];
  const i = !!e._loop, { start: l, end: c } = my(n, r, i, o);
  if (o === !0)
    return $4(e, [
      {
        start: l,
        end: c,
        loop: i
      }
    ], n, t);
  const d = c < l ? c + r : c, u = !!e._fullLoop && l === 0 && c === r - 1;
  return $4(e, by(n, l, d, u), n, t);
}
a(Cy, "_computeSegments");
function $4(e, t, n, o) {
  return !o || !o.setContext || !n ? t : yy(e, t, n, o);
}
a($4, "splitByStyles");
function yy(e, t, n, o) {
  const r = e._chart.getContext(), i = P4(e.options), { _datasetIndex: l, options: { spanGaps: c } } = e, d = n.length, u = [];
  let p = i, f = t[0].start, m = f;
  function b(C, g, y, w) {
    const T = c ? -1 : 1;
    if (C !== g) {
      for (C += d; n[C % d].skip; )
        C -= T;
      for (; n[g % d].skip; )
        g += T;
      C % d !== g % d && (u.push({
        start: C % d,
        end: g % d,
        loop: y,
        style: w
      }), p = w, f = g % d);
    }
  }
  a(b, "addStyle");
  for (const C of t) {
    f = c ? f : C.start;
    let g = n[f % d], y;
    for (m = f + 1; m <= C.end; m++) {
      const w = n[m % d];
      y = P4(o.setContext(lr(r, {
        type: "segment",
        p0: g,
        p1: w,
        p0DataIndex: (m - 1) % d,
        p1DataIndex: m % d,
        datasetIndex: l
      }))), xy(y, p) && b(f, m - 1, C.loop, p), g = w, p = y;
    }
    f < m - 1 && b(f, m - 1, C.loop, p);
  }
  return u;
}
a(yy, "doSplitByStyles");
function P4(e) {
  return {
    backgroundColor: e.backgroundColor,
    borderCapStyle: e.borderCapStyle,
    borderDash: e.borderDash,
    borderDashOffset: e.borderDashOffset,
    borderJoinStyle: e.borderJoinStyle,
    borderWidth: e.borderWidth,
    borderColor: e.borderColor
  };
}
a(P4, "readStyle");
function xy(e, t) {
  if (!t)
    return !1;
  const n = [], o = /* @__PURE__ */ a(function(r, i) {
    return qc(i) ? (n.includes(i) || n.push(i), n.indexOf(i)) : i;
  }, "replacer");
  return JSON.stringify(e, o) !== JSON.stringify(t, o);
}
a(xy, "styleChanged");
function As(e, t, n) {
  return e.options.clip ? e[n] : t[n];
}
a(As, "getSizeForArea");
function vy(e, t) {
  const { xScale: n, yScale: o } = e;
  return n && o ? {
    left: As(n, t, "left"),
    right: As(n, t, "right"),
    top: As(o, t, "top"),
    bottom: As(o, t, "bottom")
  } : t;
}
a(vy, "getDatasetArea");
function wy(e, t) {
  const n = t._clip;
  if (n.disabled)
    return !1;
  const o = vy(t, e.chartArea);
  return {
    left: n.left === !1 ? 0 : o.left - (n.left === !0 ? 0 : n.left),
    right: n.right === !1 ? e.width : o.right + (n.right === !0 ? 0 : n.right),
    top: n.top === !1 ? 0 : o.top - (n.top === !0 ? 0 : n.top),
    bottom: n.bottom === !1 ? e.height : o.bottom + (n.bottom === !0 ? 0 : n.bottom)
  };
}
a(wy, "getDatasetClipArea");
/*!
 * Chart.js v4.5.0
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
const l2 = class l2 {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(t, n, o, r) {
    const i = n.listeners[r], l = n.duration;
    i.forEach((c) => c({
      chart: t,
      initial: n.initial,
      numSteps: l,
      currentStep: Math.min(o - n.start, l)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = Ad.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(t = Date.now()) {
    let n = 0;
    this._charts.forEach((o, r) => {
      if (!o.running || !o.items.length)
        return;
      const i = o.items;
      let l = i.length - 1, c = !1, d;
      for (; l >= 0; --l)
        d = i[l], d._active ? (d._total > o.duration && (o.duration = d._total), d.tick(t), c = !0) : (i[l] = i[i.length - 1], i.pop());
      c && (r.draw(), this._notify(r, o, t, "progress")), i.length || (o.running = !1, this._notify(r, o, t, "complete"), o.initial = !1), n += i.length;
    }), this._lastDate = t, n === 0 && (this._running = !1);
  }
  _getAnims(t) {
    const n = this._charts;
    let o = n.get(t);
    return o || (o = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, n.set(t, o)), o;
  }
  listen(t, n, o) {
    this._getAnims(t).listeners[n].push(o);
  }
  add(t, n) {
    !n || !n.length || this._getAnims(t).items.push(...n);
  }
  has(t) {
    return this._getAnims(t).items.length > 0;
  }
  start(t) {
    const n = this._charts.get(t);
    n && (n.running = !0, n.start = Date.now(), n.duration = n.items.reduce((o, r) => Math.max(o, r._duration), 0), this._refresh());
  }
  running(t) {
    if (!this._running)
      return !1;
    const n = this._charts.get(t);
    return !(!n || !n.running || !n.items.length);
  }
  stop(t) {
    const n = this._charts.get(t);
    if (!n || !n.items.length)
      return;
    const o = n.items;
    let r = o.length - 1;
    for (; r >= 0; --r)
      o[r].cancel();
    n.items = [], this._notify(t, n, Date.now(), "complete");
  }
  remove(t) {
    return this._charts.delete(t);
  }
};
a(l2, "Animator");
let j1 = l2;
var no = /* @__PURE__ */ new j1();
const _4 = "transparent", Sy = {
  boolean(e, t, n) {
    return n > 0.5 ? t : e;
  },
  color(e, t, n) {
    const o = x4(e || _4), r = o.valid && x4(t || _4);
    return r && r.valid ? r.mix(o, n).hexString() : t;
  },
  number(e, t, n) {
    return e + (t - e) * n;
  }
}, c2 = class c2 {
  constructor(t, n, o, r) {
    const i = n[o];
    r = dt([
      t.to,
      r,
      i,
      t.from
    ]);
    const l = dt([
      t.from,
      i,
      r
    ]);
    this._active = !0, this._fn = t.fn || Sy[t.type || typeof l], this._easing = Ti[t.easing] || Ti.linear, this._start = Math.floor(Date.now() + (t.delay || 0)), this._duration = this._total = Math.floor(t.duration), this._loop = !!t.loop, this._target = n, this._prop = o, this._from = l, this._to = r, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(t, n, o) {
    if (this._active) {
      this._notify(!1);
      const r = this._target[this._prop], i = o - this._start, l = this._duration - i;
      this._start = o, this._duration = Math.floor(Math.max(l, t.duration)), this._total += i, this._loop = !!t.loop, this._to = dt([
        t.to,
        n,
        r,
        t.from
      ]), this._from = dt([
        t.from,
        r,
        n
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(t) {
    const n = t - this._start, o = this._duration, r = this._prop, i = this._from, l = this._loop, c = this._to;
    let d;
    if (this._active = i !== c && (l || n < o), !this._active) {
      this._target[r] = c, this._notify(!0);
      return;
    }
    if (n < 0) {
      this._target[r] = i;
      return;
    }
    d = n / o % 2, d = l && d > 1 ? 2 - d : d, d = this._easing(Math.min(1, Math.max(0, d))), this._target[r] = this._fn(i, c, d);
  }
  wait() {
    const t = this._promises || (this._promises = []);
    return new Promise((n, o) => {
      t.push({
        res: n,
        rej: o
      });
    });
  }
  _notify(t) {
    const n = t ? "res" : "rej", o = this._promises || [];
    for (let r = 0; r < o.length; r++)
      o[r][n]();
  }
};
a(c2, "Animation");
let L1 = c2;
const d2 = class d2 {
  constructor(t, n) {
    this._chart = t, this._properties = /* @__PURE__ */ new Map(), this.configure(n);
  }
  configure(t) {
    if (!Ne(t))
      return;
    const n = Object.keys(yt.animation), o = this._properties;
    Object.getOwnPropertyNames(t).forEach((r) => {
      const i = t[r];
      if (!Ne(i))
        return;
      const l = {};
      for (const c of n)
        l[c] = i[c];
      (Et(i.properties) && i.properties || [
        r
      ]).forEach((c) => {
        (c === r || !o.has(c)) && o.set(c, l);
      });
    });
  }
  _animateOptions(t, n) {
    const o = n.options, r = Ty(t, o);
    if (!r)
      return [];
    const i = this._createAnimations(r, o);
    return o.$shared && My(t.options.$animations, o).then(() => {
      t.options = o;
    }, () => {
    }), i;
  }
  _createAnimations(t, n) {
    const o = this._properties, r = [], i = t.$animations || (t.$animations = {}), l = Object.keys(n), c = Date.now();
    let d;
    for (d = l.length - 1; d >= 0; --d) {
      const u = l[d];
      if (u.charAt(0) === "$")
        continue;
      if (u === "options") {
        r.push(...this._animateOptions(t, n));
        continue;
      }
      const p = n[u];
      let f = i[u];
      const m = o.get(u);
      if (f)
        if (m && f.active()) {
          f.update(m, p, c);
          continue;
        } else
          f.cancel();
      if (!m || !m.duration) {
        t[u] = p;
        continue;
      }
      i[u] = f = new L1(m, t, u, p), r.push(f);
    }
    return r;
  }
  update(t, n) {
    if (this._properties.size === 0) {
      Object.assign(t, n);
      return;
    }
    const o = this._createAnimations(t, n);
    if (o.length)
      return no.add(this._chart, o), !0;
  }
};
a(d2, "Animations");
let Oa = d2;
function My(e, t) {
  const n = [], o = Object.keys(t);
  for (let r = 0; r < o.length; r++) {
    const i = e[o[r]];
    i && i.active() && n.push(i.wait());
  }
  return Promise.all(n);
}
a(My, "awaitAll");
function Ty(e, t) {
  if (!t)
    return;
  let n = e.options;
  if (!n) {
    e.options = t;
    return;
  }
  return n.$shared && (e.options = n = Object.assign({}, n, {
    $shared: !1,
    $animations: {}
  })), n;
}
a(Ty, "resolveTargetOptions");
function R4(e, t) {
  const n = e && e.options || {}, o = n.reverse, r = n.min === void 0 ? t : 0, i = n.max === void 0 ? t : 0;
  return {
    start: o ? i : r,
    end: o ? r : i
  };
}
a(R4, "scaleClip");
function ky(e, t, n) {
  if (n === !1)
    return !1;
  const o = R4(e, n), r = R4(t, n);
  return {
    top: r.end,
    right: o.end,
    bottom: r.start,
    left: o.start
  };
}
a(ky, "defaultClip");
function Oy(e) {
  let t, n, o, r;
  return Ne(e) ? (t = e.top, n = e.right, o = e.bottom, r = e.left) : t = n = o = r = e, {
    top: t,
    right: n,
    bottom: o,
    left: r,
    disabled: e === !1
  };
}
a(Oy, "toClip");
function Kd(e, t) {
  const n = [], o = e._getSortedDatasetMetas(t);
  let r, i;
  for (r = 0, i = o.length; r < i; ++r)
    n.push(o[r].index);
  return n;
}
a(Kd, "getSortedDatasetIndices");
function I4(e, t, n, o = {}) {
  const r = e.keys, i = o.mode === "single";
  let l, c, d, u;
  if (t === null)
    return;
  let p = !1;
  for (l = 0, c = r.length; l < c; ++l) {
    if (d = +r[l], d === n) {
      if (p = !0, o.all)
        continue;
      break;
    }
    u = e.values[d], Tn(u) && (i || t === 0 || Yn(t) === Yn(u)) && (t += u);
  }
  return !p && !o.all ? 0 : t;
}
a(I4, "applyStack");
function Ey(e, t) {
  const { iScale: n, vScale: o } = t, r = n.axis === "x" ? "x" : "y", i = o.axis === "x" ? "x" : "y", l = Object.keys(e), c = new Array(l.length);
  let d, u, p;
  for (d = 0, u = l.length; d < u; ++d)
    p = l[d], c[d] = {
      [r]: p,
      [i]: e[p]
    };
  return c;
}
a(Ey, "convertObjectDataToArray");
function ql(e, t) {
  const n = e && e.options.stacked;
  return n || n === void 0 && t.stack !== void 0;
}
a(ql, "isStacked");
function $y(e, t, n) {
  return `${e.id}.${t.id}.${n.stack || n.type}`;
}
a($y, "getStackKey");
function Py(e) {
  const { min: t, max: n, minDefined: o, maxDefined: r } = e.getUserBounds();
  return {
    min: o ? t : Number.NEGATIVE_INFINITY,
    max: r ? n : Number.POSITIVE_INFINITY
  };
}
a(Py, "getUserBounds");
function _y(e, t, n) {
  const o = e[t] || (e[t] = {});
  return o[n] || (o[n] = {});
}
a(_y, "getOrCreateStack");
function j4(e, t, n, o) {
  for (const r of t.getMatchingVisibleMetas(o).reverse()) {
    const i = e[r.index];
    if (n && i > 0 || !n && i < 0)
      return r.index;
  }
  return null;
}
a(j4, "getLastIndexInStack");
function L4(e, t) {
  const { chart: n, _cachedMeta: o } = e, r = n._stacks || (n._stacks = {}), { iScale: i, vScale: l, index: c } = o, d = i.axis, u = l.axis, p = $y(i, l, o), f = t.length;
  let m;
  for (let b = 0; b < f; ++b) {
    const C = t[b], { [d]: g, [u]: y } = C, w = C._stacks || (C._stacks = {});
    m = w[u] = _y(r, p, g), m[c] = y, m._top = j4(m, l, !0, o.type), m._bottom = j4(m, l, !1, o.type);
    const T = m._visualValues || (m._visualValues = {});
    T[c] = y;
  }
}
a(L4, "updateStacks");
function Kl(e, t) {
  const n = e.scales;
  return Object.keys(n).filter((o) => n[o].axis === t).shift();
}
a(Kl, "getFirstScaleId");
function Ry(e, t) {
  return lr(e, {
    active: !1,
    dataset: void 0,
    datasetIndex: t,
    index: t,
    mode: "default",
    type: "dataset"
  });
}
a(Ry, "createDatasetContext");
function Iy(e, t, n) {
  return lr(e, {
    active: !1,
    dataIndex: t,
    parsed: void 0,
    raw: void 0,
    element: n,
    index: t,
    mode: "default",
    type: "data"
  });
}
a(Iy, "createDataContext");
function ni(e, t) {
  const n = e.controller.index, o = e.vScale && e.vScale.axis;
  if (o) {
    t = t || e._parsed;
    for (const r of t) {
      const i = r._stacks;
      if (!i || i[o] === void 0 || i[o][n] === void 0)
        return;
      delete i[o][n], i[o]._visualValues !== void 0 && i[o]._visualValues[n] !== void 0 && delete i[o]._visualValues[n];
    }
  }
}
a(ni, "clearStacks");
const Xl = /* @__PURE__ */ a((e) => e === "reset" || e === "none", "isDirectUpdateMode"), V4 = /* @__PURE__ */ a((e, t) => t ? e : Object.assign({}, e), "cloneIfNotShared"), jy = /* @__PURE__ */ a((e, t, n) => e && !t.hidden && t._stacked && {
  keys: Kd(n, !0),
  values: null
}, "createStack"), yr = class yr {
  constructor(t, n) {
    this.chart = t, this._ctx = t.ctx, this.index = n, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const t = this._cachedMeta;
    this.configure(), this.linkScales(), t._stacked = ql(t.vScale, t), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(t) {
    this.index !== t && ni(this._cachedMeta), this.index = t;
  }
  linkScales() {
    const t = this.chart, n = this._cachedMeta, o = this.getDataset(), r = /* @__PURE__ */ a((f, m, b, C) => f === "x" ? m : f === "r" ? C : b, "chooseId"), i = n.xAxisID = je(o.xAxisID, Kl(t, "x")), l = n.yAxisID = je(o.yAxisID, Kl(t, "y")), c = n.rAxisID = je(o.rAxisID, Kl(t, "r")), d = n.indexAxis, u = n.iAxisID = r(d, i, l, c), p = n.vAxisID = r(d, l, i, c);
    n.xScale = this.getScaleForId(i), n.yScale = this.getScaleForId(l), n.rScale = this.getScaleForId(c), n.iScale = this.getScaleForId(u), n.vScale = this.getScaleForId(p);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(t) {
    return this.chart.scales[t];
  }
  _getOtherScale(t) {
    const n = this._cachedMeta;
    return t === n.iScale ? n.vScale : n.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const t = this._cachedMeta;
    this._data && b4(this._data, this), t._stacked && ni(t);
  }
  _dataCheck() {
    const t = this.getDataset(), n = t.data || (t.data = []), o = this._data;
    if (Ne(n)) {
      const r = this._cachedMeta;
      this._data = Ey(n, r);
    } else if (o !== n) {
      if (o) {
        b4(o, this);
        const r = this._cachedMeta;
        ni(r), r._parsed = [];
      }
      n && Object.isExtensible(n) && mC(n, this), this._syncList = [], this._data = n;
    }
  }
  addElements() {
    const t = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (t.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(t) {
    const n = this._cachedMeta, o = this.getDataset();
    let r = !1;
    this._dataCheck();
    const i = n._stacked;
    n._stacked = ql(n.vScale, n), n.stack !== o.stack && (r = !0, ni(n), n.stack = o.stack), this._resyncElements(t), (r || i !== n._stacked) && (L4(this, n._parsed), n._stacked = ql(n.vScale, n));
  }
  configure() {
    const t = this.chart.config, n = t.datasetScopeKeys(this._type), o = t.getOptionScopes(this.getDataset(), n, !0);
    this.options = t.createResolver(o, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(t, n) {
    const { _cachedMeta: o, _data: r } = this, { iScale: i, _stacked: l } = o, c = i.axis;
    let d = t === 0 && n === r.length ? !0 : o._sorted, u = t > 0 && o._parsed[t - 1], p, f, m;
    if (this._parsing === !1)
      o._parsed = r, o._sorted = !0, m = r;
    else {
      Et(r[t]) ? m = this.parseArrayData(o, r, t, n) : Ne(r[t]) ? m = this.parseObjectData(o, r, t, n) : m = this.parsePrimitiveData(o, r, t, n);
      const b = /* @__PURE__ */ a(() => f[c] === null || u && f[c] < u[c], "isNotInOrderComparedToPrev");
      for (p = 0; p < n; ++p)
        o._parsed[p + t] = f = m[p], d && (b() && (d = !1), u = f);
      o._sorted = d;
    }
    l && L4(this, m);
  }
  parsePrimitiveData(t, n, o, r) {
    const { iScale: i, vScale: l } = t, c = i.axis, d = l.axis, u = i.getLabels(), p = i === l, f = new Array(r);
    let m, b, C;
    for (m = 0, b = r; m < b; ++m)
      C = m + o, f[m] = {
        [c]: p || i.parse(u[C], C),
        [d]: l.parse(n[C], C)
      };
    return f;
  }
  parseArrayData(t, n, o, r) {
    const { xScale: i, yScale: l } = t, c = new Array(r);
    let d, u, p, f;
    for (d = 0, u = r; d < u; ++d)
      p = d + o, f = n[p], c[d] = {
        x: i.parse(f[0], p),
        y: l.parse(f[1], p)
      };
    return c;
  }
  parseObjectData(t, n, o, r) {
    const { xScale: i, yScale: l } = t, { xAxisKey: c = "x", yAxisKey: d = "y" } = this._parsing, u = new Array(r);
    let p, f, m, b;
    for (p = 0, f = r; p < f; ++p)
      m = p + o, b = n[m], u[p] = {
        x: i.parse(or(b, c), m),
        y: l.parse(or(b, d), m)
      };
    return u;
  }
  getParsed(t) {
    return this._cachedMeta._parsed[t];
  }
  getDataElement(t) {
    return this._cachedMeta.data[t];
  }
  applyStack(t, n, o) {
    const r = this.chart, i = this._cachedMeta, l = n[t.axis], c = {
      keys: Kd(r, !0),
      values: n._stacks[t.axis]._visualValues
    };
    return I4(c, l, i.index, {
      mode: o
    });
  }
  updateRangeFromParsed(t, n, o, r) {
    const i = o[n.axis];
    let l = i === null ? NaN : i;
    const c = r && o._stacks[n.axis];
    r && c && (r.values = c, l = I4(r, i, this._cachedMeta.index)), t.min = Math.min(t.min, l), t.max = Math.max(t.max, l);
  }
  getMinMax(t, n) {
    const o = this._cachedMeta, r = o._parsed, i = o._sorted && t === o.iScale, l = r.length, c = this._getOtherScale(t), d = jy(n, o, this.chart), u = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: p, max: f } = Py(c);
    let m, b;
    function C() {
      b = r[m];
      const g = b[c.axis];
      return !Tn(b[t.axis]) || p > g || f < g;
    }
    for (a(C, "_skip"), m = 0; m < l && !(!C() && (this.updateRangeFromParsed(u, t, b, d), i)); ++m)
      ;
    if (i) {
      for (m = l - 1; m >= 0; --m)
        if (!C()) {
          this.updateRangeFromParsed(u, t, b, d);
          break;
        }
    }
    return u;
  }
  getAllParsedValues(t) {
    const n = this._cachedMeta._parsed, o = [];
    let r, i, l;
    for (r = 0, i = n.length; r < i; ++r)
      l = n[r][t.axis], Tn(l) && o.push(l);
    return o;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, o = n.iScale, r = n.vScale, i = this.getParsed(t);
    return {
      label: o ? "" + o.getLabelForValue(i[o.axis]) : "",
      value: r ? "" + r.getLabelForValue(i[r.axis]) : ""
    };
  }
  _update(t) {
    const n = this._cachedMeta;
    this.update(t || "default"), n._clip = Oy(je(this.options.clip, ky(n.xScale, n.yScale, this.getMaxOverflow())));
  }
  update(t) {
  }
  draw() {
    const t = this._ctx, n = this.chart, o = this._cachedMeta, r = o.data || [], i = n.chartArea, l = [], c = this._drawStart || 0, d = this._drawCount || r.length - c, u = this.options.drawActiveElementsOnTop;
    let p;
    for (o.dataset && o.dataset.draw(t, i, c, d), p = c; p < c + d; ++p) {
      const f = r[p];
      f.hidden || (f.active && u ? l.push(f) : f.draw(t, i));
    }
    for (p = 0; p < l.length; ++p)
      l[p].draw(t, i);
  }
  getStyle(t, n) {
    const o = n ? "active" : "default";
    return t === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(o) : this.resolveDataElementOptions(t || 0, o);
  }
  getContext(t, n, o) {
    const r = this.getDataset();
    let i;
    if (t >= 0 && t < this._cachedMeta.data.length) {
      const l = this._cachedMeta.data[t];
      i = l.$context || (l.$context = Iy(this.getContext(), t, l)), i.parsed = this.getParsed(t), i.raw = r.data[t], i.index = i.dataIndex = t;
    } else
      i = this.$context || (this.$context = Ry(this.chart.getContext(), this.index)), i.dataset = r, i.index = i.datasetIndex = this.index;
    return i.active = !!n, i.mode = o, i;
  }
  resolveDatasetElementOptions(t) {
    return this._resolveElementOptions(this.datasetElementType.id, t);
  }
  resolveDataElementOptions(t, n) {
    return this._resolveElementOptions(this.dataElementType.id, n, t);
  }
  _resolveElementOptions(t, n = "default", o) {
    const r = n === "active", i = this._cachedDataOpts, l = t + "-" + n, c = i[l], d = this.enableOptionSharing && Gi(o);
    if (c)
      return V4(c, d);
    const u = this.chart.config, p = u.datasetElementScopeKeys(this._type, t), f = r ? [
      `${t}Hover`,
      "hover",
      t,
      ""
    ] : [
      t,
      ""
    ], m = u.getOptionScopes(this.getDataset(), p), b = Object.keys(yt.elements[t]), C = /* @__PURE__ */ a(() => this.getContext(o, r, n), "context"), g = u.resolveNamedOptions(m, b, C, f);
    return g.$shared && (g.$shared = d, i[l] = Object.freeze(V4(g, d))), g;
  }
  _resolveAnimations(t, n, o) {
    const r = this.chart, i = this._cachedDataOpts, l = `animation-${n}`, c = i[l];
    if (c)
      return c;
    let d;
    if (r.options.animation !== !1) {
      const p = this.chart.config, f = p.datasetAnimationScopeKeys(this._type, n), m = p.getOptionScopes(this.getDataset(), f);
      d = p.createResolver(m, this.getContext(t, o, n));
    }
    const u = new Oa(r, d && d.animations);
    return d && d._cacheable && (i[l] = Object.freeze(u)), u;
  }
  getSharedOptions(t) {
    if (t.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, t));
  }
  includeOptions(t, n) {
    return !n || Xl(t) || this.chart._animationsDisabled;
  }
  _getSharedOptions(t, n) {
    const o = this.resolveDataElementOptions(t, n), r = this._sharedOptions, i = this.getSharedOptions(o), l = this.includeOptions(n, i) || i !== r;
    return this.updateSharedOptions(i, n, o), {
      sharedOptions: i,
      includeOptions: l
    };
  }
  updateElement(t, n, o, r) {
    Xl(r) ? Object.assign(t, o) : this._resolveAnimations(n, r).update(t, o);
  }
  updateSharedOptions(t, n, o) {
    t && !Xl(n) && this._resolveAnimations(void 0, n).update(t, o);
  }
  _setStyle(t, n, o, r) {
    t.active = r;
    const i = this.getStyle(n, r);
    this._resolveAnimations(n, o, r).update(t, {
      options: !r && this.getSharedOptions(i) || i
    });
  }
  removeHoverStyle(t, n, o) {
    this._setStyle(t, o, "active", !1);
  }
  setHoverStyle(t, n, o) {
    this._setStyle(t, o, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !0);
  }
  _resyncElements(t) {
    const n = this._data, o = this._cachedMeta.data;
    for (const [c, d, u] of this._syncList)
      this[c](d, u);
    this._syncList = [];
    const r = o.length, i = n.length, l = Math.min(i, r);
    l && this.parse(0, l), i > r ? this._insertElements(r, i - r, t) : i < r && this._removeElements(i, r - i);
  }
  _insertElements(t, n, o = !0) {
    const r = this._cachedMeta, i = r.data, l = t + n;
    let c;
    const d = /* @__PURE__ */ a((u) => {
      for (u.length += n, c = u.length - 1; c >= l; c--)
        u[c] = u[c - n];
    }, "move");
    for (d(i), c = t; c < l; ++c)
      i[c] = new this.dataElementType();
    this._parsing && d(r._parsed), this.parse(t, n), o && this.updateElements(i, t, n, "reset");
  }
  updateElements(t, n, o, r) {
  }
  _removeElements(t, n) {
    const o = this._cachedMeta;
    if (this._parsing) {
      const r = o._parsed.splice(t, n);
      o._stacked && ni(o, r);
    }
    o.data.splice(t, n);
  }
  _sync(t) {
    if (this._parsing)
      this._syncList.push(t);
    else {
      const [n, o, r] = t;
      this[n](o, r);
    }
    this.chart._dataChanges.push([
      this.index,
      ...t
    ]);
  }
  _onDataPush() {
    const t = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - t,
      t
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(t, n) {
    n && this._sync([
      "_removeElements",
      t,
      n
    ]);
    const o = arguments.length - 2;
    o && this._sync([
      "_insertElements",
      t,
      o
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
};
a(yr, "DatasetController"), pe(yr, "defaults", {}), pe(yr, "datasetElementType", null), pe(yr, "dataElementType", null);
let Ar = yr;
function Ly(e, t) {
  if (!e._cache.$bar) {
    const n = e.getMatchingVisibleMetas(t);
    let o = [];
    for (let r = 0, i = n.length; r < i; r++)
      o = o.concat(n[r].controller.getAllParsedValues(e));
    e._cache.$bar = Vd(o.sort((r, i) => r - i));
  }
  return e._cache.$bar;
}
a(Ly, "getAllScaleValues");
function Vy(e) {
  const t = e.iScale, n = Ly(t, e.type);
  let o = t._length, r, i, l, c;
  const d = /* @__PURE__ */ a(() => {
    l === 32767 || l === -32768 || (Gi(c) && (o = Math.min(o, Math.abs(l - c) || o)), c = l);
  }, "updateMinAndPrev");
  for (r = 0, i = n.length; r < i; ++r)
    l = t.getPixelForValue(n[r]), d();
  for (c = void 0, r = 0, i = t.ticks.length; r < i; ++r)
    l = t.getPixelForTick(r), d();
  return o;
}
a(Vy, "computeMinSampleSize");
function Ay(e, t, n, o) {
  const r = n.barThickness;
  let i, l;
  return He(r) ? (i = t.min * n.categoryPercentage, l = n.barPercentage) : (i = r * o, l = 1), {
    chunk: i / o,
    ratio: l,
    start: t.pixels[e] - i / 2
  };
}
a(Ay, "computeFitCategoryTraits");
function By(e, t, n, o) {
  const r = t.pixels, i = r[e];
  let l = e > 0 ? r[e - 1] : null, c = e < r.length - 1 ? r[e + 1] : null;
  const d = n.categoryPercentage;
  l === null && (l = i - (c === null ? t.end - t.start : c - i)), c === null && (c = i + i - l);
  const u = i - (i - Math.min(l, c)) / 2 * d;
  return {
    chunk: Math.abs(c - l) / 2 * d / o,
    ratio: n.barPercentage,
    start: u
  };
}
a(By, "computeFlexCategoryTraits");
function Hy(e, t, n, o) {
  const r = n.parse(e[0], o), i = n.parse(e[1], o), l = Math.min(r, i), c = Math.max(r, i);
  let d = l, u = c;
  Math.abs(l) > Math.abs(c) && (d = c, u = l), t[n.axis] = u, t._custom = {
    barStart: d,
    barEnd: u,
    start: r,
    end: i,
    min: l,
    max: c
  };
}
a(Hy, "parseFloatBar");
function Xd(e, t, n, o) {
  return Et(e) ? Hy(e, t, n, o) : t[n.axis] = n.parse(e, o), t;
}
a(Xd, "parseValue");
function A4(e, t, n, o) {
  const r = e.iScale, i = e.vScale, l = r.getLabels(), c = r === i, d = [];
  let u, p, f, m;
  for (u = n, p = n + o; u < p; ++u)
    m = t[u], f = {}, f[r.axis] = c || r.parse(l[u], u), d.push(Xd(m, f, i, u));
  return d;
}
a(A4, "parseArrayOrPrimitive");
function Jl(e) {
  return e && e.barStart !== void 0 && e.barEnd !== void 0;
}
a(Jl, "isFloatBar");
function Dy(e, t, n) {
  return e !== 0 ? Yn(e) : (t.isHorizontal() ? 1 : -1) * (t.min >= n ? 1 : -1);
}
a(Dy, "barSign");
function Ny(e) {
  let t, n, o, r, i;
  return e.horizontal ? (t = e.base > e.x, n = "left", o = "right") : (t = e.base < e.y, n = "bottom", o = "top"), t ? (r = "end", i = "start") : (r = "start", i = "end"), {
    start: n,
    end: o,
    reverse: t,
    top: r,
    bottom: i
  };
}
a(Ny, "borderProps");
function zy(e, t, n, o) {
  let r = t.borderSkipped;
  const i = {};
  if (!r) {
    e.borderSkipped = i;
    return;
  }
  if (r === !0) {
    e.borderSkipped = {
      top: !0,
      right: !0,
      bottom: !0,
      left: !0
    };
    return;
  }
  const { start: l, end: c, reverse: d, top: u, bottom: p } = Ny(e);
  r === "middle" && n && (e.enableBorderRadius = !0, (n._top || 0) === o ? r = u : (n._bottom || 0) === o ? r = p : (i[B4(p, l, c, d)] = !0, r = u)), i[B4(r, l, c, d)] = !0, e.borderSkipped = i;
}
a(zy, "setBorderSkipped");
function B4(e, t, n, o) {
  return o ? (e = Fy(e, t, n), e = H4(e, n, t)) : e = H4(e, t, n), e;
}
a(B4, "parseEdge");
function Fy(e, t, n) {
  return e === t ? n : e === n ? t : e;
}
a(Fy, "swap");
function H4(e, t, n) {
  return e === "start" ? t : e === "end" ? n : e;
}
a(H4, "startEnd");
function Wy(e, { inflateAmount: t }, n) {
  e.inflateAmount = t === "auto" ? n === 1 ? 0.33 : 0 : t;
}
a(Wy, "setInflateAmount");
const xr = class xr extends Ar {
  parsePrimitiveData(t, n, o, r) {
    return A4(t, n, o, r);
  }
  parseArrayData(t, n, o, r) {
    return A4(t, n, o, r);
  }
  parseObjectData(t, n, o, r) {
    const { iScale: i, vScale: l } = t, { xAxisKey: c = "x", yAxisKey: d = "y" } = this._parsing, u = i.axis === "x" ? c : d, p = l.axis === "x" ? c : d, f = [];
    let m, b, C, g;
    for (m = o, b = o + r; m < b; ++m)
      g = n[m], C = {}, C[i.axis] = i.parse(or(g, u), m), f.push(Xd(or(g, p), C, l, m));
    return f;
  }
  updateRangeFromParsed(t, n, o, r) {
    super.updateRangeFromParsed(t, n, o, r);
    const i = o._custom;
    i && n === this._cachedMeta.vScale && (t.min = Math.min(t.min, i.min), t.max = Math.max(t.max, i.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, { iScale: o, vScale: r } = n, i = this.getParsed(t), l = i._custom, c = Jl(l) ? "[" + l.start + ", " + l.end + "]" : "" + r.getLabelForValue(i[r.axis]);
    return {
      label: "" + o.getLabelForValue(i[o.axis]),
      value: c
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const t = this._cachedMeta;
    t.stack = this.getDataset().stack;
  }
  update(t) {
    const n = this._cachedMeta;
    this.updateElements(n.data, 0, n.data.length, t);
  }
  updateElements(t, n, o, r) {
    const i = r === "reset", { index: l, _cachedMeta: { vScale: c } } = this, d = c.getBasePixel(), u = c.isHorizontal(), p = this._getRuler(), { sharedOptions: f, includeOptions: m } = this._getSharedOptions(n, r);
    for (let b = n; b < n + o; b++) {
      const C = this.getParsed(b), g = i || He(C[c.axis]) ? {
        base: d,
        head: d
      } : this._calculateBarValuePixels(b), y = this._calculateBarIndexPixels(b, p), w = (C._stacks || {})[c.axis], T = {
        horizontal: u,
        base: g.base,
        enableBorderRadius: !w || Jl(C._custom) || l === w._top || l === w._bottom,
        x: u ? g.head : y.center,
        y: u ? y.center : g.head,
        height: u ? y.size : Math.abs(g.size),
        width: u ? Math.abs(g.size) : y.size
      };
      m && (T.options = f || this.resolveDataElementOptions(b, t[b].active ? "active" : r));
      const x = T.options || t[b].options;
      zy(T, x, w, l), Wy(T, x, p.ratio), this.updateElement(t[b], b, T, r);
    }
  }
  _getStacks(t, n) {
    const { iScale: o } = this._cachedMeta, r = o.getMatchingVisibleMetas(this._type).filter((p) => p.controller.options.grouped), i = o.options.stacked, l = [], c = this._cachedMeta.controller.getParsed(n), d = c && c[o.axis], u = /* @__PURE__ */ a((p) => {
      const f = p._parsed.find((b) => b[o.axis] === d), m = f && f[p.vScale.axis];
      if (He(m) || isNaN(m))
        return !0;
    }, "skipNull");
    for (const p of r)
      if (!(n !== void 0 && u(p)) && ((i === !1 || l.indexOf(p.stack) === -1 || i === void 0 && p.stack === void 0) && l.push(p.stack), p.index === t))
        break;
    return l.length || l.push(void 0), l;
  }
  _getStackCount(t) {
    return this._getStacks(void 0, t).length;
  }
  _getAxisCount() {
    return this._getAxis().length;
  }
  getFirstScaleIdForIndexAxis() {
    const t = this.chart.scales, n = this.chart.options.indexAxis;
    return Object.keys(t).filter((o) => t[o].axis === n).shift();
  }
  _getAxis() {
    const t = {}, n = this.getFirstScaleIdForIndexAxis();
    for (const o of this.chart.data.datasets)
      t[je(this.chart.options.indexAxis === "x" ? o.xAxisID : o.yAxisID, n)] = !0;
    return Object.keys(t);
  }
  _getStackIndex(t, n, o) {
    const r = this._getStacks(t, o), i = n !== void 0 ? r.indexOf(n) : -1;
    return i === -1 ? r.length - 1 : i;
  }
  _getRuler() {
    const t = this.options, n = this._cachedMeta, o = n.iScale, r = [];
    let i, l;
    for (i = 0, l = n.data.length; i < l; ++i)
      r.push(o.getPixelForValue(this.getParsed(i)[o.axis], i));
    const c = t.barThickness;
    return {
      min: c || Vy(n),
      pixels: r,
      start: o._startPixel,
      end: o._endPixel,
      stackCount: this._getStackCount(),
      scale: o,
      grouped: t.grouped,
      ratio: c ? 1 : t.categoryPercentage * t.barPercentage
    };
  }
  _calculateBarValuePixels(t) {
    const { _cachedMeta: { vScale: n, _stacked: o, index: r }, options: { base: i, minBarLength: l } } = this, c = i || 0, d = this.getParsed(t), u = d._custom, p = Jl(u);
    let f = d[n.axis], m = 0, b = o ? this.applyStack(n, d, o) : f, C, g;
    b !== f && (m = b - f, b = f), p && (f = u.barStart, b = u.barEnd - u.barStart, f !== 0 && Yn(f) !== Yn(u.barEnd) && (m = 0), m += f);
    const y = !He(i) && !p ? i : m;
    let w = n.getPixelForValue(y);
    if (this.chart.getDataVisibility(t) ? C = n.getPixelForValue(m + b) : C = w, g = C - w, Math.abs(g) < l) {
      g = Dy(g, n, c) * l, f === c && (w -= g / 2);
      const T = n.getPixelForDecimal(0), x = n.getPixelForDecimal(1), S = Math.min(T, x), M = Math.max(T, x);
      w = Math.max(Math.min(w, M), S), C = w + g, o && !p && (d._stacks[n.axis]._visualValues[r] = n.getValueForPixel(C) - n.getValueForPixel(w));
    }
    if (w === n.getPixelForValue(c)) {
      const T = Yn(g) * n.getLineWidthForValue(c) / 2;
      w += T, g -= T;
    }
    return {
      size: g,
      base: w,
      head: C,
      center: C + g / 2
    };
  }
  _calculateBarIndexPixels(t, n) {
    const o = n.scale, r = this.options, i = r.skipNull, l = je(r.maxBarThickness, 1 / 0);
    let c, d;
    const u = this._getAxisCount();
    if (n.grouped) {
      const p = i ? this._getStackCount(t) : n.stackCount, f = r.barThickness === "flex" ? By(t, n, r, p * u) : Ay(t, n, r, p * u), m = this.chart.options.indexAxis === "x" ? this.getDataset().xAxisID : this.getDataset().yAxisID, b = this._getAxis().indexOf(je(m, this.getFirstScaleIdForIndexAxis())), C = this._getStackIndex(this.index, this._cachedMeta.stack, i ? t : void 0) + b;
      c = f.start + f.chunk * C + f.chunk / 2, d = Math.min(l, f.chunk * f.ratio);
    } else
      c = o.getPixelForValue(this.getParsed(t)[o.axis], t), d = Math.min(l, n.min * n.ratio);
    return {
      base: c - d / 2,
      head: c + d / 2,
      center: c,
      size: d
    };
  }
  draw() {
    const t = this._cachedMeta, n = t.vScale, o = t.data, r = o.length;
    let i = 0;
    for (; i < r; ++i)
      this.getParsed(i)[n.axis] !== null && !o[i].hidden && o[i].draw(this._ctx);
  }
};
a(xr, "BarController"), pe(xr, "id", "bar"), pe(xr, "defaults", {
  datasetElementType: !1,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: !0,
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "base",
        "width",
        "height"
      ]
    }
  }
}), pe(xr, "overrides", {
  scales: {
    _index_: {
      type: "category",
      offset: !0,
      grid: {
        offset: !0
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: !0
    }
  }
});
let V1 = xr;
function Zy(e, t, n) {
  let o = 1, r = 1, i = 0, l = 0;
  if (t < Ct) {
    const c = e, d = c + t, u = Math.cos(c), p = Math.sin(c), f = Math.cos(d), m = Math.sin(d), b = /* @__PURE__ */ a((x, S, M) => qi(x, c, d, !0) ? 1 : Math.max(S, S * n, M, M * n), "calcMax"), C = /* @__PURE__ */ a((x, S, M) => qi(x, c, d, !0) ? -1 : Math.min(S, S * n, M, M * n), "calcMin"), g = b(0, u, f), y = b(Pt, p, m), w = C(Qe, u, f), T = C(Qe + Pt, p, m);
    o = (g - w) / 2, r = (y - T) / 2, i = -(g + w) / 2, l = -(y + T) / 2;
  }
  return {
    ratioX: o,
    ratioY: r,
    offsetX: i,
    offsetY: l
  };
}
a(Zy, "getRatioAndOffset");
const Zo = class Zo extends Ar {
  constructor(t, n) {
    super(t, n), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(t, n) {
    const o = this.getDataset().data, r = this._cachedMeta;
    if (this._parsing === !1)
      r._parsed = o;
    else {
      let i = /* @__PURE__ */ a((d) => +o[d], "getter");
      if (Ne(o[t])) {
        const { key: d = "value" } = this._parsing;
        i = /* @__PURE__ */ a((u) => +or(o[u], d), "getter");
      }
      let l, c;
      for (l = t, c = t + n; l < c; ++l)
        r._parsed[l] = i(l);
    }
  }
  _getRotation() {
    return io(this.options.rotation - 90);
  }
  _getCircumference() {
    return io(this.options.circumference);
  }
  _getRotationExtents() {
    let t = Ct, n = -Ct;
    for (let o = 0; o < this.chart.data.datasets.length; ++o)
      if (this.chart.isDatasetVisible(o) && this.chart.getDatasetMeta(o).type === this._type) {
        const r = this.chart.getDatasetMeta(o).controller, i = r._getRotation(), l = r._getCircumference();
        t = Math.min(t, i), n = Math.max(n, i + l);
      }
    return {
      rotation: t,
      circumference: n - t
    };
  }
  update(t) {
    const n = this.chart, { chartArea: o } = n, r = this._cachedMeta, i = r.data, l = this.getMaxBorderWidth() + this.getMaxOffset(i) + this.options.spacing, c = Math.max((Math.min(o.width, o.height) - l) / 2, 0), d = Math.min(Qb(this.options.cutout, c), 1), u = this._getRingWeight(this.index), { circumference: p, rotation: f } = this._getRotationExtents(), { ratioX: m, ratioY: b, offsetX: C, offsetY: g } = Zy(f, p, d), y = (o.width - l) / m, w = (o.height - l) / b, T = Math.max(Math.min(y, w) / 2, 0), x = _d(this.options.radius, T), S = Math.max(x * d, 0), M = (x - S) / this._getVisibleDatasetWeightTotal();
    this.offsetX = C * x, this.offsetY = g * x, r.total = this.calculateTotal(), this.outerRadius = x - M * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - M * u, 0), this.updateElements(i, 0, i.length, t);
  }
  _circumference(t, n) {
    const o = this.options, r = this._cachedMeta, i = this._getCircumference();
    return n && o.animation.animateRotate || !this.chart.getDataVisibility(t) || r._parsed[t] === null || r.data[t].hidden ? 0 : this.calculateCircumference(r._parsed[t] * i / Ct);
  }
  updateElements(t, n, o, r) {
    const i = r === "reset", l = this.chart, c = l.chartArea, u = l.options.animation, p = (c.left + c.right) / 2, f = (c.top + c.bottom) / 2, m = i && u.animateScale, b = m ? 0 : this.innerRadius, C = m ? 0 : this.outerRadius, { sharedOptions: g, includeOptions: y } = this._getSharedOptions(n, r);
    let w = this._getRotation(), T;
    for (T = 0; T < n; ++T)
      w += this._circumference(T, i);
    for (T = n; T < n + o; ++T) {
      const x = this._circumference(T, i), S = t[T], M = {
        x: p + this.offsetX,
        y: f + this.offsetY,
        startAngle: w,
        endAngle: w + x,
        circumference: x,
        outerRadius: C,
        innerRadius: b
      };
      y && (M.options = g || this.resolveDataElementOptions(T, S.active ? "active" : r)), w += x, this.updateElement(S, T, M, r);
    }
  }
  calculateTotal() {
    const t = this._cachedMeta, n = t.data;
    let o = 0, r;
    for (r = 0; r < n.length; r++) {
      const i = t._parsed[r];
      i !== null && !isNaN(i) && this.chart.getDataVisibility(r) && !n[r].hidden && (o += Math.abs(i));
    }
    return o;
  }
  calculateCircumference(t) {
    const n = this._cachedMeta.total;
    return n > 0 && !isNaN(t) ? Ct * (Math.abs(t) / n) : 0;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, o = this.chart, r = o.data.labels || [], i = Kc(n._parsed[t], o.options.locale);
    return {
      label: r[t] || "",
      value: i
    };
  }
  getMaxBorderWidth(t) {
    let n = 0;
    const o = this.chart;
    let r, i, l, c, d;
    if (!t) {
      for (r = 0, i = o.data.datasets.length; r < i; ++r)
        if (o.isDatasetVisible(r)) {
          l = o.getDatasetMeta(r), t = l.data, c = l.controller;
          break;
        }
    }
    if (!t)
      return 0;
    for (r = 0, i = t.length; r < i; ++r)
      d = c.resolveDataElementOptions(r), d.borderAlign !== "inner" && (n = Math.max(n, d.borderWidth || 0, d.hoverBorderWidth || 0));
    return n;
  }
  getMaxOffset(t) {
    let n = 0;
    for (let o = 0, r = t.length; o < r; ++o) {
      const i = this.resolveDataElementOptions(o);
      n = Math.max(n, i.offset || 0, i.hoverOffset || 0);
    }
    return n;
  }
  _getRingWeightOffset(t) {
    let n = 0;
    for (let o = 0; o < t; ++o)
      this.chart.isDatasetVisible(o) && (n += this._getRingWeight(o));
    return n;
  }
  _getRingWeight(t) {
    return Math.max(je(this.chart.data.datasets[t].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
};
a(Zo, "DoughnutController"), pe(Zo, "id", "doughnut"), pe(Zo, "defaults", {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "circumference",
        "endAngle",
        "innerRadius",
        "outerRadius",
        "startAngle",
        "x",
        "y",
        "offset",
        "borderWidth",
        "spacing"
      ]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
}), pe(Zo, "descriptors", {
  _scriptable: /* @__PURE__ */ a((t) => t !== "spacing", "_scriptable"),
  _indexable: /* @__PURE__ */ a((t) => t !== "spacing" && !t.startsWith("borderDash") && !t.startsWith("hoverBorderDash"), "_indexable")
}), pe(Zo, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(t) {
          const n = t.data;
          if (n.labels.length && n.datasets.length) {
            const { labels: { pointStyle: o, color: r } } = t.legend.options;
            return n.labels.map((i, l) => {
              const d = t.getDatasetMeta(0).controller.getStyle(l);
              return {
                text: i,
                fillStyle: d.backgroundColor,
                strokeStyle: d.borderColor,
                fontColor: r,
                lineWidth: d.borderWidth,
                pointStyle: o,
                hidden: !t.getDataVisibility(l),
                index: l
              };
            });
          }
          return [];
        }
      },
      onClick(t, n, o) {
        o.chart.toggleDataVisibility(n.index), o.chart.update();
      }
    }
  }
});
let Ji = Zo;
const vr = class vr extends Ar {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(t) {
    const n = this._cachedMeta, { dataset: o, data: r = [], _dataset: i } = n, l = this.chart._animationsDisabled;
    let { start: c, count: d } = yC(n, r, l);
    this._drawStart = c, this._drawCount = d, xC(n) && (c = 0, d = r.length), o._chart = this.chart, o._datasetIndex = this.index, o._decimated = !!i._decimated, o.points = r;
    const u = this.resolveDatasetElementOptions(t);
    this.options.showLine || (u.borderWidth = 0), u.segment = this.options.segment, this.updateElement(o, void 0, {
      animated: !l,
      options: u
    }, t), this.updateElements(r, c, d, t);
  }
  updateElements(t, n, o, r) {
    const i = r === "reset", { iScale: l, vScale: c, _stacked: d, _dataset: u } = this._cachedMeta, { sharedOptions: p, includeOptions: f } = this._getSharedOptions(n, r), m = l.axis, b = c.axis, { spanGaps: C, segment: g } = this.options, y = Yi(C) ? C : Number.POSITIVE_INFINITY, w = this.chart._animationsDisabled || i || r === "none", T = n + o, x = t.length;
    let S = n > 0 && this.getParsed(n - 1);
    for (let M = 0; M < x; ++M) {
      const O = t[M], P = w ? O : {};
      if (M < n || M >= T) {
        P.skip = !0;
        continue;
      }
      const E = this.getParsed(M), I = He(E[b]), v = P[m] = l.getPixelForValue(E[m], M), _ = P[b] = i || I ? c.getBasePixel() : c.getPixelForValue(d ? this.applyStack(c, E, d) : E[b], M);
      P.skip = isNaN(v) || isNaN(_) || I, P.stop = M > 0 && Math.abs(E[m] - S[m]) > y, g && (P.parsed = E, P.raw = u.data[M]), f && (P.options = p || this.resolveDataElementOptions(M, O.active ? "active" : r)), w || this.updateElement(O, M, P, r), S = E;
    }
  }
  getMaxOverflow() {
    const t = this._cachedMeta, n = t.dataset, o = n.options && n.options.borderWidth || 0, r = t.data || [];
    if (!r.length)
      return o;
    const i = r[0].size(this.resolveDataElementOptions(0)), l = r[r.length - 1].size(this.resolveDataElementOptions(r.length - 1));
    return Math.max(o, i, l) / 2;
  }
  draw() {
    const t = this._cachedMeta;
    t.dataset.updateControlPoints(this.chart.chartArea, t.iScale.axis), super.draw();
  }
};
a(vr, "LineController"), pe(vr, "id", "line"), pe(vr, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
}), pe(vr, "overrides", {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
});
let A1 = vr;
const _i = class _i extends Ji {
};
a(_i, "PieController"), pe(_i, "id", "pie"), pe(_i, "defaults", {
  cutout: 0,
  rotation: 0,
  circumference: 360,
  radius: "100%"
});
let Ea = _i;
function Do() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
a(Do, "abstract");
const Na = class Na {
  constructor(t) {
    pe(this, "options");
    this.options = t || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(t) {
    Object.assign(Na.prototype, t);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return Do();
  }
  parse() {
    return Do();
  }
  format() {
    return Do();
  }
  add() {
    return Do();
  }
  diff() {
    return Do();
  }
  startOf() {
    return Do();
  }
  endOf() {
    return Do();
  }
};
a(Na, "DateAdapterBase");
let B1 = Na;
var Uy = {
  _date: B1
};
function Gy(e, t, n, o) {
  const { controller: r, data: i, _sorted: l } = e, c = r._cachedMeta.iScale, d = e.dataset && e.dataset.options ? e.dataset.options.spanGaps : null;
  if (c && t === c.axis && t !== "r" && l && i.length) {
    const u = c._reversePixels ? hC : Xo;
    if (o) {
      if (r._sharedOptions) {
        const p = i[0], f = typeof p.getRange == "function" && p.getRange(t);
        if (f) {
          const m = u(i, t, n - f), b = u(i, t, n + f);
          return {
            lo: m.lo,
            hi: b.hi
          };
        }
      }
    } else {
      const p = u(i, t, n);
      if (d) {
        const { vScale: f } = r._cachedMeta, { _parsed: m } = e, b = m.slice(0, p.lo + 1).reverse().findIndex((g) => !He(g[f.axis]));
        p.lo -= Math.max(0, b);
        const C = m.slice(p.hi).findIndex((g) => !He(g[f.axis]));
        p.hi += Math.max(0, C);
      }
      return p;
    }
  }
  return {
    lo: 0,
    hi: i.length - 1
  };
}
a(Gy, "binarySearch");
function wl(e, t, n, o, r) {
  const i = e.getSortedVisibleDatasetMetas(), l = n[t];
  for (let c = 0, d = i.length; c < d; ++c) {
    const { index: u, data: p } = i[c], { lo: f, hi: m } = Gy(i[c], t, l, r);
    for (let b = f; b <= m; ++b) {
      const C = p[b];
      C.skip || o(C, u, b);
    }
  }
}
a(wl, "evaluateInteractionItems");
function Yy(e) {
  const t = e.indexOf("x") !== -1, n = e.indexOf("y") !== -1;
  return function(o, r) {
    const i = t ? Math.abs(o.x - r.x) : 0, l = n ? Math.abs(o.y - r.y) : 0;
    return Math.sqrt(Math.pow(i, 2) + Math.pow(l, 2));
  };
}
a(Yy, "getDistanceMetricForAxis");
function Ql(e, t, n, o, r) {
  const i = [];
  return !r && !e.isPointInArea(t) || wl(e, n, t, /* @__PURE__ */ a(function(c, d, u) {
    !r && !Ki(c, e.chartArea, 0) || c.inRange(t.x, t.y, o) && i.push({
      element: c,
      datasetIndex: d,
      index: u
    });
  }, "evaluationFunc"), !0), i;
}
a(Ql, "getIntersectItems");
function qy(e, t, n, o) {
  let r = [];
  function i(l, c, d) {
    const { startAngle: u, endAngle: p } = l.getProps([
      "startAngle",
      "endAngle"
    ], o), { angle: f } = jd(l, {
      x: t.x,
      y: t.y
    });
    qi(f, u, p) && r.push({
      element: l,
      datasetIndex: c,
      index: d
    });
  }
  return a(i, "evaluationFunc"), wl(e, n, t, i), r;
}
a(qy, "getNearestRadialItems");
function Ky(e, t, n, o, r, i) {
  let l = [];
  const c = Yy(n);
  let d = Number.POSITIVE_INFINITY;
  function u(p, f, m) {
    const b = p.inRange(t.x, t.y, r);
    if (o && !b)
      return;
    const C = p.getCenterPoint(r);
    if (!(!!i || e.isPointInArea(C)) && !b)
      return;
    const y = c(t, C);
    y < d ? (l = [
      {
        element: p,
        datasetIndex: f,
        index: m
      }
    ], d = y) : y === d && l.push({
      element: p,
      datasetIndex: f,
      index: m
    });
  }
  return a(u, "evaluationFunc"), wl(e, n, t, u), l;
}
a(Ky, "getNearestCartesianItems");
function e1(e, t, n, o, r, i) {
  return !i && !e.isPointInArea(t) ? [] : n === "r" && !o ? qy(e, t, n, r) : Ky(e, t, n, o, r, i);
}
a(e1, "getNearestItems");
function D4(e, t, n, o, r) {
  const i = [], l = n === "x" ? "inXRange" : "inYRange";
  let c = !1;
  return wl(e, n, t, (d, u, p) => {
    d[l] && d[l](t[n], r) && (i.push({
      element: d,
      datasetIndex: u,
      index: p
    }), c = c || d.inRange(t.x, t.y, r));
  }), o && !c ? [] : i;
}
a(D4, "getAxisItems");
var Xy = {
  modes: {
    index(e, t, n, o) {
      const r = Fo(t, e), i = n.axis || "x", l = n.includeInvisible || !1, c = n.intersect ? Ql(e, r, i, o, l) : e1(e, r, i, !1, o, l), d = [];
      return c.length ? (e.getSortedVisibleDatasetMetas().forEach((u) => {
        const p = c[0].index, f = u.data[p];
        f && !f.skip && d.push({
          element: f,
          datasetIndex: u.index,
          index: p
        });
      }), d) : [];
    },
    dataset(e, t, n, o) {
      const r = Fo(t, e), i = n.axis || "xy", l = n.includeInvisible || !1;
      let c = n.intersect ? Ql(e, r, i, o, l) : e1(e, r, i, !1, o, l);
      if (c.length > 0) {
        const d = c[0].datasetIndex, u = e.getDatasetMeta(d).data;
        c = [];
        for (let p = 0; p < u.length; ++p)
          c.push({
            element: u[p],
            datasetIndex: d,
            index: p
          });
      }
      return c;
    },
    point(e, t, n, o) {
      const r = Fo(t, e), i = n.axis || "xy", l = n.includeInvisible || !1;
      return Ql(e, r, i, o, l);
    },
    nearest(e, t, n, o) {
      const r = Fo(t, e), i = n.axis || "xy", l = n.includeInvisible || !1;
      return e1(e, r, i, n.intersect, o, l);
    },
    x(e, t, n, o) {
      const r = Fo(t, e);
      return D4(e, r, "x", n.intersect, o);
    },
    y(e, t, n, o) {
      const r = Fo(t, e);
      return D4(e, r, "y", n.intersect, o);
    }
  }
};
const Jd = [
  "left",
  "top",
  "right",
  "bottom"
];
function oi(e, t) {
  return e.filter((n) => n.pos === t);
}
a(oi, "filterByPosition");
function N4(e, t) {
  return e.filter((n) => Jd.indexOf(n.pos) === -1 && n.box.axis === t);
}
a(N4, "filterDynamicPositionByAxis");
function ri(e, t) {
  return e.sort((n, o) => {
    const r = t ? o : n, i = t ? n : o;
    return r.weight === i.weight ? r.index - i.index : r.weight - i.weight;
  });
}
a(ri, "sortByWeight");
function Jy(e) {
  const t = [];
  let n, o, r, i, l, c;
  for (n = 0, o = (e || []).length; n < o; ++n)
    r = e[n], { position: i, options: { stack: l, stackWeight: c = 1 } } = r, t.push({
      index: n,
      box: r,
      pos: i,
      horizontal: r.isHorizontal(),
      weight: r.weight,
      stack: l && i + l,
      stackWeight: c
    });
  return t;
}
a(Jy, "wrapBoxes");
function Qy(e) {
  const t = {};
  for (const n of e) {
    const { stack: o, pos: r, stackWeight: i } = n;
    if (!o || !Jd.includes(r))
      continue;
    const l = t[o] || (t[o] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    l.count++, l.weight += i;
  }
  return t;
}
a(Qy, "buildStacks");
function ex(e, t) {
  const n = Qy(e), { vBoxMaxWidth: o, hBoxMaxHeight: r } = t;
  let i, l, c;
  for (i = 0, l = e.length; i < l; ++i) {
    c = e[i];
    const { fullSize: d } = c.box, u = n[c.stack], p = u && c.stackWeight / u.weight;
    c.horizontal ? (c.width = p ? p * o : d && t.availableWidth, c.height = r) : (c.width = o, c.height = p ? p * r : d && t.availableHeight);
  }
  return n;
}
a(ex, "setLayoutDims");
function tx(e) {
  const t = Jy(e), n = ri(t.filter((u) => u.box.fullSize), !0), o = ri(oi(t, "left"), !0), r = ri(oi(t, "right")), i = ri(oi(t, "top"), !0), l = ri(oi(t, "bottom")), c = N4(t, "x"), d = N4(t, "y");
  return {
    fullSize: n,
    leftAndTop: o.concat(i),
    rightAndBottom: r.concat(d).concat(l).concat(c),
    chartArea: oi(t, "chartArea"),
    vertical: o.concat(r).concat(d),
    horizontal: i.concat(l).concat(c)
  };
}
a(tx, "buildLayoutBoxes");
function z4(e, t, n, o) {
  return Math.max(e[n], t[n]) + Math.max(e[o], t[o]);
}
a(z4, "getCombinedMax");
function Qd(e, t) {
  e.top = Math.max(e.top, t.top), e.left = Math.max(e.left, t.left), e.bottom = Math.max(e.bottom, t.bottom), e.right = Math.max(e.right, t.right);
}
a(Qd, "updateMaxPadding");
function nx(e, t, n, o) {
  const { pos: r, box: i } = n, l = e.maxPadding;
  if (!Ne(r)) {
    n.size && (e[r] -= n.size);
    const f = o[n.stack] || {
      size: 0,
      count: 1
    };
    f.size = Math.max(f.size, n.horizontal ? i.height : i.width), n.size = f.size / f.count, e[r] += n.size;
  }
  i.getPadding && Qd(l, i.getPadding());
  const c = Math.max(0, t.outerWidth - z4(l, e, "left", "right")), d = Math.max(0, t.outerHeight - z4(l, e, "top", "bottom")), u = c !== e.w, p = d !== e.h;
  return e.w = c, e.h = d, n.horizontal ? {
    same: u,
    other: p
  } : {
    same: p,
    other: u
  };
}
a(nx, "updateDims");
function ox(e) {
  const t = e.maxPadding;
  function n(o) {
    const r = Math.max(t[o] - e[o], 0);
    return e[o] += r, r;
  }
  a(n, "updatePos"), e.y += n("top"), e.x += n("left"), n("right"), n("bottom");
}
a(ox, "handleMaxPadding");
function rx(e, t) {
  const n = t.maxPadding;
  function o(r) {
    const i = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return r.forEach((l) => {
      i[l] = Math.max(t[l], n[l]);
    }), i;
  }
  return a(o, "marginForPositions"), o(e ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
a(rx, "getMargins");
function gi(e, t, n, o) {
  const r = [];
  let i, l, c, d, u, p;
  for (i = 0, l = e.length, u = 0; i < l; ++i) {
    c = e[i], d = c.box, d.update(c.width || t.w, c.height || t.h, rx(c.horizontal, t));
    const { same: f, other: m } = nx(t, n, c, o);
    u |= f && r.length, p = p || m, d.fullSize || r.push(c);
  }
  return u && gi(r, t, n, o) || p;
}
a(gi, "fitBoxes");
function Bs(e, t, n, o, r) {
  e.top = n, e.left = t, e.right = t + o, e.bottom = n + r, e.width = o, e.height = r;
}
a(Bs, "setBoxDims");
function F4(e, t, n, o) {
  const r = n.padding;
  let { x: i, y: l } = t;
  for (const c of e) {
    const d = c.box, u = o[c.stack] || {
      placed: 0,
      weight: 1
    }, p = c.stackWeight / u.weight || 1;
    if (c.horizontal) {
      const f = t.w * p, m = u.size || d.height;
      Gi(u.start) && (l = u.start), d.fullSize ? Bs(d, r.left, l, n.outerWidth - r.right - r.left, m) : Bs(d, t.left + u.placed, l, f, m), u.start = l, u.placed += f, l = d.bottom;
    } else {
      const f = t.h * p, m = u.size || d.width;
      Gi(u.start) && (i = u.start), d.fullSize ? Bs(d, i, r.top, m, n.outerHeight - r.bottom - r.top) : Bs(d, i, t.top + u.placed, m, f), u.start = i, u.placed += f, i = d.right;
    }
  }
  t.x = i, t.y = l;
}
a(F4, "placeBoxes");
var vn = {
  addBox(e, t) {
    e.boxes || (e.boxes = []), t.fullSize = t.fullSize || !1, t.position = t.position || "top", t.weight = t.weight || 0, t._layers = t._layers || function() {
      return [
        {
          z: 0,
          draw(n) {
            t.draw(n);
          }
        }
      ];
    }, e.boxes.push(t);
  },
  removeBox(e, t) {
    const n = e.boxes ? e.boxes.indexOf(t) : -1;
    n !== -1 && e.boxes.splice(n, 1);
  },
  configure(e, t, n) {
    t.fullSize = n.fullSize, t.position = n.position, t.weight = n.weight;
  },
  update(e, t, n, o) {
    if (!e)
      return;
    const r = pn(e.options.layout.padding), i = Math.max(t - r.width, 0), l = Math.max(n - r.height, 0), c = tx(e.boxes), d = c.vertical, u = c.horizontal;
    qe(e.boxes, (g) => {
      typeof g.beforeLayout == "function" && g.beforeLayout();
    });
    const p = d.reduce((g, y) => y.box.options && y.box.options.display === !1 ? g : g + 1, 0) || 1, f = Object.freeze({
      outerWidth: t,
      outerHeight: n,
      padding: r,
      availableWidth: i,
      availableHeight: l,
      vBoxMaxWidth: i / 2 / p,
      hBoxMaxHeight: l / 2
    }), m = Object.assign({}, r);
    Qd(m, pn(o));
    const b = Object.assign({
      maxPadding: m,
      w: i,
      h: l,
      x: r.left,
      y: r.top
    }, r), C = ex(d.concat(u), f);
    gi(c.fullSize, b, f, C), gi(d, b, f, C), gi(u, b, f, C) && gi(d, b, f, C), ox(b), F4(c.leftAndTop, b, f, C), b.x += b.w, b.y += b.h, F4(c.rightAndBottom, b, f, C), e.chartArea = {
      left: b.left,
      top: b.top,
      right: b.left + b.w,
      bottom: b.top + b.h,
      height: b.h,
      width: b.w
    }, qe(c.chartArea, (g) => {
      const y = g.box;
      Object.assign(y, e.chartArea), y.update(b.w, b.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
const u2 = class u2 {
  acquireContext(t, n) {
  }
  releaseContext(t) {
    return !1;
  }
  addEventListener(t, n, o) {
  }
  removeEventListener(t, n, o) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(t, n, o, r) {
    return n = Math.max(0, n || t.width), o = o || t.height, {
      width: n,
      height: Math.max(0, r ? Math.floor(n / r) : o)
    };
  }
  isAttached(t) {
    return !0;
  }
  updateConfig(t) {
  }
};
a(u2, "BasePlatform");
let $a = u2;
const p2 = class p2 extends $a {
  acquireContext(t) {
    return t && t.getContext && t.getContext("2d") || null;
  }
  updateConfig(t) {
    t.options.animation = !1;
  }
};
a(p2, "BasicPlatform");
let H1 = p2;
const ta = "$chartjs", ix = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, W4 = /* @__PURE__ */ a((e) => e === null || e === "", "isNullOrEmpty");
function sx(e, t) {
  const n = e.style, o = e.getAttribute("height"), r = e.getAttribute("width");
  if (e[ta] = {
    initial: {
      height: o,
      width: r,
      style: {
        display: n.display,
        height: n.height,
        width: n.width
      }
    }
  }, n.display = n.display || "block", n.boxSizing = n.boxSizing || "border-box", W4(r)) {
    const i = O4(e, "width");
    i !== void 0 && (e.width = i);
  }
  if (W4(o))
    if (e.style.height === "")
      e.height = e.width / (t || 2);
    else {
      const i = O4(e, "height");
      i !== void 0 && (e.height = i);
    }
  return e;
}
a(sx, "initCanvas");
const eu = ly ? {
  passive: !0
} : !1;
function ax(e, t, n) {
  e && e.addEventListener(t, n, eu);
}
a(ax, "addListener");
function lx(e, t, n) {
  e && e.canvas && e.canvas.removeEventListener(t, n, eu);
}
a(lx, "removeListener");
function cx(e, t) {
  const n = ix[e.type] || e.type, { x: o, y: r } = Fo(e, t);
  return {
    type: n,
    chart: t,
    native: e,
    x: o !== void 0 ? o : null,
    y: r !== void 0 ? r : null
  };
}
a(cx, "fromNativeEvent");
function Pa(e, t) {
  for (const n of e)
    if (n === t || n.contains(t))
      return !0;
}
a(Pa, "nodeListContains");
function dx(e, t, n) {
  const o = e.canvas, r = new MutationObserver((i) => {
    let l = !1;
    for (const c of i)
      l = l || Pa(c.addedNodes, o), l = l && !Pa(c.removedNodes, o);
    l && n();
  });
  return r.observe(document, {
    childList: !0,
    subtree: !0
  }), r;
}
a(dx, "createAttachObserver");
function ux(e, t, n) {
  const o = e.canvas, r = new MutationObserver((i) => {
    let l = !1;
    for (const c of i)
      l = l || Pa(c.removedNodes, o), l = l && !Pa(c.addedNodes, o);
    l && n();
  });
  return r.observe(document, {
    childList: !0,
    subtree: !0
  }), r;
}
a(ux, "createDetachObserver");
const Qi = /* @__PURE__ */ new Map();
let Z4 = 0;
function tu() {
  const e = window.devicePixelRatio;
  e !== Z4 && (Z4 = e, Qi.forEach((t, n) => {
    n.currentDevicePixelRatio !== e && t();
  }));
}
a(tu, "onWindowResize");
function px(e, t) {
  Qi.size || window.addEventListener("resize", tu), Qi.set(e, t);
}
a(px, "listenDevicePixelRatioChanges");
function fx(e) {
  Qi.delete(e), Qi.size || window.removeEventListener("resize", tu);
}
a(fx, "unlistenDevicePixelRatioChanges");
function hx(e, t, n) {
  const o = e.canvas, r = o && r2(o);
  if (!r)
    return;
  const i = Bd((c, d) => {
    const u = r.clientWidth;
    n(c, d), u < r.clientWidth && n();
  }, window), l = new ResizeObserver((c) => {
    const d = c[0], u = d.contentRect.width, p = d.contentRect.height;
    u === 0 && p === 0 || i(u, p);
  });
  return l.observe(r), px(e, i), l;
}
a(hx, "createResizeObserver");
function t1(e, t, n) {
  n && n.disconnect(), t === "resize" && fx(e);
}
a(t1, "releaseObserver");
function gx(e, t, n) {
  const o = e.canvas, r = Bd((i) => {
    e.ctx !== null && n(cx(i, e));
  }, e);
  return ax(o, t, r), r;
}
a(gx, "createProxyAndListen");
const f2 = class f2 extends $a {
  acquireContext(t, n) {
    const o = t && t.getContext && t.getContext("2d");
    return o && o.canvas === t ? (sx(t, n), o) : null;
  }
  releaseContext(t) {
    const n = t.canvas;
    if (!n[ta])
      return !1;
    const o = n[ta].initial;
    [
      "height",
      "width"
    ].forEach((i) => {
      const l = o[i];
      He(l) ? n.removeAttribute(i) : n.setAttribute(i, l);
    });
    const r = o.style || {};
    return Object.keys(r).forEach((i) => {
      n.style[i] = r[i];
    }), n.width = n.width, delete n[ta], !0;
  }
  addEventListener(t, n, o) {
    this.removeEventListener(t, n);
    const r = t.$proxies || (t.$proxies = {}), l = {
      attach: dx,
      detach: ux,
      resize: hx
    }[n] || gx;
    r[n] = l(t, n, o);
  }
  removeEventListener(t, n) {
    const o = t.$proxies || (t.$proxies = {}), r = o[n];
    if (!r)
      return;
    ({
      attach: t1,
      detach: t1,
      resize: t1
    }[n] || lx)(t, n, r), o[n] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(t, n, o, r) {
    return ay(t, n, o, r);
  }
  isAttached(t) {
    const n = t && r2(t);
    return !!(n && n.isConnected);
  }
};
a(f2, "DomPlatform");
let D1 = f2;
function mx(e) {
  return !o2() || typeof OffscreenCanvas < "u" && e instanceof OffscreenCanvas ? H1 : D1;
}
a(mx, "_detectPlatform");
var xo;
let fo = (xo = class {
  constructor() {
    pe(this, "x");
    pe(this, "y");
    pe(this, "active", !1);
    pe(this, "options");
    pe(this, "$animations");
  }
  tooltipPosition(t) {
    const { x: n, y: o } = this.getProps([
      "x",
      "y"
    ], t);
    return {
      x: n,
      y: o
    };
  }
  hasValue() {
    return Yi(this.x) && Yi(this.y);
  }
  getProps(t, n) {
    const o = this.$animations;
    if (!n || !o)
      return this;
    const r = {};
    return t.forEach((i) => {
      r[i] = o[i] && o[i].active() ? o[i]._to : this[i];
    }), r;
  }
}, a(xo, "Element"), pe(xo, "defaults", {}), pe(xo, "defaultRoutes"), xo);
function bx(e, t) {
  const n = e.options.ticks, o = Cx(e), r = Math.min(n.maxTicksLimit || o, o), i = n.major.enabled ? xx(t) : [], l = i.length, c = i[0], d = i[l - 1], u = [];
  if (l > r)
    return vx(t, u, i, l / r), u;
  const p = yx(i, t, r);
  if (l > 0) {
    let f, m;
    const b = l > 1 ? Math.round((d - c) / (l - 1)) : null;
    for (Hs(t, u, p, He(b) ? 0 : c - b, c), f = 0, m = l - 1; f < m; f++)
      Hs(t, u, p, i[f], i[f + 1]);
    return Hs(t, u, p, d, He(b) ? t.length : d + b), u;
  }
  return Hs(t, u, p), u;
}
a(bx, "autoSkip");
function Cx(e) {
  const t = e.options.offset, n = e._tickSize(), o = e._length / n + (t ? 0 : 1), r = e._maxLength / n;
  return Math.floor(Math.min(o, r));
}
a(Cx, "determineMaxTicks");
function yx(e, t, n) {
  const o = wx(e), r = t.length / n;
  if (!o)
    return Math.max(r, 1);
  const i = aC(o);
  for (let l = 0, c = i.length - 1; l < c; l++) {
    const d = i[l];
    if (d > r)
      return d;
  }
  return Math.max(r, 1);
}
a(yx, "calculateSpacing");
function xx(e) {
  const t = [];
  let n, o;
  for (n = 0, o = e.length; n < o; n++)
    e[n].major && t.push(n);
  return t;
}
a(xx, "getMajorIndices");
function vx(e, t, n, o) {
  let r = 0, i = n[0], l;
  for (o = Math.ceil(o), l = 0; l < e.length; l++)
    l === i && (t.push(e[l]), r++, i = n[r * o]);
}
a(vx, "skipMajors");
function Hs(e, t, n, o, r) {
  const i = je(o, 0), l = Math.min(je(r, e.length), e.length);
  let c = 0, d, u, p;
  for (n = Math.ceil(n), r && (d = r - o, n = d / Math.floor(d / n)), p = i; p < 0; )
    c++, p = Math.round(i + c * n);
  for (u = Math.max(i, 0); u < l; u++)
    u === p && (t.push(e[u]), c++, p = Math.round(i + c * n));
}
a(Hs, "skip");
function wx(e) {
  const t = e.length;
  let n, o;
  if (t < 2)
    return !1;
  for (o = e[0], n = 1; n < t; ++n)
    if (e[n] - e[n - 1] !== o)
      return !1;
  return o;
}
a(wx, "getEvenSpacing");
const Sx = /* @__PURE__ */ a((e) => e === "left" ? "right" : e === "right" ? "left" : e, "reverseAlign"), U4 = /* @__PURE__ */ a((e, t, n) => t === "top" || t === "left" ? e[t] + n : e[t] - n, "offsetFromEdge"), G4 = /* @__PURE__ */ a((e, t) => Math.min(t || e, e), "getTicksLimit");
function Y4(e, t) {
  const n = [], o = e.length / t, r = e.length;
  let i = 0;
  for (; i < r; i += o)
    n.push(e[Math.floor(i)]);
  return n;
}
a(Y4, "sample");
function Mx(e, t, n) {
  const o = e.ticks.length, r = Math.min(t, o - 1), i = e._startPixel, l = e._endPixel, c = 1e-6;
  let d = e.getPixelForTick(r), u;
  if (!(n && (o === 1 ? u = Math.max(d - i, l - d) : t === 0 ? u = (e.getPixelForTick(1) - d) / 2 : u = (d - e.getPixelForTick(r - 1)) / 2, d += r < t ? u : -u, d < i - c || d > l + c)))
    return d;
}
a(Mx, "getPixelForGridLine");
function Tx(e, t) {
  qe(e, (n) => {
    const o = n.gc, r = o.length / 2;
    let i;
    if (r > t) {
      for (i = 0; i < r; ++i)
        delete n.data[o[i]];
      o.splice(0, r);
    }
  });
}
a(Tx, "garbageCollect");
function ii(e) {
  return e.drawTicks ? e.tickLength : 0;
}
a(ii, "getTickMarkLength");
function q4(e, t) {
  if (!e.display)
    return 0;
  const n = Lt(e.font, t), o = pn(e.padding);
  return (Et(e.text) ? e.text.length : 1) * n.lineHeight + o.height;
}
a(q4, "getTitleHeight");
function kx(e, t) {
  return lr(e, {
    scale: t,
    type: "scale"
  });
}
a(kx, "createScaleContext");
function Ox(e, t, n) {
  return lr(e, {
    tick: n,
    index: t,
    type: "tick"
  });
}
a(Ox, "createTickContext");
function Ex(e, t, n) {
  let o = Yc(e);
  return (n && t !== "right" || !n && t === "right") && (o = Sx(o)), o;
}
a(Ex, "titleAlign");
function $x(e, t, n, o) {
  const { top: r, left: i, bottom: l, right: c, chart: d } = e, { chartArea: u, scales: p } = d;
  let f = 0, m, b, C;
  const g = l - r, y = c - i;
  if (e.isHorizontal()) {
    if (b = Ht(o, i, c), Ne(n)) {
      const w = Object.keys(n)[0], T = n[w];
      C = p[w].getPixelForValue(T) + g - t;
    } else n === "center" ? C = (u.bottom + u.top) / 2 + g - t : C = U4(e, n, t);
    m = c - i;
  } else {
    if (Ne(n)) {
      const w = Object.keys(n)[0], T = n[w];
      b = p[w].getPixelForValue(T) - y + t;
    } else n === "center" ? b = (u.left + u.right) / 2 - y + t : b = U4(e, n, t);
    C = Ht(o, l, r), f = n === "left" ? -Pt : Pt;
  }
  return {
    titleX: b,
    titleY: C,
    maxWidth: m,
    rotation: f
  };
}
a($x, "titleArgs");
const za = class za extends fo {
  constructor(t) {
    super(), this.id = t.id, this.type = t.type, this.options = void 0, this.ctx = t.ctx, this.chart = t.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(t) {
    this.options = t.setContext(this.getContext()), this.axis = t.axis, this._userMin = this.parse(t.min), this._userMax = this.parse(t.max), this._suggestedMin = this.parse(t.suggestedMin), this._suggestedMax = this.parse(t.suggestedMax);
  }
  parse(t, n) {
    return t;
  }
  getUserBounds() {
    let { _userMin: t, _userMax: n, _suggestedMin: o, _suggestedMax: r } = this;
    return t = Dn(t, Number.POSITIVE_INFINITY), n = Dn(n, Number.NEGATIVE_INFINITY), o = Dn(o, Number.POSITIVE_INFINITY), r = Dn(r, Number.NEGATIVE_INFINITY), {
      min: Dn(t, o),
      max: Dn(n, r),
      minDefined: Tn(t),
      maxDefined: Tn(n)
    };
  }
  getMinMax(t) {
    let { min: n, max: o, minDefined: r, maxDefined: i } = this.getUserBounds(), l;
    if (r && i)
      return {
        min: n,
        max: o
      };
    const c = this.getMatchingVisibleMetas();
    for (let d = 0, u = c.length; d < u; ++d)
      l = c[d].controller.getMinMax(this, t), r || (n = Math.min(n, l.min)), i || (o = Math.max(o, l.max));
    return n = i && n > o ? o : n, o = r && n > o ? n : o, {
      min: Dn(n, Dn(o, n)),
      max: Dn(o, Dn(n, o))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const t = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels || [];
  }
  getLabelItems(t = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(t));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    st(this.options.beforeUpdate, [
      this
    ]);
  }
  update(t, n, o) {
    const { beginAtZero: r, grace: i, ticks: l } = this.options, c = l.sampleSize;
    this.beforeUpdate(), this.maxWidth = t, this.maxHeight = n, this._margins = o = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, o), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + o.left + o.right : this.height + o.top + o.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = HC(this, i, r), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const d = c < this.ticks.length;
    this._convertTicksToLabels(d ? Y4(this.ticks, c) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), l.display && (l.autoSkip || l.source === "auto") && (this.ticks = bx(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), d && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let t = this.options.reverse, n, o;
    this.isHorizontal() ? (n = this.left, o = this.right) : (n = this.top, o = this.bottom, t = !t), this._startPixel = n, this._endPixel = o, this._reversePixels = t, this._length = o - n, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    st(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    st(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    st(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(t) {
    this.chart.notifyPlugins(t, this.getContext()), st(this.options[t], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    st(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(t) {
    const n = this.options.ticks;
    let o, r, i;
    for (o = 0, r = t.length; o < r; o++)
      i = t[o], i.label = st(n.callback, [
        i.value,
        o,
        t
      ], this);
  }
  afterTickToLabelConversion() {
    st(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    st(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const t = this.options, n = t.ticks, o = G4(this.ticks.length, t.ticks.maxTicksLimit), r = n.minRotation || 0, i = n.maxRotation;
    let l = r, c, d, u;
    if (!this._isVisible() || !n.display || r >= i || o <= 1 || !this.isHorizontal()) {
      this.labelRotation = r;
      return;
    }
    const p = this._getLabelSizes(), f = p.widest.width, m = p.highest.height, b = Nt(this.chart.width - f, 0, this.maxWidth);
    c = t.offset ? this.maxWidth / o : b / (o - 1), f + 6 > c && (c = b / (o - (t.offset ? 0.5 : 1)), d = this.maxHeight - ii(t.grid) - n.padding - q4(t.title, this.chart.options.font), u = Math.sqrt(f * f + m * m), l = uC(Math.min(Math.asin(Nt((p.highest.height + 6) / c, -1, 1)), Math.asin(Nt(d / u, -1, 1)) - Math.asin(Nt(m / u, -1, 1)))), l = Math.max(r, Math.min(i, l))), this.labelRotation = l;
  }
  afterCalculateLabelRotation() {
    st(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    st(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const t = {
      width: 0,
      height: 0
    }, { chart: n, options: { ticks: o, title: r, grid: i } } = this, l = this._isVisible(), c = this.isHorizontal();
    if (l) {
      const d = q4(r, n.options.font);
      if (c ? (t.width = this.maxWidth, t.height = ii(i) + d) : (t.height = this.maxHeight, t.width = ii(i) + d), o.display && this.ticks.length) {
        const { first: u, last: p, widest: f, highest: m } = this._getLabelSizes(), b = o.padding * 2, C = io(this.labelRotation), g = Math.cos(C), y = Math.sin(C);
        if (c) {
          const w = o.mirror ? 0 : y * f.width + g * m.height;
          t.height = Math.min(this.maxHeight, t.height + w + b);
        } else {
          const w = o.mirror ? 0 : g * f.width + y * m.height;
          t.width = Math.min(this.maxWidth, t.width + w + b);
        }
        this._calculatePadding(u, p, y, g);
      }
    }
    this._handleMargins(), c ? (this.width = this._length = n.width - this._margins.left - this._margins.right, this.height = t.height) : (this.width = t.width, this.height = this._length = n.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(t, n, o, r) {
    const { ticks: { align: i, padding: l }, position: c } = this.options, d = this.labelRotation !== 0, u = c !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const p = this.getPixelForTick(0) - this.left, f = this.right - this.getPixelForTick(this.ticks.length - 1);
      let m = 0, b = 0;
      d ? u ? (m = r * t.width, b = o * n.height) : (m = o * t.height, b = r * n.width) : i === "start" ? b = n.width : i === "end" ? m = t.width : i !== "inner" && (m = t.width / 2, b = n.width / 2), this.paddingLeft = Math.max((m - p + l) * this.width / (this.width - p), 0), this.paddingRight = Math.max((b - f + l) * this.width / (this.width - f), 0);
    } else {
      let p = n.height / 2, f = t.height / 2;
      i === "start" ? (p = 0, f = t.height) : i === "end" && (p = n.height, f = 0), this.paddingTop = p + l, this.paddingBottom = f + l;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    st(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: t, position: n } = this.options;
    return n === "top" || n === "bottom" || t === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(t) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(t);
    let n, o;
    for (n = 0, o = t.length; n < o; n++)
      He(t[n].label) && (t.splice(n, 1), o--, n--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let t = this._labelSizes;
    if (!t) {
      const n = this.options.ticks.sampleSize;
      let o = this.ticks;
      n < o.length && (o = Y4(o, n)), this._labelSizes = t = this._computeLabelSizes(o, o.length, this.options.ticks.maxTicksLimit);
    }
    return t;
  }
  _computeLabelSizes(t, n, o) {
    const { ctx: r, _longestTextCache: i } = this, l = [], c = [], d = Math.floor(n / G4(n, o));
    let u = 0, p = 0, f, m, b, C, g, y, w, T, x, S, M;
    for (f = 0; f < n; f += d) {
      if (C = t[f].label, g = this._resolveTickFontOptions(f), r.font = y = g.string, w = i[y] = i[y] || {
        data: {},
        gc: []
      }, T = g.lineHeight, x = S = 0, !He(C) && !Et(C))
        x = w4(r, w.data, w.gc, x, C), S = T;
      else if (Et(C))
        for (m = 0, b = C.length; m < b; ++m)
          M = C[m], !He(M) && !Et(M) && (x = w4(r, w.data, w.gc, x, M), S += T);
      l.push(x), c.push(S), u = Math.max(x, u), p = Math.max(S, p);
    }
    Tx(i, n);
    const O = l.indexOf(u), P = c.indexOf(p), E = /* @__PURE__ */ a((I) => ({
      width: l[I] || 0,
      height: c[I] || 0
    }), "valueAt");
    return {
      first: E(0),
      last: E(n - 1),
      widest: E(O),
      highest: E(P),
      widths: l,
      heights: c
    };
  }
  getLabelForValue(t) {
    return t;
  }
  getPixelForValue(t, n) {
    return NaN;
  }
  getValueForPixel(t) {
  }
  getPixelForTick(t) {
    const n = this.ticks;
    return t < 0 || t > n.length - 1 ? null : this.getPixelForValue(n[t].value);
  }
  getPixelForDecimal(t) {
    this._reversePixels && (t = 1 - t);
    const n = this._startPixel + t * this._length;
    return fC(this._alignToPixels ? Ho(this.chart, n, 0) : n);
  }
  getDecimalForPixel(t) {
    const n = (t - this._startPixel) / this._length;
    return this._reversePixels ? 1 - n : n;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: t, max: n } = this;
    return t < 0 && n < 0 ? n : t > 0 && n > 0 ? t : 0;
  }
  getContext(t) {
    const n = this.ticks || [];
    if (t >= 0 && t < n.length) {
      const o = n[t];
      return o.$context || (o.$context = Ox(this.getContext(), t, o));
    }
    return this.$context || (this.$context = kx(this.chart.getContext(), this));
  }
  _tickSize() {
    const t = this.options.ticks, n = io(this.labelRotation), o = Math.abs(Math.cos(n)), r = Math.abs(Math.sin(n)), i = this._getLabelSizes(), l = t.autoSkipPadding || 0, c = i ? i.widest.width + l : 0, d = i ? i.highest.height + l : 0;
    return this.isHorizontal() ? d * o > c * r ? c / o : d / r : d * r < c * o ? d / o : c / r;
  }
  _isVisible() {
    const t = this.options.display;
    return t !== "auto" ? !!t : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(t) {
    const n = this.axis, o = this.chart, r = this.options, { grid: i, position: l, border: c } = r, d = i.offset, u = this.isHorizontal(), f = this.ticks.length + (d ? 1 : 0), m = ii(i), b = [], C = c.setContext(this.getContext()), g = C.display ? C.width : 0, y = g / 2, w = /* @__PURE__ */ a(function(L) {
      return Ho(o, L, g);
    }, "alignBorderValue");
    let T, x, S, M, O, P, E, I, v, _, R, j;
    if (l === "top")
      T = w(this.bottom), P = this.bottom - m, I = T - y, _ = w(t.top) + y, j = t.bottom;
    else if (l === "bottom")
      T = w(this.top), _ = t.top, j = w(t.bottom) - y, P = T + y, I = this.top + m;
    else if (l === "left")
      T = w(this.right), O = this.right - m, E = T - y, v = w(t.left) + y, R = t.right;
    else if (l === "right")
      T = w(this.left), v = t.left, R = w(t.right) - y, O = T + y, E = this.left + m;
    else if (n === "x") {
      if (l === "center")
        T = w((t.top + t.bottom) / 2 + 0.5);
      else if (Ne(l)) {
        const L = Object.keys(l)[0], D = l[L];
        T = w(this.chart.scales[L].getPixelForValue(D));
      }
      _ = t.top, j = t.bottom, P = T + y, I = P + m;
    } else if (n === "y") {
      if (l === "center")
        T = w((t.left + t.right) / 2);
      else if (Ne(l)) {
        const L = Object.keys(l)[0], D = l[L];
        T = w(this.chart.scales[L].getPixelForValue(D));
      }
      O = T - y, E = O - m, v = t.left, R = t.right;
    }
    const B = je(r.ticks.maxTicksLimit, f), V = Math.max(1, Math.ceil(f / B));
    for (x = 0; x < f; x += V) {
      const L = this.getContext(x), D = i.setContext(L), z = c.setContext(L), H = D.lineWidth, $ = D.color, A = z.dash || [], U = z.dashOffset, K = D.tickWidth, J = D.tickColor, F = D.tickBorderDash || [], N = D.tickBorderDashOffset;
      S = Mx(this, x, d), S !== void 0 && (M = Ho(o, S, H), u ? O = E = v = R = M : P = I = _ = j = M, b.push({
        tx1: O,
        ty1: P,
        tx2: E,
        ty2: I,
        x1: v,
        y1: _,
        x2: R,
        y2: j,
        width: H,
        color: $,
        borderDash: A,
        borderDashOffset: U,
        tickWidth: K,
        tickColor: J,
        tickBorderDash: F,
        tickBorderDashOffset: N
      }));
    }
    return this._ticksLength = f, this._borderValue = T, b;
  }
  _computeLabelItems(t) {
    const n = this.axis, o = this.options, { position: r, ticks: i } = o, l = this.isHorizontal(), c = this.ticks, { align: d, crossAlign: u, padding: p, mirror: f } = i, m = ii(o.grid), b = m + p, C = f ? -p : b, g = -io(this.labelRotation), y = [];
    let w, T, x, S, M, O, P, E, I, v, _, R, j = "middle";
    if (r === "top")
      O = this.bottom - C, P = this._getXAxisLabelAlignment();
    else if (r === "bottom")
      O = this.top + C, P = this._getXAxisLabelAlignment();
    else if (r === "left") {
      const V = this._getYAxisLabelAlignment(m);
      P = V.textAlign, M = V.x;
    } else if (r === "right") {
      const V = this._getYAxisLabelAlignment(m);
      P = V.textAlign, M = V.x;
    } else if (n === "x") {
      if (r === "center")
        O = (t.top + t.bottom) / 2 + b;
      else if (Ne(r)) {
        const V = Object.keys(r)[0], L = r[V];
        O = this.chart.scales[V].getPixelForValue(L) + b;
      }
      P = this._getXAxisLabelAlignment();
    } else if (n === "y") {
      if (r === "center")
        M = (t.left + t.right) / 2 - b;
      else if (Ne(r)) {
        const V = Object.keys(r)[0], L = r[V];
        M = this.chart.scales[V].getPixelForValue(L);
      }
      P = this._getYAxisLabelAlignment(m).textAlign;
    }
    n === "y" && (d === "start" ? j = "top" : d === "end" && (j = "bottom"));
    const B = this._getLabelSizes();
    for (w = 0, T = c.length; w < T; ++w) {
      x = c[w], S = x.label;
      const V = i.setContext(this.getContext(w));
      E = this.getPixelForTick(w) + i.labelOffset, I = this._resolveTickFontOptions(w), v = I.lineHeight, _ = Et(S) ? S.length : 1;
      const L = _ / 2, D = V.color, z = V.textStrokeColor, H = V.textStrokeWidth;
      let $ = P;
      l ? (M = E, P === "inner" && (w === T - 1 ? $ = this.options.reverse ? "left" : "right" : w === 0 ? $ = this.options.reverse ? "right" : "left" : $ = "center"), r === "top" ? u === "near" || g !== 0 ? R = -_ * v + v / 2 : u === "center" ? R = -B.highest.height / 2 - L * v + v : R = -B.highest.height + v / 2 : u === "near" || g !== 0 ? R = v / 2 : u === "center" ? R = B.highest.height / 2 - L * v : R = B.highest.height - _ * v, f && (R *= -1), g !== 0 && !V.showLabelBackdrop && (M += v / 2 * Math.sin(g))) : (O = E, R = (1 - _) * v / 2);
      let A;
      if (V.showLabelBackdrop) {
        const U = pn(V.backdropPadding), K = B.heights[w], J = B.widths[w];
        let F = R - U.top, N = 0 - U.left;
        switch (j) {
          case "middle":
            F -= K / 2;
            break;
          case "bottom":
            F -= K;
            break;
        }
        switch (P) {
          case "center":
            N -= J / 2;
            break;
          case "right":
            N -= J;
            break;
          case "inner":
            w === T - 1 ? N -= J : w > 0 && (N -= J / 2);
            break;
        }
        A = {
          left: N,
          top: F,
          width: J + U.width,
          height: K + U.height,
          color: V.backdropColor
        };
      }
      y.push({
        label: S,
        font: I,
        textOffset: R,
        options: {
          rotation: g,
          color: D,
          strokeColor: z,
          strokeWidth: H,
          textAlign: $,
          textBaseline: j,
          translation: [
            M,
            O
          ],
          backdrop: A
        }
      });
    }
    return y;
  }
  _getXAxisLabelAlignment() {
    const { position: t, ticks: n } = this.options;
    if (-io(this.labelRotation))
      return t === "top" ? "left" : "right";
    let r = "center";
    return n.align === "start" ? r = "left" : n.align === "end" ? r = "right" : n.align === "inner" && (r = "inner"), r;
  }
  _getYAxisLabelAlignment(t) {
    const { position: n, ticks: { crossAlign: o, mirror: r, padding: i } } = this.options, l = this._getLabelSizes(), c = t + i, d = l.widest.width;
    let u, p;
    return n === "left" ? r ? (p = this.right + i, o === "near" ? u = "left" : o === "center" ? (u = "center", p += d / 2) : (u = "right", p += d)) : (p = this.right - c, o === "near" ? u = "right" : o === "center" ? (u = "center", p -= d / 2) : (u = "left", p = this.left)) : n === "right" ? r ? (p = this.left + i, o === "near" ? u = "right" : o === "center" ? (u = "center", p -= d / 2) : (u = "left", p -= d)) : (p = this.left + c, o === "near" ? u = "left" : o === "center" ? (u = "center", p += d / 2) : (u = "right", p = this.right)) : u = "right", {
      textAlign: u,
      x: p
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const t = this.chart, n = this.options.position;
    if (n === "left" || n === "right")
      return {
        top: 0,
        left: this.left,
        bottom: t.height,
        right: this.right
      };
    if (n === "top" || n === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: t.width
      };
  }
  drawBackground() {
    const { ctx: t, options: { backgroundColor: n }, left: o, top: r, width: i, height: l } = this;
    n && (t.save(), t.fillStyle = n, t.fillRect(o, r, i, l), t.restore());
  }
  getLineWidthForValue(t) {
    const n = this.options.grid;
    if (!this._isVisible() || !n.display)
      return 0;
    const r = this.ticks.findIndex((i) => i.value === t);
    return r >= 0 ? n.setContext(this.getContext(r)).lineWidth : 0;
  }
  drawGrid(t) {
    const n = this.options.grid, o = this.ctx, r = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(t));
    let i, l;
    const c = /* @__PURE__ */ a((d, u, p) => {
      !p.width || !p.color || (o.save(), o.lineWidth = p.width, o.strokeStyle = p.color, o.setLineDash(p.borderDash || []), o.lineDashOffset = p.borderDashOffset, o.beginPath(), o.moveTo(d.x, d.y), o.lineTo(u.x, u.y), o.stroke(), o.restore());
    }, "drawLine");
    if (n.display)
      for (i = 0, l = r.length; i < l; ++i) {
        const d = r[i];
        n.drawOnChartArea && c({
          x: d.x1,
          y: d.y1
        }, {
          x: d.x2,
          y: d.y2
        }, d), n.drawTicks && c({
          x: d.tx1,
          y: d.ty1
        }, {
          x: d.tx2,
          y: d.ty2
        }, {
          color: d.tickColor,
          width: d.tickWidth,
          borderDash: d.tickBorderDash,
          borderDashOffset: d.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: t, ctx: n, options: { border: o, grid: r } } = this, i = o.setContext(this.getContext()), l = o.display ? i.width : 0;
    if (!l)
      return;
    const c = r.setContext(this.getContext(0)).lineWidth, d = this._borderValue;
    let u, p, f, m;
    this.isHorizontal() ? (u = Ho(t, this.left, l) - l / 2, p = Ho(t, this.right, c) + c / 2, f = m = d) : (f = Ho(t, this.top, l) - l / 2, m = Ho(t, this.bottom, c) + c / 2, u = p = d), n.save(), n.lineWidth = i.width, n.strokeStyle = i.color, n.beginPath(), n.moveTo(u, f), n.lineTo(p, m), n.stroke(), n.restore();
  }
  drawLabels(t) {
    if (!this.options.ticks.display)
      return;
    const o = this.ctx, r = this._computeLabelArea();
    r && Xc(o, r);
    const i = this.getLabelItems(t);
    for (const l of i) {
      const c = l.options, d = l.font, u = l.label, p = l.textOffset;
      Xi(o, u, 0, p, d, c);
    }
    r && Jc(o);
  }
  drawTitle() {
    const { ctx: t, options: { position: n, title: o, reverse: r } } = this;
    if (!o.display)
      return;
    const i = Lt(o.font), l = pn(o.padding), c = o.align;
    let d = i.lineHeight / 2;
    n === "bottom" || n === "center" || Ne(n) ? (d += l.bottom, Et(o.text) && (d += i.lineHeight * (o.text.length - 1))) : d += l.top;
    const { titleX: u, titleY: p, maxWidth: f, rotation: m } = $x(this, d, n, c);
    Xi(t, o.text, 0, 0, i, {
      color: o.color,
      maxWidth: f,
      rotation: m,
      textAlign: Ex(c, n, r),
      textBaseline: "middle",
      translation: [
        u,
        p
      ]
    });
  }
  draw(t) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(t), this.drawBorder(), this.drawTitle(), this.drawLabels(t));
  }
  _layers() {
    const t = this.options, n = t.ticks && t.ticks.z || 0, o = je(t.grid && t.grid.z, -1), r = je(t.border && t.border.z, 0);
    return !this._isVisible() || this.draw !== za.prototype.draw ? [
      {
        z: n,
        draw: /* @__PURE__ */ a((i) => {
          this.draw(i);
        }, "draw")
      }
    ] : [
      {
        z: o,
        draw: /* @__PURE__ */ a((i) => {
          this.drawBackground(), this.drawGrid(i), this.drawTitle();
        }, "draw")
      },
      {
        z: r,
        draw: /* @__PURE__ */ a(() => {
          this.drawBorder();
        }, "draw")
      },
      {
        z: n,
        draw: /* @__PURE__ */ a((i) => {
          this.drawLabels(i);
        }, "draw")
      }
    ];
  }
  getMatchingVisibleMetas(t) {
    const n = this.chart.getSortedVisibleDatasetMetas(), o = this.axis + "AxisID", r = [];
    let i, l;
    for (i = 0, l = n.length; i < l; ++i) {
      const c = n[i];
      c[o] === this.id && (!t || c.type === t) && r.push(c);
    }
    return r;
  }
  _resolveTickFontOptions(t) {
    const n = this.options.ticks.setContext(this.getContext(t));
    return Lt(n.font);
  }
  _maxDigits() {
    const t = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / t;
  }
};
a(za, "Scale");
let Br = za;
const h2 = class h2 {
  constructor(t, n, o) {
    this.type = t, this.scope = n, this.override = o, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(t) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, t.prototype);
  }
  register(t) {
    const n = Object.getPrototypeOf(t);
    let o;
    Rx(n) && (o = this.register(n));
    const r = this.items, i = t.id, l = this.scope + "." + i;
    if (!i)
      throw new Error("class does not have id: " + t);
    return i in r || (r[i] = t, Px(t, l, o), this.override && yt.override(t.id, t.overrides)), l;
  }
  get(t) {
    return this.items[t];
  }
  unregister(t) {
    const n = this.items, o = t.id, r = this.scope;
    o in n && delete n[o], r && o in yt[r] && (delete yt[r][o], this.override && delete rr[o]);
  }
};
a(h2, "TypedRegistry");
let Cr = h2;
function Px(e, t, n) {
  const o = Jn(/* @__PURE__ */ Object.create(null), [
    n ? yt.get(n) : {},
    yt.get(t),
    e.defaults
  ]);
  yt.set(t, o), e.defaultRoutes && _x(t, e.defaultRoutes), e.descriptors && yt.describe(t, e.descriptors);
}
a(Px, "registerDefaults");
function _x(e, t) {
  Object.keys(t).forEach((n) => {
    const o = n.split("."), r = o.pop(), i = [
      e
    ].concat(o).join("."), l = t[n].split("."), c = l.pop(), d = l.join(".");
    yt.route(i, r, d, c);
  });
}
a(_x, "routeDefaults");
function Rx(e) {
  return "id" in e && "defaults" in e;
}
a(Rx, "isIChartComponent");
const g2 = class g2 {
  constructor() {
    this.controllers = new Cr(Ar, "datasets", !0), this.elements = new Cr(fo, "elements"), this.plugins = new Cr(Object, "plugins"), this.scales = new Cr(Br, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...t) {
    this._each("register", t);
  }
  remove(...t) {
    this._each("unregister", t);
  }
  addControllers(...t) {
    this._each("register", t, this.controllers);
  }
  addElements(...t) {
    this._each("register", t, this.elements);
  }
  addPlugins(...t) {
    this._each("register", t, this.plugins);
  }
  addScales(...t) {
    this._each("register", t, this.scales);
  }
  getController(t) {
    return this._get(t, this.controllers, "controller");
  }
  getElement(t) {
    return this._get(t, this.elements, "element");
  }
  getPlugin(t) {
    return this._get(t, this.plugins, "plugin");
  }
  getScale(t) {
    return this._get(t, this.scales, "scale");
  }
  removeControllers(...t) {
    this._each("unregister", t, this.controllers);
  }
  removeElements(...t) {
    this._each("unregister", t, this.elements);
  }
  removePlugins(...t) {
    this._each("unregister", t, this.plugins);
  }
  removeScales(...t) {
    this._each("unregister", t, this.scales);
  }
  _each(t, n, o) {
    [
      ...n
    ].forEach((r) => {
      const i = o || this._getRegistryForType(r);
      o || i.isForType(r) || i === this.plugins && r.id ? this._exec(t, i, r) : qe(r, (l) => {
        const c = o || this._getRegistryForType(l);
        this._exec(t, c, l);
      });
    });
  }
  _exec(t, n, o) {
    const r = Uc(t);
    st(o["before" + r], [], o), n[t](o), st(o["after" + r], [], o);
  }
  _getRegistryForType(t) {
    for (let n = 0; n < this._typedRegistries.length; n++) {
      const o = this._typedRegistries[n];
      if (o.isForType(t))
        return o;
    }
    return this.plugins;
  }
  _get(t, n, o) {
    const r = n.get(t);
    if (r === void 0)
      throw new Error('"' + t + '" is not a registered ' + o + ".");
    return r;
  }
};
a(g2, "Registry");
let N1 = g2;
var zn = /* @__PURE__ */ new N1();
const m2 = class m2 {
  constructor() {
    this._init = [];
  }
  notify(t, n, o, r) {
    n === "beforeInit" && (this._init = this._createDescriptors(t, !0), this._notify(this._init, t, "install"));
    const i = r ? this._descriptors(t).filter(r) : this._descriptors(t), l = this._notify(i, t, n, o);
    return n === "afterDestroy" && (this._notify(i, t, "stop"), this._notify(this._init, t, "uninstall")), l;
  }
  _notify(t, n, o, r) {
    r = r || {};
    for (const i of t) {
      const l = i.plugin, c = l[o], d = [
        n,
        r,
        i.options
      ];
      if (st(c, d, l) === !1 && r.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    He(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(t) {
    if (this._cache)
      return this._cache;
    const n = this._cache = this._createDescriptors(t);
    return this._notifyStateChanges(t), n;
  }
  _createDescriptors(t, n) {
    const o = t && t.config, r = je(o.options && o.options.plugins, {}), i = Ix(o);
    return r === !1 && !n ? [] : Lx(t, i, r, n);
  }
  _notifyStateChanges(t) {
    const n = this._oldCache || [], o = this._cache, r = /* @__PURE__ */ a((i, l) => i.filter((c) => !l.some((d) => c.plugin.id === d.plugin.id)), "diff");
    this._notify(r(n, o), t, "stop"), this._notify(r(o, n), t, "start");
  }
};
a(m2, "PluginService");
let z1 = m2;
function Ix(e) {
  const t = {}, n = [], o = Object.keys(zn.plugins.items);
  for (let i = 0; i < o.length; i++)
    n.push(zn.getPlugin(o[i]));
  const r = e.plugins || [];
  for (let i = 0; i < r.length; i++) {
    const l = r[i];
    n.indexOf(l) === -1 && (n.push(l), t[l.id] = !0);
  }
  return {
    plugins: n,
    localIds: t
  };
}
a(Ix, "allPlugins");
function jx(e, t) {
  return !t && e === !1 ? null : e === !0 ? {} : e;
}
a(jx, "getOpts");
function Lx(e, { plugins: t, localIds: n }, o, r) {
  const i = [], l = e.getContext();
  for (const c of t) {
    const d = c.id, u = jx(o[d], r);
    u !== null && i.push({
      plugin: c,
      options: Vx(e.config, {
        plugin: c,
        local: n[d]
      }, u, l)
    });
  }
  return i;
}
a(Lx, "createDescriptors");
function Vx(e, { plugin: t, local: n }, o, r) {
  const i = e.pluginScopeKeys(t), l = e.getOptionScopes(o, i);
  return n && t.defaults && l.push(t.defaults), e.createResolver(l, r, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
a(Vx, "pluginOpts");
function F1(e, t) {
  const n = yt.datasets[e] || {};
  return ((t.datasets || {})[e] || {}).indexAxis || t.indexAxis || n.indexAxis || "x";
}
a(F1, "getIndexAxis");
function Ax(e, t) {
  let n = e;
  return e === "_index_" ? n = t : e === "_value_" && (n = t === "x" ? "y" : "x"), n;
}
a(Ax, "getAxisFromDefaultScaleID");
function Bx(e, t) {
  return e === t ? "_index_" : "_value_";
}
a(Bx, "getDefaultScaleIDFromAxis");
function K4(e) {
  if (e === "x" || e === "y" || e === "r")
    return e;
}
a(K4, "idMatchesAxis");
function Hx(e) {
  if (e === "top" || e === "bottom")
    return "x";
  if (e === "left" || e === "right")
    return "y";
}
a(Hx, "axisFromPosition");
function W1(e, ...t) {
  if (K4(e))
    return e;
  for (const n of t) {
    const o = n.axis || Hx(n.position) || e.length > 1 && K4(e[0].toLowerCase());
    if (o)
      return o;
  }
  throw new Error(`Cannot determine type of '${e}' axis. Please provide 'axis' or 'position' option.`);
}
a(W1, "determineAxis");
function X4(e, t, n) {
  if (n[t + "AxisID"] === e)
    return {
      axis: t
    };
}
a(X4, "getAxisFromDataset");
function Dx(e, t) {
  if (t.data && t.data.datasets) {
    const n = t.data.datasets.filter((o) => o.xAxisID === e || o.yAxisID === e);
    if (n.length)
      return X4(e, "x", n[0]) || X4(e, "y", n[0]);
  }
  return {};
}
a(Dx, "retrieveAxisFromDatasets");
function Nx(e, t) {
  const n = rr[e.type] || {
    scales: {}
  }, o = t.scales || {}, r = F1(e.type, t), i = /* @__PURE__ */ Object.create(null);
  return Object.keys(o).forEach((l) => {
    const c = o[l];
    if (!Ne(c))
      return console.error(`Invalid scale configuration for scale: ${l}`);
    if (c._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${l}`);
    const d = W1(l, c, Dx(l, e), yt.scales[c.type]), u = Bx(d, r), p = n.scales || {};
    i[l] = Si(/* @__PURE__ */ Object.create(null), [
      {
        axis: d
      },
      c,
      p[d],
      p[u]
    ]);
  }), e.data.datasets.forEach((l) => {
    const c = l.type || e.type, d = l.indexAxis || F1(c, t), p = (rr[c] || {}).scales || {};
    Object.keys(p).forEach((f) => {
      const m = Ax(f, d), b = l[m + "AxisID"] || m;
      i[b] = i[b] || /* @__PURE__ */ Object.create(null), Si(i[b], [
        {
          axis: m
        },
        o[b],
        p[f]
      ]);
    });
  }), Object.keys(i).forEach((l) => {
    const c = i[l];
    Si(c, [
      yt.scales[c.type],
      yt.scale
    ]);
  }), i;
}
a(Nx, "mergeScaleConfig");
function nu(e) {
  const t = e.options || (e.options = {});
  t.plugins = je(t.plugins, {}), t.scales = Nx(e, t);
}
a(nu, "initOptions");
function ou(e) {
  return e = e || {}, e.datasets = e.datasets || [], e.labels = e.labels || [], e;
}
a(ou, "initData");
function zx(e) {
  return e = e || {}, e.data = ou(e.data), nu(e), e;
}
a(zx, "initConfig");
const J4 = /* @__PURE__ */ new Map(), ru = /* @__PURE__ */ new Set();
function Ds(e, t) {
  let n = J4.get(e);
  return n || (n = t(), J4.set(e, n), ru.add(n)), n;
}
a(Ds, "cachedKeys");
const si = /* @__PURE__ */ a((e, t, n) => {
  const o = or(t, n);
  o !== void 0 && e.add(o);
}, "addIfFound"), b2 = class b2 {
  constructor(t) {
    this._config = zx(t), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(t) {
    this._config.type = t;
  }
  get data() {
    return this._config.data;
  }
  set data(t) {
    this._config.data = ou(t);
  }
  get options() {
    return this._config.options;
  }
  set options(t) {
    this._config.options = t;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const t = this._config;
    this.clearCache(), nu(t);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(t) {
    return Ds(t, () => [
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(t, n) {
    return Ds(`${t}.transition.${n}`, () => [
      [
        `datasets.${t}.transitions.${n}`,
        `transitions.${n}`
      ],
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(t, n) {
    return Ds(`${t}-${n}`, () => [
      [
        `datasets.${t}.elements.${n}`,
        `datasets.${t}`,
        `elements.${n}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(t) {
    const n = t.id, o = this.type;
    return Ds(`${o}-plugin-${n}`, () => [
      [
        `plugins.${n}`,
        ...t.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(t, n) {
    const o = this._scopeCache;
    let r = o.get(t);
    return (!r || n) && (r = /* @__PURE__ */ new Map(), o.set(t, r)), r;
  }
  getOptionScopes(t, n, o) {
    const { options: r, type: i } = this, l = this._cachedScopes(t, o), c = l.get(n);
    if (c)
      return c;
    const d = /* @__PURE__ */ new Set();
    n.forEach((p) => {
      t && (d.add(t), p.forEach((f) => si(d, t, f))), p.forEach((f) => si(d, r, f)), p.forEach((f) => si(d, rr[i] || {}, f)), p.forEach((f) => si(d, yt, f)), p.forEach((f) => si(d, _1, f));
    });
    const u = Array.from(d);
    return u.length === 0 && u.push(/* @__PURE__ */ Object.create(null)), ru.has(n) && l.set(n, u), u;
  }
  chartOptionScopes() {
    const { options: t, type: n } = this;
    return [
      t,
      rr[n] || {},
      yt.datasets[n] || {},
      {
        type: n
      },
      yt,
      _1
    ];
  }
  resolveNamedOptions(t, n, o, r = [
    ""
  ]) {
    const i = {
      $shared: !0
    }, { resolver: l, subPrefixes: c } = Q4(this._resolverCache, t, r);
    let d = l;
    if (Wx(l, n)) {
      i.$shared = !1, o = $o(o) ? o() : o;
      const u = this.createResolver(t, o, c);
      d = Lr(l, o, u);
    }
    for (const u of n)
      i[u] = d[u];
    return i;
  }
  createResolver(t, n, o = [
    ""
  ], r) {
    const { resolver: i } = Q4(this._resolverCache, t, o);
    return Ne(n) ? Lr(i, n, void 0, r) : i;
  }
};
a(b2, "Config");
let Z1 = b2;
function Q4(e, t, n) {
  let o = e.get(t);
  o || (o = /* @__PURE__ */ new Map(), e.set(t, o));
  const r = n.join();
  let i = o.get(r);
  return i || (i = {
    resolver: e2(t, n),
    subPrefixes: n.filter((c) => !c.toLowerCase().includes("hover"))
  }, o.set(r, i)), i;
}
a(Q4, "getResolver");
const Fx = /* @__PURE__ */ a((e) => Ne(e) && Object.getOwnPropertyNames(e).some((t) => $o(e[t])), "hasFunction");
function Wx(e, t) {
  const { isScriptable: n, isIndexable: o } = zd(e);
  for (const r of t) {
    const i = n(r), l = o(r), c = (l || i) && e[r];
    if (i && ($o(c) || Fx(c)) || l && Et(c))
      return !0;
  }
  return !1;
}
a(Wx, "needContext");
var Zx = "4.5.0";
const Ux = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function e6(e, t) {
  return e === "top" || e === "bottom" || Ux.indexOf(e) === -1 && t === "x";
}
a(e6, "positionIsHorizontal");
function t6(e, t) {
  return function(n, o) {
    return n[e] === o[e] ? n[t] - o[t] : n[e] - o[e];
  };
}
a(t6, "compare2Level");
function n6(e) {
  const t = e.chart, n = t.options.animation;
  t.notifyPlugins("afterRender"), st(n && n.onComplete, [
    e
  ], t);
}
a(n6, "onAnimationsComplete");
function Gx(e) {
  const t = e.chart, n = t.options.animation;
  st(n && n.onProgress, [
    e
  ], t);
}
a(Gx, "onAnimationProgress");
function iu(e) {
  return o2() && typeof e == "string" ? e = document.getElementById(e) : e && e.length && (e = e[0]), e && e.canvas && (e = e.canvas), e;
}
a(iu, "getCanvas");
const na = {}, o6 = /* @__PURE__ */ a((e) => {
  const t = iu(e);
  return Object.values(na).filter((n) => n.canvas === t).pop();
}, "getChart");
function Yx(e, t, n) {
  const o = Object.keys(e);
  for (const r of o) {
    const i = +r;
    if (i >= t) {
      const l = e[r];
      delete e[r], (n > 0 || i > t) && (e[i + n] = l);
    }
  }
}
a(Yx, "moveNumericKeys");
function qx(e, t, n, o) {
  return !n || e.type === "mouseout" ? null : o ? t : e;
}
a(qx, "determineLastEvent");
var mn;
let Nr = (mn = class {
  static register(...t) {
    zn.add(...t), r6();
  }
  static unregister(...t) {
    zn.remove(...t), r6();
  }
  constructor(t, n) {
    const o = this.config = new Z1(n), r = iu(t), i = o6(r);
    if (i)
      throw new Error("Canvas is already in use. Chart with ID '" + i.id + "' must be destroyed before the canvas with ID '" + i.canvas.id + "' can be reused.");
    const l = o.createResolver(o.chartOptionScopes(), this.getContext());
    this.platform = new (o.platform || mx(r))(), this.platform.updateConfig(o);
    const c = this.platform.acquireContext(r, l.aspectRatio), d = c && c.canvas, u = d && d.height, p = d && d.width;
    if (this.id = Jb(), this.ctx = c, this.canvas = d, this.width = p, this.height = u, this._options = l, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new z1(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = bC((f) => this.update(f), l.resizeDelay || 0), this._dataChanges = [], na[this.id] = this, !c || !d) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    no.listen(this, "complete", n6), no.listen(this, "progress", Gx), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: t, maintainAspectRatio: n }, width: o, height: r, _aspectRatio: i } = this;
    return He(t) ? n && i ? i : r ? o / r : null : t;
  }
  get data() {
    return this.config.data;
  }
  set data(t) {
    this.config.data = t;
  }
  get options() {
    return this._options;
  }
  set options(t) {
    this.config.options = t;
  }
  get registry() {
    return zn;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : k4(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return S4(this.canvas, this.ctx), this;
  }
  stop() {
    return no.stop(this), this;
  }
  resize(t, n) {
    no.running(this) ? this._resizeBeforeDraw = {
      width: t,
      height: n
    } : this._resize(t, n);
  }
  _resize(t, n) {
    const o = this.options, r = this.canvas, i = o.maintainAspectRatio && this.aspectRatio, l = this.platform.getMaximumSize(r, t, n, i), c = o.devicePixelRatio || this.platform.getDevicePixelRatio(), d = this.width ? "resize" : "attach";
    this.width = l.width, this.height = l.height, this._aspectRatio = this.aspectRatio, k4(this, c, !0) && (this.notifyPlugins("resize", {
      size: l
    }), st(o.onResize, [
      this,
      l
    ], this), this.attached && this._doResize(d) && this.render());
  }
  ensureScalesHaveIDs() {
    const n = this.options.scales || {};
    qe(n, (o, r) => {
      o.id = r;
    });
  }
  buildOrUpdateScales() {
    const t = this.options, n = t.scales, o = this.scales, r = Object.keys(o).reduce((l, c) => (l[c] = !1, l), {});
    let i = [];
    n && (i = i.concat(Object.keys(n).map((l) => {
      const c = n[l], d = W1(l, c), u = d === "r", p = d === "x";
      return {
        options: c,
        dposition: u ? "chartArea" : p ? "bottom" : "left",
        dtype: u ? "radialLinear" : p ? "category" : "linear"
      };
    }))), qe(i, (l) => {
      const c = l.options, d = c.id, u = W1(d, c), p = je(c.type, l.dtype);
      (c.position === void 0 || e6(c.position, u) !== e6(l.dposition)) && (c.position = l.dposition), r[d] = !0;
      let f = null;
      if (d in o && o[d].type === p)
        f = o[d];
      else {
        const m = zn.getScale(p);
        f = new m({
          id: d,
          type: p,
          ctx: this.ctx,
          chart: this
        }), o[f.id] = f;
      }
      f.init(c, t);
    }), qe(r, (l, c) => {
      l || delete o[c];
    }), qe(o, (l) => {
      vn.configure(this, l, l.options), vn.addBox(this, l);
    });
  }
  _updateMetasets() {
    const t = this._metasets, n = this.data.datasets.length, o = t.length;
    if (t.sort((r, i) => r.index - i.index), o > n) {
      for (let r = n; r < o; ++r)
        this._destroyDatasetMeta(r);
      t.splice(n, o - n);
    }
    this._sortedMetasets = t.slice(0).sort(t6("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: t, data: { datasets: n } } = this;
    t.length > n.length && delete this._stacks, t.forEach((o, r) => {
      n.filter((i) => i === o._dataset).length === 0 && this._destroyDatasetMeta(r);
    });
  }
  buildOrUpdateControllers() {
    const t = [], n = this.data.datasets;
    let o, r;
    for (this._removeUnreferencedMetasets(), o = 0, r = n.length; o < r; o++) {
      const i = n[o];
      let l = this.getDatasetMeta(o);
      const c = i.type || this.config.type;
      if (l.type && l.type !== c && (this._destroyDatasetMeta(o), l = this.getDatasetMeta(o)), l.type = c, l.indexAxis = i.indexAxis || F1(c, this.options), l.order = i.order || 0, l.index = o, l.label = "" + i.label, l.visible = this.isDatasetVisible(o), l.controller)
        l.controller.updateIndex(o), l.controller.linkScales();
      else {
        const d = zn.getController(c), { datasetElementType: u, dataElementType: p } = yt.datasets[c];
        Object.assign(d, {
          dataElementType: zn.getElement(p),
          datasetElementType: u && zn.getElement(u)
        }), l.controller = new d(this, o), t.push(l.controller);
      }
    }
    return this._updateMetasets(), t;
  }
  _resetElements() {
    qe(this.data.datasets, (t, n) => {
      this.getDatasetMeta(n).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(t) {
    const n = this.config;
    n.update();
    const o = this._options = n.createResolver(n.chartOptionScopes(), this.getContext()), r = this._animationsDisabled = !o.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: t,
      cancelable: !0
    }) === !1)
      return;
    const i = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let l = 0;
    for (let u = 0, p = this.data.datasets.length; u < p; u++) {
      const { controller: f } = this.getDatasetMeta(u), m = !r && i.indexOf(f) === -1;
      f.buildOrUpdateElements(m), l = Math.max(+f.getMaxOverflow(), l);
    }
    l = this._minPadding = o.layout.autoPadding ? l : 0, this._updateLayout(l), r || qe(i, (u) => {
      u.reset();
    }), this._updateDatasets(t), this.notifyPlugins("afterUpdate", {
      mode: t
    }), this._layers.sort(t6("z", "_idx"));
    const { _active: c, _lastEvent: d } = this;
    d ? this._eventHandler(d, !0) : c.length && this._updateHoverStyles(c, c, !0), this.render();
  }
  _updateScales() {
    qe(this.scales, (t) => {
      vn.removeBox(this, t);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const t = this.options, n = new Set(Object.keys(this._listeners)), o = new Set(t.events);
    (!f4(n, o) || !!this._responsiveListeners !== t.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: t } = this, n = this._getUniformDataChanges() || [];
    for (const { method: o, start: r, count: i } of n) {
      const l = o === "_removeElements" ? -i : i;
      Yx(t, r, l);
    }
  }
  _getUniformDataChanges() {
    const t = this._dataChanges;
    if (!t || !t.length)
      return;
    this._dataChanges = [];
    const n = this.data.datasets.length, o = /* @__PURE__ */ a((i) => new Set(t.filter((l) => l[0] === i).map((l, c) => c + "," + l.splice(1).join(","))), "makeSet"), r = o(0);
    for (let i = 1; i < n; i++)
      if (!f4(r, o(i)))
        return;
    return Array.from(r).map((i) => i.split(",")).map((i) => ({
      method: i[1],
      start: +i[2],
      count: +i[3]
    }));
  }
  _updateLayout(t) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    vn.update(this, this.width, this.height, t);
    const n = this.chartArea, o = n.width <= 0 || n.height <= 0;
    this._layers = [], qe(this.boxes, (r) => {
      o && r.position === "chartArea" || (r.configure && r.configure(), this._layers.push(...r._layers()));
    }, this), this._layers.forEach((r, i) => {
      r._idx = i;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(t) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: t,
      cancelable: !0
    }) !== !1) {
      for (let n = 0, o = this.data.datasets.length; n < o; ++n)
        this.getDatasetMeta(n).controller.configure();
      for (let n = 0, o = this.data.datasets.length; n < o; ++n)
        this._updateDataset(n, $o(t) ? t({
          datasetIndex: n
        }) : t);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: t
      });
    }
  }
  _updateDataset(t, n) {
    const o = this.getDatasetMeta(t), r = {
      meta: o,
      index: t,
      mode: n,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", r) !== !1 && (o.controller._update(n), r.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", r));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (no.has(this) ? this.attached && !no.running(this) && no.start(this) : (this.draw(), n6({
      chart: this
    })));
  }
  draw() {
    let t;
    if (this._resizeBeforeDraw) {
      const { width: o, height: r } = this._resizeBeforeDraw;
      this._resizeBeforeDraw = null, this._resize(o, r);
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const n = this._layers;
    for (t = 0; t < n.length && n[t].z <= 0; ++t)
      n[t].draw(this.chartArea);
    for (this._drawDatasets(); t < n.length; ++t)
      n[t].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(t) {
    const n = this._sortedMetasets, o = [];
    let r, i;
    for (r = 0, i = n.length; r < i; ++r) {
      const l = n[r];
      (!t || l.visible) && o.push(l);
    }
    return o;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const t = this.getSortedVisibleDatasetMetas();
    for (let n = t.length - 1; n >= 0; --n)
      this._drawDataset(t[n]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(t) {
    const n = this.ctx, o = {
      meta: t,
      index: t.index,
      cancelable: !0
    }, r = wy(this, t);
    this.notifyPlugins("beforeDatasetDraw", o) !== !1 && (r && Xc(n, r), t.controller.draw(), r && Jc(n), o.cancelable = !1, this.notifyPlugins("afterDatasetDraw", o));
  }
  isPointInArea(t) {
    return Ki(t, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(t, n, o, r) {
    const i = Xy.modes[n];
    return typeof i == "function" ? i(this, t, o, r) : [];
  }
  getDatasetMeta(t) {
    const n = this.data.datasets[t], o = this._metasets;
    let r = o.filter((i) => i && i._dataset === n).pop();
    return r || (r = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: n && n.order || 0,
      index: t,
      _dataset: n,
      _parsed: [],
      _sorted: !1
    }, o.push(r)), r;
  }
  getContext() {
    return this.$context || (this.$context = lr(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(t) {
    const n = this.data.datasets[t];
    if (!n)
      return !1;
    const o = this.getDatasetMeta(t);
    return typeof o.hidden == "boolean" ? !o.hidden : !n.hidden;
  }
  setDatasetVisibility(t, n) {
    const o = this.getDatasetMeta(t);
    o.hidden = !n;
  }
  toggleDataVisibility(t) {
    this._hiddenIndices[t] = !this._hiddenIndices[t];
  }
  getDataVisibility(t) {
    return !this._hiddenIndices[t];
  }
  _updateVisibility(t, n, o) {
    const r = o ? "show" : "hide", i = this.getDatasetMeta(t), l = i.controller._resolveAnimations(void 0, r);
    Gi(n) ? (i.data[n].hidden = !o, this.update()) : (this.setDatasetVisibility(t, o), l.update(i, {
      visible: o
    }), this.update((c) => c.datasetIndex === t ? r : void 0));
  }
  hide(t, n) {
    this._updateVisibility(t, n, !1);
  }
  show(t, n) {
    this._updateVisibility(t, n, !0);
  }
  _destroyDatasetMeta(t) {
    const n = this._metasets[t];
    n && n.controller && n.controller._destroy(), delete this._metasets[t];
  }
  _stop() {
    let t, n;
    for (this.stop(), no.remove(this), t = 0, n = this.data.datasets.length; t < n; ++t)
      this._destroyDatasetMeta(t);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: t, ctx: n } = this;
    this._stop(), this.config.clearCache(), t && (this.unbindEvents(), S4(t, n), this.platform.releaseContext(n), this.canvas = null, this.ctx = null), delete na[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...t) {
    return this.canvas.toDataURL(...t);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const t = this._listeners, n = this.platform, o = /* @__PURE__ */ a((i, l) => {
      n.addEventListener(this, i, l), t[i] = l;
    }, "_add"), r = /* @__PURE__ */ a((i, l, c) => {
      i.offsetX = l, i.offsetY = c, this._eventHandler(i);
    }, "listener");
    qe(this.options.events, (i) => o(i, r));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const t = this._responsiveListeners, n = this.platform, o = /* @__PURE__ */ a((d, u) => {
      n.addEventListener(this, d, u), t[d] = u;
    }, "_add"), r = /* @__PURE__ */ a((d, u) => {
      t[d] && (n.removeEventListener(this, d, u), delete t[d]);
    }, "_remove"), i = /* @__PURE__ */ a((d, u) => {
      this.canvas && this.resize(d, u);
    }, "listener");
    let l;
    const c = /* @__PURE__ */ a(() => {
      r("attach", c), this.attached = !0, this.resize(), o("resize", i), o("detach", l);
    }, "attached");
    l = /* @__PURE__ */ a(() => {
      this.attached = !1, r("resize", i), this._stop(), this._resize(0, 0), o("attach", c);
    }, "detached"), n.isAttached(this.canvas) ? c() : l();
  }
  unbindEvents() {
    qe(this._listeners, (t, n) => {
      this.platform.removeEventListener(this, n, t);
    }), this._listeners = {}, qe(this._responsiveListeners, (t, n) => {
      this.platform.removeEventListener(this, n, t);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(t, n, o) {
    const r = o ? "set" : "remove";
    let i, l, c, d;
    for (n === "dataset" && (i = this.getDatasetMeta(t[0].datasetIndex), i.controller["_" + r + "DatasetHoverStyle"]()), c = 0, d = t.length; c < d; ++c) {
      l = t[c];
      const u = l && this.getDatasetMeta(l.datasetIndex).controller;
      u && u[r + "HoverStyle"](l.element, l.datasetIndex, l.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t) {
    const n = this._active || [], o = t.map(({ datasetIndex: i, index: l }) => {
      const c = this.getDatasetMeta(i);
      if (!c)
        throw new Error("No dataset found at index " + i);
      return {
        datasetIndex: i,
        element: c.data[l],
        index: l
      };
    });
    !wa(o, n) && (this._active = o, this._lastEvent = null, this._updateHoverStyles(o, n));
  }
  notifyPlugins(t, n, o) {
    return this._plugins.notify(this, t, n, o);
  }
  isPluginEnabled(t) {
    return this._plugins._cache.filter((n) => n.plugin.id === t).length === 1;
  }
  _updateHoverStyles(t, n, o) {
    const r = this.options.hover, i = /* @__PURE__ */ a((d, u) => d.filter((p) => !u.some((f) => p.datasetIndex === f.datasetIndex && p.index === f.index)), "diff"), l = i(n, t), c = o ? t : i(t, n);
    l.length && this.updateHoverStyle(l, r.mode, !1), c.length && r.mode && this.updateHoverStyle(c, r.mode, !0);
  }
  _eventHandler(t, n) {
    const o = {
      event: t,
      replay: n,
      cancelable: !0,
      inChartArea: this.isPointInArea(t)
    }, r = /* @__PURE__ */ a((l) => (l.options.events || this.options.events).includes(t.native.type), "eventFilter");
    if (this.notifyPlugins("beforeEvent", o, r) === !1)
      return;
    const i = this._handleEvent(t, n, o.inChartArea);
    return o.cancelable = !1, this.notifyPlugins("afterEvent", o, r), (i || o.changed) && this.render(), this;
  }
  _handleEvent(t, n, o) {
    const { _active: r = [], options: i } = this, l = n, c = this._getActiveElements(t, r, o, l), d = rC(t), u = qx(t, this._lastEvent, o, d);
    o && (this._lastEvent = null, st(i.onHover, [
      t,
      c,
      this
    ], this), d && st(i.onClick, [
      t,
      c,
      this
    ], this));
    const p = !wa(c, r);
    return (p || n) && (this._active = c, this._updateHoverStyles(c, r, n)), this._lastEvent = u, p;
  }
  _getActiveElements(t, n, o, r) {
    if (t.type === "mouseout")
      return [];
    if (!o)
      return n;
    const i = this.options.hover;
    return this.getElementsAtEventForMode(t, i.mode, i, r);
  }
}, a(mn, "Chart"), pe(mn, "defaults", yt), pe(mn, "instances", na), pe(mn, "overrides", rr), pe(mn, "registry", zn), pe(mn, "version", Zx), pe(mn, "getChart", o6), mn);
function r6() {
  return qe(Nr.instances, (e) => e._plugins.invalidate());
}
a(r6, "invalidatePlugins");
function Kx(e, t, n) {
  const { startAngle: o, x: r, y: i, outerRadius: l, innerRadius: c, options: d } = t, { borderWidth: u, borderJoinStyle: p } = d, f = Math.min(u / l, Pn(o - n));
  if (e.beginPath(), e.arc(r, i, l - u / 2, o + f / 2, n - f / 2), c > 0) {
    const m = Math.min(u / c, Pn(o - n));
    e.arc(r, i, c + u / 2, n - m / 2, o + m / 2, !0);
  } else {
    const m = Math.min(u / 2, l * Pn(o - n));
    if (p === "round")
      e.arc(r, i, m, n - Qe / 2, o + Qe / 2, !0);
    else if (p === "bevel") {
      const b = 2 * m * m, C = -b * Math.cos(n + Qe / 2) + r, g = -b * Math.sin(n + Qe / 2) + i, y = b * Math.cos(o + Qe / 2) + r, w = b * Math.sin(o + Qe / 2) + i;
      e.lineTo(C, g), e.lineTo(y, w);
    }
  }
  e.closePath(), e.moveTo(0, 0), e.rect(0, 0, e.canvas.width, e.canvas.height), e.clip("evenodd");
}
a(Kx, "clipSelf");
function Xx(e, t, n) {
  const { startAngle: o, pixelMargin: r, x: i, y: l, outerRadius: c, innerRadius: d } = t;
  let u = r / c;
  e.beginPath(), e.arc(i, l, c, o - u, n + u), d > r ? (u = r / d, e.arc(i, l, d, n + u, o - u, !0)) : e.arc(i, l, r, n + Pt, o - Pt), e.closePath(), e.clip();
}
a(Xx, "clipArc");
function Jx(e) {
  return Qc(e, [
    "outerStart",
    "outerEnd",
    "innerStart",
    "innerEnd"
  ]);
}
a(Jx, "toRadiusCorners");
function Qx(e, t, n, o) {
  const r = Jx(e.options.borderRadius), i = (n - t) / 2, l = Math.min(i, o * t / 2), c = /* @__PURE__ */ a((d) => {
    const u = (n - Math.min(i, d)) * o / 2;
    return Nt(d, 0, Math.min(i, u));
  }, "computeOuterLimit");
  return {
    outerStart: c(r.outerStart),
    outerEnd: c(r.outerEnd),
    innerStart: Nt(r.innerStart, 0, l),
    innerEnd: Nt(r.innerEnd, 0, l)
  };
}
a(Qx, "parseBorderRadius$1");
function mr(e, t, n, o) {
  return {
    x: n + e * Math.cos(t),
    y: o + e * Math.sin(t)
  };
}
a(mr, "rThetaToXY");
function _a(e, t, n, o, r, i) {
  const { x: l, y: c, startAngle: d, pixelMargin: u, innerRadius: p } = t, f = Math.max(t.outerRadius + o + n - u, 0), m = p > 0 ? p + o + n + u : 0;
  let b = 0;
  const C = r - d;
  if (o) {
    const V = p > 0 ? p - o : 0, L = f > 0 ? f - o : 0, D = (V + L) / 2, z = D !== 0 ? C * D / (D + o) : C;
    b = (C - z) / 2;
  }
  const g = Math.max(1e-3, C * f - n / Qe) / f, y = (C - g) / 2, w = d + y + b, T = r - y - b, { outerStart: x, outerEnd: S, innerStart: M, innerEnd: O } = Qx(t, m, f, T - w), P = f - x, E = f - S, I = w + x / P, v = T - S / E, _ = m + M, R = m + O, j = w + M / _, B = T - O / R;
  if (e.beginPath(), i) {
    const V = (I + v) / 2;
    if (e.arc(l, c, f, I, V), e.arc(l, c, f, V, v), S > 0) {
      const H = mr(E, v, l, c);
      e.arc(H.x, H.y, S, v, T + Pt);
    }
    const L = mr(R, T, l, c);
    if (e.lineTo(L.x, L.y), O > 0) {
      const H = mr(R, B, l, c);
      e.arc(H.x, H.y, O, T + Pt, B + Math.PI);
    }
    const D = (T - O / m + (w + M / m)) / 2;
    if (e.arc(l, c, m, T - O / m, D, !0), e.arc(l, c, m, D, w + M / m, !0), M > 0) {
      const H = mr(_, j, l, c);
      e.arc(H.x, H.y, M, j + Math.PI, w - Pt);
    }
    const z = mr(P, w, l, c);
    if (e.lineTo(z.x, z.y), x > 0) {
      const H = mr(P, I, l, c);
      e.arc(H.x, H.y, x, w - Pt, I);
    }
  } else {
    e.moveTo(l, c);
    const V = Math.cos(I) * f + l, L = Math.sin(I) * f + c;
    e.lineTo(V, L);
    const D = Math.cos(v) * f + l, z = Math.sin(v) * f + c;
    e.lineTo(D, z);
  }
  e.closePath();
}
a(_a, "pathArc");
function ev(e, t, n, o, r) {
  const { fullCircles: i, startAngle: l, circumference: c } = t;
  let d = t.endAngle;
  if (i) {
    _a(e, t, n, o, d, r);
    for (let u = 0; u < i; ++u)
      e.fill();
    isNaN(c) || (d = l + (c % Ct || Ct));
  }
  return _a(e, t, n, o, d, r), e.fill(), d;
}
a(ev, "drawArc");
function tv(e, t, n, o, r) {
  const { fullCircles: i, startAngle: l, circumference: c, options: d } = t, { borderWidth: u, borderJoinStyle: p, borderDash: f, borderDashOffset: m, borderRadius: b } = d, C = d.borderAlign === "inner";
  if (!u)
    return;
  e.setLineDash(f || []), e.lineDashOffset = m, C ? (e.lineWidth = u * 2, e.lineJoin = p || "round") : (e.lineWidth = u, e.lineJoin = p || "bevel");
  let g = t.endAngle;
  if (i) {
    _a(e, t, n, o, g, r);
    for (let y = 0; y < i; ++y)
      e.stroke();
    isNaN(c) || (g = l + (c % Ct || Ct));
  }
  C && Xx(e, t, g), d.selfJoin && g - l >= Qe && b === 0 && p !== "miter" && Kx(e, t, g), i || (_a(e, t, n, o, g, r), e.stroke());
}
a(tv, "drawBorder");
const Uo = class Uo extends fo {
  constructor(n) {
    super();
    pe(this, "circumference");
    pe(this, "endAngle");
    pe(this, "fullCircles");
    pe(this, "innerRadius");
    pe(this, "outerRadius");
    pe(this, "pixelMargin");
    pe(this, "startAngle");
    this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, n && Object.assign(this, n);
  }
  inRange(n, o, r) {
    const i = this.getProps([
      "x",
      "y"
    ], r), { angle: l, distance: c } = jd(i, {
      x: n,
      y: o
    }), { startAngle: d, endAngle: u, innerRadius: p, outerRadius: f, circumference: m } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], r), b = (this.options.spacing + this.options.borderWidth) / 2, C = je(m, u - d), g = qi(l, d, u) && d !== u, y = C >= Ct || g, w = wo(c, p + b, f + b);
    return y && w;
  }
  getCenterPoint(n) {
    const { x: o, y: r, startAngle: i, endAngle: l, innerRadius: c, outerRadius: d } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius"
    ], n), { offset: u, spacing: p } = this.options, f = (i + l) / 2, m = (c + d + p + u) / 2;
    return {
      x: o + Math.cos(f) * m,
      y: r + Math.sin(f) * m
    };
  }
  tooltipPosition(n) {
    return this.getCenterPoint(n);
  }
  draw(n) {
    const { options: o, circumference: r } = this, i = (o.offset || 0) / 4, l = (o.spacing || 0) / 2, c = o.circular;
    if (this.pixelMargin = o.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = r > Ct ? Math.floor(r / Ct) : 0, r === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    n.save();
    const d = (this.startAngle + this.endAngle) / 2;
    n.translate(Math.cos(d) * i, Math.sin(d) * i);
    const u = 1 - Math.sin(Math.min(Qe, r || 0)), p = i * u;
    n.fillStyle = o.backgroundColor, n.strokeStyle = o.borderColor, ev(n, this, p, l, c), tv(n, this, p, l, c), n.restore();
  }
};
a(Uo, "ArcElement"), pe(Uo, "id", "arc"), pe(Uo, "defaults", {
  borderAlign: "center",
  borderColor: "#fff",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0,
  selfJoin: !1
}), pe(Uo, "defaultRoutes", {
  backgroundColor: "backgroundColor"
}), pe(Uo, "descriptors", {
  _scriptable: !0,
  _indexable: /* @__PURE__ */ a((n) => n !== "borderDash", "_indexable")
});
let Ra = Uo;
function su(e, t, n = t) {
  e.lineCap = je(n.borderCapStyle, t.borderCapStyle), e.setLineDash(je(n.borderDash, t.borderDash)), e.lineDashOffset = je(n.borderDashOffset, t.borderDashOffset), e.lineJoin = je(n.borderJoinStyle, t.borderJoinStyle), e.lineWidth = je(n.borderWidth, t.borderWidth), e.strokeStyle = je(n.borderColor, t.borderColor);
}
a(su, "setStyle");
function nv(e, t, n) {
  e.lineTo(n.x, n.y);
}
a(nv, "lineTo");
function ov(e) {
  return e.stepped ? PC : e.tension || e.cubicInterpolationMode === "monotone" ? _C : nv;
}
a(ov, "getLineMethod");
function au(e, t, n = {}) {
  const o = e.length, { start: r = 0, end: i = o - 1 } = n, { start: l, end: c } = t, d = Math.max(r, l), u = Math.min(i, c), p = r < l && i < l || r > c && i > c;
  return {
    count: o,
    start: d,
    loop: t.loop,
    ilen: u < d && !p ? o + u - d : u - d
  };
}
a(au, "pathVars");
function rv(e, t, n, o) {
  const { points: r, options: i } = t, { count: l, start: c, loop: d, ilen: u } = au(r, n, o), p = ov(i);
  let { move: f = !0, reverse: m } = o || {}, b, C, g;
  for (b = 0; b <= u; ++b)
    C = r[(c + (m ? u - b : b)) % l], !C.skip && (f ? (e.moveTo(C.x, C.y), f = !1) : p(e, g, C, m, i.stepped), g = C);
  return d && (C = r[(c + (m ? u : 0)) % l], p(e, g, C, m, i.stepped)), !!d;
}
a(rv, "pathSegment");
function iv(e, t, n, o) {
  const r = t.points, { count: i, start: l, ilen: c } = au(r, n, o), { move: d = !0, reverse: u } = o || {};
  let p = 0, f = 0, m, b, C, g, y, w;
  const T = /* @__PURE__ */ a((S) => (l + (u ? c - S : S)) % i, "pointIndex"), x = /* @__PURE__ */ a(() => {
    g !== y && (e.lineTo(p, y), e.lineTo(p, g), e.lineTo(p, w));
  }, "drawX");
  for (d && (b = r[T(0)], e.moveTo(b.x, b.y)), m = 0; m <= c; ++m) {
    if (b = r[T(m)], b.skip)
      continue;
    const S = b.x, M = b.y, O = S | 0;
    O === C ? (M < g ? g = M : M > y && (y = M), p = (f * p + S) / ++f) : (x(), e.lineTo(S, M), C = O, f = 0, g = y = M), w = M;
  }
  x();
}
a(iv, "fastPathSegment");
function U1(e) {
  const t = e.options, n = t.borderDash && t.borderDash.length;
  return !e._decimated && !e._loop && !t.tension && t.cubicInterpolationMode !== "monotone" && !t.stepped && !n ? iv : rv;
}
a(U1, "_getSegmentMethod");
function sv(e) {
  return e.stepped ? cy : e.tension || e.cubicInterpolationMode === "monotone" ? dy : Wo;
}
a(sv, "_getInterpolationMethod");
function av(e, t, n, o) {
  let r = t._path;
  r || (r = t._path = new Path2D(), t.path(r, n, o) && r.closePath()), su(e, t.options), e.stroke(r);
}
a(av, "strokePathWithCache");
function lv(e, t, n, o) {
  const { segments: r, options: i } = t, l = U1(t);
  for (const c of r)
    su(e, i, c.style), e.beginPath(), l(e, t, c, {
      start: n,
      end: n + o - 1
    }) && e.closePath(), e.stroke();
}
a(lv, "strokePathDirect");
const cv = typeof Path2D == "function";
function dv(e, t, n, o) {
  cv && !t.options.segment ? av(e, t, n, o) : lv(e, t, n, o);
}
a(dv, "draw");
const Go = class Go extends fo {
  constructor(t) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, t && Object.assign(this, t);
  }
  updateControlPoints(t, n) {
    const o = this.options;
    if ((o.tension || o.cubicInterpolationMode === "monotone") && !o.stepped && !this._pointsUpdated) {
      const r = o.spanGaps ? this._loop : this._fullLoop;
      ty(this._points, o, t, r, n), this._pointsUpdated = !0;
    }
  }
  set points(t) {
    this._points = t, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = Cy(this, this.options.segment));
  }
  first() {
    const t = this.segments, n = this.points;
    return t.length && n[t[0].start];
  }
  last() {
    const t = this.segments, n = this.points, o = t.length;
    return o && n[t[o - 1].end];
  }
  interpolate(t, n) {
    const o = this.options, r = t[n], i = this.points, l = gy(this, {
      property: n,
      start: r,
      end: r
    });
    if (!l.length)
      return;
    const c = [], d = sv(o);
    let u, p;
    for (u = 0, p = l.length; u < p; ++u) {
      const { start: f, end: m } = l[u], b = i[f], C = i[m];
      if (b === C) {
        c.push(b);
        continue;
      }
      const g = Math.abs((r - b[n]) / (C[n] - b[n])), y = d(b, C, g, o.stepped);
      y[n] = t[n], c.push(y);
    }
    return c.length === 1 ? c[0] : c;
  }
  pathSegment(t, n, o) {
    return U1(this)(t, this, n, o);
  }
  path(t, n, o) {
    const r = this.segments, i = U1(this);
    let l = this._loop;
    n = n || 0, o = o || this.points.length - n;
    for (const c of r)
      l &= i(t, this, c, {
        start: n,
        end: n + o - 1
      });
    return !!l;
  }
  draw(t, n, o, r) {
    const i = this.options || {};
    (this.points || []).length && i.borderWidth && (t.save(), dv(t, this, o, r), t.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
};
a(Go, "LineElement"), pe(Go, "id", "line"), pe(Go, "defaults", {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
}), pe(Go, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
}), pe(Go, "descriptors", {
  _scriptable: !0,
  _indexable: /* @__PURE__ */ a((t) => t !== "borderDash" && t !== "fill", "_indexable")
});
let G1 = Go;
function i6(e, t, n, o) {
  const r = e.options, { [n]: i } = e.getProps([
    n
  ], o);
  return Math.abs(t - i) < r.radius + r.hitRadius;
}
a(i6, "inRange$1");
const wr = class wr extends fo {
  constructor(n) {
    super();
    pe(this, "parsed");
    pe(this, "skip");
    pe(this, "stop");
    this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, n && Object.assign(this, n);
  }
  inRange(n, o, r) {
    const i = this.options, { x: l, y: c } = this.getProps([
      "x",
      "y"
    ], r);
    return Math.pow(n - l, 2) + Math.pow(o - c, 2) < Math.pow(i.hitRadius + i.radius, 2);
  }
  inXRange(n, o) {
    return i6(this, n, "x", o);
  }
  inYRange(n, o) {
    return i6(this, n, "y", o);
  }
  getCenterPoint(n) {
    const { x: o, y: r } = this.getProps([
      "x",
      "y"
    ], n);
    return {
      x: o,
      y: r
    };
  }
  size(n) {
    n = n || this.options || {};
    let o = n.radius || 0;
    o = Math.max(o, o && n.hoverRadius || 0);
    const r = o && n.borderWidth || 0;
    return (o + r) * 2;
  }
  draw(n, o) {
    const r = this.options;
    this.skip || r.radius < 0.1 || !Ki(this, o, this.size(r) / 2) || (n.strokeStyle = r.borderColor, n.lineWidth = r.borderWidth, n.fillStyle = r.backgroundColor, I1(n, r, this.x, this.y));
  }
  getRange() {
    const n = this.options || {};
    return n.radius + n.hitRadius;
  }
};
a(wr, "PointElement"), pe(wr, "id", "point"), /**
* @type {any}
*/
pe(wr, "defaults", {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
}), /**
* @type {any}
*/
pe(wr, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
let Ia = wr;
function lu(e, t) {
  const { x: n, y: o, base: r, width: i, height: l } = e.getProps([
    "x",
    "y",
    "base",
    "width",
    "height"
  ], t);
  let c, d, u, p, f;
  return e.horizontal ? (f = l / 2, c = Math.min(n, r), d = Math.max(n, r), u = o - f, p = o + f) : (f = i / 2, c = n - f, d = n + f, u = Math.min(o, r), p = Math.max(o, r)), {
    left: c,
    top: u,
    right: d,
    bottom: p
  };
}
a(lu, "getBarBounds");
function So(e, t, n, o) {
  return e ? 0 : Nt(t, n, o);
}
a(So, "skipOrLimit");
function uv(e, t, n) {
  const o = e.options.borderWidth, r = e.borderSkipped, i = Nd(o);
  return {
    t: So(r.top, i.top, 0, n),
    r: So(r.right, i.right, 0, t),
    b: So(r.bottom, i.bottom, 0, n),
    l: So(r.left, i.left, 0, t)
  };
}
a(uv, "parseBorderWidth");
function pv(e, t, n) {
  const { enableBorderRadius: o } = e.getProps([
    "enableBorderRadius"
  ]), r = e.options.borderRadius, i = kr(r), l = Math.min(t, n), c = e.borderSkipped, d = o || Ne(r);
  return {
    topLeft: So(!d || c.top || c.left, i.topLeft, 0, l),
    topRight: So(!d || c.top || c.right, i.topRight, 0, l),
    bottomLeft: So(!d || c.bottom || c.left, i.bottomLeft, 0, l),
    bottomRight: So(!d || c.bottom || c.right, i.bottomRight, 0, l)
  };
}
a(pv, "parseBorderRadius");
function fv(e) {
  const t = lu(e), n = t.right - t.left, o = t.bottom - t.top, r = uv(e, n / 2, o / 2), i = pv(e, n / 2, o / 2);
  return {
    outer: {
      x: t.left,
      y: t.top,
      w: n,
      h: o,
      radius: i
    },
    inner: {
      x: t.left + r.l,
      y: t.top + r.t,
      w: n - r.l - r.r,
      h: o - r.t - r.b,
      radius: {
        topLeft: Math.max(0, i.topLeft - Math.max(r.t, r.l)),
        topRight: Math.max(0, i.topRight - Math.max(r.t, r.r)),
        bottomLeft: Math.max(0, i.bottomLeft - Math.max(r.b, r.l)),
        bottomRight: Math.max(0, i.bottomRight - Math.max(r.b, r.r))
      }
    }
  };
}
a(fv, "boundingRects$1");
function n1(e, t, n, o) {
  const r = t === null, i = n === null, c = e && !(r && i) && lu(e, o);
  return c && (r || wo(t, c.left, c.right)) && (i || wo(n, c.top, c.bottom));
}
a(n1, "inRange");
function hv(e) {
  return e.topLeft || e.topRight || e.bottomLeft || e.bottomRight;
}
a(hv, "hasRadius");
function gv(e, t) {
  e.rect(t.x, t.y, t.w, t.h);
}
a(gv, "addNormalRectPath");
function o1(e, t, n = {}) {
  const o = e.x !== n.x ? -t : 0, r = e.y !== n.y ? -t : 0, i = (e.x + e.w !== n.x + n.w ? t : 0) - o, l = (e.y + e.h !== n.y + n.h ? t : 0) - r;
  return {
    x: e.x + o,
    y: e.y + r,
    w: e.w + i,
    h: e.h + l,
    radius: e.radius
  };
}
a(o1, "inflateRect");
const Sr = class Sr extends fo {
  constructor(t) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, t && Object.assign(this, t);
  }
  draw(t) {
    const { inflateAmount: n, options: { borderColor: o, backgroundColor: r } } = this, { inner: i, outer: l } = fv(this), c = hv(l.radius) ? Ta : gv;
    t.save(), (l.w !== i.w || l.h !== i.h) && (t.beginPath(), c(t, o1(l, n, i)), t.clip(), c(t, o1(i, -n, l)), t.fillStyle = o, t.fill("evenodd")), t.beginPath(), c(t, o1(i, n)), t.fillStyle = r, t.fill(), t.restore();
  }
  inRange(t, n, o) {
    return n1(this, t, n, o);
  }
  inXRange(t, n) {
    return n1(this, t, null, n);
  }
  inYRange(t, n) {
    return n1(this, null, t, n);
  }
  getCenterPoint(t) {
    const { x: n, y: o, base: r, horizontal: i } = this.getProps([
      "x",
      "y",
      "base",
      "horizontal"
    ], t);
    return {
      x: i ? (n + r) / 2 : n,
      y: i ? o : (o + r) / 2
    };
  }
  getRange(t) {
    return t === "x" ? this.width / 2 : this.height / 2;
  }
};
a(Sr, "BarElement"), pe(Sr, "id", "bar"), pe(Sr, "defaults", {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
}), pe(Sr, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
let ja = Sr;
const s6 = /* @__PURE__ */ a((e, t) => {
  let { boxHeight: n = t, boxWidth: o = t } = e;
  return e.usePointStyle && (n = Math.min(n, t), o = e.pointStyleWidth || Math.min(o, t)), {
    boxWidth: o,
    boxHeight: n,
    itemHeight: Math.max(t, n)
  };
}, "getBoxSize"), mv = /* @__PURE__ */ a((e, t) => e !== null && t !== null && e.datasetIndex === t.datasetIndex && e.index === t.index, "itemsEqual"), C2 = class C2 extends fo {
  constructor(t) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, n, o) {
    this.maxWidth = t, this.maxHeight = n, this._margins = o, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const t = this.options.labels || {};
    let n = st(t.generateLabels, [
      this.chart
    ], this) || [];
    t.filter && (n = n.filter((o) => t.filter(o, this.chart.data))), t.sort && (n = n.sort((o, r) => t.sort(o, r, this.chart.data))), this.options.reverse && n.reverse(), this.legendItems = n;
  }
  fit() {
    const { options: t, ctx: n } = this;
    if (!t.display) {
      this.width = this.height = 0;
      return;
    }
    const o = t.labels, r = Lt(o.font), i = r.size, l = this._computeTitleHeight(), { boxWidth: c, itemHeight: d } = s6(o, i);
    let u, p;
    n.font = r.string, this.isHorizontal() ? (u = this.maxWidth, p = this._fitRows(l, i, c, d) + 10) : (p = this.maxHeight, u = this._fitCols(l, r, c, d) + 10), this.width = Math.min(u, t.maxWidth || this.maxWidth), this.height = Math.min(p, t.maxHeight || this.maxHeight);
  }
  _fitRows(t, n, o, r) {
    const { ctx: i, maxWidth: l, options: { labels: { padding: c } } } = this, d = this.legendHitBoxes = [], u = this.lineWidths = [
      0
    ], p = r + c;
    let f = t;
    i.textAlign = "left", i.textBaseline = "middle";
    let m = -1, b = -p;
    return this.legendItems.forEach((C, g) => {
      const y = o + n / 2 + i.measureText(C.text).width;
      (g === 0 || u[u.length - 1] + y + 2 * c > l) && (f += p, u[u.length - (g > 0 ? 0 : 1)] = 0, b += p, m++), d[g] = {
        left: 0,
        top: b,
        row: m,
        width: y,
        height: r
      }, u[u.length - 1] += y + c;
    }), f;
  }
  _fitCols(t, n, o, r) {
    const { ctx: i, maxHeight: l, options: { labels: { padding: c } } } = this, d = this.legendHitBoxes = [], u = this.columnSizes = [], p = l - t;
    let f = c, m = 0, b = 0, C = 0, g = 0;
    return this.legendItems.forEach((y, w) => {
      const { itemWidth: T, itemHeight: x } = bv(o, n, i, y, r);
      w > 0 && b + x + 2 * c > p && (f += m + c, u.push({
        width: m,
        height: b
      }), C += m + c, g++, m = b = 0), d[w] = {
        left: C,
        top: b,
        col: g,
        width: T,
        height: x
      }, m = Math.max(m, T), b += x + c;
    }), f += m, u.push({
      width: m,
      height: b
    }), f;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const t = this._computeTitleHeight(), { legendHitBoxes: n, options: { align: o, labels: { padding: r }, rtl: i } } = this, l = Or(i, this.left, this.width);
    if (this.isHorizontal()) {
      let c = 0, d = Ht(o, this.left + r, this.right - this.lineWidths[c]);
      for (const u of n)
        c !== u.row && (c = u.row, d = Ht(o, this.left + r, this.right - this.lineWidths[c])), u.top += this.top + t + r, u.left = l.leftForLtr(l.x(d), u.width), d += u.width + r;
    } else {
      let c = 0, d = Ht(o, this.top + t + r, this.bottom - this.columnSizes[c].height);
      for (const u of n)
        u.col !== c && (c = u.col, d = Ht(o, this.top + t + r, this.bottom - this.columnSizes[c].height)), u.top = d, u.left += this.left + r, u.left = l.leftForLtr(l.x(u.left), u.width), d += u.height + r;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const t = this.ctx;
      Xc(t, this), this._draw(), Jc(t);
    }
  }
  _draw() {
    const { options: t, columnSizes: n, lineWidths: o, ctx: r } = this, { align: i, labels: l } = t, c = yt.color, d = Or(t.rtl, this.left, this.width), u = Lt(l.font), { padding: p } = l, f = u.size, m = f / 2;
    let b;
    this.drawTitle(), r.textAlign = d.textAlign("left"), r.textBaseline = "middle", r.lineWidth = 0.5, r.font = u.string;
    const { boxWidth: C, boxHeight: g, itemHeight: y } = s6(l, f), w = /* @__PURE__ */ a(function(O, P, E) {
      if (isNaN(C) || C <= 0 || isNaN(g) || g < 0)
        return;
      r.save();
      const I = je(E.lineWidth, 1);
      if (r.fillStyle = je(E.fillStyle, c), r.lineCap = je(E.lineCap, "butt"), r.lineDashOffset = je(E.lineDashOffset, 0), r.lineJoin = je(E.lineJoin, "miter"), r.lineWidth = I, r.strokeStyle = je(E.strokeStyle, c), r.setLineDash(je(E.lineDash, [])), l.usePointStyle) {
        const v = {
          radius: g * Math.SQRT2 / 2,
          pointStyle: E.pointStyle,
          rotation: E.rotation,
          borderWidth: I
        }, _ = d.xPlus(O, C / 2), R = P + m;
        Dd(r, v, _, R, l.pointStyleWidth && C);
      } else {
        const v = P + Math.max((f - g) / 2, 0), _ = d.leftForLtr(O, C), R = kr(E.borderRadius);
        r.beginPath(), Object.values(R).some((j) => j !== 0) ? Ta(r, {
          x: _,
          y: v,
          w: C,
          h: g,
          radius: R
        }) : r.rect(_, v, C, g), r.fill(), I !== 0 && r.stroke();
      }
      r.restore();
    }, "drawLegendBox"), T = /* @__PURE__ */ a(function(O, P, E) {
      Xi(r, E.text, O, P + y / 2, u, {
        strikethrough: E.hidden,
        textAlign: d.textAlign(E.textAlign)
      });
    }, "fillText"), x = this.isHorizontal(), S = this._computeTitleHeight();
    x ? b = {
      x: Ht(i, this.left + p, this.right - o[0]),
      y: this.top + p + S,
      line: 0
    } : b = {
      x: this.left + p,
      y: Ht(i, this.top + S + p, this.bottom - n[0].height),
      line: 0
    }, Gd(this.ctx, t.textDirection);
    const M = y + p;
    this.legendItems.forEach((O, P) => {
      r.strokeStyle = O.fontColor, r.fillStyle = O.fontColor;
      const E = r.measureText(O.text).width, I = d.textAlign(O.textAlign || (O.textAlign = l.textAlign)), v = C + m + E;
      let _ = b.x, R = b.y;
      d.setWidth(this.width), x ? P > 0 && _ + v + p > this.right && (R = b.y += M, b.line++, _ = b.x = Ht(i, this.left + p, this.right - o[b.line])) : P > 0 && R + M > this.bottom && (_ = b.x = _ + n[b.line].width + p, b.line++, R = b.y = Ht(i, this.top + S + p, this.bottom - n[b.line].height));
      const j = d.x(_);
      if (w(j, R, O), _ = CC(I, _ + C + m, x ? _ + v : this.right, t.rtl), T(d.x(_), R, O), x)
        b.x += v + p;
      else if (typeof O.text != "string") {
        const B = u.lineHeight;
        b.y += cu(O, B) + p;
      } else
        b.y += M;
    }), Yd(this.ctx, t.textDirection);
  }
  drawTitle() {
    const t = this.options, n = t.title, o = Lt(n.font), r = pn(n.padding);
    if (!n.display)
      return;
    const i = Or(t.rtl, this.left, this.width), l = this.ctx, c = n.position, d = o.size / 2, u = r.top + d;
    let p, f = this.left, m = this.width;
    if (this.isHorizontal())
      m = Math.max(...this.lineWidths), p = this.top + u, f = Ht(t.align, f, this.right - m);
    else {
      const C = this.columnSizes.reduce((g, y) => Math.max(g, y.height), 0);
      p = u + Ht(t.align, this.top, this.bottom - C - t.labels.padding - this._computeTitleHeight());
    }
    const b = Ht(c, f, f + m);
    l.textAlign = i.textAlign(Yc(c)), l.textBaseline = "middle", l.strokeStyle = n.color, l.fillStyle = n.color, l.font = o.string, Xi(l, n.text, b, p, o);
  }
  _computeTitleHeight() {
    const t = this.options.title, n = Lt(t.font), o = pn(t.padding);
    return t.display ? n.lineHeight + o.height : 0;
  }
  _getLegendItemAt(t, n) {
    let o, r, i;
    if (wo(t, this.left, this.right) && wo(n, this.top, this.bottom)) {
      for (i = this.legendHitBoxes, o = 0; o < i.length; ++o)
        if (r = i[o], wo(t, r.left, r.left + r.width) && wo(n, r.top, r.top + r.height))
          return this.legendItems[o];
    }
    return null;
  }
  handleEvent(t) {
    const n = this.options;
    if (!xv(t.type, n))
      return;
    const o = this._getLegendItemAt(t.x, t.y);
    if (t.type === "mousemove" || t.type === "mouseout") {
      const r = this._hoveredItem, i = mv(r, o);
      r && !i && st(n.onLeave, [
        t,
        r,
        this
      ], this), this._hoveredItem = o, o && !i && st(n.onHover, [
        t,
        o,
        this
      ], this);
    } else o && st(n.onClick, [
      t,
      o,
      this
    ], this);
  }
};
a(C2, "Legend");
let La = C2;
function bv(e, t, n, o, r) {
  const i = Cv(o, e, t, n), l = yv(r, o, t.lineHeight);
  return {
    itemWidth: i,
    itemHeight: l
  };
}
a(bv, "calculateItemSize");
function Cv(e, t, n, o) {
  let r = e.text;
  return r && typeof r != "string" && (r = r.reduce((i, l) => i.length > l.length ? i : l)), t + n.size / 2 + o.measureText(r).width;
}
a(Cv, "calculateItemWidth");
function yv(e, t, n) {
  let o = e;
  return typeof t.text != "string" && (o = cu(t, n)), o;
}
a(yv, "calculateItemHeight");
function cu(e, t) {
  const n = e.text ? e.text.length : 0;
  return t * n;
}
a(cu, "calculateLegendItemHeight");
function xv(e, t) {
  return !!((e === "mousemove" || e === "mouseout") && (t.onHover || t.onLeave) || t.onClick && (e === "click" || e === "mouseup"));
}
a(xv, "isListened");
var du = {
  id: "legend",
  _element: La,
  start(e, t, n) {
    const o = e.legend = new La({
      ctx: e.ctx,
      options: n,
      chart: e
    });
    vn.configure(e, o, n), vn.addBox(e, o);
  },
  stop(e) {
    vn.removeBox(e, e.legend), delete e.legend;
  },
  beforeUpdate(e, t, n) {
    const o = e.legend;
    vn.configure(e, o, n), o.options = n;
  },
  afterUpdate(e) {
    const t = e.legend;
    t.buildLabels(), t.adjustHitBoxes();
  },
  afterEvent(e, t) {
    t.replay || e.legend.handleEvent(t.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(e, t, n) {
      const o = t.datasetIndex, r = n.chart;
      r.isDatasetVisible(o) ? (r.hide(o), t.hidden = !0) : (r.show(o), t.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: /* @__PURE__ */ a((e) => e.chart.options.color, "color"),
      boxWidth: 40,
      padding: 10,
      generateLabels(e) {
        const t = e.data.datasets, { labels: { usePointStyle: n, pointStyle: o, textAlign: r, color: i, useBorderRadius: l, borderRadius: c } } = e.legend.options;
        return e._getSortedDatasetMetas().map((d) => {
          const u = d.controller.getStyle(n ? 0 : void 0), p = pn(u.borderWidth);
          return {
            text: t[d.index].label,
            fillStyle: u.backgroundColor,
            fontColor: i,
            hidden: !d.visible,
            lineCap: u.borderCapStyle,
            lineDash: u.borderDash,
            lineDashOffset: u.borderDashOffset,
            lineJoin: u.borderJoinStyle,
            lineWidth: (p.width + p.height) / 4,
            strokeStyle: u.borderColor,
            pointStyle: o || u.pointStyle,
            rotation: u.rotation,
            textAlign: r || u.textAlign,
            borderRadius: l && (c || u.borderRadius),
            datasetIndex: d.index
          };
        }, this);
      }
    },
    title: {
      color: /* @__PURE__ */ a((e) => e.chart.options.color, "color"),
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: /* @__PURE__ */ a((e) => !e.startsWith("on"), "_scriptable"),
    labels: {
      _scriptable: /* @__PURE__ */ a((e) => ![
        "generateLabels",
        "filter",
        "sort"
      ].includes(e), "_scriptable")
    }
  }
}, Er;
let uu = (Er = class extends fo {
  constructor(t) {
    super(), this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this._padding = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, n) {
    const o = this.options;
    if (this.left = 0, this.top = 0, !o.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = t, this.height = this.bottom = n;
    const r = Et(o.text) ? o.text.length : 1;
    this._padding = pn(o.padding);
    const i = r * Lt(o.font).lineHeight + this._padding.height;
    this.isHorizontal() ? this.height = i : this.width = i;
  }
  isHorizontal() {
    const t = this.options.position;
    return t === "top" || t === "bottom";
  }
  _drawArgs(t) {
    const { top: n, left: o, bottom: r, right: i, options: l } = this, c = l.align;
    let d = 0, u, p, f;
    return this.isHorizontal() ? (p = Ht(c, o, i), f = n + t, u = i - o) : (l.position === "left" ? (p = o + t, f = Ht(c, r, n), d = Qe * -0.5) : (p = i - t, f = Ht(c, n, r), d = Qe * 0.5), u = r - n), {
      titleX: p,
      titleY: f,
      maxWidth: u,
      rotation: d
    };
  }
  draw() {
    const t = this.ctx, n = this.options;
    if (!n.display)
      return;
    const o = Lt(n.font), i = o.lineHeight / 2 + this._padding.top, { titleX: l, titleY: c, maxWidth: d, rotation: u } = this._drawArgs(i);
    Xi(t, n.text, 0, 0, o, {
      color: n.color,
      maxWidth: d,
      rotation: u,
      textAlign: Yc(n.align),
      textBaseline: "middle",
      translation: [
        l,
        c
      ]
    });
  }
}, a(Er, "Title"), Er);
function vv(e, t) {
  const n = new uu({
    ctx: e.ctx,
    options: t,
    chart: e
  });
  vn.configure(e, n, t), vn.addBox(e, n), e.titleBlock = n;
}
a(vv, "createTitle");
var pu = {
  id: "title",
  _element: uu,
  start(e, t, n) {
    vv(e, n);
  },
  stop(e) {
    const t = e.titleBlock;
    vn.removeBox(e, t), delete e.titleBlock;
  },
  beforeUpdate(e, t, n) {
    const o = e.titleBlock;
    vn.configure(e, o, n), o.options = n;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "bold"
    },
    fullSize: !0,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const mi = {
  average(e) {
    if (!e.length)
      return !1;
    let t, n, o = /* @__PURE__ */ new Set(), r = 0, i = 0;
    for (t = 0, n = e.length; t < n; ++t) {
      const c = e[t].element;
      if (c && c.hasValue()) {
        const d = c.tooltipPosition();
        o.add(d.x), r += d.y, ++i;
      }
    }
    return i === 0 || o.size === 0 ? !1 : {
      x: [
        ...o
      ].reduce((c, d) => c + d) / o.size,
      y: r / i
    };
  },
  nearest(e, t) {
    if (!e.length)
      return !1;
    let n = t.x, o = t.y, r = Number.POSITIVE_INFINITY, i, l, c;
    for (i = 0, l = e.length; i < l; ++i) {
      const d = e[i].element;
      if (d && d.hasValue()) {
        const u = d.getCenterPoint(), p = P1(t, u);
        p < r && (r = p, c = d);
      }
    }
    if (c) {
      const d = c.tooltipPosition();
      n = d.x, o = d.y;
    }
    return {
      x: n,
      y: o
    };
  }
};
function Nn(e, t) {
  return t && (Et(t) ? Array.prototype.push.apply(e, t) : e.push(t)), e;
}
a(Nn, "pushOrConcat");
function oo(e) {
  return (typeof e == "string" || e instanceof String) && e.indexOf(`
`) > -1 ? e.split(`
`) : e;
}
a(oo, "splitNewlines");
function wv(e, t) {
  const { element: n, datasetIndex: o, index: r } = t, i = e.getDatasetMeta(o).controller, { label: l, value: c } = i.getLabelAndValue(r);
  return {
    chart: e,
    label: l,
    parsed: i.getParsed(r),
    raw: e.data.datasets[o].data[r],
    formattedValue: c,
    dataset: i.getDataset(),
    dataIndex: r,
    datasetIndex: o,
    element: n
  };
}
a(wv, "createTooltipItem");
function a6(e, t) {
  const n = e.chart.ctx, { body: o, footer: r, title: i } = e, { boxWidth: l, boxHeight: c } = t, d = Lt(t.bodyFont), u = Lt(t.titleFont), p = Lt(t.footerFont), f = i.length, m = r.length, b = o.length, C = pn(t.padding);
  let g = C.height, y = 0, w = o.reduce((S, M) => S + M.before.length + M.lines.length + M.after.length, 0);
  if (w += e.beforeBody.length + e.afterBody.length, f && (g += f * u.lineHeight + (f - 1) * t.titleSpacing + t.titleMarginBottom), w) {
    const S = t.displayColors ? Math.max(c, d.lineHeight) : d.lineHeight;
    g += b * S + (w - b) * d.lineHeight + (w - 1) * t.bodySpacing;
  }
  m && (g += t.footerMarginTop + m * p.lineHeight + (m - 1) * t.footerSpacing);
  let T = 0;
  const x = /* @__PURE__ */ a(function(S) {
    y = Math.max(y, n.measureText(S).width + T);
  }, "maxLineWidth");
  return n.save(), n.font = u.string, qe(e.title, x), n.font = d.string, qe(e.beforeBody.concat(e.afterBody), x), T = t.displayColors ? l + 2 + t.boxPadding : 0, qe(o, (S) => {
    qe(S.before, x), qe(S.lines, x), qe(S.after, x);
  }), T = 0, n.font = p.string, qe(e.footer, x), n.restore(), y += C.width, {
    width: y,
    height: g
  };
}
a(a6, "getTooltipSize");
function Sv(e, t) {
  const { y: n, height: o } = t;
  return n < o / 2 ? "top" : n > e.height - o / 2 ? "bottom" : "center";
}
a(Sv, "determineYAlign");
function Mv(e, t, n, o) {
  const { x: r, width: i } = o, l = n.caretSize + n.caretPadding;
  if (e === "left" && r + i + l > t.width || e === "right" && r - i - l < 0)
    return !0;
}
a(Mv, "doesNotFitWithAlign");
function Tv(e, t, n, o) {
  const { x: r, width: i } = n, { width: l, chartArea: { left: c, right: d } } = e;
  let u = "center";
  return o === "center" ? u = r <= (c + d) / 2 ? "left" : "right" : r <= i / 2 ? u = "left" : r >= l - i / 2 && (u = "right"), Mv(u, e, t, n) && (u = "center"), u;
}
a(Tv, "determineXAlign");
function l6(e, t, n) {
  const o = n.yAlign || t.yAlign || Sv(e, n);
  return {
    xAlign: n.xAlign || t.xAlign || Tv(e, t, n, o),
    yAlign: o
  };
}
a(l6, "determineAlignment");
function kv(e, t) {
  let { x: n, width: o } = e;
  return t === "right" ? n -= o : t === "center" && (n -= o / 2), n;
}
a(kv, "alignX");
function Ov(e, t, n) {
  let { y: o, height: r } = e;
  return t === "top" ? o += n : t === "bottom" ? o -= r + n : o -= r / 2, o;
}
a(Ov, "alignY");
function c6(e, t, n, o) {
  const { caretSize: r, caretPadding: i, cornerRadius: l } = e, { xAlign: c, yAlign: d } = n, u = r + i, { topLeft: p, topRight: f, bottomLeft: m, bottomRight: b } = kr(l);
  let C = kv(t, c);
  const g = Ov(t, d, u);
  return d === "center" ? c === "left" ? C += u : c === "right" && (C -= u) : c === "left" ? C -= Math.max(p, m) + r : c === "right" && (C += Math.max(f, b) + r), {
    x: Nt(C, 0, o.width - t.width),
    y: Nt(g, 0, o.height - t.height)
  };
}
a(c6, "getBackgroundPoint");
function Ns(e, t, n) {
  const o = pn(n.padding);
  return t === "center" ? e.x + e.width / 2 : t === "right" ? e.x + e.width - o.right : e.x + o.left;
}
a(Ns, "getAlignedX");
function d6(e) {
  return Nn([], oo(e));
}
a(d6, "getBeforeAfterBodyLines");
function Ev(e, t, n) {
  return lr(e, {
    tooltip: t,
    tooltipItems: n,
    type: "tooltip"
  });
}
a(Ev, "createTooltipContext");
function u6(e, t) {
  const n = t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
  return n ? e.override(n) : e;
}
a(u6, "overrideCallbacks");
const fu = {
  beforeTitle: to,
  title(e) {
    if (e.length > 0) {
      const t = e[0], n = t.chart.data.labels, o = n ? n.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return t.dataset.label || "";
      if (t.label)
        return t.label;
      if (o > 0 && t.dataIndex < o)
        return n[t.dataIndex];
    }
    return "";
  },
  afterTitle: to,
  beforeBody: to,
  beforeLabel: to,
  label(e) {
    if (this && this.options && this.options.mode === "dataset")
      return e.label + ": " + e.formattedValue || e.formattedValue;
    let t = e.dataset.label || "";
    t && (t += ": ");
    const n = e.formattedValue;
    return He(n) || (t += n), t;
  },
  labelColor(e) {
    const n = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      borderColor: n.borderColor,
      backgroundColor: n.backgroundColor,
      borderWidth: n.borderWidth,
      borderDash: n.borderDash,
      borderDashOffset: n.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(e) {
    const n = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      pointStyle: n.pointStyle,
      rotation: n.rotation
    };
  },
  afterLabel: to,
  afterBody: to,
  beforeFooter: to,
  footer: to,
  afterFooter: to
};
function Gt(e, t, n, o) {
  const r = e[t].call(n, o);
  return typeof r > "u" ? fu[t].call(n, o) : r;
}
a(Gt, "invokeCallbackWithFallback");
var Jo;
let p6 = (Jo = class extends fo {
  constructor(t) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = t.chart, this.options = t.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(t) {
    this.options = t, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const t = this._cachedAnimations;
    if (t)
      return t;
    const n = this.chart, o = this.options.setContext(this.getContext()), r = o.enabled && n.options.animation && o.animations, i = new Oa(this.chart, r);
    return r._cacheable && (this._cachedAnimations = Object.freeze(i)), i;
  }
  getContext() {
    return this.$context || (this.$context = Ev(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(t, n) {
    const { callbacks: o } = n, r = Gt(o, "beforeTitle", this, t), i = Gt(o, "title", this, t), l = Gt(o, "afterTitle", this, t);
    let c = [];
    return c = Nn(c, oo(r)), c = Nn(c, oo(i)), c = Nn(c, oo(l)), c;
  }
  getBeforeBody(t, n) {
    return d6(Gt(n.callbacks, "beforeBody", this, t));
  }
  getBody(t, n) {
    const { callbacks: o } = n, r = [];
    return qe(t, (i) => {
      const l = {
        before: [],
        lines: [],
        after: []
      }, c = u6(o, i);
      Nn(l.before, oo(Gt(c, "beforeLabel", this, i))), Nn(l.lines, Gt(c, "label", this, i)), Nn(l.after, oo(Gt(c, "afterLabel", this, i))), r.push(l);
    }), r;
  }
  getAfterBody(t, n) {
    return d6(Gt(n.callbacks, "afterBody", this, t));
  }
  getFooter(t, n) {
    const { callbacks: o } = n, r = Gt(o, "beforeFooter", this, t), i = Gt(o, "footer", this, t), l = Gt(o, "afterFooter", this, t);
    let c = [];
    return c = Nn(c, oo(r)), c = Nn(c, oo(i)), c = Nn(c, oo(l)), c;
  }
  _createItems(t) {
    const n = this._active, o = this.chart.data, r = [], i = [], l = [];
    let c = [], d, u;
    for (d = 0, u = n.length; d < u; ++d)
      c.push(wv(this.chart, n[d]));
    return t.filter && (c = c.filter((p, f, m) => t.filter(p, f, m, o))), t.itemSort && (c = c.sort((p, f) => t.itemSort(p, f, o))), qe(c, (p) => {
      const f = u6(t.callbacks, p);
      r.push(Gt(f, "labelColor", this, p)), i.push(Gt(f, "labelPointStyle", this, p)), l.push(Gt(f, "labelTextColor", this, p));
    }), this.labelColors = r, this.labelPointStyles = i, this.labelTextColors = l, this.dataPoints = c, c;
  }
  update(t, n) {
    const o = this.options.setContext(this.getContext()), r = this._active;
    let i, l = [];
    if (!r.length)
      this.opacity !== 0 && (i = {
        opacity: 0
      });
    else {
      const c = mi[o.position].call(this, r, this._eventPosition);
      l = this._createItems(o), this.title = this.getTitle(l, o), this.beforeBody = this.getBeforeBody(l, o), this.body = this.getBody(l, o), this.afterBody = this.getAfterBody(l, o), this.footer = this.getFooter(l, o);
      const d = this._size = a6(this, o), u = Object.assign({}, c, d), p = l6(this.chart, o, u), f = c6(o, u, p, this.chart);
      this.xAlign = p.xAlign, this.yAlign = p.yAlign, i = {
        opacity: 1,
        x: f.x,
        y: f.y,
        width: d.width,
        height: d.height,
        caretX: c.x,
        caretY: c.y
      };
    }
    this._tooltipItems = l, this.$context = void 0, i && this._resolveAnimations().update(this, i), t && o.external && o.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: n
    });
  }
  drawCaret(t, n, o, r) {
    const i = this.getCaretPosition(t, o, r);
    n.lineTo(i.x1, i.y1), n.lineTo(i.x2, i.y2), n.lineTo(i.x3, i.y3);
  }
  getCaretPosition(t, n, o) {
    const { xAlign: r, yAlign: i } = this, { caretSize: l, cornerRadius: c } = o, { topLeft: d, topRight: u, bottomLeft: p, bottomRight: f } = kr(c), { x: m, y: b } = t, { width: C, height: g } = n;
    let y, w, T, x, S, M;
    return i === "center" ? (S = b + g / 2, r === "left" ? (y = m, w = y - l, x = S + l, M = S - l) : (y = m + C, w = y + l, x = S - l, M = S + l), T = y) : (r === "left" ? w = m + Math.max(d, p) + l : r === "right" ? w = m + C - Math.max(u, f) - l : w = this.caretX, i === "top" ? (x = b, S = x - l, y = w - l, T = w + l) : (x = b + g, S = x + l, y = w + l, T = w - l), M = x), {
      x1: y,
      x2: w,
      x3: T,
      y1: x,
      y2: S,
      y3: M
    };
  }
  drawTitle(t, n, o) {
    const r = this.title, i = r.length;
    let l, c, d;
    if (i) {
      const u = Or(o.rtl, this.x, this.width);
      for (t.x = Ns(this, o.titleAlign, o), n.textAlign = u.textAlign(o.titleAlign), n.textBaseline = "middle", l = Lt(o.titleFont), c = o.titleSpacing, n.fillStyle = o.titleColor, n.font = l.string, d = 0; d < i; ++d)
        n.fillText(r[d], u.x(t.x), t.y + l.lineHeight / 2), t.y += l.lineHeight + c, d + 1 === i && (t.y += o.titleMarginBottom - c);
    }
  }
  _drawColorBox(t, n, o, r, i) {
    const l = this.labelColors[o], c = this.labelPointStyles[o], { boxHeight: d, boxWidth: u } = i, p = Lt(i.bodyFont), f = Ns(this, "left", i), m = r.x(f), b = d < p.lineHeight ? (p.lineHeight - d) / 2 : 0, C = n.y + b;
    if (i.usePointStyle) {
      const g = {
        radius: Math.min(u, d) / 2,
        pointStyle: c.pointStyle,
        rotation: c.rotation,
        borderWidth: 1
      }, y = r.leftForLtr(m, u) + u / 2, w = C + d / 2;
      t.strokeStyle = i.multiKeyBackground, t.fillStyle = i.multiKeyBackground, I1(t, g, y, w), t.strokeStyle = l.borderColor, t.fillStyle = l.backgroundColor, I1(t, g, y, w);
    } else {
      t.lineWidth = Ne(l.borderWidth) ? Math.max(...Object.values(l.borderWidth)) : l.borderWidth || 1, t.strokeStyle = l.borderColor, t.setLineDash(l.borderDash || []), t.lineDashOffset = l.borderDashOffset || 0;
      const g = r.leftForLtr(m, u), y = r.leftForLtr(r.xPlus(m, 1), u - 2), w = kr(l.borderRadius);
      Object.values(w).some((T) => T !== 0) ? (t.beginPath(), t.fillStyle = i.multiKeyBackground, Ta(t, {
        x: g,
        y: C,
        w: u,
        h: d,
        radius: w
      }), t.fill(), t.stroke(), t.fillStyle = l.backgroundColor, t.beginPath(), Ta(t, {
        x: y,
        y: C + 1,
        w: u - 2,
        h: d - 2,
        radius: w
      }), t.fill()) : (t.fillStyle = i.multiKeyBackground, t.fillRect(g, C, u, d), t.strokeRect(g, C, u, d), t.fillStyle = l.backgroundColor, t.fillRect(y, C + 1, u - 2, d - 2));
    }
    t.fillStyle = this.labelTextColors[o];
  }
  drawBody(t, n, o) {
    const { body: r } = this, { bodySpacing: i, bodyAlign: l, displayColors: c, boxHeight: d, boxWidth: u, boxPadding: p } = o, f = Lt(o.bodyFont);
    let m = f.lineHeight, b = 0;
    const C = Or(o.rtl, this.x, this.width), g = /* @__PURE__ */ a(function(E) {
      n.fillText(E, C.x(t.x + b), t.y + m / 2), t.y += m + i;
    }, "fillLineOfText"), y = C.textAlign(l);
    let w, T, x, S, M, O, P;
    for (n.textAlign = l, n.textBaseline = "middle", n.font = f.string, t.x = Ns(this, y, o), n.fillStyle = o.bodyColor, qe(this.beforeBody, g), b = c && y !== "right" ? l === "center" ? u / 2 + p : u + 2 + p : 0, S = 0, O = r.length; S < O; ++S) {
      for (w = r[S], T = this.labelTextColors[S], n.fillStyle = T, qe(w.before, g), x = w.lines, c && x.length && (this._drawColorBox(n, t, S, C, o), m = Math.max(f.lineHeight, d)), M = 0, P = x.length; M < P; ++M)
        g(x[M]), m = f.lineHeight;
      qe(w.after, g);
    }
    b = 0, m = f.lineHeight, qe(this.afterBody, g), t.y -= i;
  }
  drawFooter(t, n, o) {
    const r = this.footer, i = r.length;
    let l, c;
    if (i) {
      const d = Or(o.rtl, this.x, this.width);
      for (t.x = Ns(this, o.footerAlign, o), t.y += o.footerMarginTop, n.textAlign = d.textAlign(o.footerAlign), n.textBaseline = "middle", l = Lt(o.footerFont), n.fillStyle = o.footerColor, n.font = l.string, c = 0; c < i; ++c)
        n.fillText(r[c], d.x(t.x), t.y + l.lineHeight / 2), t.y += l.lineHeight + o.footerSpacing;
    }
  }
  drawBackground(t, n, o, r) {
    const { xAlign: i, yAlign: l } = this, { x: c, y: d } = t, { width: u, height: p } = o, { topLeft: f, topRight: m, bottomLeft: b, bottomRight: C } = kr(r.cornerRadius);
    n.fillStyle = r.backgroundColor, n.strokeStyle = r.borderColor, n.lineWidth = r.borderWidth, n.beginPath(), n.moveTo(c + f, d), l === "top" && this.drawCaret(t, n, o, r), n.lineTo(c + u - m, d), n.quadraticCurveTo(c + u, d, c + u, d + m), l === "center" && i === "right" && this.drawCaret(t, n, o, r), n.lineTo(c + u, d + p - C), n.quadraticCurveTo(c + u, d + p, c + u - C, d + p), l === "bottom" && this.drawCaret(t, n, o, r), n.lineTo(c + b, d + p), n.quadraticCurveTo(c, d + p, c, d + p - b), l === "center" && i === "left" && this.drawCaret(t, n, o, r), n.lineTo(c, d + f), n.quadraticCurveTo(c, d, c + f, d), n.closePath(), n.fill(), r.borderWidth > 0 && n.stroke();
  }
  _updateAnimationTarget(t) {
    const n = this.chart, o = this.$animations, r = o && o.x, i = o && o.y;
    if (r || i) {
      const l = mi[t.position].call(this, this._active, this._eventPosition);
      if (!l)
        return;
      const c = this._size = a6(this, t), d = Object.assign({}, l, this._size), u = l6(n, t, d), p = c6(t, d, u, n);
      (r._to !== p.x || i._to !== p.y) && (this.xAlign = u.xAlign, this.yAlign = u.yAlign, this.width = c.width, this.height = c.height, this.caretX = l.x, this.caretY = l.y, this._resolveAnimations().update(this, p));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(t) {
    const n = this.options.setContext(this.getContext());
    let o = this.opacity;
    if (!o)
      return;
    this._updateAnimationTarget(n);
    const r = {
      width: this.width,
      height: this.height
    }, i = {
      x: this.x,
      y: this.y
    };
    o = Math.abs(o) < 1e-3 ? 0 : o;
    const l = pn(n.padding), c = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    n.enabled && c && (t.save(), t.globalAlpha = o, this.drawBackground(i, t, r, n), Gd(t, n.textDirection), i.y += l.top, this.drawTitle(i, t, n), this.drawBody(i, t, n), this.drawFooter(i, t, n), Yd(t, n.textDirection), t.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t, n) {
    const o = this._active, r = t.map(({ datasetIndex: c, index: d }) => {
      const u = this.chart.getDatasetMeta(c);
      if (!u)
        throw new Error("Cannot find a dataset at index " + c);
      return {
        datasetIndex: c,
        element: u.data[d],
        index: d
      };
    }), i = !wa(o, r), l = this._positionChanged(r, n);
    (i || l) && (this._active = r, this._eventPosition = n, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(t, n, o = !0) {
    if (n && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const r = this.options, i = this._active || [], l = this._getActiveElements(t, i, n, o), c = this._positionChanged(l, t), d = n || !wa(l, i) || c;
    return d && (this._active = l, (r.enabled || r.external) && (this._eventPosition = {
      x: t.x,
      y: t.y
    }, this.update(!0, n))), d;
  }
  _getActiveElements(t, n, o, r) {
    const i = this.options;
    if (t.type === "mouseout")
      return [];
    if (!r)
      return n.filter((c) => this.chart.data.datasets[c.datasetIndex] && this.chart.getDatasetMeta(c.datasetIndex).controller.getParsed(c.index) !== void 0);
    const l = this.chart.getElementsAtEventForMode(t, i.mode, i, o);
    return i.reverse && l.reverse(), l;
  }
  _positionChanged(t, n) {
    const { caretX: o, caretY: r, options: i } = this, l = mi[i.position].call(this, t, n);
    return l !== !1 && (o !== l.x || r !== l.y);
  }
}, a(Jo, "Tooltip"), pe(Jo, "positioners", mi), Jo);
var hu = {
  id: "tooltip",
  _element: p6,
  positioners: mi,
  afterInit(e, t, n) {
    n && (e.tooltip = new p6({
      chart: e,
      options: n
    }));
  },
  beforeUpdate(e, t, n) {
    e.tooltip && e.tooltip.initialize(n);
  },
  reset(e, t, n) {
    e.tooltip && e.tooltip.initialize(n);
  },
  afterDraw(e) {
    const t = e.tooltip;
    if (t && t._willRender()) {
      const n = {
        tooltip: t
      };
      if (e.notifyPlugins("beforeTooltipDraw", {
        ...n,
        cancelable: !0
      }) === !1)
        return;
      t.draw(e.ctx), e.notifyPlugins("afterTooltipDraw", n);
    }
  },
  afterEvent(e, t) {
    if (e.tooltip) {
      const n = t.replay;
      e.tooltip.handleEvent(t.event, n, t.inChartArea) && (t.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: /* @__PURE__ */ a((e, t) => t.bodyFont.size, "boxHeight"),
    boxWidth: /* @__PURE__ */ a((e, t) => t.bodyFont.size, "boxWidth"),
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: fu
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: /* @__PURE__ */ a((e) => e !== "filter" && e !== "itemSort" && e !== "external", "_scriptable"),
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
};
const $v = /* @__PURE__ */ a((e, t, n, o) => (typeof t == "string" ? (n = e.push(t) - 1, o.unshift({
  index: n,
  label: t
})) : isNaN(t) && (n = null), n), "addIfString");
function Pv(e, t, n, o) {
  const r = e.indexOf(t);
  if (r === -1)
    return $v(e, t, n, o);
  const i = e.lastIndexOf(t);
  return r !== i ? n : r;
}
a(Pv, "findOrAddLabel");
const _v = /* @__PURE__ */ a((e, t) => e === null ? null : Nt(Math.round(e), 0, t), "validIndex");
function f6(e) {
  const t = this.getLabels();
  return e >= 0 && e < t.length ? t[e] : e;
}
a(f6, "_getLabelForValue");
const Ri = class Ri extends Br {
  constructor(t) {
    super(t), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(t) {
    const n = this._addedLabels;
    if (n.length) {
      const o = this.getLabels();
      for (const { index: r, label: i } of n)
        o[r] === i && o.splice(r, 1);
      this._addedLabels = [];
    }
    super.init(t);
  }
  parse(t, n) {
    if (He(t))
      return null;
    const o = this.getLabels();
    return n = isFinite(n) && o[n] === t ? n : Pv(o, t, je(n, t), this._addedLabels), _v(n, o.length - 1);
  }
  determineDataLimits() {
    const { minDefined: t, maxDefined: n } = this.getUserBounds();
    let { min: o, max: r } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (t || (o = 0), n || (r = this.getLabels().length - 1)), this.min = o, this.max = r;
  }
  buildTicks() {
    const t = this.min, n = this.max, o = this.options.offset, r = [];
    let i = this.getLabels();
    i = t === 0 && n === i.length - 1 ? i : i.slice(t, n + 1), this._valueRange = Math.max(i.length - (o ? 0 : 1), 1), this._startValue = this.min - (o ? 0.5 : 0);
    for (let l = t; l <= n; l++)
      r.push({
        value: l
      });
    return r;
  }
  getLabelForValue(t) {
    return f6.call(this, t);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(t) {
    return typeof t != "number" && (t = this.parse(t)), t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getPixelForTick(t) {
    const n = this.ticks;
    return t < 0 || t > n.length - 1 ? null : this.getPixelForValue(n[t].value);
  }
  getValueForPixel(t) {
    return Math.round(this._startValue + this.getDecimalForPixel(t) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
};
a(Ri, "CategoryScale"), pe(Ri, "id", "category"), pe(Ri, "defaults", {
  ticks: {
    callback: f6
  }
});
let Va = Ri;
function Rv(e, t) {
  const n = [], { bounds: r, step: i, min: l, max: c, precision: d, count: u, maxTicks: p, maxDigits: f, includeBounds: m } = e, b = i || 1, C = p - 1, { min: g, max: y } = t, w = !He(l), T = !He(c), x = !He(u), S = (y - g) / (f + 1);
  let M = g4((y - g) / C / b) * b, O, P, E, I;
  if (M < 1e-14 && !w && !T)
    return [
      {
        value: g
      },
      {
        value: y
      }
    ];
  I = Math.ceil(y / M) - Math.floor(g / M), I > C && (M = g4(I * M / C / b) * b), He(d) || (O = Math.pow(10, d), M = Math.ceil(M * O) / O), r === "ticks" ? (P = Math.floor(g / M) * M, E = Math.ceil(y / M) * M) : (P = g, E = y), w && T && i && cC((c - l) / i, M / 1e3) ? (I = Math.round(Math.min((c - l) / M, p)), M = (c - l) / I, P = l, E = c) : x ? (P = w ? l : P, E = T ? c : E, I = u - 1, M = (E - P) / I) : (I = (E - P) / M, Mi(I, Math.round(I), M / 1e3) ? I = Math.round(I) : I = Math.ceil(I));
  const v = Math.max(m4(M), m4(P));
  O = Math.pow(10, He(d) ? v : d), P = Math.round(P * O) / O, E = Math.round(E * O) / O;
  let _ = 0;
  for (w && (m && P !== l ? (n.push({
    value: l
  }), P < l && _++, Mi(Math.round((P + _ * M) * O) / O, l, h6(l, S, e)) && _++) : P < l && _++); _ < I; ++_) {
    const R = Math.round((P + _ * M) * O) / O;
    if (T && R > c)
      break;
    n.push({
      value: R
    });
  }
  return T && m && E !== c ? n.length && Mi(n[n.length - 1].value, c, h6(c, S, e)) ? n[n.length - 1].value = c : n.push({
    value: c
  }) : (!T || E === c) && n.push({
    value: E
  }), n;
}
a(Rv, "generateTicks$1");
function h6(e, t, { horizontal: n, minRotation: o }) {
  const r = io(o), i = (n ? Math.sin(r) : Math.cos(r)) || 1e-3, l = 0.75 * t * ("" + e).length;
  return Math.min(t / i, l);
}
a(h6, "relativeLabelSize");
const y2 = class y2 extends Br {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(t, n) {
    return He(t) || (typeof t == "number" || t instanceof Number) && !isFinite(+t) ? null : +t;
  }
  handleTickRangeOptions() {
    const { beginAtZero: t } = this.options, { minDefined: n, maxDefined: o } = this.getUserBounds();
    let { min: r, max: i } = this;
    const l = /* @__PURE__ */ a((d) => r = n ? r : d, "setMin"), c = /* @__PURE__ */ a((d) => i = o ? i : d, "setMax");
    if (t) {
      const d = Yn(r), u = Yn(i);
      d < 0 && u < 0 ? c(0) : d > 0 && u > 0 && l(0);
    }
    if (r === i) {
      let d = i === 0 ? 1 : Math.abs(i * 0.05);
      c(i + d), t || l(r - d);
    }
    this.min = r, this.max = i;
  }
  getTickLimit() {
    const t = this.options.ticks;
    let { maxTicksLimit: n, stepSize: o } = t, r;
    return o ? (r = Math.ceil(this.max / o) - Math.floor(this.min / o) + 1, r > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${o} would result generating up to ${r} ticks. Limiting to 1000.`), r = 1e3)) : (r = this.computeTickLimit(), n = n || 11), n && (r = Math.min(n, r)), r;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const t = this.options, n = t.ticks;
    let o = this.getTickLimit();
    o = Math.max(2, o);
    const r = {
      maxTicks: o,
      bounds: t.bounds,
      min: t.min,
      max: t.max,
      precision: n.precision,
      step: n.stepSize,
      count: n.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: n.minRotation || 0,
      includeBounds: n.includeBounds !== !1
    }, i = this._range || this, l = Rv(r, i);
    return t.bounds === "ticks" && dC(l, this, "value"), t.reverse ? (l.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), l;
  }
  configure() {
    const t = this.ticks;
    let n = this.min, o = this.max;
    if (super.configure(), this.options.offset && t.length) {
      const r = (o - n) / Math.max(t.length - 1, 1) / 2;
      n -= r, o += r;
    }
    this._startValue = n, this._endValue = o, this._valueRange = o - n;
  }
  getLabelForValue(t) {
    return Kc(t, this.chart.options.locale, this.options.ticks.format);
  }
};
a(y2, "LinearScaleBase");
let Y1 = y2;
const Ii = class Ii extends Y1 {
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!0);
    this.min = Tn(t) ? t : 0, this.max = Tn(n) ? n : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const t = this.isHorizontal(), n = t ? this.width : this.height, o = io(this.options.ticks.minRotation), r = (t ? Math.sin(o) : Math.cos(o)) || 1e-3, i = this._resolveTickFontOptions(0);
    return Math.ceil(n / Math.min(40, i.lineHeight / r));
  }
  getPixelForValue(t) {
    return t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    return this._startValue + this.getDecimalForPixel(t) * this._valueRange;
  }
};
a(Ii, "LinearScale"), pe(Ii, "id", "linear"), pe(Ii, "defaults", {
  ticks: {
    callback: Hd.formatters.numeric
  }
});
let Aa = Ii;
const Sl = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, qt = /* @__PURE__ */ Object.keys(Sl);
function g6(e, t) {
  return e - t;
}
a(g6, "sorter");
function m6(e, t) {
  if (He(t))
    return null;
  const n = e._adapter, { parser: o, round: r, isoWeekday: i } = e._parseOpts;
  let l = t;
  return typeof o == "function" && (l = o(l)), Tn(l) || (l = typeof o == "string" ? n.parse(l, o) : n.parse(l)), l === null ? null : (r && (l = r === "week" && (Yi(i) || i === !0) ? n.startOf(l, "isoWeek", i) : n.startOf(l, r)), +l);
}
a(m6, "parse");
function b6(e, t, n, o) {
  const r = qt.length;
  for (let i = qt.indexOf(e); i < r - 1; ++i) {
    const l = Sl[qt[i]], c = l.steps ? l.steps : Number.MAX_SAFE_INTEGER;
    if (l.common && Math.ceil((n - t) / (c * l.size)) <= o)
      return qt[i];
  }
  return qt[r - 1];
}
a(b6, "determineUnitForAutoTicks");
function Iv(e, t, n, o, r) {
  for (let i = qt.length - 1; i >= qt.indexOf(n); i--) {
    const l = qt[i];
    if (Sl[l].common && e._adapter.diff(r, o, l) >= t - 1)
      return l;
  }
  return qt[n ? qt.indexOf(n) : 0];
}
a(Iv, "determineUnitForFormatting");
function jv(e) {
  for (let t = qt.indexOf(e) + 1, n = qt.length; t < n; ++t)
    if (Sl[qt[t]].common)
      return qt[t];
}
a(jv, "determineMajorUnit");
function C6(e, t, n) {
  if (!n)
    e[t] = !0;
  else if (n.length) {
    const { lo: o, hi: r } = Gc(n, t), i = n[o] >= t ? n[o] : n[r];
    e[i] = !0;
  }
}
a(C6, "addTick");
function Lv(e, t, n, o) {
  const r = e._adapter, i = +r.startOf(t[0].value, o), l = t[t.length - 1].value;
  let c, d;
  for (c = i; c <= l; c = +r.add(c, 1, o))
    d = n[c], d >= 0 && (t[d].major = !0);
  return t;
}
a(Lv, "setMajorTicks");
function y6(e, t, n) {
  const o = [], r = {}, i = t.length;
  let l, c;
  for (l = 0; l < i; ++l)
    c = t[l], r[c] = l, o.push({
      value: c,
      major: !1
    });
  return i === 0 || !n ? o : Lv(e, o, r, n);
}
a(y6, "ticksFromTimestamps");
const ji = class ji extends Br {
  constructor(t) {
    super(t), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(t, n = {}) {
    const o = t.time || (t.time = {}), r = this._adapter = new Uy._date(t.adapters.date);
    r.init(n), Si(o.displayFormats, r.formats()), this._parseOpts = {
      parser: o.parser,
      round: o.round,
      isoWeekday: o.isoWeekday
    }, super.init(t), this._normalized = n.normalized;
  }
  parse(t, n) {
    return t === void 0 ? null : m6(this, t);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const t = this.options, n = this._adapter, o = t.time.unit || "day";
    let { min: r, max: i, minDefined: l, maxDefined: c } = this.getUserBounds();
    function d(u) {
      !l && !isNaN(u.min) && (r = Math.min(r, u.min)), !c && !isNaN(u.max) && (i = Math.max(i, u.max));
    }
    a(d, "_applyBounds"), (!l || !c) && (d(this._getLabelBounds()), (t.bounds !== "ticks" || t.ticks.source !== "labels") && d(this.getMinMax(!1))), r = Tn(r) && !isNaN(r) ? r : +n.startOf(Date.now(), o), i = Tn(i) && !isNaN(i) ? i : +n.endOf(Date.now(), o) + 1, this.min = Math.min(r, i - 1), this.max = Math.max(r + 1, i);
  }
  _getLabelBounds() {
    const t = this.getLabelTimestamps();
    let n = Number.POSITIVE_INFINITY, o = Number.NEGATIVE_INFINITY;
    return t.length && (n = t[0], o = t[t.length - 1]), {
      min: n,
      max: o
    };
  }
  buildTicks() {
    const t = this.options, n = t.time, o = t.ticks, r = o.source === "labels" ? this.getLabelTimestamps() : this._generate();
    t.bounds === "ticks" && r.length && (this.min = this._userMin || r[0], this.max = this._userMax || r[r.length - 1]);
    const i = this.min, l = this.max, c = gC(r, i, l);
    return this._unit = n.unit || (o.autoSkip ? b6(n.minUnit, this.min, this.max, this._getLabelCapacity(i)) : Iv(this, c.length, n.minUnit, this.min, this.max)), this._majorUnit = !o.major.enabled || this._unit === "year" ? void 0 : jv(this._unit), this.initOffsets(r), t.reverse && c.reverse(), y6(this, c, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((t) => +t.value));
  }
  initOffsets(t = []) {
    let n = 0, o = 0, r, i;
    this.options.offset && t.length && (r = this.getDecimalForValue(t[0]), t.length === 1 ? n = 1 - r : n = (this.getDecimalForValue(t[1]) - r) / 2, i = this.getDecimalForValue(t[t.length - 1]), t.length === 1 ? o = i : o = (i - this.getDecimalForValue(t[t.length - 2])) / 2);
    const l = t.length < 3 ? 0.5 : 0.25;
    n = Nt(n, 0, l), o = Nt(o, 0, l), this._offsets = {
      start: n,
      end: o,
      factor: 1 / (n + 1 + o)
    };
  }
  _generate() {
    const t = this._adapter, n = this.min, o = this.max, r = this.options, i = r.time, l = i.unit || b6(i.minUnit, n, o, this._getLabelCapacity(n)), c = je(r.ticks.stepSize, 1), d = l === "week" ? i.isoWeekday : !1, u = Yi(d) || d === !0, p = {};
    let f = n, m, b;
    if (u && (f = +t.startOf(f, "isoWeek", d)), f = +t.startOf(f, u ? "day" : l), t.diff(o, n, l) > 1e5 * c)
      throw new Error(n + " and " + o + " are too far apart with stepSize of " + c + " " + l);
    const C = r.ticks.source === "data" && this.getDataTimestamps();
    for (m = f, b = 0; m < o; m = +t.add(m, c, l), b++)
      C6(p, m, C);
    return (m === o || r.bounds === "ticks" || b === 1) && C6(p, m, C), Object.keys(p).sort(g6).map((g) => +g);
  }
  getLabelForValue(t) {
    const n = this._adapter, o = this.options.time;
    return o.tooltipFormat ? n.format(t, o.tooltipFormat) : n.format(t, o.displayFormats.datetime);
  }
  format(t, n) {
    const r = this.options.time.displayFormats, i = this._unit, l = n || r[i];
    return this._adapter.format(t, l);
  }
  _tickFormatFunction(t, n, o, r) {
    const i = this.options, l = i.ticks.callback;
    if (l)
      return st(l, [
        t,
        n,
        o
      ], this);
    const c = i.time.displayFormats, d = this._unit, u = this._majorUnit, p = d && c[d], f = u && c[u], m = o[n], b = u && f && m && m.major;
    return this._adapter.format(t, r || (b ? f : p));
  }
  generateTickLabels(t) {
    let n, o, r;
    for (n = 0, o = t.length; n < o; ++n)
      r = t[n], r.label = this._tickFormatFunction(r.value, n, t);
  }
  getDecimalForValue(t) {
    return t === null ? NaN : (t - this.min) / (this.max - this.min);
  }
  getPixelForValue(t) {
    const n = this._offsets, o = this.getDecimalForValue(t);
    return this.getPixelForDecimal((n.start + o) * n.factor);
  }
  getValueForPixel(t) {
    const n = this._offsets, o = this.getDecimalForPixel(t) / n.factor - n.end;
    return this.min + o * (this.max - this.min);
  }
  _getLabelSize(t) {
    const n = this.options.ticks, o = this.ctx.measureText(t).width, r = io(this.isHorizontal() ? n.maxRotation : n.minRotation), i = Math.cos(r), l = Math.sin(r), c = this._resolveTickFontOptions(0).size;
    return {
      w: o * i + c * l,
      h: o * l + c * i
    };
  }
  _getLabelCapacity(t) {
    const n = this.options.time, o = n.displayFormats, r = o[n.unit] || o.millisecond, i = this._tickFormatFunction(t, 0, y6(this, [
      t
    ], this._majorUnit), r), l = this._getLabelSize(i), c = Math.floor(this.isHorizontal() ? this.width / l.w : this.height / l.h) - 1;
    return c > 0 ? c : 1;
  }
  getDataTimestamps() {
    let t = this._cache.data || [], n, o;
    if (t.length)
      return t;
    const r = this.getMatchingVisibleMetas();
    if (this._normalized && r.length)
      return this._cache.data = r[0].controller.getAllParsedValues(this);
    for (n = 0, o = r.length; n < o; ++n)
      t = t.concat(r[n].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(t);
  }
  getLabelTimestamps() {
    const t = this._cache.labels || [];
    let n, o;
    if (t.length)
      return t;
    const r = this.getLabels();
    for (n = 0, o = r.length; n < o; ++n)
      t.push(m6(this, r[n]));
    return this._cache.labels = this._normalized ? t : this.normalize(t);
  }
  normalize(t) {
    return Vd(t.sort(g6));
  }
};
a(ji, "TimeScale"), pe(ji, "id", "time"), pe(ji, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
let Ba = ji;
function zs(e, t, n) {
  let o = 0, r = e.length - 1, i, l, c, d;
  n ? (t >= e[o].pos && t <= e[r].pos && ({ lo: o, hi: r } = Xo(e, "pos", t)), { pos: i, time: c } = e[o], { pos: l, time: d } = e[r]) : (t >= e[o].time && t <= e[r].time && ({ lo: o, hi: r } = Xo(e, "time", t)), { time: i, pos: c } = e[o], { time: l, pos: d } = e[r]);
  const u = l - i;
  return u ? c + (d - c) * (t - i) / u : c;
}
a(zs, "interpolate");
const Li = class Li extends Ba {
  constructor(t) {
    super(t), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const t = this._getTimestampsForTable(), n = this._table = this.buildLookupTable(t);
    this._minPos = zs(n, this.min), this._tableRange = zs(n, this.max) - this._minPos, super.initOffsets(t);
  }
  buildLookupTable(t) {
    const { min: n, max: o } = this, r = [], i = [];
    let l, c, d, u, p;
    for (l = 0, c = t.length; l < c; ++l)
      u = t[l], u >= n && u <= o && r.push(u);
    if (r.length < 2)
      return [
        {
          time: n,
          pos: 0
        },
        {
          time: o,
          pos: 1
        }
      ];
    for (l = 0, c = r.length; l < c; ++l)
      p = r[l + 1], d = r[l - 1], u = r[l], Math.round((p + d) / 2) !== u && i.push({
        time: u,
        pos: l / (c - 1)
      });
    return i;
  }
  _generate() {
    const t = this.min, n = this.max;
    let o = super.getDataTimestamps();
    return (!o.includes(t) || !o.length) && o.splice(0, 0, t), (!o.includes(n) || o.length === 1) && o.push(n), o.sort((r, i) => r - i);
  }
  _getTimestampsForTable() {
    let t = this._cache.all || [];
    if (t.length)
      return t;
    const n = this.getDataTimestamps(), o = this.getLabelTimestamps();
    return n.length && o.length ? t = this.normalize(n.concat(o)) : t = n.length ? n : o, t = this._cache.all = t, t;
  }
  getDecimalForValue(t) {
    return (zs(this._table, t) - this._minPos) / this._tableRange;
  }
  getValueForPixel(t) {
    const n = this._offsets, o = this.getDecimalForPixel(t) / n.factor - n.end;
    return zs(this._table, o * this._tableRange + this._minPos, !0);
  }
};
a(Li, "TimeSeriesScale"), pe(Li, "id", "timeseries"), pe(Li, "defaults", Ba.defaults);
let x6 = Li;
const gu = "label";
function v6(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
a(v6, "reforwardRef");
function Vv(e, t) {
  const n = e.options;
  n && t && Object.assign(n, t);
}
a(Vv, "setOptions");
function mu(e, t) {
  e.labels = t;
}
a(mu, "setLabels");
function bu(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : gu;
  const o = [];
  e.datasets = t.map((r) => {
    const i = e.datasets.find((l) => l[n] === r[n]);
    return !i || !r.data || o.includes(i) ? {
      ...r
    } : (o.push(i), Object.assign(i, r), i);
  });
}
a(bu, "setDatasets");
function Av(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : gu;
  const n = {
    labels: [],
    datasets: []
  };
  return mu(n, e.labels), bu(n, e.datasets, t), n;
}
a(Av, "cloneData");
function Bv(e, t) {
  const { height: n = 150, width: o = 300, redraw: r = !1, datasetIdKey: i, type: l, data: c, options: d, plugins: u = [], fallbackContent: p, updateMode: f, ...m } = e, b = Vi(null), C = Vi(null), g = /* @__PURE__ */ a(() => {
    b.current && (C.current = new Nr(b.current, {
      type: l,
      data: Av(c, i),
      options: d && {
        ...d
      },
      plugins: u
    }), v6(t, C.current));
  }, "renderChart"), y = /* @__PURE__ */ a(() => {
    v6(t, null), C.current && (C.current.destroy(), C.current = null);
  }, "destroyChart");
  return Cn(() => {
    !r && C.current && d && Vv(C.current, d);
  }, [
    r,
    d
  ]), Cn(() => {
    !r && C.current && mu(C.current.config.data, c.labels);
  }, [
    r,
    c.labels
  ]), Cn(() => {
    !r && C.current && c.datasets && bu(C.current.config.data, c.datasets, i);
  }, [
    r,
    c.datasets
  ]), Cn(() => {
    C.current && (r ? (y(), setTimeout(g)) : C.current.update(f));
  }, [
    r,
    d,
    c.labels,
    c.datasets,
    f
  ]), Cn(() => {
    C.current && (y(), setTimeout(g));
  }, [
    l
  ]), Cn(() => (g(), () => y()), []), /* @__PURE__ */ xn.createElement("canvas", {
    ref: b,
    role: "img",
    height: n,
    width: o,
    ...m
  }, p);
}
a(Bv, "ChartComponent");
const Hv = /* @__PURE__ */ J1(Bv);
function Ml(e, t) {
  return Nr.register(t), /* @__PURE__ */ J1((n, o) => /* @__PURE__ */ xn.createElement(Hv, {
    ...n,
    ref: o,
    type: e
  }));
}
a(Ml, "createTypedChart");
const Dv = /* @__PURE__ */ Ml("line", A1), Nv = /* @__PURE__ */ Ml("bar", V1), zv = /* @__PURE__ */ Ml("doughnut", Ji), Fv = /* @__PURE__ */ Ml("pie", Ea);
Nr.register(Va, Aa, ja, pu, hu, du);
const fT = /* @__PURE__ */ a(({ labels: e, data: t, colors: n, title: o }) => {
  const r = {
    labels: e,
    datasets: [
      {
        data: t,
        backgroundColor: n
      }
    ]
  }, i = /* @__PURE__ */ a((c, d) => {
    if (c.length <= d) return [c];
    const u = c.split(" "), p = [];
    let f = "";
    for (const m of u)
      (f + " " + m).trim().length > d && f ? (p.push(f.trim()), f = m) : f = f ? `${f} ${m}` : m;
    return f && p.push(f.trim()), p;
  }, "wrapText"), l = {
    responsive: !0,
    interaction: {
      mode: "nearest",
      intersect: !0
    },
    plugins: {
      datalabels: { anchor: "end", align: "end", offset: -2 },
      legend: { display: !1 },
      tooltip: {
        callbacks: {
          title: /* @__PURE__ */ a((c) => {
            var d;
            return i(((d = c[0]) == null ? void 0 : d.label) || "", 30);
          }, "title")
        }
      },
      title: o ? {
        display: !0,
        text: o
      } : void 0
    },
    scales: {
      x: {
        display: !1
      },
      y: {
        beginAtZero: !0,
        ticks: { precision: 0, stepSize: 10 },
        border: {
          dash: [4, 4],
          color: "rgba(223, 219, 219, 1)",
          width: 1.5
        }
      }
    }
  };
  return /* @__PURE__ */ h.jsx(Nv, { data: r, options: l });
}, "BarChart"), Wv = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsxs("svg", { width: "21", height: "16", viewBox: "0 0 21 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M18.375 0H2.375C1.275 0 0.375 0.9 0.375 2V14C0.375 15.1 1.275 16 2.375 16H18.375C19.475 16 20.375 15.1 20.375 14V2C20.375 0.9 19.475 0 18.375 0ZM18.375 14H2.375V2H18.375V14Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ h.jsx("path", { d: "M9.875 3.5H5.875V7.5H9.875V3.5Z", fill: "currentColor" }),
  /* @__PURE__ */ h.jsx("path", { d: "M14.875 3.5H10.875V7.5H14.875V3.5Z", fill: "currentColor" }),
  /* @__PURE__ */ h.jsx("path", { d: "M9.875 8.5H5.875V12.5H9.875V8.5Z", fill: "currentColor" }),
  /* @__PURE__ */ h.jsx("path", { d: "M14.875 8.5H10.875V12.5H14.875V8.5Z", fill: "currentColor" })
] }), "ApplicationsIcon"), Zv = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "38", height: "38", viewBox: "0 0 38 38", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M18.9977 12.3376L12.3352 19.0001L18.9977 25.6626L20.0268 24.6334L15.1518 19.7584L26.256 19.7584L26.256 18.2418L15.1518 18.2418L20.0268 13.3668L18.9977 12.3376ZM18.9884 0.150099C21.5946 0.150098 24.0453 0.644639 26.3405 1.63372C28.6357 2.62281 30.6321 3.96523 32.3297 5.66101C34.0276 7.35679 35.3717 9.35067 36.3619 11.6426C37.3524 13.935 37.8477 16.3844 37.8477 18.9909C37.8477 21.597 37.3531 24.0477 36.364 26.3429C35.3749 28.6382 34.0325 30.6346 32.3367 32.3321C30.641 34.0301 28.6471 35.3741 26.3551 36.3643C24.0628 37.3548 21.6134 37.8501 19.0069 37.8501C16.4007 37.8501 13.95 37.3556 11.6548 36.3665C9.3596 35.3774 7.3632 34.035 5.66561 32.3392C3.96767 30.6434 2.62361 28.6495 1.63344 26.3576C0.642916 24.0652 0.147654 21.6158 0.147654 19.0093C0.147654 16.4032 0.642195 13.9525 1.63128 11.6573C2.62036 9.36204 3.96279 7.36564 5.65857 5.66806C7.35435 3.97011 9.34822 2.62606 11.6402 1.63589C13.9325 0.645361 16.3819 0.150099 18.9884 0.150099ZM18.9977 1.66676C14.1588 1.66676 10.0602 3.34593 6.70182 6.70427C3.34348 10.0626 1.66432 14.1612 1.66432 19.0001C1.66432 23.839 3.34349 27.9376 6.70182 31.2959C10.0602 34.6543 14.1588 36.3334 18.9977 36.3334C23.8365 36.3334 27.9352 34.6543 31.2935 31.2959C34.6518 27.9376 36.331 23.839 36.331 19.0001C36.331 14.1612 34.6518 10.0626 31.2935 6.70426C27.9352 3.34593 23.8365 1.66676 18.9977 1.66676Z",
    fill: "currentColor"
  }
) }), "ArrowCircleLeft"), Uv = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "38", height: "38", viewBox: "0 0 38 38", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M19.0023 25.6624L25.6648 18.9999L19.0023 12.3374L17.9732 13.3666L22.8482 18.2416H11.744V19.7582H22.8482L17.9732 24.6332L19.0023 25.6624ZM19.0116 37.8499C16.4054 37.8499 13.9547 37.3554 11.6595 36.3663C9.36429 35.3772 7.36789 34.0348 5.6703 32.339C3.97236 30.6432 2.6283 28.6493 1.63814 26.3574C0.647607 24.065 0.152344 21.6156 0.152344 19.0091C0.152344 16.403 0.646885 13.9523 1.63597 11.6571C2.62505 9.36185 3.96748 7.36544 5.66326 5.66786C7.35904 3.96992 9.35291 2.62586 11.6449 1.63569C13.9372 0.645166 16.3866 0.149902 18.9931 0.149902C21.5993 0.149902 24.05 0.644445 26.3452 1.63353C28.6404 2.62261 30.6368 3.96504 32.3344 5.66082C34.0323 7.3566 35.3764 9.35047 36.3666 11.6424C37.3571 13.9348 37.8523 16.3842 37.8523 18.9907C37.8523 21.5968 37.3578 24.0475 36.3687 26.3427C35.3796 28.638 34.0372 30.6344 32.3414 32.3319C30.6457 34.0299 28.6518 35.3739 26.3598 36.3641C24.0675 37.3546 21.6181 37.8499 19.0116 37.8499ZM19.0023 36.3332C23.8412 36.3332 27.9398 34.6541 31.2982 31.2957C34.6565 27.9374 36.3357 23.8388 36.3357 18.9999C36.3357 14.161 34.6565 10.0624 31.2982 6.70407C27.9398 3.34574 23.8412 1.66657 19.0023 1.66657C14.1635 1.66657 10.0648 3.34574 6.70651 6.70407C3.34818 10.0624 1.66901 14.161 1.66901 18.9999C1.66901 23.8388 3.34818 27.9374 6.70651 31.2957C10.0648 34.6541 14.1635 36.3332 19.0023 36.3332Z",
    fill: "currentColor"
  }
) }), "ArrowCircleRight"), hT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "6 9 12 7", fill: "currentColor", children: /* @__PURE__ */ h.jsx("path", { d: "M7 10l5 5 5-5z" }) }), "ArrowDropDownIcon"), gT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M13.6666 6.16683H3.52492L8.18325 1.5085L6.99992 0.333496L0.333252 7.00016L6.99992 13.6668L8.17492 12.4918L3.52492 7.8335H13.6666V6.16683Z",
    fill: "currentColor"
  }
) }), "ArrowLeft"), Gv = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "15", height: "14", viewBox: "0 0 15 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M7.49992 0.0678711L6.32492 1.24287L10.9749 5.9012H0.833252V7.56787H10.9749L6.32492 12.2262L7.49992 13.4012L14.1666 6.73454L7.49992 0.0678711Z",
    fill: "currentColor"
  }
) }), "ArrowRight"), mT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx("path", { d: "M12 16V9H16V16H12ZM6 16V0H10V16H6ZM0 16V5H4V16H0Z", fill: "currentColor" }) }), "ChartsIcon"), q1 = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsxs("svg", { width: "21", height: "20", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ h.jsx("rect", { width: "20", height: "20", transform: "translate(0.25)", fill: "#0073E6" }),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M8.11339 12.5833L5.33339 9.80333L4.38672 10.7433L8.11339 14.47L16.1134 6.47L15.1734 5.53L8.11339 12.5833Z",
      fill: "white"
    }
  )
] }), "CheckboxCheckedIcon"), K1 = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsxs("svg", { width: "21", height: "20", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ h.jsx("path", { d: "M19.75 0.5V19.5H0.75V0.5H19.75Z", fill: "white" }),
  /* @__PURE__ */ h.jsx("path", { d: "M19.75 0.5V19.5H0.75V0.5H19.75Z", stroke: "#0073E6" })
] }), "CheckboxIcon"), bT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M7.33342 13.25L3.83341 9.75002L2.66675 10.9167L7.33342 15.5834L17.3334 5.58335L16.1667 4.41669L7.33342 13.25Z",
    fill: "white"
  }
) }), "CheckIcon"), CT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "14", height: "16", viewBox: "0 0 14 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M10.0399 5.96L4.07992 0L3.13992 0.94L4.72659 2.52667L1.29325 5.96C0.899919 6.35333 0.899919 6.98667 1.29325 7.37333L4.95992 11.04C5.15325 11.2333 5.41325 11.3333 5.66659 11.3333C5.91992 11.3333 6.17992 11.2333 6.37325 11.04L10.0399 7.37333C10.4333 6.98667 10.4333 6.35333 10.0399 5.96ZM2.47325 6.66667L5.66659 3.47333L8.85992 6.66667H2.47325ZM11.6666 7.66667C11.6666 7.66667 10.3333 9.11333 10.3333 10C10.3333 10.7333 10.9333 11.3333 11.6666 11.3333C12.3999 11.3333 12.9999 10.7333 12.9999 10C12.9999 9.11333 11.6666 7.66667 11.6666 7.66667ZM0.333252 13.3333H13.6666V16H0.333252V13.3333Z",
    fill: "currentColor"
  }
) }), "ChemicalIcon"), yT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    fill: "currentColor",
    children: [
      /* @__PURE__ */ h.jsx("rect", { fill: "none", height: "24", width: "24" }),
      /* @__PURE__ */ h.jsx("path", { d: "M3,5v14h18V5H3z M8.33,17H5V7h3.33V17z M13.67,17h-3.33V7h3.33V17z M19,17h-3.33V7H19V17z" })
    ]
  }
), "ColumnsIcon"), i2 = /* @__PURE__ */ a((e) => /* @__PURE__ */ h.jsx("svg", { width: "12", height: "8", viewBox: "0 0 12 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M10.59 0.294922L6 4.87492L1.41 0.294922L0 1.70492L6 7.70492L12 1.70492L10.59 0.294922Z",
    fill: "currentColor"
  }
) }), "ChevronDownIcon"), xT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsxs("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ h.jsx(
    "mask",
    {
      id: "mask0_3139_47309",
      style: { maskType: "alpha" },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "24",
      height: "24",
      children: /* @__PURE__ */ h.jsx("rect", { y: "24", width: "24", height: "24", transform: "rotate(-90 0 24)", fill: "currentColor" })
    }
  ),
  /* @__PURE__ */ h.jsx("g", { mask: "url(#mask0_3139_47309)", children: /* @__PURE__ */ h.jsx("path", { d: "M15.4 12L9.4 18L8 16.6L12.6 12L8 7.4L9.4 6L15.4 12Z", fill: "currentColor" }) })
] }), "ChevronRightIcon"), Yv = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "12", height: "8", viewBox: "0 0 12 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M1.41 7.70492L6 3.12492L10.59 7.70492L12 6.29492L6 0.294922L0 6.29492L1.41 7.70492Z",
    fill: "currentColor"
  }
) }), "ChevronUpIcon"), vT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "3 1 18 22", fill: "currentColor", children: /* @__PURE__ */ h.jsx("path", { d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" }) }), "ExcelFileIcon"), wT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "14", height: "16", viewBox: "0 0 14 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M7.58008 8.70683C7.42675 8.4535 7.33341 8.1535 7.33341 7.8335C7.33341 6.9135 8.08008 6.16683 9.00008 6.16683H9.66675C10.6734 6.16683 11.0001 5.50016 11.0001 5.50016C11.0001 5.50016 11.3667 9.50016 9.00008 9.50016C8.67341 9.50016 8.37341 9.40683 8.12008 9.24683C7.96008 9.6735 7.72675 10.4202 7.61341 11.2202C8.45341 11.3668 9.13341 11.8135 9.46008 12.4002C10.5867 11.6202 11.3334 10.3135 11.3334 8.8335H13.3334C13.3334 12.3268 10.4934 15.1668 7.00008 15.1668C3.50675 15.1668 0.666748 12.3268 0.666748 8.8335C0.666748 5.34016 3.50675 2.50016 7.00008 2.50016V0.833496L9.66675 3.50016L7.00008 6.16683V4.50016C4.61341 4.50016 2.66675 6.44683 2.66675 8.8335C2.66675 10.3068 3.40675 11.6135 4.54008 12.4002C4.88008 11.7868 5.62675 11.3202 6.52675 11.2002C6.46675 10.7402 6.35341 10.2535 6.20008 9.84683C5.96675 10.0468 5.66675 10.1668 5.33341 10.1668C4.60008 10.1668 4.00008 9.56683 4.00008 8.8335V8.1735C4.00008 7.80016 3.87341 7.44683 3.66675 7.16683C3.66675 7.16683 6.63341 7.0135 6.66675 8.8335C6.66675 9.02683 6.62675 9.20683 6.55341 9.36683C6.27341 9.1535 5.98008 8.96683 5.66675 8.8335C6.05341 9.12016 6.58008 9.74683 7.00008 10.5668C7.44675 9.48683 8.12008 8.38683 9.00008 7.50016C8.49341 7.84683 8.02008 8.24683 7.58008 8.70683Z",
    fill: "currentColor"
  }
) }), "ClimateActionIcon"), Ha = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M2.53366 19.3334L0.666992 17.4667L8.13366 10.0001L0.666992 2.53341L2.53366 0.666748L10.0003 8.13341L17.467 0.666748L19.3337 2.53341L11.867 10.0001L19.3337 17.4667L17.467 19.3334L10.0003 11.8667L2.53366 19.3334Z",
    fill: "currentColor"
  }
) }), "CloseIcon"), ST = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-hidden": "true",
    children: /* @__PURE__ */ h.jsx(
      "path",
      {
        d: "M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z",
        fill: "currentColor"
      }
    )
  }
), "CompareArrowsIcon"), MT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "14", height: "18", viewBox: "0 0 14 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M13.6666 2.33317H1.99998V0.666504H0.333313V17.3332H1.99998V10.6665H13.6666L12 6.49984L13.6666 2.33317ZM10.45 7.1165L11.2 8.99984H1.99998V3.99984H11.2083L10.4583 5.88317L10.2083 6.49984L10.45 7.1165ZM7.83331 6.49984C7.83331 7.4165 7.08331 8.1665 6.16665 8.1665C5.24998 8.1665 4.49998 7.4165 4.49998 6.49984C4.49998 5.58317 5.24998 4.83317 6.16665 4.83317C7.08331 4.83317 7.83331 5.58317 7.83331 6.49984Z",
    fill: "currentColor"
  }
) }), "CountryIcon"), qv = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "15", height: "14", viewBox: "0 0 15 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M7.50004 0.333496C3.82004 0.333496 0.833374 3.32016 0.833374 7.00016C0.833374 10.6802 3.82004 13.6668 7.50004 13.6668C11.18 13.6668 14.1667 10.6802 14.1667 7.00016C14.1667 3.32016 11.18 0.333496 7.50004 0.333496ZM2.16671 7.00016C2.16671 6.5935 2.22004 6.1935 2.30671 5.8135L5.49337 9.00016V9.66683C5.49337 10.4002 6.09337 11.0002 6.82671 11.0002V12.2868C4.20671 11.9535 2.16671 9.7135 2.16671 7.00016ZM11.4267 10.6002C11.2534 10.0602 10.76 9.66683 10.16 9.66683H9.49337V7.66683C9.49337 7.30016 9.19337 7.00016 8.82671 7.00016H4.82671V5.66683H6.16004C6.52671 5.66683 6.82671 5.36683 6.82671 5.00016V3.66683H8.16004C8.89337 3.66683 9.49337 3.06683 9.49337 2.3335V2.06016C11.4467 2.84683 12.8334 4.76683 12.8334 7.00016C12.8334 8.38683 12.2934 9.6535 11.4267 10.6002Z",
    fill: "currentColor"
  }
) }), "CountryProfilesIcon"), Kv = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsxs("svg", { width: "13", height: "18", viewBox: "0 0 13 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M0.980469 15.78L1.23047 18L2.85047 16.46L5.62047 8.86C4.94047 8.69 4.34047 8.35 3.85047 7.88L0.980469 15.78Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M9.39047 7.88C8.90047 8.35 8.29047 8.69 7.62047 8.86L10.3905 16.46L12.0105 18L12.2705 15.78L9.39047 7.88Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M9.62047 5C9.62047 3.7 8.78047 2.6 7.62047 2.18V0H5.62047V2.18C4.46047 2.6 3.62047 3.7 3.62047 5C3.62047 6.66 4.96047 8 6.62047 8C8.28047 8 9.62047 6.66 9.62047 5ZM6.62047 6C6.07047 6 5.62047 5.55 5.62047 5C5.62047 4.45 6.07047 4 6.62047 4C7.17047 4 7.62047 4.45 7.62047 5C7.62047 5.55 7.17047 6 6.62047 6Z",
      fill: "currentColor"
    }
  )
] }), "DataAnalysisIcon"), Xv = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "23", height: "20", viewBox: "0 0 23 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M21.845 4.95C21.375 4.71 20.885 4.51 20.375 4.34V16.37C19.235 15.96 18.065 15.75 16.875 15.75C14.975 15.75 13.095 16.29 11.375 17.33V5.23C9.755 4.3 7.885 3.75 5.875 3.75C4.085 3.75 2.395 4.19 0.905 4.95C0.575 5.11 0.375 5.46 0.375 5.83V17.91C0.375 18.49 0.845 18.9 1.375 18.9C1.535 18.9 1.695 18.86 1.855 18.78C3.065 18.15 4.425 17.75 5.875 17.75C7.945 17.75 9.855 18.57 11.375 19.75C12.895 18.57 14.805 17.75 16.875 17.75C18.325 17.75 19.685 18.15 20.895 18.79C21.055 18.87 21.215 18.91 21.375 18.91C21.895 18.91 22.375 18.5 22.375 17.92V5.83C22.375 5.46 22.175 5.11 21.845 4.95ZM9.375 16.37C8.235 15.96 7.065 15.75 5.875 15.75C4.685 15.75 3.515 15.96 2.375 16.37V6.46C3.485 5.99 4.655 5.75 5.875 5.75C7.075 5.75 8.265 6 9.375 6.47V16.37ZM18.375 0.25L13.375 5.25V14.75L18.375 10.25V0.25Z",
    fill: "currentColor"
  }
) }), "DataCatalogueIcon"), TT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M12.0002 9.50016V12.0002H2.00016V9.50016H0.333496V12.0002C0.333496 12.9168 1.0835 13.6668 2.00016 13.6668H12.0002C12.9168 13.6668 13.6668 12.9168 13.6668 12.0002V9.50016H12.0002ZM11.1668 6.16683L9.99183 4.99183L7.8335 7.14183V0.333496H6.16683V7.14183L4.0085 4.99183L2.8335 6.16683L7.00016 10.3335L11.1668 6.16683Z",
    fill: "currentColor"
  }
) }), "DownloadIcon"), Jv = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "16", height: "16", viewBox: "0 0 46 46", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M25,3C12.85,3,3,12.85,3,25c0,11.03,8.125,20.137,18.712,21.728V30.831h-5.443v-5.783h5.443v-3.848 c0-6.371,3.104-9.168,8.399-9.168c2.536,0,3.877,0.188,4.512,0.274v5.048h-3.612c-2.248,0-3.033,2.131-3.033,4.533v3.161h6.588 l-0.894,5.783h-5.694v15.944C38.716,45.318,47,36.137,47,25C47,12.85,37.15,3,25,3z",
    fill: "currentColor"
  }
) }), "FacebookIcon"), kT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "16", height: "10", viewBox: "0 0 16 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M6.33333 10H9.66667V8.33333H6.33333V10ZM0.5 0V1.66667H15.5V0H0.5ZM3 5.83333H13V4.16667H3V5.83333Z",
    fill: "currentColor"
  }
) }), "FilterListIcon"), OT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M8.99996 0.666504C4.39996 0.666504 0.666626 4.39984 0.666626 8.99984C0.666626 13.5998 4.39996 17.3332 8.99996 17.3332C13.6 17.3332 17.3333 13.5998 17.3333 8.99984C17.3333 4.39984 13.6 0.666504 8.99996 0.666504ZM2.33329 8.99984C2.33329 8.4915 2.39996 7.9915 2.50829 7.5165L6.49163 11.4998V12.3332C6.49163 13.2498 7.24163 13.9998 8.15829 13.9998V15.6082C4.88329 15.1915 2.33329 12.3915 2.33329 8.99984ZM13.9083 13.4998C13.6916 12.8248 13.075 12.3332 12.325 12.3332H11.4916V9.83317C11.4916 9.37484 11.1166 8.99984 10.6583 8.99984H5.65829V7.33317H7.32496C7.78329 7.33317 8.15829 6.95817 8.15829 6.49984V4.83317H9.82496C10.7416 4.83317 11.4916 4.08317 11.4916 3.1665V2.82484C13.9333 3.80817 15.6666 6.20817 15.6666 8.99984C15.6666 10.7332 14.9916 12.3165 13.9083 13.4998Z",
    fill: "currentColor"
  }
) }), "GlobalIcon"), Qv = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "15", height: "12", viewBox: "0 0 15 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M7.50004 2.12683L10.8334 5.12683V10.3335H9.50004V6.3335H5.50004V10.3335H4.16671V5.12683L7.50004 2.12683ZM7.50004 0.333496L0.833374 6.3335H2.83337V11.6668H6.83337V7.66683H8.16671V11.6668H12.1667V6.3335H14.1667L7.50004 0.333496Z",
    fill: "currentColor"
  }
) }), "HomeIcon"), ET = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M11 17H13V11H11V17ZM12 9C12.2833 9 12.5208 8.90417 12.7125 8.7125C12.9042 8.52083 13 8.28333 13 8C13 7.71667 12.9042 7.47917 12.7125 7.2875C12.5208 7.09583 12.2833 7 12 7C11.7167 7 11.4792 7.09583 11.2875 7.2875C11.0958 7.47917 11 7.71667 11 8C11 8.28333 11.0958 8.52083 11.2875 8.7125C11.4792 8.90417 11.7167 9 12 9ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z",
    fill: "currentColor"
  }
) }), "InfoIcon"), $T = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    fill: "currentColor",
    children: [
      /* @__PURE__ */ h.jsx("g", { children: /* @__PURE__ */ h.jsx("rect", { fill: "none", height: "24", width: "24" }) }),
      /* @__PURE__ */ h.jsx("g", { children: /* @__PURE__ */ h.jsxs("g", { children: [
        /* @__PURE__ */ h.jsx("path", { d: "M21,8c-1.45,0-2.26,1.44-1.93,2.51l-3.55,3.56c-0.3-0.09-0.74-0.09-1.04,0l-2.55-2.55C12.27,10.45,11.46,9,10,9 c-1.45,0-2.27,1.44-1.93,2.52l-4.56,4.55C2.44,15.74,1,16.55,1,18c0,1.1,0.9,2,2,2c1.45,0,2.26-1.44,1.93-2.51l4.55-4.56 c0.3,0.09,0.74,0.09,1.04,0l2.55,2.55C12.73,16.55,13.54,18,15,18c1.45,0,2.27-1.44,1.93-2.52l3.56-3.55 C21.56,12.26,23,11.45,23,10C23,8.9,22.1,8,21,8z" }),
        /* @__PURE__ */ h.jsx("polygon", { points: "15,9 15.94,6.93 18,6 15.94,5.07 15,3 14.08,5.07 12,6 14.08,6.93" }),
        /* @__PURE__ */ h.jsx("polygon", { points: "3.5,11 4,9 6,8.5 4,8 3.5,6 3,8 1,8.5 3,9" })
      ] }) })
    ]
  }
), "InsightsIcon"), ew = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z",
    fill: "currentColor"
  }
) }), "InstagramIcon"), tw = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "15", height: "12", viewBox: "0 0 15 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M7.49996 0L0.166626 4L2.83329 5.45333V9.45333L7.49996 12L12.1666 9.45333V5.45333L13.5 4.72667V9.33333H14.8333V4L7.49996 0ZM12.0466 4L7.49996 6.48L2.95329 4L7.49996 1.52L12.0466 4ZM10.8333 8.66L7.49996 10.48L4.16663 8.66V6.18L7.49996 8L10.8333 6.18V8.66Z",
    fill: "currentColor"
  }
) }), "KnowledgeHubIcon"), PT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "16", height: "8", viewBox: "0 0 16 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M9.33341 0L6.52008 3.75333L7.35341 4.86667L9.33341 2.22L12.6667 6.66667H7.02675L4.35341 3.08667L0.666748 8H15.3334L9.33341 0ZM3.33341 6.66667L4.34675 5.31333L5.36008 6.66667H3.33341Z",
    fill: "currentColor"
  }
) }), "LandIcon"), _T = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M11.99 18.54L4.62 13.97L3 15.05L11.99 21L21 15.05L19.37 13.97L11.99 18.54ZM11.99 16L19.36 11.43L21 10.35L11.99 4.4L3 10.35L4.63 11.43L11.99 16ZM11.99 13.47L6.26 10.35L11.99 7.23L17.71 10.35L11.99 13.47Z",
    fill: "currentColor"
  }
) }), "LayersIcon"), RT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "20", height: "14", viewBox: "0 0 20 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M1.5 13.5L0 12L7.5 4.5L11.5 8.5L18.6 0.5L20 1.9L11.5 11.5L7.5 7.5L1.5 13.5Z",
    fill: "currentColor"
  }
) }), "LineIcon"), nw = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "16", height: "16", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M24,4H6C4.895,4,4,4.895,4,6v18c0,1.105,0.895,2,2,2h18c1.105,0,2-0.895,2-2V6C26,4.895,25.105,4,24,4z M10.954,22h-2.95 v-9.492h2.95V22z M9.449,11.151c-0.951,0-1.72-0.771-1.72-1.72c0-0.949,0.77-1.719,1.72-1.719c0.948,0,1.719,0.771,1.719,1.719 C11.168,10.38,10.397,11.151,9.449,11.151z M22.004,22h-2.948v-4.616c0-1.101-0.02-2.517-1.533-2.517 c-1.535,0-1.771,1.199-1.771,2.437V22h-2.948v-9.492h2.83v1.297h0.04c0.394-0.746,1.356-1.533,2.791-1.533 c2.987,0,3.539,1.966,3.539,4.522V22z",
    fill: "currentColor"
  }
) }), "LinkedinIcon"), IT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M9.2 16L12 13.9L14.75 16L13.7 12.6L16.5 10.4H13.1L12 7L10.9 10.4H7.5L10.25 12.6L9.2 16ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V14.625C2 14.4417 2.05833 14.2833 2.175 14.15C2.29167 14.0167 2.44167 13.9333 2.625 13.9C3.025 13.7667 3.35417 13.525 3.6125 13.175C3.87083 12.825 4 12.4333 4 12C4 11.5667 3.87083 11.175 3.6125 10.825C3.35417 10.475 3.025 10.2333 2.625 10.1C2.44167 10.0667 2.29167 9.98333 2.175 9.85C2.05833 9.71667 2 9.55833 2 9.375V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V9.375C22 9.55833 21.9417 9.71667 21.825 9.85C21.7083 9.98333 21.5583 10.0667 21.375 10.1C20.975 10.2333 20.6458 10.475 20.3875 10.825C20.1292 11.175 20 11.5667 20 12C20 12.4333 20.1292 12.825 20.3875 13.175C20.6458 13.525 20.975 13.7667 21.375 13.9C21.5583 13.9333 21.7083 14.0167 21.825 14.15C21.9417 14.2833 22 14.4417 22 14.625V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4ZM4 18H20V15.45C19.3833 15.0833 18.8958 14.5958 18.5375 13.9875C18.1792 13.3792 18 12.7167 18 12C18 11.2833 18.1792 10.6208 18.5375 10.0125C18.8958 9.40417 19.3833 8.91667 20 8.55V6H4V8.55C4.61667 8.91667 5.10417 9.40417 5.4625 10.0125C5.82083 10.6208 6 11.2833 6 12C6 12.7167 5.82083 13.3792 5.4625 13.9875C5.10417 14.5958 4.61667 15.0833 4 15.45V18Z",
    fill: "currentColor"
  }
) }), "LocalActivityIcon"), jT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M12 18L6 15.9L1.35 17.7C1.01667 17.8333 0.708333 17.7958 0.425 17.5875C0.141667 17.3792 0 17.1 0 16.75V2.75C0 2.53333 0.0625 2.34167 0.1875 2.175C0.3125 2.00833 0.483333 1.88333 0.7 1.8L6 0L12 2.1L16.65 0.3C16.9833 0.166667 17.2917 0.204167 17.575 0.4125C17.8583 0.620833 18 0.9 18 1.25V15.25C18 15.4667 17.9375 15.6583 17.8125 15.825C17.6875 15.9917 17.5167 16.1167 17.3 16.2L12 18ZM11 15.55V3.85L7 2.45V14.15L11 15.55ZM13 15.55L16 14.55V2.7L13 3.85V15.55ZM2 15.3L5 14.15V2.45L2 3.45V15.3Z",
    fill: "currentColor"
  }
) }), "MapIcon"), w6 = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "currentColor",
    children: /* @__PURE__ */ h.jsx("path", { d: "M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z" })
  }
), "MenuIcon"), LT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "17", height: "17", viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M13.1911 13.1914H3.47131V3.47155H8.33121V2.08301H3.47131C2.70067 2.08301 2.08276 2.70785 2.08276 3.47155V13.1914C2.08276 13.9551 2.70067 14.5799 3.47131 14.5799H13.1911C13.9548 14.5799 14.5797 13.9551 14.5797 13.1914V8.33146H13.1911V13.1914ZM9.71975 2.08301V3.47155H12.2122L5.3875 10.2962L6.36642 11.2752L13.1911 4.45047V6.94291H14.5797V2.08301H9.71975Z",
    fill: "currentColor"
  }
) }), "OpenInNewIcon"), VT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "21", height: "21", viewBox: "0 0 21 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M16.1666 16.4998H4.49998V4.83317H10.3333V3.1665H4.49998C3.57498 3.1665 2.83331 3.9165 2.83331 4.83317V16.4998C2.83331 17.4165 3.57498 18.1665 4.49998 18.1665H16.1666C17.0833 18.1665 17.8333 17.4165 17.8333 16.4998V10.6665H16.1666V16.4998ZM12 3.1665V4.83317H14.9916L6.79998 13.0248L7.97498 14.1998L16.1666 6.00817V8.99984H17.8333V3.1665H12Z",
    fill: "currentColor"
  }
) }), "OpenUrlIcon"), AT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "2 2 20 20", fill: "currentColor", children: /* @__PURE__ */ h.jsx("path", { d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" }) }), "PngFileIcon"), BT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "14", height: "18", viewBox: "0 0 14 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M6.99998 8.99984C6.08331 8.99984 5.33331 8.24984 5.33331 7.33317C5.33331 6.4165 6.08331 5.6665 6.99998 5.6665C7.91665 5.6665 8.66665 6.4165 8.66665 7.33317C8.66665 8.24984 7.91665 8.99984 6.99998 8.99984ZM12 7.49984C12 4.47484 9.79165 2.33317 6.99998 2.33317C4.20831 2.33317 1.99998 4.47484 1.99998 7.49984C1.99998 9.44984 3.62498 12.0332 6.99998 15.1165C10.375 12.0332 12 9.44984 12 7.49984ZM6.99998 0.666504C10.5 0.666504 13.6666 3.34984 13.6666 7.49984C13.6666 10.2665 11.4416 13.5415 6.99998 17.3332C2.55831 13.5415 0.333313 10.2665 0.333313 7.49984C0.333313 3.34984 3.49998 0.666504 6.99998 0.666504Z",
    fill: "currentColor"
  }
) }), "RegionIcon"), HT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M5.00016 11.0709C5.00016 9.69586 5.5585 8.44586 6.46683 7.53753L5.2835 6.3542C4.0835 7.56253 3.3335 9.2292 3.3335 11.0709C3.3335 14.4709 5.87516 17.2709 9.16683 17.6792V15.9959C6.8085 15.5959 5.00016 13.5459 5.00016 11.0709ZM16.6668 11.0709C16.6668 7.38753 13.6835 4.4042 10.0002 4.4042C9.95016 4.4042 9.90016 4.41253 9.85016 4.41253L10.7585 3.5042L9.5835 2.32086L6.66683 5.23753L9.5835 8.15419L10.7585 6.9792L9.8585 6.0792C9.9085 6.0792 9.9585 6.07086 10.0002 6.07086C12.7585 6.07086 15.0002 8.31253 15.0002 11.0709C15.0002 13.5459 13.1918 15.5959 10.8335 15.9959V17.6792C14.1252 17.2709 16.6668 14.4709 16.6668 11.0709Z",
    fill: "#BBBBBC"
  }
) }), "ResetIcon"), ow = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M15.755 14.255H14.965L14.685 13.985C15.665 12.845 16.255 11.365 16.255 9.755C16.255 6.165 13.345 3.255 9.755 3.255C6.165 3.255 3.255 6.165 3.255 9.755C3.255 13.345 6.165 16.255 9.755 16.255C11.365 16.255 12.845 15.665 13.985 14.685L14.255 14.965V15.755L19.255 20.745L20.745 19.255L15.755 14.255ZM9.755 14.255C7.26501 14.255 5.255 12.245 5.255 9.755C5.255 7.26501 7.26501 5.255 9.755 5.255C12.245 5.255 14.255 7.26501 14.255 9.755C14.255 12.245 12.245 14.255 9.755 14.255Z",
    fill: "currentColor"
  }
) }), "SearchIcon"), DT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsxs("svg", { width: "40", height: "38", viewBox: "0 0 40 38", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M35.5202 37.1353L23.7223 26.2021C22.6026 27.0979 21.3149 27.8071 19.8592 28.3296C18.4035 28.8522 16.8545 29.1134 15.2122 29.1134C11.1438 29.1134 7.7006 27.7044 4.88257 24.8864C2.06453 22.0684 0.655518 18.6251 0.655518 14.5567C0.655518 10.4883 2.06453 7.04508 4.88257 4.22705C7.7006 1.40902 11.1438 0 15.2122 0C19.2807 0 22.7239 1.40902 25.5419 4.22705C28.3599 7.04508 29.769 10.4883 29.769 14.5567C29.769 16.199 29.5077 17.748 28.9851 19.2037C28.4626 20.6593 27.7534 21.9471 26.8576 23.0668L38.6555 34C38.6555 34 40.2059 35.5849 38.6555 37.1353C37.1051 38.6857 35.5202 37.1353 35.5202 37.1353ZM15.2122 24.6345C18.0116 24.6345 20.3911 23.6547 22.3506 21.6951C24.3102 19.7356 25.29 17.3561 25.29 14.5567C25.29 11.7574 24.3102 9.37789 22.3506 7.41833C20.3911 5.45877 18.0116 4.47899 15.2122 4.47899C12.4129 4.47899 10.0334 5.45877 8.07385 7.41833C6.11429 9.37789 5.13451 11.7574 5.13451 14.5567C5.13451 17.3561 6.11429 19.7356 8.07385 21.6951C10.0334 23.6547 12.4129 24.6345 15.2122 24.6345Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M19.1069 9.91553C19.301 9.78748 19.565 9.80916 19.7358 9.97998L20.6753 10.9204C20.769 11.0142 20.8218 11.1413 20.8218 11.2739C20.8217 11.4064 20.769 11.5338 20.6753 11.6274L17.3022 15.0005L20.6753 18.3735C20.7691 18.4673 20.8218 18.5944 20.8218 18.7271C20.8217 18.8596 20.769 18.9869 20.6753 19.0806L19.7358 20.02C19.6421 20.1137 19.5149 20.1664 19.3823 20.1665C19.2497 20.1665 19.1226 20.1138 19.0288 20.02L15.6558 16.647L12.2827 20.02C12.189 20.1137 12.0617 20.1664 11.9292 20.1665C11.7966 20.1665 11.6694 20.1138 11.5757 20.02L10.6353 19.0806C10.44 18.8853 10.4401 18.5688 10.6353 18.3735L14.0083 15.0005L10.6353 11.6274C10.4401 11.4323 10.4402 11.1157 10.6353 10.9204L11.5757 9.97998L11.6538 9.91553C11.8479 9.78758 12.1119 9.8092 12.2827 9.97998L15.6558 13.353L19.0288 9.97998L19.1069 9.91553Z",
      fill: "currentColor",
      stroke: "currentColor",
      strokeLinejoin: "round"
    }
  )
] }), "SearchIconNotFound"), NT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "4 2 16 20", fill: "currentColor", children: /* @__PURE__ */ h.jsx("path", { d: "M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z" }) }), "SwapVerticalIcon"), zT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "3 3 19 18",
    width: "18",
    height: "18",
    fill: "currentColor",
    children: /* @__PURE__ */ h.jsx("path", { d: "M20 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 2v3H5V5h15zm-5 14h-5v-9h5v9zM5 10h3v9H5v-9zm12 9v-9h3v9h-3z" })
  }
), "TableChartIcon"), rw = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "16", height: "16", viewBox: "0 0 26 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M16.656 1.029c1.637-0.025 3.262-0.012 4.886-0.025 0.054 2.031 0.878 3.859 2.189 5.213l-0.002-0.002c1.411 1.271 3.247 2.095 5.271 2.235l0.028 0.002v5.036c-1.912-0.048-3.71-0.489-5.331-1.247l0.082 0.034c-0.784-0.377-1.447-0.764-2.077-1.196l0.052 0.034c-0.012 3.649 0.012 7.298-0.025 10.934-0.103 1.853-0.719 3.543-1.707 4.954l0.020-0.031c-1.652 2.366-4.328 3.919-7.371 4.011l-0.014 0c-0.123 0.006-0.268 0.009-0.414 0.009-1.73 0-3.347-0.482-4.725-1.319l0.040 0.023c-2.508-1.509-4.238-4.091-4.558-7.094l-0.004-0.041c-0.025-0.625-0.037-1.25-0.012-1.862 0.49-4.779 4.494-8.476 9.361-8.476 0.547 0 1.083 0.047 1.604 0.136l-0.056-0.008c0.025 1.849-0.050 3.699-0.050 5.548-0.423-0.153-0.911-0.242-1.42-0.242-1.868 0-3.457 1.194-4.045 2.861l-0.009 0.030c-0.133 0.427-0.21 0.918-0.21 1.426 0 0.206 0.013 0.41 0.037 0.61l-0.002-0.024c0.332 2.046 2.086 3.59 4.201 3.59 0.061 0 0.121-0.001 0.181-0.004l-0.009 0c1.463-0.044 2.733-0.831 3.451-1.994l0.010-0.018c0.267-0.372 0.45-0.822 0.511-1.311l0.001-0.014c0.125-2.237 0.075-4.461 0.087-6.698 0.012-5.036-0.012-10.060 0.025-15.083z",
    fill: "currentColor"
  }
) }), "TiktokIcon"), FT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C14.4333 2 16.5625 2.7625 18.3875 4.2875C20.2125 5.8125 21.35 7.725 21.8 10.025H19.75C19.4333 8.80833 18.8625 7.72083 18.0375 6.7625C17.2125 5.80417 16.2 5.08333 15 4.6V5C15 5.55 14.8042 6.02083 14.4125 6.4125C14.0208 6.80417 13.55 7 13 7H11V9C11 9.28333 10.9042 9.52083 10.7125 9.7125C10.5208 9.90417 10.2833 10 10 10H8V12H10V15H9L4.2 10.2C4.15 10.5 4.10417 10.8 4.0625 11.1C4.02083 11.4 4 11.7 4 12C4 14.1833 4.76667 16.0583 6.3 17.625C7.83333 19.1917 9.73333 19.9833 12 20V22ZM21.1 21.5L17.9 18.3C17.55 18.5 17.175 18.6667 16.775 18.8C16.375 18.9333 15.95 19 15.5 19C14.25 19 13.1875 18.5625 12.3125 17.6875C11.4375 16.8125 11 15.75 11 14.5C11 13.25 11.4375 12.1875 12.3125 11.3125C13.1875 10.4375 14.25 10 15.5 10C16.75 10 17.8125 10.4375 18.6875 11.3125C19.5625 12.1875 20 13.25 20 14.5C20 14.95 19.9333 15.375 19.8 15.775C19.6667 16.175 19.5 16.55 19.3 16.9L22.5 20.1L21.1 21.5ZM15.5 17C16.2 17 16.7917 16.7583 17.275 16.275C17.7583 15.7917 18 15.2 18 14.5C18 13.8 17.7583 13.2083 17.275 12.725C16.7917 12.2417 16.2 12 15.5 12C14.8 12 14.2083 12.2417 13.725 12.725C13.2417 13.2083 13 13.8 13 14.5C13 15.2 13.2417 15.7917 13.725 16.275C14.2083 16.7583 14.8 17 15.5 17Z",
    fill: "currentColor"
  }
) }), "TravelExploreIcon"), iw = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "16", height: "16", viewBox: "0 0 280 280", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M210.857,197.545c-1.616-0.872-3.584-0.787-5.119,0.223c-11.62,7.638-23.4,11.511-35.016,11.511  c-6.242,0-11.605-1.394-16.416-4.275c-3.27-1.936-6.308-5.321-7.397-8.263c-1.057-2.797-1.045-10.327-1.029-20.748l0.005-63.543  h52.795c2.762,0,5-2.239,5-5V62.802c0-2.761-2.238-5-5-5h-52.795V5c0-2.761-2.238-5-5-5h-35.566c-2.528,0-4.658,1.887-4.964,4.397  c-1.486,12.229-4.258,22.383-8.247,30.196c-3.89,7.7-9.153,14.401-15.651,19.925c-5.206,4.44-14.118,8.736-26.49,12.769  c-2.058,0.671-3.45,2.589-3.45,4.754v35.41c0,2.761,2.238,5,5,5h28.953v82.666c0,12.181,1.292,21.347,3.952,28.026  c2.71,6.785,7.521,13.174,14.303,18.993c6.671,5.716,14.79,10.187,24.158,13.298c9.082,2.962,16.315,4.567,28.511,4.567  c10.31,0,20.137-1.069,29.213-3.179c8.921-2.082,19.017-5.761,30.008-10.934c1.753-0.825,2.871-2.587,2.871-4.524v-39.417  C213.484,200.108,212.476,198.418,210.857,197.545z",
    fill: "currentColor"
  }
) }), "TumblrIcon"), WT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsxs(
  "svg",
  {
    width: "295",
    height: "57",
    viewBox: "0 0 295 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M20.4531 0.829102V16.75C20.4531 19.3952 19.623 21.487 17.9629 23.0254C16.3138 24.5638 14.056 25.333 11.1895 25.333C8.36719 25.333 6.12598 24.5859 4.46582 23.0918C2.80566 21.5977 1.95898 19.5446 1.92578 16.9326V0.829102H6.90625V16.7832C6.90625 18.3659 7.28255 19.5225 8.03516 20.2529C8.79883 20.9723 9.85026 21.332 11.1895 21.332C13.9896 21.332 15.4118 19.86 15.4561 16.916V0.829102H20.4531ZM44.1934 25.001H39.2129L29.5176 9.09668V25.001H24.5371V0.829102H29.5176L39.2295 16.7666V0.829102H44.1934V25.001Z",
          fill: "#0F1A22"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M62.0719 19.9892C59.0657 19.081 56.8772 16.2893 56.8772 12.9881C56.8772 12.3916 56.9476 11.8118 57.0816 11.2588L61.8306 11.8687C61.8306 11.8687 63.6537 11.9492 63.5867 15.1766C63.523 18.3068 62.0719 19.9892 62.0719 19.9892Z",
          fill: "#0F1A22"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M66.3182 19.9892C69.3244 19.081 71.5128 16.2893 71.5128 12.9881C71.5128 12.3916 71.4425 11.8118 71.3084 11.2588L66.5595 11.8687C66.5595 11.8687 64.7363 11.9492 64.8033 15.1766C64.867 18.3068 66.3182 19.9892 66.3182 19.9892Z",
          fill: "#0F1A22"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M64.1931 7.75366C64.803 7.75366 65.2991 8.24967 65.2991 8.85962C65.2991 9.33552 64.9706 9.69077 64.5752 9.90191C64.5282 9.92872 64.4813 9.94883 64.4914 10.0259C64.5014 10.103 64.7293 10.1466 64.8265 10.17L71.2109 10.9107C70.3161 7.88436 67.5143 5.67578 64.1964 5.67578H64.1864C60.8685 5.67578 58.0701 7.88436 57.1719 10.9107L63.5563 10.17C63.6535 10.1466 63.8814 10.1063 63.8915 10.0259C63.9015 9.95218 63.8546 9.92872 63.8077 9.90191C63.4122 9.69077 63.0838 9.33552 63.0838 8.85962C63.0871 8.24967 63.5831 7.75366 64.1931 7.75366Z",
          fill: "#0F1A22"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M67.112 25.1654L67.5443 24.894C67.5443 24.894 65.4933 22.1123 60.9018 22.1123C58.5525 22.1123 57.3359 23.0574 55.6904 23.0574C55.6904 23.0574 55.0168 23.1378 54.3666 22.7323C54.3666 22.7323 55.1508 23.8651 57.9861 23.8651C60.064 23.8651 61.552 22.6485 63.0099 22.6485C65.004 22.6519 66.4886 24.4348 67.112 25.1654Z",
          fill: "#0F1A22"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M60.737 25.1654L60.3047 24.894C60.3047 24.894 62.3557 22.1123 66.9472 22.1123C69.2965 22.1123 70.5131 23.0574 72.1586 23.0574C72.1586 23.0574 72.8323 23.1378 73.4824 22.7323C73.4824 22.7323 72.6982 23.8651 69.8629 23.8651C67.785 23.8651 66.297 22.6485 64.8391 22.6485C62.8451 22.6519 61.357 24.4348 60.737 25.1654Z",
          fill: "#0F1A22"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M58.5495 21.8739C58.4691 22.0884 57.591 21.8336 56.9978 22.0079C56.3342 22.2057 52.8253 22.6279 51.287 18.9849C51.287 18.9849 52.7449 20.5501 53.881 20.6607C55.0138 20.7679 56.2571 21.0394 57.3095 21.6326L57.5541 21.6862C57.5541 21.6862 57.5206 21.5789 57.4201 21.5253C57.2827 21.4516 56.1901 21.0963 55.6639 19.3637C55.3925 18.4722 55.4494 17.8254 55.3388 17.3662C55.3388 17.3662 56.5286 18.69 57.0146 19.5279C57.4972 20.3624 57.5508 21.3075 58.5495 21.8739Z",
          fill: "#0F1A22"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M54.9724 20.0375C54.8853 20.1246 54.6607 19.9838 54.5803 19.9436C54.4998 19.9034 53.9167 19.6353 52.918 19.2834C51.9327 18.9315 50.0961 17.3798 50.2704 14.7188C50.2704 14.7188 50.5284 15.7175 51.2825 16.3811C52.0399 17.0413 52.308 17.1251 52.7672 17.6647C53.2263 18.2042 54.2652 19.4342 54.3055 19.4208C54.3457 19.4074 54.3591 19.3404 54.2787 19.2733C54.1982 19.2063 53.9268 18.5293 53.7525 18.3014C53.5782 18.0735 53.052 16.4917 53.8195 14.5479C53.8195 14.5479 54.644 15.9655 54.5903 17.3966C54.5367 18.8276 54.4697 18.4891 54.8182 19.6789C54.8216 19.6722 55.0126 19.9972 54.9724 20.0375Z",
          fill: "#0F1A22"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M52.6775 16.5714C52.6272 16.6217 52.4194 16.3134 52.2585 16.0319C52.0977 15.747 50.9615 14.5338 50.8141 14.2891C50.6666 14.0445 49.3964 12.5062 50.3549 10.2239C50.3549 10.2239 50.4488 10.197 50.4488 10.7366C50.4488 11.2762 50.9481 12.4794 51.3537 12.9921C51.7592 13.5049 52.1245 14.3293 52.2049 15.2074C52.2049 15.2074 52.2585 15.3683 52.3256 15.3817C52.3926 15.3951 52.3926 15.2208 52.3926 15.2208C52.3926 15.2208 52.339 14.4098 52.339 13.8568C52.339 13.3038 52.5836 12.3587 53.1098 11.8191C53.1098 11.8191 53.3545 11.5477 53.5019 11.2259C53.5019 11.2259 53.5958 11.0114 53.7298 10.9008C53.7298 10.9008 53.8371 12.4525 53.3109 13.897C52.7847 15.3415 52.6104 15.5861 52.6909 16.367C52.6909 16.367 52.7043 16.5413 52.6775 16.5714Z",
          fill: "#0F1A22"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M51.7851 12.2972C51.7315 12.2972 51.6913 12.1095 51.6645 11.9587C51.6376 11.8113 51.4768 10.9466 51.3662 10.7556C51.2589 10.5679 50.8534 9.70323 50.84 8.6911C50.8266 7.67898 51.2857 6.30154 52.3113 5.20898C52.3113 5.20898 52.2711 5.53407 51.9996 6.24792C51.7281 6.96512 51.8924 7.63876 51.9192 7.75941C51.946 7.88006 52.0398 8.71791 52.0398 9.11003C52.0398 9.42171 51.9594 10.4875 51.8924 10.7019C51.8924 10.7019 51.8655 10.8494 51.9192 10.8494C51.9728 10.8494 52.0264 10.7288 52.0264 10.7288C52.0264 10.7288 52.08 9.89091 52.7 9.13684C53.3201 8.37942 54.4428 7.92028 54.6171 7.58514C54.6171 7.58514 54.5366 8.77489 53.2262 10.1624C52.0599 11.4024 52.4018 10.769 52.0231 11.7811C52.0231 11.7811 51.8622 12.1598 51.8622 12.2402C51.8655 12.3274 51.7851 12.2972 51.7851 12.2972Z",
          fill: "#0F1A22"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M52.5033 8.29941C52.5033 8.29941 52.4765 8.13854 52.6775 7.77324C52.8786 7.40793 52.6641 6.76111 52.9356 5.81601C53.2071 4.87092 53.7064 3.25218 55.61 2.28027C55.61 2.28027 55.4223 2.45455 55.3252 2.59195C55.2313 2.72601 54.7185 3.69792 54.5677 4.37491C54.4203 5.04854 53.7701 6.18467 53.5288 6.43938C53.2841 6.69744 53.3947 6.72425 53.3947 6.72425C53.3947 6.72425 53.5154 6.69744 53.6394 6.50976C53.76 6.32208 54.3834 5.61828 55.0704 5.45741C55.7575 5.29655 56.8534 4.97146 56.9204 4.90443C56.9204 4.90443 55.7307 6.12099 54.6381 6.741C53.5456 7.36102 53.4215 7.17334 52.7747 8.01119C52.7714 8.00113 52.5569 8.29941 52.5033 8.29941Z",
          fill: "#0F1A22"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M55.1208 4.69435C55.1208 4.69435 55.1209 4.5871 55.3219 4.39607C55.523 4.20839 55.7275 3.63865 56.0794 3.11248C56.4313 2.58631 57.2255 1.20888 59.2934 0.883789C59.2934 0.883789 58.6733 1.34293 58.5762 1.49039C58.4823 1.63786 57.8757 2.43549 57.6042 2.70696C57.3328 2.97842 56.5653 3.54481 56.3072 3.66546C56.3072 3.66546 56.1732 3.77271 56.2 3.81292C56.2268 3.85314 56.3609 3.77271 56.3609 3.77271C56.3609 3.77271 57.0781 3.21972 57.9394 3.19291C58.8041 3.1661 59.7089 3.20632 59.843 3.21972C59.843 3.21972 59.032 3.77271 57.1015 4.12461C55.1711 4.4765 55.5364 4.48991 55.2382 4.67759C55.2415 4.68094 55.1745 4.73456 55.1208 4.69435Z",
          fill: "#0F1A22"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M58.5618 2.45766C58.5618 2.45766 58.602 2.35041 58.9137 2.25657C59.2254 2.16273 59.1986 1.86446 60.1437 1.3651C61.0888 0.865737 62.0741 0.63449 63.0728 1.05342C63.0728 1.05342 62.6539 1.10704 62.5869 1.13385C62.5198 1.16066 61.8026 1.34834 61.6016 1.45894C61.4005 1.56618 60.3582 2.02533 59.9393 2.10576C59.5203 2.18619 59.7248 2.21301 59.7248 2.21301C59.7248 2.21301 59.8186 2.25322 59.899 2.25322C59.9795 2.25322 60.9112 2.15938 61.5178 2.37387C62.1244 2.58836 62.111 2.67215 62.3556 2.75258C62.6003 2.83302 62.8818 2.88664 62.922 2.98048C62.922 2.98048 62.3154 3.0341 61.9501 3.0341C61.5848 3.0341 60.6263 2.94026 60.1672 2.72242C59.708 2.50793 59.1818 2.41074 59.0076 2.45096C58.8333 2.49788 58.6188 2.49788 58.5618 2.45766Z",
          fill: "#0F1A22"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M62.4006 1.98853C62.4006 1.98853 62.4408 1.93491 62.7123 1.88129C62.9837 1.82766 63.0507 1.6668 63.6842 1.52939C64.3176 1.39198 65.3029 1.27133 66.2078 1.89469C66.2078 1.89469 65.6548 1.88129 65.5341 1.88129C65.4135 1.88129 64.3611 2.06897 64.1165 2.06897C63.8718 2.06897 63.3859 1.96172 63.3189 2.04215C63.2518 2.12259 63.7646 2.22983 63.845 2.25664C63.9255 2.28346 64.2908 2.31027 64.7499 2.75601C65.2091 3.20174 65.5341 3.44304 65.5878 3.47321C65.5878 3.47321 64.2371 3.16153 63.8987 2.97385C63.5602 2.78617 62.9804 2.20302 62.8865 2.16281C62.7893 2.12259 62.4006 1.98853 62.4006 1.98853Z",
          fill: "#0F1A22"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M65.5162 2.53945C65.5162 2.53945 66.3674 2.51264 66.9874 2.90475C67.6075 3.29687 68.1068 3.80964 68.1604 4.12132C68.1604 4.12132 67.8085 3.82304 67.5806 3.75601C67.3494 3.68899 66.7026 3.32368 66.5685 3.24325C66.4345 3.16281 65.6502 2.6601 65.5162 2.53945Z",
          fill: "#0F1A22"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M69.5143 22.0162C69.5143 22.0162 69.6349 21.8956 70.0405 21.5437C70.446 21.1918 70.5532 20.679 70.999 19.8814C71.4447 19.0838 71.8234 18.5308 72.7283 17.7197C72.7283 17.7197 72.5674 18.3263 72.554 18.5174C72.5406 18.705 72.3931 19.7607 71.8804 20.3673C71.3676 20.9739 71.3408 21.1114 70.7476 21.4733C70.7476 21.4733 70.5164 21.6342 70.5331 21.6878C70.5465 21.7414 70.9386 21.6744 70.9386 21.6744C70.9386 21.6744 71.371 21.5135 71.505 21.4297C71.6391 21.3493 72.249 21.0376 72.4903 20.9438C72.735 20.8499 72.9361 20.7561 73.4757 20.5919C74.0152 20.431 75.9725 19.9317 76.7433 18.6883C76.7433 18.6883 76.5154 19.4189 76.2305 19.754C75.9456 20.0925 74.3403 22.2106 72.1116 22.1704C72.1116 22.1704 71.2336 22.1034 70.7744 22.0229C70.3153 21.9425 70.1544 21.9425 70.0874 21.9559C70.0136 21.976 69.5813 22.0565 69.5143 22.0162Z",
          fill: "#0F1A22"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M74.4952 14.4441C74.4952 14.4441 73.6573 15.7545 73.4696 17.6447C73.2819 19.5349 73.6037 18.9685 73.2954 19.8063C73.2954 19.8063 73.1881 20.0208 73.2283 20.0342C73.2685 20.0476 73.4294 19.9538 74.026 19.5885C74.6192 19.2232 75.2023 19.3304 76.4691 18.1172C77.7393 16.9007 77.994 14.4843 78.0208 14.2832C78.0208 14.2832 77.8332 14.4709 77.736 14.796C77.6421 15.1211 77.4377 15.3758 77.3975 15.416C77.3573 15.4562 75.9798 16.9677 75.819 17.1051C75.6581 17.2391 74.8471 18.2245 74.6728 18.5093C74.4985 18.7942 73.9857 19.307 73.8886 19.2668C73.8886 19.2668 73.902 19.1461 73.9422 19.0523C73.9824 18.9584 74.3611 18.4457 74.522 17.8491C74.6828 17.2559 74.7231 16.8906 74.7365 16.5119C74.7532 16.1332 74.5086 14.7423 74.4952 14.4441Z",
          fill: "#0F1A22"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M75.6311 16.2693C75.6311 16.2693 75.5473 16.0716 75.6177 15.9308C75.6579 15.8504 75.6981 15.2002 75.4568 14.674C75.2155 14.1479 74.686 12.69 74.7262 11.7181C74.7664 10.7462 74.8737 10.6121 74.8737 10.6121C74.8737 10.6121 75.1452 11.4098 75.2256 11.5438C75.306 11.6779 76.1171 13.1089 76.05 13.8932C75.983 14.6774 75.9428 14.9187 75.983 14.9321C76.0232 14.9455 76.1171 14.8383 76.1305 14.7444C76.1439 14.6506 76.2779 14.111 76.536 13.4742C76.794 12.8408 77.833 11.4366 78.0609 10.5049C78.0609 10.5049 78.3994 12.1236 77.4945 13.6385C76.5896 15.1499 76.4958 14.8114 76.1171 15.5018C75.7384 16.1889 75.6847 16.2693 75.6311 16.2693Z",
          fill: "#0F1A22"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M76.4515 11.9864C76.3845 11.973 76.4247 11.353 76.2639 11.1485C76.103 10.9475 74.7122 9.29856 74.4139 7.65302C74.4139 7.65302 75.2919 8.54449 75.4394 8.63833C75.5869 8.73217 76.1834 9.32537 76.3577 9.84149C76.532 10.3543 76.4918 10.7866 76.5588 10.8C76.6258 10.8134 76.6258 10.2336 76.6258 10.2336C76.6258 10.2336 76.6392 9.10083 76.7331 8.5579C76.8269 8.01832 77.0716 7.11344 76.9643 6.6543C76.9643 6.6543 77.4905 7.49215 77.4637 8.67855C77.4369 9.8683 76.9375 10.8134 76.8705 10.9475C76.8034 11.0815 76.6124 11.6647 76.6124 11.7853C76.6158 11.906 76.4515 11.9864 76.4515 11.9864Z",
          fill: "#0F1A22"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M74.8065 3.53516C74.8065 3.53516 76.6297 4.61431 76.3448 8.23384C76.3448 8.23384 76.3448 8.39471 76.2376 8.22043C76.1304 8.04616 75.7382 7.5468 75.564 7.4362C75.3897 7.32896 73.7676 6.34364 73.0806 4.8288C73.0806 4.8288 73.1878 4.80199 73.352 4.94945C73.5129 5.09691 74.0123 5.35497 74.096 5.39519C74.1765 5.43541 74.7429 5.58287 75.1618 6.04201C75.5807 6.50116 75.7282 6.83965 75.8488 7.10776C75.8488 7.10776 75.9695 7.2016 75.8891 6.93349C75.8086 6.66202 75.7952 6.48775 75.5774 6.14926C75.3629 5.81077 75.1718 5.20416 75.145 4.78523C75.1182 4.37301 74.9942 3.74965 74.8065 3.53516Z",
          fill: "#0F1A22"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M74.4956 4.80707C74.4956 4.80707 74.5358 4.56241 74.3615 4.22727C74.1873 3.88878 74.3247 3.51342 73.7683 2.62194C73.4567 2.12258 72.3775 1.73047 72.3775 1.73047C72.3775 1.73047 72.6892 2.1628 72.8903 2.4041C73.0913 2.64876 73.1617 2.82303 73.2288 2.94368C73.2958 3.06433 73.6711 3.42628 73.8085 3.63072C73.8354 3.67094 73.889 3.77818 73.889 3.84521C73.889 3.91224 73.7415 3.80499 73.7013 3.76478C73.6611 3.72456 73.0009 3.2252 72.5819 3.14477C72.163 3.06433 71.3654 2.9839 71.1509 2.8733C71.1509 2.8733 72.096 3.72456 73.1215 3.97927C74.1437 4.23733 74.4956 4.80707 74.4956 4.80707Z",
          fill: "#0F1A22"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M72.3627 2.57848C72.3627 2.57848 71.4176 1.29489 69.7285 1.3217C69.7285 1.3217 69.8224 1.41554 70.0134 1.45576C70.2011 1.49598 70.5396 1.83447 70.7138 1.94171C70.8915 2.05231 71.2534 2.32042 72.3627 2.57848Z",
          fill: "#0F1A22"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M5.66309 40.3018C4.57845 40.3018 3.69434 39.9691 3.01074 39.3037C2.33171 38.6383 1.99219 37.752 1.99219 36.6445V36.4531C1.99219 35.7103 2.13574 35.0472 2.42285 34.4639C2.70996 33.876 3.11556 33.4248 3.63965 33.1104C4.16829 32.7913 4.76986 32.6318 5.44434 32.6318C6.45605 32.6318 7.2513 32.9508 7.83008 33.5889C8.41341 34.2269 8.70508 35.1315 8.70508 36.3027V37.1094H3.99512C4.05892 37.5924 4.25033 37.9798 4.56934 38.2715C4.8929 38.5632 5.30078 38.709 5.79297 38.709C6.55404 38.709 7.14876 38.4333 7.57715 37.8818L8.54785 38.9688C8.25163 39.388 7.85059 39.7161 7.34473 39.9531C6.83887 40.1855 6.27832 40.3018 5.66309 40.3018ZM5.4375 34.2314C5.04557 34.2314 4.72656 34.3636 4.48047 34.6279C4.23893 34.8923 4.08398 35.2705 4.01562 35.7627H6.76367V35.6055C6.75456 35.168 6.63607 34.8307 6.4082 34.5938C6.18034 34.3522 5.85677 34.2314 5.4375 34.2314ZM11.5114 32.7686L11.5729 33.623C12.1015 32.9622 12.8102 32.6318 13.6989 32.6318C14.4827 32.6318 15.0661 32.862 15.4489 33.3223C15.8317 33.7826 16.0276 34.4707 16.0368 35.3867V40.165H14.0612V35.4346C14.0612 35.0153 13.97 34.7122 13.7877 34.5254C13.6054 34.334 13.3024 34.2383 12.8786 34.2383C12.3226 34.2383 11.9056 34.4753 11.6276 34.9492V40.165H9.65199V32.7686H11.5114ZM20.1692 37.752L21.5432 32.7686H23.6077L21.1126 40.165H19.2259L16.7307 32.7686H18.7952L20.1692 37.752ZM26.4277 40.165H24.4452V32.7686H26.4277V40.165ZM24.329 30.8545C24.329 30.5583 24.427 30.3145 24.623 30.123C24.8235 29.9316 25.0946 29.8359 25.4364 29.8359C25.7737 29.8359 26.0426 29.9316 26.2431 30.123C26.4436 30.3145 26.5439 30.5583 26.5439 30.8545C26.5439 31.1553 26.4413 31.4014 26.2362 31.5928C26.0357 31.7842 25.7691 31.8799 25.4364 31.8799C25.1038 31.8799 24.8349 31.7842 24.6298 31.5928C24.4293 31.4014 24.329 31.1553 24.329 30.8545ZM32.0777 34.6211C31.8088 34.5846 31.5718 34.5664 31.3668 34.5664C30.6194 34.5664 30.1295 34.8193 29.897 35.3252V40.165H27.9214V32.7686H29.7877L29.8423 33.6504C30.2388 32.9714 30.788 32.6318 31.4898 32.6318C31.7086 32.6318 31.9136 32.6615 32.105 32.7207L32.0777 34.6211ZM32.341 36.3984C32.341 35.6647 32.4823 35.0107 32.7648 34.4365C33.0474 33.8623 33.453 33.418 33.9816 33.1035C34.5148 32.7891 35.1324 32.6318 35.8342 32.6318C36.8322 32.6318 37.6457 32.9372 38.2746 33.5479C38.9081 34.1585 39.2613 34.988 39.3342 36.0361L39.3479 36.542C39.3479 37.6768 39.0311 38.5882 38.3977 39.2764C37.7642 39.96 36.9143 40.3018 35.8479 40.3018C34.7814 40.3018 33.9292 39.96 33.2912 39.2764C32.6577 38.5928 32.341 37.6631 32.341 36.4873V36.3984ZM34.3166 36.542C34.3166 37.2438 34.4488 37.7816 34.7131 38.1553C34.9774 38.5244 35.3557 38.709 35.8479 38.709C36.3264 38.709 36.7001 38.5267 36.9689 38.1621C37.2378 37.793 37.3723 37.2051 37.3723 36.3984C37.3723 35.7103 37.2378 35.1771 36.9689 34.7988C36.7001 34.4206 36.3218 34.2314 35.8342 34.2314C35.3511 34.2314 34.9774 34.4206 34.7131 34.7988C34.4488 35.1725 34.3166 35.7536 34.3166 36.542ZM42.243 32.7686L42.3045 33.623C42.8332 32.9622 43.5418 32.6318 44.4305 32.6318C45.2144 32.6318 45.7977 32.862 46.1805 33.3223C46.5633 33.7826 46.7593 34.4707 46.7684 35.3867V40.165H44.7928V35.4346C44.7928 35.0153 44.7017 34.7122 44.5194 34.5254C44.3371 34.334 44.034 34.2383 43.6102 34.2383C43.0542 34.2383 42.6372 34.4753 42.3592 34.9492V40.165H40.3836V32.7686H42.243ZM49.9848 32.7686L50.0464 33.5957C50.5705 32.9531 51.2791 32.6318 52.1723 32.6318C53.1248 32.6318 53.7788 33.0078 54.1343 33.7598C54.6538 33.0078 55.3943 32.6318 56.3559 32.6318C57.158 32.6318 57.755 32.8665 58.147 33.3359C58.5389 33.8008 58.7348 34.5026 58.7348 35.4414V40.165H56.7524V35.4482C56.7524 35.029 56.6704 34.7236 56.5063 34.5322C56.3423 34.3363 56.0529 34.2383 55.6382 34.2383C55.0457 34.2383 54.6356 34.5208 54.4077 35.0859L54.4145 40.165H52.4389V35.4551C52.4389 35.0267 52.3546 34.7168 52.186 34.5254C52.0174 34.334 51.7303 34.2383 51.3247 34.2383C50.7641 34.2383 50.3585 34.4707 50.1079 34.9355V40.165H48.1323V32.7686H49.9848ZM63.5236 40.3018C62.4389 40.3018 61.5548 39.9691 60.8712 39.3037C60.1922 38.6383 59.8527 37.752 59.8527 36.6445V36.4531C59.8527 35.7103 59.9962 35.0472 60.2833 34.4639C60.5704 33.876 60.976 33.4248 61.5001 33.1104C62.0288 32.7913 62.6303 32.6318 63.3048 32.6318C64.3165 32.6318 65.1118 32.9508 65.6905 33.5889C66.2739 34.2269 66.5655 35.1315 66.5655 36.3027V37.1094H61.8556C61.9194 37.5924 62.1108 37.9798 62.4298 38.2715C62.7534 38.5632 63.1613 38.709 63.6534 38.709C64.4145 38.709 65.0092 38.4333 65.4376 37.8818L66.4083 38.9688C66.1121 39.388 65.7111 39.7161 65.2052 39.9531C64.6993 40.1855 64.1388 40.3018 63.5236 40.3018ZM63.298 34.2314C62.906 34.2314 62.587 34.3636 62.3409 34.6279C62.0994 34.8923 61.9445 35.2705 61.8761 35.7627H64.6241V35.6055C64.615 35.168 64.4965 34.8307 64.2687 34.5938C64.0408 34.3522 63.7172 34.2314 63.298 34.2314ZM69.3718 32.7686L69.4334 33.623C69.962 32.9622 70.6707 32.6318 71.5593 32.6318C72.3432 32.6318 72.9265 32.862 73.3093 33.3223C73.6921 33.7826 73.8881 34.4707 73.8972 35.3867V40.165H71.9216V35.4346C71.9216 35.0153 71.8305 34.7122 71.6482 34.5254C71.4659 34.334 71.1628 34.2383 70.739 34.2383C70.183 34.2383 69.766 34.4753 69.488 34.9492V40.165H67.5125V32.7686H69.3718ZM77.6264 30.9502V32.7686H78.891V34.2178H77.6264V37.9092C77.6264 38.1826 77.6788 38.3786 77.7836 38.4971C77.8884 38.6156 78.0889 38.6748 78.3852 38.6748C78.6039 38.6748 78.7976 38.6589 78.9662 38.627V40.124C78.5788 40.2425 78.1801 40.3018 77.7699 40.3018C76.3845 40.3018 75.6781 39.6022 75.6508 38.2031V34.2178H74.5707V32.7686H75.6508V30.9502H77.6264ZM8.91699 49.5352C8.91699 50.6745 8.65723 51.5882 8.1377 52.2764C7.62272 52.96 6.92546 53.3018 6.0459 53.3018C5.2985 53.3018 4.69466 53.042 4.23438 52.5225V56.0088H2.25879V45.7686H4.09082L4.15918 46.4932C4.6377 45.9189 5.26204 45.6318 6.03223 45.6318C6.94368 45.6318 7.65234 45.9691 8.1582 46.6436C8.66406 47.318 8.91699 48.2477 8.91699 49.4326V49.5352ZM6.94141 49.3916C6.94141 48.7035 6.81836 48.1725 6.57227 47.7988C6.33073 47.4251 5.97754 47.2383 5.5127 47.2383C4.8929 47.2383 4.4668 47.4753 4.23438 47.9492V50.9775C4.47591 51.4652 4.90658 51.709 5.52637 51.709C6.46973 51.709 6.94141 50.9365 6.94141 49.3916ZM14.1637 47.6211C13.8948 47.5846 13.6579 47.5664 13.4528 47.5664C12.7054 47.5664 12.2155 47.8193 11.983 48.3252V53.165H10.0075V45.7686H11.8737L11.9284 46.6504C12.3248 45.9714 12.874 45.6318 13.5758 45.6318C13.7946 45.6318 13.9996 45.6615 14.1911 45.7207L14.1637 47.6211ZM14.427 49.3984C14.427 48.6647 14.5683 48.0107 14.8509 47.4365C15.1334 46.8623 15.539 46.418 16.0677 46.1035C16.6009 45.7891 17.2184 45.6318 17.9202 45.6318C18.9182 45.6318 19.7317 45.9372 20.3606 46.5479C20.9941 47.1585 21.3473 47.988 21.4202 49.0361L21.4339 49.542C21.4339 50.6768 21.1171 51.5882 20.4837 52.2764C19.8502 52.96 19.0003 53.3018 17.9339 53.3018C16.8675 53.3018 16.0152 52.96 15.3772 52.2764C14.7438 51.5928 14.427 50.6631 14.427 49.4873V49.3984ZM16.4026 49.542C16.4026 50.2438 16.5348 50.7816 16.7991 51.1553C17.0634 51.5244 17.4417 51.709 17.9339 51.709C18.4124 51.709 18.7861 51.5267 19.055 51.1621C19.3238 50.793 19.4583 50.2051 19.4583 49.3984C19.4583 48.7103 19.3238 48.1771 19.055 47.7988C18.7861 47.4206 18.4078 47.2314 17.9202 47.2314C17.4371 47.2314 17.0634 47.4206 16.7991 47.7988C16.5348 48.1725 16.4026 48.7536 16.4026 49.542ZM22.2236 49.4121C22.2236 48.2773 22.4924 47.3636 23.0302 46.6709C23.5725 45.9782 24.3017 45.6318 25.2177 45.6318C26.0289 45.6318 26.6601 45.9098 27.1112 46.4658L27.1933 45.7686H28.9843V52.9189C28.9843 53.5661 28.8362 54.1289 28.54 54.6074C28.2483 55.0859 27.8359 55.4505 27.3027 55.7012C26.7695 55.9518 26.1451 56.0771 25.4296 56.0771C24.8873 56.0771 24.3586 55.9678 23.8437 55.749C23.3287 55.5348 22.939 55.2568 22.6747 54.915L23.5497 53.7119C24.0419 54.2633 24.6389 54.5391 25.3407 54.5391C25.8648 54.5391 26.2727 54.3978 26.5644 54.1152C26.856 53.8372 27.0019 53.4408 27.0019 52.9258V52.5293C26.5461 53.0443 25.9469 53.3018 25.204 53.3018C24.3154 53.3018 23.5953 52.9554 23.0439 52.2627C22.497 51.5654 22.2236 50.6426 22.2236 49.4941V49.4121ZM24.1991 49.5557C24.1991 50.2256 24.3336 50.752 24.6025 51.1348C24.8713 51.513 25.2405 51.7021 25.7099 51.7021C26.3114 51.7021 26.7421 51.4766 27.0019 51.0254V47.915C26.7376 47.4639 26.3114 47.2383 25.7236 47.2383C25.2496 47.2383 24.8759 47.432 24.6025 47.8193C24.3336 48.2067 24.1991 48.7855 24.1991 49.5557ZM34.525 47.6211C34.2561 47.5846 34.0191 47.5664 33.814 47.5664C33.0666 47.5664 32.5767 47.8193 32.3443 48.3252V53.165H30.3687V45.7686H32.2349L32.2896 46.6504C32.6861 45.9714 33.2352 45.6318 33.9371 45.6318C34.1558 45.6318 34.3609 45.6615 34.5523 45.7207L34.525 47.6211ZM39.423 53.165C39.3319 52.9873 39.2658 52.7663 39.2248 52.502C38.7463 53.0352 38.1242 53.3018 37.3586 53.3018C36.634 53.3018 36.0324 53.0921 35.5539 52.6729C35.0799 52.2536 34.843 51.7249 34.843 51.0869C34.843 50.3031 35.1324 49.7015 35.7111 49.2822C36.2945 48.863 37.1353 48.651 38.2336 48.6465H39.1428V48.2227C39.1428 47.8809 39.0539 47.6074 38.8762 47.4023C38.703 47.1973 38.4273 47.0947 38.049 47.0947C37.7163 47.0947 37.4543 47.1745 37.2629 47.334C37.076 47.4935 36.9826 47.7122 36.9826 47.9902H35.007C35.007 47.5618 35.1392 47.1654 35.4035 46.8008C35.6678 46.4362 36.0415 46.1514 36.5246 45.9463C37.0077 45.7367 37.55 45.6318 38.1516 45.6318C39.063 45.6318 39.7854 45.862 40.3186 46.3223C40.8563 46.778 41.1252 47.4206 41.1252 48.25V51.4561C41.1298 52.1579 41.2277 52.6888 41.4191 53.0488V53.165H39.423ZM37.7893 51.791C38.0809 51.791 38.3498 51.7272 38.5959 51.5996C38.842 51.4674 39.0243 51.292 39.1428 51.0732V49.8018H38.4045C37.4156 49.8018 36.8892 50.1436 36.8254 50.8271L36.8186 50.9434C36.8186 51.1895 36.9051 51.3923 37.0783 51.5518C37.2515 51.7113 37.4885 51.791 37.7893 51.791ZM44.3553 45.7686L44.4168 46.5957C44.9409 45.9531 45.6496 45.6318 46.5428 45.6318C47.4953 45.6318 48.1493 46.0078 48.5047 46.7598C49.0243 46.0078 49.7648 45.6318 50.7264 45.6318C51.5285 45.6318 52.1255 45.8665 52.5174 46.3359C52.9093 46.8008 53.1053 47.5026 53.1053 48.4414V53.165H51.1229V48.4482C51.1229 48.029 51.0409 47.7236 50.8768 47.5322C50.7127 47.3363 50.4233 47.2383 50.0086 47.2383C49.4162 47.2383 49.006 47.5208 48.7782 48.0859L48.785 53.165H46.8094V48.4551C46.8094 48.0267 46.7251 47.7168 46.5565 47.5254C46.3879 47.334 46.1008 47.2383 45.6952 47.2383C45.1346 47.2383 44.729 47.4707 44.4784 47.9355V53.165H42.5028V45.7686H44.3553ZM56.3423 45.7686L56.4038 46.5957C56.9279 45.9531 57.6365 45.6318 58.5298 45.6318C59.4822 45.6318 60.1362 46.0078 60.4917 46.7598C61.0112 46.0078 61.7518 45.6318 62.7134 45.6318C63.5154 45.6318 64.1124 45.8665 64.5044 46.3359C64.8963 46.8008 65.0923 47.5026 65.0923 48.4414V53.165H63.1098V48.4482C63.1098 48.029 63.0278 47.7236 62.8638 47.5322C62.6997 47.3363 62.4103 47.2383 61.9956 47.2383C61.4031 47.2383 60.993 47.5208 60.7651 48.0859L60.772 53.165H58.7964V48.4551C58.7964 48.0267 58.7121 47.7168 58.5434 47.5254C58.3748 47.334 58.0877 47.2383 57.6821 47.2383C57.1216 47.2383 56.716 47.4707 56.4653 47.9355V53.165H54.4897V45.7686H56.3423ZM69.881 53.3018C68.7963 53.3018 67.9122 52.9691 67.2286 52.3037C66.5496 51.6383 66.2101 50.752 66.2101 49.6445V49.4531C66.2101 48.7103 66.3536 48.0472 66.6407 47.4639C66.9278 46.876 67.3334 46.4248 67.8575 46.1104C68.3862 45.7913 68.9877 45.6318 69.6622 45.6318C70.6739 45.6318 71.4692 45.9508 72.048 46.5889C72.6313 47.2269 72.923 48.1315 72.923 49.3027V50.1094H68.213C68.2768 50.5924 68.4682 50.9798 68.7872 51.2715C69.1108 51.5632 69.5187 51.709 70.0109 51.709C70.7719 51.709 71.3667 51.4333 71.795 50.8818L72.7657 51.9688C72.4695 52.388 72.0685 52.7161 71.5626 52.9531C71.0568 53.1855 70.4962 53.3018 69.881 53.3018ZM69.6554 47.2314C69.2635 47.2314 68.9445 47.3636 68.6984 47.6279C68.4568 47.8923 68.3019 48.2705 68.2335 48.7627H70.9816V48.6055C70.9724 48.168 70.854 47.8307 70.6261 47.5938C70.3982 47.3522 70.0747 47.2314 69.6554 47.2314Z",
          fill: "#0F1A22"
        }
      ),
      /* @__PURE__ */ h.jsx("rect", { x: "95.5", y: "1", width: "2", height: "54", fill: "#0F1A22" }),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M120.377 10.6865H116.439V13.3525H121.061V15H114.389V5.04688H121.047V6.70801H116.439V9.08008H120.377V10.6865ZM123.812 7.60352L123.874 8.45801C124.402 7.7972 125.111 7.4668 126 7.4668C126.784 7.4668 127.367 7.69694 127.75 8.15723C128.132 8.61751 128.328 9.30566 128.338 10.2217V15H126.362V10.2695C126.362 9.85026 126.271 9.5472 126.089 9.36035C125.906 9.16895 125.603 9.07324 125.179 9.07324C124.623 9.07324 124.206 9.31022 123.928 9.78418V15H121.953V7.60352H123.812ZM132.47 12.5869L133.844 7.60352H135.908L133.413 15H131.527L129.032 7.60352H131.096L132.47 12.5869ZM138.728 15H136.746V7.60352H138.728V15ZM136.63 5.68945C136.63 5.39323 136.728 5.14941 136.924 4.95801C137.124 4.7666 137.395 4.6709 137.737 4.6709C138.074 4.6709 138.343 4.7666 138.544 4.95801C138.744 5.14941 138.845 5.39323 138.845 5.68945C138.845 5.99023 138.742 6.23633 138.537 6.42773C138.337 6.61914 138.07 6.71484 137.737 6.71484C137.405 6.71484 137.136 6.61914 136.931 6.42773C136.73 6.23633 136.63 5.99023 136.63 5.68945ZM144.378 9.45605C144.11 9.4196 143.873 9.40137 143.668 9.40137C142.92 9.40137 142.43 9.6543 142.198 10.1602V15H140.222V7.60352H142.088L142.143 8.48535C142.54 7.80632 143.089 7.4668 143.791 7.4668C144.009 7.4668 144.214 7.49642 144.406 7.55566L144.378 9.45605ZM144.642 11.2334C144.642 10.4997 144.783 9.8457 145.066 9.27148C145.348 8.69727 145.754 8.25293 146.282 7.93848C146.816 7.62402 147.433 7.4668 148.135 7.4668C149.133 7.4668 149.946 7.77214 150.575 8.38281C151.209 8.99349 151.562 9.82292 151.635 10.8711L151.649 11.377C151.649 12.5117 151.332 13.4232 150.698 14.1113C150.065 14.7949 149.215 15.1367 148.149 15.1367C147.082 15.1367 146.23 14.7949 145.592 14.1113C144.959 13.4277 144.642 12.498 144.642 11.3223V11.2334ZM146.617 11.377C146.617 12.0788 146.75 12.6165 147.014 12.9902C147.278 13.3594 147.656 13.5439 148.149 13.5439C148.627 13.5439 149.001 13.3617 149.27 12.9971C149.539 12.6279 149.673 12.04 149.673 11.2334C149.673 10.5452 149.539 10.012 149.27 9.63379C149.001 9.25553 148.623 9.06641 148.135 9.06641C147.652 9.06641 147.278 9.25553 147.014 9.63379C146.75 10.0075 146.617 10.5885 146.617 11.377ZM154.544 7.60352L154.605 8.45801C155.134 7.7972 155.843 7.4668 156.731 7.4668C157.515 7.4668 158.098 7.69694 158.481 8.15723C158.864 8.61751 159.06 9.30566 159.069 10.2217V15H157.094V10.2695C157.094 9.85026 157.002 9.5472 156.82 9.36035C156.638 9.16895 156.335 9.07324 155.911 9.07324C155.355 9.07324 154.938 9.31022 154.66 9.78418V15H152.684V7.60352H154.544ZM162.286 7.60352L162.347 8.43066C162.871 7.78809 163.58 7.4668 164.473 7.4668C165.426 7.4668 166.08 7.84277 166.435 8.59473C166.955 7.84277 167.695 7.4668 168.657 7.4668C169.459 7.4668 170.056 7.7015 170.448 8.1709C170.84 8.63574 171.036 9.33757 171.036 10.2764V15H169.053V10.2832C169.053 9.86393 168.971 9.55859 168.807 9.36719C168.643 9.17122 168.354 9.07324 167.939 9.07324C167.346 9.07324 166.936 9.35579 166.708 9.9209L166.715 15H164.74V10.29C164.74 9.86165 164.655 9.55176 164.487 9.36035C164.318 9.16895 164.031 9.07324 163.625 9.07324C163.065 9.07324 162.659 9.30566 162.409 9.77051V15H160.433V7.60352H162.286ZM175.824 15.1367C174.74 15.1367 173.856 14.804 173.172 14.1387C172.493 13.4733 172.153 12.5869 172.153 11.4795V11.2881C172.153 10.5452 172.297 9.88216 172.584 9.29883C172.871 8.71094 173.277 8.25977 173.801 7.94531C174.33 7.6263 174.931 7.4668 175.606 7.4668C176.617 7.4668 177.413 7.78581 177.991 8.42383C178.575 9.06185 178.866 9.96647 178.866 11.1377V11.9443H174.156C174.22 12.4274 174.412 12.8148 174.731 13.1064C175.054 13.3981 175.462 13.5439 175.954 13.5439C176.715 13.5439 177.31 13.2682 177.738 12.7168L178.709 13.8037C178.413 14.223 178.012 14.5511 177.506 14.7881C177 15.0205 176.44 15.1367 175.824 15.1367ZM175.599 9.06641C175.207 9.06641 174.888 9.19857 174.642 9.46289C174.4 9.72721 174.245 10.1055 174.177 10.5977H176.925V10.4404C176.916 10.0029 176.797 9.66569 176.569 9.42871C176.342 9.18717 176.018 9.06641 175.599 9.06641ZM181.673 7.60352L181.734 8.45801C182.263 7.7972 182.971 7.4668 183.86 7.4668C184.644 7.4668 185.227 7.69694 185.61 8.15723C185.993 8.61751 186.189 9.30566 186.198 10.2217V15H184.222V10.2695C184.222 9.85026 184.131 9.5472 183.949 9.36035C183.767 9.16895 183.464 9.07324 183.04 9.07324C182.484 9.07324 182.067 9.31022 181.789 9.78418V15H179.813V7.60352H181.673ZM189.927 5.78516V7.60352H191.192V9.05273H189.927V12.7441C189.927 13.0176 189.98 13.2135 190.084 13.332C190.189 13.4505 190.39 13.5098 190.686 13.5098C190.905 13.5098 191.098 13.4938 191.267 13.4619V14.959C190.88 15.0775 190.481 15.1367 190.071 15.1367C188.685 15.1367 187.979 14.4372 187.952 13.0381V9.05273H186.871V7.60352H187.952V5.78516H189.927ZM196.439 15C196.347 14.8223 196.281 14.6012 196.24 14.3369C195.762 14.8701 195.14 15.1367 194.374 15.1367C193.649 15.1367 193.048 14.9271 192.569 14.5078C192.095 14.0885 191.858 13.5599 191.858 12.9219C191.858 12.138 192.148 11.5365 192.727 11.1172C193.31 10.6979 194.151 10.486 195.249 10.4814H196.158V10.0576C196.158 9.71582 196.069 9.44238 195.892 9.2373C195.718 9.03223 195.443 8.92969 195.064 8.92969C194.732 8.92969 194.47 9.00944 194.278 9.16895C194.092 9.32845 193.998 9.5472 193.998 9.8252H192.022C192.022 9.39681 192.155 9.00033 192.419 8.63574C192.683 8.27116 193.057 7.98633 193.54 7.78125C194.023 7.57161 194.565 7.4668 195.167 7.4668C196.078 7.4668 196.801 7.69694 197.334 8.15723C197.872 8.61296 198.141 9.25553 198.141 10.085V13.291C198.145 13.9928 198.243 14.5238 198.435 14.8838V15H196.439ZM194.805 13.626C195.096 13.626 195.365 13.5622 195.611 13.4346C195.857 13.3024 196.04 13.127 196.158 12.9082V11.6367H195.42C194.431 11.6367 193.905 11.9785 193.841 12.6621L193.834 12.7783C193.834 13.0244 193.921 13.2272 194.094 13.3867C194.267 13.5462 194.504 13.626 194.805 13.626ZM201.603 15H199.621V4.5H201.603V15ZM208.624 11.4932V15H206.573V5.04688H210.456C211.203 5.04688 211.86 5.18359 212.425 5.45703C212.994 5.73047 213.432 6.12012 213.737 6.62598C214.043 7.12728 214.195 7.69922 214.195 8.3418C214.195 9.31706 213.86 10.0872 213.19 10.6523C212.525 11.2129 211.602 11.4932 210.422 11.4932H208.624ZM208.624 9.83203H210.456C210.998 9.83203 211.411 9.70443 211.693 9.44922C211.98 9.19401 212.124 8.82943 212.124 8.35547C212.124 7.86784 211.98 7.47363 211.693 7.17285C211.406 6.87207 211.01 6.71712 210.504 6.70801H208.624V9.83203ZM214.937 11.2334C214.937 10.4997 215.078 9.8457 215.361 9.27148C215.643 8.69727 216.049 8.25293 216.578 7.93848C217.111 7.62402 217.728 7.4668 218.43 7.4668C219.428 7.4668 220.242 7.77214 220.871 8.38281C221.504 8.99349 221.857 9.82292 221.93 10.8711L221.944 11.377C221.944 12.5117 221.627 13.4232 220.994 14.1113C220.36 14.7949 219.51 15.1367 218.444 15.1367C217.378 15.1367 216.525 14.7949 215.887 14.1113C215.254 13.4277 214.937 12.498 214.937 11.3223V11.2334ZM216.913 11.377C216.913 12.0788 217.045 12.6165 217.309 12.9902C217.574 13.3594 217.952 13.5439 218.444 13.5439C218.922 13.5439 219.296 13.3617 219.565 12.9971C219.834 12.6279 219.968 12.04 219.968 11.2334C219.968 10.5452 219.834 10.012 219.565 9.63379C219.296 9.25553 218.918 9.06641 218.43 9.06641C217.947 9.06641 217.574 9.25553 217.309 9.63379C217.045 10.0075 216.913 10.5885 216.913 11.377ZM225.106 15H223.123V4.5H225.106V15ZM228.684 15H226.702V7.60352H228.684V15ZM226.586 5.68945C226.586 5.39323 226.684 5.14941 226.88 4.95801C227.08 4.7666 227.351 4.6709 227.693 4.6709C228.03 4.6709 228.299 4.7666 228.5 4.95801C228.7 5.14941 228.801 5.39323 228.801 5.68945C228.801 5.99023 228.698 6.23633 228.493 6.42773C228.293 6.61914 228.026 6.71484 227.693 6.71484C227.361 6.71484 227.092 6.61914 226.887 6.42773C226.686 6.23633 226.586 5.99023 226.586 5.68945ZM233.254 13.5439C233.619 13.5439 233.915 13.4437 234.143 13.2432C234.371 13.0426 234.489 12.776 234.499 12.4434H236.351C236.347 12.9447 236.21 13.4049 235.941 13.8242C235.672 14.2389 235.303 14.5625 234.834 14.7949C234.369 15.0228 233.854 15.1367 233.289 15.1367C232.231 15.1367 231.397 14.8018 230.787 14.1318C230.176 13.4574 229.871 12.5277 229.871 11.3428V11.2129C229.871 10.0736 230.174 9.16439 230.78 8.48535C231.386 7.80632 232.218 7.4668 233.275 7.4668C234.2 7.4668 234.941 7.73112 235.497 8.25977C236.057 8.78385 236.342 9.4834 236.351 10.3584H234.499C234.489 9.97559 234.371 9.66569 234.143 9.42871C233.915 9.18717 233.614 9.06641 233.241 9.06641C232.78 9.06641 232.432 9.23503 232.195 9.57227C231.962 9.90495 231.846 10.4473 231.846 11.1992V11.4043C231.846 12.1654 231.962 12.7122 232.195 13.0449C232.427 13.3776 232.78 13.5439 233.254 13.5439ZM240.101 12.2041L241.468 7.60352H243.587L240.613 16.1484L240.449 16.5381C240.007 17.5042 239.278 17.9873 238.262 17.9873C237.975 17.9873 237.683 17.944 237.387 17.8574V16.3604L237.688 16.3672C238.061 16.3672 238.339 16.3102 238.522 16.1963C238.708 16.0824 238.854 15.8932 238.959 15.6289L239.192 15.0205L236.601 7.60352H238.727L240.101 12.2041ZM254.785 6.70801H251.736V15H249.685V6.70801H246.677V5.04688H254.785V6.70801ZM259.396 9.45605C259.127 9.4196 258.89 9.40137 258.685 9.40137C257.937 9.40137 257.447 9.6543 257.215 10.1602V15H255.239V7.60352H257.106L257.16 8.48535C257.557 7.80632 258.106 7.4668 258.808 7.4668C259.026 7.4668 259.232 7.49642 259.423 7.55566L259.396 9.45605ZM264.294 15C264.203 14.8223 264.136 14.6012 264.095 14.3369C263.617 14.8701 262.995 15.1367 262.229 15.1367C261.505 15.1367 260.903 14.9271 260.425 14.5078C259.951 14.0885 259.714 13.5599 259.714 12.9219C259.714 12.138 260.003 11.5365 260.582 11.1172C261.165 10.6979 262.006 10.486 263.104 10.4814H264.013V10.0576C264.013 9.71582 263.925 9.44238 263.747 9.2373C263.574 9.03223 263.298 8.92969 262.92 8.92969C262.587 8.92969 262.325 9.00944 262.134 9.16895C261.947 9.32845 261.853 9.5472 261.853 9.8252H259.878C259.878 9.39681 260.01 9.00033 260.274 8.63574C260.538 8.27116 260.912 7.98633 261.395 7.78125C261.878 7.57161 262.421 7.4668 263.022 7.4668C263.934 7.4668 264.656 7.69694 265.189 8.15723C265.727 8.61296 265.996 9.25553 265.996 10.085V13.291C266 13.9928 266.098 14.5238 266.29 14.8838V15H264.294ZM262.66 13.626C262.952 13.626 263.22 13.5622 263.467 13.4346C263.713 13.3024 263.895 13.127 264.013 12.9082V11.6367H263.275C262.286 11.6367 261.76 11.9785 261.696 12.6621L261.689 12.7783C261.689 13.0244 261.776 13.2272 261.949 13.3867C262.122 13.5462 262.359 13.626 262.66 13.626ZM270.45 13.5439C270.814 13.5439 271.11 13.4437 271.338 13.2432C271.566 13.0426 271.685 12.776 271.694 12.4434H273.546C273.542 12.9447 273.405 13.4049 273.136 13.8242C272.867 14.2389 272.498 14.5625 272.029 14.7949C271.564 15.0228 271.049 15.1367 270.484 15.1367C269.426 15.1367 268.592 14.8018 267.982 14.1318C267.371 13.4574 267.066 12.5277 267.066 11.3428V11.2129C267.066 10.0736 267.369 9.16439 267.975 8.48535C268.581 7.80632 269.413 7.4668 270.47 7.4668C271.395 7.4668 272.136 7.73112 272.692 8.25977C273.252 8.78385 273.537 9.4834 273.546 10.3584H271.694C271.685 9.97559 271.566 9.66569 271.338 9.42871C271.11 9.18717 270.81 9.06641 270.436 9.06641C269.976 9.06641 269.627 9.23503 269.39 9.57227C269.158 9.90495 269.041 10.4473 269.041 11.1992V11.4043C269.041 12.1654 269.158 12.7122 269.39 13.0449C269.622 13.3776 269.976 13.5439 270.45 13.5439ZM277.221 12.0332L276.51 12.7441V15H274.534V4.5H276.51V10.3174L276.893 9.8252L278.786 7.60352H281.158L278.485 10.6865L281.391 15H279.121L277.221 12.0332ZM285.14 15.1367C284.056 15.1367 283.172 14.804 282.488 14.1387C281.809 13.4733 281.469 12.5869 281.469 11.4795V11.2881C281.469 10.5452 281.613 9.88216 281.9 9.29883C282.187 8.71094 282.593 8.25977 283.117 7.94531C283.645 7.6263 284.247 7.4668 284.922 7.4668C285.933 7.4668 286.728 7.78581 287.307 8.42383C287.891 9.06185 288.182 9.96647 288.182 11.1377V11.9443H283.472C283.536 12.4274 283.728 12.8148 284.047 13.1064C284.37 13.3981 284.778 13.5439 285.27 13.5439C286.031 13.5439 286.626 13.2682 287.054 12.7168L288.025 13.8037C287.729 14.223 287.328 14.5511 286.822 14.7881C286.316 15.0205 285.756 15.1367 285.14 15.1367ZM284.915 9.06641C284.523 9.06641 284.204 9.19857 283.958 9.46289C283.716 9.72721 283.561 10.1055 283.493 10.5977H286.241V10.4404C286.232 10.0029 286.113 9.66569 285.885 9.42871C285.658 9.18717 285.334 9.06641 284.915 9.06641ZM293.326 9.45605C293.058 9.4196 292.821 9.40137 292.616 9.40137C291.868 9.40137 291.378 9.6543 291.146 10.1602V15H289.17V7.60352H291.036L291.091 8.48535C291.488 7.80632 292.037 7.4668 292.739 7.4668C292.957 7.4668 293.162 7.49642 293.354 7.55566L293.326 9.45605Z",
          fill: "#162631"
        }
      ),
      /* @__PURE__ */ h.jsx("rect", { x: "113.5", y: "35", width: "100", height: "17", rx: "4", fill: "#213543" }),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M119.662 46L121.696 40.06H123.586L125.62 46H124.216L122.713 41.086H122.578L121.066 46H119.662ZM120.805 44.83V43.948H124.666V44.83H120.805ZM128.241 46V40.06H129.564V46H128.241ZM132.678 46V40.06H135.09C135.414 40.06 135.708 40.087 135.972 40.141C136.236 40.189 136.47 40.261 136.674 40.357C136.878 40.453 137.049 40.573 137.187 40.717C137.331 40.855 137.439 41.017 137.511 41.203C137.583 41.383 137.619 41.584 137.619 41.806C137.619 42.016 137.586 42.208 137.52 42.382C137.454 42.55 137.355 42.697 137.223 42.823C137.091 42.949 136.926 43.054 136.728 43.138C136.53 43.216 136.299 43.27 136.035 43.3V43.435C136.341 43.465 136.584 43.537 136.764 43.651C136.95 43.759 137.094 43.906 137.196 44.092C137.304 44.278 137.397 44.509 137.475 44.785L137.835 46H136.404L136.125 44.875C136.071 44.635 135.993 44.449 135.891 44.317C135.789 44.179 135.66 44.083 135.504 44.029C135.348 43.969 135.159 43.939 134.937 43.939H133.974V46H132.678ZM133.974 42.967H135C135.408 42.967 135.723 42.889 135.945 42.733C136.167 42.577 136.278 42.334 136.278 42.004C136.278 41.68 136.173 41.443 135.963 41.293C135.759 41.137 135.45 41.059 135.036 41.059H133.974V42.967ZM145.37 44.326V43.309H146.729C147.161 43.309 147.485 43.222 147.701 43.048C147.917 42.868 148.025 42.574 148.025 42.166C148.025 41.806 147.923 41.533 147.719 41.347C147.521 41.155 147.212 41.059 146.792 41.059H145.37V40.06H146.828C147.212 40.06 147.557 40.105 147.863 40.195C148.175 40.285 148.439 40.42 148.655 40.6C148.877 40.774 149.045 40.996 149.159 41.266C149.273 41.53 149.33 41.842 149.33 42.202C149.33 42.664 149.225 43.054 149.015 43.372C148.805 43.684 148.493 43.921 148.079 44.083C147.671 44.245 147.161 44.326 146.549 44.326H145.37ZM144.461 46V40.06H145.757V46H144.461ZM154.67 46.126C154.238 46.126 153.851 46.06 153.509 45.928C153.167 45.79 152.873 45.592 152.627 45.334C152.387 45.07 152.201 44.749 152.069 44.371C151.943 43.987 151.88 43.549 151.88 43.057C151.88 42.355 152.003 41.776 152.249 41.32C152.495 40.858 152.831 40.513 153.257 40.285C153.689 40.051 154.175 39.934 154.715 39.934C155.135 39.934 155.516 40.003 155.858 40.141C156.2 40.273 156.491 40.471 156.731 40.735C156.977 40.993 157.166 41.317 157.298 41.707C157.43 42.091 157.496 42.532 157.496 43.03C157.496 43.54 157.43 43.987 157.298 44.371C157.166 44.755 156.974 45.079 156.722 45.343C156.476 45.601 156.179 45.796 155.831 45.928C155.483 46.06 155.096 46.126 154.67 46.126ZM154.706 45.091C155.024 45.091 155.291 45.013 155.507 44.857C155.723 44.701 155.888 44.476 156.002 44.182C156.116 43.888 156.173 43.528 156.173 43.102C156.173 42.658 156.113 42.28 155.993 41.968C155.879 41.656 155.711 41.419 155.489 41.257C155.267 41.089 154.997 41.005 154.679 41.005C154.367 41.005 154.1 41.086 153.878 41.248C153.662 41.404 153.494 41.632 153.374 41.932C153.26 42.232 153.203 42.604 153.203 43.048C153.203 43.372 153.236 43.663 153.302 43.921C153.374 44.173 153.473 44.386 153.599 44.56C153.725 44.734 153.881 44.866 154.067 44.956C154.253 45.046 154.466 45.091 154.706 45.091ZM160.392 46V40.06H161.688V46H160.392ZM160.662 46V44.911H164.199V46H160.662ZM166.762 46V40.06H168.058V46H166.762ZM167.032 46V44.911H170.569V46H167.032ZM175.646 46.126C175.28 46.126 174.953 46.087 174.665 46.009C174.383 45.937 174.137 45.832 173.927 45.694C173.717 45.55 173.54 45.379 173.396 45.181C173.258 44.977 173.153 44.749 173.081 44.497C173.015 44.245 172.982 43.969 172.982 43.669V40.06H174.287V43.624C174.287 43.93 174.335 44.185 174.431 44.389C174.533 44.587 174.683 44.734 174.881 44.83C175.079 44.926 175.331 44.974 175.637 44.974C175.949 44.974 176.204 44.926 176.402 44.83C176.606 44.734 176.756 44.587 176.852 44.389C176.954 44.185 177.005 43.93 177.005 43.624V40.06H178.292V43.669C178.292 44.449 178.07 45.055 177.626 45.487C177.188 45.913 176.528 46.126 175.646 46.126ZM182.626 46V40.06H183.922V46H182.626ZM180.871 41.149V40.06H185.677V41.149H180.871ZM188.307 46V40.06H189.63V46H188.307ZM195.318 46.126C194.886 46.126 194.499 46.06 194.157 45.928C193.815 45.79 193.521 45.592 193.275 45.334C193.035 45.07 192.849 44.749 192.717 44.371C192.591 43.987 192.528 43.549 192.528 43.057C192.528 42.355 192.651 41.776 192.897 41.32C193.143 40.858 193.479 40.513 193.905 40.285C194.337 40.051 194.823 39.934 195.363 39.934C195.783 39.934 196.164 40.003 196.506 40.141C196.848 40.273 197.139 40.471 197.379 40.735C197.625 40.993 197.814 41.317 197.946 41.707C198.078 42.091 198.144 42.532 198.144 43.03C198.144 43.54 198.078 43.987 197.946 44.371C197.814 44.755 197.622 45.079 197.37 45.343C197.124 45.601 196.827 45.796 196.479 45.928C196.131 46.06 195.744 46.126 195.318 46.126ZM195.354 45.091C195.672 45.091 195.939 45.013 196.155 44.857C196.371 44.701 196.536 44.476 196.65 44.182C196.764 43.888 196.821 43.528 196.821 43.102C196.821 42.658 196.761 42.28 196.641 41.968C196.527 41.656 196.359 41.419 196.137 41.257C195.915 41.089 195.645 41.005 195.327 41.005C195.015 41.005 194.748 41.086 194.526 41.248C194.31 41.404 194.142 41.632 194.022 41.932C193.908 42.232 193.851 42.604 193.851 43.048C193.851 43.372 193.884 43.663 193.95 43.921C194.022 44.173 194.121 44.386 194.247 44.56C194.373 44.734 194.529 44.866 194.715 44.956C194.901 45.046 195.114 45.091 195.354 45.091ZM201.039 46V40.06H202.731L205.422 44.263H205.521L205.44 40.06H206.7V46H205.17L202.326 41.599H202.227L202.308 46H201.039Z",
          fill: "white"
        }
      )
    ]
  }
), "UNEPEPTLogo"), ZT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsxs("svg", { width: "295", height: "57", viewBox: "0 0 295 57", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M20.4531 0.828125V16.749C20.4531 19.3942 19.623 21.486 17.9629 23.0244C16.3138 24.5628 14.056 25.332 11.1895 25.332C8.36719 25.332 6.12598 24.585 4.46582 23.0908C2.80566 21.5967 1.95898 19.5436 1.92578 16.9316V0.828125H6.90625V16.7822C6.90625 18.3649 7.28255 19.5215 8.03516 20.252C8.79883 20.9714 9.85026 21.3311 11.1895 21.3311C13.9896 21.3311 15.4118 19.859 15.4561 16.915V0.828125H20.4531ZM44.1934 25H39.2129L29.5176 9.0957V25H24.5371V0.828125H29.5176L39.2295 16.7656V0.828125H44.1934V25Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M62.0721 19.9887C59.0659 19.0805 56.8774 16.2888 56.8774 12.9876C56.8774 12.3911 56.9478 11.8113 57.0819 11.2583L61.8308 11.8683C61.8308 11.8683 63.654 11.9487 63.587 15.1761C63.5233 18.3063 62.0721 19.9887 62.0721 19.9887Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M66.3184 19.9887C69.3246 19.0805 71.5131 16.2888 71.5131 12.9876C71.5131 12.3911 71.4427 11.8113 71.3087 11.2583L66.5597 11.8683C66.5597 11.8683 64.7365 11.9487 64.8036 15.1761C64.8672 18.3063 66.3184 19.9887 66.3184 19.9887Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M64.1931 7.75268C64.803 7.75268 65.2991 8.24869 65.2991 8.85865C65.2991 9.33455 64.9706 9.6898 64.5752 9.90094C64.5282 9.92775 64.4813 9.94786 64.4914 10.0249C64.5014 10.102 64.7293 10.1456 64.8265 10.169L71.2109 10.9097C70.3161 7.88339 67.5143 5.6748 64.1964 5.6748H64.1864C60.8685 5.6748 58.0701 7.88339 57.1719 10.9097L63.5563 10.169C63.6535 10.1456 63.8814 10.1054 63.8915 10.0249C63.9015 9.95121 63.8546 9.92775 63.8077 9.90094C63.4122 9.6898 63.0838 9.33455 63.0838 8.85865C63.0871 8.24869 63.5831 7.75268 64.1931 7.75268Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M67.1121 25.1645L67.5445 24.893C67.5445 24.893 65.4934 22.1113 60.902 22.1113C58.5526 22.1113 57.3361 23.0564 55.6905 23.0564C55.6905 23.0564 55.0169 23.1369 54.3667 22.7313C54.3667 22.7313 55.1509 23.8641 57.9862 23.8641C60.0641 23.8641 61.5521 22.6476 63.01 22.6476C65.0041 22.6509 66.4888 24.4339 67.1121 25.1645Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M60.737 25.1645L60.3047 24.893C60.3047 24.893 62.3557 22.1113 66.9472 22.1113C69.2965 22.1113 70.5131 23.0564 72.1586 23.0564C72.1586 23.0564 72.8323 23.1369 73.4824 22.7313C73.4824 22.7313 72.6982 23.8641 69.8629 23.8641C67.785 23.8641 66.297 22.6476 64.8391 22.6476C62.8451 22.6509 61.357 24.4339 60.737 25.1645Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M58.5496 21.8739C58.4692 22.0884 57.5911 21.8336 56.9979 22.0079C56.3343 22.2057 52.8254 22.6279 51.2871 18.9849C51.2871 18.9849 52.745 20.5501 53.8811 20.6607C55.0139 20.7679 56.2573 21.0394 57.3096 21.6326L57.5543 21.6862C57.5543 21.6862 57.5207 21.5789 57.4202 21.5253C57.2828 21.4516 56.1902 21.0963 55.6641 19.3637C55.3926 18.4722 55.4496 17.8254 55.339 17.3662C55.339 17.3662 56.5287 18.69 57.0147 19.5279C57.4973 20.3624 57.5509 21.3075 58.5496 21.8739Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M54.9724 20.0365C54.8853 20.1236 54.6607 19.9829 54.5803 19.9426C54.4998 19.9024 53.9167 19.6343 52.918 19.2824C51.9327 18.9305 50.0961 17.3788 50.2704 14.7178C50.2704 14.7178 50.5284 15.7165 51.2825 16.3801C52.0399 17.0403 52.308 17.1241 52.7672 17.6637C53.2263 18.2033 54.2652 19.4332 54.3055 19.4198C54.3457 19.4064 54.3591 19.3394 54.2787 19.2724C54.1982 19.2053 53.9268 18.5284 53.7525 18.3005C53.5782 18.0726 53.052 16.4907 53.8195 14.5469C53.8195 14.5469 54.644 15.9645 54.5903 17.3956C54.5367 18.8266 54.4697 18.4881 54.8182 19.6779C54.8216 19.6712 55.0126 19.9963 54.9724 20.0365Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M52.6775 16.5709C52.6272 16.6212 52.4194 16.3129 52.2585 16.0314C52.0977 15.7465 50.9615 14.5333 50.8141 14.2886C50.6666 14.044 49.3964 12.5057 50.3549 10.2234C50.3549 10.2234 50.4488 10.1966 50.4488 10.7361C50.4488 11.2757 50.9481 12.4789 51.3537 12.9916C51.7592 13.5044 52.1245 14.3288 52.2049 15.2069C52.2049 15.2069 52.2585 15.3678 52.3256 15.3812C52.3926 15.3946 52.3926 15.2203 52.3926 15.2203C52.3926 15.2203 52.339 14.4093 52.339 13.8563C52.339 13.3033 52.5836 12.3582 53.1098 11.8186C53.1098 11.8186 53.3545 11.5472 53.5019 11.2254C53.5019 11.2254 53.5958 11.0109 53.7298 10.9003C53.7298 10.9003 53.8371 12.4521 53.3109 13.8965C52.7847 15.341 52.6104 15.5856 52.6909 16.3665C52.6909 16.3665 52.7043 16.5408 52.6775 16.5709Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M51.7852 12.2972C51.7316 12.2972 51.6914 12.1095 51.6646 11.9587C51.6378 11.8113 51.4769 10.9466 51.3663 10.7556C51.2591 10.5679 50.8535 9.70323 50.8401 8.6911C50.8267 7.67898 51.2859 6.30154 52.3114 5.20898C52.3114 5.20898 52.2712 5.53407 51.9997 6.24792C51.7283 6.96512 51.8925 7.63876 51.9193 7.75941C51.9461 7.88006 52.0399 8.71791 52.0399 9.11003C52.0399 9.42171 51.9595 10.4875 51.8925 10.7019C51.8925 10.7019 51.8657 10.8494 51.9193 10.8494C51.9729 10.8494 52.0265 10.7288 52.0265 10.7288C52.0265 10.7288 52.0802 9.89091 52.7002 9.13684C53.3202 8.37942 54.4429 7.92028 54.6172 7.58514C54.6172 7.58514 54.5367 8.77489 53.2263 10.1624C52.06 11.4024 52.4019 10.769 52.0232 11.7811C52.0232 11.7811 51.8623 12.1598 51.8623 12.2402C51.8657 12.3274 51.7852 12.2972 51.7852 12.2972Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M52.5031 8.29941C52.5031 8.29941 52.4763 8.13854 52.6774 7.77324C52.8785 7.40793 52.664 6.76111 52.9355 5.81601C53.2069 4.87092 53.7063 3.25218 55.6099 2.28027C55.6099 2.28027 55.4222 2.45455 55.325 2.59195C55.2312 2.72601 54.7184 3.69792 54.5676 4.37491C54.4202 5.04854 53.77 6.18467 53.5287 6.43938C53.284 6.69744 53.3946 6.72425 53.3946 6.72425C53.3946 6.72425 53.5153 6.69744 53.6393 6.50976C53.7599 6.32208 54.3833 5.61828 55.0703 5.45741C55.7574 5.29655 56.8533 4.97146 56.9203 4.90443C56.9203 4.90443 55.7306 6.12099 54.638 6.741C53.5454 7.36102 53.4214 7.17334 52.7746 8.01119C52.7713 8.00113 52.5568 8.29941 52.5031 8.29941Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M55.1206 4.69386C55.1206 4.69386 55.1206 4.58661 55.3217 4.39558C55.5228 4.2079 55.7272 3.63816 56.0791 3.11199C56.431 2.58582 57.2253 1.20839 59.2931 0.883301C59.2931 0.883301 58.6731 1.34244 58.5759 1.48991C58.4821 1.63737 57.8755 2.43501 57.604 2.70647C57.3325 2.97793 56.5651 3.54432 56.307 3.66497C56.307 3.66497 56.1729 3.77222 56.1998 3.81244C56.2266 3.85265 56.3606 3.77222 56.3606 3.77222C56.3606 3.77222 57.0778 3.21924 57.9391 3.19242C58.8038 3.16561 59.7087 3.20583 59.8427 3.21924C59.8427 3.21924 59.0317 3.77222 57.1013 4.12412C55.1709 4.47602 55.5362 4.48942 55.2379 4.6771C55.2413 4.68045 55.1742 4.73407 55.1206 4.69386Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M58.562 2.45717C58.562 2.45717 58.6022 2.34992 58.9139 2.25609C59.2256 2.16225 59.1988 1.86397 60.1439 1.36461C61.089 0.865249 62.0743 0.634001 63.073 1.05293C63.073 1.05293 62.6541 1.10655 62.5871 1.13336C62.52 1.16017 61.8028 1.34785 61.6017 1.45845C61.4007 1.56569 60.3584 2.02484 59.9394 2.10527C59.5205 2.18571 59.725 2.21252 59.725 2.21252C59.725 2.21252 59.8188 2.25273 59.8992 2.25273C59.9797 2.25273 60.9113 2.15889 61.518 2.37338C62.1246 2.58788 62.1112 2.67166 62.3558 2.75209C62.6005 2.83253 62.882 2.88615 62.9222 2.97999C62.9222 2.97999 62.3156 3.03361 61.9503 3.03361C61.585 3.03361 60.6265 2.93977 60.1673 2.72193C59.7082 2.50744 59.182 2.41025 59.0078 2.45047C58.8335 2.49739 58.619 2.49739 58.562 2.45717Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M62.4004 1.98756C62.4004 1.98756 62.4406 1.93393 62.7121 1.88031C62.9835 1.82669 63.0506 1.66582 63.684 1.52841C64.3174 1.391 65.3027 1.27035 66.2076 1.89372C66.2076 1.89372 65.6546 1.88031 65.534 1.88031C65.4133 1.88031 64.361 2.06799 64.1163 2.06799C63.8717 2.06799 63.3857 1.96074 63.3187 2.04118C63.2517 2.12161 63.7644 2.22886 63.8448 2.25567C63.9253 2.28248 64.2906 2.30929 64.7497 2.75503C65.2089 3.20077 65.534 3.44207 65.5876 3.47223C65.5876 3.47223 64.237 3.16055 63.8985 2.97287C63.56 2.78519 62.9802 2.20205 62.8863 2.16183C62.7892 2.12161 62.4004 1.98756 62.4004 1.98756Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M65.5161 2.53945C65.5161 2.53945 66.3674 2.51264 66.9874 2.90475C67.6074 3.29687 68.1068 3.80964 68.1604 4.12132C68.1604 4.12132 67.8085 3.82304 67.5806 3.75601C67.3493 3.68899 66.7025 3.32368 66.5685 3.24325C66.4344 3.16281 65.6502 2.6601 65.5161 2.53945Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M69.5142 22.0157C69.5142 22.0157 69.6348 21.8951 70.0403 21.5432C70.4459 21.1913 70.5531 20.6785 70.9988 19.8809C71.4446 19.0833 71.8233 18.5303 72.7282 17.7192C72.7282 17.7192 72.5673 18.3258 72.5539 18.5169C72.5405 18.7046 72.393 19.7602 71.8803 20.3669C71.3675 20.9735 71.3407 21.1109 70.7475 21.4728C70.7475 21.4728 70.5162 21.6337 70.533 21.6873C70.5464 21.7409 70.9385 21.6739 70.9385 21.6739C70.9385 21.6739 71.3708 21.513 71.5049 21.4293C71.639 21.3488 72.2489 21.0371 72.4902 20.9433C72.7349 20.8495 72.936 20.7556 73.4755 20.5914C74.0151 20.4305 75.9723 19.9312 76.7432 18.6878C76.7432 18.6878 76.5153 19.4184 76.2304 19.7535C75.9455 20.092 74.3402 22.2101 72.1115 22.1699C72.1115 22.1699 71.2334 22.1029 70.7743 22.0225C70.3152 21.942 70.1543 21.942 70.0873 21.9554C70.0135 21.9755 69.5812 22.056 69.5142 22.0157Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M74.4951 14.4441C74.4951 14.4441 73.6572 15.7545 73.4696 17.6447C73.2819 19.5349 73.6036 18.9685 73.2953 19.8063C73.2953 19.8063 73.188 20.0208 73.2283 20.0342C73.2685 20.0476 73.4293 19.9538 74.0259 19.5885C74.6191 19.2232 75.2022 19.3304 76.4691 18.1172C77.7393 16.9007 77.994 14.4843 78.0208 14.2832C78.0208 14.2832 77.8331 14.4709 77.7359 14.796C77.6421 15.1211 77.4376 15.3758 77.3974 15.416C77.3572 15.4562 75.9798 16.9677 75.8189 17.1051C75.658 17.2391 74.847 18.2245 74.6727 18.5093C74.4984 18.7942 73.9857 19.307 73.8885 19.2668C73.8885 19.2668 73.9019 19.1461 73.9421 19.0523C73.9823 18.9584 74.361 18.4457 74.5219 17.8491C74.6828 17.2559 74.723 16.8906 74.7364 16.5119C74.7532 16.1332 74.5085 14.7423 74.4951 14.4441Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M75.6312 16.2688C75.6312 16.2688 75.5474 16.0711 75.6178 15.9303C75.658 15.8499 75.6982 15.1997 75.4569 14.6736C75.2156 14.1474 74.6861 12.6895 74.7263 11.7176C74.7665 10.7457 74.8738 10.6116 74.8738 10.6116C74.8738 10.6116 75.1452 11.4093 75.2257 11.5433C75.3061 11.6774 76.1171 13.1084 76.0501 13.8927C75.9831 14.6769 75.9429 14.9182 75.9831 14.9316C76.0233 14.945 76.1171 14.8378 76.1305 14.7439C76.1439 14.6501 76.278 14.1105 76.5361 13.4737C76.7941 12.8403 77.833 11.4361 78.0609 10.5044C78.0609 10.5044 78.3994 12.1231 77.4946 13.638C76.5897 15.1495 76.4958 14.811 76.1171 15.5014C75.7384 16.1884 75.6848 16.2688 75.6312 16.2688Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M76.4517 11.9859C76.3847 11.9725 76.4249 11.3525 76.264 11.1481C76.1032 10.947 74.7123 9.29807 74.4141 7.65253C74.4141 7.65253 75.2921 8.54401 75.4396 8.63784C75.5871 8.73168 76.1836 9.32488 76.3579 9.841C76.5322 10.3538 76.4919 10.7861 76.559 10.7995C76.626 10.8129 76.626 10.2331 76.626 10.2331C76.626 10.2331 76.6394 9.10034 76.7332 8.55741C76.8271 8.01783 77.0717 7.11295 76.9645 6.65381C76.9645 6.65381 77.4907 7.49166 77.4638 8.67806C77.437 9.86781 76.9377 10.8129 76.8706 10.947C76.8036 11.081 76.6126 11.6642 76.6126 11.7848C76.6159 11.9055 76.4517 11.9859 76.4517 11.9859Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M74.8065 3.53467C74.8065 3.53467 76.6297 4.61382 76.3448 8.23335C76.3448 8.23335 76.3448 8.39422 76.2376 8.21994C76.1304 8.04567 75.7382 7.54631 75.564 7.43571C75.3897 7.32847 73.7676 6.34315 73.0806 4.82831C73.0806 4.82831 73.1878 4.8015 73.352 4.94896C73.5129 5.09643 74.0123 5.35449 74.096 5.3947C74.1765 5.43492 74.7429 5.58238 75.1618 6.04153C75.5807 6.50067 75.7282 6.83916 75.8488 7.10727C75.8488 7.10727 75.9695 7.20111 75.8891 6.933C75.8086 6.66154 75.7952 6.48726 75.5774 6.14877C75.3629 5.81028 75.1718 5.20367 75.145 4.78475C75.1182 4.37252 74.9942 3.74916 74.8065 3.53467Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M74.4956 4.80658C74.4956 4.80658 74.5358 4.56192 74.3615 4.22678C74.1873 3.88829 74.3247 3.51293 73.7683 2.62146C73.4567 2.1221 72.3775 1.72998 72.3775 1.72998C72.3775 1.72998 72.6892 2.16231 72.8903 2.40361C73.0913 2.64827 73.1617 2.82254 73.2288 2.94319C73.2958 3.06384 73.6711 3.4258 73.8085 3.63023C73.8354 3.67045 73.889 3.77769 73.889 3.84472C73.889 3.91175 73.7415 3.80451 73.7013 3.76429C73.6611 3.72407 73.0009 3.22471 72.5819 3.14428C72.163 3.06384 71.3654 2.98341 71.1509 2.87281C71.1509 2.87281 72.096 3.72407 73.1215 3.97878C74.1437 4.23684 74.4956 4.80658 74.4956 4.80658Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M72.3627 2.57751C72.3627 2.57751 71.4176 1.29392 69.7285 1.32073C69.7285 1.32073 69.8224 1.41457 70.0134 1.45478C70.2011 1.495 70.5396 1.83349 70.7138 1.94074C70.8915 2.05133 71.2534 2.31945 72.3627 2.57751Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M5.66309 40.3013C4.57845 40.3013 3.69434 39.9686 3.01074 39.3032C2.33171 38.6379 1.99219 37.7515 1.99219 36.644V36.4526C1.99219 35.7098 2.13574 35.0467 2.42285 34.4634C2.70996 33.8755 3.11556 33.4243 3.63965 33.1099C4.16829 32.7909 4.76986 32.6313 5.44434 32.6313C6.45605 32.6313 7.2513 32.9504 7.83008 33.5884C8.41341 34.2264 8.70508 35.131 8.70508 36.3022V37.1089H3.99512C4.05892 37.592 4.25033 37.9793 4.56934 38.271C4.8929 38.5627 5.30078 38.7085 5.79297 38.7085C6.55404 38.7085 7.14876 38.4328 7.57715 37.8813L8.54785 38.9683C8.25163 39.3875 7.85059 39.7157 7.34473 39.9526C6.83887 40.1851 6.27832 40.3013 5.66309 40.3013ZM5.4375 34.231C5.04557 34.231 4.72656 34.3631 4.48047 34.6274C4.23893 34.8918 4.08398 35.27 4.01562 35.7622H6.76367V35.605C6.75456 35.1675 6.63607 34.8302 6.4082 34.5933C6.18034 34.3517 5.85677 34.231 5.4375 34.231ZM11.5114 32.7681L11.5729 33.6226C12.1015 32.9618 12.8102 32.6313 13.6989 32.6313C14.4827 32.6313 15.0661 32.8615 15.4489 33.3218C15.8317 33.7821 16.0276 34.4702 16.0368 35.3862V40.1646H14.0612V35.4341C14.0612 35.0148 13.97 34.7118 13.7877 34.5249C13.6054 34.3335 13.3024 34.2378 12.8786 34.2378C12.3226 34.2378 11.9056 34.4748 11.6276 34.9487V40.1646H9.65199V32.7681H11.5114ZM20.1692 37.7515L21.5432 32.7681H23.6077L21.1126 40.1646H19.2259L16.7307 32.7681H18.7952L20.1692 37.7515ZM26.4277 40.1646H24.4452V32.7681H26.4277V40.1646ZM24.329 30.854C24.329 30.5578 24.427 30.314 24.623 30.1226C24.8235 29.9312 25.0946 29.8354 25.4364 29.8354C25.7737 29.8354 26.0426 29.9312 26.2431 30.1226C26.4436 30.314 26.5439 30.5578 26.5439 30.854C26.5439 31.1548 26.4413 31.4009 26.2362 31.5923C26.0357 31.7837 25.7691 31.8794 25.4364 31.8794C25.1038 31.8794 24.8349 31.7837 24.6298 31.5923C24.4293 31.4009 24.329 31.1548 24.329 30.854ZM32.0777 34.6206C31.8088 34.5841 31.5718 34.5659 31.3668 34.5659C30.6194 34.5659 30.1295 34.8188 29.897 35.3247V40.1646H27.9214V32.7681H29.7877L29.8423 33.6499C30.2388 32.9709 30.788 32.6313 31.4898 32.6313C31.7086 32.6313 31.9136 32.661 32.105 32.7202L32.0777 34.6206ZM32.341 36.3979C32.341 35.6642 32.4823 35.0103 32.7648 34.436C33.0474 33.8618 33.453 33.4175 33.9816 33.103C34.5148 32.7886 35.1324 32.6313 35.8342 32.6313C36.8322 32.6313 37.6457 32.9367 38.2746 33.5474C38.9081 34.158 39.2613 34.9875 39.3342 36.0356L39.3479 36.5415C39.3479 37.6763 39.0311 38.5877 38.3977 39.2759C37.7642 39.9595 36.9143 40.3013 35.8479 40.3013C34.7814 40.3013 33.9292 39.9595 33.2912 39.2759C32.6577 38.5923 32.341 37.6626 32.341 36.4868V36.3979ZM34.3166 36.5415C34.3166 37.2433 34.4488 37.7811 34.7131 38.1548C34.9774 38.5239 35.3557 38.7085 35.8479 38.7085C36.3264 38.7085 36.7001 38.5262 36.9689 38.1616C37.2378 37.7925 37.3723 37.2046 37.3723 36.3979C37.3723 35.7098 37.2378 35.1766 36.9689 34.7983C36.7001 34.4201 36.3218 34.231 35.8342 34.231C35.3511 34.231 34.9774 34.4201 34.7131 34.7983C34.4488 35.172 34.3166 35.7531 34.3166 36.5415ZM42.243 32.7681L42.3045 33.6226C42.8332 32.9618 43.5418 32.6313 44.4305 32.6313C45.2144 32.6313 45.7977 32.8615 46.1805 33.3218C46.5633 33.7821 46.7593 34.4702 46.7684 35.3862V40.1646H44.7928V35.4341C44.7928 35.0148 44.7017 34.7118 44.5194 34.5249C44.3371 34.3335 44.034 34.2378 43.6102 34.2378C43.0542 34.2378 42.6372 34.4748 42.3592 34.9487V40.1646H40.3836V32.7681H42.243ZM49.9848 32.7681L50.0464 33.5952C50.5705 32.9526 51.2791 32.6313 52.1723 32.6313C53.1248 32.6313 53.7788 33.0073 54.1343 33.7593C54.6538 33.0073 55.3943 32.6313 56.3559 32.6313C57.158 32.6313 57.755 32.866 58.147 33.3354C58.5389 33.8003 58.7348 34.5021 58.7348 35.4409V40.1646H56.7524V35.4478C56.7524 35.0285 56.6704 34.7231 56.5063 34.5317C56.3423 34.3358 56.0529 34.2378 55.6382 34.2378C55.0457 34.2378 54.6356 34.5203 54.4077 35.0854L54.4145 40.1646H52.4389V35.4546C52.4389 35.0262 52.3546 34.7163 52.186 34.5249C52.0174 34.3335 51.7303 34.2378 51.3247 34.2378C50.7641 34.2378 50.3585 34.4702 50.1079 34.9351V40.1646H48.1323V32.7681H49.9848ZM63.5236 40.3013C62.4389 40.3013 61.5548 39.9686 60.8712 39.3032C60.1922 38.6379 59.8527 37.7515 59.8527 36.644V36.4526C59.8527 35.7098 59.9962 35.0467 60.2833 34.4634C60.5704 33.8755 60.976 33.4243 61.5001 33.1099C62.0288 32.7909 62.6303 32.6313 63.3048 32.6313C64.3165 32.6313 65.1118 32.9504 65.6905 33.5884C66.2739 34.2264 66.5655 35.131 66.5655 36.3022V37.1089H61.8556C61.9194 37.592 62.1108 37.9793 62.4298 38.271C62.7534 38.5627 63.1613 38.7085 63.6534 38.7085C64.4145 38.7085 65.0092 38.4328 65.4376 37.8813L66.4083 38.9683C66.1121 39.3875 65.7111 39.7157 65.2052 39.9526C64.6993 40.1851 64.1388 40.3013 63.5236 40.3013ZM63.298 34.231C62.906 34.231 62.587 34.3631 62.3409 34.6274C62.0994 34.8918 61.9445 35.27 61.8761 35.7622H64.6241V35.605C64.615 35.1675 64.4965 34.8302 64.2687 34.5933C64.0408 34.3517 63.7172 34.231 63.298 34.231ZM69.3718 32.7681L69.4334 33.6226C69.962 32.9618 70.6707 32.6313 71.5593 32.6313C72.3432 32.6313 72.9265 32.8615 73.3093 33.3218C73.6921 33.7821 73.8881 34.4702 73.8972 35.3862V40.1646H71.9216V35.4341C71.9216 35.0148 71.8305 34.7118 71.6482 34.5249C71.4659 34.3335 71.1628 34.2378 70.739 34.2378C70.183 34.2378 69.766 34.4748 69.488 34.9487V40.1646H67.5125V32.7681H69.3718ZM77.6264 30.9497V32.7681H78.891V34.2173H77.6264V37.9087C77.6264 38.1821 77.6788 38.3781 77.7836 38.4966C77.8884 38.6151 78.0889 38.6743 78.3852 38.6743C78.6039 38.6743 78.7976 38.6584 78.9662 38.6265V40.1235C78.5788 40.242 78.1801 40.3013 77.7699 40.3013C76.3845 40.3013 75.6781 39.6017 75.6508 38.2026V34.2173H74.5707V32.7681H75.6508V30.9497H77.6264ZM8.91699 49.5347C8.91699 50.674 8.65723 51.5877 8.1377 52.2759C7.62272 52.9595 6.92546 53.3013 6.0459 53.3013C5.2985 53.3013 4.69466 53.0415 4.23438 52.522V56.0083H2.25879V45.7681H4.09082L4.15918 46.4927C4.6377 45.9185 5.26204 45.6313 6.03223 45.6313C6.94368 45.6313 7.65234 45.9686 8.1582 46.6431C8.66406 47.3175 8.91699 48.2472 8.91699 49.4321V49.5347ZM6.94141 49.3911C6.94141 48.703 6.81836 48.172 6.57227 47.7983C6.33073 47.4246 5.97754 47.2378 5.5127 47.2378C4.8929 47.2378 4.4668 47.4748 4.23438 47.9487V50.9771C4.47591 51.4647 4.90658 51.7085 5.52637 51.7085C6.46973 51.7085 6.94141 50.936 6.94141 49.3911ZM14.1637 47.6206C13.8948 47.5841 13.6579 47.5659 13.4528 47.5659C12.7054 47.5659 12.2155 47.8188 11.983 48.3247V53.1646H10.0075V45.7681H11.8737L11.9284 46.6499C12.3248 45.9709 12.874 45.6313 13.5758 45.6313C13.7946 45.6313 13.9996 45.661 14.1911 45.7202L14.1637 47.6206ZM14.427 49.3979C14.427 48.6642 14.5683 48.0103 14.8509 47.436C15.1334 46.8618 15.539 46.4175 16.0677 46.103C16.6009 45.7886 17.2184 45.6313 17.9202 45.6313C18.9182 45.6313 19.7317 45.9367 20.3606 46.5474C20.9941 47.158 21.3473 47.9875 21.4202 49.0356L21.4339 49.5415C21.4339 50.6763 21.1171 51.5877 20.4837 52.2759C19.8502 52.9595 19.0003 53.3013 17.9339 53.3013C16.8675 53.3013 16.0152 52.9595 15.3772 52.2759C14.7438 51.5923 14.427 50.6626 14.427 49.4868V49.3979ZM16.4026 49.5415C16.4026 50.2433 16.5348 50.7811 16.7991 51.1548C17.0634 51.5239 17.4417 51.7085 17.9339 51.7085C18.4124 51.7085 18.7861 51.5262 19.055 51.1616C19.3238 50.7925 19.4583 50.2046 19.4583 49.3979C19.4583 48.7098 19.3238 48.1766 19.055 47.7983C18.7861 47.4201 18.4078 47.231 17.9202 47.231C17.4371 47.231 17.0634 47.4201 16.7991 47.7983C16.5348 48.172 16.4026 48.7531 16.4026 49.5415ZM22.2236 49.4116C22.2236 48.2769 22.4924 47.3631 23.0302 46.6704C23.5725 45.9777 24.3017 45.6313 25.2177 45.6313C26.0289 45.6313 26.6601 45.9093 27.1112 46.4653L27.1933 45.7681H28.9843V52.9185C28.9843 53.5656 28.8362 54.1284 28.54 54.6069C28.2483 55.0854 27.8359 55.45 27.3027 55.7007C26.7695 55.9513 26.1451 56.0767 25.4296 56.0767C24.8873 56.0767 24.3586 55.9673 23.8437 55.7485C23.3287 55.5343 22.939 55.2563 22.6747 54.9146L23.5497 53.7114C24.0419 54.2629 24.6389 54.5386 25.3407 54.5386C25.8648 54.5386 26.2727 54.3973 26.5644 54.1147C26.856 53.8368 27.0019 53.4403 27.0019 52.9253V52.5288C26.5461 53.0438 25.9469 53.3013 25.204 53.3013C24.3154 53.3013 23.5953 52.9549 23.0439 52.2622C22.497 51.5649 22.2236 50.6421 22.2236 49.4937V49.4116ZM24.1991 49.5552C24.1991 50.2251 24.3336 50.7515 24.6025 51.1343C24.8713 51.5125 25.2405 51.7017 25.7099 51.7017C26.3114 51.7017 26.7421 51.4761 27.0019 51.0249V47.9146C26.7376 47.4634 26.3114 47.2378 25.7236 47.2378C25.2496 47.2378 24.8759 47.4315 24.6025 47.8188C24.3336 48.2062 24.1991 48.785 24.1991 49.5552ZM34.525 47.6206C34.2561 47.5841 34.0191 47.5659 33.814 47.5659C33.0666 47.5659 32.5767 47.8188 32.3443 48.3247V53.1646H30.3687V45.7681H32.2349L32.2896 46.6499C32.6861 45.9709 33.2352 45.6313 33.9371 45.6313C34.1558 45.6313 34.3609 45.661 34.5523 45.7202L34.525 47.6206ZM39.423 53.1646C39.3319 52.9868 39.2658 52.7658 39.2248 52.5015C38.7463 53.0347 38.1242 53.3013 37.3586 53.3013C36.634 53.3013 36.0324 53.0916 35.5539 52.6724C35.0799 52.2531 34.843 51.7244 34.843 51.0864C34.843 50.3026 35.1324 49.701 35.7111 49.2817C36.2945 48.8625 37.1353 48.6506 38.2336 48.646H39.1428V48.2222C39.1428 47.8804 39.0539 47.6069 38.8762 47.4019C38.703 47.1968 38.4273 47.0942 38.049 47.0942C37.7163 47.0942 37.4543 47.174 37.2629 47.3335C37.076 47.493 36.9826 47.7118 36.9826 47.9897H35.007C35.007 47.5614 35.1392 47.1649 35.4035 46.8003C35.6678 46.4357 36.0415 46.1509 36.5246 45.9458C37.0077 45.7362 37.55 45.6313 38.1516 45.6313C39.063 45.6313 39.7854 45.8615 40.3186 46.3218C40.8563 46.7775 41.1252 47.4201 41.1252 48.2495V51.4556C41.1298 52.1574 41.2277 52.6883 41.4191 53.0483V53.1646H39.423ZM37.7893 51.7905C38.0809 51.7905 38.3498 51.7267 38.5959 51.5991C38.842 51.467 39.0243 51.2915 39.1428 51.0728V49.8013H38.4045C37.4156 49.8013 36.8892 50.1431 36.8254 50.8267L36.8186 50.9429C36.8186 51.189 36.9051 51.3918 37.0783 51.5513C37.2515 51.7108 37.4885 51.7905 37.7893 51.7905ZM44.3553 45.7681L44.4168 46.5952C44.9409 45.9526 45.6496 45.6313 46.5428 45.6313C47.4953 45.6313 48.1493 46.0073 48.5047 46.7593C49.0243 46.0073 49.7648 45.6313 50.7264 45.6313C51.5285 45.6313 52.1255 45.866 52.5174 46.3354C52.9093 46.8003 53.1053 47.5021 53.1053 48.4409V53.1646H51.1229V48.4478C51.1229 48.0285 51.0409 47.7231 50.8768 47.5317C50.7127 47.3358 50.4233 47.2378 50.0086 47.2378C49.4162 47.2378 49.006 47.5203 48.7782 48.0854L48.785 53.1646H46.8094V48.4546C46.8094 48.0262 46.7251 47.7163 46.5565 47.5249C46.3879 47.3335 46.1008 47.2378 45.6952 47.2378C45.1346 47.2378 44.729 47.4702 44.4784 47.9351V53.1646H42.5028V45.7681H44.3553ZM56.3423 45.7681L56.4038 46.5952C56.9279 45.9526 57.6365 45.6313 58.5298 45.6313C59.4822 45.6313 60.1362 46.0073 60.4917 46.7593C61.0112 46.0073 61.7518 45.6313 62.7134 45.6313C63.5154 45.6313 64.1124 45.866 64.5044 46.3354C64.8963 46.8003 65.0923 47.5021 65.0923 48.4409V53.1646H63.1098V48.4478C63.1098 48.0285 63.0278 47.7231 62.8638 47.5317C62.6997 47.3358 62.4103 47.2378 61.9956 47.2378C61.4031 47.2378 60.993 47.5203 60.7651 48.0854L60.772 53.1646H58.7964V48.4546C58.7964 48.0262 58.7121 47.7163 58.5434 47.5249C58.3748 47.3335 58.0877 47.2378 57.6821 47.2378C57.1216 47.2378 56.716 47.4702 56.4653 47.9351V53.1646H54.4897V45.7681H56.3423ZM69.881 53.3013C68.7963 53.3013 67.9122 52.9686 67.2286 52.3032C66.5496 51.6379 66.2101 50.7515 66.2101 49.644V49.4526C66.2101 48.7098 66.3536 48.0467 66.6407 47.4634C66.9278 46.8755 67.3334 46.4243 67.8575 46.1099C68.3862 45.7909 68.9877 45.6313 69.6622 45.6313C70.6739 45.6313 71.4692 45.9504 72.048 46.5884C72.6313 47.2264 72.923 48.131 72.923 49.3022V50.1089H68.213C68.2768 50.592 68.4682 50.9793 68.7872 51.271C69.1108 51.5627 69.5187 51.7085 70.0109 51.7085C70.7719 51.7085 71.3667 51.4328 71.795 50.8813L72.7657 51.9683C72.4695 52.3875 72.0685 52.7157 71.5626 52.9526C71.0568 53.1851 70.4962 53.3013 69.881 53.3013ZM69.6554 47.231C69.2635 47.231 68.9445 47.3631 68.6984 47.6274C68.4568 47.8918 68.3019 48.27 68.2335 48.7622H70.9816V48.605C70.9724 48.1675 70.854 47.8302 70.6261 47.5933C70.3982 47.3517 70.0747 47.231 69.6554 47.231Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx("rect", { x: "95.5", y: "1", width: "2", height: "54", fill: "white" }),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M120.377 15.6865H116.439V18.3525H121.061V20H114.389V10.0469H121.047V11.708H116.439V14.0801H120.377V15.6865ZM123.812 12.6035L123.874 13.458C124.402 12.7972 125.111 12.4668 126 12.4668C126.784 12.4668 127.367 12.6969 127.75 13.1572C128.132 13.6175 128.328 14.3057 128.338 15.2217V20H126.362V15.2695C126.362 14.8503 126.271 14.5472 126.089 14.3604C125.906 14.1689 125.603 14.0732 125.179 14.0732C124.623 14.0732 124.206 14.3102 123.928 14.7842V20H121.953V12.6035H123.812ZM132.47 17.5869L133.844 12.6035H135.908L133.413 20H131.527L129.032 12.6035H131.096L132.47 17.5869ZM138.728 20H136.746V12.6035H138.728V20ZM136.63 10.6895C136.63 10.3932 136.728 10.1494 136.924 9.95801C137.124 9.7666 137.395 9.6709 137.737 9.6709C138.074 9.6709 138.343 9.7666 138.544 9.95801C138.744 10.1494 138.845 10.3932 138.845 10.6895C138.845 10.9902 138.742 11.2363 138.537 11.4277C138.337 11.6191 138.07 11.7148 137.737 11.7148C137.405 11.7148 137.136 11.6191 136.931 11.4277C136.73 11.2363 136.63 10.9902 136.63 10.6895ZM144.378 14.4561C144.11 14.4196 143.873 14.4014 143.668 14.4014C142.92 14.4014 142.43 14.6543 142.198 15.1602V20H140.222V12.6035H142.088L142.143 13.4854C142.54 12.8063 143.089 12.4668 143.791 12.4668C144.009 12.4668 144.214 12.4964 144.406 12.5557L144.378 14.4561ZM144.642 16.2334C144.642 15.4997 144.783 14.8457 145.066 14.2715C145.348 13.6973 145.754 13.2529 146.282 12.9385C146.816 12.624 147.433 12.4668 148.135 12.4668C149.133 12.4668 149.946 12.7721 150.575 13.3828C151.209 13.9935 151.562 14.8229 151.635 15.8711L151.649 16.377C151.649 17.5117 151.332 18.4232 150.698 19.1113C150.065 19.7949 149.215 20.1367 148.149 20.1367C147.082 20.1367 146.23 19.7949 145.592 19.1113C144.959 18.4277 144.642 17.498 144.642 16.3223V16.2334ZM146.617 16.377C146.617 17.0788 146.75 17.6165 147.014 17.9902C147.278 18.3594 147.656 18.5439 148.149 18.5439C148.627 18.5439 149.001 18.3617 149.27 17.9971C149.539 17.6279 149.673 17.04 149.673 16.2334C149.673 15.5452 149.539 15.012 149.27 14.6338C149.001 14.2555 148.623 14.0664 148.135 14.0664C147.652 14.0664 147.278 14.2555 147.014 14.6338C146.75 15.0075 146.617 15.5885 146.617 16.377ZM154.544 12.6035L154.605 13.458C155.134 12.7972 155.843 12.4668 156.731 12.4668C157.515 12.4668 158.098 12.6969 158.481 13.1572C158.864 13.6175 159.06 14.3057 159.069 15.2217V20H157.094V15.2695C157.094 14.8503 157.002 14.5472 156.82 14.3604C156.638 14.1689 156.335 14.0732 155.911 14.0732C155.355 14.0732 154.938 14.3102 154.66 14.7842V20H152.684V12.6035H154.544ZM162.286 12.6035L162.347 13.4307C162.871 12.7881 163.58 12.4668 164.473 12.4668C165.426 12.4668 166.08 12.8428 166.435 13.5947C166.955 12.8428 167.695 12.4668 168.657 12.4668C169.459 12.4668 170.056 12.7015 170.448 13.1709C170.84 13.6357 171.036 14.3376 171.036 15.2764V20H169.053V15.2832C169.053 14.8639 168.971 14.5586 168.807 14.3672C168.643 14.1712 168.354 14.0732 167.939 14.0732C167.346 14.0732 166.936 14.3558 166.708 14.9209L166.715 20H164.74V15.29C164.74 14.8617 164.655 14.5518 164.487 14.3604C164.318 14.1689 164.031 14.0732 163.625 14.0732C163.065 14.0732 162.659 14.3057 162.409 14.7705V20H160.433V12.6035H162.286ZM175.824 20.1367C174.74 20.1367 173.856 19.804 173.172 19.1387C172.493 18.4733 172.153 17.5869 172.153 16.4795V16.2881C172.153 15.5452 172.297 14.8822 172.584 14.2988C172.871 13.7109 173.277 13.2598 173.801 12.9453C174.33 12.6263 174.931 12.4668 175.606 12.4668C176.617 12.4668 177.413 12.7858 177.991 13.4238C178.575 14.0618 178.866 14.9665 178.866 16.1377V16.9443H174.156C174.22 17.4274 174.412 17.8148 174.731 18.1064C175.054 18.3981 175.462 18.5439 175.954 18.5439C176.715 18.5439 177.31 18.2682 177.738 17.7168L178.709 18.8037C178.413 19.223 178.012 19.5511 177.506 19.7881C177 20.0205 176.44 20.1367 175.824 20.1367ZM175.599 14.0664C175.207 14.0664 174.888 14.1986 174.642 14.4629C174.4 14.7272 174.245 15.1055 174.177 15.5977H176.925V15.4404C176.916 15.0029 176.797 14.6657 176.569 14.4287C176.342 14.1872 176.018 14.0664 175.599 14.0664ZM181.673 12.6035L181.734 13.458C182.263 12.7972 182.971 12.4668 183.86 12.4668C184.644 12.4668 185.227 12.6969 185.61 13.1572C185.993 13.6175 186.189 14.3057 186.198 15.2217V20H184.222V15.2695C184.222 14.8503 184.131 14.5472 183.949 14.3604C183.767 14.1689 183.464 14.0732 183.04 14.0732C182.484 14.0732 182.067 14.3102 181.789 14.7842V20H179.813V12.6035H181.673ZM189.927 10.7852V12.6035H191.192V14.0527H189.927V17.7441C189.927 18.0176 189.98 18.2135 190.084 18.332C190.189 18.4505 190.39 18.5098 190.686 18.5098C190.905 18.5098 191.098 18.4938 191.267 18.4619V19.959C190.88 20.0775 190.481 20.1367 190.071 20.1367C188.685 20.1367 187.979 19.4372 187.952 18.0381V14.0527H186.871V12.6035H187.952V10.7852H189.927ZM196.439 20C196.347 19.8223 196.281 19.6012 196.24 19.3369C195.762 19.8701 195.14 20.1367 194.374 20.1367C193.649 20.1367 193.048 19.9271 192.569 19.5078C192.095 19.0885 191.858 18.5599 191.858 17.9219C191.858 17.138 192.148 16.5365 192.727 16.1172C193.31 15.6979 194.151 15.486 195.249 15.4814H196.158V15.0576C196.158 14.7158 196.069 14.4424 195.892 14.2373C195.718 14.0322 195.443 13.9297 195.064 13.9297C194.732 13.9297 194.47 14.0094 194.278 14.1689C194.092 14.3285 193.998 14.5472 193.998 14.8252H192.022C192.022 14.3968 192.155 14.0003 192.419 13.6357C192.683 13.2712 193.057 12.9863 193.54 12.7812C194.023 12.5716 194.565 12.4668 195.167 12.4668C196.078 12.4668 196.801 12.6969 197.334 13.1572C197.872 13.613 198.141 14.2555 198.141 15.085V18.291C198.145 18.9928 198.243 19.5238 198.435 19.8838V20H196.439ZM194.805 18.626C195.096 18.626 195.365 18.5622 195.611 18.4346C195.857 18.3024 196.04 18.127 196.158 17.9082V16.6367H195.42C194.431 16.6367 193.905 16.9785 193.841 17.6621L193.834 17.7783C193.834 18.0244 193.921 18.2272 194.094 18.3867C194.267 18.5462 194.504 18.626 194.805 18.626ZM201.603 20H199.621V9.5H201.603V20ZM208.624 16.4932V20H206.573V10.0469H210.456C211.203 10.0469 211.86 10.1836 212.425 10.457C212.994 10.7305 213.432 11.1201 213.737 11.626C214.043 12.1273 214.195 12.6992 214.195 13.3418C214.195 14.3171 213.86 15.0872 213.19 15.6523C212.525 16.2129 211.602 16.4932 210.422 16.4932H208.624ZM208.624 14.832H210.456C210.998 14.832 211.411 14.7044 211.693 14.4492C211.98 14.194 212.124 13.8294 212.124 13.3555C212.124 12.8678 211.98 12.4736 211.693 12.1729C211.406 11.8721 211.01 11.7171 210.504 11.708H208.624V14.832ZM214.937 16.2334C214.937 15.4997 215.078 14.8457 215.361 14.2715C215.643 13.6973 216.049 13.2529 216.578 12.9385C217.111 12.624 217.728 12.4668 218.43 12.4668C219.428 12.4668 220.242 12.7721 220.871 13.3828C221.504 13.9935 221.857 14.8229 221.93 15.8711L221.944 16.377C221.944 17.5117 221.627 18.4232 220.994 19.1113C220.36 19.7949 219.51 20.1367 218.444 20.1367C217.378 20.1367 216.525 19.7949 215.887 19.1113C215.254 18.4277 214.937 17.498 214.937 16.3223V16.2334ZM216.913 16.377C216.913 17.0788 217.045 17.6165 217.309 17.9902C217.574 18.3594 217.952 18.5439 218.444 18.5439C218.922 18.5439 219.296 18.3617 219.565 17.9971C219.834 17.6279 219.968 17.04 219.968 16.2334C219.968 15.5452 219.834 15.012 219.565 14.6338C219.296 14.2555 218.918 14.0664 218.43 14.0664C217.947 14.0664 217.574 14.2555 217.309 14.6338C217.045 15.0075 216.913 15.5885 216.913 16.377ZM225.106 20H223.123V9.5H225.106V20ZM228.684 20H226.702V12.6035H228.684V20ZM226.586 10.6895C226.586 10.3932 226.684 10.1494 226.88 9.95801C227.08 9.7666 227.351 9.6709 227.693 9.6709C228.03 9.6709 228.299 9.7666 228.5 9.95801C228.7 10.1494 228.801 10.3932 228.801 10.6895C228.801 10.9902 228.698 11.2363 228.493 11.4277C228.293 11.6191 228.026 11.7148 227.693 11.7148C227.361 11.7148 227.092 11.6191 226.887 11.4277C226.686 11.2363 226.586 10.9902 226.586 10.6895ZM233.254 18.5439C233.619 18.5439 233.915 18.4437 234.143 18.2432C234.371 18.0426 234.489 17.776 234.499 17.4434H236.351C236.347 17.9447 236.21 18.4049 235.941 18.8242C235.672 19.2389 235.303 19.5625 234.834 19.7949C234.369 20.0228 233.854 20.1367 233.289 20.1367C232.231 20.1367 231.397 19.8018 230.787 19.1318C230.176 18.4574 229.871 17.5277 229.871 16.3428V16.2129C229.871 15.0736 230.174 14.1644 230.78 13.4854C231.386 12.8063 232.218 12.4668 233.275 12.4668C234.2 12.4668 234.941 12.7311 235.497 13.2598C236.057 13.7839 236.342 14.4834 236.351 15.3584H234.499C234.489 14.9756 234.371 14.6657 234.143 14.4287C233.915 14.1872 233.614 14.0664 233.241 14.0664C232.78 14.0664 232.432 14.235 232.195 14.5723C231.962 14.9049 231.846 15.4473 231.846 16.1992V16.4043C231.846 17.1654 231.962 17.7122 232.195 18.0449C232.427 18.3776 232.78 18.5439 233.254 18.5439ZM240.101 17.2041L241.468 12.6035H243.587L240.613 21.1484L240.449 21.5381C240.007 22.5042 239.278 22.9873 238.262 22.9873C237.975 22.9873 237.683 22.944 237.387 22.8574V21.3604L237.688 21.3672C238.061 21.3672 238.339 21.3102 238.522 21.1963C238.708 21.0824 238.854 20.8932 238.959 20.6289L239.192 20.0205L236.601 12.6035H238.727L240.101 17.2041ZM254.785 11.708H251.736V20H249.685V11.708H246.677V10.0469H254.785V11.708ZM259.396 14.4561C259.127 14.4196 258.89 14.4014 258.685 14.4014C257.937 14.4014 257.447 14.6543 257.215 15.1602V20H255.239V12.6035H257.106L257.16 13.4854C257.557 12.8063 258.106 12.4668 258.808 12.4668C259.026 12.4668 259.232 12.4964 259.423 12.5557L259.396 14.4561ZM264.294 20C264.203 19.8223 264.136 19.6012 264.095 19.3369C263.617 19.8701 262.995 20.1367 262.229 20.1367C261.505 20.1367 260.903 19.9271 260.425 19.5078C259.951 19.0885 259.714 18.5599 259.714 17.9219C259.714 17.138 260.003 16.5365 260.582 16.1172C261.165 15.6979 262.006 15.486 263.104 15.4814H264.013V15.0576C264.013 14.7158 263.925 14.4424 263.747 14.2373C263.574 14.0322 263.298 13.9297 262.92 13.9297C262.587 13.9297 262.325 14.0094 262.134 14.1689C261.947 14.3285 261.853 14.5472 261.853 14.8252H259.878C259.878 14.3968 260.01 14.0003 260.274 13.6357C260.538 13.2712 260.912 12.9863 261.395 12.7812C261.878 12.5716 262.421 12.4668 263.022 12.4668C263.934 12.4668 264.656 12.6969 265.189 13.1572C265.727 13.613 265.996 14.2555 265.996 15.085V18.291C266 18.9928 266.098 19.5238 266.29 19.8838V20H264.294ZM262.66 18.626C262.952 18.626 263.22 18.5622 263.467 18.4346C263.713 18.3024 263.895 18.127 264.013 17.9082V16.6367H263.275C262.286 16.6367 261.76 16.9785 261.696 17.6621L261.689 17.7783C261.689 18.0244 261.776 18.2272 261.949 18.3867C262.122 18.5462 262.359 18.626 262.66 18.626ZM270.45 18.5439C270.814 18.5439 271.11 18.4437 271.338 18.2432C271.566 18.0426 271.685 17.776 271.694 17.4434H273.546C273.542 17.9447 273.405 18.4049 273.136 18.8242C272.867 19.2389 272.498 19.5625 272.029 19.7949C271.564 20.0228 271.049 20.1367 270.484 20.1367C269.426 20.1367 268.592 19.8018 267.982 19.1318C267.371 18.4574 267.066 17.5277 267.066 16.3428V16.2129C267.066 15.0736 267.369 14.1644 267.975 13.4854C268.581 12.8063 269.413 12.4668 270.47 12.4668C271.395 12.4668 272.136 12.7311 272.692 13.2598C273.252 13.7839 273.537 14.4834 273.546 15.3584H271.694C271.685 14.9756 271.566 14.6657 271.338 14.4287C271.11 14.1872 270.81 14.0664 270.436 14.0664C269.976 14.0664 269.627 14.235 269.39 14.5723C269.158 14.9049 269.041 15.4473 269.041 16.1992V16.4043C269.041 17.1654 269.158 17.7122 269.39 18.0449C269.622 18.3776 269.976 18.5439 270.45 18.5439ZM277.221 17.0332L276.51 17.7441V20H274.534V9.5H276.51V15.3174L276.893 14.8252L278.786 12.6035H281.158L278.485 15.6865L281.391 20H279.121L277.221 17.0332ZM285.14 20.1367C284.056 20.1367 283.172 19.804 282.488 19.1387C281.809 18.4733 281.469 17.5869 281.469 16.4795V16.2881C281.469 15.5452 281.613 14.8822 281.9 14.2988C282.187 13.7109 282.593 13.2598 283.117 12.9453C283.645 12.6263 284.247 12.4668 284.922 12.4668C285.933 12.4668 286.728 12.7858 287.307 13.4238C287.891 14.0618 288.182 14.9665 288.182 16.1377V16.9443H283.472C283.536 17.4274 283.728 17.8148 284.047 18.1064C284.37 18.3981 284.778 18.5439 285.27 18.5439C286.031 18.5439 286.626 18.2682 287.054 17.7168L288.025 18.8037C287.729 19.223 287.328 19.5511 286.822 19.7881C286.316 20.0205 285.756 20.1367 285.14 20.1367ZM284.915 14.0664C284.523 14.0664 284.204 14.1986 283.958 14.4629C283.716 14.7272 283.561 15.1055 283.493 15.5977H286.241V15.4404C286.232 15.0029 286.113 14.6657 285.885 14.4287C285.658 14.1872 285.334 14.0664 284.915 14.0664ZM293.326 14.4561C293.058 14.4196 292.821 14.4014 292.616 14.4014C291.868 14.4014 291.378 14.6543 291.146 15.1602V20H289.17V12.6035H291.036L291.091 13.4854C291.488 12.8063 292.037 12.4668 292.739 12.4668C292.957 12.4668 293.162 12.4964 293.354 12.5557L293.326 14.4561Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx("rect", { x: "113.5", y: "30", width: "100", height: "17", rx: "4", fill: "#213543" }),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M119.662 41L121.696 35.06H123.586L125.62 41H124.216L122.713 36.086H122.578L121.066 41H119.662ZM120.805 39.83V38.948H124.666V39.83H120.805ZM128.241 41V35.06H129.564V41H128.241ZM132.678 41V35.06H135.09C135.414 35.06 135.708 35.087 135.972 35.141C136.236 35.189 136.47 35.261 136.674 35.357C136.878 35.453 137.049 35.573 137.187 35.717C137.331 35.855 137.439 36.017 137.511 36.203C137.583 36.383 137.619 36.584 137.619 36.806C137.619 37.016 137.586 37.208 137.52 37.382C137.454 37.55 137.355 37.697 137.223 37.823C137.091 37.949 136.926 38.054 136.728 38.138C136.53 38.216 136.299 38.27 136.035 38.3V38.435C136.341 38.465 136.584 38.537 136.764 38.651C136.95 38.759 137.094 38.906 137.196 39.092C137.304 39.278 137.397 39.509 137.475 39.785L137.835 41H136.404L136.125 39.875C136.071 39.635 135.993 39.449 135.891 39.317C135.789 39.179 135.66 39.083 135.504 39.029C135.348 38.969 135.159 38.939 134.937 38.939H133.974V41H132.678ZM133.974 37.967H135C135.408 37.967 135.723 37.889 135.945 37.733C136.167 37.577 136.278 37.334 136.278 37.004C136.278 36.68 136.173 36.443 135.963 36.293C135.759 36.137 135.45 36.059 135.036 36.059H133.974V37.967ZM145.37 39.326V38.309H146.729C147.161 38.309 147.485 38.222 147.701 38.048C147.917 37.868 148.025 37.574 148.025 37.166C148.025 36.806 147.923 36.533 147.719 36.347C147.521 36.155 147.212 36.059 146.792 36.059H145.37V35.06H146.828C147.212 35.06 147.557 35.105 147.863 35.195C148.175 35.285 148.439 35.42 148.655 35.6C148.877 35.774 149.045 35.996 149.159 36.266C149.273 36.53 149.33 36.842 149.33 37.202C149.33 37.664 149.225 38.054 149.015 38.372C148.805 38.684 148.493 38.921 148.079 39.083C147.671 39.245 147.161 39.326 146.549 39.326H145.37ZM144.461 41V35.06H145.757V41H144.461ZM154.67 41.126C154.238 41.126 153.851 41.06 153.509 40.928C153.167 40.79 152.873 40.592 152.627 40.334C152.387 40.07 152.201 39.749 152.069 39.371C151.943 38.987 151.88 38.549 151.88 38.057C151.88 37.355 152.003 36.776 152.249 36.32C152.495 35.858 152.831 35.513 153.257 35.285C153.689 35.051 154.175 34.934 154.715 34.934C155.135 34.934 155.516 35.003 155.858 35.141C156.2 35.273 156.491 35.471 156.731 35.735C156.977 35.993 157.166 36.317 157.298 36.707C157.43 37.091 157.496 37.532 157.496 38.03C157.496 38.54 157.43 38.987 157.298 39.371C157.166 39.755 156.974 40.079 156.722 40.343C156.476 40.601 156.179 40.796 155.831 40.928C155.483 41.06 155.096 41.126 154.67 41.126ZM154.706 40.091C155.024 40.091 155.291 40.013 155.507 39.857C155.723 39.701 155.888 39.476 156.002 39.182C156.116 38.888 156.173 38.528 156.173 38.102C156.173 37.658 156.113 37.28 155.993 36.968C155.879 36.656 155.711 36.419 155.489 36.257C155.267 36.089 154.997 36.005 154.679 36.005C154.367 36.005 154.1 36.086 153.878 36.248C153.662 36.404 153.494 36.632 153.374 36.932C153.26 37.232 153.203 37.604 153.203 38.048C153.203 38.372 153.236 38.663 153.302 38.921C153.374 39.173 153.473 39.386 153.599 39.56C153.725 39.734 153.881 39.866 154.067 39.956C154.253 40.046 154.466 40.091 154.706 40.091ZM160.392 41V35.06H161.688V41H160.392ZM160.662 41V39.911H164.199V41H160.662ZM166.762 41V35.06H168.058V41H166.762ZM167.032 41V39.911H170.569V41H167.032ZM175.646 41.126C175.28 41.126 174.953 41.087 174.665 41.009C174.383 40.937 174.137 40.832 173.927 40.694C173.717 40.55 173.54 40.379 173.396 40.181C173.258 39.977 173.153 39.749 173.081 39.497C173.015 39.245 172.982 38.969 172.982 38.669V35.06H174.287V38.624C174.287 38.93 174.335 39.185 174.431 39.389C174.533 39.587 174.683 39.734 174.881 39.83C175.079 39.926 175.331 39.974 175.637 39.974C175.949 39.974 176.204 39.926 176.402 39.83C176.606 39.734 176.756 39.587 176.852 39.389C176.954 39.185 177.005 38.93 177.005 38.624V35.06H178.292V38.669C178.292 39.449 178.07 40.055 177.626 40.487C177.188 40.913 176.528 41.126 175.646 41.126ZM182.626 41V35.06H183.922V41H182.626ZM180.871 36.149V35.06H185.677V36.149H180.871ZM188.307 41V35.06H189.63V41H188.307ZM195.318 41.126C194.886 41.126 194.499 41.06 194.157 40.928C193.815 40.79 193.521 40.592 193.275 40.334C193.035 40.07 192.849 39.749 192.717 39.371C192.591 38.987 192.528 38.549 192.528 38.057C192.528 37.355 192.651 36.776 192.897 36.32C193.143 35.858 193.479 35.513 193.905 35.285C194.337 35.051 194.823 34.934 195.363 34.934C195.783 34.934 196.164 35.003 196.506 35.141C196.848 35.273 197.139 35.471 197.379 35.735C197.625 35.993 197.814 36.317 197.946 36.707C198.078 37.091 198.144 37.532 198.144 38.03C198.144 38.54 198.078 38.987 197.946 39.371C197.814 39.755 197.622 40.079 197.37 40.343C197.124 40.601 196.827 40.796 196.479 40.928C196.131 41.06 195.744 41.126 195.318 41.126ZM195.354 40.091C195.672 40.091 195.939 40.013 196.155 39.857C196.371 39.701 196.536 39.476 196.65 39.182C196.764 38.888 196.821 38.528 196.821 38.102C196.821 37.658 196.761 37.28 196.641 36.968C196.527 36.656 196.359 36.419 196.137 36.257C195.915 36.089 195.645 36.005 195.327 36.005C195.015 36.005 194.748 36.086 194.526 36.248C194.31 36.404 194.142 36.632 194.022 36.932C193.908 37.232 193.851 37.604 193.851 38.048C193.851 38.372 193.884 38.663 193.95 38.921C194.022 39.173 194.121 39.386 194.247 39.56C194.373 39.734 194.529 39.866 194.715 39.956C194.901 40.046 195.114 40.091 195.354 40.091ZM201.039 41V35.06H202.731L205.422 39.263H205.521L205.44 35.06H206.7V41H205.17L202.326 36.599H202.227L202.308 41H201.039Z",
      fill: "white"
    }
  )
] }), "UNEPEPTLogoInverted"), sw = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "13", height: "12", viewBox: "0 0 13 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M7.16662 5.55317L10.5 9.99984H2.49995L5.83329 5.55317V1.99984H7.16662M9.13995 0.666504H3.85995C3.57995 0.666504 3.42662 0.986504 3.59995 1.2065L4.49995 2.33317V5.11317L0.633287 10.2665C0.306621 10.7065 0.619954 11.3332 1.16662 11.3332H11.8333C12.38 11.3332 12.6933 10.7065 12.3666 10.2665L8.49995 5.11317V2.33317L9.39995 1.2065C9.57329 0.986504 9.41995 0.666504 9.13995 0.666504Z",
    fill: "currentColor"
  }
) }), "UNEPLabIcon"), UT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsxs("svg", { width: "288", height: "57", viewBox: "0 0 288 57", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M20.4531 0.828125V16.749C20.4531 19.3942 19.623 21.486 17.9629 23.0244C16.3138 24.5628 14.056 25.332 11.1895 25.332C8.36719 25.332 6.12598 24.585 4.46582 23.0908C2.80566 21.5967 1.95898 19.5436 1.92578 16.9316V0.828125H6.90625V16.7822C6.90625 18.3649 7.28255 19.5215 8.03516 20.252C8.79883 20.9714 9.85026 21.3311 11.1895 21.3311C13.9896 21.3311 15.4118 19.859 15.4561 16.915V0.828125H20.4531ZM44.1934 25H39.2129L29.5176 9.0957V25H24.5371V0.828125H29.5176L39.2295 16.7656V0.828125H44.1934V25Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M62.0719 19.9887C59.0657 19.0805 56.8772 16.2888 56.8772 12.9876C56.8772 12.3911 56.9476 11.8113 57.0816 11.2583L61.8306 11.8683C61.8306 11.8683 63.6537 11.9487 63.5867 15.1761C63.523 18.3063 62.0719 19.9887 62.0719 19.9887Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M66.3182 19.9887C69.3244 19.0805 71.5128 16.2888 71.5128 12.9876C71.5128 12.3911 71.4425 11.8113 71.3084 11.2583L66.5595 11.8683C66.5595 11.8683 64.7363 11.9487 64.8033 15.1761C64.867 18.3063 66.3182 19.9887 66.3182 19.9887Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M64.1931 7.75268C64.803 7.75268 65.2991 8.24869 65.2991 8.85865C65.2991 9.33455 64.9706 9.6898 64.5752 9.90094C64.5282 9.92775 64.4813 9.94786 64.4914 10.0249C64.5014 10.102 64.7293 10.1456 64.8265 10.169L71.2109 10.9097C70.3161 7.88339 67.5143 5.6748 64.1964 5.6748H64.1864C60.8685 5.6748 58.0701 7.88339 57.1719 10.9097L63.5563 10.169C63.6535 10.1456 63.8814 10.1054 63.8915 10.0249C63.9015 9.95121 63.8546 9.92775 63.8077 9.90094C63.4122 9.6898 63.0838 9.33455 63.0838 8.85865C63.0871 8.24869 63.5831 7.75268 64.1931 7.75268Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M67.1121 25.1645L67.5445 24.893C67.5445 24.893 65.4934 22.1113 60.902 22.1113C58.5526 22.1113 57.3361 23.0564 55.6905 23.0564C55.6905 23.0564 55.0169 23.1369 54.3667 22.7313C54.3667 22.7313 55.1509 23.8641 57.9862 23.8641C60.0641 23.8641 61.5521 22.6476 63.01 22.6476C65.0041 22.6509 66.4888 24.4339 67.1121 25.1645Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M60.737 25.1645L60.3047 24.893C60.3047 24.893 62.3557 22.1113 66.9472 22.1113C69.2965 22.1113 70.5131 23.0564 72.1586 23.0564C72.1586 23.0564 72.8323 23.1369 73.4824 22.7313C73.4824 22.7313 72.6982 23.8641 69.8629 23.8641C67.785 23.8641 66.297 22.6476 64.8391 22.6476C62.8451 22.6509 61.357 24.4339 60.737 25.1645Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M58.5496 21.8739C58.4692 22.0884 57.5911 21.8336 56.9979 22.0079C56.3343 22.2057 52.8254 22.6279 51.2871 18.9849C51.2871 18.9849 52.745 20.5501 53.8811 20.6607C55.0139 20.7679 56.2573 21.0394 57.3096 21.6326L57.5543 21.6862C57.5543 21.6862 57.5207 21.5789 57.4202 21.5253C57.2828 21.4516 56.1902 21.0963 55.6641 19.3637C55.3926 18.4722 55.4496 17.8254 55.339 17.3662C55.339 17.3662 56.5287 18.69 57.0147 19.5279C57.4973 20.3624 57.5509 21.3075 58.5496 21.8739Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M54.9724 20.0365C54.8853 20.1236 54.6607 19.9829 54.5803 19.9426C54.4998 19.9024 53.9167 19.6343 52.918 19.2824C51.9327 18.9305 50.0961 17.3788 50.2704 14.7178C50.2704 14.7178 50.5284 15.7165 51.2825 16.3801C52.0399 17.0403 52.308 17.1241 52.7672 17.6637C53.2263 18.2033 54.2652 19.4332 54.3055 19.4198C54.3457 19.4064 54.3591 19.3394 54.2787 19.2724C54.1982 19.2053 53.9268 18.5284 53.7525 18.3005C53.5782 18.0726 53.052 16.4907 53.8195 14.5469C53.8195 14.5469 54.644 15.9645 54.5903 17.3956C54.5367 18.8266 54.4697 18.4881 54.8182 19.6779C54.8216 19.6712 55.0126 19.9963 54.9724 20.0365Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M52.6775 16.5709C52.6272 16.6212 52.4194 16.3129 52.2585 16.0314C52.0977 15.7465 50.9615 14.5333 50.8141 14.2886C50.6666 14.044 49.3964 12.5057 50.3549 10.2234C50.3549 10.2234 50.4488 10.1966 50.4488 10.7361C50.4488 11.2757 50.9481 12.4789 51.3537 12.9916C51.7592 13.5044 52.1245 14.3288 52.2049 15.2069C52.2049 15.2069 52.2585 15.3678 52.3256 15.3812C52.3926 15.3946 52.3926 15.2203 52.3926 15.2203C52.3926 15.2203 52.339 14.4093 52.339 13.8563C52.339 13.3033 52.5836 12.3582 53.1098 11.8186C53.1098 11.8186 53.3545 11.5472 53.5019 11.2254C53.5019 11.2254 53.5958 11.0109 53.7298 10.9003C53.7298 10.9003 53.8371 12.4521 53.3109 13.8965C52.7847 15.341 52.6104 15.5856 52.6909 16.3665C52.6909 16.3665 52.7043 16.5408 52.6775 16.5709Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M51.7852 12.2972C51.7316 12.2972 51.6914 12.1095 51.6646 11.9587C51.6378 11.8113 51.4769 10.9466 51.3663 10.7556C51.2591 10.5679 50.8535 9.70323 50.8401 8.6911C50.8267 7.67898 51.2859 6.30154 52.3114 5.20898C52.3114 5.20898 52.2712 5.53407 51.9997 6.24792C51.7283 6.96512 51.8925 7.63876 51.9193 7.75941C51.9461 7.88006 52.0399 8.71791 52.0399 9.11003C52.0399 9.42171 51.9595 10.4875 51.8925 10.7019C51.8925 10.7019 51.8657 10.8494 51.9193 10.8494C51.9729 10.8494 52.0265 10.7288 52.0265 10.7288C52.0265 10.7288 52.0802 9.89091 52.7002 9.13684C53.3202 8.37942 54.4429 7.92028 54.6172 7.58514C54.6172 7.58514 54.5367 8.77489 53.2263 10.1624C52.06 11.4024 52.4019 10.769 52.0232 11.7811C52.0232 11.7811 51.8623 12.1598 51.8623 12.2402C51.8657 12.3274 51.7852 12.2972 51.7852 12.2972Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M52.5031 8.29941C52.5031 8.29941 52.4763 8.13854 52.6774 7.77324C52.8785 7.40793 52.664 6.76111 52.9355 5.81601C53.2069 4.87092 53.7063 3.25218 55.6099 2.28027C55.6099 2.28027 55.4222 2.45455 55.325 2.59195C55.2312 2.72601 54.7184 3.69792 54.5676 4.37491C54.4202 5.04854 53.77 6.18467 53.5287 6.43938C53.284 6.69744 53.3946 6.72425 53.3946 6.72425C53.3946 6.72425 53.5153 6.69744 53.6393 6.50976C53.7599 6.32208 54.3833 5.61828 55.0703 5.45741C55.7574 5.29655 56.8533 4.97146 56.9203 4.90443C56.9203 4.90443 55.7306 6.12099 54.638 6.741C53.5454 7.36102 53.4214 7.17334 52.7746 8.01119C52.7713 8.00113 52.5568 8.29941 52.5031 8.29941Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M55.1208 4.69386C55.1208 4.69386 55.1209 4.58661 55.3219 4.39558C55.523 4.2079 55.7275 3.63816 56.0794 3.11199C56.4313 2.58582 57.2255 1.20839 59.2934 0.883301C59.2934 0.883301 58.6733 1.34244 58.5762 1.48991C58.4823 1.63737 57.8757 2.43501 57.6042 2.70647C57.3328 2.97793 56.5653 3.54432 56.3072 3.66497C56.3072 3.66497 56.1732 3.77222 56.2 3.81244C56.2268 3.85265 56.3609 3.77222 56.3609 3.77222C56.3609 3.77222 57.0781 3.21924 57.9394 3.19242C58.8041 3.16561 59.7089 3.20583 59.843 3.21924C59.843 3.21924 59.032 3.77222 57.1015 4.12412C55.1711 4.47602 55.5364 4.48942 55.2382 4.6771C55.2415 4.68045 55.1745 4.73407 55.1208 4.69386Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M58.5618 2.45717C58.5618 2.45717 58.602 2.34992 58.9137 2.25609C59.2253 2.16225 59.1985 1.86397 60.1436 1.36461C61.0887 0.865249 62.074 0.634001 63.0728 1.05293C63.0728 1.05293 62.6538 1.10655 62.5868 1.13336C62.5198 1.16017 61.8026 1.34785 61.6015 1.45845C61.4004 1.56569 60.3581 2.02484 59.9392 2.10527C59.5203 2.18571 59.7247 2.21252 59.7247 2.21252C59.7247 2.21252 59.8185 2.25273 59.899 2.25273C59.9794 2.25273 60.9111 2.15889 61.5177 2.37338C62.1243 2.58788 62.1109 2.67166 62.3556 2.75209C62.6002 2.83253 62.8817 2.88615 62.922 2.97999C62.922 2.97999 62.3154 3.03361 61.95 3.03361C61.5847 3.03361 60.6262 2.93977 60.1671 2.72193C59.7079 2.50744 59.1818 2.41025 59.0075 2.45047C58.8332 2.49739 58.6187 2.49739 58.5618 2.45717Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M62.4006 1.98756C62.4006 1.98756 62.4408 1.93393 62.7123 1.88031C62.9838 1.82669 63.0508 1.66582 63.6842 1.52841C64.3176 1.391 65.303 1.27035 66.2078 1.89372C66.2078 1.89372 65.6549 1.88031 65.5342 1.88031C65.4136 1.88031 64.3612 2.06799 64.1166 2.06799C63.8719 2.06799 63.386 1.96074 63.3189 2.04118C63.2519 2.12161 63.7647 2.22886 63.8451 2.25567C63.9255 2.28248 64.2908 2.30929 64.75 2.75503C65.2091 3.20077 65.5342 3.44207 65.5878 3.47223C65.5878 3.47223 64.2372 3.16055 63.8987 2.97287C63.5602 2.78519 62.9804 2.20205 62.8866 2.16183C62.7894 2.12161 62.4006 1.98756 62.4006 1.98756Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M65.5161 2.53945C65.5161 2.53945 66.3674 2.51264 66.9874 2.90475C67.6074 3.29687 68.1068 3.80964 68.1604 4.12132C68.1604 4.12132 67.8085 3.82304 67.5806 3.75601C67.3493 3.68899 66.7025 3.32368 66.5685 3.24325C66.4344 3.16281 65.6502 2.6601 65.5161 2.53945Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M69.5144 22.0157C69.5144 22.0157 69.6351 21.8951 70.0406 21.5432C70.4461 21.1913 70.5533 20.6785 70.9991 19.8809C71.4448 19.0833 71.8235 18.5303 72.7284 17.7192C72.7284 17.7192 72.5675 18.3258 72.5541 18.5169C72.5407 18.7046 72.3933 19.7602 71.8805 20.3669C71.3677 20.9735 71.3409 21.1109 70.7477 21.4728C70.7477 21.4728 70.5165 21.6337 70.5332 21.6873C70.5466 21.7409 70.9388 21.6739 70.9388 21.6739C70.9388 21.6739 71.3711 21.513 71.5051 21.4293C71.6392 21.3488 72.2492 21.0371 72.4905 20.9433C72.7351 20.8495 72.9362 20.7556 73.4758 20.5914C74.0154 20.4305 75.9726 19.9312 76.7434 18.6878C76.7434 18.6878 76.5155 19.4184 76.2306 19.7535C75.9458 20.092 74.3404 22.2101 72.1117 22.1699C72.1117 22.1699 71.2337 22.1029 70.7745 22.0225C70.3154 21.942 70.1545 21.942 70.0875 21.9554C70.0138 21.9755 69.5814 22.056 69.5144 22.0157Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M74.4951 14.4441C74.4951 14.4441 73.6572 15.7545 73.4696 17.6447C73.2819 19.5349 73.6036 18.9685 73.2953 19.8063C73.2953 19.8063 73.188 20.0208 73.2283 20.0342C73.2685 20.0476 73.4293 19.9538 74.0259 19.5885C74.6191 19.2232 75.2022 19.3304 76.4691 18.1172C77.7393 16.9007 77.994 14.4843 78.0208 14.2832C78.0208 14.2832 77.8331 14.4709 77.7359 14.796C77.6421 15.1211 77.4376 15.3758 77.3974 15.416C77.3572 15.4562 75.9798 16.9677 75.8189 17.1051C75.658 17.2391 74.847 18.2245 74.6727 18.5093C74.4984 18.7942 73.9857 19.307 73.8885 19.2668C73.8885 19.2668 73.9019 19.1461 73.9421 19.0523C73.9823 18.9584 74.361 18.4457 74.5219 17.8491C74.6828 17.2559 74.723 16.8906 74.7364 16.5119C74.7532 16.1332 74.5085 14.7423 74.4951 14.4441Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M75.6312 16.2688C75.6312 16.2688 75.5474 16.0711 75.6178 15.9303C75.658 15.8499 75.6982 15.1997 75.4569 14.6736C75.2156 14.1474 74.6861 12.6895 74.7263 11.7176C74.7665 10.7457 74.8738 10.6116 74.8738 10.6116C74.8738 10.6116 75.1452 11.4093 75.2257 11.5433C75.3061 11.6774 76.1171 13.1084 76.0501 13.8927C75.9831 14.6769 75.9429 14.9182 75.9831 14.9316C76.0233 14.945 76.1171 14.8378 76.1305 14.7439C76.1439 14.6501 76.278 14.1105 76.5361 13.4737C76.7941 12.8403 77.833 11.4361 78.0609 10.5044C78.0609 10.5044 78.3994 12.1231 77.4946 13.638C76.5897 15.1495 76.4958 14.811 76.1171 15.5014C75.7384 16.1884 75.6848 16.2688 75.6312 16.2688Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M76.4515 11.9859C76.3844 11.9725 76.4247 11.3525 76.2638 11.1481C76.1029 10.947 74.7121 9.29807 74.4138 7.65253C74.4138 7.65253 75.2919 8.54401 75.4394 8.63784C75.5868 8.73168 76.1834 9.32488 76.3576 9.841C76.5319 10.3538 76.4917 10.7861 76.5587 10.7995C76.6257 10.8129 76.6257 10.2331 76.6257 10.2331C76.6257 10.2331 76.6392 9.10034 76.733 8.55741C76.8268 8.01783 77.0715 7.11295 76.9642 6.65381C76.9642 6.65381 77.4904 7.49166 77.4636 8.67806C77.4368 9.86781 76.9374 10.8129 76.8704 10.947C76.8034 11.081 76.6123 11.6642 76.6123 11.7848C76.6157 11.9055 76.4515 11.9859 76.4515 11.9859Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M74.8065 3.53467C74.8065 3.53467 76.6297 4.61382 76.3448 8.23335C76.3448 8.23335 76.3448 8.39422 76.2376 8.21994C76.1304 8.04567 75.7382 7.54631 75.564 7.43571C75.3897 7.32847 73.7676 6.34315 73.0806 4.82831C73.0806 4.82831 73.1878 4.8015 73.352 4.94896C73.5129 5.09643 74.0123 5.35449 74.096 5.3947C74.1765 5.43492 74.7429 5.58238 75.1618 6.04153C75.5807 6.50067 75.7282 6.83916 75.8488 7.10727C75.8488 7.10727 75.9695 7.20111 75.8891 6.933C75.8086 6.66154 75.7952 6.48726 75.5774 6.14877C75.3629 5.81028 75.1718 5.20367 75.145 4.78475C75.1182 4.37252 74.9942 3.74916 74.8065 3.53467Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M74.4956 4.80658C74.4956 4.80658 74.5358 4.56192 74.3615 4.22678C74.1873 3.88829 74.3247 3.51293 73.7683 2.62146C73.4567 2.1221 72.3775 1.72998 72.3775 1.72998C72.3775 1.72998 72.6892 2.16231 72.8903 2.40361C73.0913 2.64827 73.1617 2.82254 73.2288 2.94319C73.2958 3.06384 73.6711 3.4258 73.8085 3.63023C73.8354 3.67045 73.889 3.77769 73.889 3.84472C73.889 3.91175 73.7415 3.80451 73.7013 3.76429C73.6611 3.72407 73.0009 3.22471 72.5819 3.14428C72.163 3.06384 71.3654 2.98341 71.1509 2.87281C71.1509 2.87281 72.096 3.72407 73.1215 3.97878C74.1437 4.23684 74.4956 4.80658 74.4956 4.80658Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M72.3627 2.57751C72.3627 2.57751 71.4176 1.29392 69.7285 1.32073C69.7285 1.32073 69.8224 1.41457 70.0134 1.45478C70.2011 1.495 70.5396 1.83349 70.7138 1.94074C70.8915 2.05133 71.2534 2.31945 72.3627 2.57751Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M5.66309 40.3013C4.57845 40.3013 3.69434 39.9686 3.01074 39.3032C2.33171 38.6379 1.99219 37.7515 1.99219 36.644V36.4526C1.99219 35.7098 2.13574 35.0467 2.42285 34.4634C2.70996 33.8755 3.11556 33.4243 3.63965 33.1099C4.16829 32.7909 4.76986 32.6313 5.44434 32.6313C6.45605 32.6313 7.2513 32.9504 7.83008 33.5884C8.41341 34.2264 8.70508 35.131 8.70508 36.3022V37.1089H3.99512C4.05892 37.592 4.25033 37.9793 4.56934 38.271C4.8929 38.5627 5.30078 38.7085 5.79297 38.7085C6.55404 38.7085 7.14876 38.4328 7.57715 37.8813L8.54785 38.9683C8.25163 39.3875 7.85059 39.7157 7.34473 39.9526C6.83887 40.1851 6.27832 40.3013 5.66309 40.3013ZM5.4375 34.231C5.04557 34.231 4.72656 34.3631 4.48047 34.6274C4.23893 34.8918 4.08398 35.27 4.01562 35.7622H6.76367V35.605C6.75456 35.1675 6.63607 34.8302 6.4082 34.5933C6.18034 34.3517 5.85677 34.231 5.4375 34.231ZM11.5114 32.7681L11.5729 33.6226C12.1015 32.9618 12.8102 32.6313 13.6989 32.6313C14.4827 32.6313 15.0661 32.8615 15.4489 33.3218C15.8317 33.7821 16.0276 34.4702 16.0368 35.3862V40.1646H14.0612V35.4341C14.0612 35.0148 13.97 34.7118 13.7877 34.5249C13.6054 34.3335 13.3024 34.2378 12.8786 34.2378C12.3226 34.2378 11.9056 34.4748 11.6276 34.9487V40.1646H9.65199V32.7681H11.5114ZM20.1692 37.7515L21.5432 32.7681H23.6077L21.1126 40.1646H19.2259L16.7307 32.7681H18.7952L20.1692 37.7515ZM26.4277 40.1646H24.4452V32.7681H26.4277V40.1646ZM24.329 30.854C24.329 30.5578 24.427 30.314 24.623 30.1226C24.8235 29.9312 25.0946 29.8354 25.4364 29.8354C25.7737 29.8354 26.0426 29.9312 26.2431 30.1226C26.4436 30.314 26.5439 30.5578 26.5439 30.854C26.5439 31.1548 26.4413 31.4009 26.2362 31.5923C26.0357 31.7837 25.7691 31.8794 25.4364 31.8794C25.1038 31.8794 24.8349 31.7837 24.6298 31.5923C24.4293 31.4009 24.329 31.1548 24.329 30.854ZM32.0777 34.6206C31.8088 34.5841 31.5718 34.5659 31.3668 34.5659C30.6194 34.5659 30.1295 34.8188 29.897 35.3247V40.1646H27.9214V32.7681H29.7877L29.8423 33.6499C30.2388 32.9709 30.788 32.6313 31.4898 32.6313C31.7086 32.6313 31.9136 32.661 32.105 32.7202L32.0777 34.6206ZM32.341 36.3979C32.341 35.6642 32.4823 35.0103 32.7648 34.436C33.0474 33.8618 33.453 33.4175 33.9816 33.103C34.5148 32.7886 35.1324 32.6313 35.8342 32.6313C36.8322 32.6313 37.6457 32.9367 38.2746 33.5474C38.9081 34.158 39.2613 34.9875 39.3342 36.0356L39.3479 36.5415C39.3479 37.6763 39.0311 38.5877 38.3977 39.2759C37.7642 39.9595 36.9143 40.3013 35.8479 40.3013C34.7814 40.3013 33.9292 39.9595 33.2912 39.2759C32.6577 38.5923 32.341 37.6626 32.341 36.4868V36.3979ZM34.3166 36.5415C34.3166 37.2433 34.4488 37.7811 34.7131 38.1548C34.9774 38.5239 35.3557 38.7085 35.8479 38.7085C36.3264 38.7085 36.7001 38.5262 36.9689 38.1616C37.2378 37.7925 37.3723 37.2046 37.3723 36.3979C37.3723 35.7098 37.2378 35.1766 36.9689 34.7983C36.7001 34.4201 36.3218 34.231 35.8342 34.231C35.3511 34.231 34.9774 34.4201 34.7131 34.7983C34.4488 35.172 34.3166 35.7531 34.3166 36.5415ZM42.243 32.7681L42.3045 33.6226C42.8332 32.9618 43.5418 32.6313 44.4305 32.6313C45.2144 32.6313 45.7977 32.8615 46.1805 33.3218C46.5633 33.7821 46.7593 34.4702 46.7684 35.3862V40.1646H44.7928V35.4341C44.7928 35.0148 44.7017 34.7118 44.5194 34.5249C44.3371 34.3335 44.034 34.2378 43.6102 34.2378C43.0542 34.2378 42.6372 34.4748 42.3592 34.9487V40.1646H40.3836V32.7681H42.243ZM49.9848 32.7681L50.0464 33.5952C50.5705 32.9526 51.2791 32.6313 52.1723 32.6313C53.1248 32.6313 53.7788 33.0073 54.1343 33.7593C54.6538 33.0073 55.3943 32.6313 56.3559 32.6313C57.158 32.6313 57.755 32.866 58.147 33.3354C58.5389 33.8003 58.7348 34.5021 58.7348 35.4409V40.1646H56.7524V35.4478C56.7524 35.0285 56.6704 34.7231 56.5063 34.5317C56.3423 34.3358 56.0529 34.2378 55.6382 34.2378C55.0457 34.2378 54.6356 34.5203 54.4077 35.0854L54.4145 40.1646H52.4389V35.4546C52.4389 35.0262 52.3546 34.7163 52.186 34.5249C52.0174 34.3335 51.7303 34.2378 51.3247 34.2378C50.7641 34.2378 50.3585 34.4702 50.1079 34.9351V40.1646H48.1323V32.7681H49.9848ZM63.5236 40.3013C62.4389 40.3013 61.5548 39.9686 60.8712 39.3032C60.1922 38.6379 59.8527 37.7515 59.8527 36.644V36.4526C59.8527 35.7098 59.9962 35.0467 60.2833 34.4634C60.5704 33.8755 60.976 33.4243 61.5001 33.1099C62.0288 32.7909 62.6303 32.6313 63.3048 32.6313C64.3165 32.6313 65.1118 32.9504 65.6905 33.5884C66.2739 34.2264 66.5655 35.131 66.5655 36.3022V37.1089H61.8556C61.9194 37.592 62.1108 37.9793 62.4298 38.271C62.7534 38.5627 63.1613 38.7085 63.6534 38.7085C64.4145 38.7085 65.0092 38.4328 65.4376 37.8813L66.4083 38.9683C66.1121 39.3875 65.7111 39.7157 65.2052 39.9526C64.6993 40.1851 64.1388 40.3013 63.5236 40.3013ZM63.298 34.231C62.906 34.231 62.587 34.3631 62.3409 34.6274C62.0994 34.8918 61.9445 35.27 61.8761 35.7622H64.6241V35.605C64.615 35.1675 64.4965 34.8302 64.2687 34.5933C64.0408 34.3517 63.7172 34.231 63.298 34.231ZM69.3718 32.7681L69.4334 33.6226C69.962 32.9618 70.6707 32.6313 71.5593 32.6313C72.3432 32.6313 72.9265 32.8615 73.3093 33.3218C73.6921 33.7821 73.8881 34.4702 73.8972 35.3862V40.1646H71.9216V35.4341C71.9216 35.0148 71.8305 34.7118 71.6482 34.5249C71.4659 34.3335 71.1628 34.2378 70.739 34.2378C70.183 34.2378 69.766 34.4748 69.488 34.9487V40.1646H67.5125V32.7681H69.3718ZM77.6264 30.9497V32.7681H78.891V34.2173H77.6264V37.9087C77.6264 38.1821 77.6788 38.3781 77.7836 38.4966C77.8884 38.6151 78.0889 38.6743 78.3852 38.6743C78.6039 38.6743 78.7976 38.6584 78.9662 38.6265V40.1235C78.5788 40.242 78.1801 40.3013 77.7699 40.3013C76.3845 40.3013 75.6781 39.6017 75.6508 38.2026V34.2173H74.5707V32.7681H75.6508V30.9497H77.6264ZM8.91699 49.5347C8.91699 50.674 8.65723 51.5877 8.1377 52.2759C7.62272 52.9595 6.92546 53.3013 6.0459 53.3013C5.2985 53.3013 4.69466 53.0415 4.23438 52.522V56.0083H2.25879V45.7681H4.09082L4.15918 46.4927C4.6377 45.9185 5.26204 45.6313 6.03223 45.6313C6.94368 45.6313 7.65234 45.9686 8.1582 46.6431C8.66406 47.3175 8.91699 48.2472 8.91699 49.4321V49.5347ZM6.94141 49.3911C6.94141 48.703 6.81836 48.172 6.57227 47.7983C6.33073 47.4246 5.97754 47.2378 5.5127 47.2378C4.8929 47.2378 4.4668 47.4748 4.23438 47.9487V50.9771C4.47591 51.4647 4.90658 51.7085 5.52637 51.7085C6.46973 51.7085 6.94141 50.936 6.94141 49.3911ZM14.1637 47.6206C13.8948 47.5841 13.6579 47.5659 13.4528 47.5659C12.7054 47.5659 12.2155 47.8188 11.983 48.3247V53.1646H10.0075V45.7681H11.8737L11.9284 46.6499C12.3248 45.9709 12.874 45.6313 13.5758 45.6313C13.7946 45.6313 13.9996 45.661 14.1911 45.7202L14.1637 47.6206ZM14.427 49.3979C14.427 48.6642 14.5683 48.0103 14.8509 47.436C15.1334 46.8618 15.539 46.4175 16.0677 46.103C16.6009 45.7886 17.2184 45.6313 17.9202 45.6313C18.9182 45.6313 19.7317 45.9367 20.3606 46.5474C20.9941 47.158 21.3473 47.9875 21.4202 49.0356L21.4339 49.5415C21.4339 50.6763 21.1171 51.5877 20.4837 52.2759C19.8502 52.9595 19.0003 53.3013 17.9339 53.3013C16.8675 53.3013 16.0152 52.9595 15.3772 52.2759C14.7438 51.5923 14.427 50.6626 14.427 49.4868V49.3979ZM16.4026 49.5415C16.4026 50.2433 16.5348 50.7811 16.7991 51.1548C17.0634 51.5239 17.4417 51.7085 17.9339 51.7085C18.4124 51.7085 18.7861 51.5262 19.055 51.1616C19.3238 50.7925 19.4583 50.2046 19.4583 49.3979C19.4583 48.7098 19.3238 48.1766 19.055 47.7983C18.7861 47.4201 18.4078 47.231 17.9202 47.231C17.4371 47.231 17.0634 47.4201 16.7991 47.7983C16.5348 48.172 16.4026 48.7531 16.4026 49.5415ZM22.2236 49.4116C22.2236 48.2769 22.4924 47.3631 23.0302 46.6704C23.5725 45.9777 24.3017 45.6313 25.2177 45.6313C26.0289 45.6313 26.6601 45.9093 27.1112 46.4653L27.1933 45.7681H28.9843V52.9185C28.9843 53.5656 28.8362 54.1284 28.54 54.6069C28.2483 55.0854 27.8359 55.45 27.3027 55.7007C26.7695 55.9513 26.1451 56.0767 25.4296 56.0767C24.8873 56.0767 24.3586 55.9673 23.8437 55.7485C23.3287 55.5343 22.939 55.2563 22.6747 54.9146L23.5497 53.7114C24.0419 54.2629 24.6389 54.5386 25.3407 54.5386C25.8648 54.5386 26.2727 54.3973 26.5644 54.1147C26.856 53.8368 27.0019 53.4403 27.0019 52.9253V52.5288C26.5461 53.0438 25.9469 53.3013 25.204 53.3013C24.3154 53.3013 23.5953 52.9549 23.0439 52.2622C22.497 51.5649 22.2236 50.6421 22.2236 49.4937V49.4116ZM24.1991 49.5552C24.1991 50.2251 24.3336 50.7515 24.6025 51.1343C24.8713 51.5125 25.2405 51.7017 25.7099 51.7017C26.3114 51.7017 26.7421 51.4761 27.0019 51.0249V47.9146C26.7376 47.4634 26.3114 47.2378 25.7236 47.2378C25.2496 47.2378 24.8759 47.4315 24.6025 47.8188C24.3336 48.2062 24.1991 48.785 24.1991 49.5552ZM34.525 47.6206C34.2561 47.5841 34.0191 47.5659 33.814 47.5659C33.0666 47.5659 32.5767 47.8188 32.3443 48.3247V53.1646H30.3687V45.7681H32.2349L32.2896 46.6499C32.6861 45.9709 33.2352 45.6313 33.9371 45.6313C34.1558 45.6313 34.3609 45.661 34.5523 45.7202L34.525 47.6206ZM39.423 53.1646C39.3319 52.9868 39.2658 52.7658 39.2248 52.5015C38.7463 53.0347 38.1242 53.3013 37.3586 53.3013C36.634 53.3013 36.0324 53.0916 35.5539 52.6724C35.0799 52.2531 34.843 51.7244 34.843 51.0864C34.843 50.3026 35.1324 49.701 35.7111 49.2817C36.2945 48.8625 37.1353 48.6506 38.2336 48.646H39.1428V48.2222C39.1428 47.8804 39.0539 47.6069 38.8762 47.4019C38.703 47.1968 38.4273 47.0942 38.049 47.0942C37.7163 47.0942 37.4543 47.174 37.2629 47.3335C37.076 47.493 36.9826 47.7118 36.9826 47.9897H35.007C35.007 47.5614 35.1392 47.1649 35.4035 46.8003C35.6678 46.4357 36.0415 46.1509 36.5246 45.9458C37.0077 45.7362 37.55 45.6313 38.1516 45.6313C39.063 45.6313 39.7854 45.8615 40.3186 46.3218C40.8563 46.7775 41.1252 47.4201 41.1252 48.2495V51.4556C41.1298 52.1574 41.2277 52.6883 41.4191 53.0483V53.1646H39.423ZM37.7893 51.7905C38.0809 51.7905 38.3498 51.7267 38.5959 51.5991C38.842 51.467 39.0243 51.2915 39.1428 51.0728V49.8013H38.4045C37.4156 49.8013 36.8892 50.1431 36.8254 50.8267L36.8186 50.9429C36.8186 51.189 36.9051 51.3918 37.0783 51.5513C37.2515 51.7108 37.4885 51.7905 37.7893 51.7905ZM44.3553 45.7681L44.4168 46.5952C44.9409 45.9526 45.6496 45.6313 46.5428 45.6313C47.4953 45.6313 48.1493 46.0073 48.5047 46.7593C49.0243 46.0073 49.7648 45.6313 50.7264 45.6313C51.5285 45.6313 52.1255 45.866 52.5174 46.3354C52.9093 46.8003 53.1053 47.5021 53.1053 48.4409V53.1646H51.1229V48.4478C51.1229 48.0285 51.0409 47.7231 50.8768 47.5317C50.7127 47.3358 50.4233 47.2378 50.0086 47.2378C49.4162 47.2378 49.006 47.5203 48.7782 48.0854L48.785 53.1646H46.8094V48.4546C46.8094 48.0262 46.7251 47.7163 46.5565 47.5249C46.3879 47.3335 46.1008 47.2378 45.6952 47.2378C45.1346 47.2378 44.729 47.4702 44.4784 47.9351V53.1646H42.5028V45.7681H44.3553ZM56.3423 45.7681L56.4038 46.5952C56.9279 45.9526 57.6365 45.6313 58.5298 45.6313C59.4822 45.6313 60.1362 46.0073 60.4917 46.7593C61.0112 46.0073 61.7518 45.6313 62.7134 45.6313C63.5154 45.6313 64.1124 45.866 64.5044 46.3354C64.8963 46.8003 65.0923 47.5021 65.0923 48.4409V53.1646H63.1098V48.4478C63.1098 48.0285 63.0278 47.7231 62.8638 47.5317C62.6997 47.3358 62.4103 47.2378 61.9956 47.2378C61.4031 47.2378 60.993 47.5203 60.7651 48.0854L60.772 53.1646H58.7964V48.4546C58.7964 48.0262 58.7121 47.7163 58.5434 47.5249C58.3748 47.3335 58.0877 47.2378 57.6821 47.2378C57.1216 47.2378 56.716 47.4702 56.4653 47.9351V53.1646H54.4897V45.7681H56.3423ZM69.881 53.3013C68.7963 53.3013 67.9122 52.9686 67.2286 52.3032C66.5496 51.6379 66.2101 50.7515 66.2101 49.644V49.4526C66.2101 48.7098 66.3536 48.0467 66.6407 47.4634C66.9278 46.8755 67.3334 46.4243 67.8575 46.1099C68.3862 45.7909 68.9877 45.6313 69.6622 45.6313C70.6739 45.6313 71.4692 45.9504 72.048 46.5884C72.6313 47.2264 72.923 48.131 72.923 49.3022V50.1089H68.213C68.2768 50.592 68.4682 50.9793 68.7872 51.271C69.1108 51.5627 69.5187 51.7085 70.0109 51.7085C70.7719 51.7085 71.3667 51.4328 71.795 50.8813L72.7657 51.9683C72.4695 52.3875 72.0685 52.7157 71.5626 52.9526C71.0568 53.1851 70.4962 53.3013 69.881 53.3013ZM69.6554 47.231C69.2635 47.231 68.9445 47.3631 68.6984 47.6274C68.4568 47.8918 68.3019 48.27 68.2335 48.7622H70.9816V48.605C70.9724 48.1675 70.854 47.8302 70.6261 47.5933C70.3982 47.3517 70.0747 47.231 69.6554 47.231Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ h.jsx("rect", { x: "95.5", y: "1", width: "2", height: "54", fill: "white" }),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M118.217 18.5176L118.49 20.3926L118.891 18.7031L121.703 8.78125H123.285L126.029 18.7031L126.42 20.4219L126.723 18.5078L128.93 8.78125H130.814L127.367 23H125.658L122.729 12.6387L122.504 11.5547L122.279 12.6387L119.242 23H117.533L114.096 8.78125H115.971L118.217 18.5176ZM131.83 17.6191C131.83 16.584 132.032 15.653 132.436 14.8262C132.846 13.9993 133.412 13.3613 134.135 12.9121C134.864 12.4629 135.694 12.2383 136.625 12.2383C138.064 12.2383 139.226 12.7363 140.111 13.7324C141.003 14.7285 141.449 16.0534 141.449 17.707V17.834C141.449 18.8626 141.251 19.7871 140.854 20.6074C140.463 21.4212 139.9 22.056 139.164 22.5117C138.435 22.9674 137.595 23.1953 136.645 23.1953C135.212 23.1953 134.05 22.6973 133.158 21.7012C132.273 20.7051 131.83 19.3867 131.83 17.7461V17.6191ZM133.646 17.834C133.646 19.0059 133.917 19.9466 134.457 20.6562C135.004 21.3659 135.733 21.7207 136.645 21.7207C137.562 21.7207 138.292 21.3626 138.832 20.6465C139.372 19.9238 139.643 18.9147 139.643 17.6191C139.643 16.4603 139.366 15.5228 138.812 14.8066C138.266 14.084 137.536 13.7227 136.625 13.7227C135.733 13.7227 135.014 14.0775 134.467 14.7871C133.92 15.4967 133.646 16.5124 133.646 17.834ZM148.822 14.0547C148.549 14.0091 148.253 13.9863 147.934 13.9863C146.749 13.9863 145.945 14.4909 145.521 15.5V23H143.715V12.4336H145.473L145.502 13.6543C146.094 12.7103 146.934 12.2383 148.021 12.2383C148.373 12.2383 148.64 12.2839 148.822 12.375V14.0547ZM152.455 23H150.648V8H152.455V23ZM154.916 17.6289C154.916 16.0078 155.3 14.7057 156.068 13.7227C156.837 12.7331 157.842 12.2383 159.086 12.2383C160.323 12.2383 161.303 12.6615 162.025 13.5078V8H163.832V23H162.172L162.084 21.8672C161.361 22.7526 160.355 23.1953 159.066 23.1953C157.842 23.1953 156.843 22.694 156.068 21.6914C155.3 20.6888 154.916 19.3802 154.916 17.7656V17.6289ZM156.723 17.834C156.723 19.0319 156.97 19.9694 157.465 20.6465C157.96 21.3236 158.643 21.6621 159.516 21.6621C160.661 21.6621 161.498 21.1478 162.025 20.1191V15.2656C161.485 14.2695 160.655 13.7715 159.535 13.7715C158.65 13.7715 157.96 14.1133 157.465 14.7969C156.97 15.4805 156.723 16.4928 156.723 17.834ZM179.926 16.4277H173.764V21.4668H180.922V23H171.889V8.78125H180.824V10.3242H173.764V14.8945H179.926V16.4277ZM184.682 12.4336L184.74 13.7617C185.548 12.7461 186.602 12.2383 187.904 12.2383C190.137 12.2383 191.264 13.498 191.283 16.0176V23H189.477V16.0078C189.47 15.2461 189.294 14.6829 188.949 14.3184C188.611 13.9538 188.08 13.7715 187.357 13.7715C186.771 13.7715 186.257 13.9277 185.814 14.2402C185.372 14.5527 185.027 14.9629 184.779 15.4707V23H182.973V12.4336H184.682ZM197.494 20.5488L200.111 12.4336H201.957L198.168 23H196.791L192.963 12.4336H194.809L197.494 20.5488ZM205.658 23H203.852V12.4336H205.658V23ZM203.705 9.63086C203.705 9.33789 203.793 9.09049 203.969 8.88867C204.151 8.68685 204.418 8.58594 204.77 8.58594C205.121 8.58594 205.388 8.68685 205.57 8.88867C205.753 9.09049 205.844 9.33789 205.844 9.63086C205.844 9.92383 205.753 10.168 205.57 10.3633C205.388 10.5586 205.121 10.6562 204.77 10.6562C204.418 10.6562 204.151 10.5586 203.969 10.3633C203.793 10.168 203.705 9.92383 203.705 9.63086ZM213.666 14.0547C213.393 14.0091 213.096 13.9863 212.777 13.9863C211.592 13.9863 210.788 14.4909 210.365 15.5V23H208.559V12.4336H210.316L210.346 13.6543C210.938 12.7103 211.778 12.2383 212.865 12.2383C213.217 12.2383 213.484 12.2839 213.666 12.375V14.0547ZM214.662 17.6191C214.662 16.584 214.864 15.653 215.268 14.8262C215.678 13.9993 216.244 13.3613 216.967 12.9121C217.696 12.4629 218.526 12.2383 219.457 12.2383C220.896 12.2383 222.058 12.7363 222.943 13.7324C223.835 14.7285 224.281 16.0534 224.281 17.707V17.834C224.281 18.8626 224.083 19.7871 223.686 20.6074C223.295 21.4212 222.732 22.056 221.996 22.5117C221.267 22.9674 220.427 23.1953 219.477 23.1953C218.044 23.1953 216.882 22.6973 215.99 21.7012C215.105 20.7051 214.662 19.3867 214.662 17.7461V17.6191ZM216.479 17.834C216.479 19.0059 216.749 19.9466 217.289 20.6562C217.836 21.3659 218.565 21.7207 219.477 21.7207C220.395 21.7207 221.124 21.3626 221.664 20.6465C222.204 19.9238 222.475 18.9147 222.475 17.6191C222.475 16.4603 222.198 15.5228 221.645 14.8066C221.098 14.084 220.368 13.7227 219.457 13.7227C218.565 13.7227 217.846 14.0775 217.299 14.7871C216.752 15.4967 216.479 16.5124 216.479 17.834ZM228.256 12.4336L228.314 13.7617C229.122 12.7461 230.176 12.2383 231.479 12.2383C233.712 12.2383 234.838 13.498 234.857 16.0176V23H233.051V16.0078C233.044 15.2461 232.868 14.6829 232.523 14.3184C232.185 13.9538 231.654 13.7715 230.932 13.7715C230.346 13.7715 229.831 13.9277 229.389 14.2402C228.946 14.5527 228.601 14.9629 228.354 15.4707V23H226.547V12.4336H228.256ZM239.281 12.4336L239.33 13.6055C240.105 12.694 241.15 12.2383 242.465 12.2383C243.943 12.2383 244.949 12.8047 245.482 13.9375C245.834 13.4297 246.29 13.0195 246.85 12.707C247.416 12.3945 248.083 12.2383 248.852 12.2383C251.169 12.2383 252.348 13.4655 252.387 15.9199V23H250.58V16.0273C250.58 15.2721 250.408 14.709 250.062 14.3379C249.717 13.9603 249.138 13.7715 248.324 13.7715C247.654 13.7715 247.097 13.9733 246.654 14.377C246.212 14.7741 245.954 15.3112 245.883 15.9883V23H244.066V16.0762C244.066 14.5397 243.314 13.7715 241.811 13.7715C240.626 13.7715 239.815 14.276 239.379 15.2852V23H237.572V12.4336H239.281ZM259.506 23.1953C258.074 23.1953 256.908 22.7266 256.01 21.7891C255.111 20.8451 254.662 19.5853 254.662 18.0098V17.6777C254.662 16.6296 254.861 15.6953 255.258 14.875C255.661 14.0482 256.221 13.4036 256.938 12.9414C257.66 12.4727 258.441 12.2383 259.281 12.2383C260.655 12.2383 261.723 12.6908 262.484 13.5957C263.246 14.5007 263.627 15.7962 263.627 17.4824V18.2344H256.469C256.495 19.276 256.798 20.1191 257.377 20.7637C257.963 21.4017 258.705 21.7207 259.604 21.7207C260.242 21.7207 260.782 21.5905 261.225 21.3301C261.667 21.0697 262.055 20.7246 262.387 20.2949L263.49 21.1543C262.605 22.515 261.277 23.1953 259.506 23.1953ZM259.281 13.7227C258.552 13.7227 257.94 13.9896 257.445 14.5234C256.951 15.0508 256.645 15.793 256.527 16.75H261.82V16.6133C261.768 15.6953 261.521 14.9857 261.078 14.4844C260.635 13.9766 260.036 13.7227 259.281 13.7227ZM267.436 12.4336L267.494 13.7617C268.301 12.7461 269.356 12.2383 270.658 12.2383C272.891 12.2383 274.018 13.498 274.037 16.0176V23H272.23V16.0078C272.224 15.2461 272.048 14.6829 271.703 14.3184C271.365 13.9538 270.834 13.7715 270.111 13.7715C269.525 13.7715 269.011 13.9277 268.568 14.2402C268.126 14.5527 267.781 14.9629 267.533 15.4707V23H265.727V12.4336H267.436ZM279.213 9.875V12.4336H281.186V13.8301H279.213V20.3828C279.213 20.806 279.301 21.125 279.477 21.3398C279.652 21.5482 279.952 21.6523 280.375 21.6523C280.583 21.6523 280.87 21.6133 281.234 21.5352V23C280.759 23.1302 280.297 23.1953 279.848 23.1953C279.04 23.1953 278.432 22.9512 278.021 22.4629C277.611 21.9746 277.406 21.2812 277.406 20.3828V13.8301H275.482V12.4336H277.406V9.875H279.213ZM119.34 39.6621C117.732 39.1999 116.56 38.6335 115.824 37.9629C115.095 37.2858 114.73 36.4525 114.73 35.4629C114.73 34.3431 115.176 33.4186 116.068 32.6895C116.967 31.9538 118.132 31.5859 119.564 31.5859C120.541 31.5859 121.41 31.7747 122.172 32.1523C122.94 32.5299 123.533 33.0508 123.949 33.7148C124.372 34.3789 124.584 35.1048 124.584 35.8926H122.699C122.699 35.0332 122.426 34.3594 121.879 33.8711C121.332 33.3763 120.561 33.1289 119.564 33.1289C118.64 33.1289 117.917 33.334 117.396 33.7441C116.882 34.1478 116.625 34.7109 116.625 35.4336C116.625 36.013 116.869 36.5046 117.357 36.9082C117.852 37.3053 118.689 37.6699 119.867 38.002C121.052 38.334 121.977 38.7018 122.641 39.1055C123.311 39.5026 123.806 39.9681 124.125 40.502C124.451 41.0358 124.613 41.6641 124.613 42.3867C124.613 43.5391 124.164 44.4635 123.266 45.1602C122.367 45.8503 121.166 46.1953 119.662 46.1953C118.686 46.1953 117.774 46.0098 116.928 45.6387C116.081 45.2611 115.427 44.7467 114.965 44.0957C114.509 43.4447 114.281 42.7057 114.281 41.8789H116.166C116.166 42.7383 116.482 43.4186 117.113 43.9199C117.751 44.4147 118.601 44.6621 119.662 44.6621C120.652 44.6621 121.41 44.4603 121.938 44.0566C122.465 43.653 122.729 43.1029 122.729 42.4062C122.729 41.7096 122.484 41.1725 121.996 40.7949C121.508 40.4108 120.622 40.0332 119.34 39.6621ZM128.705 46H126.898V35.4336H128.705V46ZM126.752 32.6309C126.752 32.3379 126.84 32.0905 127.016 31.8887C127.198 31.6868 127.465 31.5859 127.816 31.5859C128.168 31.5859 128.435 31.6868 128.617 31.8887C128.799 32.0905 128.891 32.3379 128.891 32.6309C128.891 32.9238 128.799 33.168 128.617 33.3633C128.435 33.5586 128.168 33.6562 127.816 33.6562C127.465 33.6562 127.198 33.5586 127.016 33.3633C126.84 33.168 126.752 32.9238 126.752 32.6309ZM134.057 32.875V35.4336H136.029V36.8301H134.057V43.3828C134.057 43.806 134.145 44.125 134.32 44.3398C134.496 44.5482 134.796 44.6523 135.219 44.6523C135.427 44.6523 135.714 44.6133 136.078 44.5352V46C135.603 46.1302 135.141 46.1953 134.691 46.1953C133.884 46.1953 133.275 45.9512 132.865 45.4629C132.455 44.9746 132.25 44.2812 132.25 43.3828V36.8301H130.326V35.4336H132.25V32.875H134.057ZM144.672 44.9551C143.969 45.7819 142.937 46.1953 141.576 46.1953C140.45 46.1953 139.59 45.8698 138.998 45.2188C138.412 44.5612 138.116 43.5911 138.109 42.3086V35.4336H139.916V42.2598C139.916 43.8613 140.567 44.6621 141.869 44.6621C143.249 44.6621 144.167 44.1478 144.623 43.1191V35.4336H146.43V46H144.711L144.672 44.9551ZM155.707 46C155.603 45.7917 155.518 45.4206 155.453 44.8867C154.613 45.7591 153.611 46.1953 152.445 46.1953C151.404 46.1953 150.548 45.9023 149.877 45.3164C149.213 44.724 148.881 43.9753 148.881 43.0703C148.881 41.9701 149.298 41.1172 150.131 40.5117C150.971 39.8997 152.149 39.5938 153.666 39.5938H155.424V38.7637C155.424 38.1322 155.235 37.6309 154.857 37.2598C154.48 36.8822 153.923 36.6934 153.188 36.6934C152.543 36.6934 152.003 36.8561 151.566 37.1816C151.13 37.5072 150.912 37.901 150.912 38.3633H149.096C149.096 37.8359 149.281 37.3281 149.652 36.8398C150.03 36.3451 150.538 35.9544 151.176 35.668C151.82 35.3815 152.527 35.2383 153.295 35.2383C154.512 35.2383 155.466 35.5443 156.156 36.1562C156.846 36.7617 157.204 37.5983 157.23 38.666V43.5293C157.23 44.4993 157.354 45.2708 157.602 45.8438V46H155.707ZM152.709 44.623C153.275 44.623 153.812 44.4766 154.32 44.1836C154.828 43.8906 155.196 43.5098 155.424 43.041V40.873H154.008C151.794 40.873 150.688 41.5208 150.688 42.8164C150.688 43.3828 150.876 43.8255 151.254 44.1445C151.632 44.4635 152.117 44.623 152.709 44.623ZM162.514 32.875V35.4336H164.486V36.8301H162.514V43.3828C162.514 43.806 162.602 44.125 162.777 44.3398C162.953 44.5482 163.253 44.6523 163.676 44.6523C163.884 44.6523 164.171 44.6133 164.535 44.5352V46C164.06 46.1302 163.598 46.1953 163.148 46.1953C162.341 46.1953 161.732 45.9512 161.322 45.4629C160.912 44.9746 160.707 44.2812 160.707 43.3828V36.8301H158.783V35.4336H160.707V32.875H162.514ZM168.568 46H166.762V35.4336H168.568V46ZM166.615 32.6309C166.615 32.3379 166.703 32.0905 166.879 31.8887C167.061 31.6868 167.328 31.5859 167.68 31.5859C168.031 31.5859 168.298 31.6868 168.48 31.8887C168.663 32.0905 168.754 32.3379 168.754 32.6309C168.754 32.9238 168.663 33.168 168.48 33.3633C168.298 33.5586 168.031 33.6562 167.68 33.6562C167.328 33.6562 167.061 33.5586 166.879 33.3633C166.703 33.168 166.615 32.9238 166.615 32.6309ZM170.99 40.6191C170.99 39.584 171.192 38.653 171.596 37.8262C172.006 36.9993 172.572 36.3613 173.295 35.9121C174.024 35.4629 174.854 35.2383 175.785 35.2383C177.224 35.2383 178.386 35.7363 179.271 36.7324C180.163 37.7285 180.609 39.0534 180.609 40.707V40.834C180.609 41.8626 180.411 42.7871 180.014 43.6074C179.623 44.4212 179.06 45.056 178.324 45.5117C177.595 45.9674 176.755 46.1953 175.805 46.1953C174.372 46.1953 173.21 45.6973 172.318 44.7012C171.433 43.7051 170.99 42.3867 170.99 40.7461V40.6191ZM172.807 40.834C172.807 42.0059 173.077 42.9466 173.617 43.6562C174.164 44.3659 174.893 44.7207 175.805 44.7207C176.723 44.7207 177.452 44.3626 177.992 43.6465C178.533 42.9238 178.803 41.9147 178.803 40.6191C178.803 39.4603 178.526 38.5228 177.973 37.8066C177.426 37.084 176.697 36.7227 175.785 36.7227C174.893 36.7227 174.174 37.0775 173.627 37.7871C173.08 38.4967 172.807 39.5124 172.807 40.834ZM184.584 35.4336L184.643 36.7617C185.45 35.7461 186.505 35.2383 187.807 35.2383C190.04 35.2383 191.166 36.498 191.186 39.0176V46H189.379V39.0078C189.372 38.2461 189.197 37.6829 188.852 37.3184C188.513 36.9538 187.982 36.7715 187.26 36.7715C186.674 36.7715 186.16 36.9277 185.717 37.2402C185.274 37.5527 184.929 37.9629 184.682 38.4707V46H182.875V35.4336H184.584ZM204.369 40.248H201.029V46H199.145V31.7812H203.852C205.453 31.7812 206.684 32.1458 207.543 32.875C208.409 33.6042 208.842 34.6654 208.842 36.0586C208.842 36.944 208.601 37.7155 208.119 38.373C207.644 39.0306 206.98 39.5221 206.127 39.8477L209.467 45.8828V46H207.455L204.369 40.248ZM201.029 38.7148H203.91C204.841 38.7148 205.58 38.474 206.127 37.9922C206.68 37.5104 206.957 36.8659 206.957 36.0586C206.957 35.1797 206.693 34.5059 206.166 34.0371C205.645 33.5684 204.89 33.3307 203.9 33.3242H201.029V38.7148ZM210.717 40.6191C210.717 39.584 210.919 38.653 211.322 37.8262C211.732 36.9993 212.299 36.3613 213.021 35.9121C213.751 35.4629 214.581 35.2383 215.512 35.2383C216.951 35.2383 218.113 35.7363 218.998 36.7324C219.89 37.7285 220.336 39.0534 220.336 40.707V40.834C220.336 41.8626 220.137 42.7871 219.74 43.6074C219.35 44.4212 218.786 45.056 218.051 45.5117C217.322 45.9674 216.482 46.1953 215.531 46.1953C214.099 46.1953 212.937 45.6973 212.045 44.7012C211.16 43.7051 210.717 42.3867 210.717 40.7461V40.6191ZM212.533 40.834C212.533 42.0059 212.803 42.9466 213.344 43.6562C213.891 44.3659 214.62 44.7207 215.531 44.7207C216.449 44.7207 217.178 44.3626 217.719 43.6465C218.259 42.9238 218.529 41.9147 218.529 40.6191C218.529 39.4603 218.253 38.5228 217.699 37.8066C217.152 37.084 216.423 36.7227 215.512 36.7227C214.62 36.7227 213.9 37.0775 213.354 37.7871C212.807 38.4967 212.533 39.5124 212.533 40.834ZM222.123 40.6191C222.123 39.584 222.325 38.653 222.729 37.8262C223.139 36.9993 223.705 36.3613 224.428 35.9121C225.157 35.4629 225.987 35.2383 226.918 35.2383C228.357 35.2383 229.519 35.7363 230.404 36.7324C231.296 37.7285 231.742 39.0534 231.742 40.707V40.834C231.742 41.8626 231.544 42.7871 231.146 43.6074C230.756 44.4212 230.193 45.056 229.457 45.5117C228.728 45.9674 227.888 46.1953 226.938 46.1953C225.505 46.1953 224.343 45.6973 223.451 44.7012C222.566 43.7051 222.123 42.3867 222.123 40.7461V40.6191ZM223.939 40.834C223.939 42.0059 224.21 42.9466 224.75 43.6562C225.297 44.3659 226.026 44.7207 226.938 44.7207C227.855 44.7207 228.585 44.3626 229.125 43.6465C229.665 42.9238 229.936 41.9147 229.936 40.6191C229.936 39.4603 229.659 38.5228 229.105 37.8066C228.559 37.084 227.829 36.7227 226.918 36.7227C226.026 36.7227 225.307 37.0775 224.76 37.7871C224.213 38.4967 223.939 39.5124 223.939 40.834ZM235.707 35.4336L235.756 36.6055C236.531 35.694 237.576 35.2383 238.891 35.2383C240.368 35.2383 241.374 35.8047 241.908 36.9375C242.26 36.4297 242.715 36.0195 243.275 35.707C243.842 35.3945 244.509 35.2383 245.277 35.2383C247.595 35.2383 248.773 36.4655 248.812 38.9199V46H247.006V39.0273C247.006 38.2721 246.833 37.709 246.488 37.3379C246.143 36.9603 245.564 36.7715 244.75 36.7715C244.079 36.7715 243.523 36.9733 243.08 37.377C242.637 37.7741 242.38 38.3112 242.309 38.9883V46H240.492V39.0762C240.492 37.5397 239.74 36.7715 238.236 36.7715C237.051 36.7715 236.241 37.276 235.805 38.2852V46H233.998V35.4336H235.707Z",
      fill: "white"
    }
  )
] }), "UNEPLogo"), GT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsxs(
  "svg",
  {
    width: "121",
    height: "106",
    viewBox: "0 0 121 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M51.9441 83.0495C39.0095 79.1392 29.5933 67.1194 29.5933 52.9063C29.5933 50.3379 29.8961 47.8416 30.4729 45.4607L50.9059 48.0869C50.9059 48.0869 58.7503 48.4332 58.4619 62.3288C58.1879 75.8059 51.9441 83.0495 51.9441 83.0495Z",
          fill: "#00ABF1"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M70.2142 83.0495C83.1488 79.1392 92.565 67.1194 92.565 52.9063C92.565 50.3379 92.2622 47.8416 91.6854 45.4607L71.2524 48.0869C71.2524 48.0869 63.408 48.4332 63.6964 62.3288C63.9703 75.8059 70.2142 83.0495 70.2142 83.0495Z",
          fill: "#00ABF1"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M61.0708 30.3643C63.6952 30.3643 65.8293 32.4998 65.8293 35.126C65.8293 37.175 64.4162 38.7045 62.7147 39.6136C62.5128 39.729 62.3109 39.8156 62.3542 40.1474C62.3974 40.4793 63.378 40.6669 63.7961 40.7679L91.266 43.9568C87.4159 30.927 75.3609 21.418 61.0852 21.418H61.0419C46.7662 21.418 34.7256 30.927 30.8611 43.9568L58.331 40.7679C58.7492 40.6669 59.7297 40.4938 59.773 40.1474C59.8162 39.83 59.6144 39.729 59.4125 39.6136C57.7109 38.7045 56.2978 37.175 56.2978 35.126C56.3122 32.4998 58.4464 30.3643 61.0708 30.3643Z",
          fill: "#00ABF1"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M73.6317 105.323L75.4919 104.154C75.4919 104.154 66.6669 92.1775 46.9116 92.1775C36.8033 92.1775 31.5689 96.2466 24.4887 96.2466C24.4887 96.2466 21.5903 96.5929 18.7928 94.847C18.7928 94.847 22.1671 99.7241 34.3663 99.7241C43.3067 99.7241 49.7091 94.4862 55.9817 94.4862C64.5616 94.5007 70.9496 102.177 73.6317 105.323Z",
          fill: "#00ABF1"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M46.2056 105.323L44.3455 104.154C44.3455 104.154 53.1705 92.1775 72.9257 92.1775C83.0341 92.1775 88.2685 96.2466 95.3487 96.2466C95.3487 96.2466 98.2471 96.5929 101.045 94.847C101.045 94.847 97.6703 99.7241 85.471 99.7241C76.5307 99.7241 70.1283 94.4862 63.8556 94.4862C55.2758 94.5007 48.8733 102.177 46.2056 105.323Z",
          fill: "#00ABF1"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M36.7886 91.1579C36.4425 92.0814 32.6645 90.9847 30.1122 91.7351C27.2571 92.5864 12.1594 94.4045 5.54071 78.7197C5.54071 78.7197 11.8134 85.4582 16.7017 85.9344C21.5756 86.3961 26.9254 87.5649 31.4533 90.119L32.5059 90.3498C32.5059 90.3498 32.3617 89.8881 31.9291 89.6572C31.3379 89.3398 26.637 87.8102 24.3731 80.3502C23.2051 76.5119 23.4502 73.7271 22.9744 71.7502C22.9744 71.7502 28.0934 77.4499 30.1843 81.0572C32.2608 84.6502 32.4915 88.7193 36.7886 91.1579Z",
          fill: "#00ABF1"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M21.4021 83.2481C21.0272 83.6233 20.061 83.0173 19.715 82.8441C19.3689 82.671 16.8598 81.5166 12.5627 80.0015C8.32326 78.4864 0.421141 71.8055 1.17098 60.3485C1.17098 60.3485 2.28131 64.6485 5.52579 67.5056C8.78469 70.3482 9.93827 70.7089 11.9138 73.032C13.8893 75.3552 18.3595 80.6508 18.5325 80.5931C18.7056 80.5354 18.7633 80.2468 18.4172 79.9582C18.0711 79.6696 16.9031 76.7549 16.1532 75.7737C15.4034 74.7924 13.1395 67.9817 16.4416 59.6126C16.4416 59.6126 19.9889 65.7163 19.7582 71.8777C19.5275 78.0391 19.2391 76.5817 20.7388 81.7042C20.7532 81.6753 21.5751 83.075 21.4021 83.2481Z",
          fill: "#00ABF1"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M11.5252 68.3235C11.3089 68.5399 10.4149 67.2124 9.7227 66.0003C9.03054 64.7738 4.14218 59.5503 3.5077 58.497C2.87323 57.4436 -2.59191 50.8205 1.53218 40.994C1.53218 40.994 1.93594 40.8786 1.93594 43.2017C1.93594 45.5249 4.0845 50.705 5.82931 52.9128C7.57411 55.1205 9.14589 58.6701 9.49197 62.4506C9.49197 62.4506 9.72269 63.1433 10.0111 63.201C10.2995 63.2587 10.2995 62.5084 10.2995 62.5084C10.2995 62.5084 10.0688 59.0164 10.0688 56.6356C10.0688 54.2547 11.1214 50.1856 13.3853 47.8624C13.3853 47.8624 14.438 46.6937 15.0725 45.3084C15.0725 45.3084 15.4762 44.3849 16.053 43.9088C16.053 43.9088 16.5145 50.5896 14.2505 56.8087C11.9866 63.0278 11.2368 64.0812 11.5829 67.4433C11.5829 67.4433 11.6405 68.1936 11.5252 68.3235Z",
          fill: "#00ABF1"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M7.68932 49.922C7.4586 49.922 7.28556 49.114 7.1702 48.4646C7.05484 47.8297 6.36269 44.1069 5.88683 43.2844C5.4254 42.4764 3.68058 38.7536 3.6229 34.3959C3.56522 30.0382 5.54075 24.1077 9.95323 19.4036C9.95323 19.4036 9.78021 20.8033 8.61219 23.8768C7.44418 26.9647 8.15075 29.865 8.26611 30.3845C8.38147 30.9039 8.78523 34.5113 8.78523 36.1996C8.78523 37.5415 8.43914 42.1301 8.15075 43.0536C8.15075 43.0536 8.03539 43.6885 8.26611 43.6885C8.49683 43.6885 8.72756 43.169 8.72756 43.169C8.72756 43.169 8.95827 39.5616 11.6259 36.315C14.2936 33.0539 19.1243 31.0771 19.8741 29.6341C19.8741 29.6341 19.5281 34.7566 13.8899 40.7304C8.87176 46.0693 10.3426 43.3422 8.71312 47.6999C8.71312 47.6999 8.02097 49.3304 8.02097 49.6767C8.03539 50.0519 7.68932 49.922 7.68932 49.922Z",
          fill: "#00ABF1"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M10.7755 32.7166C10.7755 32.7166 10.6601 32.024 11.5253 30.4511C12.3905 28.8783 11.4676 26.0934 12.6356 22.0243C13.8036 17.9552 15.9522 10.9858 24.1427 6.80122C24.1427 6.80122 23.3352 7.55155 22.917 8.14316C22.5133 8.72034 20.307 12.9049 19.6581 15.8196C19.0237 18.72 16.2262 23.6116 15.188 24.7082C14.1353 25.8193 14.6112 25.9347 14.6112 25.9347C14.6112 25.9347 15.1303 25.8193 15.6638 25.0112C16.1829 24.2032 18.865 21.173 21.8211 20.4804C24.7772 19.7878 29.4925 18.3881 29.7809 18.0995C29.7809 18.0995 24.6618 23.3374 19.9609 26.0069C15.26 28.6763 14.7265 27.8683 11.9435 31.4756C11.9291 31.4324 11.0062 32.7166 10.7755 32.7166Z",
          fill: "#00ABF1"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M22.0381 17.1904C22.0381 17.1904 22.0382 16.7287 22.9033 15.9062C23.7685 15.0981 24.6481 12.6451 26.1622 10.3797C27.6763 8.11425 31.0938 2.18373 39.9909 0.784069C39.9909 0.784069 37.3232 2.76091 36.9051 3.39581C36.5013 4.0307 33.8913 7.46492 32.7233 8.63371C31.5553 9.8025 28.2531 12.2411 27.1428 12.7605C27.1428 12.7605 26.566 13.2223 26.6814 13.3954C26.7967 13.5686 27.3735 13.2223 27.3735 13.2223C27.3735 13.2223 30.4594 10.8414 34.1653 10.726C37.8856 10.6106 41.779 10.7837 42.3558 10.8414C42.3558 10.8414 38.8662 13.2223 30.5603 14.7374C22.2545 16.2525 23.8262 16.3102 22.5429 17.1183C22.5573 17.1327 22.2689 17.3636 22.0381 17.1904Z",
          fill: "#00ABF1"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M36.8452 7.55978C36.8452 7.55978 37.0182 7.09804 38.3593 6.69401C39.7003 6.28999 39.585 5.00576 43.6514 2.85577C47.7178 0.705774 51.9572 -0.28986 56.2544 1.51383C56.2544 1.51383 54.4519 1.7447 54.1635 1.86013C53.8751 1.97557 50.7892 2.78362 49.924 3.25979C49.0588 3.72154 44.5742 5.69838 42.7718 6.04468C40.9693 6.39099 41.8489 6.50643 41.8489 6.50643C41.8489 6.50643 42.2526 6.67958 42.5987 6.67958C42.9448 6.67958 46.9535 6.27556 49.5635 7.19904C52.1735 8.12253 52.1158 8.48327 53.1685 8.82958C54.2211 9.17588 55.4324 9.40676 55.6055 9.81078C55.6055 9.81078 52.9955 10.0417 51.4237 10.0417C49.8519 10.0417 45.7278 9.63763 43.7523 8.69971C41.7768 7.77622 39.5129 7.35777 38.763 7.53092C38.0132 7.73293 37.0903 7.73293 36.8452 7.55978Z",
          fill: "#00ABF1"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M53.3587 5.53482C53.3587 5.53482 53.5318 5.30394 54.6998 5.07307C55.8678 4.8422 56.1562 4.14959 58.8816 3.55798C61.6069 2.96637 65.8464 2.44691 69.7397 5.13079C69.7397 5.13079 67.3605 5.07307 66.8413 5.07307C66.3222 5.07307 61.7944 5.88112 60.7417 5.88112C59.6891 5.88112 57.5982 5.41938 57.3098 5.76569C57.0214 6.112 59.2276 6.57374 59.5737 6.68918C59.9198 6.80461 61.4915 6.92005 63.4671 8.83917C65.4426 10.7583 66.8413 11.7972 67.072 11.9271C67.072 11.9271 61.2608 10.5851 59.8044 9.77709C58.348 8.96904 55.8534 6.4583 55.4496 6.28515C55.0314 6.112 53.3587 5.53482 53.3587 5.53482Z",
          fill: "#00ABF1"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M66.769 7.91335C66.769 7.91335 70.4316 7.79791 73.0993 9.48616C75.767 11.1744 77.9155 13.3821 78.1462 14.7241C78.1462 14.7241 76.6322 13.4398 75.6516 13.1512C74.6566 12.8627 71.8736 11.2898 71.2968 10.9435C70.72 10.5972 67.3457 8.43281 66.769 7.91335Z",
          fill: "#00ABF1"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M83.9697 91.7725C83.9697 91.7725 84.4888 91.253 86.2336 89.7379C87.9784 88.2228 88.4398 86.0151 90.3577 82.5809C92.2755 79.1467 93.905 76.7658 97.7983 73.2739C97.7983 73.2739 97.1062 75.8856 97.0485 76.7081C96.9908 77.5161 96.3564 82.0614 94.1501 84.6732C91.9439 87.2849 91.8285 87.8765 89.2762 89.4349C89.2762 89.4349 88.2812 90.1275 88.3533 90.3584C88.411 90.5893 90.0981 90.3007 90.0981 90.3007C90.0981 90.3007 91.9583 89.608 92.5351 89.2473C93.1119 88.901 95.7363 87.5591 96.7745 87.155C97.8272 86.751 98.6924 86.347 101.014 85.6399C103.336 84.9473 111.757 82.7973 115.073 77.444C115.073 77.444 114.093 80.5896 112.867 82.0326C111.641 83.4899 104.734 92.6094 95.1451 92.4362C95.1451 92.4362 91.3671 92.1476 89.3916 91.8013C87.416 91.455 86.7239 91.455 86.4355 91.5127C86.1182 91.5993 84.2581 91.9456 83.9697 91.7725Z",
          fill: "#00ABF1"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M105.399 59.169C105.399 59.169 101.794 64.8109 100.986 72.9491C100.179 81.0874 101.563 78.6488 100.236 82.2561C100.236 82.2561 99.775 83.1796 99.948 83.2374C100.121 83.2951 100.813 82.891 103.38 81.3182C105.932 79.7454 108.441 80.2072 113.892 74.9837C119.357 69.7458 120.453 59.3421 120.568 58.4763C120.568 58.4763 119.761 59.2844 119.343 60.6841C118.939 62.0837 118.059 63.1804 117.886 63.3535C117.713 63.5267 111.787 70.0344 111.095 70.626C110.402 71.2032 106.913 75.4454 106.163 76.6719C105.413 77.8984 103.207 80.1061 102.789 79.933C102.789 79.933 102.846 79.4135 103.019 79.0095C103.193 78.6055 104.822 76.3978 105.514 73.8293C106.206 71.2753 106.379 69.7025 106.437 68.072C106.509 66.4414 105.456 60.4532 105.399 59.169Z",
          fill: "#00ABF1"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M110.286 67.0255C110.286 67.0255 109.926 66.1742 110.228 65.5682C110.401 65.2219 110.575 62.4225 109.536 60.1571C108.498 57.8917 106.22 51.6148 106.393 47.4303C106.566 43.2457 107.027 42.6686 107.027 42.6686C107.027 42.6686 108.195 46.1028 108.541 46.68C108.887 47.2571 112.377 53.4185 112.089 56.795C111.8 60.1715 111.627 61.2105 111.8 61.2682C111.973 61.3259 112.377 60.8641 112.435 60.4601C112.492 60.0561 113.069 57.7329 114.179 54.9913C115.29 52.2642 119.76 46.2182 120.741 42.2068C120.741 42.2068 122.197 49.1763 118.304 55.6984C114.41 62.2061 114.006 60.7487 112.377 63.7212C110.748 66.6792 110.517 67.0255 110.286 67.0255Z",
          fill: "#00ABF1"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M113.818 48.5847C113.53 48.527 113.703 45.8575 113.011 44.9773C112.319 44.1116 106.335 37.0123 105.051 29.9274C105.051 29.9274 108.829 33.7656 109.464 34.1696C110.098 34.5737 112.665 37.1277 113.415 39.3498C114.165 41.5575 113.991 43.4189 114.28 43.4767C114.568 43.5344 114.568 41.0381 114.568 41.0381C114.568 41.0381 114.626 36.1609 115.03 33.8233C115.433 31.5002 116.486 27.6042 116.025 25.6274C116.025 25.6274 118.289 29.2348 118.173 34.3428C118.058 39.4653 115.909 43.5344 115.621 44.1116C115.333 44.6887 114.511 47.1995 114.511 47.7189C114.525 48.2384 113.818 48.5847 113.818 48.5847Z",
          fill: "#00ABF1"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M106.738 12.1986C106.738 12.1986 114.583 16.8449 113.357 32.4287C113.357 32.4287 113.357 33.1213 112.896 32.371C112.434 31.6207 110.747 29.4707 109.997 28.9945C109.248 28.5327 102.268 24.2905 99.3122 17.7683C99.3122 17.7683 99.7736 17.6529 100.48 18.2878C101.172 18.9227 103.321 20.0338 103.681 20.2069C104.027 20.3801 106.464 21.015 108.267 22.9918C110.069 24.9687 110.704 26.426 111.223 27.5804C111.223 27.5804 111.742 27.9844 111.396 26.8301C111.05 25.6613 110.992 24.9109 110.055 23.4536C109.132 21.9962 108.31 19.3844 108.195 17.5808C108.079 15.8059 107.546 13.122 106.738 12.1986Z",
          fill: "#00ABF1"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M105.4 17.6716C105.4 17.6716 105.573 16.6183 104.823 15.1753C104.073 13.7179 104.664 12.1018 102.271 8.26359C100.93 6.1136 96.2863 4.42535 96.2863 4.42535C96.2863 4.42535 97.6274 6.28675 98.4926 7.32567C99.3578 8.37903 99.6606 9.12936 99.949 9.64882C100.237 10.1683 101.852 11.7267 102.444 12.6069C102.559 12.78 102.79 13.2418 102.79 13.5304C102.79 13.8189 102.155 13.3572 101.982 13.184C101.809 13.0109 98.9684 10.8609 97.1659 10.5146C95.3635 10.1683 91.9315 9.82198 91.0086 9.3458C91.0086 9.3458 95.0751 13.0109 99.4875 14.1075C103.886 15.2186 105.4 17.6716 105.4 17.6716Z",
          fill: "#00ABF1"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          d: "M96.2263 8.08211C96.2263 8.08211 92.1599 2.55561 84.8923 2.67105C84.8923 2.67105 85.296 3.07507 86.118 3.24823C86.9255 3.42138 88.3819 4.87876 89.1317 5.3405C89.896 5.81668 91.4533 6.97104 96.2263 8.08211Z",
          fill: "#00ABF1"
        }
      )
    ]
  }
), "UNEPLogoSimple"), aw = /* @__PURE__ */ a(({ color: e = "white" }) => /* @__PURE__ */ h.jsxs("svg", { width: "100", height: "73", viewBox: "0 0 100 73", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M78.882 25.2276C74.9264 24.0326 72.0469 20.3593 72.0469 16.0157C72.0469 15.2307 72.1395 14.4678 72.3159 13.7402L78.5645 14.5428C78.5645 14.5428 80.9634 14.6486 80.8752 18.8952C80.7914 23.0139 78.882 25.2276 78.882 25.2276Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M84.4692 25.2276C88.4248 24.0326 91.3043 20.3593 91.3043 16.0157C91.3043 15.2307 91.2117 14.4678 91.0353 13.7402L84.7867 14.5428C84.7867 14.5428 82.3878 14.6486 82.476 18.8952C82.5598 23.0139 84.4692 25.2276 84.4692 25.2276Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M81.673 9.12663C82.4756 9.12663 83.1282 9.77927 83.1282 10.5818C83.1282 11.208 82.6961 11.6755 82.1757 11.9533C82.114 11.9886 82.0522 12.015 82.0655 12.1164C82.0787 12.2179 82.3786 12.2752 82.5065 12.3061L90.907 13.2806C89.7296 9.29861 86.0431 6.39258 81.6774 6.39258H81.6642C77.2985 6.39258 73.6164 9.29861 72.4346 13.2806L80.8352 12.3061C80.963 12.2752 81.2629 12.2223 81.2761 12.1164C81.2894 12.0194 81.2276 11.9886 81.1659 11.9533C80.6455 11.6755 80.2134 11.208 80.2134 10.5818C80.2178 9.77927 80.8704 9.12663 81.673 9.12663Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M85.5144 32.0341L86.0833 31.6769C86.0833 31.6769 83.3845 28.0168 77.3432 28.0168C74.2519 28.0168 72.6512 29.2604 70.486 29.2604C70.486 29.2604 69.5996 29.3662 68.7441 28.8326C68.7441 28.8326 69.776 30.3231 73.5067 30.3231C76.2407 30.3231 78.1987 28.7224 80.1169 28.7224C82.7407 28.7268 84.6942 31.0728 85.5144 32.0341Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M77.1274 32.0341L76.5586 31.6769C76.5586 31.6769 79.2574 28.0168 85.2987 28.0168C88.39 28.0168 89.9907 29.2604 92.1559 29.2604C92.1559 29.2604 93.0422 29.3662 93.8977 28.8326C93.8977 28.8326 92.8659 30.3231 89.1352 30.3231C86.4012 30.3231 84.4432 28.7224 82.525 28.7224C79.9012 28.7268 77.9433 31.0728 77.1274 32.0341Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M74.2473 27.7058C74.1415 27.988 72.9862 27.6529 72.2056 27.8822C71.3325 28.1423 66.7155 28.698 64.6914 23.9046C64.6914 23.9046 66.6097 25.9639 68.1046 26.1094C69.5951 26.2506 71.2311 26.6077 72.6157 27.3883L72.9376 27.4588C72.9376 27.4588 72.8936 27.3177 72.7613 27.2472C72.5805 27.1501 71.1429 26.6827 70.4505 24.4029C70.0934 23.2299 70.1683 22.3788 70.0228 21.7747C70.0228 21.7747 71.5883 23.5165 72.2277 24.619C72.8627 25.717 72.9332 26.9605 74.2473 27.7058Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M69.542 25.2889C69.4273 25.4035 69.1318 25.2183 69.026 25.1654C68.9202 25.1125 68.1529 24.7597 66.8388 24.2967C65.5423 23.8336 63.1258 21.7919 63.3551 18.2906C63.3551 18.2906 63.6946 19.6047 64.6868 20.4778C65.6834 21.3465 66.0362 21.4568 66.6403 22.1667C67.2445 22.8767 68.6115 24.4951 68.6644 24.4775C68.7173 24.4598 68.735 24.3716 68.6291 24.2834C68.5233 24.1952 68.1661 23.3045 67.9368 23.0046C67.7075 22.7047 67.0152 20.6233 68.025 18.0657C68.025 18.0657 69.1098 19.931 69.0392 21.814C68.9687 23.6969 68.8805 23.2515 69.3391 24.817C69.3435 24.8082 69.5949 25.2359 69.542 25.2889Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M66.5215 20.7276C66.4554 20.7938 66.182 20.3881 65.9703 20.0176C65.7586 19.6428 64.2637 18.0465 64.0697 17.7246C63.8757 17.4027 62.2044 15.3786 63.4656 12.3755C63.4656 12.3755 63.589 12.3403 63.589 13.0502C63.589 13.7602 64.2461 15.3433 64.7797 16.018C65.3132 16.6927 65.7939 17.7775 65.8997 18.9328C65.8997 18.9328 65.9703 19.1445 66.0585 19.1621C66.1467 19.1798 66.1467 18.9505 66.1467 18.9505C66.1467 18.9505 66.0761 17.8833 66.0761 17.1557C66.0761 16.4281 66.398 15.1845 67.0904 14.4746C67.0904 14.4746 67.4123 14.1174 67.6063 13.694C67.6063 13.694 67.7298 13.4118 67.9062 13.2663C67.9062 13.2663 68.0473 15.308 67.355 17.2086C66.6626 19.1092 66.4333 19.4311 66.5392 20.4586C66.5392 20.4586 66.5568 20.6879 66.5215 20.7276Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M65.3484 15.1032C65.2779 15.1032 65.2249 14.8563 65.1897 14.6579C65.1544 14.4638 64.9427 13.3261 64.7972 13.0748C64.6561 12.8278 64.1225 11.6901 64.1049 10.3583C64.0872 9.0266 64.6914 7.21419 66.0407 5.77661C66.0407 5.77661 65.9878 6.20436 65.6306 7.14364C65.2735 8.08732 65.4895 8.97368 65.5248 9.13243C65.5601 9.29119 65.6836 10.3936 65.6836 10.9096C65.6836 11.3197 65.5777 12.722 65.4895 13.0042C65.4895 13.0042 65.4543 13.1982 65.5248 13.1982C65.5954 13.1982 65.6659 13.0395 65.6659 13.0395C65.6659 13.0395 65.7365 11.937 66.5523 10.9448C67.3681 9.94824 68.8454 9.3441 69.0747 8.90313C69.0747 8.90313 68.9688 10.4686 67.2446 12.2942C65.71 13.9258 66.1598 13.0924 65.6615 14.4241C65.6615 14.4241 65.4498 14.9224 65.4498 15.0283C65.4543 15.1429 65.3484 15.1032 65.3484 15.1032Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M66.2926 9.84594C66.2926 9.84594 66.2573 9.63427 66.5219 9.15361C66.7865 8.67295 66.5042 7.82187 66.8614 6.57832C67.2186 5.33477 67.8757 3.20485 70.3804 1.92603C70.3804 1.92603 70.1335 2.15533 70.0056 2.33613C69.8821 2.51252 69.2074 3.79135 69.009 4.68212C68.815 5.56848 67.9595 7.06339 67.642 7.39853C67.3201 7.73808 67.4656 7.77336 67.4656 7.77336C67.4656 7.77336 67.6243 7.73808 67.7875 7.49113C67.9462 7.24419 68.7665 6.31814 69.6705 6.10647C70.5745 5.8948 72.0164 5.46706 72.1046 5.37886C72.1046 5.37886 70.5392 6.9796 69.1016 7.79541C67.664 8.61121 67.5009 8.36426 66.6498 9.4667C66.6454 9.45347 66.3631 9.84594 66.2926 9.84594Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M69.7363 5.10105C69.7363 5.10105 69.7363 4.95994 70.0009 4.70858C70.2655 4.46164 70.5345 3.71198 70.9975 3.01964C71.4605 2.32731 72.5057 0.514904 75.2265 0.0871582C75.2265 0.0871582 74.4107 0.691295 74.2828 0.885324C74.1593 1.07935 73.3611 2.12887 73.004 2.48606C72.6468 2.84325 71.6369 3.5885 71.2974 3.74725C71.2974 3.74725 71.121 3.88837 71.1563 3.94128C71.1915 3.9942 71.3679 3.88837 71.3679 3.88837C71.3679 3.88837 72.3116 3.16076 73.4449 3.12548C74.5827 3.0902 75.7733 3.14312 75.9497 3.16076C75.9497 3.16076 74.8825 3.88837 72.3425 4.35139C69.8025 4.81441 70.2831 4.83205 69.8907 5.079C69.8951 5.08341 69.8069 5.15397 69.7363 5.10105Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M74.2646 2.15752C74.2646 2.15752 74.3176 2.01641 74.7277 1.89294C75.1378 1.76947 75.1025 1.377 76.3461 0.719945C77.5896 0.0628915 78.8861 -0.241381 80.2002 0.309838C80.2002 0.309838 79.649 0.380394 79.5608 0.415672C79.4726 0.45095 78.5289 0.697896 78.2643 0.843418C77.9997 0.98453 76.6283 1.58867 76.0771 1.6945C75.5258 1.80033 75.7948 1.83561 75.7948 1.83561C75.7948 1.83561 75.9183 1.88853 76.0241 1.88853C76.13 1.88853 77.3559 1.76506 78.154 2.04728C78.9522 2.3295 78.9346 2.43975 79.2565 2.54558C79.5784 2.65142 79.9488 2.72197 80.0017 2.84545C80.0017 2.84545 79.2036 2.916 78.7229 2.916C78.2422 2.916 76.9811 2.79253 76.3769 2.5059C75.7728 2.22367 75.0805 2.09579 74.8511 2.14871C74.6218 2.21044 74.3396 2.21044 74.2646 2.15752Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M79.3145 1.53876C79.3145 1.53876 79.3674 1.46821 79.7246 1.39765C80.0817 1.32709 80.1699 1.11543 81.0034 0.934626C81.8368 0.753826 83.1333 0.595075 84.3239 1.41529C84.3239 1.41529 83.5963 1.39765 83.4376 1.39765C83.2788 1.39765 81.8942 1.6446 81.5722 1.6446C81.2503 1.6446 80.6109 1.50348 80.5227 1.60932C80.4345 1.71515 81.1092 1.85626 81.2151 1.89154C81.3209 1.92682 81.8016 1.9621 82.4057 2.5486C83.0098 3.13509 83.4376 3.4526 83.5081 3.49228C83.5081 3.49228 81.731 3.08218 81.2856 2.83523C80.8402 2.58828 80.0773 1.82099 79.9539 1.76807C79.826 1.71515 79.3145 1.53876 79.3145 1.53876Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M83.4155 2.26565C83.4155 2.26565 84.5356 2.23037 85.3514 2.74631C86.1672 3.26225 86.8243 3.93694 86.8948 4.34705C86.8948 4.34705 86.4318 3.95458 86.1319 3.86639C85.8277 3.77819 84.9766 3.29753 84.8002 3.1917C84.6238 3.08586 83.5919 2.4244 83.4155 2.26565Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M88.6758 27.8938C88.6758 27.8938 88.8345 27.735 89.3681 27.272C89.9017 26.809 90.0428 26.1343 90.6293 25.0848C91.2158 24.0352 91.7141 23.3076 92.9047 22.2405C92.9047 22.2405 92.6931 23.0386 92.6754 23.29C92.6578 23.5369 92.4638 24.926 91.7891 25.7242C91.1144 26.5223 91.0791 26.7031 90.2986 27.1794C90.2986 27.1794 89.9943 27.3911 90.0164 27.4616C90.034 27.5322 90.5499 27.444 90.5499 27.444C90.5499 27.444 91.1188 27.2323 91.2952 27.1221C91.4716 27.0162 92.2741 26.6061 92.5916 26.4827C92.9136 26.3592 93.1781 26.2357 93.8881 26.0196C94.5981 25.808 97.1734 25.1509 98.1876 23.5149C98.1876 23.5149 97.8878 24.4762 97.5129 24.9172C97.1381 25.3626 95.0258 28.1495 92.0933 28.0966C92.0933 28.0966 90.938 28.0084 90.3339 27.9026C89.7297 27.7968 89.518 27.7968 89.4299 27.8144C89.3328 27.8409 88.764 27.9467 88.6758 27.8938Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M95.2291 17.9297C95.2291 17.9297 94.1266 19.6539 93.8797 22.141C93.6327 24.6281 94.0561 23.8829 93.6504 24.9853C93.6504 24.9853 93.5092 25.2675 93.5622 25.2852C93.6151 25.3028 93.8268 25.1793 94.6117 24.6987C95.3922 24.218 96.1595 24.3591 97.8264 22.7628C99.4977 21.162 99.8328 17.9826 99.8681 17.718C99.8681 17.718 99.6212 17.965 99.4933 18.3927C99.3698 18.8205 99.1008 19.1556 99.0479 19.2085C98.995 19.2614 97.1826 21.2502 96.9709 21.431C96.7592 21.6074 95.6921 22.9039 95.4628 23.2787C95.2335 23.6535 94.5588 24.3282 94.4309 24.2753C94.4309 24.2753 94.4485 24.1166 94.5014 23.9931C94.5544 23.8696 95.0527 23.1949 95.2643 22.41C95.476 21.6295 95.5289 21.1488 95.5466 20.6505C95.5686 20.1522 95.2467 18.3222 95.2291 17.9297Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M96.7238 20.3311C96.7238 20.3311 96.6135 20.0709 96.7061 19.8857C96.759 19.7799 96.812 18.9244 96.4945 18.2321C96.177 17.5397 95.4802 15.6215 95.5331 14.3427C95.586 13.0638 95.7272 12.8874 95.7272 12.8874C95.7272 12.8874 96.0843 13.937 96.1902 14.1134C96.296 14.2898 97.3632 16.1727 97.275 17.2046C97.1868 18.2365 97.1339 18.554 97.1868 18.5716C97.2397 18.5893 97.3632 18.4481 97.3808 18.3247C97.3985 18.2012 97.5748 17.4912 97.9144 16.6534C98.2539 15.8199 99.621 13.9722 99.9208 12.7463C99.9208 12.7463 100.366 14.8762 99.1756 16.8695C97.9849 18.8583 97.8615 18.4129 97.3632 19.3213C96.8649 20.2253 96.7943 20.3311 96.7238 20.3311Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M97.8037 14.6951C97.7155 14.6775 97.7684 13.8617 97.5567 13.5927C97.3451 13.3281 95.515 11.1585 95.1226 8.99331C95.1226 8.99331 96.2779 10.1663 96.4719 10.2898C96.666 10.4132 97.4509 11.1938 97.6802 11.8729C97.9095 12.5476 97.8566 13.1164 97.9448 13.1341C98.033 13.1517 98.033 12.3888 98.033 12.3888C98.033 12.3888 98.0506 10.8983 98.1741 10.1839C98.2976 9.47397 98.6195 8.28334 98.4784 7.6792C98.4784 7.6792 99.1707 8.78164 99.1354 10.3427C99.1002 11.9082 98.4431 13.1517 98.3549 13.3281C98.2667 13.5045 98.0154 14.2718 98.0154 14.4305C98.0198 14.5893 97.8037 14.6951 97.8037 14.6951Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M95.6387 3.57544C95.6387 3.57544 98.0376 4.99538 97.6628 9.75791C97.6628 9.75791 97.6628 9.96958 97.5217 9.74028C97.3806 9.51097 96.8646 8.85392 96.6353 8.70839C96.406 8.56728 94.2717 7.27081 93.3677 5.2776C93.3677 5.2776 93.5088 5.24233 93.7249 5.43636C93.9365 5.63038 94.5936 5.96994 94.7038 6.02285C94.8097 6.07577 95.5549 6.2698 96.1061 6.87394C96.6574 7.47807 96.8514 7.92346 97.0101 8.27624C97.0101 8.27624 97.1689 8.39971 97.0631 8.04693C96.9572 7.68974 96.9396 7.46043 96.6529 7.01505C96.3707 6.56966 96.1194 5.7715 96.0841 5.22028C96.0488 4.67788 95.8856 3.85766 95.6387 3.57544Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M95.2295 5.24786C95.2295 5.24786 95.2825 4.92595 95.0532 4.48497C94.8239 4.03959 95.0046 3.5457 94.2726 2.3727C93.8625 1.71565 92.4426 1.19971 92.4426 1.19971C92.4426 1.19971 92.8527 1.76857 93.1173 2.08607C93.3819 2.40798 93.4745 2.63729 93.5627 2.79604C93.6509 2.95479 94.1447 3.43104 94.3255 3.70004C94.3608 3.75295 94.4314 3.89407 94.4314 3.98226C94.4314 4.07046 94.2374 3.92934 94.1844 3.87643C94.1315 3.82351 93.2628 3.16646 92.7116 3.06062C92.1604 2.95479 91.1108 2.84896 90.8286 2.70343C90.8286 2.70343 92.0722 3.82351 93.4216 4.15865C94.7665 4.4982 95.2295 5.24786 95.2295 5.24786Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M92.4241 2.31753C92.4241 2.31753 91.1805 0.628597 88.958 0.663875C88.958 0.663875 89.0815 0.787348 89.3328 0.840265C89.5798 0.893182 90.0252 1.33857 90.2545 1.47968C90.4882 1.6252 90.9644 1.97798 92.4241 2.31753Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M24.236 0V20.8714C24.236 22.697 23.9317 24.3066 23.3232 25.7045C22.7146 27.1023 21.8768 28.2709 20.8052 29.2102C19.7337 30.1495 18.4548 30.8595 16.9731 31.3401C15.4871 31.8164 13.8731 32.0589 12.118 32.0589C10.3497 32.0589 8.7269 31.8208 7.24082 31.3401C5.75473 30.8639 4.48031 30.1539 3.40874 29.2102C2.33717 28.2709 1.49932 27.0979 0.89959 25.7045C0.299863 24.3066 0 22.697 0 20.8714V0H6.51762V20.8714C6.51762 22.944 7.01151 24.4521 8.0037 25.4002C8.9959 26.3483 10.3673 26.8245 12.118 26.8245C13.8863 26.8245 15.2578 26.3527 16.2323 25.4002C17.2113 24.4521 17.6963 22.944 17.6963 20.8714V0H24.236Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M55.2943 31.6223H48.7811L36.0987 10.8171V31.6223H29.5811V0H36.0943L48.7988 20.8493V0H55.2943V31.6223Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M4.70104 52.0451C3.33402 52.0451 2.21835 51.6173 1.35845 50.7618C0.498547 49.9063 0.0708008 48.7642 0.0708008 47.3398V47.0929C0.0708008 46.136 0.251601 45.2849 0.6132 44.5308C0.9748 43.7768 1.48633 43.1947 2.1522 42.789C2.81367 42.3833 3.57215 42.176 4.42323 42.176C5.69765 42.176 6.70307 42.5861 7.43509 43.4063C8.16711 44.2266 8.53312 45.3907 8.53312 46.8989V47.9352H2.59759C2.67697 48.5569 2.9195 49.0552 3.3252 49.4301C3.7309 49.8049 4.24243 49.9945 4.8642 49.9945C5.82553 49.9945 6.57519 49.6417 7.11318 48.9318L8.33468 50.3297C7.95985 50.8676 7.45714 51.291 6.81772 51.5908C6.18272 51.8951 5.47716 52.0451 4.70104 52.0451ZM4.41882 44.2266C3.92493 44.2266 3.52364 44.3985 3.21496 44.7381C2.90627 45.0821 2.71224 45.5671 2.62405 46.2065H6.09011V46.0037C6.07689 45.4392 5.92695 45.0027 5.64032 44.694C5.35369 44.3809 4.94799 44.2266 4.41882 44.2266Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M12.3518 42.3524L12.4312 43.4504C13.0971 42.5994 13.9923 42.176 15.1124 42.176C16.1001 42.176 16.8366 42.4715 17.3172 43.0624C17.7979 43.6533 18.0493 44.5397 18.0581 45.7171V51.8643H15.5666V45.7788C15.5666 45.2408 15.4519 44.8483 15.2226 44.6058C14.9933 44.3633 14.6096 44.2398 14.0761 44.2398C13.3749 44.2398 12.8502 44.5441 12.4974 45.1526V51.8643H10.0059V42.3524H12.3518Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M23.5438 48.7614L25.2768 42.3496H27.8786L24.73 51.8659H22.3532L19.2046 42.3496H21.8063L23.5438 48.7614Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M29.0649 39.8913C29.0649 39.512 29.1884 39.1945 29.4398 38.9476C29.6911 38.7006 30.0307 38.5771 30.4628 38.5771C30.8862 38.5771 31.2257 38.7006 31.4815 38.9476C31.7328 39.1945 31.8607 39.5076 31.8607 39.8913C31.8607 40.2793 31.7328 40.5924 31.4771 40.8394C31.2213 41.0863 30.8818 41.2098 30.4628 41.2098C30.0439 41.2098 29.7044 41.0863 29.4486 40.8394C29.1928 40.5968 29.0649 40.2793 29.0649 39.8913ZM31.7108 51.8681H29.2105V42.3563H31.7108V51.8681Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M39.1099 44.7337C38.7703 44.6852 38.4705 44.6631 38.2147 44.6631C37.271 44.6631 36.6536 44.9894 36.3626 45.6377V51.8643H33.8711V42.3524H36.2259L36.2965 43.4857C36.7948 42.6126 37.4871 42.176 38.3735 42.176C38.6513 42.176 38.907 42.2157 39.1496 42.2907L39.1099 44.7337Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M39.7192 47.0223C39.7192 46.0787 39.8956 45.2364 40.2528 44.5C40.61 43.7591 41.1215 43.1903 41.7918 42.7846C42.4621 42.3789 43.2382 42.176 44.1246 42.176C45.3814 42.176 46.4088 42.5685 47.207 43.3534C48.0052 44.1384 48.4461 45.2055 48.5387 46.5549L48.5564 47.2076C48.5564 48.6672 48.1551 49.8402 47.3569 50.7221C46.5588 51.6041 45.4872 52.0451 44.1422 52.0451C42.7972 52.0451 41.7257 51.6041 40.9231 50.7265C40.1205 49.849 39.7192 48.6495 39.7192 47.137V47.0223ZM42.2108 47.1987C42.2108 48.1027 42.3783 48.7951 42.7091 49.2713C43.0442 49.752 43.5204 49.9901 44.1422 49.9901C44.7464 49.9901 45.2182 49.752 45.5578 49.2801C45.8973 48.8083 46.0649 48.0498 46.0649 47.0135C46.0649 46.1272 45.8973 45.4392 45.5578 44.9542C45.2182 44.4691 44.7419 44.2222 44.1246 44.2222C43.516 44.2222 43.0442 44.4647 42.7091 44.9498C42.3783 45.4348 42.2108 46.1845 42.2108 47.1987Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M52.49 42.3524L52.5694 43.4504C53.2353 42.5994 54.1305 42.176 55.2505 42.176C56.2383 42.176 56.9747 42.4715 57.4554 43.0624C57.9361 43.6533 58.1874 44.5397 58.1963 45.7171V51.8643H55.7047V45.7788C55.7047 45.2408 55.5901 44.8483 55.3608 44.6058C55.1315 44.3633 54.7478 44.2398 54.2142 44.2398C53.5131 44.2398 52.9883 44.5441 52.6356 45.1526V51.8643H50.144V42.3524H52.49Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M62.5261 42.3524L62.6055 43.4152C63.267 42.5861 64.1621 42.176 65.2866 42.176C66.4861 42.176 67.3107 42.6611 67.7605 43.6268C68.4131 42.6611 69.348 42.176 70.5607 42.176C71.5705 42.176 72.3246 42.4759 72.8185 43.0756C73.3124 43.6753 73.5593 44.5793 73.5593 45.7876V51.8643H71.059V45.7964C71.059 45.2584 70.9576 44.8616 70.7503 44.6146C70.5431 44.3633 70.177 44.2398 69.6567 44.2398C68.9114 44.2398 68.3911 44.6014 68.1045 45.329L68.1133 51.8643H65.6218V45.8053C65.6218 45.254 65.5159 44.8572 65.3043 44.6102C65.0926 44.3633 64.731 44.2398 64.2195 44.2398C63.5139 44.2398 63.0024 44.5397 62.6849 45.135V51.8643H60.1934V42.3524H62.5261Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M79.8739 52.0451C78.5069 52.0451 77.3912 51.6173 76.5313 50.7618C75.6714 49.9063 75.2437 48.7642 75.2437 47.3398V47.0929C75.2437 46.136 75.4245 45.2849 75.7861 44.5308C76.1477 43.7768 76.6592 43.1947 77.3251 42.789C77.9865 42.3833 78.745 42.176 79.5961 42.176C80.8705 42.176 81.8759 42.5861 82.6079 43.4063C83.34 44.2266 83.706 45.3907 83.706 46.8989V47.9352H77.766C77.8454 48.5569 78.0879 49.0552 78.4936 49.4301C78.8993 49.8049 79.4109 49.9945 80.0326 49.9945C80.994 49.9945 81.7436 49.6417 82.2816 48.9318L83.5031 50.3297C83.1283 50.8676 82.6256 51.291 81.9862 51.5908C81.36 51.8951 80.65 52.0451 79.8739 52.0451ZM79.5917 44.2266C79.0978 44.2266 78.6965 44.3985 78.3878 44.7381C78.0791 45.0821 77.8851 45.5671 77.7969 46.2065H81.263V46.0037C81.2497 45.4392 81.0998 45.0027 80.8132 44.694C80.5265 44.3809 80.1208 44.2266 79.5917 44.2266Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M87.5252 42.3524L87.6046 43.4504C88.2704 42.5994 89.1656 42.176 90.2857 42.176C91.2735 42.176 92.0099 42.4715 92.4906 43.0624C92.9712 43.6533 93.2226 44.5397 93.2314 45.7171V51.8643H90.7399V45.7788C90.7399 45.2408 90.6252 44.8483 90.3959 44.6058C90.1666 44.3633 89.783 44.2398 89.2494 44.2398C88.5482 44.2398 88.0235 44.5441 87.6707 45.1526V51.8643H85.1792V42.3524H87.5252Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M98.2101 40.0134V42.355H99.8064V44.2203H98.2101V48.9696C98.2101 49.3224 98.2762 49.5738 98.4085 49.7237C98.5408 49.878 98.7922 49.953 99.167 49.953C99.4404 49.953 99.6873 49.931 99.899 49.8913V51.8183C99.4095 51.9727 98.9068 52.0476 98.3909 52.0476C96.6446 52.0476 95.7538 51.1481 95.7186 49.3489V44.2203H94.356V42.355H95.7186V40.0134H98.2101Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M8.80633 64.3203C8.80633 65.7843 8.48001 66.9617 7.82736 67.8437C7.17472 68.7256 6.29277 69.1666 5.18592 69.1666C4.24223 69.1666 3.47935 68.8315 2.90167 68.1656V72.6503H0.410156V59.4784H2.72087L2.80906 60.4089C3.4132 59.668 4.19814 59.302 5.17269 59.302C6.32364 59.302 7.21441 59.7386 7.85382 60.6029C8.49324 61.4716 8.81074 62.6666 8.81074 64.1924V64.3203H8.80633ZM6.31482 64.1351C6.31482 63.2487 6.16048 62.5652 5.85179 62.0846C5.54311 61.6039 5.09772 61.3614 4.51123 61.3614C3.7307 61.3614 3.19271 61.6656 2.89726 62.2742V66.1724C3.20153 66.7986 3.74393 67.1117 4.52446 67.1117C5.7195 67.1161 6.31482 66.1195 6.31482 64.1351Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M15.6987 61.8563C15.3592 61.8077 15.0593 61.7857 14.8036 61.7857C13.8599 61.7857 13.2425 62.112 12.9515 62.7603V68.9868H10.46V59.4706H12.8148L12.8853 60.6039C13.3836 59.7307 14.076 59.2942 14.9623 59.2942C15.2401 59.2942 15.4959 59.3339 15.7384 59.4088L15.6987 61.8563Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M16.3032 64.1483C16.3032 63.2046 16.4796 62.3624 16.8368 61.6259C17.194 60.8851 17.7055 60.3162 18.3758 59.9106C19.0461 59.5049 19.8222 59.302 20.7086 59.302C21.9653 59.302 22.9928 59.6945 23.791 60.4794C24.5892 61.2643 25.0301 62.3315 25.1227 63.6809L25.1404 64.3335C25.1404 65.7932 24.7391 66.9662 23.9409 67.8481C23.1428 68.7301 22.0712 69.171 20.7262 69.171C19.3812 69.171 18.3097 68.7301 17.5071 67.8525C16.7045 66.975 16.3032 65.7755 16.3032 64.263V64.1483ZM18.7947 64.3291C18.7947 65.2331 18.9623 65.9255 19.293 66.4017C19.6282 66.8824 20.1044 67.1205 20.7262 67.1205C21.3303 67.1205 21.8022 66.8824 22.1417 66.4105C22.4813 65.9387 22.6489 65.1802 22.6489 64.1439C22.6489 63.2575 22.4813 62.5696 22.1417 62.0846C21.8022 61.5995 21.3259 61.3525 20.7086 61.3525C20.1 61.3525 19.6282 61.5951 19.293 62.0801C18.9623 62.5608 18.7947 63.3105 18.7947 64.3291Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M26.419 64.166C26.419 62.7063 26.7585 61.5289 27.4376 60.6382C28.1211 59.7474 29.0384 59.302 30.1937 59.302C31.2168 59.302 32.0105 59.6592 32.5838 60.3736L32.6852 59.4784H34.943V68.6771C34.943 69.5106 34.7578 70.2338 34.3874 70.8511C34.017 71.4685 33.4966 71.9359 32.8219 72.2579C32.1472 72.5798 31.3623 72.7429 30.4583 72.7429C29.7748 72.7429 29.1089 72.6018 28.4563 72.324C27.808 72.0462 27.3142 71.6846 26.9834 71.248L28.0859 69.7002C28.7076 70.4102 29.4573 70.763 30.3437 70.763C31.0051 70.763 31.5211 70.5822 31.8871 70.2206C32.2531 69.859 32.4383 69.3474 32.4383 68.686V68.1744C31.865 68.8359 31.1065 69.1666 30.1717 69.1666C29.0516 69.1666 28.1432 68.7212 27.4509 67.8261C26.7585 66.9309 26.4102 65.7446 26.4102 64.2674V64.166H26.419ZM28.9105 64.3556C28.9105 65.2199 29.0781 65.8946 29.4176 66.3841C29.7572 66.8735 30.2202 67.1205 30.8155 67.1205C31.574 67.1205 32.1164 66.8295 32.4427 66.2474V62.2389C32.1076 61.6568 31.574 61.3658 30.8287 61.3658C30.2334 61.3658 29.7616 61.6171 29.4176 62.1154C29.0825 62.6137 28.9105 63.3634 28.9105 64.3556Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M42.2056 61.8563C41.866 61.8077 41.5662 61.7857 41.3104 61.7857C40.3667 61.7857 39.7494 62.112 39.4583 62.7603V68.9868H36.9668V59.4706H39.3216L39.3922 60.6039C39.8905 59.7307 40.5828 59.2942 41.4692 59.2942C41.747 59.2942 42.0027 59.3339 42.2453 59.4088L42.2056 61.8563Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M48.6567 68.9946C48.542 68.7653 48.4582 68.4831 48.4053 68.1436C47.8012 68.8315 47.0162 69.171 46.0505 69.171C45.1377 69.171 44.3792 68.902 43.7795 68.364C43.1797 67.8261 42.8799 67.1425 42.8799 66.3223C42.8799 65.3125 43.2459 64.5408 43.9779 64.0028C44.7099 63.4648 45.7683 63.1914 47.1529 63.1826H48.2995V62.6358C48.2995 62.1948 48.1892 61.842 47.9687 61.5818C47.7483 61.3173 47.3999 61.185 46.9192 61.185C46.5003 61.185 46.1696 61.2864 45.9314 61.4937C45.6933 61.6965 45.5742 61.9787 45.5742 62.3359H43.0827C43.0827 61.7847 43.2503 61.2732 43.581 60.8057C43.9162 60.3339 44.388 59.9679 44.9966 59.7033C45.6051 59.4343 46.2886 59.302 47.0471 59.302C48.198 59.302 49.1109 59.5975 49.7856 60.1884C50.4603 60.7793 50.7998 61.6039 50.7998 62.6711V66.7942C50.8042 67.6982 50.9277 68.3817 51.1702 68.8447V68.9946H48.6567ZM46.5973 67.2263C46.9633 67.2263 47.3029 67.1425 47.616 66.975C47.9246 66.8074 48.154 66.5825 48.3039 66.3003V64.6643H47.3734C46.1255 64.6643 45.464 65.1052 45.3802 65.9828L45.3714 66.1327C45.3714 66.4502 45.4816 66.7104 45.6977 66.9132C45.9182 67.1249 46.2181 67.2263 46.5973 67.2263Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M55.1619 59.4784L55.2412 60.5411C55.9027 59.7121 56.7979 59.302 57.9224 59.302C59.1218 59.302 59.9464 59.7871 60.3962 60.7528C61.0489 59.7871 61.9837 59.302 63.1964 59.302C64.2063 59.302 64.9603 59.6019 65.4542 60.2016C65.9481 60.8013 66.1951 61.7053 66.1951 62.9136V68.9902H63.6947V62.9224C63.6947 62.3844 63.5933 61.9875 63.3861 61.7406C63.1788 61.4892 62.8128 61.3658 62.2924 61.3658C61.5472 61.3658 61.0268 61.7274 60.7402 62.455L60.749 68.9902H58.2575V62.9312C58.2575 62.38 58.1517 61.9831 57.94 61.7362C57.7283 61.4892 57.3667 61.3658 56.8552 61.3658C56.1496 61.3658 55.6381 61.6656 55.3206 62.2609V68.9902H52.8291V59.474H55.1619V59.4784Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M70.5515 59.4784L70.6309 60.5411C71.2923 59.7121 72.1875 59.302 73.312 59.302C74.5115 59.302 75.3361 59.7871 75.7859 60.7528C76.4385 59.7871 77.3734 59.302 78.5861 59.302C79.5959 59.302 80.35 59.6019 80.8439 60.2016C81.3378 60.8013 81.5847 61.7053 81.5847 62.9136V68.9902H79.0844V62.9224C79.0844 62.3844 78.983 61.9875 78.7757 61.7406C78.5684 61.4892 78.2024 61.3658 77.6821 61.3658C76.9368 61.3658 76.4165 61.7274 76.1299 62.455L76.1387 68.9902H73.6472V62.9312C73.6472 62.38 73.5413 61.9831 73.3297 61.7362C73.118 61.4892 72.7564 61.3658 72.2449 61.3658C71.5393 61.3658 71.0278 61.6656 70.7103 62.2609V68.9902H68.2188V59.474H70.5515V59.4784Z",
      fill: e
    }
  ),
  /* @__PURE__ */ h.jsx(
    "path",
    {
      d: "M87.8998 69.1632C86.5327 69.1632 85.4171 68.7355 84.5572 67.88C83.6973 67.0245 83.2695 65.8824 83.2695 64.458V64.2111C83.2695 63.2541 83.4503 62.4031 83.8119 61.649C84.1735 60.8949 84.6851 60.3128 85.3509 59.9071C86.0124 59.5014 86.7709 59.2942 87.622 59.2942C88.8964 59.2942 89.9018 59.7043 90.6338 60.5245C91.3658 61.3447 91.7319 62.5089 91.7319 64.017V65.0533H85.7919C85.8713 65.6751 86.1138 66.1734 86.5195 66.5482C86.9252 66.9231 87.4367 67.1127 88.0585 67.1127C89.0199 67.1127 89.7695 66.7599 90.3075 66.0499L91.529 67.4478C91.1542 67.9858 90.6515 68.4091 90.012 68.709C89.3859 69.0133 88.6759 69.1632 87.8998 69.1632ZM87.6175 61.3491C87.1237 61.3491 86.7224 61.5211 86.4137 61.8607C86.105 62.2046 85.911 62.6897 85.8228 63.3291H89.2888V63.1263C89.2756 62.5618 89.1257 62.1252 88.8391 61.8166C88.5524 61.5035 88.1467 61.3491 87.6175 61.3491Z",
      fill: e
    }
  )
] }), "UNEPLogoSmall"), lw = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "16", height: "16", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M26.37,26l-8.795-12.822l0.015,0.012L25.52,4h-2.65l-6.46,7.48L11.28,4H4.33l8.211,11.971L12.54,15.97L3.88,26h2.65 l7.182-8.322L19.42,26H26.37z M10.23,6l12.34,18h-2.1L8.12,6H10.23z",
    fill: "currentColor"
  }
) }), "XIcon"), cw = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { width: "16", height: "16", viewBox: "0 0 34 34", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M12.932 20.459v-8.917l7.839 4.459zM30.368 8.735c-0.354-1.301-1.354-2.307-2.625-2.663l-0.027-0.006c-3.193-0.406-6.886-0.638-10.634-0.638-0.381 0-0.761 0.002-1.14 0.007l0.058-0.001c-0.322-0.004-0.701-0.007-1.082-0.007-3.748 0-7.443 0.232-11.070 0.681l0.434-0.044c-1.297 0.363-2.297 1.368-2.644 2.643l-0.006 0.026c-0.4 2.109-0.628 4.536-0.628 7.016 0 0.088 0 0.176 0.001 0.263l-0-0.014c-0 0.074-0.001 0.162-0.001 0.25 0 2.48 0.229 4.906 0.666 7.259l-0.038-0.244c0.354 1.301 1.354 2.307 2.625 2.663l0.027 0.006c3.193 0.406 6.886 0.638 10.634 0.638 0.38 0 0.76-0.002 1.14-0.007l-0.058 0.001c0.322 0.004 0.702 0.007 1.082 0.007 3.749 0 7.443-0.232 11.070-0.681l-0.434 0.044c1.298-0.362 2.298-1.368 2.646-2.643l0.006-0.026c0.399-2.109 0.627-4.536 0.627-7.015 0-0.088-0-0.176-0.001-0.263l0 0.013c0-0.074 0.001-0.162 0.001-0.25 0-2.48-0.229-4.906-0.666-7.259l0.038 0.244z",
    fill: "currentColor"
  }
) }), "YoutubeIcon"), YT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { "aria-hidden": "true", fill: "currentColor", viewBox: "0 0 24 24", children: /* @__PURE__ */ h.jsx("path", { d: "M7 9H2V7h5v2Zm0 3H2v2h5v-2Zm13.59 7-3.83-3.83A4.96 4.96 0 0 1 14 16a5 5 0 1 1 4.17-2.25L22 17.59 20.59 19ZM14 8a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM2 19h10v-2H2v2Z" }) }), "ManageSearchIcon"), qT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-hidden": "true",
    children: /* @__PURE__ */ h.jsx(
      "path",
      {
        d: "M6,13c0-1.65,0.67-3.15,1.76-4.24L6.34,7.34C4.9,8.79,4,10.79,4,13c0,4.08,3.05,7.44,7,7.93v-2.02 C8.17,18.43,6,15.97,6,13z M20,13c0-4.42-3.58-8-8-8c-0.06,0-0.12,0.01-0.18,0.01l1.09-1.09L11.5,2.5L8,6l3.5,3.5l1.41-1.41 l-1.08-1.08C11.89,7.01,11.95,7,12,7c3.31,0,6,2.69,6,6c0,2.97-2.17,5.43-5,5.91v2.02C16.95,20.44,20,17.08,20,13z",
        fill: "currentColor"
      }
    )
  }
), "ResetAltIcon"), KT = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx("svg", { "aria-hidden": "true", height: "24", viewBox: "0 0 24 24", width: "24", children: /* @__PURE__ */ h.jsx("path", { d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z", fill: "currentColor" }) }), "WarningIcon"), dw = Q(ge)`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  align-items: start;
  width: 100%;
`, uw = Q(ge)`
  width: 100%;
  display: flex;
  gap: 23px;
  padding: 8px 0;
  overflow-x: auto;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
  scroll-padding: 0 16px;
  scrollbar-width: none;
  justify-content: flex-start;

  @media (min-width: ${({ theme: e }) => e.breakpoints.xl}px) {
    justify-content: center;
    gap: 32px;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`, pw = Q(ge)`
  min-width: 210px;
  width: 210px;
  flex-shrink: 0;
  scroll-snap-align: start;
`, fw = Q(ge)`
  display: flex;
  gap: 10px;
`, S6 = Q(po)`
  &.MuiIconButton-root {
    color: ${({ theme: e }) => e.palette.primary.mediumBlue};
    padding: 0;

    &.Mui-disabled {
      color: ${({ theme: e }) => e.palette.primary.lightGrey5};
      opacity: 0.5;
    }
  }
`, XT = /* @__PURE__ */ a(({ children: e }) => {
  const t = Vi(null), n = H6(), [o, r] = ln(window.innerWidth), [i, l] = ln(!1), [c, d] = ln(!0);
  Cn(() => {
    const b = /* @__PURE__ */ a(() => r(window.innerWidth), "handleResize");
    return window.addEventListener("resize", b), () => window.removeEventListener("resize", b);
  }, []);
  const u = o < n.breakpoints.xl, p = /* @__PURE__ */ a(() => {
    const b = t.current;
    if (!b) return;
    const { scrollLeft: C, scrollWidth: g, clientWidth: y } = b;
    l(C > 5), d(C < g - y - 5);
  }, "updateScrollButtons");
  Cn(() => {
    const b = t.current;
    if (!(!b || !u))
      return p(), b.addEventListener("scroll", p), () => b.removeEventListener("scroll", p);
  }, [u]), Cn(() => {
    if (u) {
      const b = setTimeout(p, 100);
      return () => clearTimeout(b);
    }
  }, [u, o]);
  const f = /* @__PURE__ */ a((b) => {
    const C = t.current;
    if (!C) return;
    const w = (210 + 23) * (b === "left" ? -1 : 1);
    C.scrollBy({
      left: w,
      behavior: "smooth"
    });
  }, "scroll"), m = Array.isArray(e) ? e : [e];
  return /* @__PURE__ */ h.jsxs(dw, { children: [
    /* @__PURE__ */ h.jsx(uw, { ref: t, children: m.map((b, C) => /* @__PURE__ */ h.jsx(pw, { children: b }, C)) }),
    u && /* @__PURE__ */ h.jsxs(fw, { children: [
      /* @__PURE__ */ h.jsx(S6, { onClick: /* @__PURE__ */ a(() => f("left"), "onClick"), disabled: !i, children: /* @__PURE__ */ h.jsx(Zv, {}) }),
      /* @__PURE__ */ h.jsx(S6, { onClick: /* @__PURE__ */ a(() => f("right"), "onClick"), disabled: !c, children: /* @__PURE__ */ h.jsx(Uv, {}) })
    ] })
  ] });
}, "Carousel"), hw = Q(ar).withConfig({
  shouldForwardProp: /* @__PURE__ */ a((e) => e !== "component", "shouldForwardProp")
})`
  & .MuiFormLabel-root {
    color: ${({ theme: e }) => e.palette.primary.white};
    font-weight: ${({ theme: e }) => e.fontWeights.bold};
    font-size: ${({ theme: e }) => e.fontSizes.headings.h5};

    &.Mui-focused {
      color: ${({ theme: e }) => e.palette.primary.white};
    }
  }
`, gw = Q(Vc)`
  margin-top: 8px;
  gap: 10px; /* Space between checkboxes */
  padding-left: 4px; /* Add left padding to prevent overlap */
`, mw = Q(Lc)`
  margin-left: 0;

  & .MuiFormControlLabel-label {
    font-size: ${({ theme: e }) => e.fontSizes.body.l};
    color: ${({ theme: e }) => e.palette.primary.white};
  }

  & .MuiCheckbox-root {
    color: ${({ theme: e }) => e.palette.primary.primaryBlue};
    padding: 5px 8px;

    &.Mui-checked {
      color: ${({ theme: e }) => e.palette.primary.primaryBlue};
    }

    &:hover {
      background-color: rgba(25, 118, 210, 0.04);
    }

    &.Mui-disabled {
      color: ${({ theme: e }) => e.palette.primary.darkGrey4};
    }
  }
`, bw = Q(po)`
  & svg {
    color: ${({ theme: e }) => e.palette.primary.white} !important;
    fill: ${({ theme: e }) => e.palette.primary.white} !important;
  }
`, JT = /* @__PURE__ */ a(({
  options: e,
  selectedValues: t,
  onChange: n,
  label: o,
  defaultExpanded: r = !0
}) => {
  const [i, l] = ln(r), c = /* @__PURE__ */ a((d, u) => {
    n(u ? [...t, d] : t.filter((p) => p !== d));
  }, "handleChange");
  return /* @__PURE__ */ h.jsxs(hw, { component: "fieldset", fullWidth: !0, children: [
    o && /* @__PURE__ */ h.jsxs(
      ge,
      {
        sx: {
          display: "flex",
          alignItems: "center",
          cursor: "pointer"
        },
        onClick: /* @__PURE__ */ a(() => l(!i), "onClick"),
        children: [
          /* @__PURE__ */ h.jsx(_n, { component: "legend", sx: { flexGrow: 1 }, children: o }),
          /* @__PURE__ */ h.jsx(
            bw,
            {
              size: "small",
              sx: {
                transform: i ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.2s"
              },
              children: /* @__PURE__ */ h.jsx(i2, {})
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ h.jsx(da, { in: i, children: /* @__PURE__ */ h.jsx(gw, { children: e == null ? void 0 : e.map((d) => /* @__PURE__ */ h.jsx(
      mw,
      {
        control: /* @__PURE__ */ h.jsx(
          Ca,
          {
            icon: /* @__PURE__ */ h.jsx(K1, {}),
            checkedIcon: /* @__PURE__ */ h.jsx(q1, {}),
            checked: t.includes(d.value),
            onChange: /* @__PURE__ */ a((u) => c(d.value, u.target.checked), "onChange")
          }
        ),
        label: d.label
      },
      d.value
    )) }) })
  ] });
}, "CheckboxGroup"), ai = Q(ge)`
  color: inherit;
  width: 16px;
  height: 16px;
  margin: 0;
  padding: 0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  
  & svg {
    color: inherit;
    fill: inherit;
    width: 16px !important;
    height: 16px !important;
  }
`, Cw = Q(jo)`

  ${({ $canStretch: e }) => e ? `flex: 1 1 0px;
    max-width: 100%;
    min-width: 0;
    
    /* Don't stretch when there's only one chip */
    &:only-child {
      flex: 0 0 auto;
      width: auto;
    }` : `
    flex: 0 0 auto;
    width: auto;
  `}
  

  &.MuiChip-root {
    padding: 4px 8px;
    background-color: ${({ theme: e }) => e.palette.primary.accentGreen};
    color: ${({ theme: e }) => e.palette.primary.white};
    gap: 4px;

    & .MuiChip-icon {
      margin: 0;
    }

    & svg {
      color: ${({ theme: e }) => e.palette.primary.white};
      fill: ${({ theme: e }) => e.palette.primary.white};
    }
  }
  
  & .MuiChip-label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0;
    
    color: ${({ theme: e }) => e.palette.primary.white};
    font-size: ${({ theme: e }) => e.fontSizes.body.m};
  }
`, M6 = Q(jo)`
  &.MuiChip-root {
    flex-shrink: 0;
    font-size: ${({ theme: e }) => e.fontSizes.body.m};
    height: 24px;
    color: ${({ theme: e }) => e.palette.primary.darkGrey4};
    background-color: ${({ theme: e }) => e.palette.primary.white};
    border: 1px solid ${({ theme: e }) => e.palette.primary.neutralGrey2};
  }
`;
Q(jo)`
  &.MuiChip-root {
    flex-shrink: 0;
    font-size: ${({ theme: e }) => e.fontSizes.body.m};
    height: 24px;
    color: ${({ theme: e }) => e.palette.primary.darkGrey4};
    background-color: ${({ theme: e }) => e.palette.primary.white};
    border: 1px solid ${({ theme: e }) => e.palette.primary.neutralGrey2};
  }
`;
const yw = Q(jo)`
  &.MuiChip-root {
    height: 24px;
    padding: 4px 8px;
    background-color: ${({ theme: e }) => e.palette.primary.lightBlue3};
    border-radius: 4px;
    gap: 4px;
    font-size: ${({ theme: e }) => e.fontSizes.body.m};

    & svg {
      color: ${({ theme: e }) => e.palette.primary.darkGrey4};
      fill: ${({ theme: e }) => e.palette.primary.darkGrey4};
    }

    & .MuiChip-icon {
      margin: 0;
    }
  }
  
  & .MuiChip-label {
    color: ${({ theme: e }) => e.palette.primary.darkGrey4};
    font-size: ${({ theme: e }) => e.fontSizes.body.m};
    padding: 0;
  }
`, xw = Q(jo)`
  &.MuiChip-root {
    height: 24px;
    padding: 4px 8px;
    background-color: #536B84;
    border-radius: 4px;
    gap: 4px;

    & .MuiChip-icon {
      margin: 0;
    }
    
    & svg {
      color: ${({ theme: e }) => e.palette.primary.white};
      fill: ${({ theme: e }) => e.palette.primary.white};
    }
  }
  
  & .MuiChip-label {
    color: ${({ theme: e }) => e.palette.primary.white};
    font-size: ${({ theme: e }) => e.fontSizes.body.m};
    padding: 0;
  }
`, vw = Q(jo)`
  &.MuiChip-root {
    height: 28px;
    padding: 6px 8px;
    background-color: transparent;
    font-size: ${({ theme: e }) => e.fontSizes.body.m};
    border: 1px solid ${({ theme: e }) => e.palette.primary.secondaryBlue};
    text-align: center;
    border-radius: 25px;
    gap: 8px;

    & .MuiChip-con {
      margin: 0;
    }
  }

  & .MuiChip-deleteIcon {
    color: ${({ theme: e }) => e.palette.primary.secondaryBlue} !important;
    fill: ${({ theme: e }) => e.palette.primary.secondaryBlue} !important;
    margin-left: 4px; // para separarlo del texto
    height: 12px;
    width: 12px;

    svg {
      height: 12px;
      width: 12px;
    }
  }

  & .MuiChip-deleteIcon.MuiChip-deleteIcon {
    cursor: pointer;
  }

  & .MuiChip-label {
    color: ${({ theme: e }) => e.palette.primary.secondaryBlue};
    font-weight: ${({ theme: e }) => e.fontWeights.bold};
    font-size: ${({ theme: e }) => e.fontSizes.body.m};
    padding: 0;
  }
`, QT = /* @__PURE__ */ a(({
  label: e,
  variant: t = "filled",
  type: n = "primary",
  icon: o,
  size: r = "small",
  canStretch: i = !0,
  ...l
}) => {
  if (n === "primary")
    return /* @__PURE__ */ h.jsx(
      Cw,
      {
        ...l,
        $canStretch: i,
        label: e,
        variant: t,
        icon: o ? /* @__PURE__ */ h.jsx(ai, { children: o }) : void 0,
        size: r
      }
    );
  if (n === "secondary")
    return /* @__PURE__ */ h.jsx(
      M6,
      {
        ...l,
        label: e,
        variant: t,
        icon: o ? /* @__PURE__ */ h.jsx(ai, { children: o }) : void 0,
        size: r
      }
    );
  if (n === "overflow")
    return /* @__PURE__ */ h.jsx(M6, { ...l, label: e, variant: t, size: r });
  if (n === "ternary")
    return /* @__PURE__ */ h.jsx(
      yw,
      {
        ...l,
        label: e,
        variant: t,
        icon: o ? /* @__PURE__ */ h.jsx(ai, { children: o }) : void 0,
        size: r
      }
    );
  if (n === "quaternary")
    return /* @__PURE__ */ h.jsx(
      xw,
      {
        ...l,
        label: e,
        variant: t,
        icon: o ? /* @__PURE__ */ h.jsx(ai, { children: o }) : void 0,
        size: r
      }
    );
  if (n === "quinary")
    return /* @__PURE__ */ h.jsx(
      vw,
      {
        ...l,
        label: e,
        variant: t,
        size: r,
        deleteIcon: o ? /* @__PURE__ */ h.jsx(ai, { children: o }) : void 0,
        onDelete: /* @__PURE__ */ a((c) => {
          var d;
          c.stopPropagation(), (d = l.onDelete) == null || d.call(l, c);
        }, "onDelete")
      }
    );
}, "Chip"), ww = Q(xl)`
  && {
    border: none;
    border-radius: 4px;
    padding: 7px 5px;
    background-color: ${(e) => e.theme.palette.primary.darkBlue};
    color: ${(e) => e.theme.palette.primary.white};

    .MuiSelect-select {
      padding: 2px 5px;
    }

    svg {
      color: ${(e) => e.theme.palette.primary.white};
      width: 20px;
      height: 20px;
    }

    fieldset {
      border: none;
    }
  }
`, Sw = Q.div`
  display: flex;
  align-items: center;
  justify-content: center;
  ${yb({ time: "0.3s" })}
`, Cu = /* @__PURE__ */ a(({ className: e = "", disabled: t, ...n }) => /* @__PURE__ */ h.jsx(
  ww,
  {
    "data-testid": "selectBase",
    className: e,
    disabled: t,
    ...n,
    IconComponent: /* @__PURE__ */ a((o) => /* @__PURE__ */ h.jsx(Sw, { ...o, children: /* @__PURE__ */ h.jsx(i2, {}) }), "IconComponent")
  }
), "SelectBase"), Tl = Q(ar)`
  & .MuiFormLabel-root {
    color: ${({ theme: e }) => e.palette.primary.white};
    font-weight: ${({ theme: e }) => e.fontWeights.medium};
    font-size: ${({ theme: e }) => e.fontSizes.body.l};
    margin-bottom: 8px;

    &.Mui-focused {
      color: ${({ theme: e }) => e.palette.primary.white}; /* Keep white, don't change */
    }
  }
`, kl = Q(Cu)`
  && {
    font-style: normal;
    color: ${({ theme: e }) => e.palette.primary.white};
    background-color: ${({ theme: e }) => e.palette.primary.darkBlue};
    padding: 4px 14px;
    align-items: center;

    .MuiSelect-select {
      padding: 0;
    }

    svg {
      color: ${({ theme: e }) => e.palette.primary.white};
      width: 12px;
      height: 12px;
    }

    & .MuiSelect-icon {
      color: ${({ theme: e }) => e.palette.primary.white};
      width: 20px;
      height: 20px;
    }
  }
`, ps = Q(Ac)`
  && {
    font-style: normal;
    font-weight: 400;
    font-size: ${(e) => e.theme.fontSizes.body.xl};
    color: ${(e) => e.theme.palette.primary.white};
    line-height: 20px;
    background-color: ${(e) => e.theme.palette.primary.darkBlue};
    justify-content: normal;
    min-height: unset;
    margin: 0 5px;
    border-radius: 4px;
    white-space: normal;
    word-wrap: break-word;

    &.Mui-selected {
      background-color: ${(e) => e.theme.palette.primary.darkBlue};
      &:hover {
        background-color: ${(e) => e.theme.palette.primary.darkGrey3};
      }
    }

    &.Mui-focusVisible {
      background-color: ${({ theme: e }) => e.palette.primary.darkGrey};
    }

    &:hover {
      background-color: ${(e) => e.theme.palette.primary.darkGrey};
    }
  }
`, Ol = Q.p`
  font-size: ${({ theme: e }) => e.fontSizes.body.xl};
  color: ${({ theme: e }) => e.palette.primary.white};
`, Mw = Q(Tl)`
  & .MuiFormLabel-root {
    font-weight: ${({ theme: e }) => e.fontWeights.medium};

    &.Mui-focused {
      color: ${({ theme: e }) => e.palette.primary.white};
    }
  }`, Tw = Q(kl)`
  && {
    height: 35px;
    background-color: transparent;
    color: ${({ theme: e }) => e.palette.primary.neutralGrey2};
    border: 1px solid ${({ theme: e }) => e.palette.primary.neutralGrey2};
    font-size: ${({ theme: e }) => e.fontSizes.body.l};

    &.Mui-focused,
    ${({ $hasValue: e }) => e && `
      &:not(.Mui-focused) {
        background-color: ${at.palette.primary.mainBlue};
        color: ${at.palette.primary.white};
        border: 1px solid ${at.palette.primary.mediumBlue2};
      }
    `}

    &.Mui-focused {
      background-color: ${({ theme: e }) => e.palette.primary.mainBlue};
      color: ${({ theme: e }) => e.palette.primary.white};
      border: 1px solid ${({ theme: e }) => e.palette.primary.mediumBlue2};
    }
  }
`, kw = Q(ps)`
  && {
    font-size: ${(e) => e.theme.fontSizes.body.l};
    background-color: ${(e) => e.theme.palette.primary.mainBlue};

    &.Mui-focused {
      color: ${({ theme: e }) => e.palette.primary.white};
    }

    &.Mui-selected {
      background-color: ${(e) => e.theme.palette.primary.mainBlue};
      border: 1px solid ${(e) => e.theme.palette.primary.mediumBlue2};
      border-radius: 4px;
    }
  } 
`, Ow = Q(Ol)`
  font-size: ${({ theme: e }) => e.fontSizes.body.l};
  color: ${({ theme: e }) => e.palette.primary.neutralGrey2};
`, T6 = Q(Tl)`
  & .MuiFormLabel-root {
    font-weight: ${({ theme: e }) => e.fontWeights.bold};
    font-size: ${({ theme: e }) => e.fontSizes.body.l};
  }
`, k6 = Q(kl)`
  && {
    background-color: ${({ theme: e }) => e.palette.primary.darkGrey};
    border: 1px solid ${({ theme: e }) => e.palette.primary.white};
    height: 40px;
  }
`, Ew = Q(ps)`
  && {
    font-size: ${(e) => e.theme.fontSizes.body.m};
    background-color: ${({ theme: e }) => e.palette.primary.darkGrey3};

    &.Mui-selected {
      border: none;
    }
  }
`, O6 = Q(Ol)`
  color: ${({ theme: e }) => e.palette.primary.neutralGrey2};
  font-size: ${({ theme: e }) => e.fontSizes.body.m};
`, $w = Q(ps)`
  && {
    background-color: ${({ theme: e }) => e.palette.primary.darkGrey3};
    font-size: ${(e) => e.theme.fontSizes.body.m};
    padding: 6px 4px;
    margin: 0 4px;
    border-radius: 2px;
    line-height: 1.4;
    min-height: unset;

    & .MuiCheckbox-root {
      padding: 4px;
    }
  }
`, E6 = Q(Tl)`
  && {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
    width: auto;
    flex: 0 0 auto;

    & .MuiFormLabel-root {
      color: ${({ theme: e }) => e.palette.primary.darkGrey4};
      font-weight: ${({ theme: e }) => e.fontWeights.regular};
      font-size: ${({ theme: e }) => e.fontSizes.body.m};
      margin-bottom: 0;
      white-space: nowrap;
      flex-shrink: 0;

      &.Mui-focused {
        color: ${({ theme: e }) => e.palette.primary.darkGrey4};
      }
    }
  }
`, $6 = Q(kl)`
  && {
    font-style: normal;
    color: ${({ theme: e }) => e.palette.primary.neutralBlack};
    background-color: ${({ theme: e }) => e.palette.primary.white};
    border: 1px solid ${({ theme: e }) => e.palette.primary.darkGrey4};
    height: 100%;
    min-height: 28px;
    /* min-width: 155px; */

    .MuiSelect-select {
      padding: 0;
      font-size: ${({ theme: e }) => e.fontSizes.body.m};
    }

    svg {
      color: ${({ theme: e }) => e.palette.primary.secondaryBlue};
    }

    & .MuiSelect-icon {
      color: ${({ theme: e }) => e.palette.primary.secondaryBlue};
      height: 18px;
      width: 18px;
    }
  }
`, yu = Q(ps)`
  && {
    font-size: ${(e) => e.theme.fontSizes.body.m};
    color: ${(e) => e.theme.palette.primary.neutralBlack};
    line-height: 16px;
    background-color: ${(e) => e.theme.palette.primary.white};

    &.Mui-selected {
      background-color: ${(e) => e.theme.palette.primary.neutralGrey2};
      &:hover {
        background-color: ${(e) => e.theme.palette.primary.neutralGrey1};
      }
    }

    &.Mui-focusVisible {
      background-color: ${({ theme: e }) => e.palette.primary.neutralGrey1};
    }

    &:hover {
      background-color: ${(e) => e.theme.palette.primary.neutralGrey1};
    }
  }
`, P6 = Q(Ol)`
  font-size: ${({ theme: e }) => e.fontSizes.body.m};
  color: ${({ theme: e }) => e.palette.primary.neutralBlack};
`, Pw = Q(yu)`
  && {
    font-size: ${(e) => e.theme.fontSizes.body.m};
    padding: 6px 4px;
    margin: 0 4px;
    border-radius: 2px;
    line-height: 1.4;
    min-height: unset;

    & .MuiCheckbox-root {
      padding: 4px;
    }
  }
`, _w = Q(Tl)`
  && {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
    width: auto; /* Don't take full width */
    flex: 0 0 auto; /* Don't grow, don't shrink, use content size */

    & .MuiFormLabel-root {
      color: ${({ theme: e }) => e.palette.primary.neutralBlack};
      font-weight: ${({ theme: e }) => e.fontWeights.regular};
      font-size: ${({ theme: e }) => e.fontSizes.body.m};
      margin-bottom: 0;
      white-space: nowrap;
      flex-shrink: 0;

      &.Mui-focused {
        color: ${({ theme: e }) => e.palette.primary.darkGrey4};
      }
    }
  }
`, Rw = Q(kl)`
  && {
    font-style: normal;
    color: ${({ theme: e }) => e.palette.primary.neutralBlack};
    background-color: transparent;
    border-bottom: none;
    padding: 4px 14px;
    height: 28px;

    .MuiSelect-select {
      padding: 0;
      font-size: ${({ theme: e }) => e.fontSizes.body.m};
    }

    svg {
      color: ${({ theme: e }) => e.palette.primary.neutralBlack};
    }

    & .MuiSelect-icon {
      color: ${({ theme: e }) => e.palette.primary.neutralBlack};
      height: 18px;
      width: 18px;
    }
  }
`, Iw = Q(ps)`
  && {
    font-size: ${(e) => e.theme.fontSizes.body.m};
    color: ${(e) => e.theme.palette.primary.neutralBlack};
    line-height: 16px;
    background-color: ${(e) => e.theme.palette.primary.white};

    &.Mui-selected {
      background-color: ${(e) => e.theme.palette.primary.neutralGrey2};
      &:hover {
        background-color: ${(e) => e.theme.palette.primary.neutralGrey1};
      }
    }

    &.Mui-focusVisible {
      background-color: ${({ theme: e }) => e.palette.primary.neutralGrey1};
    }

    &:hover {
      background-color: ${(e) => e.theme.palette.primary.neutralGrey1};
    }
  }
`, jw = Q(Ol)`
  font-size: ${({ theme: e }) => e.fontSizes.body.m};
  color: ${({ theme: e }) => e.palette.primary.neutralBlack};
`, bi = {
  backgroundColor: "inherit",
  border: "none",
  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  maxHeight: "185px",
  gap: "4px",
  "&::-webkit-scrollbar": {
    width: "5px",
    height: "5px"
  },
  "&::-webkit-scrollbar-track": {
    backgroundImage: "none"
  },
  "::-webkit-scrollbar-track:vertical": {
    backgroundSize: "1px 100%"
  },
  "::-webkit-scrollbar-track:horizontal": {
    backgroundSize: "100% 1px"
  },
  "&::-webkit-scrollbar-thumb": {
    background: `${at.palette.primary.mediumGrey3}B3`,
    borderRadius: "8px"
  }
}, _6 = {
  ...bi,
  maxHeight: "191px"
}, R6 = /* @__PURE__ */ a(({
  type: e = "primary",
  options: t = [],
  selectedValue: n,
  multiSelectedValue: o,
  onSelectChange: r,
  onMultiSelectChange: i,
  multiSelectMaxValue: l,
  placeholder: c,
  title: d,
  disabled: u,
  fullWidth: p = !1
}) => {
  const [f, m] = ln([]), [b, C] = ln(void 0), g = Vi(null), y = /* @__PURE__ */ a((x) => {
    const {
      target: { value: S }
    } = x;
    r == null || r(S);
  }, "handleChange"), w = /* @__PURE__ */ a((x) => {
    const {
      target: { value: S }
    } = x, M = typeof S == "string" ? S.split(",") : S;
    l && l > 0 && M.length > l && M.length > f.length || (m(M), i == null || i(M));
  }, "handleMultiChange"), T = /* @__PURE__ */ a(() => {
    g.current && C(g.current.offsetWidth);
  }, "handleMenuOpen");
  if (e === "primary")
    return /* @__PURE__ */ h.jsxs(Mw, { fullWidth: !0, children: [
      d && /* @__PURE__ */ h.jsx(_n, { component: "legend", sx: { flexGrow: 1 }, children: d }),
      /* @__PURE__ */ h.jsx(
        Tw,
        {
          ref: g,
          value: n,
          onChange: /* @__PURE__ */ a((x) => y(x), "onChange"),
          displayEmpty: !0,
          onOpen: T,
          $hasValue: !!n,
          MenuProps: {
            PaperProps: {
              sx: {
                ...bi,
                backgroundColor: at.palette.primary.mainBlue
              },
              style: {
                width: b || "auto",
                minWidth: "unset",
                maxWidth: "100%",
                marginTop: "4px"
              }
            },
            disableScrollLock: !0
          },
          renderValue: /* @__PURE__ */ a((x) => {
            var M;
            const S = x;
            return S ? ((M = t.find((O) => O.value === S)) == null ? void 0 : M.label) || S : /* @__PURE__ */ h.jsx(Ow, { children: c ?? "Select an option" });
          }, "renderValue"),
          disabled: u,
          children: t.map((x) => /* @__PURE__ */ h.jsx(kw, { value: x.value, children: x.label }, x.value))
        }
      )
    ] });
  if (e === "secondary")
    return /* @__PURE__ */ h.jsxs(T6, { fullWidth: !0, children: [
      d && /* @__PURE__ */ h.jsx(_n, { component: "legend", sx: { flexGrow: 1 }, children: d }),
      /* @__PURE__ */ h.jsx(
        k6,
        {
          ref: g,
          value: n,
          onChange: /* @__PURE__ */ a((x) => y(x), "onChange"),
          placeholder: c ?? "Select an option",
          displayEmpty: !0,
          onOpen: T,
          MenuProps: {
            PaperProps: {
              sx: {
                ..._6,
                backgroundColor: at.palette.primary.darkGrey3
              },
              style: {
                width: b || "auto",
                minWidth: "unset",
                maxWidth: "100%",
                marginTop: "4px"
              }
            },
            disableScrollLock: !0
          },
          renderValue: /* @__PURE__ */ a((x) => {
            var M;
            const S = x;
            return S ? ((M = t.find((O) => O.value === S)) == null ? void 0 : M.label) || S : /* @__PURE__ */ h.jsx(O6, { children: c ?? "Select an option" });
          }, "renderValue"),
          children: t.map((x) => /* @__PURE__ */ h.jsx(Ew, { value: x.value, children: x.label }, x.value))
        }
      )
    ] });
  if (e === "secondaryMulti")
    return /* @__PURE__ */ h.jsxs(T6, { fullWidth: !0, children: [
      d && /* @__PURE__ */ h.jsx(_n, { component: "legend", sx: { flexGrow: 1 }, children: d }),
      /* @__PURE__ */ h.jsx(
        k6,
        {
          ref: g,
          value: o ?? f,
          onChange: /* @__PURE__ */ a((x) => w(x), "onChange"),
          displayEmpty: !0,
          multiple: !0,
          onOpen: T,
          renderValue: /* @__PURE__ */ a((x) => x.length === 0 ? /* @__PURE__ */ h.jsx(O6, { children: c ?? "Select an option" }) : x.map((M) => {
            const O = t.find((P) => P.value === M);
            return O ? O.label : M;
          }).join(", "), "renderValue"),
          MenuProps: {
            PaperProps: {
              sx: {
                ..._6,
                backgroundColor: at.palette.primary.darkGrey3
              },
              style: {
                width: b || "auto",
                minWidth: "unset",
                maxWidth: "100%",
                marginTop: "4px"
              }
            },
            disableScrollLock: !0
          },
          children: t.map((x) => /* @__PURE__ */ h.jsxs($w, { value: x.value, children: [
            /* @__PURE__ */ h.jsx(
              Ca,
              {
                icon: /* @__PURE__ */ h.jsx(K1, {}),
                checkedIcon: /* @__PURE__ */ h.jsx(q1, {}),
                checked: o ? o.includes(x.value) : f.includes(x.value)
              }
            ),
            x.label
          ] }, x.value))
        }
      )
    ] });
  if (e === "ternary")
    return /* @__PURE__ */ h.jsxs(E6, { fullWidth: !0, children: [
      d && /* @__PURE__ */ h.jsx(_n, { component: "span", children: d }),
      /* @__PURE__ */ h.jsx(
        $6,
        {
          fullWidth: p,
          ref: g,
          value: n,
          onChange: /* @__PURE__ */ a((x) => y(x), "onChange"),
          displayEmpty: !0,
          onOpen: T,
          MenuProps: {
            PaperProps: {
              sx: {
                ...bi,
                backgroundColor: at.palette.primary.white,
                maxHeight: "150px"
              },
              style: {
                width: b || "auto",
                minWidth: "unset",
                maxWidth: "100%",
                marginTop: "4px"
              }
            },
            disableScrollLock: !0
          },
          renderValue: /* @__PURE__ */ a((x) => {
            var M;
            const S = x;
            return S ? ((M = t.find((O) => O.value === S)) == null ? void 0 : M.label) || S : /* @__PURE__ */ h.jsx(P6, { children: c ?? S });
          }, "renderValue"),
          children: t.map((x) => /* @__PURE__ */ h.jsx(yu, { value: x.value, children: x.label }, x.value))
        }
      )
    ] });
  if (e === "ternaryMulti")
    return /* @__PURE__ */ h.jsxs(E6, { fullWidth: !0, children: [
      d && /* @__PURE__ */ h.jsx(_n, { component: "span", children: d }),
      /* @__PURE__ */ h.jsx(
        $6,
        {
          fullWidth: p,
          ref: g,
          value: o ?? f,
          onChange: /* @__PURE__ */ a((x) => w(x), "onChange"),
          displayEmpty: !0,
          multiple: !0,
          onOpen: T,
          MenuProps: {
            PaperProps: {
              sx: {
                ...bi,
                backgroundColor: at.palette.primary.white,
                maxHeight: "270px"
              },
              style: {
                width: b || "auto",
                minWidth: "unset",
                maxWidth: "224px",
                marginTop: "4px"
              }
            },
            disableScrollLock: !0
          },
          renderValue: /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx(P6, { children: c ?? "Select countries" }), "renderValue"),
          children: t.map((x) => /* @__PURE__ */ h.jsxs(Pw, { value: x.value, children: [
            /* @__PURE__ */ h.jsx(
              Ca,
              {
                icon: /* @__PURE__ */ h.jsx(K1, {}),
                checkedIcon: /* @__PURE__ */ h.jsx(q1, {}),
                checked: o ? o.includes(x.value) : f.includes(x.value)
              }
            ),
            x.label
          ] }, x.value))
        }
      )
    ] });
  if (e === "minimal")
    return /* @__PURE__ */ h.jsxs(_w, { fullWidth: !0, children: [
      d && /* @__PURE__ */ h.jsx(_n, { component: "span", children: d }),
      /* @__PURE__ */ h.jsx(
        Rw,
        {
          ref: g,
          value: n,
          onChange: /* @__PURE__ */ a((x) => y(x), "onChange"),
          displayEmpty: !0,
          onOpen: T,
          MenuProps: {
            PaperProps: {
              sx: {
                ...bi,
                backgroundColor: at.palette.primary.white
              },
              style: {
                width: b || "auto",
                minWidth: "unset",
                maxWidth: "100%",
                marginTop: "4px"
              }
            },
            disableScrollLock: !0
          },
          renderValue: /* @__PURE__ */ a((x) => {
            var M;
            const S = x;
            return S ? ((M = t.find((O) => O.value === S)) == null ? void 0 : M.label) || S : /* @__PURE__ */ h.jsx(jw, { children: c ?? S });
          }, "renderValue"),
          children: t.map((x) => /* @__PURE__ */ h.jsx(Iw, { value: x.value, children: x.label }, x.value))
        }
      )
    ] });
}, "Select"), Lw = me(ge)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`, Vw = me.p`
    font-weight: ${({ theme: e }) => e.fontWeights.bold};
    font-size: ${({ theme: e }) => e.fontSizes.body.xl};
`, Aw = me(ge)`
  display: flex;
  gap: 16px;
  align-items: center;
`, ek = /* @__PURE__ */ a(({
  value: e,
  onChange: t,
  fromLabel: n = "From",
  toLabel: o = "To",
  type: r = "primary",
  fromPlaceholder: i = "Year",
  toPlaceholder: l = "Year",
  options: c,
  disabled: d = !1
}) => {
  const u = /* @__PURE__ */ a((b) => {
    const C = parseInt(b), g = parseInt(e.to);
    e.to && !isNaN(g) && !isNaN(C) && C > g ? t({ from: b, to: "" }) : t({ ...e, from: b });
  }, "handleFromChange"), p = /* @__PURE__ */ a((b) => {
    const C = parseInt(b), g = parseInt(e.from);
    e.from && !isNaN(g) && !isNaN(C) && C < g ? t({ from: "", to: b }) : t({ ...e, to: b });
  }, "handleToChange"), f = /* @__PURE__ */ a(() => {
    if (!e.to) return c;
    const b = parseInt(e.to);
    return c == null ? void 0 : c.filter((C) => parseInt(C.value) <= b);
  }, "getFilteredFromOptions"), m = /* @__PURE__ */ a(() => {
    if (!e.from) return c;
    const b = parseInt(e.from);
    return c == null ? void 0 : c.filter((C) => parseInt(C.value) >= b);
  }, "getFilteredToOptions");
  return /* @__PURE__ */ h.jsxs(Lw, { children: [
    /* @__PURE__ */ h.jsx(Vw, { children: "Date range" }),
    /* @__PURE__ */ h.jsxs(Aw, { children: [
      /* @__PURE__ */ h.jsx(
        R6,
        {
          type: r,
          options: f(),
          selectedValue: e.from,
          onSelectChange: u,
          placeholder: i,
          disabled: d,
          title: n
        }
      ),
      /* @__PURE__ */ h.jsx(
        R6,
        {
          type: r,
          options: m(),
          selectedValue: e.to,
          onSelectChange: p,
          placeholder: l,
          disabled: d,
          title: o
        }
      )
    ] })
  ] });
}, "DateRange"), Bw = Q(Rc)`
  z-index: 250 !important;

  .MuiPaper-root {
    position: relative;
    max-width: 580px;
    min-width: 250px;
    max-height: 380px;
    padding: 8px;
    background-color: ${({ theme: e }) => e.palette.primary.white}${({ theme: e }) => e.palette.opacity[95]};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .MuiDialog-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .MuiBackdrop-root {
    opacity: 0.2 !important;
    background-color: ${({ theme: e }) => e.palette.primary.darkBlue};
    backface-visibility: hidden;
    position: absolute;
  }
`, Hw = Q(ge)`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 8px;
  justify-content: ${(e) => e.$hasTitle ? "space-between" : "flex-end"};
`, Dw = Q.h3`
  font-weight: ${({ theme: e }) => e.fontWeights.bold};
  color: ${({ theme: e }) => e.palette.primary.darkGrey3};
`, Nw = Q(ge)`
  height: 100%;
  padding: 8px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  gap: 16px;
  color: ${({ theme: e }) => e.palette.primary.darkGrey3};
  font-size: ${({ theme: e }) => e.fontSizes.body.m};
  overflow-y: auto !important;
  white-space: pre-line;

  & {
    /* This treats consecutive \n\n as paragraph breaks */
    text-indent: 0;
  }

  ${zc(at.palette.primary.darkGrey3)}
`, zw = Q(po)`
  &.MuiIconButton-root {
    width: 24px;
    height: 24px;
    padding: 4px;
    color: ${({ theme: e }) => e.palette.primary.darkGrey3};

    &:hover {
      background: rgba(0, 0, 0, 0.04);
    }
  }
`, tk = /* @__PURE__ */ a(({
  isOpen: e,
  title: t,
  children: n,
  onClose: o,
  container: r,
  hasOverlay: i = !0
}) => /* @__PURE__ */ h.jsxs(
  Bw,
  {
    open: e,
    className: "modal-wrapper",
    "data-testid": "modal.wrapper",
    onClose: o,
    maxWidth: "lg",
    container: r,
    style: r ? { position: "absolute" } : void 0,
    hideBackdrop: !i,
    disableScrollLock: !!r,
    disableRestoreFocus: !!r,
    disableEnforceFocus: !!r,
    children: [
      /* @__PURE__ */ h.jsxs(Hw, { $hasTitle: !!t, children: [
        t && /* @__PURE__ */ h.jsx(Dw, { children: t }),
        o && /* @__PURE__ */ h.jsx(zw, { onClick: o, "data-testid": "close-modal-testid", children: /* @__PURE__ */ h.jsx(Ha, {}) })
      ] }),
      /* @__PURE__ */ h.jsx(Nw, { "data-testid": "modal.dialog-body", className: "modal-body", children: n })
    ]
  }
), "DisclaimerModal"), Fw = /* @__PURE__ */ a((e = 10, t = 100) => {
  const [n, o] = ln("top"), [r, i] = ln(0), [l, c] = ln(0), d = Vi(null);
  return Cn(() => {
    const u = /* @__PURE__ */ a(() => {
      d.current && cancelAnimationFrame(d.current), d.current = requestAnimationFrame(() => {
        const p = window.scrollY;
        p <= e ? o("top") : p > r && p > e ? o("down") : p < r && o("up"), i(p), c(Math.min(p / t, 1));
      });
    }, "handleScroll");
    return window.addEventListener("scroll", u, { passive: !0 }), () => {
      window.removeEventListener("scroll", u), d.current && cancelAnimationFrame(d.current);
    };
  }, [r, e, t]), {
    direction: n,
    scrollY: r,
    isAtTop: r <= e,
    scrollProgress: l
  };
}, "useScrollDirection"), Ww = me(ge)`
  position: fixed;
  top: var(--top-position, 36px);
  transform: translateY(${(e) => e.$isHidden ? "-100%" : "0"});
  background-color: rgba(255, 255, 255, 0);

  transition: transform 0.3s ease-in-out;

  /* Add will-change for GPU acceleration */
  will-change: top, background-color;

  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 100;
`, Zw = me(ge)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
`;
me(ge)`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    height: 100%;
    width: auto;
  }
`;
const r1 = me(N6)`
  display: inline-flex;
  align-items: center;
  height: 100%;
  text-decoration: none;
  color: inherit;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${({ theme: e }) => e.palette.primary.primaryBlue};
    outline-offset: 2px;
    border-radius: 4px;
  }
`, Uw = me(
  Vo
)`
  height: 82px;
  padding-top: 14px;
  padding-bottom: 14px;
  background-color: inherit;
  gap: 16px;
  display: flex;
  justify-content: start;
  align-items: center;
  background-color: ${({ $isTransparent: e, theme: t }) => e ? "transparent" : t.palette.primary.lightGrey2};

  svg {
    fill: ${({ theme: e }) => e.palette.primary.darkBlue};
    height: 100%;
    width: auto;
  }
`, Fs = me(ge)`
  width: 32px;
  height: 32px;
  padding: 0;

  &:hover {
    cursor: pointer;
  }
`, Gw = me(jc)`
  .MuiDrawer-paper {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    gap: 40px;
    align-items: center;
    background-color: ${({ theme: e }) => e.palette.primary.darkGrey + e.palette.opacity[90]};
  }

  footer {
    background-color: ${({ theme: e }) => e.palette.primary.darkGrey};
  }
`, Yw = me(Vo)`
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 25px;
  padding-top: 14px;
  padding-bottom: 14px;
  max-height: 82px;

  svg {
    fill: ${({ theme: e }) => e.palette.primary.white};
    color: ${({ theme: e }) => e.palette.primary.white};
    max-height: 100%;
    width: auto;
  }
`, qw = me(Vo)`
  flex-direction: column;
  justify-content: start;
  gap: 40px;
  flex: 1;
  overflow-y: auto;
  padding: 24px 65px;

  ${zc()}
`, Kw = me.a`
  color: ${({ theme: e }) => e.palette.primary.white};
  font-family: ${({ theme: e }) => e.fontFamilies.BigShouldersDisplay};
  font-size: ${({ theme: e }) => e.fontSizes.headings.h1};
  font-weight: ${({ theme: e }) => e.fontWeights.bold};
  line-height: 100%;
  text-decoration: none;

  &:hover {
    cursor: pointer;
  }
`, Xw = me(ge)`
  position: fixed;
  top: var(--top-position, 36px);
  transform: translateY(${(e) => e.$isHidden ? "-100%" : "0"});
  background-color: rgba(31, 38, 46, var(--bg-opacity, 1));

  transition: transform 0.3s ease-in-out;

  /* Add will-change for GPU acceleration */
  will-change: top, background-color;

  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 100;
`, Jw = me(ge)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
`, Qw = me(
  ge
)`
  height: 82px;
  width: 100%;
  padding: 14px 20px;
  padding-bottom: 14px;
  gap: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ $isTransparent: e, theme: t }) => e ? "transparent" : t.palette.primary.mainBlue};

  svg {
    fill: ${({ theme: e }) => e.palette.primary.white};
    height: 100%;
    width: auto;
  }
`, eS = me(jc)`
  .MuiDrawer-paper {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    gap: 32px;
    align-items: center;
    background-color: ${({ theme: e }) => e.palette.primary.darkBlue + e.palette.opacity[90]};

    @media (max-width: ${({ theme: e }) => e.breakpoints.md}px) {
      gap: 8px;
    }
  }

  footer {
    background-color: ${({ theme: e }) => e.palette.primary.darkBlue};
  }
`, tS = me(Vo)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 25px;
  padding-top: 14px;
  padding-bottom: 14px;
  max-height: 82px;

  svg {
    fill: ${({ theme: e }) => e.palette.primary.white};
    color: ${({ theme: e }) => e.palette.primary.white};
    max-height: 100%;
    width: auto;
  }
`, nS = me(Vo)`
  flex-direction: column;
  justify-content: start;
  gap: 24px;
  flex: 1;
  overflow-y: auto;
  padding: 24px 32px;

  ${zc()}
`, oS = me.a`
  color: ${({ theme: e }) => e.palette.primary.white};
  font-size: ${({ theme: e }) => e.fontSizes.body.xl};
  font-weight: ${({ theme: e }) => e.fontWeights.medium};
  line-height: 100%;
  text-decoration: none;
  display: flex;
  gap: 8px;
  align-items: center;

  svg {
    height: auto;
    width: ${({ theme: e }) => e.fontSizes.body.xl};
    max-height: ${({ theme: e }) => e.fontSizes.body.xl};
  }

  &:hover {
    cursor: pointer;
  }
`, rS = me.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`, iS = me.p`
  font-size: ${({ theme: e }) => e.fontSizes.body.m};
  font-style: italic;
  color: ${({ theme: e }) => e.palette.primary.mediumGrey4};
  font-weight: ${({ theme: e }) => e.fontWeights.light};
`, nk = /* @__PURE__ */ a(({
  navigationItems: e = [],
  headerLogo: t,
  logoUrl: n,
  hasDrawer: o,
  isTransparent: r = !0,
  type: i,
  hideOnScroll: l = !1,
  transparentWhenTop: c = !1,
  children: d,
  onDrawerClose: u
}) => {
  const [p, f] = ln(!1), { direction: m, scrollY: b, scrollProgress: C } = Fw(10, 100), g = l && m === "down" && b > 100, y = b < 36 ? 36 - b : 0, w = c ? C : 1, T = /* @__PURE__ */ a((x) => {
    f(() => x);
  }, "handleToogleDrawer");
  if (i === "primary")
    return /* @__PURE__ */ h.jsxs(
      Ww,
      {
        $isHidden: g,
        style: {
          "--top-position": `${y}px`,
          "--bg-opacity": w
        },
        children: [
          /* @__PURE__ */ h.jsx(Zw, { children: /* @__PURE__ */ h.jsxs(Uw, { $isTransparent: r, children: [
            o && /* @__PURE__ */ h.jsx(Fs, { onClick: /* @__PURE__ */ a(() => T(!0), "onClick"), children: /* @__PURE__ */ h.jsx(w6, {}) }),
            /* @__PURE__ */ h.jsx(r1, { to: n, "aria-label": "Home", children: t })
          ] }) }),
          /* @__PURE__ */ h.jsxs(
            Gw,
            {
              anchor: "left",
              open: p,
              onClose: /* @__PURE__ */ a(() => T(!1), "onClose"),
              children: [
                /* @__PURE__ */ h.jsx(Yw, { children: /* @__PURE__ */ h.jsx(Fs, { onClick: /* @__PURE__ */ a(() => T(!1), "onClick"), children: /* @__PURE__ */ h.jsx(Ha, {}) }) }),
                /* @__PURE__ */ h.jsxs(qw, { children: [
                  e.map((x) => /* @__PURE__ */ h.jsx(
                    Kw,
                    {
                      href: x.to,
                      children: x.label
                    },
                    x.label
                  )),
                  d && /* @__PURE__ */ h.jsx(
                    "div",
                    {
                      onClick: /* @__PURE__ */ a(() => {
                        T(!1), u == null || u();
                      }, "onClick"),
                      children: d
                    }
                  )
                ] })
              ]
            }
          )
        ]
      }
    );
  if (i === "secondary")
    return /* @__PURE__ */ h.jsxs(
      Xw,
      {
        $isHidden: g,
        style: {
          "--top-position": `${y}px`,
          "--bg-opacity": w
        },
        children: [
          /* @__PURE__ */ h.jsx(Jw, { children: /* @__PURE__ */ h.jsxs(Qw, { $isTransparent: r, children: [
            /* @__PURE__ */ h.jsx(r1, { to: n, "aria-label": "Home", children: t }),
            o && /* @__PURE__ */ h.jsx(Fs, { onClick: /* @__PURE__ */ a(() => T(!0), "onClick"), children: /* @__PURE__ */ h.jsx(w6, {}) })
          ] }) }),
          /* @__PURE__ */ h.jsxs(
            eS,
            {
              anchor: "left",
              open: p,
              onClose: /* @__PURE__ */ a(() => T(!1), "onClose"),
              children: [
                /* @__PURE__ */ h.jsxs(tS, { children: [
                  /* @__PURE__ */ h.jsx(r1, { to: n, "aria-label": "Home", children: t }),
                  /* @__PURE__ */ h.jsx(Fs, { onClick: /* @__PURE__ */ a(() => T(!1), "onClick"), children: /* @__PURE__ */ h.jsx(Ha, {}) })
                ] }),
                /* @__PURE__ */ h.jsx(nS, { children: e.map((x) => /* @__PURE__ */ h.jsxs(rS, { children: [
                  /* @__PURE__ */ h.jsxs(
                    oS,
                    {
                      href: x.to,
                      onClick: /* @__PURE__ */ a(() => T(!1), "onClick"),
                      children: [
                        x.icon,
                        x.label
                      ]
                    },
                    x.label
                  ),
                  !x.isInPOC && /* @__PURE__ */ h.jsx(iS, { children: x.sublabel })
                ] }, x.label)) })
              ]
            }
          )
        ]
      }
    );
}, "DrawerHeaderNav"), sS = me(ge)`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0 20px 20px;
  z-index: 300;
  pointer-events: none;

  display: flex;
  justify-content: center;
`, ok = /* @__PURE__ */ a(({ message: e, open: t, onClose: n, duration: o = 5e3 }) => (Cn(() => {
  if (!t) return;
  const r = setTimeout(n, o);
  return () => clearTimeout(r);
}, [t, o, n]), /* @__PURE__ */ h.jsx(sS, { children: /* @__PURE__ */ h.jsx(Ic, { in: t, direction: "up", mountOnEnter: !0, unmountOnExit: !0, children: /* @__PURE__ */ h.jsx(
  H5,
  {
    severity: "error",
    variant: "filled",
    onClose: n,
    sx: {
      width: "100%",
      pointerEvents: "auto",
      backgroundColor: "rgba(211, 47, 47, 0.7)",
      backdropFilter: "blur(4px)"
    },
    children: e
  }
) }) })), "ErrorBar"), aS = Q(ge)`
  display: flex;
  justify-content: center;
  width: 100%;
  flex-grow: 0;
`, lS = Q.footer`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: ${({ theme: e }) => e.palette.primary.marginBlue};
  color: ${({ theme: e }) => e.palette.primary.white};
`, cS = Q(Vo)`
  display: flex;
  overflow-y: hidden;
  justify-content: space-between;
  align-items: center;
  height: 36px;
  font-size: ${(e) => e.theme.fontSizes.body.m};

  @media (max-width: ${({ theme: e }) => e.breakpoints.md}px) {
    justify-content: center;
    padding: 16px;
    height: auto;
  }
`, dS = Q(ge)`
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: ${({ theme: e }) => e.breakpoints.lg}px) {
    justify-content: center;
  }
`;
Q.p`
  &:hover {
    cursor: pointer;
  }
`;
const uS = Q(ge)`
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: ${({ theme: e }) => e.breakpoints.lg}px) {
    flex-wrap: wrap;
    justify-content: center;
  }
`, pS = Q.a`
  display: inline-block;
  color: ${(e) => e.theme.palette.primary.white};
  text-decoration: none;
  white-space: nowrap;
  padding: 0;

  &:hover {
    cursor: pointer;
    text-decoration: none;
  }

  &:not(:last-child)::after {
    content: "|";
    display: inline-block;
    margin-left: 16px;
    color: ${(e) => e.theme.palette.primary.white};
    opacity: 0.8;
  }
`, fS = Q.pattern`
  display: inline-block;
  color: ${(e) => e.theme.palette.primary.white};
  text-decoration: none;
  white-space: nowrap;
  padding: 0;

  &:not(:last-child)::after {
    content: "|";
    display: inline-block;
    margin-left: 16px;
    color: ${(e) => e.theme.palette.primary.white};
    opacity: 0.8;
  }
`, hS = {
  FacebookIcon: Jv,
  XIcon: lw,
  TumblrIcon: iw,
  LinkedinIcon: nw,
  InstagramIcon: ew,
  YoutubeIcon: cw,
  TiktokIcon: rw
}, rk = /* @__PURE__ */ a(({ footerItems: e = [], footerSocialMedia: t = [] }) => /* @__PURE__ */ h.jsx(aS, { children: /* @__PURE__ */ h.jsx(lS, { children: /* @__PURE__ */ h.jsxs(cS, { children: [
  /* @__PURE__ */ h.jsx(dS, { children: t.map((n, o) => {
    const r = hS[n.icon];
    return /* @__PURE__ */ h.jsx(
      "a",
      {
        href: n.url,
        target: "_blank",
        rel: "noopener noreferrer",
        style: { color: "white" },
        children: r ? /* @__PURE__ */ h.jsx(r, { style: { fill: "white", width: 24, height: 24 } }) : null
      },
      n.icon + o
    );
  }) }),
  /* @__PURE__ */ h.jsx(uS, { children: e.map((n, o) => n.url ? /* @__PURE__ */ h.jsx(pS, { href: n.url, target: "_blank", children: n.label }, n.label + o) : /* @__PURE__ */ h.jsx(fS, { children: n.label }, n.label + o)) })
] }) }) }), "Footer"), gS = Q(ge)`
  position: absolute;
  top: 36px;
  left: 0;
  z-index: 100;
  width: 100%;
  display: flex;
  justify-content: center;
`, mS = Q(
  ge
)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(e) => e.$isHomepage ? "transparent" : e.$bgColour};
`, bS = Q(
  Vo
)`
  height: 82px;
  overflow-y: hidden;
  display: flex;
  justify-content: ${(e) => e.$flexJustify};
  background-color: inherit;
`;
Q(ge)`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    height: 100%;
    width: auto;
  }
`;
const CS = Q(N6)`
  display: inline-flex;
  align-items: center;
  height: 100%;
  text-decoration: none;
  color: inherit;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${({ theme: e }) => e.palette.primary.primaryBlue};
    outline-offset: 2px;
    border-radius: 4px;
  }
`, yS = Q(ge)`
  display: flex;
  align-items: flex-start;
  justify-content: space-evenly;
  gap: 24px;
  padding: 18px 0;
`, xS = Q(z6)`
  position: relative;
  height: 50px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  padding-bottom: 5px;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;

  &.active {
    font-weight: 500;
    border-bottom-color: ${({ theme: e }) => e.palette.primary.primaryBlue};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme: e }) => e.palette.primary.primaryBlue};
    outline-offset: 2px;
    border-radius: 2px;
  }
`;
Q(z6)`
  position: relative;
  height: 50px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  padding-bottom: 5px;
  cursor: pointer;

  &.active {
    font-weight: 500;
    border-bottom: 2px solid ${(e) => e.theme.palette.primary.primaryBlue};
  }
`;
const vS = Q.p`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  color: ${(e) => e.$colour};
  font-size: ${({ theme: e }) => e.fontSizes.body.l};
  font-weight: ${({ theme: e }) => e.fontWeights.regular};

  svg {
    width: 16px;
    height: auto;
    max-height: 16px;
  }
`, wS = Q.p`
  font-size: ${({ theme: e }) => e.fontSizes.body.m};
  font-style: italic;
  color: ${({ theme: e }) => e.palette.primary.mediumGrey4};
  font-weight: ${({ theme: e }) => e.fontWeights.light};
`, ik = /* @__PURE__ */ a(({
  navigationItems: e = [],
  isHomepage: t,
  bgColour: n,
  colour: o,
  headerLogo: r,
  logoUrl: i,
  flexJustify: l = "space-between"
}) => /* @__PURE__ */ h.jsx(gS, { children: /* @__PURE__ */ h.jsx(mS, { $isHomepage: t, $bgColour: n, children: /* @__PURE__ */ h.jsxs(bS, { $flexJustify: l, children: [
  /* @__PURE__ */ h.jsx(CS, { to: i, "aria-label": "Home", children: r }),
  /* @__PURE__ */ h.jsx(yS, { children: !t && e.map((c, d) => /* @__PURE__ */ h.jsxs(xS, { to: c.to ?? "#", children: [
    /* @__PURE__ */ h.jsxs(vS, { $colour: o, children: [
      c.icon,
      c.label
    ] }),
    !c.isInPOC && /* @__PURE__ */ h.jsx(wS, { children: c.sublabel })
  ] }, c.label + d)) })
] }) }) }), "HeaderNav"), SS = Q(ar)`
  & .MuiFormLabel-root {
    color: ${({ theme: e }) => e.palette.primary.white};
    font-weight: ${({ theme: e }) => e.fontWeights.medium};
    font-size: ${({ theme: e }) => e.fontSizes.body.l};
    margin-bottom: 8px;
    padding-left: 2px;

    &.Mui-focused {
      color: ${({ theme: e }) => e.palette.primary.white};
    }
  }
`, MS = Q(Ko)`
  && {
    .MuiOutlinedInput-root {
      border: none;
      border-radius: 4px;
      padding: 7px 5px;
      background-color: ${(e) => e.theme.palette.primary.darkBlue};
      color: ${(e) => e.theme.palette.primary.white};
      height: 40px;

      .MuiOutlinedInput-input {
        padding: 2px 5px;
        font-size: ${(e) => e.theme.fontSizes.body.xl};

        &::placeholder {
          color: ${(e) => e.theme.palette.primary.lightGrey};
          opacity: 1;
        }
      }

      .MuiOutlinedInput-notchedOutline {
        border: none;
      }

      &.Mui-focused {
        .MuiOutlinedInput-notchedOutline {
          border: none;
        }
      }

      &:hover {
        .MuiOutlinedInput-notchedOutline {
          border: none;
        }
      }
    }

    &.Mui-disabled {
      .MuiOutlinedInput-root {
        background-color: ${(e) => e.theme.palette.primary.darkGrey};
        color: ${(e) => e.theme.palette.primary.neutralGrey2};
      }
    }
  }
`, sk = /* @__PURE__ */ a(({
  title: e,
  placeholder: t,
  value: n,
  onChange: o,
  onKeyPress: r,
  disabled: i = !1,
  type: l = "text",
  fullWidth: c = !0,
  variant: d = "outlined"
}) => {
  const u = /* @__PURE__ */ a((p) => {
    o(p.target.value);
  }, "handleChange");
  return /* @__PURE__ */ h.jsxs(SS, { fullWidth: c, children: [
    e && /* @__PURE__ */ h.jsx(_n, { children: e }),
    /* @__PURE__ */ h.jsx(
      MS,
      {
        placeholder: t,
        value: n,
        onChange: u,
        onKeyDown: r,
        disabled: i,
        type: l,
        variant: d,
        slotProps: {
          input: {
            endAdornment: /* @__PURE__ */ h.jsx(ow, {})
          }
        }
      }
    )
  ] });
}, "InputText"), TS = me(ge)`
  display: flex;
  flex-direction: ${({ $orientation: e }) => e === "horizontal" ? "row" : "column"};
  gap: 12px;
`, kS = me(ge)`
  display: flex;
  flex-direction: ${({ $orientation: e }) => e === "horizontal" ? "column" : "row"};
  align-items: center;
  gap: ${({ $orientation: e }) => e === "horizontal" ? "4px" : "12px"};
`, I6 = me(ge)`
    width: ${({ $size: e }) => e}px;
    height: ${({ $size: e }) => e}px;
    border-radius: 50%;
    border: 1px solid ${({ $borderColor: e }) => e};
    background-color: ${({ $color: e }) => e};
    opacity: 0.8;
    flex-shrink: 0;
  `, j6 = me.span`
  font-size: ${({ theme: e }) => e.fontSizes.body.m};
  color: ${({ theme: e }) => e.palette.primary.darkGrey};
`, ak = /* @__PURE__ */ a(({
  items: e,
  color: t,
  borderColor: n,
  orientation: o = "horizontal",
  formatValue: r
}) => {
  const i = [...e].sort((d, u) => d.radius - u.radius), c = r ?? /* @__PURE__ */ a((d) => {
    const u = typeof d == "string" ? parseFloat(d) : d;
    return new Intl.NumberFormat("en-GB").format(u);
  }, "defaultFormatter");
  return /* @__PURE__ */ h.jsx(TS, { $orientation: o, "data-testid": "legend-bubbles", children: i.map((d) => /* @__PURE__ */ h.jsx(
    kS,
    {
      $orientation: o,
      "data-testid": "legend-bubble-item",
      children: o === "horizontal" ? /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
        /* @__PURE__ */ h.jsx(j6, { children: d.label || c(d.value) }),
        /* @__PURE__ */ h.jsx(I6, { $size: d.radius * 2, $color: t, $borderColor: n })
      ] }) : /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
        /* @__PURE__ */ h.jsx(I6, { $size: d.radius * 2, $color: t, $borderColor: n }),
        /* @__PURE__ */ h.jsx(j6, { children: d.label || c(d.value) })
      ] })
    },
    `${d.radius}-${d.value}`
  )) });
}, "LegendBubbles"), OS = me(ge)`
  display: flex;
  flex-direction: column;
  gap: 6px;
`, ES = me(ge)`
  display: flex;
  align-items: center;
  gap: 8px;
`, $S = me(ge)`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${({ $color: e }) => e};
  flex-shrink: 0;
`, PS = me.span`
  font-size: ${({ theme: e }) => e.fontSizes.body.m};
  color: ${({ theme: e }) => e.palette.primary.darkGrey};
`, lk = /* @__PURE__ */ a(({ items: e }) => /* @__PURE__ */ h.jsx(OS, { "data-testid": "legend-color-dots", children: e.map((t) => /* @__PURE__ */ h.jsxs(ES, { "data-testid": "legend-color-dot-item", children: [
  /* @__PURE__ */ h.jsx($S, { $color: t.color }),
  /* @__PURE__ */ h.jsx(PS, { children: t.label })
] }, `${t.color}-${t.label}`)) }), "LegendColorDots"), _S = me(ge)`
  display: flex;
  flex-direction: column;
  gap: 4px;
`, RS = me(ge)`
  height: 24px;
  width: 100%;
  background: linear-gradient(to right, ${({ $minColor: e }) => e}, ${({ $maxColor: e }) => e});
  border-radius: 2px;
`, IS = me(ge)`
  display: flex;
  justify-content: space-between;
  font-size: ${({ theme: e }) => e.fontSizes.body.m};
  color: ${({ theme: e }) => e.palette.primary.darkGrey};
`, ck = /* @__PURE__ */ a(({
  minValue: e,
  maxValue: t,
  minColor: n,
  maxColor: o,
  formatValue: r
}) => {
  const l = r ?? /* @__PURE__ */ a((c) => new Intl.NumberFormat("en-GB").format(c), "defaultFormatter");
  return /* @__PURE__ */ h.jsxs(_S, { "data-testid": "legend-gradient", children: [
    /* @__PURE__ */ h.jsxs(IS, { children: [
      /* @__PURE__ */ h.jsx("span", { "data-testid": "legend-gradient-min", children: l(e) }),
      /* @__PURE__ */ h.jsx("span", { "data-testid": "legend-gradient-max", children: l(t) })
    ] }),
    /* @__PURE__ */ h.jsx(RS, { $minColor: n, $maxColor: o })
  ] });
}, "LegendGradient"), jS = Q(ge)`
  width: 308px;
  background-color: ${({ theme: e }) => e.palette.primary.white}${({ theme: e }) => e.palette.opacity[90]};
  color: ${({ theme: e }) => e.palette.primary.darkGrey};
  padding: ${({ $isCollapsed: e }) => e ? "8px 16px" : "8px 16px 16px 16px"};
  border-radius: 0;
  display: flex;
  flex-direction: column;
  align-content: center;
  box-shadow: 0px 2px 4px 0px #00000040;
`, LS = Q(ge)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: ${({ $isCollapsed: e }) => e ? "0" : "8px"};
  gap: 8px;
  cursor: pointer;
  user-select: none;
  border-bottom: ${({ $isCollapsed: e, theme: t }) => e ? "0" : `1px solid ${t.palette.primary.mediumGrey4}`};
`, VS = Q.p`
  color: ${({ theme: e }) => e.palette.primary.darkGrey};
  font-size: ${({ theme: e }) => e.fontSizes.body.m};
  font-weight: ${({ theme: e }) => e.fontWeights.bold};
`, AS = Q(po)`
  display: flex;
  align-items: center;
  color: ${({ theme: e }) => e.palette.primary.mediumBlue2};
  margin-left: auto;

  svg {
    color: ${({ theme: e }) => e.palette.primary.mediumBlue2};
    fill: ${({ theme: e }) => e.palette.primary.mediumBlue2};
  }
`, BS = Q(ge)`
  padding: ${({ $isCollapsed: e }) => e ? "0" : "8px 0 0 0"};
  max-height: ${({ $isCollapsed: e }) => e ? "0" : "500px"};
  overflow: hidden;
  transition:
    max-height 0.3s ease,
    padding 0.3s ease;
  display: flex;
`, HS = Q(ge)`
  min-width: 170px;
  width: ${({ $hasYearSelector: e }) => e ? "170px" : "100%"};
  border-right: ${({ $hasYearSelector: e, theme: t }) => e ? `1px solid ${t.palette.primary.mediumGrey4}` : "none"};
  padding-right: ${({ $hasYearSelector: e }) => e ? "16px" : "0"};
  align-self: center;
`, DS = Q(ge)`
  padding-left: 16px;
`, dk = /* @__PURE__ */ a(({
  title: e,
  unit: t,
  children: n,
  id: o,
  className: r,
  yearSelector: i,
  dataPolicyYear: l,
  dataPollutantYear: c,
  dataYear: d,
  dataStartYear: u,
  dataEndYear: p
}) => {
  const [f, m] = ln(!1), b = /* @__PURE__ */ a(() => {
    m(!f);
  }, "handleToggle"), C = t ? `${e} (${t})` : e;
  return /* @__PURE__ */ h.jsxs(jS, { $isCollapsed: f, id: o, className: r, children: [
    /* @__PURE__ */ h.jsxs(
      LS,
      {
        $isCollapsed: f,
        onClick: b,
        "data-testid": "legend-item-header",
        "data-policy-year": l,
        "data-pollutant-year": c,
        "data-year": d,
        "data-start-year": u,
        "data-end-year": p,
        children: [
          /* @__PURE__ */ h.jsx(VS, { children: C }),
          /* @__PURE__ */ h.jsx(AS, { "data-testid": "legend-item-toggle", children: f ? /* @__PURE__ */ h.jsx(i2, {}) : /* @__PURE__ */ h.jsx(Yv, {}) })
        ]
      }
    ),
    /* @__PURE__ */ h.jsxs(BS, { $isCollapsed: f, children: [
      /* @__PURE__ */ h.jsx(HS, { $hasYearSelector: !!i, children: n }),
      i && /* @__PURE__ */ h.jsx(DS, { children: i })
    ] })
  ] });
}, "LegendItem"), NS = me(ge)`
  display: flex;
  flex-direction: column;
  gap: 6px;
`, zS = me(ge)`
  display: flex;
  align-items: center;
  gap: 8px;
`, FS = me(ge)`
  display: flex;
  align-items: center;
  width: 24px;
  height: 16px;
  flex-shrink: 0;
`, WS = me.span`
  font-size: ${({ theme: e }) => e.fontSizes.body.m};
  color: ${({ theme: e }) => e.palette.primary.darkGrey};
`, uk = /* @__PURE__ */ a(({ items: e, lineWidth: t = 24 }) => /* @__PURE__ */ h.jsx(NS, { "data-testid": "legend-line", children: e.map((n, o) => {
  const r = n.strokeWidth ?? 2;
  return /* @__PURE__ */ h.jsxs(zS, { "data-testid": "legend-line-item", children: [
    /* @__PURE__ */ h.jsx(FS, { style: { width: t }, children: /* @__PURE__ */ h.jsx(
      "svg",
      {
        width: "100%",
        height: r,
        viewBox: `0 0 ${t} ${r}`,
        preserveAspectRatio: "none",
        children: /* @__PURE__ */ h.jsx(
          "line",
          {
            x1: "0",
            y1: r / 2,
            x2: t,
            y2: r / 2,
            stroke: n.color,
            strokeWidth: r,
            strokeDasharray: n.dashPattern.join(" "),
            vectorEffect: "non-scaling-stroke"
          }
        )
      }
    ) }),
    /* @__PURE__ */ h.jsx(WS, { children: n.label })
  ] }, `${n.label}-${o}`);
}) }), "LegendLine"), ZS = me(ge)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 90px;
`, US = me.span`
  font-size: ${({ theme: e }) => e.fontSizes.body.m};
  font-weight: ${({ theme: e }) => e.fontWeights.bold};
  color: ${({ theme: e }) => e.palette.primary.darkGrey};
`, GS = me(Cu)`
  && {
    width: 100%;
    border: 1px solid ${({ theme: e }) => e.palette.primary.darkGrey4};
    border-radius: 4px;
    padding: 4px 8px;
    background-color: transparent;
    color: ${({ theme: e }) => e.palette.primary.darkGrey};
    font-size: ${({ theme: e }) => e.fontSizes.body.m};

    svg {
      color: ${({ theme: e }) => e.palette.primary.darkGrey};
      width: 12px;
      height: 12px;
    }

    fieldset {
      border: none;
    }

    &.Mui-disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
`, YS = me(Ac)`
  && {
    font-style: normal;
    font-weight: ${({ theme: e }) => e.fontWeights.regular};
    font-size: ${({ theme: e }) => e.fontSizes.body.m};
    color: ${({ theme: e }) => e.palette.primary.darkGrey};
    line-height: 16px;
    background-color: ${({ theme: e }) => e.palette.primary.white};
    justify-content: normal;
    min-height: unset;
    margin: 0 5px;
    border-radius: 4px;
    white-space: normal;
    word-wrap: break-word;

    &.Mui-selected {
      background-color: ${({ theme: e }) => e.palette.primary.white};
      border: 1px solid ${({ theme: e }) => e.palette.primary.mediumBlue2};
      &:hover {
        background-color: ${({ theme: e }) => e.palette.primary.lightGrey4};
      }
    }

    &.Mui-focusVisible {
      background-color: ${({ theme: e }) => e.palette.primary.lightGrey4};
    }

    &:hover {
      background-color: ${({ theme: e }) => e.palette.primary.lightGrey4};
    }
  }
`, qS = me.span`
  font-style: normal;
  font-size: ${({ theme: e }) => e.fontSizes.body.m};
  color: ${({ theme: e }) => e.palette.primary.darkGrey};
  opacity: 0.7;
`, KS = {
  backgroundColor: "inherit",
  border: "none",
  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  maxHeight: "185px",
  gap: "4px",
  "&::-webkit-scrollbar": {
    width: "5px",
    height: "5px"
  },
  "&::-webkit-scrollbar-track": {
    backgroundImage: "none"
  },
  "::-webkit-scrollbar-track:vertical": {
    backgroundSize: "1px 100%"
  },
  "::-webkit-scrollbar-track:horizontal": {
    backgroundSize: "100% 1px"
  },
  "&::-webkit-scrollbar-thumb": {
    background: `${at.palette.primary.mediumGrey3}B3`,
    borderRadius: "8px"
  }
}, pk = /* @__PURE__ */ a(({
  label: e = "Year",
  selectedYear: t,
  yearOptions: n,
  onYearChange: o,
  disabled: r = !1,
  placeholder: i = "—"
}) => {
  const l = /* @__PURE__ */ a((c) => {
    const {
      target: { value: d }
    } = c;
    o == null || o(d);
  }, "handleChange");
  return /* @__PURE__ */ h.jsxs(ZS, { "data-testid": "legend-year-selector", children: [
    /* @__PURE__ */ h.jsx(US, { children: e }),
    /* @__PURE__ */ h.jsx(
      GS,
      {
        "data-testid": "legend-year-select",
        value: t || "",
        onChange: /* @__PURE__ */ a((c) => l(c), "onChange"),
        disabled: r || !(n != null && n.length),
        displayEmpty: !0,
        MenuProps: {
          PaperProps: {
            sx: {
              ...KS,
              backgroundColor: at.palette.primary.white
            },
            style: {
              marginTop: "4px"
            }
          }
        },
        renderValue: /* @__PURE__ */ a((c) => {
          var u;
          const d = c;
          return d ? ((u = n.find((p) => p.value === d)) == null ? void 0 : u.label) || d : /* @__PURE__ */ h.jsx(qS, { children: i });
        }, "renderValue"),
        children: n == null ? void 0 : n.map((c) => /* @__PURE__ */ h.jsx(YS, { value: c.value, children: c.label }, c.value))
      }
    )
  ] });
}, "LegendYearSelector");
Nr.register(Va, Aa, Ia, G1, pu, hu, du);
const fk = /* @__PURE__ */ a(({ labels: e, datasets: t, title: n, maxYValue: o }) => {
  const r = H6(), i = /* @__PURE__ */ a((C, g) => {
    const y = C[g] !== null && C[g] !== void 0;
    if (!y) return !1;
    const w = g > 0 ? C[g - 1] !== null && C[g - 1] !== void 0 : !1, T = g < C.length - 1 ? C[g + 1] !== null && C[g + 1] !== void 0 : !1;
    return y && !w && !T;
  }, "shouldShowPoint"), l = /* @__PURE__ */ a((C) => C.map((g, y) => i(C, y) ? 3 : 0), "createPointRadiusArray"), c = /* @__PURE__ */ a((C, g = "circle") => C.map((y, w) => i(C, w) ? g : "circle"), "createPointStyleArray"), d = Ur(() => {
    const C = e.map((y) => Number(y));
    return C.every((y) => Number.isFinite(y) && Number.isInteger(y)) ? C : null;
  }, [e]), u = Ur(() => d ? new Set(d).size >= 10 : !1, [d]), p = Ur(() => {
    if (d)
      return d[0];
  }, [d]), f = Ur(() => {
    if (d)
      return d[d.length - 1];
  }, [d]), m = Ur(
    () => ({
      labels: e,
      datasets: t.map((C) => {
        const g = C.data.map((y) => y && y > 0 && (!o || y < o) ? y : null);
        return {
          label: C.label,
          data: g,
          borderColor: C.color,
          backgroundColor: C.color,
          borderDash: C.dashPattern,
          pointRadius: l(g),
          pointStyle: c(g, "circle"),
          pointBackgroundColor: C.color,
          pointBorderColor: C.color,
          pointHoverRadius: l(g).map((y) => y > 0 ? y + 2 : 5)
        };
      })
    }),
    [e, t]
  ), b = {
    responsive: !0,
    maintainAspectRatio: !1,
    plugins: {
      legend: {
        display: !1
      },
      title: n ? {
        display: !0,
        text: n,
        align: "start",
        color: r.palette.primary.darkGrey3,
        font: {
          family: r.fontFamilies.Roboto,
          size: 18,
          weight: "bold"
        },
        padding: {
          top: 32,
          bottom: 32
        }
      } : void 0,
      tooltip: {
        mode: "nearest",
        intersect: !1,
        position: "nearest",
        callbacks: {
          title: /* @__PURE__ */ a((C) => `${C[0].label}`, "title"),
          label: /* @__PURE__ */ a((C) => {
            var g;
            return `${C.dataset.label}: ${((g = C.parsed.y) == null ? void 0 : g.toLocaleString()) || "No data"}`;
          }, "label")
        }
      },
      datalabels: {
        display: !1
      }
    },
    scales: {
      x: {
        display: !0,
        border: {
          display: !1
        },
        grid: {
          display: !1
        },
        ticks: u ? {
          autoSkip: !1,
          // let our callback control visibility
          maxRotation: 0,
          callback: /* @__PURE__ */ a(function(C) {
            const g = C, y = Number(e[g]);
            return !Number.isFinite(y) || p === void 0 || f === void 0 ? this.getLabelForValue(g) : (y - p) % 5 === 0 || y === f ? String(y) : "";
          }, "callback")
        } : {
          // Default behavior when labels aren't years or <10 items
          autoSkip: !0,
          maxRotation: 0
        }
      },
      y: {
        display: !0,
        ticks: { precision: 0 },
        border: {
          dash: [4, 4],
          color: "rgba(223, 219, 219, 1)",
          width: 1.5
        },
        grid: {
          display: !0,
          color: "rgba(223, 219, 219, 1)"
        },
        beginAtZero: !0
      }
    },
    elements: {
      line: {
        borderWidth: 3,
        tension: 0
      }
    },
    interaction: {
      intersect: !0,
      mode: "nearest",
      axis: "xy"
    }
  };
  return /* @__PURE__ */ h.jsx(Dv, { data: m, options: b });
}, "LineChart"), XS = D6`
  0%, 60%, 100% {
    transform: scale(0.6);
    opacity: 0.4;
  }
  30% {
    transform: scale(1);
    opacity: 1;
  }
`, JS = Q(ge)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  z-index: 600;
`, i1 = Q(ge)`
  width: 8px;
  height: 8px;
  background-color: ${({ theme: e }) => e.palette.primary.darkGrey2};
  border-radius: 50%;
  animation: ${XS} 1.4s ease-in-out infinite;
  animation-delay: ${(e) => e.$delay}s;
`, QS = Q(ge)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ theme: e }) => e.palette.primary.white + e.palette.opacity[80]};
  z-index: 500;
  pointer-events: auto;
`, hk = /* @__PURE__ */ a(({ isVisible: e, withOverlay: t = !0 }) => e ? /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
  t && /* @__PURE__ */ h.jsx(QS, {}),
  /* @__PURE__ */ h.jsxs(JS, { children: [
    /* @__PURE__ */ h.jsx(i1, { $delay: 0 }),
    /* @__PURE__ */ h.jsx(i1, { $delay: 0.2 }),
    /* @__PURE__ */ h.jsx(i1, { $delay: 0.4 })
  ] })
] }) : null, "LoaderDots"), eM = Q(hl)`
  z-index: 9999 !important;
  background-color: white;
  pointer-events: none !important;
  backdrop-filter: saturate(250%) blur(8px);
  backface-visibility: hidden;
`, tM = Q(ge)`
  animation: zoominout 1s infinite;
  svg {
    width: 120px;
    height: 120px;
  }
`, gk = /* @__PURE__ */ a(() => /* @__PURE__ */ h.jsx(eM, { "data-testid": "loading-backdrop", open: !0, $bgColor: at.palette.primary.darkGrey, children: /* @__PURE__ */ h.jsx(tM, { "data-testid": "loading-backdrop.wrapper", children: /* @__PURE__ */ h.jsx(aw, {}) }) }), "LoadingBackdrop"), nM = Q(Rc)`
  .MuiPaper-root {
    position: relative;
    width: 818px;
    height: auto;
    padding: 16px;
    background-color: ${({ theme: e }) => e.palette.primary.darkGrey};
  }

  .MuiDialog-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 30px;
    height: 100%;
  }

  .MuiBackdrop-root {
    opacity: 0.15 !important;
    background-color: ${({ theme: e }) => e.palette.primary.darkGrey};
    backface-visibility: hidden;
  }
`, oM = Q(ge)`
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 0;
  justify-content: ${(e) => e.$hasTitle ? "space-between" : "flex-end"};
`, rM = Q.h4`
  color: ${(e) => e.theme.palette.primary.white};
  margin: 0;
  line-height: 26px;
`, iM = Q(ge)`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  color: ${({ theme: e }) => e.palette.primary.white};
`, sM = Q(po)`
  justify-content: flex-end;
  padding: 0 !important;

  && {
    color: ${({ theme: e }) => e.palette.primary.white};
  }

  svg {
    height: 20px;
    width: 20px;
  }
`, mk = /* @__PURE__ */ a(({ isOpen: e, modalTitle: t, children: n, onClose: o }) => /* @__PURE__ */ h.jsxs(
  nM,
  {
    open: e,
    className: "modal-wrapper",
    "data-testid": "modal.wrapper",
    onClose: /* @__PURE__ */ a((r, i) => {
      i && i === "backdropClick" || o();
    }, "onClose"),
    maxWidth: "lg",
    children: [
      /* @__PURE__ */ h.jsxs(oM, { $hasTitle: !!t, children: [
        t && /* @__PURE__ */ h.jsx(rM, { children: t }),
        o && /* @__PURE__ */ h.jsx(sM, { onClick: o, "data-testid": "close-modal-testid", children: /* @__PURE__ */ h.jsx(Ha, {}) })
      ] }),
      /* @__PURE__ */ h.jsx(iM, { "data-testid": "modal.dialog-body", className: "modal-body", children: n })
    ]
  }
), "Modal"), aM = me(
  ge
)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: 24px;
  height: 290px;
  width: 100%;
  min-width: 210px;
  padding: 24px 8px;
  border-radius: 4px;
  background-image: linear-gradient(rgba(22, 36, 45, 0), 45%, rgba(22, 36, 45, 1) 65%);
  background-color: ${({ theme: e }) => e.palette.primary.darkGrey};
  color: ${({ theme: e }) => e.palette.primary.white};
  box-shadow: 0 4px 8px 0
    ${({ theme: e }) => e.palette.primary.darkBlue}${({ theme: e }) => e.palette.opacity[40]};
  z-index: 0; /* Create stacking context */

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url(${(e) => e.$backgroundImage});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 4px;
    filter: ${(e) => e.$isInPOC ? "none" : "grayscale(100%)"};
    z-index: 1;
  }

  /* Gradient overlay using ::after */
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: linear-gradient(rgba(22, 36, 45, 0), 45%, rgba(22, 36, 45, 1) 65%);
    border-radius: 4px;
    z-index: 2;
    pointer-events: none;
  }

  /* Ensure content appears above everything */
  & > * {
    position: relative;
    z-index: 3;
  }

  &:hover {
    &::after {
      background-image: linear-gradient(rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 1) 45%);
    }

    color: ${({ theme: e }) => e.palette.primary.darkBlue};
    transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);

    .card-description {
      display: block;
    }

    .navigate-button {
      color: ${({ $isInPOC: e, theme: t }) => e ? t.palette.primary.white : t.palette.primary.neutralGreyDark};
      background-color: ${({ $isInPOC: e, theme: t }) => e ? t.palette.primary.secondaryBlue : t.palette.primary.neutralGrey2};
    }
  }
`, lM = me(ge)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 8px;

  svg {
    width: 24px;
    height: auto;
    max-height: 24px;
    flex-shrink: 0;
  }
`, cM = me.p`
  font-size: ${({ theme: e }) => e.fontSizes.body.xl};
  font-weight: ${({ theme: e }) => e.fontWeights.bold};
`, dM = me.p`
  text-align: center;
  display: none;
  font-size: 16px;
  font-weight: 400;
  line-height: 100%;
`, uM = me(gl)`
  && {
    width: 142px;
    color: ${({ $isInPOC: e, theme: t }) => e ? t.palette.primary.mediumBlue : t.palette.primary.neutralGrey1};

    border-radius: 0;
    text-transform: none;
    font-size: ${({ theme: e }) => e.fontSizes.body.m};
    font-weight: ${({ theme: e }) => e.fontWeights.bold};
  }
`, bk = /* @__PURE__ */ a(({
  title: e,
  description: t,
  backgroundImg: n,
  icon: o,
  linkUrl: r,
  onNavigate: i,
  isInPOC: l = !0,
  buttonLabel: c,
  disabled: d = !1
}) => /* @__PURE__ */ h.jsxs(aM, { $backgroundImage: n ?? "", $isInPOC: l, children: [
  /* @__PURE__ */ h.jsxs(lM, { className: "card-title", children: [
    o,
    /* @__PURE__ */ h.jsx(cM, { children: e })
  ] }),
  t && /* @__PURE__ */ h.jsx(dM, { className: "card-description", children: t }),
  /* @__PURE__ */ h.jsx(
    uM,
    {
      $isInPOC: l,
      variant: "text",
      className: "navigate-button",
      onClick: /* @__PURE__ */ a(() => i == null ? void 0 : i(r), "onClick"),
      endIcon: l ? /* @__PURE__ */ h.jsx(Gv, {}) : null,
      disabled: d,
      children: c
    }
  )
] }), "NavCard"), pM = Q.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
  background-color: lightgray;
  color: lightgray;
`;
Q.div`
  margin-bottom: 1rem;

  svg {
    width: 200px;
    height: 200px;
  }
`;
const fM = Q.h1`
  color: blue;
  font-size: 80px;
  font-weight: 600;
  margin-bottom: 3rem;
`, hM = Q.h4`
  margin-bottom: 3rem;
`, Ck = /* @__PURE__ */ a(({ onClickHandler: e }) => /* @__PURE__ */ h.jsxs(pM, { children: [
  /* @__PURE__ */ h.jsx(fM, { children: "Not Found title" }),
  /* @__PURE__ */ h.jsx(hM, { children: "Not found subtitle" }),
  /* @__PURE__ */ h.jsx("button", { onClick: /* @__PURE__ */ a(() => e(), "onClick"), children: "Go back" })
] }), "NotFoundContent");
/*!
 * chartjs-plugin-datalabels v2.2.0
 * https://chartjs-plugin-datalabels.netlify.app
 * (c) 2017-2022 chartjs-plugin-datalabels contributors
 * Released under the MIT license
 */
var L6 = function() {
  if (typeof window < "u") {
    if (window.devicePixelRatio)
      return window.devicePixelRatio;
    var e = window.screen;
    if (e)
      return (e.deviceXDPI || 1) / (e.logicalXDPI || 1);
  }
  return 1;
}(), Oi = {
  // @todo move this in Chart.helpers.toTextLines
  toTextLines: /* @__PURE__ */ a(function(e) {
    var t = [], n;
    for (e = [].concat(e); e.length; )
      n = e.pop(), typeof n == "string" ? t.unshift.apply(t, n.split(`
`)) : Array.isArray(n) ? e.push.apply(e, n) : He(e) || t.unshift("" + n);
    return t;
  }, "toTextLines"),
  // @todo move this in Chart.helpers.canvas.textSize
  // @todo cache calls of measureText if font doesn't change?!
  textSize: /* @__PURE__ */ a(function(e, t, n) {
    var o = [].concat(t), r = o.length, i = e.font, l = 0, c;
    for (e.font = n.string, c = 0; c < r; ++c)
      l = Math.max(e.measureText(o[c]).width, l);
    return e.font = i, {
      height: r * n.lineHeight,
      width: l
    };
  }, "textSize"),
  /**
   * Returns value bounded by min and max. This is equivalent to max(min, min(value, max)).
   * @todo move this method in Chart.helpers.bound
   * https://doc.qt.io/qt-5/qtglobal.html#qBound
   */
  bound: /* @__PURE__ */ a(function(e, t, n) {
    return Math.max(e, Math.min(t, n));
  }, "bound"),
  /**
   * Returns an array of pair [value, state] where state is:
   * * -1: value is only in a0 (removed)
   * *  1: value is only in a1 (added)
   */
  arrayDiff: /* @__PURE__ */ a(function(e, t) {
    var n = e.slice(), o = [], r, i, l, c;
    for (r = 0, l = t.length; r < l; ++r)
      c = t[r], i = n.indexOf(c), i === -1 ? o.push([c, 1]) : n.splice(i, 1);
    for (r = 0, l = n.length; r < l; ++r)
      o.push([n[r], -1]);
    return o;
  }, "arrayDiff"),
  /**
   * https://github.com/chartjs/chartjs-plugin-datalabels/issues/70
   */
  rasterize: /* @__PURE__ */ a(function(e) {
    return Math.round(e * L6) / L6;
  }, "rasterize")
};
function s1(e, t) {
  var n = t.x, o = t.y;
  if (n === null)
    return { x: 0, y: -1 };
  if (o === null)
    return { x: 1, y: 0 };
  var r = e.x - n, i = e.y - o, l = Math.sqrt(r * r + i * i);
  return {
    x: l ? r / l : 0,
    y: l ? i / l : -1
  };
}
a(s1, "orient");
function gM(e, t, n, o, r) {
  switch (r) {
    case "center":
      n = o = 0;
      break;
    case "bottom":
      n = 0, o = 1;
      break;
    case "right":
      n = 1, o = 0;
      break;
    case "left":
      n = -1, o = 0;
      break;
    case "top":
      n = 0, o = -1;
      break;
    case "start":
      n = -n, o = -o;
      break;
    case "end":
      break;
    default:
      r *= Math.PI / 180, n = Math.cos(r), o = Math.sin(r);
      break;
  }
  return {
    x: e,
    y: t,
    vx: n,
    vy: o
  };
}
a(gM, "aligned");
var mM = 0, xu = 1, vu = 2, wu = 4, Su = 8;
function Ws(e, t, n) {
  var o = mM;
  return e < n.left ? o |= xu : e > n.right && (o |= vu), t < n.top ? o |= Su : t > n.bottom && (o |= wu), o;
}
a(Ws, "region");
function bM(e, t) {
  for (var n = e.x0, o = e.y0, r = e.x1, i = e.y1, l = Ws(n, o, t), c = Ws(r, i, t), d, u, p; !(!(l | c) || l & c); )
    d = l || c, d & Su ? (u = n + (r - n) * (t.top - o) / (i - o), p = t.top) : d & wu ? (u = n + (r - n) * (t.bottom - o) / (i - o), p = t.bottom) : d & vu ? (p = o + (i - o) * (t.right - n) / (r - n), u = t.right) : d & xu && (p = o + (i - o) * (t.left - n) / (r - n), u = t.left), d === l ? (n = u, o = p, l = Ws(n, o, t)) : (r = u, i = p, c = Ws(r, i, t));
  return {
    x0: n,
    x1: r,
    y0: o,
    y1: i
  };
}
a(bM, "clipped");
function Zs(e, t) {
  var n = t.anchor, o = e, r, i;
  return t.clamp && (o = bM(o, t.area)), n === "start" ? (r = o.x0, i = o.y0) : n === "end" ? (r = o.x1, i = o.y1) : (r = (o.x0 + o.x1) / 2, i = (o.y0 + o.y1) / 2), gM(r, i, e.vx, e.vy, t.align);
}
a(Zs, "compute$1");
var Us = {
  arc: /* @__PURE__ */ a(function(e, t) {
    var n = (e.startAngle + e.endAngle) / 2, o = Math.cos(n), r = Math.sin(n), i = e.innerRadius, l = e.outerRadius;
    return Zs({
      x0: e.x + o * i,
      y0: e.y + r * i,
      x1: e.x + o * l,
      y1: e.y + r * l,
      vx: o,
      vy: r
    }, t);
  }, "arc"),
  point: /* @__PURE__ */ a(function(e, t) {
    var n = s1(e, t.origin), o = n.x * e.options.radius, r = n.y * e.options.radius;
    return Zs({
      x0: e.x - o,
      y0: e.y - r,
      x1: e.x + o,
      y1: e.y + r,
      vx: n.x,
      vy: n.y
    }, t);
  }, "point"),
  bar: /* @__PURE__ */ a(function(e, t) {
    var n = s1(e, t.origin), o = e.x, r = e.y, i = 0, l = 0;
    return e.horizontal ? (o = Math.min(e.x, e.base), i = Math.abs(e.base - e.x)) : (r = Math.min(e.y, e.base), l = Math.abs(e.base - e.y)), Zs({
      x0: o,
      y0: r + l,
      x1: o + i,
      y1: r,
      vx: n.x,
      vy: n.y
    }, t);
  }, "bar"),
  fallback: /* @__PURE__ */ a(function(e, t) {
    var n = s1(e, t.origin);
    return Zs({
      x0: e.x,
      y0: e.y,
      x1: e.x + (e.width || 0),
      y1: e.y + (e.height || 0),
      vx: n.x,
      vy: n.y
    }, t);
  }, "fallback")
}, so = Oi.rasterize;
function CM(e) {
  var t = e.borderWidth || 0, n = e.padding, o = e.size.height, r = e.size.width, i = -r / 2, l = -o / 2;
  return {
    frame: {
      x: i - n.left - t,
      y: l - n.top - t,
      w: r + n.width + t * 2,
      h: o + n.height + t * 2
    },
    text: {
      x: i,
      y: l,
      w: r,
      h: o
    }
  };
}
a(CM, "boundingRects");
function yM(e, t) {
  var n = t.chart.getDatasetMeta(t.datasetIndex).vScale;
  if (!n)
    return null;
  if (n.xCenter !== void 0 && n.yCenter !== void 0)
    return { x: n.xCenter, y: n.yCenter };
  var o = n.getBasePixel();
  return e.horizontal ? { x: o, y: null } : { x: null, y: o };
}
a(yM, "getScaleOrigin");
function xM(e) {
  return e instanceof Ra ? Us.arc : e instanceof Ia ? Us.point : e instanceof ja ? Us.bar : Us.fallback;
}
a(xM, "getPositioner");
function vM(e, t, n, o, r, i) {
  var l = Math.PI / 2;
  if (i) {
    var c = Math.min(i, r / 2, o / 2), d = t + c, u = n + c, p = t + o - c, f = n + r - c;
    e.moveTo(t, u), d < p && u < f ? (e.arc(d, u, c, -Math.PI, -l), e.arc(p, u, c, -l, 0), e.arc(p, f, c, 0, l), e.arc(d, f, c, l, Math.PI)) : d < p ? (e.moveTo(d, n), e.arc(p, u, c, -l, l), e.arc(d, u, c, l, Math.PI + l)) : u < f ? (e.arc(d, u, c, -Math.PI, 0), e.arc(d, f, c, 0, Math.PI)) : e.arc(d, u, c, -Math.PI, Math.PI), e.closePath(), e.moveTo(t, n);
  } else
    e.rect(t, n, o, r);
}
a(vM, "drawRoundedRect");
function wM(e, t, n) {
  var o = n.backgroundColor, r = n.borderColor, i = n.borderWidth;
  !o && (!r || !i) || (e.beginPath(), vM(
    e,
    so(t.x) + i / 2,
    so(t.y) + i / 2,
    so(t.w) - i,
    so(t.h) - i,
    n.borderRadius
  ), e.closePath(), o && (e.fillStyle = o, e.fill()), r && i && (e.strokeStyle = r, e.lineWidth = i, e.lineJoin = "miter", e.stroke()));
}
a(wM, "drawFrame");
function SM(e, t, n) {
  var o = n.lineHeight, r = e.w, i = e.x, l = e.y + o / 2;
  return t === "center" ? i += r / 2 : (t === "end" || t === "right") && (i += r), {
    h: o,
    w: r,
    x: i,
    y: l
  };
}
a(SM, "textGeometry");
function MM(e, t, n) {
  var o = e.shadowBlur, r = n.stroked, i = so(n.x), l = so(n.y), c = so(n.w);
  r && e.strokeText(t, i, l, c), n.filled && (o && r && (e.shadowBlur = 0), e.fillText(t, i, l, c), o && r && (e.shadowBlur = o));
}
a(MM, "drawTextLine");
function TM(e, t, n, o) {
  var r = o.textAlign, i = o.color, l = !!i, c = o.font, d = t.length, u = o.textStrokeColor, p = o.textStrokeWidth, f = u && p, m;
  if (!(!d || !l && !f))
    for (n = SM(n, r, c), e.font = c.string, e.textAlign = r, e.textBaseline = "middle", e.shadowBlur = o.textShadowBlur, e.shadowColor = o.textShadowColor, l && (e.fillStyle = i), f && (e.lineJoin = "round", e.lineWidth = p, e.strokeStyle = u), m = 0, d = t.length; m < d; ++m)
      MM(e, t[m], {
        stroked: f,
        filled: l,
        w: n.w,
        x: n.x,
        y: n.y + n.h * m
      });
}
a(TM, "drawText");
var Mu = /* @__PURE__ */ a(function(e, t, n, o) {
  var r = this;
  r._config = e, r._index = o, r._model = null, r._rects = null, r._ctx = t, r._el = n;
}, "Label");
Jn(Mu.prototype, {
  /**
   * @private
   */
  _modelize: /* @__PURE__ */ a(function(e, t, n, o) {
    var r = this, i = r._index, l = Lt(dt([n.font, {}], o, i)), c = dt([n.color, yt.color], o, i);
    return {
      align: dt([n.align, "center"], o, i),
      anchor: dt([n.anchor, "center"], o, i),
      area: o.chart.chartArea,
      backgroundColor: dt([n.backgroundColor, null], o, i),
      borderColor: dt([n.borderColor, null], o, i),
      borderRadius: dt([n.borderRadius, 0], o, i),
      borderWidth: dt([n.borderWidth, 0], o, i),
      clamp: dt([n.clamp, !1], o, i),
      clip: dt([n.clip, !1], o, i),
      color: c,
      display: e,
      font: l,
      lines: t,
      offset: dt([n.offset, 4], o, i),
      opacity: dt([n.opacity, 1], o, i),
      origin: yM(r._el, o),
      padding: pn(dt([n.padding, 4], o, i)),
      positioner: xM(r._el),
      rotation: dt([n.rotation, 0], o, i) * (Math.PI / 180),
      size: Oi.textSize(r._ctx, t, l),
      textAlign: dt([n.textAlign, "start"], o, i),
      textShadowBlur: dt([n.textShadowBlur, 0], o, i),
      textShadowColor: dt([n.textShadowColor, c], o, i),
      textStrokeColor: dt([n.textStrokeColor, c], o, i),
      textStrokeWidth: dt([n.textStrokeWidth, 0], o, i)
    };
  }, "_modelize"),
  update: /* @__PURE__ */ a(function(e) {
    var t = this, n = null, o = null, r = t._index, i = t._config, l, c, d, u = dt([i.display, !0], e, r);
    u && (l = e.dataset.data[r], c = je(st(i.formatter, [l, e]), l), d = He(c) ? [] : Oi.toTextLines(c), d.length && (n = t._modelize(u, d, i, e), o = CM(n))), t._model = n, t._rects = o;
  }, "update"),
  geometry: /* @__PURE__ */ a(function() {
    return this._rects ? this._rects.frame : {};
  }, "geometry"),
  rotation: /* @__PURE__ */ a(function() {
    return this._model ? this._model.rotation : 0;
  }, "rotation"),
  visible: /* @__PURE__ */ a(function() {
    return this._model && this._model.opacity;
  }, "visible"),
  model: /* @__PURE__ */ a(function() {
    return this._model;
  }, "model"),
  draw: /* @__PURE__ */ a(function(e, t) {
    var n = this, o = e.ctx, r = n._model, i = n._rects, l;
    this.visible() && (o.save(), r.clip && (l = r.area, o.beginPath(), o.rect(
      l.left,
      l.top,
      l.right - l.left,
      l.bottom - l.top
    ), o.clip()), o.globalAlpha = Oi.bound(0, r.opacity, 1), o.translate(so(t.x), so(t.y)), o.rotate(r.rotation), wM(o, i.frame, r), TM(o, r.lines, i.text, r), o.restore());
  }, "draw")
});
var kM = Number.MIN_SAFE_INTEGER || -9007199254740991, OM = Number.MAX_SAFE_INTEGER || 9007199254740991;
function li(e, t, n) {
  var o = Math.cos(n), r = Math.sin(n), i = t.x, l = t.y;
  return {
    x: i + o * (e.x - i) - r * (e.y - l),
    y: l + r * (e.x - i) + o * (e.y - l)
  };
}
a(li, "rotated");
function V6(e, t) {
  var n = OM, o = kM, r = t.origin, i, l, c, d, u;
  for (i = 0; i < e.length; ++i)
    l = e[i], c = l.x - r.x, d = l.y - r.y, u = t.vx * c + t.vy * d, n = Math.min(n, u), o = Math.max(o, u);
  return {
    min: n,
    max: o
  };
}
a(V6, "projected");
function Gs(e, t) {
  var n = t.x - e.x, o = t.y - e.y, r = Math.sqrt(n * n + o * o);
  return {
    vx: (t.x - e.x) / r,
    vy: (t.y - e.y) / r,
    origin: e,
    ln: r
  };
}
a(Gs, "toAxis");
var Tu = /* @__PURE__ */ a(function() {
  this._rotation = 0, this._rect = {
    x: 0,
    y: 0,
    w: 0,
    h: 0
  };
}, "HitBox");
Jn(Tu.prototype, {
  center: /* @__PURE__ */ a(function() {
    var e = this._rect;
    return {
      x: e.x + e.w / 2,
      y: e.y + e.h / 2
    };
  }, "center"),
  update: /* @__PURE__ */ a(function(e, t, n) {
    this._rotation = n, this._rect = {
      x: t.x + e.x,
      y: t.y + e.y,
      w: t.w,
      h: t.h
    };
  }, "update"),
  contains: /* @__PURE__ */ a(function(e) {
    var t = this, n = 1, o = t._rect;
    return e = li(e, t.center(), -t._rotation), !(e.x < o.x - n || e.y < o.y - n || e.x > o.x + o.w + n * 2 || e.y > o.y + o.h + n * 2);
  }, "contains"),
  // Separating Axis Theorem
  // https://gamedevelopment.tutsplus.com/tutorials/collision-detection-using-the-separating-axis-theorem--gamedev-169
  intersects: /* @__PURE__ */ a(function(e) {
    var t = this._points(), n = e._points(), o = [
      Gs(t[0], t[1]),
      Gs(t[0], t[3])
    ], r, i, l;
    for (this._rotation !== e._rotation && o.push(
      Gs(n[0], n[1]),
      Gs(n[0], n[3])
    ), r = 0; r < o.length; ++r)
      if (i = V6(t, o[r]), l = V6(n, o[r]), i.max < l.min || l.max < i.min)
        return !1;
    return !0;
  }, "intersects"),
  /**
   * @private
   */
  _points: /* @__PURE__ */ a(function() {
    var e = this, t = e._rect, n = e._rotation, o = e.center();
    return [
      li({ x: t.x, y: t.y }, o, n),
      li({ x: t.x + t.w, y: t.y }, o, n),
      li({ x: t.x + t.w, y: t.y + t.h }, o, n),
      li({ x: t.x, y: t.y + t.h }, o, n)
    ];
  }, "_points")
});
function ku(e, t, n) {
  var o = t.positioner(e, t), r = o.vx, i = o.vy;
  if (!r && !i)
    return { x: o.x, y: o.y };
  var l = n.w, c = n.h, d = t.rotation, u = Math.abs(l / 2 * Math.cos(d)) + Math.abs(c / 2 * Math.sin(d)), p = Math.abs(l / 2 * Math.sin(d)) + Math.abs(c / 2 * Math.cos(d)), f = 1 / Math.max(Math.abs(r), Math.abs(i));
  return u *= r * f, p *= i * f, u += t.offset * r, p += t.offset * i, {
    x: o.x + u,
    y: o.y + p
  };
}
a(ku, "coordinates");
function EM(e, t) {
  var n, o, r, i;
  for (n = e.length - 1; n >= 0; --n)
    for (r = e[n].$layout, o = n - 1; o >= 0 && r._visible; --o)
      i = e[o].$layout, i._visible && r._box.intersects(i._box) && t(r, i);
  return e;
}
a(EM, "collide");
function $M(e) {
  var t, n, o, r, i, l, c;
  for (t = 0, n = e.length; t < n; ++t)
    o = e[t], r = o.$layout, r._visible && (c = new Proxy(o._el, { get: /* @__PURE__ */ a((d, u) => d.getProps([u], !0)[u], "get") }), i = o.geometry(), l = ku(c, o.model(), i), r._box.update(l, i, o.rotation()));
  return EM(e, function(d, u) {
    var p = d._hidable, f = u._hidable;
    p && f || f ? u._visible = !1 : p && (d._visible = !1);
  });
}
a($M, "compute");
var Ei = {
  prepare: /* @__PURE__ */ a(function(e) {
    var t = [], n, o, r, i, l;
    for (n = 0, r = e.length; n < r; ++n)
      for (o = 0, i = e[n].length; o < i; ++o)
        l = e[n][o], t.push(l), l.$layout = {
          _box: new Tu(),
          _hidable: !1,
          _visible: !0,
          _set: n,
          _idx: l._index
        };
    return t.sort(function(c, d) {
      var u = c.$layout, p = d.$layout;
      return u._idx === p._idx ? p._set - u._set : p._idx - u._idx;
    }), this.update(t), t;
  }, "prepare"),
  update: /* @__PURE__ */ a(function(e) {
    var t = !1, n, o, r, i, l;
    for (n = 0, o = e.length; n < o; ++n)
      r = e[n], i = r.model(), l = r.$layout, l._hidable = i && i.display === "auto", l._visible = r.visible(), t |= l._hidable;
    t && $M(e);
  }, "update"),
  lookup: /* @__PURE__ */ a(function(e, t) {
    var n, o;
    for (n = e.length - 1; n >= 0; --n)
      if (o = e[n].$layout, o && o._visible && o._box.contains(t))
        return e[n];
    return null;
  }, "lookup"),
  draw: /* @__PURE__ */ a(function(e, t) {
    var n, o, r, i, l, c;
    for (n = 0, o = t.length; n < o; ++n)
      r = t[n], i = r.$layout, i._visible && (l = r.geometry(), c = ku(r._el, r.model(), l), i._box.update(c, l, r.rotation()), r.draw(e, c));
  }, "draw")
}, PM = /* @__PURE__ */ a(function(e) {
  if (He(e))
    return null;
  var t = e, n, o, r;
  if (Ne(e))
    if (!He(e.label))
      t = e.label;
    else if (!He(e.r))
      t = e.r;
    else
      for (t = "", n = Object.keys(e), r = 0, o = n.length; r < o; ++r)
        t += (r !== 0 ? ", " : "") + n[r] + ": " + e[n[r]];
  return "" + t;
}, "formatter"), _M = {
  align: "center",
  anchor: "center",
  backgroundColor: null,
  borderColor: null,
  borderRadius: 0,
  borderWidth: 0,
  clamp: !1,
  clip: !1,
  color: void 0,
  display: !0,
  font: {
    family: void 0,
    lineHeight: 1.2,
    size: void 0,
    style: void 0,
    weight: null
  },
  formatter: PM,
  labels: void 0,
  listeners: {},
  offset: 4,
  opacity: 1,
  padding: {
    top: 4,
    right: 4,
    bottom: 4,
    left: 4
  },
  rotation: 0,
  textAlign: "start",
  textStrokeColor: void 0,
  textStrokeWidth: 0,
  textShadowBlur: 0,
  textShadowColor: void 0
}, Yt = "$datalabels", Ou = "$default";
function RM(e, t) {
  var n = e.datalabels, o = {}, r = [], i, l;
  return n === !1 ? null : (n === !0 && (n = {}), t = Jn({}, [t, n]), i = t.labels || {}, l = Object.keys(i), delete t.labels, l.length ? l.forEach(function(c) {
    i[c] && r.push(Jn({}, [
      t,
      i[c],
      { _key: c }
    ]));
  }) : r.push(t), o = r.reduce(function(c, d) {
    return qe(d.listeners || {}, function(u, p) {
      c[p] = c[p] || {}, c[p][d._key || Ou] = u;
    }), delete d.listeners, c;
  }, {}), {
    labels: r,
    listeners: o
  });
}
a(RM, "configure");
function X1(e, t, n, o) {
  if (t) {
    var r = n.$context, i = n.$groups, l;
    t[i._set] && (l = t[i._set][i._key], l && st(l, [r, o]) === !0 && (e[Yt]._dirty = !0, n.update(r)));
  }
}
a(X1, "dispatchEvent");
function IM(e, t, n, o, r) {
  var i, l;
  !n && !o || (n ? o ? n !== o && (l = i = !0) : l = !0 : i = !0, l && X1(e, t.leave, n, r), i && X1(e, t.enter, o, r));
}
a(IM, "dispatchMoveEvents");
function jM(e, t) {
  var n = e[Yt], o = n._listeners, r, i;
  if (!(!o.enter && !o.leave)) {
    if (t.type === "mousemove")
      i = Ei.lookup(n._labels, t);
    else if (t.type !== "mouseout")
      return;
    r = n._hovered, n._hovered = i, IM(e, o, r, i, t);
  }
}
a(jM, "handleMoveEvents");
function LM(e, t) {
  var n = e[Yt], o = n._listeners.click, r = o && Ei.lookup(n._labels, t);
  r && X1(e, o, r, t);
}
a(LM, "handleClickEvents");
var VM = {
  id: "datalabels",
  defaults: _M,
  beforeInit: /* @__PURE__ */ a(function(e) {
    e[Yt] = {
      _actives: []
    };
  }, "beforeInit"),
  beforeUpdate: /* @__PURE__ */ a(function(e) {
    var t = e[Yt];
    t._listened = !1, t._listeners = {}, t._datasets = [], t._labels = [];
  }, "beforeUpdate"),
  afterDatasetUpdate: /* @__PURE__ */ a(function(e, t, n) {
    var o = t.index, r = e[Yt], i = r._datasets[o] = [], l = e.isDatasetVisible(o), c = e.data.datasets[o], d = RM(c, n), u = t.meta.data || [], p = e.ctx, f, m, b, C, g, y, w, T;
    for (p.save(), f = 0, b = u.length; f < b; ++f)
      if (w = u[f], w[Yt] = [], l && w && e.getDataVisibility(f) && !w.skip)
        for (m = 0, C = d.labels.length; m < C; ++m)
          g = d.labels[m], y = g._key, T = new Mu(g, p, w, f), T.$groups = {
            _set: o,
            _key: y || Ou
          }, T.$context = {
            active: !1,
            chart: e,
            dataIndex: f,
            dataset: c,
            datasetIndex: o
          }, T.update(T.$context), w[Yt].push(T), i.push(T);
    p.restore(), Jn(r._listeners, d.listeners, {
      merger: /* @__PURE__ */ a(function(x, S, M) {
        S[x] = S[x] || {}, S[x][t.index] = M[x], r._listened = !0;
      }, "merger")
    });
  }, "afterDatasetUpdate"),
  afterUpdate: /* @__PURE__ */ a(function(e) {
    e[Yt]._labels = Ei.prepare(e[Yt]._datasets);
  }, "afterUpdate"),
  // Draw labels on top of all dataset elements
  // https://github.com/chartjs/chartjs-plugin-datalabels/issues/29
  // https://github.com/chartjs/chartjs-plugin-datalabels/issues/32
  afterDatasetsDraw: /* @__PURE__ */ a(function(e) {
    Ei.draw(e, e[Yt]._labels);
  }, "afterDatasetsDraw"),
  beforeEvent: /* @__PURE__ */ a(function(e, t) {
    if (e[Yt]._listened) {
      var n = t.event;
      switch (n.type) {
        case "mousemove":
        case "mouseout":
          jM(e, n);
          break;
        case "click":
          LM(e, n);
          break;
      }
    }
  }, "beforeEvent"),
  afterEvent: /* @__PURE__ */ a(function(e) {
    var t = e[Yt], n = t._actives, o = t._actives = e.getActiveElements(), r = Oi.arrayDiff(n, o), i, l, c, d, u, p, f;
    for (i = 0, l = r.length; i < l; ++i)
      if (u = r[i], u[1])
        for (f = u[0].element[Yt] || [], c = 0, d = f.length; c < d; ++c)
          p = f[c], p.$context.active = u[1] === 1, p.update(p.$context);
    (t._dirty || r.length) && (Ei.update(t._labels), e.render()), delete t._dirty;
  }, "afterEvent")
};
Nr.register(Ea, Ra, Ji, VM);
const A6 = /* @__PURE__ */ a((e, t) => {
  if (e.length <= t) return [e];
  const n = e.split(" "), o = [];
  let r = "";
  for (const i of n)
    (r + " " + i).trim().length > t && r ? (o.push(r.trim()), r = i) : r = r ? `${r} ${i}` : i;
  return r && o.push(r.trim()), o;
}, "wrapText"), yk = /* @__PURE__ */ a(({ labels: e, data: t, colors: n, title: o, isDoughnut: r }) => {
  const i = {
    labels: e,
    datasets: [
      {
        data: t,
        backgroundColor: n
      }
    ]
  };
  return /* @__PURE__ */ h.jsx(h.Fragment, { children: r ? /* @__PURE__ */ h.jsx(
    zv,
    {
      data: i,
      options: {
        responsive: !0,
        layout: {
          padding: {
            top: 50,
            bottom: 40,
            left: 40,
            right: 30
          }
        },
        plugins: {
          legend: { display: !1 },
          title: o ? { display: !0, text: o } : void 0,
          tooltip: {
            callbacks: {
              title: /* @__PURE__ */ a((l) => {
                var c;
                return A6(((c = l[0]) == null ? void 0 : c.label) || "", 30);
              }, "title"),
              label: /* @__PURE__ */ a((l) => {
                const c = l.raw, d = l.dataset.data.reduce((p, f) => p + f, 0), u = (c / d * 100).toFixed(1);
                return `${c} (${u}%)`;
              }, "label")
            }
          },
          datalabels: {
            color: "#333",
            font: { weight: "bold", size: 13 },
            formatter: /* @__PURE__ */ a((l, c) => {
              const d = c.dataset.data.reduce((p, f) => p + f, 0), u = l / d * 100;
              return u > 2 ? `${u.toFixed(0)}%` : "";
            }, "formatter"),
            anchor: "end",
            align: "end",
            // "end" puts it outside the arc
            borderRadius: 3,
            padding: 2
          }
        },
        cutout: "50%"
      }
    }
  ) : /* @__PURE__ */ h.jsx(
    Fv,
    {
      data: i,
      options: {
        responsive: !0,
        plugins: {
          legend: { display: !1 },
          title: o ? { display: !0, text: o } : void 0,
          tooltip: {
            callbacks: {
              title: /* @__PURE__ */ a((l) => {
                var c;
                return A6(((c = l[0]) == null ? void 0 : c.label) || "", 30);
              }, "title"),
              label: /* @__PURE__ */ a((l) => {
                const c = l.raw, d = l.dataset.data.reduce((p, f) => p + f, 0), u = (c / d * 100).toFixed(1);
                return `${c} (${u}%)`;
              }, "label")
            }
          }
        }
      }
    }
  ) });
}, "PieChart"), AM = Q(ar)`
  color: ${({ theme: e }) => e.palette.primary.white};
  max-width: 100%;
`, BM = Q.p`
  font-weight: ${({ theme: e }) => e.fontWeights.bold};
  font-size: ${({ theme: e }) => e.fontSizes.headings.h5};
`, HM = Q.p`
  font-size: ${({ theme: e }) => e.fontSizes.body.m};
  line-height: 1.5;
  margin-bottom: 8px;
`, DM = Q(yd)`
  &.MuiFormGroup-root {
    gap: 8px;
    max-width: 100%;
  }
`, NM = Q(ge)`
  display: flex;
  align-items: center;
  padding: 4px 16px;
  justify-content: space-between;
  border: 1px solid #8593A5;
  border-radius: 4px;
  background: ${({ theme: e, $selected: t }) => t ? e.palette.primary.white : e.palette.primary.darkGrey};

  .MuiFormControlLabel-label {
    color: ${({ theme: e, $selected: t }) => t ? e.palette.primary.neutralBlack : e.palette.primary.white};
  }
`, zM = Q(gl)`
  color: ${({ theme: e, $selected: t }) => t ? e.palette.primary.neutralBlack : e.palette.primary.white} !important;
  text-transform: capitalize !important;

  &.MuiButton-root {
    background: transparent;
  }

  &:hover {
    background: transparent;
    color: ${({ theme: e, $selected: t }) => t ? e.palette.primary.neutralBlack : e.palette.primary.white} !important;
  }
`, FM = Q(Cd)` 
  padding: 4px; // opcional, para que quede centrado sin extra espacio
  color: ${({ theme: e }) => e.palette.primary.white};

  &.MuiRadio-root {
    .MuiTouchRipple-root {
      display: none;
    }
  }

  .MuiSvgIcon-root {
    fill: ${({ theme: e }) => e.palette.primary.white};
    stroke: ${({ theme: e }) => e.palette.primary.white};
          stroke-width: 1.5;
  }

  &.Mui-checked {
    .MuiSvgIcon-root {
      fill: ${({ theme: e }) => e.palette.primary.secondaryBlue};
      stroke: ${({ theme: e }) => e.palette.primary.secondaryBlue};
    }
  }
`, xk = /* @__PURE__ */ a(({
  header: e,
  options: t,
  value: n,
  onChange: o,
  onClear: r,
  dataTourKey: i
}) => {
  const l = /* @__PURE__ */ a((d) => {
    o(d.target.value);
  }, "handleChange"), c = /* @__PURE__ */ a(() => {
    r ? r() : o("");
  }, "handleClear");
  return /* @__PURE__ */ h.jsxs(AM, { fullWidth: !0, children: [
    (e == null ? void 0 : e.title) && /* @__PURE__ */ h.jsxs(BM, { children: [
      " ",
      e.title,
      " "
    ] }),
    (e == null ? void 0 : e.description) && /* @__PURE__ */ h.jsxs(HM, { children: [
      " ",
      e.description,
      " "
    ] }),
    /* @__PURE__ */ h.jsx(
      DM,
      {
        "aria-labelledby": e != null && e.title ? e == null ? void 0 : e.title : "radio-buttons-group",
        value: n,
        onChange: l,
        children: t == null ? void 0 : t.map((d) => {
          const u = n === d.value;
          return /* @__PURE__ */ h.jsx("div", { "data-tour": i || void 0, children: /* @__PURE__ */ h.jsxs(NM, { $selected: u, children: [
            /* @__PURE__ */ h.jsx(
              Lc,
              {
                value: d.value,
                control: /* @__PURE__ */ h.jsx(FM, {}),
                label: d.label
              }
            ),
            u && /* @__PURE__ */ h.jsxs(zM, { $selected: u, size: "small", onClick: c, children: [
              " ",
              "Clear ✕"
            ] })
          ] }) }, d.value);
        })
      }
    )
  ] });
}, "RadioButtonGroup"), WM = D6`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
`, ZM = me(ge)`
  display: flex;
  flex-direction: ${({ $flexDirection: e }) => e || "column"};
  flex-wrap: ${({ $flexWrap: e }) => e || "nowrap"};
  gap: ${({ $gap: e }) => typeof e == "number" ? `${e}px` : e || "8px"};
  width: 100%;
`, UM = me(ge)`
  width: ${({ $width: e }) => typeof e == "number" ? `${e}px` : e || "100%"};
  height: ${({ $height: e }) => typeof e == "number" ? `${e}px` : e || "20px"};
  background-color: ${({ $backgroundColor: e, theme: t }) => e || t.palette.primary.neutralGreyDark};
  border-radius: ${({ $borderRadius: e }) => typeof e == "number" ? `${e}px` : e || "4px"};
  ${({ $animation: e }) => e !== !1 ? a1`
          animation: ${WM} 1.5s ease-in-out infinite;
        ` : a1`
          animation: none;
        `};
`, vk = /* @__PURE__ */ a(({
  width: e = "100%",
  height: t = "20px",
  quantity: n,
  gap: o = "8px",
  flexDirection: r = "column",
  flexWrap: i = "nowrap",
  backgroundColor: l,
  borderRadius: c = "4px",
  animation: d = !0
}) => /* @__PURE__ */ h.jsx(
  ZM,
  {
    "data-testid": "skeleton-generator",
    $gap: o,
    $flexDirection: r,
    $flexWrap: i,
    children: Array.from(Array(n).keys()).map((u, p) => /* @__PURE__ */ h.jsx(
      UM,
      {
        "data-testid": "skeleton-box",
        $width: e,
        $height: t,
        $backgroundColor: l,
        $borderRadius: c,
        $animation: d
      },
      p
    ))
  }
), "SkeletonGenerator"), GM = Q(ge)`
  flex: 1;
`, YM = Q(ge)`
  width: 100%;
  height: 100%;
  display: flex;
`, wk = /* @__PURE__ */ a(({ children: e, value: t, index: n }) => /* @__PURE__ */ h.jsx(GM, { role: "tabpanel", hidden: t !== n, children: t === n && /* @__PURE__ */ h.jsx(YM, { children: e }) }), "TabPanel"), qM = Q(ge)`
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
`, KM = Q(kd)`
  &.MuiTabs-root {
    height: 48px;
  }

  & .MuiTabs-indicator {
    height: 4px;
    background-color: ${({ theme: e }) => e.palette.primary.secondaryBlue};
  }
`, XM = Q(Sd)`
  &.MuiTab-root {
    font-size: ${({ theme: e }) => e.fontSizes.body.xl};
    font-weight: ${({ theme: e }) => e.fontWeights.regular};
    text-transform: none;
    min-height: 21px;
    color: ${({ theme: e }) => e.palette.primary.neutralBlack};

    &.Mui-selected {
      color: ${({ theme: e }) => e.palette.primary.neutralBlack};
      font-weight: ${({ theme: e }) => e.fontWeights.regular};
    }
  }
`, Sk = /* @__PURE__ */ a(({ selectedTabIndex: e, onTabSelect: t, tabLabels: n, children: o }) => /* @__PURE__ */ h.jsxs(qM, { children: [
  /* @__PURE__ */ h.jsx(KM, { value: e, onChange: t, children: n.map((r) => /* @__PURE__ */ h.jsx(XM, { label: r }, r)) }),
  o
] }), "Tabs"), JM = Q(Ko)`
  & .MuiOutlinedInput-root {
    margin: 0;
    height: 40px;
    background-color: ${({ theme: e }) => e.palette.primary.darkBlue};
    border-radius: 4px;
    
    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: ${({ theme: e }) => e.palette.primary.lightBlue};
    }
    
    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: ${({ theme: e }) => e.palette.primary.lightBlue};
      border-width: 2px;
    }
  }

  & .MuiInputBase-root {
    padding: 4px 14px;
  }

  & .MuiInputBase-input {
    padding: 0;
    height: auto;
    color: ${({ theme: e }) => e.palette.primary.white};

     &::placeholder {
      color: ${({ theme: e }) => e.palette.primary.white};
      opacity: 1;
     }

  }
  
  & .MuiInputAdornment-root {
    color: ${({ theme: e }) => e.palette.primary.white};
  }
`, Mk = /* @__PURE__ */ a(({
  type: e = "primary",
  label: t,
  icon: n,
  iconLeft: o = !1,
  iconRight: r = !1,
  onSearch: i
}) => {
  if (e === "primary")
    return /* @__PURE__ */ h.jsx(
      JM,
      {
        onChange: /* @__PURE__ */ a((l) => i && i(l.target.value), "onChange"),
        variant: "outlined",
        placeholder: t,
        fullWidth: !0,
        slotProps: {
          input: {
            endAdornment: r ? /* @__PURE__ */ h.jsx($n, { position: "end", children: n }) : void 0,
            startAdornment: o ? /* @__PURE__ */ h.jsx($n, { position: "start", children: n }) : void 0
          }
        }
      }
    );
}, "TextInput"), Eu = me(ed)`
  width: auto;
  max-width: 100%;
  box-shadow: none !important;
  height: 32px;

  & .MuiButton-root {
    border-radius: 0;
    text-transform: none;
    font-weight: ${({ theme: e }) => e.fontWeights.bold};
    padding: 6px 12px;

    &:not(:last-child) {
      border-right: none;
    }
  }
`, QM = me(Eu)`
  /* Remove default ButtonGroup border radius overrides */
  & .MuiButton-root {
    border-radius: 0;
    height: 35px;
    
    &:first-of-type {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    }

    &:last-of-type {
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
    }
  }

  /* Remove default ButtonGroup borders */
  & .MuiButton-root:not(:first-of-type) {
    border-left: none;
  }
`, $u = me(gl)`
  && {
    background-color: ${(e) => e.$selected ? e.theme.palette.primary.secondaryBlue : e.theme.palette.primary.white} !important;

    color: ${(e) => e.$selected ? e.theme.palette.primary.white : e.theme.palette.primary.secondaryBlue} !important;

    border: 2px solid ${(e) => e.theme.palette.primary.secondaryBlue};

    &.Mui-disabled {
      background-color: ${(e) => e.$selected ? e.theme.palette.primary.neutralGrey1 : e.theme.palette.primary.white} !important;
      color: ${(e) => e.$selected ? e.theme.palette.primary.neutralGreyDark : e.theme.palette.primary.neutralGrey2} !important;
      opacity: 1;
      svg {
        path {
          fill: ${(e) => e.theme.palette.primary.neutralGreyDark};
        }
      }
      cursor: not-allowed;
      pointer-events: none;
      border: 2px solid ${(e) => e.theme.palette.primary.neutralGrey1} !important;
      border-radius: 0px !important;
    }
  }
`, eT = me($u)`
  && {
    background-color: ${(e) => e.$selected ? e.theme.palette.primary.secondaryBlue : e.theme.palette.primary.white} !important;

    color: ${(e) => e.$selected ? e.theme.palette.primary.white : e.theme.palette.primary.secondaryBlue} !important;

    border: 2px solid ${(e) => e.theme.palette.primary.secondaryBlue} !important;
    transition: all 0.2s ease-in-out;
    text-transform: uppercase !important;
  }
`, Tk = /* @__PURE__ */ a(({
  options: e,
  selectedValue: t,
  onChange: n,
  disabled: o,
  type: r = "primary"
}) => {
  if (r === "primary")
    return /* @__PURE__ */ h.jsx(Eu, { variant: "contained", children: e.map((i) => /* @__PURE__ */ h.jsx(
      $u,
      {
        $selected: t === i.value,
        onClick: /* @__PURE__ */ a(() => n(i.value), "onClick"),
        disabled: o,
        children: i.label
      },
      i.value
    )) });
  if (r === "secondary")
    return /* @__PURE__ */ h.jsx(QM, { variant: "contained", children: e.map((i) => /* @__PURE__ */ h.jsx(
      eT,
      {
        $selected: t === i.value,
        onClick: /* @__PURE__ */ a(() => n(i.value), "onClick"),
        disabled: o,
        children: i.label
      },
      i.value
    )) });
}, "ToggleButton"), tT = {
  backgroundColor: at.palette.primary.lightGrey4,
  color: at.palette.primary.darkGrey,
  fontSize: at.fontSizes.body.xl,
  fontWeight: at.fontWeights.regular,
  padding: "16px",
  borderRadius: "8px",
  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
  maxWidth: "200px",
  "& .MuiTooltip-arrow": {
    color: at.palette.primary.lightGrey4
  }
}, kk = /* @__PURE__ */ a(({
  title: e,
  children: t,
  placement: n = "top",
  arrow: o = !0,
  disabled: r = !1,
  enterDelay: i = 500,
  leaveDelay: l = 0
}) => r ? t : /* @__PURE__ */ h.jsx(
  wd,
  {
    title: e,
    placement: n,
    arrow: o,
    enterDelay: i,
    leaveDelay: l,
    slotProps: {
      tooltip: {
        sx: tT
      }
    },
    children: t
  }
), "Tooltip"), Ok = {
  home: Qv,
  applications: Wv,
  "data-analysis": Kv,
  "data-catalogue": Xv,
  "country-profiles": qv,
  "knowledge-hub": tw,
  "unep-lab": sw
};
export {
  uT as AppNav,
  Wv as ApplicationsIcon,
  Zv as ArrowCircleLeft,
  Uv as ArrowCircleRight,
  hT as ArrowDropDownIcon,
  gT as ArrowLeft,
  Gv as ArrowRight,
  pT as Autocomplete,
  fT as BarChart,
  XT as Carousel,
  mT as ChartsIcon,
  bT as CheckIcon,
  q1 as CheckboxCheckedIcon,
  JT as CheckboxGroup,
  K1 as CheckboxIcon,
  CT as ChemicalIcon,
  i2 as ChevronDownIcon,
  xT as ChevronRightIcon,
  Yv as ChevronUpIcon,
  QT as Chip,
  wT as ClimateActionIcon,
  Ha as CloseIcon,
  yT as ColumnsIcon,
  ST as CompareArrowsIcon,
  MT as CountryIcon,
  qv as CountryProfilesIcon,
  Kv as DataAnalysisIcon,
  Xv as DataCatalogueIcon,
  ek as DateRange,
  tk as DisclaimerModal,
  TT as DownloadIcon,
  nk as DrawerHeaderNav,
  ok as ErrorBar,
  vT as ExcelFileIcon,
  Jv as FacebookIcon,
  kT as FilterListIcon,
  rk as Footer,
  Vo as GenericContainer,
  dT as GenericPageWrapper,
  OT as GlobalIcon,
  lT as GlobalStyle,
  ik as HeaderNav,
  Qv as HomeIcon,
  ET as InfoIcon,
  sk as InputText,
  $T as InsightsIcon,
  ew as InstagramIcon,
  tw as KnowledgeHubIcon,
  PT as LandIcon,
  _T as LayersIcon,
  ak as LegendBubbles,
  lk as LegendColorDots,
  ck as LegendGradient,
  dk as LegendItem,
  uk as LegendLine,
  pk as LegendYearSelector,
  fk as LineChart,
  RT as LineIcon,
  nw as LinkedinIcon,
  hk as LoaderDots,
  gk as LoadingBackdrop,
  IT as LocalActivityIcon,
  YT as ManageSearchIcon,
  jT as MapIcon,
  w6 as MenuIcon,
  mk as Modal,
  bk as NavCard,
  Ck as NotFoundContent,
  LT as OpenInNewIcon,
  VT as OpenUrlIcon,
  cT as OverlayBodyLock,
  yk as PieChart,
  AT as PngFileIcon,
  xk as RadioButtonGroup,
  BT as RegionIcon,
  qT as ResetAltIcon,
  HT as ResetIcon,
  ow as SearchIcon,
  DT as SearchIconNotFound,
  R6 as Select,
  vk as SkeletonGenerator,
  NT as SwapVerticalIcon,
  wk as TabPanel,
  zT as TableChartIcon,
  Sk as Tabs,
  Mk as TextInput,
  at as Theme,
  rw as TiktokIcon,
  Tk as ToggleButton,
  kk as Tooltip,
  FT as TravelExploreIcon,
  iw as TumblrIcon,
  WT as UNEPEPTLogo,
  ZT as UNEPEPTLogoInverted,
  sw as UNEPLabIcon,
  UT as UNEPLogo,
  GT as UNEPLogoSimple,
  aw as UNEPLogoSmall,
  KT as WarningIcon,
  lw as XIcon,
  cw as YoutubeIcon,
  yb as animation,
  zc as customScrollbarMixin,
  Ok as iconRegistry,
  aT as muiDefaultTheme,
  Fw as useScrollDirection
};
//# sourceMappingURL=index.es.js.map
